
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3802"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3802"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7ikhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $54f9f2e439a2f9ff$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $54f9f2e439a2f9ff$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $54f9f2e439a2f9ff$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $54f9f2e439a2f9ff$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $54f9f2e439a2f9ff$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $54f9f2e439a2f9ff$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $54f9f2e439a2f9ff$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $54f9f2e439a2f9ff$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $54f9f2e439a2f9ff$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $54f9f2e439a2f9ff$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $54f9f2e439a2f9ff$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $54f9f2e439a2f9ff$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $54f9f2e439a2f9ff$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $54f9f2e439a2f9ff$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $54f9f2e439a2f9ff$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $54f9f2e439a2f9ff$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $54f9f2e439a2f9ff$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $54f9f2e439a2f9ff$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $54f9f2e439a2f9ff$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $54f9f2e439a2f9ff$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $54f9f2e439a2f9ff$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $54f9f2e439a2f9ff$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $54f9f2e439a2f9ff$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $54f9f2e439a2f9ff$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "StrictMode", function () { return $54f9f2e439a2f9ff$export$5f8d39834fd61797; });
$parcel$export(module.exports, "isElement", function () { return $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $54f9f2e439a2f9ff$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("7Do5B")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("7Do5B")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("7Do5B")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("7Do5B")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("7Do5B")).createRef; });

var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
function $54f9f2e439a2f9ff$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $54f9f2e439a2f9ff$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $54f9f2e439a2f9ff$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $3aPmr.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $3aPmr.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $54f9f2e439a2f9ff$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $3aPmr.useEffect)(function() {
        return $54f9f2e439a2f9ff$var$x(u) && o({
            t: u
        }), n(function() {
            $54f9f2e439a2f9ff$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $54f9f2e439a2f9ff$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $54f9f2e439a2f9ff$export$7568632d0d33d16d(n) {
    n();
}
function $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $54f9f2e439a2f9ff$export$7b286972b8d8ccbf() {
    return [
        !1,
        $54f9f2e439a2f9ff$export$7568632d0d33d16d
    ];
}
var $54f9f2e439a2f9ff$export$aaabe4eda9ed9969 = (0, $3aPmr.useLayoutEffect);
function $54f9f2e439a2f9ff$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $54f9f2e439a2f9ff$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $54f9f2e439a2f9ff$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $7Do5B.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($54f9f2e439a2f9ff$export$221d75b3f55bb0bd.prototype = new (0, $7Do5B.Component)).isPureReactComponent = !0, $54f9f2e439a2f9ff$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $54f9f2e439a2f9ff$var$E(this.props, n) || $54f9f2e439a2f9ff$var$E(this.state, t);
};
var $54f9f2e439a2f9ff$var$T = (0, $7Do5B.options).__b;
(0, $7Do5B.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $54f9f2e439a2f9ff$var$T && $54f9f2e439a2f9ff$var$T(n);
};
var $54f9f2e439a2f9ff$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $54f9f2e439a2f9ff$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $54f9f2e439a2f9ff$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $54f9f2e439a2f9ff$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $54f9f2e439a2f9ff$var$L = function(n, t) {
    return null == n ? null : (0, $7Do5B.toChildArray)((0, $7Do5B.toChildArray)(n).map(t));
}, $54f9f2e439a2f9ff$export$dca3b0875bd9a954 = {
    map: $54f9f2e439a2f9ff$var$L,
    forEach: $54f9f2e439a2f9ff$var$L,
    count: function(n) {
        return n ? (0, $7Do5B.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $7Do5B.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $7Do5B.toChildArray)
}, $54f9f2e439a2f9ff$var$F = (0, $7Do5B.options).__e;
(0, $7Do5B.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $54f9f2e439a2f9ff$var$F(n, t, e, r);
};
var $54f9f2e439a2f9ff$var$U = (0, $7Do5B.options).unmount;
function $54f9f2e439a2f9ff$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $54f9f2e439a2f9ff$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $54f9f2e439a2f9ff$var$V(n, t, e);
    })), n;
}
function $54f9f2e439a2f9ff$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $54f9f2e439a2f9ff$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $54f9f2e439a2f9ff$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $54f9f2e439a2f9ff$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $54f9f2e439a2f9ff$export$488013bae63b21da(n) {
    var e, r, u, o = null;
    function i(i) {
        if (e || (e = n()).then(function(n) {
            n && (o = n.default || n), u = !0;
        }, function(n) {
            r = n, u = !0;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, $7Do5B.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $54f9f2e439a2f9ff$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $7Do5B.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $54f9f2e439a2f9ff$var$U && $54f9f2e439a2f9ff$var$U(n);
}, ($54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype = new (0, $7Do5B.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $54f9f2e439a2f9ff$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $54f9f2e439a2f9ff$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $54f9f2e439a2f9ff$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $54f9f2e439a2f9ff$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $54f9f2e439a2f9ff$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $54f9f2e439a2f9ff$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $7Do5B.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $7Do5B.render)((0, $7Do5B.createElement)($54f9f2e439a2f9ff$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $54f9f2e439a2f9ff$export$d39a5bbd09211389(n, e) {
    var r = (0, $7Do5B.createElement)($54f9f2e439a2f9ff$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($54f9f2e439a2f9ff$export$998bcd577473dd93.prototype = new (0, $7Do5B.Component)).__a = function(n) {
    var t = this, e = $54f9f2e439a2f9ff$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $54f9f2e439a2f9ff$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $7Do5B.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.componentDidUpdate = $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $54f9f2e439a2f9ff$var$H(n, e, t);
    });
};
var $54f9f2e439a2f9ff$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $54f9f2e439a2f9ff$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $54f9f2e439a2f9ff$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $54f9f2e439a2f9ff$var$K = /[A-Z0-9]/g, $54f9f2e439a2f9ff$var$Q = "undefined" != typeof document, $54f9f2e439a2f9ff$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $54f9f2e439a2f9ff$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $7Do5B.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $54f9f2e439a2f9ff$export$fa8d919ba61d84db(n, t, e) {
    return (0, $7Do5B.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $7Do5B.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $7Do5B.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $54f9f2e439a2f9ff$var$en = (0, $7Do5B.options).event;
function $54f9f2e439a2f9ff$var$rn() {}
function $54f9f2e439a2f9ff$var$un() {
    return this.cancelBubble;
}
function $54f9f2e439a2f9ff$var$on() {
    return this.defaultPrevented;
}
(0, $7Do5B.options).event = function(n) {
    return $54f9f2e439a2f9ff$var$en && (n = $54f9f2e439a2f9ff$var$en(n)), n.persist = $54f9f2e439a2f9ff$var$rn, n.isPropagationStopped = $54f9f2e439a2f9ff$var$un, n.isDefaultPrevented = $54f9f2e439a2f9ff$var$on, n.nativeEvent = n;
};
var $54f9f2e439a2f9ff$var$ln, $54f9f2e439a2f9ff$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $54f9f2e439a2f9ff$var$fn = (0, $7Do5B.options).vnode;
(0, $7Do5B.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $54f9f2e439a2f9ff$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $54f9f2e439a2f9ff$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $54f9f2e439a2f9ff$var$J.test(i) && (i = c) : c = i = "oninput" : o && $54f9f2e439a2f9ff$var$G.test(i) ? i = i.replace($54f9f2e439a2f9ff$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $7Do5B.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $7Do5B.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $54f9f2e439a2f9ff$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $54f9f2e439a2f9ff$var$q, $54f9f2e439a2f9ff$var$fn && $54f9f2e439a2f9ff$var$fn(n);
};
var $54f9f2e439a2f9ff$var$an = (0, $7Do5B.options).__r;
(0, $7Do5B.options).__r = function(n) {
    $54f9f2e439a2f9ff$var$an && $54f9f2e439a2f9ff$var$an(n), $54f9f2e439a2f9ff$var$ln = n.__c;
};
var $54f9f2e439a2f9ff$var$sn = (0, $7Do5B.options).diffed;
(0, $7Do5B.options).diffed = function(n) {
    $54f9f2e439a2f9ff$var$sn && $54f9f2e439a2f9ff$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $54f9f2e439a2f9ff$var$ln = null;
};
var $54f9f2e439a2f9ff$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $54f9f2e439a2f9ff$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $3aPmr.useCallback),
            useContext: (0, $3aPmr.useContext),
            useDebugValue: (0, $3aPmr.useDebugValue),
            useDeferredValue: $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf,
            useEffect: (0, $3aPmr.useEffect),
            useId: (0, $3aPmr.useId),
            useImperativeHandle: (0, $3aPmr.useImperativeHandle),
            useInsertionEffect: $54f9f2e439a2f9ff$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $3aPmr.useLayoutEffect),
            useMemo: (0, $3aPmr.useMemo),
            useReducer: (0, $3aPmr.useReducer),
            useRef: (0, $3aPmr.useRef),
            useState: (0, $3aPmr.useState),
            useSyncExternalStore: $54f9f2e439a2f9ff$export$306c0aa65ff9ec16,
            useTransition: $54f9f2e439a2f9ff$export$7b286972b8d8ccbf
        }
    }
}, $54f9f2e439a2f9ff$export$83d89fbfd8236492 = "18.3.1";
function $54f9f2e439a2f9ff$export$d38cd72104c1f0e9(n) {
    return (0, $7Do5B.createElement).bind(null, n);
}
function $54f9f2e439a2f9ff$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $54f9f2e439a2f9ff$var$q;
}
function $54f9f2e439a2f9ff$export$9522e17588c12572(n) {
    return $54f9f2e439a2f9ff$export$a8257692ac88316c(n) && n.type === (0, $7Do5B.Fragment);
}
function $54f9f2e439a2f9ff$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $54f9f2e439a2f9ff$export$e530037191fcd5d7(n) {
    return $54f9f2e439a2f9ff$export$a8257692ac88316c(n) ? (0, $7Do5B.cloneElement).apply(null, arguments) : n;
}
function $54f9f2e439a2f9ff$export$502457920280e6be(n) {
    return !!n.__k && ((0, $7Do5B.render)(null, n), !0);
}
function $54f9f2e439a2f9ff$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $54f9f2e439a2f9ff$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $54f9f2e439a2f9ff$export$5f8d39834fd61797 = (0, $7Do5B.Fragment), $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d = $54f9f2e439a2f9ff$export$a8257692ac88316c, $54f9f2e439a2f9ff$export$2e2bcd8739ae039 = {
    useState: (0, $3aPmr.useState),
    useId: (0, $3aPmr.useId),
    useReducer: (0, $3aPmr.useReducer),
    useEffect: (0, $3aPmr.useEffect),
    useLayoutEffect: (0, $3aPmr.useLayoutEffect),
    useInsertionEffect: $54f9f2e439a2f9ff$export$aaabe4eda9ed9969,
    useTransition: $54f9f2e439a2f9ff$export$7b286972b8d8ccbf,
    useDeferredValue: $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $54f9f2e439a2f9ff$export$306c0aa65ff9ec16,
    startTransition: $54f9f2e439a2f9ff$export$7568632d0d33d16d,
    useRef: (0, $3aPmr.useRef),
    useImperativeHandle: (0, $3aPmr.useImperativeHandle),
    useMemo: (0, $3aPmr.useMemo),
    useCallback: (0, $3aPmr.useCallback),
    useContext: (0, $3aPmr.useContext),
    useDebugValue: (0, $3aPmr.useDebugValue),
    version: "18.3.1",
    Children: $54f9f2e439a2f9ff$export$dca3b0875bd9a954,
    render: $54f9f2e439a2f9ff$export$b3890eb0ae9dca99,
    hydrate: $54f9f2e439a2f9ff$export$fa8d919ba61d84db,
    unmountComponentAtNode: $54f9f2e439a2f9ff$export$502457920280e6be,
    createPortal: $54f9f2e439a2f9ff$export$d39a5bbd09211389,
    createElement: (0, $7Do5B.createElement),
    createContext: (0, $7Do5B.createContext),
    createFactory: $54f9f2e439a2f9ff$export$d38cd72104c1f0e9,
    cloneElement: $54f9f2e439a2f9ff$export$e530037191fcd5d7,
    createRef: (0, $7Do5B.createRef),
    Fragment: (0, $7Do5B.Fragment),
    isValidElement: $54f9f2e439a2f9ff$export$a8257692ac88316c,
    isElement: $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d,
    isFragment: $54f9f2e439a2f9ff$export$9522e17588c12572,
    isMemo: $54f9f2e439a2f9ff$export$56885ab8b9c456ab,
    findDOMNode: $54f9f2e439a2f9ff$export$466bfc07425424d5,
    Component: (0, $7Do5B.Component),
    PureComponent: $54f9f2e439a2f9ff$export$221d75b3f55bb0bd,
    memo: $54f9f2e439a2f9ff$export$7c73462e0d25e514,
    forwardRef: $54f9f2e439a2f9ff$export$257a8862b851cb5b,
    flushSync: $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $54f9f2e439a2f9ff$export$c78a37762a8d58e1,
    StrictMode: $54f9f2e439a2f9ff$export$5f8d39834fd61797,
    Suspense: $54f9f2e439a2f9ff$export$74bf444e3cd11ea5,
    SuspenseList: $54f9f2e439a2f9ff$export$998bcd577473dd93,
    lazy: $54f9f2e439a2f9ff$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $54f9f2e439a2f9ff$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $3aPmr);

});
parcelRegister("7Do5B", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $58eedc976c0db041$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $58eedc976c0db041$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $58eedc976c0db041$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $58eedc976c0db041$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $58eedc976c0db041$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $58eedc976c0db041$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $58eedc976c0db041$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $58eedc976c0db041$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $58eedc976c0db041$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $58eedc976c0db041$export$fd42f52fd3ae1109; });
var $58eedc976c0db041$var$n, $58eedc976c0db041$export$41c562ebe57d11e2, $58eedc976c0db041$var$u, $58eedc976c0db041$export$a8257692ac88316c, $58eedc976c0db041$var$i, $58eedc976c0db041$var$r, $58eedc976c0db041$var$o, $58eedc976c0db041$var$e, $58eedc976c0db041$var$f, $58eedc976c0db041$var$c, $58eedc976c0db041$var$s, $58eedc976c0db041$var$a, $58eedc976c0db041$var$h, $58eedc976c0db041$var$p = {}, $58eedc976c0db041$var$v = [], $58eedc976c0db041$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $58eedc976c0db041$var$w = Array.isArray;
function $58eedc976c0db041$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $58eedc976c0db041$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $58eedc976c0db041$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $58eedc976c0db041$var$m(l, e, i, r, null);
}
function $58eedc976c0db041$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$58eedc976c0db041$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(e), e;
}
function $58eedc976c0db041$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $58eedc976c0db041$export$ffb0004e005737fa(n) {
    return n.children;
}
function $58eedc976c0db041$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $58eedc976c0db041$var$S(n, l) {
    if (null == l) return n.__ ? $58eedc976c0db041$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $58eedc976c0db041$var$S(n) : null;
}
function $58eedc976c0db041$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $58eedc976c0db041$var$C(n);
    }
}
function $58eedc976c0db041$var$M(n) {
    (!n.__d && (n.__d = !0) && $58eedc976c0db041$var$i.push(n) && !$58eedc976c0db041$var$$.__r++ || $58eedc976c0db041$var$r != $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) && (($58eedc976c0db041$var$r = $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) || $58eedc976c0db041$var$o)($58eedc976c0db041$var$$);
}
function $58eedc976c0db041$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $58eedc976c0db041$var$i.length;)$58eedc976c0db041$var$i.length > s && $58eedc976c0db041$var$i.sort($58eedc976c0db041$var$e), n = $58eedc976c0db041$var$i.shift(), s = $58eedc976c0db041$var$i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $58eedc976c0db041$var$d({}, r)).__v = r.__v + 1, $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(t), $58eedc976c0db041$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $58eedc976c0db041$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $58eedc976c0db041$var$N(f, t, c), r.__e = r.__ = null, t.__e != o && $58eedc976c0db041$var$C(t)));
    $58eedc976c0db041$var$$.__r = 0;
}
function $58eedc976c0db041$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $58eedc976c0db041$var$v, b = l.length;
    for(f = $58eedc976c0db041$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $58eedc976c0db041$var$p : m[y.__i] || $58eedc976c0db041$var$p, y.__i = a, g = $58eedc976c0db041$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $58eedc976c0db041$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $58eedc976c0db041$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $58eedc976c0db041$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $58eedc976c0db041$var$m(null, o, null, null, null) : $58eedc976c0db041$var$w(o) ? o = n.__k[r] = $58eedc976c0db041$var$m($58eedc976c0db041$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? o = n.__k[r] = $58eedc976c0db041$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $58eedc976c0db041$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $58eedc976c0db041$var$S(e)), $58eedc976c0db041$var$D(e, e));
    return t;
}
function $58eedc976c0db041$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $58eedc976c0db041$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $58eedc976c0db041$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $58eedc976c0db041$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($58eedc976c0db041$var$w(n) ? n.some(function(n) {
        $58eedc976c0db041$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $58eedc976c0db041$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $58eedc976c0db041$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $58eedc976c0db041$var$y.test(l) ? u : u + "px";
}
function $58eedc976c0db041$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $58eedc976c0db041$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $58eedc976c0db041$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($58eedc976c0db041$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $58eedc976c0db041$var$c, n.addEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r)) : n.removeEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $58eedc976c0db041$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $58eedc976c0db041$var$c++;
            else if (u.t < t.u) return;
            return t($58eedc976c0db041$export$41c562ebe57d11e2.event ? $58eedc976c0db041$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $58eedc976c0db041$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $58eedc976c0db041$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $58eedc976c0db041$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $58eedc976c0db041$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $58eedc976c0db041$var$d({}, h.__s)), $58eedc976c0db041$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $58eedc976c0db041$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $58eedc976c0db041$var$d($58eedc976c0db041$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $58eedc976c0db041$export$ffb0004e005737fa && null == a.key && (L = $58eedc976c0db041$var$V(a.props.children)), f = $58eedc976c0db041$var$I(n, $58eedc976c0db041$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$58eedc976c0db041$var$g(o[T]);
                $58eedc976c0db041$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $58eedc976c0db041$var$z(u);
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $58eedc976c0db041$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $58eedc976c0db041$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $58eedc976c0db041$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($58eedc976c0db041$var$z);
}
function $58eedc976c0db041$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$58eedc976c0db041$var$B(t[i], t[++i], t[++i]);
    $58eedc976c0db041$export$41c562ebe57d11e2.__c && $58eedc976c0db041$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $58eedc976c0db041$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $58eedc976c0db041$var$w(n) ? n.map($58eedc976c0db041$var$V) : $58eedc976c0db041$var$d({}, n);
}
function $58eedc976c0db041$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props || $58eedc976c0db041$var$p, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($58eedc976c0db041$export$41c562ebe57d11e2.__m && $58eedc976c0db041$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $58eedc976c0db041$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $58eedc976c0db041$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $58eedc976c0db041$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $58eedc976c0db041$var$I("template" == t.type ? u.content : u, $58eedc976c0db041$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $58eedc976c0db041$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$58eedc976c0db041$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $58eedc976c0db041$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $58eedc976c0db041$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $58eedc976c0db041$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $58eedc976c0db041$var$D(n, u, t) {
    var i, r;
    if ($58eedc976c0db041$export$41c562ebe57d11e2.unmount && $58eedc976c0db041$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $58eedc976c0db041$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $58eedc976c0db041$var$D(i[r], u, t || "function" != typeof n.type);
    t || $58eedc976c0db041$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $58eedc976c0db041$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $58eedc976c0db041$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $58eedc976c0db041$export$41c562ebe57d11e2.__ && $58eedc976c0db041$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $58eedc976c0db041$var$O(t, u = (!r && i || t).__k = $58eedc976c0db041$export$c8a8987d4410bf2d($58eedc976c0db041$export$ffb0004e005737fa, null, [
        u
    ]), o || $58eedc976c0db041$var$p, $58eedc976c0db041$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $58eedc976c0db041$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $58eedc976c0db041$var$N(e, u, f);
}
function $58eedc976c0db041$export$fa8d919ba61d84db(n, l) {
    $58eedc976c0db041$export$b3890eb0ae9dca99(n, l, $58eedc976c0db041$export$fa8d919ba61d84db);
}
function $58eedc976c0db041$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $58eedc976c0db041$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), $58eedc976c0db041$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $58eedc976c0db041$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $58eedc976c0db041$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $58eedc976c0db041$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$58eedc976c0db041$var$n = $58eedc976c0db041$var$v.slice, $58eedc976c0db041$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $58eedc976c0db041$var$u = 0, $58eedc976c0db041$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $58eedc976c0db041$var$d({}, this.state), "function" == typeof n && (n = n($58eedc976c0db041$var$d({}, u), this.props)), n && $58eedc976c0db041$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.render = $58eedc976c0db041$export$ffb0004e005737fa, $58eedc976c0db041$var$i = [], $58eedc976c0db041$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $58eedc976c0db041$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $58eedc976c0db041$var$$.__r = 0, $58eedc976c0db041$var$f = /(PointerCapture)$|Capture$/i, $58eedc976c0db041$var$c = 0, $58eedc976c0db041$var$s = $58eedc976c0db041$var$F(!1), $58eedc976c0db041$var$a = $58eedc976c0db041$var$F(!0), $58eedc976c0db041$var$h = 0;

});

parcelRegister("3aPmr", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $24fa25825a717dc7$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $24fa25825a717dc7$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $24fa25825a717dc7$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $24fa25825a717dc7$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $24fa25825a717dc7$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $24fa25825a717dc7$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $24fa25825a717dc7$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $24fa25825a717dc7$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $24fa25825a717dc7$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $24fa25825a717dc7$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $24fa25825a717dc7$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $24fa25825a717dc7$export$f680877a34711e37; });

var $7Do5B = parcelRequire("7Do5B");
var $24fa25825a717dc7$var$t, $24fa25825a717dc7$var$r, $24fa25825a717dc7$var$u, $24fa25825a717dc7$var$i, $24fa25825a717dc7$var$o = 0, $24fa25825a717dc7$var$f = [], $24fa25825a717dc7$var$c = (0, $7Do5B.options), $24fa25825a717dc7$var$e = $24fa25825a717dc7$var$c.__b, $24fa25825a717dc7$var$a = $24fa25825a717dc7$var$c.__r, $24fa25825a717dc7$var$v = $24fa25825a717dc7$var$c.diffed, $24fa25825a717dc7$var$l = $24fa25825a717dc7$var$c.__c, $24fa25825a717dc7$var$m = $24fa25825a717dc7$var$c.unmount, $24fa25825a717dc7$var$s = $24fa25825a717dc7$var$c.__;
function $24fa25825a717dc7$var$p(n, t) {
    $24fa25825a717dc7$var$c.__h && $24fa25825a717dc7$var$c.__h($24fa25825a717dc7$var$r, n, $24fa25825a717dc7$var$o || t), $24fa25825a717dc7$var$o = 0;
    var u = $24fa25825a717dc7$var$r.__H || ($24fa25825a717dc7$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $24fa25825a717dc7$export$60241385465d0a34(n) {
    return $24fa25825a717dc7$var$o = 1, $24fa25825a717dc7$export$13e3392192263954($24fa25825a717dc7$var$D, n);
}
function $24fa25825a717dc7$export$13e3392192263954(n, u, i) {
    var o = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $24fa25825a717dc7$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $24fa25825a717dc7$var$r, !$24fa25825a717dc7$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $24fa25825a717dc7$var$r.__f = !0;
        var c = $24fa25825a717dc7$var$r.shouldComponentUpdate, e = $24fa25825a717dc7$var$r.componentWillUpdate;
        $24fa25825a717dc7$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $24fa25825a717dc7$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $24fa25825a717dc7$export$6d9c69b0de29b591(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 3);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__H.__h.push(i));
}
function $24fa25825a717dc7$export$e5c5a5f917a5871c(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 4);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__h.push(i));
}
function $24fa25825a717dc7$export$b8f5890fc79d6aca(n) {
    return $24fa25825a717dc7$var$o = 5, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $24fa25825a717dc7$export$d5a552a76deda3c2(n, t, r) {
    $24fa25825a717dc7$var$o = 6, $24fa25825a717dc7$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $24fa25825a717dc7$export$1538c33de8887b59(n, r) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 7);
    return $24fa25825a717dc7$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $24fa25825a717dc7$export$35808ee640e87ca7(n, t) {
    return $24fa25825a717dc7$var$o = 8, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $24fa25825a717dc7$export$fae74005e78b1a27(n) {
    var u = $24fa25825a717dc7$var$r.context[n.__c], i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($24fa25825a717dc7$var$r)), u.props.value) : n.__;
}
function $24fa25825a717dc7$export$dc8fbce3eb94dc1e(n, t) {
    $24fa25825a717dc7$var$c.useDebugValue && $24fa25825a717dc7$var$c.useDebugValue(t ? t(n) : n);
}
function $24fa25825a717dc7$export$c052f6604b7d51fe(n) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 10), i = $24fa25825a717dc7$export$60241385465d0a34();
    return u.__ = n, $24fa25825a717dc7$var$r.componentDidCatch || ($24fa25825a717dc7$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $24fa25825a717dc7$export$f680877a34711e37() {
    var n = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 11);
    if (!n.__) {
        for(var u = $24fa25825a717dc7$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $24fa25825a717dc7$var$j() {
    for(var n; n = $24fa25825a717dc7$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($24fa25825a717dc7$var$z), n.__H.__h.forEach($24fa25825a717dc7$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $24fa25825a717dc7$var$c.__e(t, n.__v);
    }
}
$24fa25825a717dc7$var$c.__b = function(n) {
    $24fa25825a717dc7$var$r = null, $24fa25825a717dc7$var$e && $24fa25825a717dc7$var$e(n);
}, $24fa25825a717dc7$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $24fa25825a717dc7$var$s && $24fa25825a717dc7$var$s(n, t);
}, $24fa25825a717dc7$var$c.__r = function(n) {
    $24fa25825a717dc7$var$a && $24fa25825a717dc7$var$a(n), $24fa25825a717dc7$var$t = 0;
    var i = ($24fa25825a717dc7$var$r = n.__c).__H;
    i && ($24fa25825a717dc7$var$u === $24fa25825a717dc7$var$r ? (i.__h = [], $24fa25825a717dc7$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($24fa25825a717dc7$var$z), i.__h.forEach($24fa25825a717dc7$var$B), i.__h = [], $24fa25825a717dc7$var$t = 0)), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r;
}, $24fa25825a717dc7$var$c.diffed = function(n) {
    $24fa25825a717dc7$var$v && $24fa25825a717dc7$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $24fa25825a717dc7$var$f.push(t) && $24fa25825a717dc7$var$i === $24fa25825a717dc7$var$c.requestAnimationFrame || (($24fa25825a717dc7$var$i = $24fa25825a717dc7$var$c.requestAnimationFrame) || $24fa25825a717dc7$var$w)($24fa25825a717dc7$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r = null;
}, $24fa25825a717dc7$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($24fa25825a717dc7$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $24fa25825a717dc7$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $24fa25825a717dc7$var$c.__e(r, n.__v);
        }
    }), $24fa25825a717dc7$var$l && $24fa25825a717dc7$var$l(n, t);
}, $24fa25825a717dc7$var$c.unmount = function(n) {
    $24fa25825a717dc7$var$m && $24fa25825a717dc7$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $24fa25825a717dc7$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $24fa25825a717dc7$var$c.__e(t, r.__v));
};
var $24fa25825a717dc7$var$k = "function" == typeof requestAnimationFrame;
function $24fa25825a717dc7$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $24fa25825a717dc7$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $24fa25825a717dc7$var$k && (t = requestAnimationFrame(r));
}
function $24fa25825a717dc7$var$z(n) {
    var t = $24fa25825a717dc7$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$B(n) {
    var t = $24fa25825a717dc7$var$r;
    n.__c = n.__(), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $24fa25825a717dc7$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8c849a51633fc8b0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("6STMo", function(module, exports) {
/*
 * Swipe 2.0.0
 * Brad Birdsall
 * https://github.com/thebird/Swipe
 * Copyright 2013-2015, MIT License
 *
 */ (function(root, factory) {
    if (module.exports) module.exports = factory();
    else root.Swipe = factory();
})(module.exports, function() {
    'use strict';
    return function Swipe(container, options) {
        // utilities
        var noop = function() {}; // simple no operation function
        var offloadFn = function(fn) {
            setTimeout(fn || noop, 0);
        }; // offload a functions execution
        // check browser capabilities
        var browser = {
            addEventListener: !!window.addEventListener,
            touch: 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch,
            transitions: function(temp) {
                var props = [
                    'transitionProperty',
                    'WebkitTransition',
                    'MozTransition',
                    'OTransition',
                    'msTransition'
                ];
                for(var i in props)if (temp.style[props[i]] !== undefined) return true;
                return false;
            }(document.createElement('swipe'))
        };
        // quit if no root element
        if (!container) return;
        var element = container.children[0];
        var slides, slidePos, width, length;
        options = options || {};
        var index = parseInt(options.startSlide, 10) || 0;
        var speed = options.speed || 300;
        var widthOfSiblingSlidePreview = parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
        var continuous = options.continuous = options.continuous !== undefined ? options.continuous : true;
        function setup() {
            // cache slides
            slides = element.children;
            length = slides.length;
            // set continuous to false if only one slide
            continuous = slides.length < 2 ? false : options.continuous;
            // create an array to store current positions of each slide
            slidePos = new Array(slides.length);
            // determine width of each slide
            width = Math.round(container.getBoundingClientRect().width || container.offsetWidth) - widthOfSiblingSlidePreview * 2;
            element.style.width = slides.length * width + 'px';
            // stack elements
            var pos = slides.length;
            while(pos--){
                var slide = slides[pos];
                slide.style.width = width + 'px';
                slide.setAttribute('data-index', pos);
                if (browser.transitions) {
                    slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
                    move(pos, index > pos ? -width : index < pos ? width : 0, 0);
                }
            }
            // reposition elements before and after index
            if (continuous && browser.transitions) {
                move(circle(index - 1), -width, 0);
                move(circle(index + 1), width, 0);
            }
            if (!browser.transitions) element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';
            container.style.visibility = 'visible';
        }
        function prev() {
            if (continuous) slide(index - 1);
            else if (index) slide(index - 1);
        }
        function next() {
            if (continuous) slide(index + 1);
            else if (index < slides.length - 1) slide(index + 1);
        }
        function circle(index) {
            // a simple positive modulo using slides.length
            return (slides.length + index % slides.length) % slides.length;
        }
        function slide(to, slideSpeed) {
            // do nothing if already on requested slide
            if (index == to) return;
            if (browser.transitions) {
                var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward
                // get the actual position of the slide
                if (continuous) {
                    var natural_direction = direction;
                    direction = -slidePos[circle(to)] / width;
                    // if going forward but to < index, use to = slides.length + to
                    // if going backward but to > index, use to = -slides.length + to
                    if (direction !== natural_direction) to = -direction * slides.length + to;
                }
                var diff = Math.abs(index - to) - 1;
                // move all the slides between index and to in the right direction
                while(diff--)move(circle((to > index ? to : index) - diff - 1), width * direction, 0);
                to = circle(to);
                move(index, width * direction, slideSpeed || speed);
                move(to, 0, slideSpeed || speed);
                if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
            } else {
                to = circle(to);
                animate(index * -width, to * -width, slideSpeed || speed);
            //no fallback for a circular continuous if the browser does not accept transitions
            }
            index = to;
            offloadFn(options.callback && options.callback(index, slides[index]));
        }
        function move(index, dist, speed) {
            translate(index, dist, speed);
            slidePos[index] = dist;
        }
        function translate(index, dist, speed) {
            var slide = slides[index];
            var style = slide && slide.style;
            if (!style) return;
            style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration = speed + 'ms';
            style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
            style.msTransform = style.MozTransform = style.OTransform = 'translateX(' + dist + 'px)';
        }
        function animate(from, to, speed) {
            // if not an animation, just reposition
            if (!speed) {
                element.style.left = to + 'px';
                return;
            }
            var start = +new Date();
            var timer = setInterval(function() {
                var timeElap = +new Date() - start;
                if (timeElap > speed) {
                    element.style.left = to + 'px';
                    if (delay) begin();
                    options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
                    clearInterval(timer);
                    return;
                }
                element.style.left = (to - from) * (Math.floor(timeElap / speed * 100) / 100) + from + 'px';
            }, 4);
        }
        // setup auto slideshow
        var delay = options.auto || 0;
        var interval;
        function begin() {
            clearTimeout(interval);
            interval = setTimeout(next, delay);
        }
        function stop() {
            delay = 0;
            clearTimeout(interval);
        }
        // setup initial vars
        var start = {};
        var delta = {};
        var isScrolling;
        // setup event capturing
        var events = {
            handleEvent: function(event1) {
                switch(event1.type){
                    case 'touchstart':
                        this.start(event1);
                        break;
                    case 'touchmove':
                        this.move(event1);
                        break;
                    case 'touchend':
                        offloadFn(this.end(event1));
                        break;
                    case 'webkitTransitionEnd':
                    case 'msTransitionEnd':
                    case 'oTransitionEnd':
                    case 'otransitionend':
                    case 'transitionend':
                        offloadFn(this.transitionEnd(event1));
                        break;
                    case 'resize':
                        offloadFn(setup);
                        break;
                }
                if (options.stopPropagation) event1.stopPropagation();
            },
            start: function(event1) {
                var touches = event1.touches[0];
                // measure start values
                start = {
                    // get initial touch coords
                    x: touches.pageX,
                    y: touches.pageY,
                    // store time to determine touch duration
                    time: +new Date()
                };
                // used for testing first move event
                isScrolling = undefined;
                // reset delta and end measurements
                delta = {};
                // attach touchmove and touchend listeners
                element.addEventListener('touchmove', this, false);
                element.addEventListener('touchend', this, false);
            },
            move: function(event1) {
                // ensure swiping with one touch and not pinching
                if (event1.touches.length > 1 || event1.scale && event1.scale !== 1) return;
                if (options.disableScroll) return;
                var touches = event1.touches[0];
                // measure change in x and y
                delta = {
                    x: touches.pageX - start.x,
                    y: touches.pageY - start.y
                };
                // determine if scrolling test has run - one time test
                if (typeof isScrolling == 'undefined') isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
                // if user is not trying to scroll vertically
                if (!isScrolling) {
                    // prevent native scrolling
                    event1.preventDefault();
                    // stop slideshow
                    stop();
                    // increase resistance if first or last slide
                    if (continuous) {
                        // we don't add resistance at the end
                        translate(circle(index - 1), delta.x + slidePos[circle(index - 1)], 0);
                        translate(index, delta.x + slidePos[index], 0);
                        translate(circle(index + 1), delta.x + slidePos[circle(index + 1)], 0);
                    } else {
                        delta.x = delta.x / (!index && delta.x > 0 || // if first slide and sliding left
                        index == slides.length - 1 && // or if last slide and sliding right
                        delta.x < 0 // and if sliding at all
                         ? Math.abs(delta.x) / width + 1 // determine resistance level
                         : 1); // no resistance if false
                        // translate 1:1
                        translate(index - 1, delta.x + slidePos[index - 1], 0);
                        translate(index, delta.x + slidePos[index], 0);
                        translate(index + 1, delta.x + slidePos[index + 1], 0);
                    }
                    options.swiping && options.swiping(-delta.x / width);
                }
            },
            end: function(event1) {
                // measure duration
                var duration = +new Date() - start.time;
                // determine if slide attempt triggers next/prev slide
                var isValidSlide = Number(duration) < 250 && // if slide duration is less than 250ms
                Math.abs(delta.x) > 20 || // and if slide amt is greater than 20px
                Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width
                // determine if slide attempt is past start and end
                var isPastBounds = !index && delta.x > 0 || // if first slide and slide amt is greater than 0
                index == slides.length - 1 && delta.x < 0; // or if last slide and slide amt is less than 0
                if (continuous) isPastBounds = false;
                // determine direction of swipe (true:right, false:left)
                var direction = delta.x < 0;
                // if not scrolling vertically
                if (!isScrolling) {
                    if (isValidSlide && !isPastBounds) {
                        if (direction) {
                            if (continuous) {
                                // we need to get the next in this direction in place
                                move(circle(index - 1), -width, 0);
                                move(circle(index + 2), width, 0);
                            } else move(index - 1, -width, 0);
                            move(index, slidePos[index] - width, speed);
                            move(circle(index + 1), slidePos[circle(index + 1)] - width, speed);
                            index = circle(index + 1);
                        } else {
                            if (continuous) {
                                // we need to get the next in this direction in place
                                move(circle(index + 1), width, 0);
                                move(circle(index - 2), -width, 0);
                            } else move(index + 1, width, 0);
                            move(index, slidePos[index] + width, speed);
                            move(circle(index - 1), slidePos[circle(index - 1)] + width, speed);
                            index = circle(index - 1);
                        }
                        options.callback && options.callback(index, slides[index]);
                    } else if (continuous) {
                        move(circle(index - 1), -width, speed);
                        move(index, 0, speed);
                        move(circle(index + 1), width, speed);
                    } else {
                        move(index - 1, -width, speed);
                        move(index, 0, speed);
                        move(index + 1, width, speed);
                    }
                }
                // kill touchmove and touchend event listeners until touchstart called again
                element.removeEventListener('touchmove', events, false);
                element.removeEventListener('touchend', events, false);
                element.removeEventListener('touchforcechange', function() {}, false);
            },
            transitionEnd: function(event1) {
                if (parseInt(event1.target.getAttribute('data-index'), 10) == index) {
                    if (delay) begin();
                    options.transitionEnd && options.transitionEnd.call(event1, index, slides[index]);
                }
            }
        };
        // trigger setup
        setup();
        // start auto slideshow if applicable
        if (delay) begin();
        // add event listeners
        if (browser.addEventListener) {
            // set touchstart event on element
            if (browser.touch) {
                element.addEventListener('touchstart', events, false);
                element.addEventListener('touchforcechange', function() {}, false);
            }
            if (browser.transitions) {
                element.addEventListener('webkitTransitionEnd', events, false);
                element.addEventListener('msTransitionEnd', events, false);
                element.addEventListener('oTransitionEnd', events, false);
                element.addEventListener('otransitionend', events, false);
                element.addEventListener('transitionend', events, false);
            }
            // set resize event on window
            window.addEventListener('resize', events, false);
        } else window.onresize = function() {
            setup();
        }; // to play nice with old IE
        // expose the Swipe API
        return {
            setup: function() {
                setup();
            },
            slide: function(to, speed) {
                // cancel slideshow
                stop();
                slide(to, speed);
            },
            prev: function() {
                // cancel slideshow
                stop();
                prev();
            },
            next: function() {
                // cancel slideshow
                stop();
                next();
            },
            stop: function() {
                // cancel slideshow
                stop();
            },
            getPos: function() {
                // return current index position
                return index;
            },
            getNumSlides: function() {
                // return total number of slides
                return length;
            },
            kill: function() {
                // cancel slideshow
                stop();
                // reset element
                element.style.width = '';
                element.style.left = '';
                // reset slides
                var pos = slides.length;
                while(pos--){
                    var slide = slides[pos];
                    slide.style.width = '';
                    slide.style.left = '';
                    if (browser.transitions) translate(pos, 0, 0);
                }
                // removed event listeners
                if (browser.addEventListener) {
                    // remove current event listeners
                    element.removeEventListener('touchstart', events, false);
                    element.removeEventListener('webkitTransitionEnd', events, false);
                    element.removeEventListener('msTransitionEnd', events, false);
                    element.removeEventListener('oTransitionEnd', events, false);
                    element.removeEventListener('otransitionend', events, false);
                    element.removeEventListener('transitionend', events, false);
                    window.removeEventListener('resize', events, false);
                } else window.onresize = null;
            }
        };
    };
});

});

parcelRegister("1DYgm", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("4kGcU", function(module, exports) {

$parcel$export(module.exports, "SOUTH_PAVILION_REFS", function () { return $3c57e64edec1d638$export$69939903710306ef; });
$parcel$export(module.exports, "default", function () { return $3c57e64edec1d638$export$2e2bcd8739ae039; });
const $3c57e64edec1d638$export$69939903710306ef = new Set([
    "pav1",
    "pav3",
    "pav5",
    "pav7",
    "pav9",
    "pav11",
    "pav13",
    "pav15"
]);
var $3c57e64edec1d638$export$2e2bcd8739ae039 = {
    kiosks: [
        {
            Pavilion: "Pad. 1",
            lat: 45.518256726665555,
            lng: 9.083576194044099,
            title: "K01",
            ref: "pav1",
            isSouth: true,
            zoom: 19.8,
            panOffset: 150,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 2",
            lat: 45.518868656078695,
            lng: 9.084017449026504,
            title: "K02",
            ref: "pav2",
            zoom: 20,
            panOffset: 250,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 3",
            lat: 45.51826094352421,
            lng: 9.083562555388454,
            title: "K03",
            ref: "pav3",
            isSouth: true,
            zoom: 19.8,
            panOffset: 150,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 4",
            lat: 45.51887348090412,
            lng: 9.08400307688862,
            title: "K04",
            ref: "pav4",
            zoom: 20,
            panOffset: 250,
            xPanOffset: 50
        },
        {
            Pavilion: "Pad. 5",
            lat: 45.5191472440992,
            lng: 9.081048788772392,
            title: "K05",
            ref: "pav5",
            isSouth: true,
            zoom: 20,
            panOffset: 100,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 6",
            lat: 45.519933742388616,
            lng: 9.080976347975792,
            title: "K06",
            ref: "pav6",
            zoom: 19.6,
            panOffset: 0,
            xPanOffset: -50
        },
        {
            Pavilion: "Pad. 7",
            lat: 45.519151875091865,
            lng: 9.081034993953523,
            title: "K07",
            ref: "pav7",
            isSouth: true,
            zoom: 20,
            panOffset: 100,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 9",
            lat: 45.52075083551185,
            lng: 9.076461198379803,
            title: "K09",
            ref: "pav9",
            isSouth: true,
            zoom: 19.8,
            panOffset: 150,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 10",
            lat: 45.519947149172594,
            lng: 9.080936411233921,
            title: "K10",
            ref: "pav10",
            zoom: 19.6,
            panOffset: 0,
            xPanOffset: 50
        },
        {
            Pavilion: "Pad. 11",
            lat: 45.520757093949925,
            lng: 9.076443439708527,
            title: "K11",
            ref: "pav11",
            isSouth: true,
            zoom: 19.8,
            panOffset: 150,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 13",
            lat: 45.52159225850994,
            lng: 9.07399133289286,
            title: "K13",
            ref: "pav13",
            isSouth: true,
            zoom: 20,
            panOffset: 250,
            xPanOffset: -300
        },
        {
            Pavilion: "Pad. 14",
            lat: 45.521186179263935,
            lng: 9.077446764010887,
            title: "K14",
            ref: "pav14",
            zoom: 19.8,
            panOffset: 0,
            xPanOffset: -120
        },
        {
            Pavilion: "Pad. 15",
            lat: 45.52164722536122,
            lng: 9.073848919933027,
            title: "K15",
            ref: "pav15",
            isSouth: true,
            zoom: 20,
            panOffset: -450,
            xPanOffset: 400
        },
        {
            Pavilion: "Pad. 18",
            lat: 45.52120142685109,
            lng: 9.077394260486443,
            title: "K18",
            ref: "pav18",
            zoom: 19.8,
            panOffset: 0,
            xPanOffset: 120
        },
        {
            Pavilion: "Pad. 22",
            lat: 45.52224289458832,
            lng: 9.074369850110315,
            title: "K22",
            ref: "pav22",
            zoom: 20,
            panOffset: 250,
            xPanOffset: 0
        },
        {
            Pavilion: "Pad. 24",
            lat: 45.52225066808077,
            lng: 9.0743496532628,
            title: "K24",
            ref: "pav24",
            zoom: 20,
            panOffset: 280,
            xPanOffset: 0
        },
        {
            Pavilion: "SS",
            lat: 45.51952550512078,
            lng: 9.078321480974722,
            title: "KSS",
            isSouth: true,
            zoom: 19.5,
            panOffset: 0,
            xPanOffset: 0
        },
        {
            Pavilion: "CI",
            lat: 45.5202425185451,
            lng: 9.07884932329173,
            title: "KCI",
            isSouth: true,
            zoom: 20,
            panOffset: 0,
            xPanOffset: 0
        }
    ]
};

});

class $50cc705403a73ebf$export$4fae95256245c8c0 {
    on(event, listener) {
        if (typeof this.events[event] !== 'object') this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.off(event, listener);
    }
    off(event, listener) {
        if (typeof this.events[event] !== 'object') return;
        this.events[event] = this.events[event].filter((eventListener)=>eventListener !== listener);
    }
    offAll() {
        Object.keys(this.events).forEach((event)=>this.events[event] = []);
    }
    emit(event, ...args) {
        if (typeof this.events[event] === 'object') [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
        [
            ...this.events['*']
        ].forEach((listener)=>listener.apply(this, [
                event,
                ...args
            ]));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
    constructor(){
        this.events = {
            '*': []
        };
    }
}


class $403d562f8e068716$export$2e2bcd8739ae039 extends (0, $50cc705403a73ebf$export$4fae95256245c8c0) {
    constructor({ $target: $target, initialState: initialState }){
        super();
        this.$target = $target;
        this.state = initialState;
        this.init();
        this.render();
    }
    /**
     * Component state change logic
     *
     * @param newState state value to change
     * @param preventRender If true, no rendering is done after the state is changed.
     * @param callback If set, called back if state has changed.
     */ setState(newState, preventRender, callback) {
        if (!this.checkNeedUpdate(newState)) return;
        if (this.state) this.state = {
            ...this.state,
            ...newState
        };
        else this.state = {
            ...newState
        };
        if (callback) {
            callback();
            return;
        }
        if (preventRender) return;
        this.render();
    }
    /**
     * Component state validation, basic... can use more advanced like fast-deep-equal package
     *
     * @param newState state value to validate
     */ checkNeedUpdate(newState) {
        const prevState = JSON.stringify({
            ...this.state
        });
        const currentState = JSON.stringify({
            ...this.state,
            ...newState
        });
        return prevState !== currentState;
    }
}



var $20654a4b7519d360$var$Urls = /*#__PURE__*/ function(Urls) {
    Urls["mapJS"] = "https://sdk.woosmap.com/map/map.js";
    Urls["widgetJS"] = "https://sdk.woosmap.com/map/widgets.js";
    Urls["lambdaExternal"] = "https://t0a2tbeh90.execute-api.eu-west-1.amazonaws.com/default/woosmap-service-sdm-id";
    Urls["favMarkerUrl"] = "https://indoor.woosmap.com/salone-del-mobile/assets/Pin-to-be-visted@3x.png";
    Urls["vistedShop"] = "https://indoor.woosmap.com/salone-del-mobile/assets/Pin.png";
    Urls["waypoints"] = "https://indoor.woosmap.com/salone-del-mobile/assets/stops";
    return Urls;
}($20654a4b7519d360$var$Urls || {});
var $20654a4b7519d360$export$2e2bcd8739ae039 = $20654a4b7519d360$var$Urls;


// index.ts
// index.ts
// index.js
// index.ts
var $99d87cb8abf11eaa$export$e3a1ee0e9945697f = 63710088e-1;
var $99d87cb8abf11eaa$export$f929e47acbed771a = {
    centimeters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 100,
    centimetres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 3.28084,
    inches: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 39.37,
    kilometers: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1e3,
    kilometres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1e3,
    meters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f,
    metres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f,
    miles: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1e3,
    millimetres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1.0936
};
var $99d87cb8abf11eaa$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $99d87cb8abf11eaa$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $99d87cb8abf11eaa$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $99d87cb8abf11eaa$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $99d87cb8abf11eaa$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $99d87cb8abf11eaa$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $99d87cb8abf11eaa$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $99d87cb8abf11eaa$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$99d87cb8abf11eaa$export$7e4aa119212bc614(coordinates[0]) || !$99d87cb8abf11eaa$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $99d87cb8abf11eaa$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $99d87cb8abf11eaa$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $99d87cb8abf11eaa$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $99d87cb8abf11eaa$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $99d87cb8abf11eaa$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $99d87cb8abf11eaa$export$c7a138e00a89bd01(distance, units) {
    return $99d87cb8abf11eaa$export$c41dd2a8460d3196($99d87cb8abf11eaa$export$a2280f7debae8f10(distance, units));
}
function $99d87cb8abf11eaa$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $99d87cb8abf11eaa$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $99d87cb8abf11eaa$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $99d87cb8abf11eaa$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $99d87cb8abf11eaa$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $99d87cb8abf11eaa$export$f234631d6a2eedf8($99d87cb8abf11eaa$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $99d87cb8abf11eaa$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $99d87cb8abf11eaa$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $99d87cb8abf11eaa$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $99d87cb8abf11eaa$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $99d87cb8abf11eaa$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $99d87cb8abf11eaa$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$99d87cb8abf11eaa$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $99d87cb8abf11eaa$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


function $3585f2d1a61dd970$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($3585f2d1a61dd970$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $3585f2d1a61dd970$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $3585f2d1a61dd970$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $3585f2d1a61dd970$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $3585f2d1a61dd970$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $3585f2d1a61dd970$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $3585f2d1a61dd970$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, callback) {
    $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $3585f2d1a61dd970$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$d3ecc1efb2be121e(geojson, callback) {
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($3585f2d1a61dd970$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $3585f2d1a61dd970$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $3585f2d1a61dd970$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $99d87cb8abf11eaa$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $3585f2d1a61dd970$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $99d87cb8abf11eaa$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $3585f2d1a61dd970$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $99d87cb8abf11eaa$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}



function $40b1a25d9324c658$export$7b82f38e9ee2ae8(geojson) {
    const points = [];
    if (geojson.type === "FeatureCollection") (0, $3585f2d1a61dd970$export$45a31c4de8035258)(geojson, function(feature) {
        (0, $3585f2d1a61dd970$export$6e011439fde007ae)(feature, function(coord) {
            points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord, feature.properties));
        });
    });
    else if (geojson.type === "Feature") (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, function(coord) {
        points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord, geojson.properties));
    });
    else (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, function(coord) {
        points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord));
    });
    return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)(points);
}
var $40b1a25d9324c658$export$2e2bcd8739ae039 = $40b1a25d9324c658$export$7b82f38e9ee2ae8;


// index.ts
// index.ts

function $72da53fb4eeebf24$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var $72da53fb4eeebf24$export$2e2bcd8739ae039 = $72da53fb4eeebf24$export$bf67010aacbe66fa;



function $4e1112713e478267$export$3481c78889e8fbe8(geojson, options = {}) {
    const ext = (0, $72da53fb4eeebf24$export$bf67010aacbe66fa)(geojson);
    const x = (ext[0] + ext[2]) / 2;
    const y = (ext[1] + ext[3]) / 2;
    return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)([
        x,
        y
    ], options.properties, options);
}
var $4e1112713e478267$export$2e2bcd8739ae039 = $4e1112713e478267$export$3481c78889e8fbe8;


// index.ts
function $15d3c242213cacca$export$9cd59f9826255e47(geojson) {
    if (!geojson) throw new Error("geojson is required");
    switch(geojson.type){
        case "Feature":
            return $15d3c242213cacca$var$cloneFeature(geojson);
        case "FeatureCollection":
            return $15d3c242213cacca$var$cloneFeatureCollection(geojson);
        case "Point":
        case "LineString":
        case "Polygon":
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
        case "GeometryCollection":
            return $15d3c242213cacca$var$cloneGeometry(geojson);
        default:
            throw new Error("unknown GeoJSON type");
    }
}
function $15d3c242213cacca$var$cloneFeature(geojson) {
    const cloned = {
        type: "Feature"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "properties":
            case "geometry":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.properties = $15d3c242213cacca$export$dc8a742a89aa85b4(geojson.properties);
    if (geojson.geometry == null) cloned.geometry = null;
    else cloned.geometry = $15d3c242213cacca$var$cloneGeometry(geojson.geometry);
    return cloned;
}
function $15d3c242213cacca$export$dc8a742a89aa85b4(properties) {
    const cloned = {};
    if (!properties) return cloned;
    Object.keys(properties).forEach((key)=>{
        const value = properties[key];
        if (typeof value === "object") {
            if (value === null) cloned[key] = null;
            else if (Array.isArray(value)) cloned[key] = value.map((item)=>{
                return item;
            });
            else cloned[key] = $15d3c242213cacca$export$dc8a742a89aa85b4(value);
        } else cloned[key] = value;
    });
    return cloned;
}
function $15d3c242213cacca$var$cloneFeatureCollection(geojson) {
    const cloned = {
        type: "FeatureCollection"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "features":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.features = geojson.features.map((feature)=>{
        return $15d3c242213cacca$var$cloneFeature(feature);
    });
    return cloned;
}
function $15d3c242213cacca$var$cloneGeometry(geometry) {
    const geom = {
        type: geometry.type
    };
    if (geometry.bbox) geom.bbox = geometry.bbox;
    if (geometry.type === "GeometryCollection") {
        geom.geometries = geometry.geometries.map((g)=>{
            return $15d3c242213cacca$var$cloneGeometry(g);
        });
        return geom;
    }
    geom.coordinates = $15d3c242213cacca$var$deepSlice(geometry.coordinates);
    return geom;
}
function $15d3c242213cacca$var$deepSlice(coords) {
    const cloned = coords;
    if (typeof cloned[0] !== "object") return cloned.slice();
    return cloned.map((coord)=>{
        return $15d3c242213cacca$var$deepSlice(coord);
    });
}
var $15d3c242213cacca$export$2e2bcd8739ae039 = $15d3c242213cacca$export$9cd59f9826255e47;


// index.ts
// index.ts

function $9b195126e45e4c4e$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $9b195126e45e4c4e$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $9b195126e45e4c4e$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $99d87cb8abf11eaa$export$7e4aa119212bc614)(coordinates[0]) && (0, $99d87cb8abf11eaa$export$7e4aa119212bc614)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $9b195126e45e4c4e$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $9b195126e45e4c4e$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $9b195126e45e4c4e$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $9b195126e45e4c4e$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $9b195126e45e4c4e$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $9b195126e45e4c4e$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}



function $35bc333ffaf3f0e9$export$9f17032d917177de(from, to, options = {}) {
    var coordinates1 = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(from);
    var coordinates2 = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(to);
    var dLat = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates1[1]);
    var lat2 = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, $99d87cb8abf11eaa$export$f234631d6a2eedf8)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var $35bc333ffaf3f0e9$export$2e2bcd8739ae039 = $35bc333ffaf3f0e9$export$9f17032d917177de;



var $cdae9ad4d14de8da$var$__defProp = Object.defineProperty;
var $cdae9ad4d14de8da$var$__defProps = Object.defineProperties;
var $cdae9ad4d14de8da$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cdae9ad4d14de8da$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cdae9ad4d14de8da$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cdae9ad4d14de8da$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cdae9ad4d14de8da$var$__defNormalProp = (obj, key, value)=>key in obj ? $cdae9ad4d14de8da$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cdae9ad4d14de8da$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cdae9ad4d14de8da$var$__hasOwnProp.call(b, prop)) $cdae9ad4d14de8da$var$__defNormalProp(a, prop, b[prop]);
    if ($cdae9ad4d14de8da$var$__getOwnPropSymbols) {
        for (var prop of $cdae9ad4d14de8da$var$__getOwnPropSymbols(b))if ($cdae9ad4d14de8da$var$__propIsEnum.call(b, prop)) $cdae9ad4d14de8da$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cdae9ad4d14de8da$var$__spreadProps = (a, b)=>$cdae9ad4d14de8da$var$__defProps(a, $cdae9ad4d14de8da$var$__getOwnPropDescs(b));
function $cdae9ad4d14de8da$export$ba330bb14d26e4ac(targetPoint, points, options = {}) {
    if (!targetPoint) throw new Error("targetPoint is required");
    if (!points) throw new Error("points is required");
    let minDist = Infinity;
    let bestFeatureIndex = 0;
    (0, $3585f2d1a61dd970$export$45a31c4de8035258)(points, (pt, featureIndex)=>{
        const distanceToPoint = (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(targetPoint, pt, options);
        if (distanceToPoint < minDist) {
            bestFeatureIndex = featureIndex;
            minDist = distanceToPoint;
        }
    });
    const nearestPoint2 = (0, $15d3c242213cacca$export$9cd59f9826255e47)(points.features[bestFeatureIndex]);
    return $cdae9ad4d14de8da$var$__spreadProps($cdae9ad4d14de8da$var$__spreadValues({}, nearestPoint2), {
        properties: $cdae9ad4d14de8da$var$__spreadProps($cdae9ad4d14de8da$var$__spreadValues({}, nearestPoint2.properties), {
            featureIndex: bestFeatureIndex,
            distanceToPoint: minDist
        })
    });
}
var $cdae9ad4d14de8da$export$2e2bcd8739ae039 = $cdae9ad4d14de8da$export$ba330bb14d26e4ac;


// index.ts
const $b7be22ffc815751f$export$6c421550c66a327d = 1.1102230246251565e-16;
const $b7be22ffc815751f$export$8cfde575cbd41e40 = 134217729;
const $b7be22ffc815751f$export$a4103c3ab16b06d7 = (3 + 8 * $b7be22ffc815751f$export$6c421550c66a327d) * $b7be22ffc815751f$export$6c421550c66a327d;
function $b7be22ffc815751f$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $b7be22ffc815751f$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $b7be22ffc815751f$export$8a63f25cc62965f1($b7be22ffc815751f$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $b7be22ffc815751f$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $b7be22ffc815751f$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $b7be22ffc815751f$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $b7be22ffc815751f$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $b7be22ffc815751f$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $b7be22ffc815751f$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $b7be22ffc815751f$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $a080ad2b3b4d3b31$var$ccwerrboundA = (3 + 16 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$ccwerrboundB = (2 + 12 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$ccwerrboundC = (9 + 64 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$B = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $a080ad2b3b4d3b31$var$C1 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $a080ad2b3b4d3b31$var$C2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(12);
const $a080ad2b3b4d3b31$var$D = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $a080ad2b3b4d3b31$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
function $a080ad2b3b4d3b31$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$B[3] = u3;
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(4, $a080ad2b3b4d3b31$var$B);
    let errbound = $a080ad2b3b4d3b31$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $a080ad2b3b4d3b31$var$ccwerrboundC * detsum + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const C1len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $a080ad2b3b4d3b31$var$B, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$C1);
    s1 = acx * bcytail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const C2len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(C1len, $a080ad2b3b4d3b31$var$C1, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const Dlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(C2len, $a080ad2b3b4d3b31$var$C2, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$D);
    return $a080ad2b3b4d3b31$var$D[Dlen - 1];
}
function $a080ad2b3b4d3b31$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $a080ad2b3b4d3b31$var$ccwerrboundA * detsum) return det;
    return -$a080ad2b3b4d3b31$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $a080ad2b3b4d3b31$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $cdc6986ffa648f91$var$o3derrboundA = (7 + 56 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$o3derrboundB = (3 + 28 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$o3derrboundC = (26 + 288 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$at_b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$at_c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bt_c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bt_a = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ct_a = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ct_b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bct = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$cat = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$abt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_8b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_12 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(12);
let $cdc6986ffa648f91$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
let $cdc6986ffa648f91$var$fin2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
function $cdc6986ffa648f91$var$finadd(finlen, alen, a) {
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(finlen, $cdc6986ffa648f91$var$fin, alen, a, $cdc6986ffa648f91$var$fin2);
    const tmp = $cdc6986ffa648f91$var$fin;
    $cdc6986ffa648f91$var$fin = $cdc6986ffa648f91$var$fin2;
    $cdc6986ffa648f91$var$fin2 = tmp;
    return finlen;
}
function $cdc6986ffa648f91$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $cdc6986ffa648f91$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $cdc6986ffa648f91$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $cdc6986ffa648f91$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $cdc6986ffa648f91$var$u[2] = _k - (u3 - _j);
    $cdc6986ffa648f91$var$u[3] = u3;
    finlen = $cdc6986ffa648f91$var$finadd(finlen, 4, $cdc6986ffa648f91$var$u);
    if (z !== 0) {
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $cdc6986ffa648f91$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $cdc6986ffa648f91$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $cdc6986ffa648f91$var$u[2] = _k - (u3 - _j);
        $cdc6986ffa648f91$var$u[3] = u3;
        finlen = $cdc6986ffa648f91$var$finadd(finlen, 4, $cdc6986ffa648f91$var$u);
    }
    return finlen;
}
function $cdc6986ffa648f91$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$ab[3] = u3;
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$bc, adz, $cdc6986ffa648f91$var$_8), $cdc6986ffa648f91$var$_8, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ca, bdz, $cdc6986ffa648f91$var$_8b), $cdc6986ffa648f91$var$_8b, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ab, cdz, $cdc6986ffa648f91$var$_8), $cdc6986ffa648f91$var$_8, $cdc6986ffa648f91$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $cdc6986ffa648f91$var$fin);
    let errbound = $cdc6986ffa648f91$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $cdc6986ffa648f91$var$o3derrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $cdc6986ffa648f91$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $cdc6986ffa648f91$var$at_b, $cdc6986ffa648f91$var$at_c);
    const bt_len = $cdc6986ffa648f91$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $cdc6986ffa648f91$var$bt_c, $cdc6986ffa648f91$var$bt_a);
    const ct_len = $cdc6986ffa648f91$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $cdc6986ffa648f91$var$ct_a, $cdc6986ffa648f91$var$ct_b);
    const bctlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(bt_len, $cdc6986ffa648f91$var$bt_c, ct_len, $cdc6986ffa648f91$var$ct_b, $cdc6986ffa648f91$var$bct);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $cdc6986ffa648f91$var$bct, adz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    const catlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(ct_len, $cdc6986ffa648f91$var$ct_a, at_len, $cdc6986ffa648f91$var$at_c, $cdc6986ffa648f91$var$cat);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $cdc6986ffa648f91$var$cat, bdz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    const abtlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(at_len, $cdc6986ffa648f91$var$at_b, bt_len, $cdc6986ffa648f91$var$bt_a, $cdc6986ffa648f91$var$abt);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $cdc6986ffa648f91$var$abt, cdz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    if (adztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$bc, adztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $cdc6986ffa648f91$var$bct, adztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ca, bdztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $cdc6986ffa648f91$var$cat, bdztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ab, cdztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $cdc6986ffa648f91$var$abt, cdztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $cdc6986ffa648f91$var$fin[finlen - 1];
}
function $cdc6986ffa648f91$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $cdc6986ffa648f91$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $cdc6986ffa648f91$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $cdc6986ffa648f91$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $39d7b03a6050569c$var$iccerrboundA = (10 + 96 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$iccerrboundB = (4 + 48 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$iccerrboundC = (44 + 576 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$ca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$aa = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$bb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$cc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$v = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$axtbc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$aytbc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bxtca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bytca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cxtab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cytab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$abt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bct = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cat = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$abtt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$bctt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$catt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_16b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_16c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_32 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(32);
const $39d7b03a6050569c$var$_32b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(32);
const $39d7b03a6050569c$var$_48 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $39d7b03a6050569c$var$_64 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(64);
let $39d7b03a6050569c$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
let $39d7b03a6050569c$var$fin2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
function $39d7b03a6050569c$var$finadd(finlen, a, alen) {
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(finlen, $39d7b03a6050569c$var$fin, a, alen, $39d7b03a6050569c$var$fin2);
    const tmp = $39d7b03a6050569c$var$fin;
    $39d7b03a6050569c$var$fin = $39d7b03a6050569c$var$fin2;
    $39d7b03a6050569c$var$fin2 = tmp;
    return finlen;
}
function $39d7b03a6050569c$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$ab[3] = u3;
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, ady, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, ady, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdy, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32b), $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdy, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $39d7b03a6050569c$var$fin);
    let errbound = $39d7b03a6050569c$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $39d7b03a6050569c$var$iccerrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adxtail, $39d7b03a6050569c$var$axtbc);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(axtbclen, $39d7b03a6050569c$var$axtbc, 2 * adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -cdy, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adytail, $39d7b03a6050569c$var$aytbc);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(aytbclen, $39d7b03a6050569c$var$aytbc, 2 * ady, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, adytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -bdx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdxtail, $39d7b03a6050569c$var$bxtca);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bxtcalen, $39d7b03a6050569c$var$bxtca, 2 * bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -ady, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdytail, $39d7b03a6050569c$var$bytca);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bytcalen, $39d7b03a6050569c$var$bytca, 2 * bdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, bdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -cdx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdxtail, $39d7b03a6050569c$var$cxtab);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cxtablen, $39d7b03a6050569c$var$cxtab, 2 * cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, ady, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -bdy, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdytail, $39d7b03a6050569c$var$cytab);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cytablen, $39d7b03a6050569c$var$cytab, 2 * cdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, cdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -adx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            bctlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $39d7b03a6050569c$var$bct[0] = 0;
            bctlen = 1;
            $39d7b03a6050569c$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $39d7b03a6050569c$var$bct, adxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(axtbclen, $39d7b03a6050569c$var$axtbc, adxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * adx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bcttlen, $39d7b03a6050569c$var$bctt, adxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, adxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, adxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (bdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (cdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, -adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $39d7b03a6050569c$var$bct, adytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(aytbclen, $39d7b03a6050569c$var$aytbc, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * ady, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bcttlen, $39d7b03a6050569c$var$bctt, adytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * ady, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, adytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            catlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $39d7b03a6050569c$var$cat[0] = 0;
            catlen = 1;
            $39d7b03a6050569c$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $39d7b03a6050569c$var$cat, bdxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bxtcalen, $39d7b03a6050569c$var$bxtca, bdxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * bdx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(cattlen, $39d7b03a6050569c$var$catt, bdxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, bdxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, bdxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (cdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (adytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, -bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $39d7b03a6050569c$var$cat, bdytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bytcalen, $39d7b03a6050569c$var$bytca, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * bdy, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(cattlen, $39d7b03a6050569c$var$catt, bdytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * bdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, bdytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            abtlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $39d7b03a6050569c$var$abt[0] = 0;
            abtlen = 1;
            $39d7b03a6050569c$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $39d7b03a6050569c$var$abt, cdxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cxtablen, $39d7b03a6050569c$var$cxtab, cdxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * cdx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abttlen, $39d7b03a6050569c$var$abtt, cdxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, cdxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, cdxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (adytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (bdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, -cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $39d7b03a6050569c$var$abt, cdytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cytablen, $39d7b03a6050569c$var$cytab, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * cdy, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abttlen, $39d7b03a6050569c$var$abtt, cdytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * cdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, cdytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    return $39d7b03a6050569c$var$fin[finlen - 1];
}
function $39d7b03a6050569c$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $39d7b03a6050569c$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $39d7b03a6050569c$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $39d7b03a6050569c$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $81600ebf6aa664b1$var$isperrboundA = (16 + 224 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$isperrboundB = (5 + 72 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$isperrboundC = (71 + 1408 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$cd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$de = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ea = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ac = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$bd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ce = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$da = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$eb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$abc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$bcd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$cde = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$dea = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$eab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$abd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$bce = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$cda = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$deb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$eac = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$adet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$bdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$cdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$ddet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$edet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$abdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(2304);
const $81600ebf6aa664b1$var$cddet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(2304);
const $81600ebf6aa664b1$var$cdedet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(3456);
const $81600ebf6aa664b1$var$deter = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(5760);
const $81600ebf6aa664b1$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_8b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_8c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $81600ebf6aa664b1$var$_24 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$_48 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $81600ebf6aa664b1$var$_48b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $81600ebf6aa664b1$var$_96 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$_192 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
const $81600ebf6aa664b1$var$_384x = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_384y = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_384z = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_768 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(768);
function $81600ebf6aa664b1$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, a, az, $81600ebf6aa664b1$var$_8), $81600ebf6aa664b1$var$_8, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, b, bz, $81600ebf6aa664b1$var$_8b), $81600ebf6aa664b1$var$_8b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, c, cz, $81600ebf6aa664b1$var$_8c), $81600ebf6aa664b1$var$_8c, $81600ebf6aa664b1$var$_16, out);
}
function $81600ebf6aa664b1$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)(alen, a, blen, b, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, (0, $b7be22ffc815751f$export$aef51622e549b8b0)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)(clen, c, dlen, d, $81600ebf6aa664b1$var$_48b), $81600ebf6aa664b1$var$_48b), $81600ebf6aa664b1$var$_48b, $81600ebf6aa664b1$var$_96);
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, x, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, x, $81600ebf6aa664b1$var$_384x), $81600ebf6aa664b1$var$_384x, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, y, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, y, $81600ebf6aa664b1$var$_384y), $81600ebf6aa664b1$var$_384y, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, z, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, z, $81600ebf6aa664b1$var$_384z), $81600ebf6aa664b1$var$_384z, $81600ebf6aa664b1$var$_768, out);
}
function $81600ebf6aa664b1$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$eb[3] = u3;
    const abclen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ac, cz, az, -bz, $81600ebf6aa664b1$var$abc);
    const bcdlen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$bd, dz, bz, -cz, $81600ebf6aa664b1$var$bcd);
    const cdelen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$ce, ez, cz, -dz, $81600ebf6aa664b1$var$cde);
    const dealen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$da, az, dz, -ez, $81600ebf6aa664b1$var$dea);
    const eablen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$eb, bz, ez, -az, $81600ebf6aa664b1$var$eab);
    const abdlen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bd, $81600ebf6aa664b1$var$da, dz, az, bz, $81600ebf6aa664b1$var$abd);
    const bcelen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ce, $81600ebf6aa664b1$var$eb, ez, bz, cz, $81600ebf6aa664b1$var$bce);
    const cdalen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ac, az, cz, dz, $81600ebf6aa664b1$var$cda);
    const deblen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$eb, $81600ebf6aa664b1$var$bd, bz, dz, ez, $81600ebf6aa664b1$var$deb);
    const eaclen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$ac, $81600ebf6aa664b1$var$ce, cz, ez, az, $81600ebf6aa664b1$var$eac);
    const deterlen = (0, $b7be22ffc815751f$export$195a93e4bd4d876f)($81600ebf6aa664b1$var$liftexact(cdelen, $81600ebf6aa664b1$var$cde, bcelen, $81600ebf6aa664b1$var$bce, deblen, $81600ebf6aa664b1$var$deb, bcdlen, $81600ebf6aa664b1$var$bcd, ax, ay, az, $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet, $81600ebf6aa664b1$var$liftexact(dealen, $81600ebf6aa664b1$var$dea, cdalen, $81600ebf6aa664b1$var$cda, eaclen, $81600ebf6aa664b1$var$eac, cdelen, $81600ebf6aa664b1$var$cde, bx, by, bz, $81600ebf6aa664b1$var$bdet), $81600ebf6aa664b1$var$bdet, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)($81600ebf6aa664b1$var$liftexact(eablen, $81600ebf6aa664b1$var$eab, deblen, $81600ebf6aa664b1$var$deb, abdlen, $81600ebf6aa664b1$var$abd, dealen, $81600ebf6aa664b1$var$dea, cx, cy, cz, $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet, $81600ebf6aa664b1$var$liftexact(abclen, $81600ebf6aa664b1$var$abc, eaclen, $81600ebf6aa664b1$var$eac, bcelen, $81600ebf6aa664b1$var$bce, eablen, $81600ebf6aa664b1$var$eab, dx, dy, dz, $81600ebf6aa664b1$var$ddet), $81600ebf6aa664b1$var$ddet, $81600ebf6aa664b1$var$liftexact(bcdlen, $81600ebf6aa664b1$var$bcd, abdlen, $81600ebf6aa664b1$var$abd, cdalen, $81600ebf6aa664b1$var$cda, abclen, $81600ebf6aa664b1$var$abc, ex, ey, ez, $81600ebf6aa664b1$var$edet), $81600ebf6aa664b1$var$edet, $81600ebf6aa664b1$var$cddet, $81600ebf6aa664b1$var$cdedet), $81600ebf6aa664b1$var$cdedet, $81600ebf6aa664b1$var$abdet, $81600ebf6aa664b1$var$deter);
    return $81600ebf6aa664b1$var$deter[deterlen - 1];
}
const $81600ebf6aa664b1$var$xdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$ydet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$zdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
function $81600ebf6aa664b1$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $81600ebf6aa664b1$var$sum_three_scale(a, b, c, az, bz, cz, $81600ebf6aa664b1$var$_24);
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, x, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, x, $81600ebf6aa664b1$var$xdet), $81600ebf6aa664b1$var$xdet, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, y, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, y, $81600ebf6aa664b1$var$ydet), $81600ebf6aa664b1$var$ydet, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, z, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, z, $81600ebf6aa664b1$var$zdet), $81600ebf6aa664b1$var$zdet, $81600ebf6aa664b1$var$_192, out);
}
function $81600ebf6aa664b1$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $81600ebf6aa664b1$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $81600ebf6aa664b1$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $81600ebf6aa664b1$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $81600ebf6aa664b1$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $81600ebf6aa664b1$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $81600ebf6aa664b1$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bd[3] = bd3;
    const finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$aef51622e549b8b0)($81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$bd, dez, bez, -cez, aex, aey, aez, $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet, $81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ac, aez, cez, dez, bex, bey, bez, $81600ebf6aa664b1$var$bdet), $81600ebf6aa664b1$var$bdet, $81600ebf6aa664b1$var$abdet), $81600ebf6aa664b1$var$abdet, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$aef51622e549b8b0)($81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bd, bez, dez, aez, cex, cey, cez, $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet, $81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ac, cez, aez, -bez, dex, dey, dez, $81600ebf6aa664b1$var$ddet), $81600ebf6aa664b1$var$ddet, $81600ebf6aa664b1$var$cddet), $81600ebf6aa664b1$var$cddet, $81600ebf6aa664b1$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $81600ebf6aa664b1$var$fin);
    let errbound = $81600ebf6aa664b1$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $81600ebf6aa664b1$var$isperrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $81600ebf6aa664b1$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $81600ebf6aa664b1$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $81600ebf6aa664b1$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$81600ebf6aa664b1$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $81600ebf6aa664b1$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




function $488a266a48dd1b5c$export$2e2bcd8739ae039(p, polygon) {
    var i;
    var ii;
    var k = 0;
    var f;
    var u1;
    var v1;
    var u2;
    var v2;
    var currentP;
    var nextP;
    var x = p[0];
    var y = p[1];
    var numContours = polygon.length;
    for(i = 0; i < numContours; i++){
        ii = 0;
        var contour = polygon[i];
        var contourLen = contour.length - 1;
        currentP = contour[0];
        if (currentP[0] !== contour[contourLen][0] && currentP[1] !== contour[contourLen][1]) throw new Error('First and last coordinates in a ring must be the same');
        u1 = currentP[0] - x;
        v1 = currentP[1] - y;
        for(ii; ii < contourLen; ii++){
            nextP = contour[ii + 1];
            u2 = nextP[0] - x;
            v2 = nextP[1] - y;
            if (v1 === 0 && v2 === 0) {
                if (u2 <= 0 && u1 >= 0 || u1 <= 0 && u2 >= 0) return 0;
            } else if (v2 >= 0 && v1 <= 0 || v2 <= 0 && v1 >= 0) {
                f = (0, $a080ad2b3b4d3b31$export$bbb923599a46a7d8)(u1, u2, v1, v2, 0, 0);
                if (f === 0) return 0;
                if (f > 0 && v2 > 0 && v1 <= 0 || f < 0 && v2 <= 0 && v1 > 0) k++;
            }
            currentP = nextP;
            v1 = v2;
            u1 = u2;
        }
    }
    if (k % 2 === 0) return false;
    return true;
}



function $644c44cdb031b418$export$ae7424f794b3544b(point, polygon, options = {}) {
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    const pt = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(point);
    const geom = (0, $9b195126e45e4c4e$export$b8f320eb9549c8fd)(polygon);
    const type = geom.type;
    const bbox = polygon.bbox;
    let polys = geom.coordinates;
    if (bbox && $644c44cdb031b418$var$inBBox(pt, bbox) === false) return false;
    if (type === "Polygon") polys = [
        polys
    ];
    let result = false;
    for(var i = 0; i < polys.length; ++i){
        const polyResult = (0, $488a266a48dd1b5c$export$2e2bcd8739ae039)(pt, polys[i]);
        if (polyResult === 0) return options.ignoreBoundary ? false : true;
        else if (polyResult) result = true;
    }
    return result;
}
function $644c44cdb031b418$var$inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}
var $644c44cdb031b418$export$2e2bcd8739ae039 = $644c44cdb031b418$export$ae7424f794b3544b;



function $20c1bb73c4d4ca81$export$497c1ce5d547cfcd(geojson) {
    const fc = $20c1bb73c4d4ca81$var$normalize(geojson);
    const cent = (0, $4e1112713e478267$export$3481c78889e8fbe8)(fc);
    let onSurface = false;
    let i = 0;
    while(!onSurface && i < fc.features.length){
        const geom = fc.features[i].geometry;
        let x, y, x1, y1, x2, y2;
        let onLine = false;
        if (geom.type === "Point") {
            if (cent.geometry.coordinates[0] === geom.coordinates[0] && cent.geometry.coordinates[1] === geom.coordinates[1]) onSurface = true;
        } else if (geom.type === "MultiPoint") {
            let onMultiPoint = false;
            let k = 0;
            while(!onMultiPoint && k < geom.coordinates.length){
                if (cent.geometry.coordinates[0] === geom.coordinates[k][0] && cent.geometry.coordinates[1] === geom.coordinates[k][1]) {
                    onSurface = true;
                    onMultiPoint = true;
                }
                k++;
            }
        } else if (geom.type === "LineString") {
            let k = 0;
            while(!onLine && k < geom.coordinates.length - 1){
                x = cent.geometry.coordinates[0];
                y = cent.geometry.coordinates[1];
                x1 = geom.coordinates[k][0];
                y1 = geom.coordinates[k][1];
                x2 = geom.coordinates[k + 1][0];
                y2 = geom.coordinates[k + 1][1];
                if ($20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2)) {
                    onLine = true;
                    onSurface = true;
                }
                k++;
            }
        } else if (geom.type === "MultiLineString") {
            let j = 0;
            while(j < geom.coordinates.length){
                onLine = false;
                let k = 0;
                const line = geom.coordinates[j];
                while(!onLine && k < line.length - 1){
                    x = cent.geometry.coordinates[0];
                    y = cent.geometry.coordinates[1];
                    x1 = line[k][0];
                    y1 = line[k][1];
                    x2 = line[k + 1][0];
                    y2 = line[k + 1][1];
                    if ($20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2)) {
                        onLine = true;
                        onSurface = true;
                    }
                    k++;
                }
                j++;
            }
        } else if (geom.type === "Polygon" || geom.type === "MultiPolygon") {
            if ((0, $644c44cdb031b418$export$ae7424f794b3544b)(cent, geom)) onSurface = true;
        }
        i++;
    }
    if (onSurface) return cent;
    else {
        const vertices = (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([]);
        for(let f = 0; f < fc.features.length; f++)vertices.features = vertices.features.concat((0, $40b1a25d9324c658$export$7b82f38e9ee2ae8)(fc.features[f]).features);
        return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)((0, $cdae9ad4d14de8da$export$ba330bb14d26e4ac)(cent, vertices).geometry.coordinates);
    }
}
function $20c1bb73c4d4ca81$var$normalize(geojson) {
    if (geojson.type !== "FeatureCollection") {
        if (geojson.type !== "Feature") return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([
            (0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geojson)
        ]);
        return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([
            geojson
        ]);
    }
    return geojson;
}
function $20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2) {
    const ab = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    const ap = Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
    const pb = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
    return ab === ap + pb;
}
var $20c1bb73c4d4ca81$export$2e2bcd8739ae039 = $20c1bb73c4d4ca81$export$497c1ce5d547cfcd;


const $bee92962b46fc3f3$var$woosmapPublicKey = "woos-a10037a3-3f08-311e-af1d-2eb8b922749a";
const $bee92962b46fc3f3$var$libraries = "widgets";
const $bee92962b46fc3f3$var$env = "prod";
const $bee92962b46fc3f3$var$eventYear = "2026";
const $bee92962b46fc3f3$var$MAX_WAYPOINTS_ALLOWED = 15;
const $bee92962b46fc3f3$var$mapOptions = {
    center: {
        lat: 49,
        lng: 9
    },
    zoom: 18,
    styles: [
        {
            featureType: "all",
            stylers: [
                {
                    "saturation": -100
                }
            ]
        }
    ]
};
const $bee92962b46fc3f3$var$mobileBreakPoint = 768;
const $bee92962b46fc3f3$var$bucket = $bee92962b46fc3f3$var$env === "prod" ? "" : "-stage";
const $bee92962b46fc3f3$var$indoorRendererOptions = {
    centerMap: false,
    theme: `sdm_default_${$bee92962b46fc3f3$var$eventYear}`,
    venue: $bee92962b46fc3f3$var$env === "prod" ? `SDM_${$bee92962b46fc3f3$var$eventYear}` : `sdm_${$bee92962b46fc3f3$var$eventYear}_dev`,
    forceExtrusion: false,
    useInfoWindow: false,
    snapToVenueBounds: true,
    directionsIcons: {
        destinationIcon: {
            url: `https://indoor.woosmap.com/salone-del-mobile${$bee92962b46fc3f3$var$bucket}/assets/destination.png`,
            scaledSize: {
                height: 40,
                width: 40
            },
            anchor: {
                x: 20,
                y: 38
            }
        },
        originIcon: {
            url: `https://indoor.woosmap.com/salone-del-mobile${$bee92962b46fc3f3$var$bucket}/assets/origin.png?v=1`,
            scaledSize: {
                height: 30,
                width: 30
            },
            anchor: {
                x: 15,
                y: 15
            }
        }
    },
    polylineOptions: {
        color: "#00158F",
        strokeColor: "#00158F",
        highlightColor: "#0090FF"
    }
};
const $bee92962b46fc3f3$var$widgetOptions = {
    // autocompleteWithDistance: true,
    ui: {
        primaryColor: "rgb(0 0 0 / 80%)",
        secondaryColor: "#e30613"
    },
    autocomplete: {
        maxResponses: 10,
        autocompleteWithDistance: false,
        baseFilter: ""
    }
};
const $bee92962b46fc3f3$var$GATag = $bee92962b46fc3f3$var$env === "prod" ? "GTM-WJM8VDL2" : "GTM-MQ2P2JCK";
const $bee92962b46fc3f3$var$themes = {
    default: `sdm_default_${$bee92962b46fc3f3$var$eventYear}`,
    favorites: "favorites"
};
var $bee92962b46fc3f3$export$2e2bcd8739ae039 = {
    mapOptions: $bee92962b46fc3f3$var$mapOptions,
    indoorRendererOptions: $bee92962b46fc3f3$var$indoorRendererOptions,
    indoorWidgetOptions: $bee92962b46fc3f3$var$widgetOptions,
    woosmapPublicKey: $bee92962b46fc3f3$var$woosmapPublicKey,
    libraries: $bee92962b46fc3f3$var$libraries,
    query: '',
    GATag: $bee92962b46fc3f3$var$GATag,
    env: $bee92962b46fc3f3$var$env,
    themes: $bee92962b46fc3f3$var$themes,
    mobileBreakPoint: $bee92962b46fc3f3$var$mobileBreakPoint,
    eventYear: $bee92962b46fc3f3$var$eventYear,
    MAX_WAYPOINTS_ALLOWED: $bee92962b46fc3f3$var$MAX_WAYPOINTS_ALLOWED
};




const $ec948a4cf72a2ce9$export$f84bd70098573c5c = {
    map: (0, $bee92962b46fc3f3$export$2e2bcd8739ae039),
    urls: (0, $20654a4b7519d360$export$2e2bcd8739ae039)
};
let $ec948a4cf72a2ce9$var$currentConfig = $ec948a4cf72a2ce9$export$f84bd70098573c5c;
function $ec948a4cf72a2ce9$export$29b4b847eef7ae1e(configObj) {
    const config = configObj || {};
    return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
        ...config
    }, {
        ...$ec948a4cf72a2ce9$var$currentConfig
    });
}
function $ec948a4cf72a2ce9$export$940a7873bb071df8(configObj) {
    $ec948a4cf72a2ce9$var$currentConfig = $ec948a4cf72a2ce9$export$29b4b847eef7ae1e(configObj);
}
function $ec948a4cf72a2ce9$export$44487a86467333c3() {
    return $ec948a4cf72a2ce9$var$currentConfig;
}


function $ee9cb80b5c23ac97$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $ee9cb80b5c23ac97$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(input) {
    return typeof input === 'object' && input !== null && !Array.isArray(input);
}
function $ee9cb80b5c23ac97$export$4950aa0f605343fb(target, source) {
    if (!$ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(source) || !$ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(sourceProp) && $ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(targetProp)) $ee9cb80b5c23ac97$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $ee9cb80b5c23ac97$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), keyValues[key]);
    });
    return result;
}
function $ee9cb80b5c23ac97$export$53fc19a32de59f94(feature) {
    let position = {
        lat: 0,
        lng: 0
    };
    if (feature && feature.geometry && feature.geometry.type === 'Polygon') {
        const center = (0, $20c1bb73c4d4ca81$export$497c1ce5d547cfcd)(feature);
        position = {
            lat: center.geometry.coordinates[1],
            lng: center.geometry.coordinates[0]
        };
    } else if (feature && feature.geometry && feature.geometry.type === 'Point') position = {
        lat: feature.geometry.coordinates[1],
        lng: feature.geometry.coordinates[0]
    };
    return position;
}
function $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17(message, type) {
    const container = document.getElementById("woos-toast-container");
    if (!container) return;
    const existingToast = container.querySelector(`.woos-toast.${type}`);
    if (existingToast) return;
    const toast = document.createElement("div");
    toast.className = `woos-toast ${type}`;
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(()=>{
        toast.remove();
    }, 4500);
}
function $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8(building) {
    if (building === "C.SO+ITALIA") return "Corso Italia";
    return building;
}
function $ee9cb80b5c23ac97$export$7d9f9b4046392aed() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width < (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mobileBreakPoint) return true;
    return false;
}
function $ee9cb80b5c23ac97$export$3ba45bd218cae310(isMobile = false) {
    const defaultPadding = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    };
    let panelHeight = 0;
    let panelWidth = 0;
    const headerContent = document.getElementsByClassName("woosmap-panel__content__header")[0];
    const bodyContent = document.getElementsByClassName("woosmap-panel__content__body")[0];
    const searchBarContainer = document.getElementsByClassName("woosmap-panel__header")[0];
    if (searchBarContainer && headerContent && bodyContent) {
        panelHeight = headerContent.clientHeight + bodyContent.clientHeight + searchBarContainer.clientHeight;
        panelWidth = searchBarContainer.clientWidth;
    }
    panelHeight = isMobile ? 0 : panelHeight;
    if ($ee9cb80b5c23ac97$export$7d9f9b4046392aed()) defaultPadding.bottom = panelHeight;
    else defaultPadding.left = panelWidth;
    return defaultPadding;
}



/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $109f615c63b90aba$var$cachedScripts = {};
function $109f615c63b90aba$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override, callback: callback } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    const existing = $109f615c63b90aba$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $109f615c63b90aba$var$getScriptElement(src);
            if (script) {
                delete $109f615c63b90aba$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($109f615c63b90aba$var$findScript(src)) resolve();
        const script = $109f615c63b90aba$export$28503efd90ff36be(url, params);
        const dependencyScriptSrc = (0, $20654a4b7519d360$export$2e2bcd8739ae039).widgetJS;
        const loadDependency = (dependencySrc)=>{
            return new Promise((dependencyResolve, dependencyReject)=>{
                const dependencyScript = $109f615c63b90aba$export$28503efd90ff36be(dependencySrc);
                const onDependencyScriptLoad = ()=>{
                    dependencyScript.removeEventListener('load', onDependencyScriptLoad);
                    dependencyScript.removeEventListener('error', onDependencyScriptError);
                    dependencyResolve();
                };
                const onDependencyScriptError = ()=>{
                    cleanup();
                    delete $109f615c63b90aba$var$cachedScripts[dependencySrc];
                    dependencyScript.remove();
                    const dependencyError = new Error(`The dependency script "${dependencySrc}" failed to load.`);
                    dependencyReject(dependencyError);
                };
                dependencyScript.addEventListener('load', onDependencyScriptLoad);
                dependencyScript.addEventListener('error', onDependencyScriptError);
                document.body.insertBefore(dependencyScript, document.body.lastElementChild);
            });
        };
        const onScriptLoad = ()=>{
            cleanup();
            if (callback) callback(); // Execute the callback after script and dependencies have loaded
        /* TO DO : CHECK NO INDOOR WIDGET LOAD FROM APP AND NOT MAPS JS lib
            loadDependency(dependencyScriptSrc)
                    .then(() => {
                        if (callback) {
                            callback(); // Execute the callback after script and dependencies have loaded
                        }
                        resolve();
                    })
                    .catch((dependencyError) => {
                        reject(dependencyError);
                    });
            */ };
        const onScriptError = ()=>{
            cleanup();
            delete $109f615c63b90aba$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        document.body.insertBefore(script, document.body.lastElementChild);
        function cleanup() {
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
        }
    });
    $109f615c63b90aba$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $109f615c63b90aba$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $109f615c63b90aba$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $109f615c63b90aba$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    newScript.async = true;
    newScript.defer = true;
    return newScript;
}
function $109f615c63b90aba$export$41a88579f6bd1282() {
    $109f615c63b90aba$var$cachedScripts = {};
}



/**
 * Language: English.
 */ var $ce6b24fd3f3f3a3b$export$2e2bcd8739ae039 = {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1",
        allexhibits: "All exhibitors",
        favorites: "Your exhibitors to visit",
        select_thematic: "Select Thematics",
        allexhibits_mobile: "All exhibitors",
        favorites_mobile: "Your exhibitors to visit",
        select_thematic_mobile: "Theme path",
        add_favorites: "Add to your exhibitors",
        remove_favorites: "Remove",
        add_favorites_toast: "Added to your list of exhibitors to visit",
        remove_favorites_toast: "Removed from your list of exhibitors to visit",
        api_error: "You need to login to access your exhibitors",
        level: "Level",
        destination: "Destination",
        origin: "Origin",
        sponsored_logo_selection: "Click on the brand logo to view the stand location",
        to_visit: "Visited",
        visited_toast: "The exhibitor has been marked as visited.",
        unvisited_toast: "Exhibitor no longer marked as visited"
    },
    thematics: {
        "umbrella": "Umbrellas and Pergolas",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Rugs"
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY.",
        "umbrella": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Dolor sit amet consectetur adipiscing elit quisque faucibus.",
        "smartoffice": "Adipiscing elit quisque faucibus ex sapien vitae pellentesque.",
        "eclectic": "Vitae pellentesque sem placerat in id cursus mi. Cursus mi pretium tellus duis convallis tempus leo.",
        "dol": "Tempus leo eu aenean sed diam urna tempor. Urna tempor pulvinar vivamus fringilla lacus nec metus.",
        "uol": " Semper vel class aptent taciti sociosqu ad litora. Conubia nostra inceptos himenaeos orci varius natoque penatibus.",
        "homent": "Dis parturient montes nascetur ridiculus mus donec rhoncus.",
        "rug": "Nulla molestie mattis scelerisque maximus eget fermentum odio. Purus est efficitur laoreet mauris pharetra vestibulum fusce."
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    keyboard: {
        space: "Space"
    },
    indoor: {
        'Search': 'Search',
        'Itinerary': 'Itinerary',
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday',
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',
        'Sunday': 'Sunday',
        'levels': 'levels',
        'level': 'level',
        'Level': 'Level',
        'Select Positions': 'Select Positions',
        'Type a origin': 'Type a origin',
        'Type a destination': 'Type a destination',
        'No route found': 'No route found',
        'Shops': 'Shops',
        'at Level': 'at Level',
        'At': 'At',
        'up': 'up',
        'down': 'down',
        'Your Location': 'Your Location',
        'Accessible for people with disabilities': 'Accessible for people with disabilities',
        'Navigate': 'Navigate',
        'Then': 'Then',
        'you are arrived': 'you are arrived',
        'Overview': 'Overview',
        'Center': 'Center',
        'Less than 1min': "Less than 1 min",
        'Next': "Next",
        'Previous': "Previous",
        'Quit': "Quit",
        'Resume': "Resume",
        'in': "in",
        'Open': "Open",
        'Closed': "Closed",
        'Closes at': "Closes at",
        'Opens': "Opens",
        'tomorrow': "tomorrow",
        'at': 'at',
        'Select a location and a destination': "Select a location and a destination",
        'Disability compliant': "Disability compliant",
        'ETA': "ETA",
        'search_stop': "Search brand to add stop...",
        "stop_cta": "Intermediate stops",
        "stop_search_label": "Add Stops",
        "steps": "stops",
        "optimized_route_cta_label": "Create optimized Route",
        "optimized_route_cta_desc": "Optimize your route to visit your favorite exhibitors.",
        "optimized_route_cta_button": "Create your route",
        "route_loader_header": "Calculating optimal route",
        "route_loader_title": "Finding the best path for your visit",
        "route_panel_title": "Create Route",
        "route_field_origin_label": "Starting Point",
        "route_field_des_label": "Final Destination",
        "exit_gate_label": "Indicate your fair exit gate",
        "cancel": "Cancel",
        "from": "from",
        "to": "to",
        "results_summary_header": "Optimized Route",
        "edit": "Edit",
        "start_navigation": "Start Navigation",
        "exit_gate_warning": "By selecting the fair exit gate, the route\u2019s final destination will be overwritten",
        "duplicate_stop_warning": "Stop already exists in route",
        "for": "for",
        "go_to_stop": "Bring me to stop",
        "of": "of",
        "meters": "meters",
        "Pause": "Pause",
        "Steps": "Stops",
        "leg_step": "Steps",
        "final_destination": "Final destination",
        "max_stop_limit_warning": "Max stop limit exceeded",
        "set_as_origin": "Set as origin",
        "set_as_destination": "Set as destination",
        "same_origin_destination_warning": "Origin and destination can\u2019t be the same",
        "fav_route_builder_heading": "Your list of exhibitors to visit",
        "fav_route_builder_sub_heading": "Select up to 15 and set starting point / final destination to create your personalized route",
        "fav_route_builder_selected_exhibitors": "Selected exhibitors:",
        "fav_route_builder_min_stop_message": "Select at least 3 exhibitors you wish to visit to create your personalised route.",
        'destination_in_sight': 'Destination in sight!',
        'continue_to_reach': 'Continue for {distance} to reach {name}',
        'unauthorised_favs': 'Log in and select the exhibitors you wish to visit to create your personalised route.',
        'unauthorized_map_toast': 'Log in to create your list of exhibitors to visit',
        'empty_map_toast': 'Search for an exhibitor or tap their name on the map to add them to your personal list',
        "edit_stops": "Edit stops",
        "route_builder_toast": "Set the origin and destination to optimize the route."
    }
};


/**
 * Language: Italian.
 */ var $7cc7518b768c600c$export$2e2bcd8739ae039 = {
    "messages": {
        "choose_thematic": "Scegli Tematica",
        "sessionReset": "La sessione si reimposter\xe0 automaticamente tra",
        "minute": "minuto",
        "resetMap": "Reimposta Mappa",
        "selectLanguage": "Seleziona una Lingua",
        "seconds": "secondi",
        "cta": {
            "switch_standard_view": "Passa alla visualizzazione standard"
        },
        "minutes": "minuti",
        "multilevelwarning": "Questo percorso \xe8 su due livelli e passa anche per il Quick Link a livello 1",
        "allexhibits": "Tutti gli espositori",
        "favorites": "Espositori da visitare",
        "select_thematic": "Percorsi tematici",
        "add_favorites": "Aggiungi ai tuoi espositori",
        "remove_favorites": "Rimuovi",
        "add_favorites_toast": "Aggiunto alla lista degli espositori che vuoi visitare",
        "remove_favorites_toast": "Rimosso degli espositori che vuoi visitare",
        "level": "Livello",
        "allexhibits_mobile": "Tutti gli espositori",
        "favorites_mobile": "Espositori da visitare",
        "select_thematic_mobile": "Percorsi a tema",
        "api_error": "Devi effettuare il login per accedere ai tuoi espositori",
        "destination": "Destinazione",
        "origin": "Partenza",
        "sponsored_logo_selection": "Clicca sul logo del brand per visualizzare la posizione lo stand",
        "to_visit": "Visitato",
        "visited_toast": "Espositore contrassegnato come visitato",
        "unvisited_toast": "Esposizione non pi\xf9 segnato come visitato"
    },
    "thematics": {
        "umbrella": "Ombrelloni e pergole",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Tappeti"
    },
    "thematicDescription": {
        "outdoor": "Design, durabilit\xe0 e comfort: evoluzione continua per arredare giardini, terrazzi e spazi di piccole dimensioni.",
        "textile": "Percorsi tessili che intrecciano tecnologie pi\xf9 avanzate e inconfondibile segno artigianale.",
        "wallpaper": "Soluzioni e ricerche tra materiali, pattern e colori che uniscono tecnica ed estetica.",
        "kitchen": "Progetti, arredi su misura e soluzioni per hotel, residence, uffici e retail.",
        "bathroom": "Arredi ad alto tasso di innovazione: la sostenibilit\xe0 idrica secondo Salotto NY.",
        "umbrella": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Dolor sit amet consectetur adipiscing elit quisque faucibus.",
        "smartoffice": "Adipiscing elit quisque faucibus ex sapien vitae pellentesque.",
        "eclectic": "Vitae pellentesque sem placerat in id cursus mi. Cursus mi pretium tellus duis convallis tempus leo.",
        "dol": "Tempus leo eu aenean sed diam urna tempor. Urna tempor pulvinar vivamus fringilla lacus nec metus.",
        "uol": " Semper vel class aptent taciti sociosqu ad litora. Conubia nostra inceptos himenaeos orci varius natoque penatibus.",
        "homent": "Dis parturient montes nascetur ridiculus mus donec rhoncus.",
        "rug": "Nulla molestie mattis scelerisque maximus eget fermentum odio. Purus est efficitur laoreet mauris pharetra vestibulum fusce."
    },
    "errors": {
        "loadingLibrary": "Impossibile caricare lo script {library}",
        "geolocationFailed": "Geolocalizzazione dell'utente fallita",
        "apiErrors": {
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore interno del server",
            "other": "Si \xe8 verificato un errore imprevisto del server"
        }
    },
    "keyboard": {
        "space": "Spazio"
    },
    "indoor": {
        'Search': 'Cerca',
        'Itinerary': 'Itinerario',
        'Monday': "Luned\xec",
        'Tuesday': "Marted\xec",
        'Wednesday': "Mercoled\xec",
        'Thursday': "Gioved\xec",
        'Friday': "Venerd\xec",
        'Saturday': 'Sabato',
        'Sunday': 'Domenica',
        'levels': 'Livelli',
        'level': 'Livello',
        'Level': 'Livello',
        'Select Positions': 'Seleziona un punto di partenza e una destinazione',
        'Type a origin': 'Punto di partenza',
        'Type a destination': 'Destinazione',
        'No route found': 'Nessun percorso trovato',
        'Shops': 'Negozi',
        'at Level': 'al Livello',
        'At': 'A',
        'up': 'su',
        'down': "gi\xf9",
        'Your Location': 'La tua posizione',
        'Accessible for people with disabilities': "Accessibile alle persone con disabilit\xe0",
        'Navigate': 'Naviga',
        'Then': 'Poi',
        'you are arrived': 'sei arrivato',
        'Overview': 'Panoramica',
        'Center': 'Centra',
        'Less than 1min': "Meno di 1 minuto",
        'Next': "Successivo",
        'Previous': "Precedente",
        'Quit': "Esci",
        'Resume': "Riprendi",
        'in': "in",
        'Open': "Aperto",
        'Closed': "Chiuso",
        'Closes at': "Chiude alle",
        'Opens': "Apre",
        'tomorrow': "domani",
        'at': 'alle',
        'Select a location and a destination': "Seleziona un luogo e una destinazione",
        'Disability compliant': "Percorso accessibile",
        'ETA': "Tempo stimato di arrivo",
        'search_stop': "Cerca brand...",
        "stop_cta": "Aggiungi fermate",
        "stop_search_label": "Aggiungi fermate intermedie",
        "steps": "tappe",
        "optimized_route_cta_label": "Crea percorso personalizzato",
        "optimized_route_cta_desc": "Ottimizza il tuo percorso per visitare i tuoi espositori preferiti.",
        "optimized_route_cta_button": "Crea il tuo percorso",
        "route_loader_header": "\xc8 in corso l\u2019ottimizzazione del percorso",
        "route_loader_title": "Stiamo cercando il percorso migliore per la tua visita",
        "route_panel_title": "Crea percorso peronalizzato",
        "route_field_origin_label": "Partenza",
        "route_field_des_label": "Arrivo",
        "exit_gate_label": "Indica la porta di uscita",
        "cancel": "Annulla",
        "from": "da",
        "to": "a",
        "results_summary_header": "percorso ottimizzato",
        "edit": "modifica",
        "start_navigation": "Avvia navigazione",
        "exit_gate_warning": "Selezionando l'uscita della fiera, sovrascrivi la destinazione finale del percorso",
        "duplicate_stop_warning": "La tappa \xe8 gi\xe0 presente nel percorso",
        "for": "per",
        "go_to_stop": "vai a tappa",
        "of": "di",
        "meters": "metri",
        "Pause": "Pausa",
        "Steps": "Tappe",
        "leg_step": "Step",
        "final_destination": "Fine percorso",
        "max_stop_limit_warning": "Limite massimo di tappe raggiunto",
        "set_as_origin": "Imposta come partenza",
        "set_as_destination": "Imposta come arrivo",
        "same_origin_destination_warning": "Partenza e arrivo non possono essere uguali",
        "fav_route_builder_heading": "La tua lista di espositori da visitare",
        "fav_route_builder_sub_heading": "Seleziona fino ad un massimo di 15 espositori ed imposta partenza e arrivo per creare il percorso personalizzato",
        "fav_route_builder_selected_exhibitors": "Espositori selezionati:",
        "fav_route_builder_min_stop_message": "Seleziona almeno 3 espositori che desideri visitare per creare il tuo percorso personalizzato.",
        'destination_in_sight': 'Destiazione invista!',
        'continue_to_reach': 'Continua per {distance} per raggiungere {name}',
        'unauthorised_favs': 'Accedi e seleziona gli espositori che desideri visitare per creare il tuo percorso personalizzato.',
        'unauthorized_map_toast': 'Accedi per creare e visualizzare la tua lista di espositori personalizzata',
        'empty_map_toast': 'Cerca un espositore oppure tocca il suo nome sulla mappa per aggiungerlo alla lista degli espositori che vuoi visitare',
        "edit_stops": "Modifica tappe",
        "route_builder_toast": "Imposta origine e destinazione per ottimizzare il percorso."
    }
};



const $58070e9281bc680d$var$LOCALE_EN = 'EN';
const $58070e9281bc680d$var$DEFAULT_LOCALE = $58070e9281bc680d$var$LOCALE_EN;
let $58070e9281bc680d$var$USER_LOCALE;
const $58070e9281bc680d$var$localeStorage = {};
const $58070e9281bc680d$export$9a2147b3808d4c6b = function() {
    return $58070e9281bc680d$var$DEFAULT_LOCALE;
}();
function $58070e9281bc680d$var$registerLocale(locale, localeObj) {
    locale = locale.toUpperCase();
    $58070e9281bc680d$var$localeStorage[locale] = localeObj;
}
function $58070e9281bc680d$export$ddc371781a6af754(lang, localeObj) {
    if (lang) {
        const localeObj = $58070e9281bc680d$var$localeStorage[lang.toUpperCase()] || {};
        if (lang === $58070e9281bc680d$var$LOCALE_EN) return {
            ...localeObj
        };
        else return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
            ...localeObj
        }, {
            ...$58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE]
        });
    } else return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
        ...localeObj
    }, {
        ...$58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE]
    });
}
function $58070e9281bc680d$export$e6103b0362967aab(lang) {
    if (lang) {
        $58070e9281bc680d$var$USER_LOCALE = lang;
        const userLocale = $58070e9281bc680d$export$ddc371781a6af754(lang);
        $58070e9281bc680d$var$registerLocale(lang, userLocale);
    }
}
function $58070e9281bc680d$export$180605366c04f0cd(lang) {
    if (lang) return $58070e9281bc680d$var$localeStorage[lang];
    else if ($58070e9281bc680d$var$USER_LOCALE) return $58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$USER_LOCALE];
    else return $58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE];
}
function $58070e9281bc680d$export$3814be8b8b1016be() {
    return $58070e9281bc680d$var$USER_LOCALE || $58070e9281bc680d$var$DEFAULT_LOCALE;
}
function $58070e9281bc680d$export$665560c9ff312dd4() {
    return (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
}
function $58070e9281bc680d$export$236350842f3cd9bc(localeObj, key) {
    if (localeObj[key] !== undefined && typeof localeObj[key] === 'string') return localeObj[key];
    else return key;
}
$58070e9281bc680d$var$registerLocale($58070e9281bc680d$var$LOCALE_EN, (0, $ce6b24fd3f3f3a3b$export$2e2bcd8739ae039));
$58070e9281bc680d$var$registerLocale('IT', (0, $7cc7518b768c600c$export$2e2bcd8739ae039));




var $7Do5B = parcelRequire("7Do5B");
var $eb3c8b789a252a22$var$t = /["&<]/;
function $eb3c8b789a252a22$var$n(r) {
    if (0 === r.length || !1 === $eb3c8b789a252a22$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $eb3c8b789a252a22$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $eb3c8b789a252a22$var$f = 0, $eb3c8b789a252a22$var$i = Array.isArray;
function $eb3c8b789a252a22$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$eb3c8b789a252a22$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $7Do5B.options).vnode && (0, $7Do5B.options).vnode(l), l;
}
function $eb3c8b789a252a22$export$45700d561b2268ac(r) {
    var t = $eb3c8b789a252a22$export$34b9dba7ce09269b((0, $7Do5B.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $eb3c8b789a252a22$var$c = {}, $eb3c8b789a252a22$var$p = /[A-Z]/g;
function $eb3c8b789a252a22$export$991f6ffe102e5bac(e, t) {
    if ((0, $7Do5B.options).attr) {
        var f = (0, $7Do5B.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $eb3c8b789a252a22$var$c[u] || ($eb3c8b789a252a22$var$c[u] = u.replace($eb3c8b789a252a22$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $eb3c8b789a252a22$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $eb3c8b789a252a22$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $eb3c8b789a252a22$var$n("" + t) + '"';
}
function $eb3c8b789a252a22$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($eb3c8b789a252a22$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $eb3c8b789a252a22$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $eb3c8b789a252a22$var$n("" + r);
}



var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");


var $7Do5B = parcelRequire("7Do5B");


var $7Do5B = parcelRequire("7Do5B");

parcelRequire("7ikhG");
const $163beaed504dbd64$var$SvgWoosmap = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M13.664 7.698V4.227h-3.36v3.471H5.153v5.151H1.682v3.36h6.831v-5.151h5.151z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M15.487 7.791v5.151h-5.151v6.831h3.36v-3.471h5.151v-5.151h3.471v-3.36h-6.831"
            })
        ]
    });
var $163beaed504dbd64$export$2e2bcd8739ae039 = $163beaed504dbd64$var$SvgWoosmap;



parcelRequire("7ikhG");
const $716a3ab1bc910cef$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M18.838 4.678a.5.5 0 0 0-.707 0l-8.969 8.968a.5.5 0 0 0 0 .708l8.969 8.968a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707L10.223 14l8.615-8.615a.5.5 0 0 0 0-.707"
        })
    });
var $716a3ab1bc910cef$export$2e2bcd8739ae039 = $716a3ab1bc910cef$var$SvgArrowLeft;



parcelRequire("7ikhG");
const $51d9ba5dec58f340$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M9.163 23.322a.5.5 0 0 0 .708 0l8.968-8.968a.5.5 0 0 0 0-.707L9.87 4.678a.5.5 0 0 0-.707.707L17.778 14l-8.615 8.615a.5.5 0 0 0 0 .707"
        })
    });
var $51d9ba5dec58f340$export$2e2bcd8739ae039 = $51d9ba5dec58f340$var$SvgArrowRight;



parcelRequire("7ikhG");
const $fe6bc85e5c3444d5$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M22.614 9.162 14 17.777 5.385 9.162a.5.5 0 0 0-.707.707l8.968 8.969a.5.5 0 0 0 .708 0l8.968-8.969a.5.5 0 0 0-.707-.707Z"
        })
    });
var $fe6bc85e5c3444d5$export$2e2bcd8739ae039 = $fe6bc85e5c3444d5$var$SvgCaretDown;



parcelRequire("7ikhG");
const $5ce58e2c168a9946$var$SvgCaretUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M22.968 18.984a.5.5 0 0 1-.354-.146L14 10.224l-8.615 8.614a.5.5 0 0 1-.707-.707l8.968-8.968a.5.5 0 0 1 .707 0l8.968 8.968a.5.5 0 0 1-.354.853Z"
        })
    });
var $5ce58e2c168a9946$export$2e2bcd8739ae039 = $5ce58e2c168a9946$var$SvgCaretUp;



parcelRequire("7ikhG");
const $e927044f3337a956$var$SvgCenterMarker = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m13.678 16.553-2.497 1.067a.557.557 0 0 1-.723-.749l3.037-6.46a.557.557 0 0 1 1.008 0l3.037 6.46a.557.557 0 0 1-.723.749l-2.497-1.067a.82.82 0 0 0-.643 0ZM14 7.941a.52.52 0 0 1-.522-.522V3.342a.522.522 0 0 1 1.044 0v4.076A.52.52 0 0 1 14 7.94ZM14 25.18a.52.52 0 0 1-.522-.522v-4.076a.522.522 0 0 1 1.044 0v4.076a.52.52 0 0 1-.522.522M7.418 14.522H3.342a.522.522 0 0 1 0-1.044h4.076a.522.522 0 0 1 0 1.044M24.658 14.522h-4.076a.522.522 0 0 1 0-1.044h4.076a.522.522 0 0 1 0 1.044"
        })
    });
var $e927044f3337a956$export$2e2bcd8739ae039 = $e927044f3337a956$var$SvgCenterMarker;



parcelRequire("7ikhG");
const $2f727b898d9822c6$var$SvgClock = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M16.804 17.458a.5.5 0 0 0 .684-.73L14.5 13.933V8.077a.5.5 0 0 0-1 0v6.073a.5.5 0 0 0 .158.365z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M14 24.045c5.539 0 10.045-4.506 10.045-10.045S19.539 3.955 14 3.955 3.955 8.461 3.955 14 8.461 24.045 14 24.045m0-19.091c4.988 0 9.045 4.058 9.045 9.045S18.987 23.044 14 23.044 4.955 18.988 4.955 14 9.012 4.955 14 4.955Z"
            })
        ]
    });
var $2f727b898d9822c6$export$2e2bcd8739ae039 = $2f727b898d9822c6$var$SvgClock;



parcelRequire("7ikhG");
const $580acb0836620f21$var$SvgInverse = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M13.94 11.414 9.349 6.823a.53.53 0 0 0-.57-.113.5.5 0 0 0-.169.113L3.993 11.44a.521.521 0 1 0 .74.738l3.726-3.725v12.998a.522.522 0 0 0 1.044 0V8.454l3.699 3.698a.521.521 0 1 0 .739-.738ZM23.268 15.821l-3.726 3.725V6.548a.522.522 0 0 0-1.044 0v12.998l-3.699-3.698a.521.521 0 1 0-.739.738l4.591 4.591a.54.54 0 0 0 .369.153.53.53 0 0 0 .369-.153l4.618-4.617a.521.521 0 1 0-.739-.738Z"
        })
    });
var $580acb0836620f21$export$2e2bcd8739ae039 = $580acb0836620f21$var$SvgInverse;



parcelRequire("7ikhG");
const $a6a75554c04119a6$var$SvgClose = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m14.707 14 8.329-8.329a.5.5 0 0 0-.707-.707L14 13.293 5.671 4.964a.5.5 0 0 0-.707.707L13.293 14l-8.329 8.329a.5.5 0 0 0 .708.707L14 14.707l8.329 8.329a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707z"
        })
    });
var $a6a75554c04119a6$export$2e2bcd8739ae039 = $a6a75554c04119a6$var$SvgClose;



parcelRequire("7ikhG");
const $8b367de7194b5ac1$var$SvgItineraryFilled = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m5.13 12.955 6.269 2.515c.516.207.925.616 1.131 1.131l2.515 6.269c.474 1.182 2.158 1.152 2.59-.046l6.02-16.706c.398-1.103-.67-2.171-1.773-1.773l-16.706 6.02c-1.198.432-1.228 2.115-.046 2.59"
        })
    });
var $8b367de7194b5ac1$export$2e2bcd8739ae039 = $8b367de7194b5ac1$var$SvgItineraryFilled;



parcelRequire("7ikhG");
const $6f1b8535ef422e45$var$SvgStairs = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M5.485 16.338h5.177v-5.177a.5.5 0 0 1 .5-.5h5.176V5.485a.5.5 0 0 1 .5-.5h5.677a.5.5 0 0 1 0 1h-5.177v5.176a.5.5 0 0 1-.5.5h-5.176v5.177a.5.5 0 0 1-.5.5H5.985v5.176a.5.5 0 0 1-1 0v-5.676a.5.5 0 0 1 .5-.5"
        })
    });
var $6f1b8535ef422e45$export$2e2bcd8739ae039 = $6f1b8535ef422e45$var$SvgStairs;



parcelRequire("7ikhG");
const $59210cf156fda2e8$var$SvgStairsThick = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M5.485 15.838h4.677v-4.676a1 1 0 0 1 1-1h4.676V5.485a1 1 0 0 1 1-1h5.677a1 1 0 1 1 0 2h-4.677v4.677a1 1 0 0 1-1 1h-4.676v4.676a1 1 0 0 1-1 1H6.485v4.677a1 1 0 1 1-2 0v-5.677a1 1 0 0 1 1-1"
        })
    });
var $59210cf156fda2e8$export$2e2bcd8739ae039 = $59210cf156fda2e8$var$SvgStairsThick;



parcelRequire("7ikhG");
const $b0649312cd295086$var$SvgMarker = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M12.77 24.418c0 .659.518 1.138 1.23 1.138.702 0 1.23-.489 1.23-1.138 0-2.324 1.6-4.211 3.293-6.209 1.849-2.182 3.761-4.438 3.761-7.479 0-4.568-3.717-8.285-8.285-8.285s-8.284 3.716-8.284 8.284c0 3.041 1.912 5.297 3.761 7.479 1.694 1.998 3.293 3.886 3.293 6.209ZM14 3.444c4.017 0 7.285 3.268 7.285 7.285 0 2.674-1.792 4.788-3.524 6.833-1.736 2.048-3.531 4.165-3.531 6.856 0 .128-.176.138-.23.138-.105 0-.23-.024-.23-.138 0-2.691-1.795-4.808-3.531-6.856-1.732-2.044-3.524-4.158-3.524-6.833 0-4.017 3.268-7.285 7.285-7.285"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M14 14.5c2 0 3.626-1.627 3.626-3.626S15.999 7.248 14 7.248s-3.626 1.627-3.626 3.626S12.001 14.5 14 14.5m0-6.253c1.448 0 2.626 1.178 2.626 2.626S15.448 13.499 14 13.499s-2.626-1.178-2.626-2.626S12.552 8.247 14 8.247"
            })
        ]
    });
var $b0649312cd295086$export$2e2bcd8739ae039 = $b0649312cd295086$var$SvgMarker;



parcelRequire("7ikhG");
const $02bcc6d1401ca51a$var$SvgMarkerFilled = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M14 2.944a7.785 7.785 0 0 0-7.785 7.785c0 5.594 7.054 8.562 7.054 13.689 0 .419.344.638.731.638s.731-.227.731-.638c0-5.127 7.054-8.095 7.054-13.689A7.785 7.785 0 0 0 14 2.944M14 14a3.126 3.126 0 1 1 0-6.252A3.126 3.126 0 0 1 14 14"
        })
    });
var $02bcc6d1401ca51a$export$2e2bcd8739ae039 = $02bcc6d1401ca51a$var$SvgMarkerFilled;



parcelRequire("7ikhG");
const $95182ba5bffd3209$var$SvgPositionFilled = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M14 6.131a7.869 7.869 0 1 0 0 15.738A7.869 7.869 0 0 0 14 6.13m0 10.996a3.126 3.126 0 1 1 0-6.252 3.126 3.126 0 0 1 0 6.252"
        })
    });
var $95182ba5bffd3209$export$2e2bcd8739ae039 = $95182ba5bffd3209$var$SvgPositionFilled;



parcelRequire("7ikhG");
const $c03f96a5653f1ea0$var$SvgPhone = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M19.772 17.07a1.49 1.49 0 0 0-2.049.055c-1.122 1.124-3.081 1.125-4.207 0l-2.52-2.52a2.98 2.98 0 0 1 0-4.206 1.49 1.49 0 0 0 .056-2.049L7.723 4.646a1.32 1.32 0 0 0-.956-.446 1.36 1.36 0 0 0-.981.393c-3.231 3.231-1.839 9.136 3.385 14.36 2.583 2.583 5.34 4.265 7.973 4.862a9 9 0 0 0 1.989.233c1.749 0 3.271-.584 4.404-1.717.256-.257.397-.613.387-.976a1.34 1.34 0 0 0-.439-.95l-3.712-3.334Zm3.019 4.527c-1.274 1.275-3.196 1.702-5.416 1.197-2.44-.553-5.021-2.137-7.466-4.582C5.197 13.5 3.773 8.083 6.524 5.332a.3.3 0 0 1 .206-.088h.008a.3.3 0 0 1 .208.1l3.329 3.704a.446.446 0 0 1-.017.612 4.025 4.025 0 0 0 0 5.685l2.52 2.52c.759.759 1.769 1.177 2.842 1.177s2.083-.418 2.842-1.177a.444.444 0 0 1 .612-.017l3.711 3.334a.29.29 0 0 1 .094.202.3.3 0 0 1-.089.213Z"
        })
    });
var $c03f96a5653f1ea0$export$2e2bcd8739ae039 = $c03f96a5653f1ea0$var$SvgPhone;



parcelRequire("7ikhG");
const $1873985a92144652$var$SvgShare = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M23.952 13.809a.5.5 0 0 0-.105-.158l-.007-.011-3.122-3.122a.521.521 0 1 0-.739.738l2.23 2.23h-8.381a.522.522 0 1 0 0 1.044h8.381l-2.213 2.213a.521.521 0 1 0 .74.738l3.104-3.104.007-.01a.523.523 0 0 0 .105-.559Z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M17.557 16.741a.52.52 0 0 0-.522.522v2.728H5.052V8.009h11.982v2.896a.522.522 0 0 0 1.044 0V7.486a.52.52 0 0 0-.522-.522H4.53a.52.52 0 0 0-.522.522v13.027c0 .288.234.522.522.522h13.027a.52.52 0 0 0 .522-.522v-3.25a.52.52 0 0 0-.522-.522"
            })
        ]
    });
var $1873985a92144652$export$2e2bcd8739ae039 = $1873985a92144652$var$SvgShare;



parcelRequire("7ikhG");
const $0628d22a60af517d$var$SvgSound = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M14.532 3.791a.5.5 0 0 0-.54.092l-6.324 5.87H4.18a2.28 2.28 0 0 0-2.28 2.28v3.7a2.28 2.28 0 0 0 2.28 2.28h3.482l6.323 6.099a.5.5 0 0 0 .542.1.5.5 0 0 0 .305-.46V4.249a.5.5 0 0 0-.3-.458M2.9 15.733v-3.7c0-.706.574-1.28 1.28-1.28h3.184v6.261H4.18c-.706 0-1.28-.574-1.28-1.28Zm10.932 6.842-5.468-5.274v-6.83l5.468-5.075zM22.601 5.435a.5.5 0 0 0-.719.695 11.36 11.36 0 0 1 3.218 7.933c0 2.952-1.131 5.756-3.183 7.896a.497.497 0 0 0 .015.706.494.494 0 0 0 .706-.014 12.35 12.35 0 0 0 3.462-8.587c0-3.232-1.242-6.296-3.499-8.628Z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M20.387 7.301a.5.5 0 0 0-.666.746 8.09 8.09 0 0 1 2.7 6.016 8.1 8.1 0 0 1-2.663 5.982.5.5 0 1 0 .672.74 9.1 9.1 0 0 0 2.991-6.723A9.1 9.1 0 0 0 20.387 7.3Z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M18.059 8.788a.5.5 0 0 0-.58.814c1.436 1.021 2.292 2.677 2.292 4.43s-.856 3.408-2.292 4.43a.5.5 0 1 0 .58.814c1.698-1.208 2.712-3.169 2.712-5.244s-1.014-4.036-2.712-5.244"
            })
        ]
    });
var $0628d22a60af517d$export$2e2bcd8739ae039 = $0628d22a60af517d$var$SvgSound;



parcelRequire("7ikhG");
const $c999ecb5f3815d3a$var$SvgSoundMute = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M14.553 3.791a.5.5 0 0 0-.54.092l-6.324 5.87H4.202a2.28 2.28 0 0 0-2.28 2.28v3.7a2.28 2.28 0 0 0 2.28 2.28h3.481l6.323 6.099a.5.5 0 0 0 .542.1.5.5 0 0 0 .305-.46V4.249a.5.5 0 0 0-.3-.458M2.922 15.733v-3.7c0-.706.574-1.28 1.28-1.28h3.184v6.261H4.202c-.706 0-1.28-.574-1.28-1.28Zm10.932 6.842-5.468-5.274v-6.83l5.468-5.075zM25.932 10.272a.5.5 0 0 0-.707 0l-3.021 3.021-3.021-3.021a.5.5 0 0 0-.707.707L21.497 14l-3.021 3.021a.5.5 0 0 0 .708.707l3.021-3.021 3.021 3.021a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707L22.913 14l3.021-3.021a.5.5 0 0 0 0-.707Z"
        })
    });
var $c999ecb5f3815d3a$export$2e2bcd8739ae039 = $c999ecb5f3815d3a$var$SvgSoundMute;



parcelRequire("7ikhG");
const $83becb381df659e1$var$SvgWorld = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M14 3.955C8.461 3.955 3.955 8.461 3.955 14S8.461 24.045 14 24.045 24.046 19.539 24.046 14 19.539 3.955 14 3.955m7.115 4.479c-.683.415-1.497.759-2.399 1.026-.444-1.703-1.132-3.113-1.984-4.081a9.07 9.07 0 0 1 4.383 3.055m1.905 5.067h-3.761a18.6 18.6 0 0 0-.324-3.068c1.022-.298 1.949-.684 2.723-1.158.01-.006.016-.017.026-.024a9 9 0 0 1 1.337 4.25Zm-1.336 5.25c-.01-.007-.015-.018-.026-.024-.774-.474-1.701-.86-2.723-1.158.186-.958.297-1.987.324-3.068h3.761a9 9 0 0 1-1.336 4.25m-15.368 0a9 9 0 0 1-1.336-4.249h3.76c.027 1.081.138 2.11.324 3.068-1.022.298-1.95.684-2.724 1.159-.01.006-.015.016-.024.022m0-9.498q.012.012.025.023c.774.474 1.701.86 2.723 1.158a18.6 18.6 0 0 0-.324 3.068H4.98a9 9 0 0 1 1.336-4.249m8.184 1.839a18.3 18.3 0 0 0 3.459-.409c.171.885.274 1.834.301 2.819H14.5zm0-1V5.026c1.381.359 2.585 2.176 3.242 4.682a17.3 17.3 0 0 1-3.242.382Zm-1-5.065v5.065c-1.135-.03-2.23-.16-3.242-.383.657-2.507 1.86-4.323 3.242-4.682m0 6.064v2.41H9.739c.027-.986.13-1.935.301-2.819a18.3 18.3 0 0 0 3.46.409m-3.761 3.41H13.5v2.41c-1.207.031-2.375.17-3.46.409a17.4 17.4 0 0 1-.301-2.819m3.761 3.41v5.065c-1.382-.359-2.585-2.176-3.242-4.682a17.3 17.3 0 0 1 3.242-.382Zm1 5.064v-5.064c1.135.03 2.23.159 3.242.382-.657 2.506-1.86 4.323-3.242 4.682m0-6.064v-2.41h3.76c-.027.986-.13 1.935-.301 2.819a18.3 18.3 0 0 0-3.459-.409M11.267 5.38c-.852.967-1.54 2.377-1.983 4.08-.902-.267-1.716-.611-2.398-1.026a9.07 9.07 0 0 1 4.382-3.054ZM6.885 19.568c.683-.415 1.497-.758 2.398-1.026.444 1.703 1.132 3.113 1.983 4.08a9.07 9.07 0 0 1-4.382-3.054Zm9.847 3.055c.852-.968 1.54-2.377 1.984-4.081.902.267 1.717.611 2.399 1.026a9.07 9.07 0 0 1-4.383 3.055"
        })
    });
var $83becb381df659e1$export$2e2bcd8739ae039 = $83becb381df659e1$var$SvgWorld;



parcelRequire("7ikhG");
const $f5dffaa16091f3b0$var$SvgItinerary = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M21.712 3.875 5.006 9.895a1.87 1.87 0 0 0-1.246 1.741 1.87 1.87 0 0 0 1.184 1.783l6.269 2.515c.387.155.698.466.854.854l2.515 6.269c.29.722.973 1.184 1.749 1.184h.035a1.87 1.87 0 0 0 1.741-1.246l6.018-16.707a1.87 1.87 0 0 0-.44-1.973 1.87 1.87 0 0 0-1.972-.44Zm1.472 2.074-6.02 16.706a.87.87 0 0 1-.818.585.87.87 0 0 1-.838-.556l-2.515-6.269a2.54 2.54 0 0 0-1.41-1.409l-6.269-2.515a.87.87 0 0 1-.556-.838.87.87 0 0 1 .585-.818l16.709-6.02c.33-.118.677-.042.926.207s.326.595.207.926Z"
        })
    });
var $f5dffaa16091f3b0$export$2e2bcd8739ae039 = $f5dffaa16091f3b0$var$SvgItinerary;



parcelRequire("7ikhG");
const $04b2bc10cfcaddba$var$SvgItineraryOverview = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m8.866 21.298-.696.528a2.13 2.13 0 0 0-1.561-.685c-1.182 0-2.144.962-2.144 2.144s.961 2.144 2.144 2.144 2.144-.962 2.144-2.144c0-.201-.037-.393-.089-.578l.807-.612a.5.5 0 1 0-.605-.797M11.388 19.385l-1.261.956a.5.5 0 1 0 .605.796l1.261-.956a.5.5 0 1 0-.605-.797ZM13.867 16.482a.5.5 0 0 0-.5.5v.901l-.718.545a.5.5 0 1 0 .605.796l.916-.695a.5.5 0 0 0 .198-.398v-1.149a.5.5 0 0 0-.5-.5ZM13.867 12.263a.5.5 0 0 0-.5.5v2.109a.5.5 0 0 0 1 0v-2.109a.5.5 0 0 0-.5-.5M14.531 8.441l-.947.651a.5.5 0 0 0-.217.412v1.15a.5.5 0 0 0 1 0v-.888l.73-.502a.5.5 0 1 0-.566-.824ZM17.279 6.551l-1.374.944a.5.5 0 1 0 .566.824l1.374-.944a.5.5 0 1 0-.566-.824M21.392 2.572a2.147 2.147 0 0 0-2.096 2.593l-.644.443a.5.5 0 1 0 .566.824l.525-.361c.394.477.982.789 1.648.789 1.182 0 2.144-.962 2.144-2.144s-.962-2.144-2.144-2.144Z"
        })
    });
var $04b2bc10cfcaddba$export$2e2bcd8739ae039 = $04b2bc10cfcaddba$var$SvgItineraryOverview;



parcelRequire("7ikhG");
const $85195db6ce8da10f$var$SvgItineraryStart = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M7.26 9.402a6.76 6.76 0 0 0-3.166 5.315 1.5 1.5 0 1 0 2.994.182 3.75 3.75 0 0 1 1.761-2.952A1.5 1.5 0 1 0 7.26 9.402M5.582 18.308a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 1 0 3 0v-5a1.5 1.5 0 0 0-1.5-1.5M23.479 8.82l-6.688-6.688a1.5 1.5 0 1 0-2.121 2.121l4.128 4.128h-6.286a1.5 1.5 0 1 0 0 3h6.286l-4.128 4.128a1.5 1.5 0 1 0 2.122 2.121l6.688-6.688a1.5 1.5 0 0 0 0-2.121Z"
        })
    });
var $85195db6ce8da10f$export$2e2bcd8739ae039 = $85195db6ce8da10f$var$SvgItineraryStart;



parcelRequire("7ikhG");
const $9b616a11ad05a467$var$SvgDisability = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M17.157 20.942a.5.5 0 0 0-.678.201 5.73 5.73 0 0 1-5.044 3.002 5.74 5.74 0 0 1-5.736-5.736c0-1.887.929-3.654 2.485-4.727a.5.5 0 1 0-.567-.824A6.74 6.74 0 0 0 4.7 18.409a6.743 6.743 0 0 0 6.736 6.736 6.74 6.74 0 0 0 5.923-3.525.5.5 0 0 0-.201-.678Z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M23.274 20.819a.5.5 0 0 0-.637-.307l-2.153.751a.236.236 0 0 1-.285-.123l-2.347-5.271a1.47 1.47 0 0 0-1.339-.87h-5.111a.467.467 0 0 1-.465-.431l-.168-2.248h5.133a.5.5 0 0 0 0-1h-5.208l-.232-3.101c.029 0 .055.009.084.009 1.481 0 2.687-1.205 2.687-2.686s-1.205-2.687-2.687-2.687S7.859 4.06 7.859 5.542c0 1.086.651 2.019 1.582 2.442l.499 6.659a1.47 1.47 0 0 0 1.462 1.356h5.111c.184 0 .351.108.426.276l2.346 5.271a1.24 1.24 0 0 0 1.528.661l2.153-.751a.5.5 0 0 0 .308-.637M8.86 5.542c0-.93.756-1.687 1.687-1.687s1.687.757 1.687 1.687a1.688 1.688 0 0 1-3.374 0"
            })
        ]
    });
var $9b616a11ad05a467$export$2e2bcd8739ae039 = $9b616a11ad05a467$var$SvgDisability;



parcelRequire("7ikhG");
const $cc6d7ec72c26e727$var$SvgElevatorDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M16.074 17.515H7.926a.5.5 0 0 0-.354.854l4.074 4.074a.5.5 0 0 0 .708 0l4.074-4.074a.499.499 0 0 0-.354-.854M12 21.382l-2.867-2.867h5.734zM18.372 1.417H5.628a1.79 1.79 0 0 0-1.787 1.787v9.582a1.79 1.79 0 0 0 1.787 1.787h12.743a1.79 1.79 0 0 0 1.787-1.787V3.204a1.79 1.79 0 0 0-1.787-1.787Zm.787 11.369a.79.79 0 0 1-.787.787H5.628a.79.79 0 0 1-.787-.787V3.204c0-.434.353-.787.787-.787h12.743c.434 0 .787.353.787.787z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M12.135 8.35a3.28 3.28 0 0 0-3.277 3.278.5.5 0 0 0 1 0c0-1.256 1.021-2.278 2.277-2.278s2.278 1.022 2.278 2.278a.5.5 0 0 0 1 0 3.28 3.28 0 0 0-3.278-3.278M12.135 7.892c1.111 0 2.016-.904 2.016-2.015s-.904-2.015-2.016-2.015-2.015.904-2.015 2.015.904 2.015 2.015 2.015m0-3.03c.56 0 1.016.456 1.016 1.015s-.456 1.015-1.016 1.015-1.015-.456-1.015-1.015.456-1.015 1.015-1.015"
            })
        ]
    });
var $cc6d7ec72c26e727$export$2e2bcd8739ae039 = $cc6d7ec72c26e727$var$SvgElevatorDown;



parcelRequire("7ikhG");
const $c5a9c9b770bcb2db$var$SvgElevatorUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M7.926 6.491h8.148a.5.5 0 0 0 .354-.854l-4.074-4.074a.5.5 0 0 0-.707 0L7.572 5.637a.499.499 0 0 0 .354.854M12 2.624l2.867 2.867H9.133zM18.375 9.209H5.631a1.79 1.79 0 0 0-1.787 1.787v9.582a1.79 1.79 0 0 0 1.787 1.787h12.743a1.79 1.79 0 0 0 1.787-1.787v-9.581a1.79 1.79 0 0 0-1.787-1.787Zm.787 11.369a.79.79 0 0 1-.787.787H5.631a.79.79 0 0 1-.787-.787v-9.581c0-.434.353-.787.787-.787h12.743c.434 0 .787.353.787.787v9.582Z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M12.135 15.988a3.28 3.28 0 0 0-3.277 3.278.5.5 0 0 0 1 0c0-1.256 1.021-2.278 2.277-2.278s2.278 1.022 2.278 2.278a.5.5 0 0 0 1 0 3.28 3.28 0 0 0-3.278-3.278M12.135 15.53c1.111 0 2.016-.904 2.016-2.015s-.904-2.015-2.016-2.015-2.015.904-2.015 2.015.904 2.015 2.015 2.015m0-3.03c.56 0 1.016.456 1.016 1.015s-.456 1.015-1.016 1.015-1.015-.456-1.015-1.015.456-1.015 1.015-1.015"
            })
        ]
    });
var $c5a9c9b770bcb2db$export$2e2bcd8739ae039 = $c5a9c9b770bcb2db$var$SvgElevatorUp;



parcelRequire("7ikhG");
const $d8e9174dede0e092$var$SvgEscalatorDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M21.918 3.981a.5.5 0 0 0-.5.5v4.458l-7.281-7.313a.5.5 0 0 0-.709.707l7.301 7.333h-4.47a.5.5 0 0 0 0 1h6.16V4.481a.5.5 0 0 0-.5-.5ZM19.272 15.954h-2.953l-5.914-5.913a1.82 1.82 0 0 0-1.292-.535h-4.13c-1.744 0-3.239 1.286-3.403 2.928a3.28 3.28 0 0 0 .827 2.523 3.27 3.27 0 0 0 2.419 1.074h2.342l5.913 5.913a1.8 1.8 0 0 0 1.292.536h4.743c1.744 0 3.239-1.286 3.403-2.928a3.28 3.28 0 0 0-.827-2.523 3.27 3.27 0 0 0-2.419-1.074Zm-.157 5.525h-4.743a.83.83 0 0 1-.584-.242l-6.207-6.206H4.825a2.264 2.264 0 0 1-2.251-2.498c.114-1.137 1.172-2.028 2.408-2.028h4.131a.82.82 0 0 1 .584.242l6.207 6.206h3.367a2.264 2.264 0 0 1 2.251 2.498c-.114 1.137-1.172 2.028-2.408 2.028Z"
        })
    });
var $d8e9174dede0e092$export$2e2bcd8739ae039 = $d8e9174dede0e092$var$SvgEscalatorDown;



parcelRequire("7ikhG");
const $548a11f8bb4a18e4$var$SvgEscalatorUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M19.115 9.506h-4.131c-.488 0-.947.19-1.291.535l-5.914 5.913H4.826a3.265 3.265 0 0 0-3.246 3.597c.165 1.642 1.659 2.928 3.403 2.928h4.743c.488 0 .947-.19 1.291-.535l5.914-5.913h2.342a3.265 3.265 0 0 0 3.246-3.597c-.165-1.642-1.659-2.928-3.403-2.928Zm1.835 4.781a2.27 2.27 0 0 1-1.678.745h-2.756l-6.207 6.207a.83.83 0 0 1-.583.242H4.983c-1.236 0-2.294-.891-2.408-2.028a2.25 2.25 0 0 1 .573-1.753 2.27 2.27 0 0 1 1.678-.745h3.367l6.207-6.207a.83.83 0 0 1 .583-.242h4.131c1.236 0 2.294.891 2.408 2.028a2.25 2.25 0 0 1-.573 1.753ZM2.254 10.495l7.333-7.301v4.47a.5.5 0 0 0 1 0v-6.16H4.403a.5.5 0 0 0 0 1h4.458L1.548 9.786a.502.502 0 0 0 .353.855.5.5 0 0 0 .353-.146"
        })
    });
var $548a11f8bb4a18e4$export$2e2bcd8739ae039 = $548a11f8bb4a18e4$var$SvgEscalatorUp;



parcelRequire("7ikhG");
const $e4e302ef99ccc447$var$SvgRampDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M22.155 21.533 2.218 10.776a.5.5 0 0 0-.738.44v10.757a.5.5 0 0 0 .5.5h19.938a.499.499 0 0 0 .237-.939Zm-19.674-.06v-9.419l17.458 9.419zM9.526 2.621l11.048 6.748-5.583 1.362a.499.499 0 1 0 .236.971l6.734-1.643a.5.5 0 0 0 .367-.604l-.003-.013-.001-.006-1.645-6.745a.501.501 0 0 0-.971.237l1.358 5.57-11.019-6.73a.5.5 0 1 0-.522.854Z"
        })
    });
var $e4e302ef99ccc447$export$2e2bcd8739ae039 = $e4e302ef99ccc447$var$SvgRampDown;



parcelRequire("7ikhG");
const $f9e099e6cec6487b$var$SvgRampUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M22.174 10.787a.5.5 0 0 0-.493-.011L1.744 21.533a.499.499 0 0 0 .237.939h19.937a.5.5 0 0 0 .5-.5V11.216a.5.5 0 0 0-.244-.429m-.756 10.686H3.961l17.457-9.419zM2.04 11.716c.089 0 .18-.023.261-.073l11.02-6.731-1.358 5.57a.5.5 0 1 0 .97.237l1.645-6.746.001-.004.003-.014a.5.5 0 0 0-.367-.604L7.48 1.708a.5.5 0 1 0-.237.971l5.583 1.362L1.779 10.79a.501.501 0 0 0 .261.927Z"
        })
    });
var $f9e099e6cec6487b$export$2e2bcd8739ae039 = $f9e099e6cec6487b$var$SvgRampUp;



parcelRequire("7ikhG");
const $6b7254b7ad8900e7$var$SvgSlightLeftWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M4.812 11.5c-1.838 0-3.334 1.496-3.334 3.334s1.496 3.334 3.334 3.334 3.334-1.496 3.334-3.334S6.65 11.5 4.812 11.5m0 5.668c-1.287 0-2.334-1.047-2.334-2.334S3.525 12.5 4.812 12.5s2.334 1.047 2.334 2.334-1.047 2.334-2.334 2.334M18.6 7.85l-5.381-5.382h6.344a.5.5 0 0 0 0-1h-7.551a.5.5 0 0 0-.462.309.5.5 0 0 0-.038.191V9.52a.5.5 0 0 0 1 0V3.175l5.381 5.382a12.34 12.34 0 0 1 3.641 8.788v4.667a.5.5 0 0 0 1 0v-4.667c0-3.587-1.396-6.959-3.934-9.495"
        })
    });
var $6b7254b7ad8900e7$export$2e2bcd8739ae039 = $6b7254b7ad8900e7$var$SvgSlightLeftWalkPast;



parcelRequire("7ikhG");
const $ce8423f1c7909134$var$SvgSlightLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M13.578 7.85 8.196 2.468h6.345a.5.5 0 0 0 0-1H6.989a.5.5 0 0 0-.462.309.5.5 0 0 0-.038.191V9.52a.5.5 0 0 0 1 0V3.175l5.382 5.382a12.35 12.35 0 0 1 3.64 8.788v4.667a.5.5 0 0 0 1 0v-4.667a13.34 13.34 0 0 0-3.933-9.495"
        })
    });
var $ce8423f1c7909134$export$2e2bcd8739ae039 = $ce8423f1c7909134$var$SvgSlightLeft;



parcelRequire("7ikhG");
const $0375b1498a25bf37$var$SvgSlightRightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M19.199 11.5c-1.839 0-3.335 1.496-3.335 3.334s1.496 3.334 3.335 3.334 3.334-1.496 3.334-3.334-1.496-3.334-3.334-3.334m0 5.668c-1.287 0-2.335-1.047-2.335-2.334s1.048-2.334 2.335-2.334 2.334 1.047 2.334 2.334-1.047 2.334-2.334 2.334M12.191 1.507A.5.5 0 0 0 12 1.469H4.448a.5.5 0 0 0 0 1h6.345L5.411 7.85a13.34 13.34 0 0 0-3.933 9.495v4.667a.5.5 0 0 0 1 0v-4.667c0-3.32 1.293-6.44 3.64-8.788L11.5 3.175V9.52a.5.5 0 0 0 1 0V1.968a.5.5 0 0 0-.309-.462Z"
        })
    });
var $0375b1498a25bf37$export$2e2bcd8739ae039 = $0375b1498a25bf37$var$SvgSlightRightWalkPast;



parcelRequire("7ikhG");
const $98845e8d7c3fb395$var$SvgSlightRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M17.202 1.507a.5.5 0 0 0-.191-.038H9.459a.5.5 0 0 0 0 1h6.345l-5.382 5.382a13.34 13.34 0 0 0-3.933 9.495v4.667a.5.5 0 0 0 1 0v-4.667a12.35 12.35 0 0 1 3.64-8.788l5.382-5.382v6.345a.5.5 0 0 0 1 0V1.968a.5.5 0 0 0-.309-.462Z"
        })
    });
var $98845e8d7c3fb395$export$2e2bcd8739ae039 = $98845e8d7c3fb395$var$SvgSlightRight;



parcelRequire("7ikhG");
const $42e3b781f0c9166f$var$SvgStairsDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M13.721 10.166h-5.66V4.468H2.04a.487.487 0 1 0 0 .974h5.046v5.698h5.66v5.197c0 .269.219.487.487.487.012 0 .023-.006.035-.007.012 0 .023.007.035.007h5.173v5.197a.488.488 0 0 0 .974 0V15.85h-5.73v-5.684ZM21.96 3.995a.487.487 0 0 0-.487.487v4.49l-7.304-7.336a.486.486 0 1 0-.688.688l7.323 7.355h-4.502a.487.487 0 1 0 0 .974h6.146V4.481a.49.49 0 0 0-.487-.487Z"
        })
    });
var $42e3b781f0c9166f$export$2e2bcd8739ae039 = $42e3b781f0c9166f$var$SvgStairsDown;



parcelRequire("7ikhG");
const $34e6a51296488203$var$SvgStairsUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M22.001 4.288H15.95v5.838h-5.683v5.823H4.514v6.317a.494.494 0 1 0 .988 0v-5.329h5.189c.013 0 .023-.006.035-.007.012 0 .023.007.035.007a.494.494 0 0 0 .494-.494v-5.329h5.683V5.276H22a.494.494 0 0 0 0-.988ZM3.991 1.734c0 .273.221.494.494.494h4.524L1.645 9.775a.494.494 0 0 0 .707.691l7.322-7.504v4.595a.494.494 0 1 0 .988 0V1.239H4.486a.494.494 0 0 0-.494.494Z"
        })
    });
var $34e6a51296488203$export$2e2bcd8739ae039 = $34e6a51296488203$var$SvgStairsUp;



parcelRequire("7ikhG");
const $66a6e8c6ad9a2887$var$SvgTravelator = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M18.313 22.378H5.662c-2.342 0-4.247-1.905-4.247-4.248s1.905-4.248 4.247-4.248h12.651c2.342 0 4.247 1.905 4.247 4.248s-1.905 4.248-4.247 4.248M5.662 14.883c-1.79 0-3.247 1.457-3.247 3.248s1.457 3.248 3.247 3.248h12.651c1.79 0 3.247-1.457 3.247-3.248s-1.457-3.248-3.247-3.248zM12.582 12.99a.5.5 0 0 1-.5-.5v-.964c0-1.244-1.012-2.256-2.256-2.256s-2.257 1.012-2.257 2.256v.964a.5.5 0 0 1-1 0v-.964c0-1.795 1.461-3.256 3.257-3.256s3.256 1.46 3.256 3.256v.964a.5.5 0 0 1-.5.5M9.826 7.588c-1.249 0-2.265-1.016-2.265-2.265s1.016-2.265 2.265-2.265 2.265 1.016 2.265 2.265-1.016 2.265-2.265 2.265m0-3.529a1.266 1.266 0 1 0 .002 2.528 1.266 1.266 0 0 0-.002-2.528"
        })
    });
var $66a6e8c6ad9a2887$export$2e2bcd8739ae039 = $66a6e8c6ad9a2887$var$SvgTravelator;



parcelRequire("7ikhG");
const $03060671e9a387db$var$SvgTurnLeftWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M15.668 8.137c1.839 0 3.334-1.496 3.334-3.334s-1.496-3.334-3.334-3.334-3.334 1.496-3.334 3.334 1.496 3.334 3.334 3.334m0-5.668c1.287 0 2.334 1.047 2.334 2.334s-1.047 2.334-2.334 2.334-2.334-1.047-2.334-2.334 1.047-2.334 2.334-2.334M18.752 11.491H3.289l4.486-4.487a.5.5 0 0 0-.707-.707l-5.339 5.34a.496.496 0 0 0 0 .708l5.339 5.339a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707l-4.487-4.486h15.463a2.67 2.67 0 0 1 2.666 2.666v6.856a.5.5 0 0 0 1 0v-6.856a3.67 3.67 0 0 0-3.666-3.666"
        })
    });
var $03060671e9a387db$export$2e2bcd8739ae039 = $03060671e9a387db$var$SvgTurnLeftWalkPast;



parcelRequire("7ikhG");
const $2b2bca3e8f8771a0$var$SvgTurnLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M1.728 12.438zl5.339 5.34a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707l-4.487-4.486h18.629a.5.5 0 0 0 0-1H3.289l4.486-4.486a.5.5 0 0 0-.707-.707l-5.339 5.339h-.001l-.353.354z"
        })
    });
var $2b2bca3e8f8771a0$export$2e2bcd8739ae039 = $2b2bca3e8f8771a0$var$SvgTurnLeft;



parcelRequire("7ikhG");
const $b0c6d90da48e7456$var$SvgTurnRightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M8.332 8.137c1.838 0 3.334-1.496 3.334-3.334S10.17 1.469 8.332 1.469 4.998 2.965 4.998 4.803s1.496 3.334 3.334 3.334m0-5.668c1.287 0 2.334 1.047 2.334 2.334S9.619 7.137 8.332 7.137 5.998 6.09 5.998 4.803s1.047-2.334 2.334-2.334M22.38 12.182a.5.5 0 0 0-.109-.545l-5.339-5.339a.5.5 0 0 0-.707.707l4.486 4.486H5.248a3.67 3.67 0 0 0-3.666 3.666v6.856a.5.5 0 0 0 1 0v-6.856a2.67 2.67 0 0 1 2.666-2.666h15.463l-4.486 4.486a.5.5 0 0 0 .708.707l5.339-5.339a.5.5 0 0 0 .109-.163Z"
        })
    });
var $b0c6d90da48e7456$export$2e2bcd8739ae039 = $b0c6d90da48e7456$var$SvgTurnRightWalkPast;



parcelRequire("7ikhG");
const $467e6545aa0b99c4$var$SvgTurnRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m22.271 11.731-5.339-5.339a.5.5 0 0 0-.707.707l4.486 4.486H2.082a.5.5 0 0 0 0 1h18.629l-4.486 4.486a.5.5 0 0 0 .708.707l5.339-5.339h.001l.353-.354-.353-.353z"
        })
    });
var $467e6545aa0b99c4$export$2e2bcd8739ae039 = $467e6545aa0b99c4$var$SvgTurnRight;



parcelRequire("7ikhG");
const $9d1e4476c51fffd9$var$SvgWalkStraightDistance = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M12.354 5.719a.496.496 0 0 0-.708 0l-5.339 5.339a.5.5 0 0 0 .707.707L11.5 7.279v10.588a.5.5 0 0 0 1 0V7.279l4.486 4.486a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707zM6.66 2.504h10.68a.5.5 0 0 0 0-1H6.66a.5.5 0 0 0 0 1M17.34 21.479H6.66a.5.5 0 0 0 0 1h10.68a.5.5 0 0 0 0-1"
        })
    });
var $9d1e4476c51fffd9$export$2e2bcd8739ae039 = $9d1e4476c51fffd9$var$SvgWalkStraightDistance;



parcelRequire("7ikhG");
const $2fb19d002a106552$var$SvgWalkStraightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M7.776 1.815a.496.496 0 0 0-.708 0L1.729 7.154a.5.5 0 0 0 .707.707l4.486-4.486v18.628a.5.5 0 0 0 1 0V3.375l4.486 4.486a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707zM19.199 12.97c-1.839 0-3.335 1.496-3.335 3.334s1.496 3.334 3.335 3.334 3.334-1.496 3.334-3.334-1.496-3.334-3.334-3.334m0 5.669c-1.287 0-2.335-1.047-2.335-2.334s1.048-2.334 2.335-2.334 2.334 1.047 2.334 2.334-1.047 2.334-2.334 2.334"
        })
    });
var $2fb19d002a106552$export$2e2bcd8739ae039 = $2fb19d002a106552$var$SvgWalkStraightWalkPast;



parcelRequire("7ikhG");
const $e4b24ed6dfc9ab90$var$SvgWalkStraight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M7.014 7.861 11.5 3.375v18.628a.5.5 0 0 0 1 0V3.375l4.486 4.486a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707l-5.34-5.339h-.001L12 1.461l-.353.353h-.001l-5.339 5.34a.5.5 0 0 0 .707.707"
        })
    });
var $e4b24ed6dfc9ab90$export$2e2bcd8739ae039 = $e4b24ed6dfc9ab90$var$SvgWalkStraight;



parcelRequire("7ikhG");
const $1662d34c473bbb42$var$SvgNavElevatorDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M33.797 37.585 26 45.051l-7.797-7.466-3.458 3.612L26 51.973l11.255-10.776zM48.981 29.293V6.082a6.067 6.067 0 0 0-6.06-6.06H9.091a6.067 6.067 0 0 0-6.059 6.06v23.211a6.067 6.067 0 0 0 6.06 6.06h33.83a6.067 6.067 0 0 0 6.06-6.06Zm-5 0c0 .584-.475 1.06-1.06 1.06H9.091c-.584 0-1.06-.475-1.06-1.06V6.082c0-.584.475-1.06 1.06-1.06h33.83c.584 0 1.06.475 1.06 1.06z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M26.292 18.879a8.707 8.707 0 0 0-8.707 8.707h17.414a8.707 8.707 0 0 0-8.707-8.707"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("circle", {
                cx: 26.292,
                cy: 12.539,
                r: 4.749
            })
        ]
    });
var $1662d34c473bbb42$export$2e2bcd8739ae039 = $1662d34c473bbb42$var$SvgNavElevatorDown;



parcelRequire("7ikhG");
const $502b8d854d4441ce$var$SvgNavElevatorUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M18.203 14.436 26 6.97l7.797 7.466 3.458-3.612L26 .048 14.745 10.824zM9.091 51.987h33.83a6.067 6.067 0 0 0 6.06-6.06V22.716a6.067 6.067 0 0 0-6.06-6.06H9.091a6.067 6.067 0 0 0-6.06 6.06v23.211a6.067 6.067 0 0 0 6.06 6.06m-1.06-29.271c0-.584.475-1.06 1.06-1.06h33.83c.584 0 1.06.475 1.06 1.06v23.211c0 .584-.475 1.06-1.06 1.06H9.091c-.584 0-1.06-.475-1.06-1.06z"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                d: "M26.292 35.513a8.707 8.707 0 0 0-8.707 8.707h17.414a8.707 8.707 0 0 0-8.707-8.707"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("circle", {
                cx: 26.292,
                cy: 29.173,
                r: 4.749
            })
        ]
    });
var $502b8d854d4441ce$export$2e2bcd8739ae039 = $502b8d854d4441ce$var$SvgNavElevatorUp;



parcelRequire("7ikhG");
const $374e53fe05c8de32$var$SvgNavEscalatorDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M9.015 36.812h4.958l13.518 13.516a5.58 5.58 0 0 0 3.973 1.646h11.151c4.773 0 8.867-3.548 9.319-8.078a9.04 9.04 0 0 0-2.278-6.954 9.02 9.02 0 0 0-6.671-2.96h-6.396L23.071 20.466a5.58 5.58 0 0 0-3.972-1.646H9.385c-4.773-.001-8.866 3.548-9.32 8.077a9.04 9.04 0 0 0 2.279 6.953 9.01 9.01 0 0 0 6.671 2.961Zm.37-12.992h9.714c.165 0 .32.064.437.181l14.983 14.98h8.466c1.127 0 2.207.479 2.964 1.315a3.98 3.98 0 0 1 1.011 3.102c-.2 2.005-2.109 3.575-4.345 3.575H31.464a.62.62 0 0 1-.438-.181l-14.981-14.98H9.016a4 4 0 0 1-2.964-1.316 3.98 3.98 0 0 1-1.011-3.101c.2-2.005 2.109-3.576 4.344-3.576ZM31.551.004 47 15.387V7.74h5v16.13H35.812v-5h7.599L28.022 3.547z"
        })
    });
var $374e53fe05c8de32$export$2e2bcd8739ae039 = $374e53fe05c8de32$var$SvgNavEscalatorDown;



parcelRequire("7ikhG");
const $78646e57b8c7e59a$var$SvgNavEscalatorUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M9.385 51.973h11.152a5.58 5.58 0 0 0 3.972-1.645l13.518-13.517h4.957a9.01 9.01 0 0 0 6.672-2.961 9.04 9.04 0 0 0 2.278-6.953c-.453-4.53-4.546-8.078-9.32-8.078H32.9c-1.5 0-2.91.584-3.972 1.645L15.41 33.981H9.015a9.01 9.01 0 0 0-6.671 2.961 9.04 9.04 0 0 0-2.279 6.954c.454 4.529 4.547 8.078 9.32 8.078ZM6.052 40.297a4 4 0 0 1 2.964-1.316h8.466l14.981-14.98a.63.63 0 0 1 .438-.182h9.714c2.236 0 4.144 1.57 4.344 3.576a3.97 3.97 0 0 1-1.01 3.101 4 4 0 0 1-2.965 1.316h-7.028L20.973 46.793a.61.61 0 0 1-.436.18H9.385c-2.235 0-4.144-1.571-4.344-3.575a3.98 3.98 0 0 1 1.011-3.101M3.564 23.87l15.45-15.383v7.647h5V.004H7.825v5h7.599L.036 20.327z"
        })
    });
var $78646e57b8c7e59a$export$2e2bcd8739ae039 = $78646e57b8c7e59a$var$SvgNavEscalatorUp;



parcelRequire("7ikhG");
const $4218d451b9a4f740$var$SvgNavRampDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M-.021 51.977h52.062L-.021 18.029zm5-24.718 30.239 19.718H4.979zM31.914 27.936l19.912-4.213-4.197-19.836-4.893 1.035L45.18 16.47 19.78.019l-2.718 4.196 25.315 16.397-11.498 2.432z"
        })
    });
var $4218d451b9a4f740$export$2e2bcd8739ae039 = $4218d451b9a4f740$var$SvgNavRampDown;



parcelRequire("7ikhG");
const $fe82e5daa836e936$var$SvgNavRampUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M51.985 51.977V18.029L-.076 51.977zm-5-5H16.746l30.239-19.718zM28.132 11.513l-2.443 11.548 4.892 1.035L34.778 4.26 14.866.047l-1.035 4.891 11.498 2.433L.014 23.768l2.717 4.196z"
        })
    });
var $fe82e5daa836e936$export$2e2bcd8739ae039 = $fe82e5daa836e936$var$SvgNavRampUp;



parcelRequire("7ikhG");
const $7a9aa69e852e59c5$var$SvgNavSlightLeftWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M30.807 5.069h12.587v-5H22.272v21.123h5V8.605L38.38 19.714c5.549 5.55 8.605 12.929 8.605 20.776V52h5V40.49c0-9.183-3.576-17.817-10.07-24.312L30.806 5.069ZM9.404 27.771c-5.183 0-9.401 4.217-9.401 9.401s4.218 9.401 9.401 9.401 9.4-4.217 9.4-9.401-4.217-9.4-9.4-9.4Zm0 13.801c-2.427 0-4.401-1.974-4.401-4.401s1.975-4.4 4.401-4.4 4.4 1.974 4.4 4.4-1.974 4.401-4.4 4.401"
        })
    });
var $7a9aa69e852e59c5$export$2e2bcd8739ae039 = $7a9aa69e852e59c5$var$SvgNavSlightLeftWalkPast;



parcelRequire("7ikhG");
const $846b933b18ee6077$var$SvgNavSlightLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m30.803 15.999-11.19-11.19h12.686v-5H11.078V21.03h5V8.344l11.189 11.19c5.581 5.581 8.654 13.002 8.654 20.896v11.571h5V40.43c0-9.229-3.594-17.906-10.119-24.431Z"
        })
    });
var $846b933b18ee6077$export$2e2bcd8739ae039 = $846b933b18ee6077$var$SvgNavSlightLeft;



parcelRequire("7ikhG");
const $f288012a8a4a6640$var$SvgNavSlightRightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M8.595 5.069h12.587L10.073 16.178C3.58 22.672.003 31.306.003 40.49V52h5V40.49c0-7.848 3.056-15.227 8.605-20.776L24.717 8.605v12.587h5V.069H8.595zM42.585 27.771c-5.184 0-9.4 4.217-9.4 9.4s4.217 9.401 9.4 9.401 9.4-4.217 9.4-9.401-4.217-9.4-9.4-9.4m0 13.801c-2.427 0-4.4-1.974-4.4-4.401s1.974-4.4 4.4-4.4 4.4 1.974 4.4 4.4-1.974 4.401-4.4 4.401"
        })
    });
var $f288012a8a4a6640$export$2e2bcd8739ae039 = $f288012a8a4a6640$var$SvgNavSlightRightWalkPast;



parcelRequire("7ikhG");
const $24c0c576f5e1e8ba$var$SvgNavSlightRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M19.701-.191v5h12.686l-11.19 11.19c-6.525 6.525-10.119 15.202-10.119 24.431v11.571h5V40.43c0-7.894 3.073-15.314 8.654-20.896l11.189-11.19V21.03h5V-.191z"
        })
    });
var $24c0c576f5e1e8ba$export$2e2bcd8739ae039 = $24c0c576f5e1e8ba$var$SvgNavSlightRight;



parcelRequire("7ikhG");
const $b7f713fe2a7e6328$var$SvgNavStairsDown = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M9.539 29.266h12.314v12.617h12.466V52h5V36.883H26.853V24.266H14.539V11.618H0v5h9.539zM35.792 18.895v5H51.98V7.765h-5v7.648L31.53.029l-3.527 3.543 15.389 15.323z"
        })
    });
var $b7f713fe2a7e6328$export$2e2bcd8739ae039 = $b7f713fe2a7e6328$var$SvgNavStairsDown;



parcelRequire("7ikhG");
const $d3d9eea7cf59d238$var$SvgNavStairsUp = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M12.681 52h5V41.883h12.466V29.266h12.314V16.618H52v-5H37.461v12.648H25.147v12.617H12.681zM3.564 23.87l15.45-15.384v7.648h5V.004H7.825v5h7.6L.037 20.327z"
        })
    });
var $d3d9eea7cf59d238$export$2e2bcd8739ae039 = $d3d9eea7cf59d238$var$SvgNavStairsUp;



parcelRequire("7ikhG");
const $f43f5dbc4b344a13$var$SvgNavTravelator = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M40.207 52.035H11.784c-6.47 0-11.732-5.263-11.732-11.732s5.263-11.732 11.732-11.732h28.423c6.47 0 11.732 5.263 11.732 11.732s-5.263 11.732-11.732 11.732M11.784 33.57c-3.712 0-6.732 3.02-6.732 6.732s3.021 6.732 6.732 6.732h28.423c3.712 0 6.732-3.02 6.732-6.732s-3.021-6.732-6.732-6.732zM31.331 25.656h-5v-2.374c0-2.366-1.925-4.29-4.29-4.29s-4.29 1.924-4.29 4.29v2.374h-5v-2.374c0-5.123 4.168-9.29 9.29-9.29s9.29 4.167 9.29 9.29zM22.041 11.384c-3.073 0-5.574-2.5-5.574-5.574S18.968.236 22.041.236s5.574 2.5 5.574 5.574-2.501 5.574-5.574 5.574"
        })
    });
var $f43f5dbc4b344a13$export$2e2bcd8739ae039 = $f43f5dbc4b344a13$var$SvgNavTravelator;



parcelRequire("7ikhG");
const $925bc0bb7aef0462$var$SvgNavTurnLeftWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M42.223 26.255H9.595l8.116-8.117-3.535-3.535L.024 28.755l14.152 14.152 3.535-3.535-8.116-8.117h32.628a4.847 4.847 0 0 1 4.842 4.842V52h5V36.097c0-5.427-4.415-9.842-9.842-9.842M33.946 18.871c5.184 0 9.4-4.217 9.4-9.4S39.129.069 33.946.069s-9.401 4.217-9.401 9.401 4.217 9.4 9.401 9.4Zm0-13.801c2.426 0 4.4 1.974 4.4 4.401s-1.974 4.4-4.4 4.4-4.401-1.974-4.401-4.4 1.974-4.401 4.401-4.401"
        })
    });
var $925bc0bb7aef0462$export$2e2bcd8739ae039 = $925bc0bb7aef0462$var$SvgNavTurnLeftWalkPast;



parcelRequire("7ikhG");
const $0a9ebd53b0724b85$var$SvgNavTurnLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M52 23.5H9.742l8.769-8.769-3.535-3.535L.171 26l14.805 14.804 3.535-3.535L9.742 28.5H52z"
        })
    });
var $0a9ebd53b0724b85$export$2e2bcd8739ae039 = $0a9ebd53b0724b85$var$SvgNavTurnLeft;



parcelRequire("7ikhG");
const $59f9108607bb5833$var$SvgNavTurnRightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m34.285 18.138 8.117 8.117H9.774c-5.427 0-9.842 4.415-9.842 9.842V52h5V36.097a4.847 4.847 0 0 1 4.842-4.842h32.628l-8.117 8.117 3.535 3.535 14.153-14.152L37.82 14.603zM8.651 9.47c0 5.184 4.217 9.4 9.4 9.4s9.4-4.217 9.4-9.4-4.216-9.401-9.4-9.401-9.4 4.217-9.4 9.401m13.801 0c0 2.426-1.974 4.4-4.4 4.4s-4.4-1.974-4.4-4.4 1.974-4.401 4.4-4.401 4.4 1.974 4.4 4.401"
        })
    });
var $59f9108607bb5833$export$2e2bcd8739ae039 = $59f9108607bb5833$var$SvgNavTurnRightWalkPast;



parcelRequire("7ikhG");
const $d6d08e426fbd00c9$var$SvgNavTurnRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m37.024 11.196-3.535 3.535 8.769 8.769H0v5h42.258l-8.769 8.769 3.535 3.535L51.829 26z"
        })
    });
var $d6d08e426fbd00c9$export$2e2bcd8739ae039 = $d6d08e426fbd00c9$var$SvgNavTurnRight;



parcelRequire("7ikhG");
const $1382c45fbb0d9b81$var$SvgNavWalkStraightDistance = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M13.447.004h25.125v5H13.447zM23.51 19.802v21.714h5V19.802l8.295 8.295 3.535-3.535-14.33-14.331-14.33 14.331 3.535 3.535zM13.447 46.997h25.125v5H13.447z"
        })
    });
var $1382c45fbb0d9b81$export$2e2bcd8739ae039 = $1382c45fbb0d9b81$var$SvgNavWalkStraightDistance;



parcelRequire("7ikhG");
const $59b5341fe358d9c2$var$SvgNavWalkStraightWalkPast = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M42.596 28.725c-5.184 0-9.401 4.217-9.401 9.4s4.218 9.401 9.401 9.401 9.4-4.217 9.4-9.401-4.217-9.4-9.4-9.4m0 13.801c-2.427 0-4.401-1.974-4.401-4.401s1.975-4.4 4.401-4.4 4.4 1.974 4.4 4.4-1.974 4.401-4.4 4.401M12.213 52h5V9.743l8.768 8.768 3.536-3.535L14.713.171-.091 14.976l3.535 3.535 8.769-8.768z"
        })
    });
var $59b5341fe358d9c2$export$2e2bcd8739ae039 = $59b5341fe358d9c2$var$SvgNavWalkStraightWalkPast;



parcelRequire("7ikhG");
const $c9b4aea02f2ff4b0$var$SvgNavWalkStraight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "M40.804 14.976 26 .171 11.196 14.976l3.535 3.535L23.5 9.742V52h5V9.742l8.769 8.769z"
        })
    });
var $c9b4aea02f2ff4b0$export$2e2bcd8739ae039 = $c9b4aea02f2ff4b0$var$SvgNavWalkStraight;



parcelRequire("7ikhG");
const $5f22df5f5ce4db75$var$SvgNavWalkStraightSmall = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            d: "m7.505 22.126 3.535 3.536L23.5 13.205v31.629h5V13.198l12.46 12.464 3.535-3.536L26.006 3.63z"
        })
    });
var $5f22df5f5ce4db75$export$2e2bcd8739ae039 = $5f22df5f5ce4db75$var$SvgNavWalkStraightSmall;



parcelRequire("7ikhG");
const $b2685b22147ed444$var$SvgNavigationArrow = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 107.537 79.32",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("defs", {
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("filter", {
                    id: "navigation-arrow_svg__a",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("feOffset", {
                            dy: 3
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("feGaussianBlur", {
                            result: "e",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("feFlood", {
                            floodColor: "#000",
                            floodOpacity: 0.34
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("feComposite", {
                            in2: "e",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ellipse", {
                cx: 53.769,
                cy: 39.66,
                rx: 53.769,
                ry: 39.66,
                style: {
                    fill: "rgba(37,37,37,.2)"
                }
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("g", {
                style: {
                    filter: "url(#navigation-arrow_svg__a)"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                        d: "M26.37 41.999v5.687c.008 4.013 3.55 7.743 8.217 6.908l16.806-3.006a13 13 0 0 1 4.938.071l16.42 3.43c4.935 1.031 8.738-3.121 8.403-7.404v-4.619",
                        style: {
                            fill: "#e2e6ff"
                        }
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                        d: "m59.381 13.433 20.159 24.16c4.241 5.082-.31 12.662-6.789 11.309l-16.42-3.43a13 13 0 0 0-4.938-.071l-16.806 3.006c-6.459 1.155-10.801-6.429-6.534-11.414l20.223-23.629c2.926-3.419 8.223-3.385 11.106.069Z",
                        style: {
                            fill: "#f9faff"
                        }
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                        d: "m58.038 14.937 19.889 23.836c3.04 3.643-.222 9.077-4.867 8.106l-17.075-3.567a11.2 11.2 0 0 0-4.266-.062l-17.35 3.103c-4.63.828-7.742-4.608-4.684-8.182l19.931-23.288c2.219-2.593 6.236-2.568 8.423.053Z",
                        style: {
                            fill: "#3d5afe"
                        }
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                        d: "M57.148 17.331 75.904 39.81c1.781 2.134-.13 5.317-2.851 4.749l-17.454-3.646a9.3 9.3 0 0 0-3.519-.051l-17.612 3.15c-2.712.485-4.536-2.7-2.744-4.793l18.768-21.93a4.356 4.356 0 0 1 6.655.042Z",
                        style: {
                            fill: "#5871fe"
                        }
                    })
                ]
            })
        ]
    });
var $b2685b22147ed444$export$2e2bcd8739ae039 = $b2685b22147ed444$var$SvgNavigationArrow;



parcelRequire("7ikhG");
const $53dec6c098410f54$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 11,
        height: 2,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M0 1.5V0h10.333v1.5z"
        })
    });
var $53dec6c098410f54$export$2e2bcd8739ae039 = $53dec6c098410f54$var$SvgMinus;



parcelRequire("7ikhG");
const $37a6380c7a271c75$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("g", {
                clipPath: "url(#plus_svg__a)",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                    fill: "#333",
                    d: "M21 8.59V4c0-.55-.45-1-1-1h-4.59c-.89 0-1.34 1.08-.71 1.71l1.59 1.59-10 10-1.59-1.59c-.62-.63-1.7-.19-1.7.7V20c0 .55.45 1 1 1h4.59c.89 0 1.34-1.08.71-1.71L7.71 17.7l10-10 1.59 1.59c.62.63 1.7.19 1.7-.7"
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("defs", {
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("clipPath", {
                    id: "plus_svg__a",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $37a6380c7a271c75$export$2e2bcd8739ae039 = $37a6380c7a271c75$var$SvgPlus;



parcelRequire("7ikhG");
const $f4e8b471a536f4bb$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#EC0E00",
            d: "M3.375 11.625h.797l5.86-5.86-.798-.796-5.859 5.86zM2.25 12.75v-2.39l8.578-8.579 2.39 2.39-8.577 8.579zm7.376-7.376-.392-.405.797.797z"
        })
    });
var $f4e8b471a536f4bb$export$2e2bcd8739ae039 = $f4e8b471a536f4bb$var$SvgEdit;



parcelRequire("7ikhG");
const $bd94dce843e76cb1$var$SvgTime = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M14.55 16.55 11 13V8h2v4.175l2.95 2.95zM11 6V4h2v2zm7 7v-2h2v2zm-7 7v-2h2v2zm-7-7v-2h2v2zm8 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2q2.074 0 3.9.787a10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
        })
    });
var $bd94dce843e76cb1$export$2e2bcd8739ae039 = $bd94dce843e76cb1$var$SvgTime;



parcelRequire("7ikhG");
const $5b745c20456dc29f$var$SvgDistance = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M12.005 12q.745 0 1.27-.53.525-.531.525-1.275 0-.745-.53-1.27a1.75 1.75 0 0 0-1.275-.525q-.745 0-1.27.53-.525.531-.525 1.275 0 .745.53 1.27.531.525 1.275.525M12 19.225q2.975-2.675 4.488-4.925Q18 12.05 18 10.275q0-2.625-1.712-4.35Q14.575 4.2 12 4.2T7.713 5.925 6 10.275Q6 12.05 7.513 14.3T12 19.225m0 2.375q-3.924-3.278-5.862-6.089T4.2 10.275q0-3.35 2.225-5.613Q8.65 2.4 11.988 2.4t5.575 2.262 2.237 5.613q0 2.425-1.925 5.225T12 21.6"
        })
    });
var $5b745c20456dc29f$export$2e2bcd8739ae039 = $5b745c20456dc29f$var$SvgDistance;



parcelRequire("7ikhG");
const $3df9457f7847519d$var$SvgStops = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M5 22V2h2v2h14l-2 5 2 5H7v8zm7.5-11q.825 0 1.413-.588Q14.5 9.825 14.5 9t-.587-1.413A1.93 1.93 0 0 0 12.5 7q-.825 0-1.412.587A1.93 1.93 0 0 0 10.5 9q0 .825.588 1.412.587.588 1.412.588M7 12h11.05l-1.2-3 1.2-3H7z"
        })
    });
var $3df9457f7847519d$export$2e2bcd8739ae039 = $3df9457f7847519d$var$SvgStops;



parcelRequire("7ikhG");
const $bbf36f5296a51b5a$var$SvgDownArrow = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "m10.75 13.125 4.188-4.187L16 10l-6 6-6-6 1.063-1.062 4.187 4.187V4h1.5z"
        })
    });
var $bbf36f5296a51b5a$export$2e2bcd8739ae039 = $bbf36f5296a51b5a$var$SvgDownArrow;



parcelRequire("7ikhG");
const $aad98fb6b65f01ff$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "m15.938 17-4.98-4.98a5.2 5.2 0 0 1-1.37.72A4.8 4.8 0 0 1 8 13q-2.084 0-3.543-1.458Q3 10.083 3 8q0-2.084 1.458-3.542Q5.917 3 8 3q2.084 0 3.542 1.458Q13 5.917 13 8.001a4.8 4.8 0 0 1-.26 1.587 5.2 5.2 0 0 1-.72 1.37l4.98 4.98zM8 11.5q1.458 0 2.48-1.02Q11.5 9.457 11.5 8t-1.02-2.48Q9.457 4.5 8 4.5T5.52 5.52Q4.5 6.543 4.5 8t1.02 2.48Q6.543 11.5 8 11.5"
        })
    });
var $aad98fb6b65f01ff$export$2e2bcd8739ae039 = $aad98fb6b65f01ff$var$SvgSearch;



parcelRequire("7ikhG");
const $2e0b8d71c095e6f5$var$SvgBigClose = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "m5.333 15.833-1.166-1.166L8.833 10 4.167 5.333l1.166-1.166L10 8.833l4.667-4.666 1.166 1.166L11.167 10l4.666 4.667-1.166 1.166L10 11.167z"
        })
    });
var $2e0b8d71c095e6f5$export$2e2bcd8739ae039 = $2e0b8d71c095e6f5$var$SvgBigClose;



parcelRequire("7ikhG");
const $46351c9f6d626d87$var$SvgTour = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M4.167 18.333V1.667h1.666v1.666H17.5L15.833 7.5l1.667 4.167H5.833v6.666zm6.25-9.166q.687 0 1.177-.49t.49-1.177q0-.687-.49-1.177a1.6 1.6 0 0 0-1.177-.49q-.687 0-1.177.49T8.75 7.5q0 .687.49 1.177.489.49 1.177.49M5.833 10h9.209l-1-2.5 1-2.5H5.833z"
        })
    });
var $46351c9f6d626d87$export$2e2bcd8739ae039 = $46351c9f6d626d87$var$SvgTour;



parcelRequire("7ikhG");
const $e2237b50e7b1f4dc$var$SvgDoubleArrowLeft = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "m9.167 15-5-5 5-5 1.166 1.167L6.521 10l3.812 3.833zm5.5 0-5-5 5-5 1.166 1.167L12.021 10l3.812 3.833z"
        })
    });
var $e2237b50e7b1f4dc$export$2e2bcd8739ae039 = $e2237b50e7b1f4dc$var$SvgDoubleArrowLeft;



parcelRequire("7ikhG");
const $fc7baabad4c992c9$var$SvgDoubleArrowRight = (props)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
            fill: "#333",
            d: "M7.98 10 4.166 6.167 5.333 5l5 5-5 5-1.166-1.167zm5.5 0L9.666 6.167 10.833 5l5 5-5 5-1.166-1.167z"
        })
    });
var $fc7baabad4c992c9$export$2e2bcd8739ae039 = $fc7baabad4c992c9$var$SvgDoubleArrowRight;


const $93f50620ef2b8799$var$Icons = {
    'arrow-left': (0, $716a3ab1bc910cef$export$2e2bcd8739ae039),
    'arrow-right': (0, $51d9ba5dec58f340$export$2e2bcd8739ae039),
    'caret-down': (0, $fe6bc85e5c3444d5$export$2e2bcd8739ae039),
    'caret-up': (0, $5ce58e2c168a9946$export$2e2bcd8739ae039),
    'center-marker': (0, $e927044f3337a956$export$2e2bcd8739ae039),
    clock: (0, $2f727b898d9822c6$export$2e2bcd8739ae039),
    inverse: (0, $580acb0836620f21$export$2e2bcd8739ae039),
    close: (0, $a6a75554c04119a6$export$2e2bcd8739ae039),
    'itinerary-filled': (0, $8b367de7194b5ac1$export$2e2bcd8739ae039),
    stairs: (0, $6f1b8535ef422e45$export$2e2bcd8739ae039),
    'stairs-thick': (0, $59210cf156fda2e8$export$2e2bcd8739ae039),
    marker: (0, $b0649312cd295086$export$2e2bcd8739ae039),
    'marker-filled': (0, $02bcc6d1401ca51a$export$2e2bcd8739ae039),
    'position-filled': (0, $95182ba5bffd3209$export$2e2bcd8739ae039),
    phone: (0, $c03f96a5653f1ea0$export$2e2bcd8739ae039),
    share: (0, $1873985a92144652$export$2e2bcd8739ae039),
    sound: (0, $0628d22a60af517d$export$2e2bcd8739ae039),
    'sound-mute': (0, $c999ecb5f3815d3a$export$2e2bcd8739ae039),
    world: (0, $83becb381df659e1$export$2e2bcd8739ae039),
    itinerary: (0, $f5dffaa16091f3b0$export$2e2bcd8739ae039),
    "itinerary-overview": (0, $04b2bc10cfcaddba$export$2e2bcd8739ae039),
    "itinerary-start": (0, $85195db6ce8da10f$export$2e2bcd8739ae039),
    disability: (0, $9b616a11ad05a467$export$2e2bcd8739ae039),
    'elevator_down': (0, $cc6d7ec72c26e727$export$2e2bcd8739ae039),
    'elevator_up': (0, $c5a9c9b770bcb2db$export$2e2bcd8739ae039),
    'escalator_down': (0, $d8e9174dede0e092$export$2e2bcd8739ae039),
    'escalator_up': (0, $548a11f8bb4a18e4$export$2e2bcd8739ae039),
    'ramp_down': (0, $e4e302ef99ccc447$export$2e2bcd8739ae039),
    'ramp_up': (0, $f9e099e6cec6487b$export$2e2bcd8739ae039),
    'slight_left_walk_past': (0, $6b7254b7ad8900e7$export$2e2bcd8739ae039),
    'slight_left': (0, $ce8423f1c7909134$export$2e2bcd8739ae039),
    'slight_right_walk_past': (0, $0375b1498a25bf37$export$2e2bcd8739ae039),
    'slight_right': (0, $98845e8d7c3fb395$export$2e2bcd8739ae039),
    'stairs_down': (0, $42e3b781f0c9166f$export$2e2bcd8739ae039),
    'stairs_up': (0, $34e6a51296488203$export$2e2bcd8739ae039),
    'travelator': (0, $66a6e8c6ad9a2887$export$2e2bcd8739ae039),
    'turn_left_walk_past': (0, $03060671e9a387db$export$2e2bcd8739ae039),
    'turn_left': (0, $2b2bca3e8f8771a0$export$2e2bcd8739ae039),
    'turn_right_walk_past': (0, $b0c6d90da48e7456$export$2e2bcd8739ae039),
    'turn_right': (0, $467e6545aa0b99c4$export$2e2bcd8739ae039),
    'walk_straight_distance': (0, $9d1e4476c51fffd9$export$2e2bcd8739ae039),
    'walk_straight_walk_past': (0, $2fb19d002a106552$export$2e2bcd8739ae039),
    'walk_straight': (0, $e4b24ed6dfc9ab90$export$2e2bcd8739ae039),
    'nav-elevator_down': (0, $1662d34c473bbb42$export$2e2bcd8739ae039),
    'nav-elevator_up': (0, $502b8d854d4441ce$export$2e2bcd8739ae039),
    'nav-escalator_down': (0, $374e53fe05c8de32$export$2e2bcd8739ae039),
    'nav-escalator_up': (0, $78646e57b8c7e59a$export$2e2bcd8739ae039),
    'nav-ramp_down': (0, $4218d451b9a4f740$export$2e2bcd8739ae039),
    'nav-ramp_up': (0, $fe82e5daa836e936$export$2e2bcd8739ae039),
    'nav-slight_left_walk_past': (0, $7a9aa69e852e59c5$export$2e2bcd8739ae039),
    'nav-slight_left': (0, $846b933b18ee6077$export$2e2bcd8739ae039),
    'nav-slight_right_walk_past': (0, $f288012a8a4a6640$export$2e2bcd8739ae039),
    'nav-slight_right': (0, $24c0c576f5e1e8ba$export$2e2bcd8739ae039),
    'nav-stairs_down': (0, $b7f713fe2a7e6328$export$2e2bcd8739ae039),
    'nav-stairs_up': (0, $d3d9eea7cf59d238$export$2e2bcd8739ae039),
    'nav-travelator': (0, $f43f5dbc4b344a13$export$2e2bcd8739ae039),
    'nav-turn_left_walk_past': (0, $925bc0bb7aef0462$export$2e2bcd8739ae039),
    'nav-turn_left': (0, $0a9ebd53b0724b85$export$2e2bcd8739ae039),
    'nav-turn_right_walk_past': (0, $59f9108607bb5833$export$2e2bcd8739ae039),
    'nav-turn_right': (0, $d6d08e426fbd00c9$export$2e2bcd8739ae039),
    'nav-walk_straight_distance': (0, $1382c45fbb0d9b81$export$2e2bcd8739ae039),
    'nav-walk_straight_walk_past': (0, $59b5341fe358d9c2$export$2e2bcd8739ae039),
    'nav-walk_straight': (0, $c9b4aea02f2ff4b0$export$2e2bcd8739ae039),
    'nav-walk_straight_small': (0, $5f22df5f5ce4db75$export$2e2bcd8739ae039),
    'navigation-arrow': (0, $b2685b22147ed444$export$2e2bcd8739ae039),
    'minus': (0, $53dec6c098410f54$export$2e2bcd8739ae039),
    'plus': (0, $37a6380c7a271c75$export$2e2bcd8739ae039),
    'edit': (0, $f4e8b471a536f4bb$export$2e2bcd8739ae039),
    'time': (0, $bd94dce843e76cb1$export$2e2bcd8739ae039),
    'distance': (0, $5b745c20456dc29f$export$2e2bcd8739ae039),
    'stops': (0, $3df9457f7847519d$export$2e2bcd8739ae039),
    'down-arrow': (0, $bbf36f5296a51b5a$export$2e2bcd8739ae039),
    'search': (0, $aad98fb6b65f01ff$export$2e2bcd8739ae039),
    'big-close': (0, $2e0b8d71c095e6f5$export$2e2bcd8739ae039),
    'tour': (0, $46351c9f6d626d87$export$2e2bcd8739ae039),
    'double-arrow-left': (0, $e2237b50e7b1f4dc$export$2e2bcd8739ae039),
    'double-arrow-right': (0, $fc7baabad4c992c9$export$2e2bcd8739ae039)
};
class $93f50620ef2b8799$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    render() {
        const { icon: icon, size: size, className: className, title: title, testId: testId } = this.props;
        const IconComponent = Object.keys($93f50620ef2b8799$var$Icons).includes(icon) ? $93f50620ef2b8799$var$Icons[icon] : (0, $163beaed504dbd64$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)(IconComponent, {
            className: `icon ${className || ''}`,
            "data-testid": `${testId || ''}-${icon}`,
            width: size,
            height: size,
            title: title
        });
    }
}
$93f50620ef2b8799$export$2e2bcd8739ae039.defaultProps = {
    size: 24,
    className: null,
    title: null,
    testId: 'icon'
};


var $4221174f429b1082$exports = {};
(function(global, factory) {
    $4221174f429b1082$exports = factory();
})($4221174f429b1082$exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithoutHoles(r) {
        if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _createForOfIteratorHelper(r, e) {
        var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (!t) {
            if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
                t && (r = t);
                var n = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return n >= r.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: r[n++]
                        };
                    },
                    e: function(r) {
                        throw r;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, a = !0, u = !1;
        return {
            s: function() {
                t = t.call(r);
            },
            n: function() {
                var r = t.next();
                return a = r.done, r;
            },
            e: function(r) {
                u = !0, o = r;
            },
            f: function() {
                try {
                    a || null == t.return || t.return();
                } finally{
                    if (u) throw o;
                }
            }
        };
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArray(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toConsumableArray(r) {
        return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var select$1 = function select(element) {
        return typeof element === "string" ? document.querySelector(element) : element();
    };
    var create = function create(tag, options) {
        var el = typeof tag === "string" ? document.createElement(tag) : tag;
        for(var key in options){
            var val = options[key];
            if (key === "inside") val.append(el);
            else if (key === "dest") select$1(val[0]).insertAdjacentElement(val[1], el);
            else if (key === "around") {
                var ref = val;
                ref.parentNode.insertBefore(el, ref);
                el.append(ref);
                if (ref.getAttribute("autofocus") != null) ref.focus();
            } else if (key in el) el[key] = val;
            else el.setAttribute(key, val);
        }
        return el;
    };
    var getQuery = function getQuery(field) {
        return field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement ? field.value : field.innerHTML;
    };
    var format = function format(value, diacritics) {
        value = String(value).toLowerCase();
        return diacritics ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").normalize("NFC") : value;
    };
    var debounce = function debounce(callback, duration) {
        var timer;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(function() {
                return callback();
            }, duration);
        };
    };
    var checkTrigger = function checkTrigger(query, condition, threshold) {
        return condition ? condition(query) : query.length >= threshold;
    };
    var mark = function mark(value, cls) {
        return create("mark", _objectSpread2({
            innerHTML: value
        }, typeof cls === "string" && {
            "class": cls
        })).outerHTML;
    };
    var configure = function(ctx) {
        var name = ctx.name, options = ctx.options, resultsList = ctx.resultsList, resultItem = ctx.resultItem;
        for(var option in options)if (_typeof(options[option]) === "object") {
            if (!ctx[option]) ctx[option] = {};
            for(var subOption in options[option])ctx[option][subOption] = options[option][subOption];
        } else ctx[option] = options[option];
        ctx.selector = ctx.selector || "#" + name;
        resultsList.destination = resultsList.destination || ctx.selector;
        resultsList.id = resultsList.id || name + "_list_" + ctx.id;
        resultItem.id = resultItem.id || name + "_result";
        ctx.input = select$1(ctx.selector);
    };
    var eventEmitter = function(name, ctx) {
        ctx.input.dispatchEvent(new CustomEvent(name, {
            bubbles: true,
            detail: ctx.feedback,
            cancelable: true
        }));
    };
    var search = function(query, record, options) {
        var _ref = options || {}, mode = _ref.mode, diacritics = _ref.diacritics, highlight = _ref.highlight;
        var nRecord = format(record, diacritics);
        record = String(record);
        query = format(query, diacritics);
        if (mode === "loose") {
            query = query.replace(/ /g, "");
            var qLength = query.length;
            var cursor = 0;
            var match = Array.from(record).map(function(character, index) {
                if (cursor < qLength && nRecord[index] === query[cursor]) {
                    character = highlight ? mark(character, highlight) : character;
                    cursor++;
                }
                return character;
            }).join("");
            if (cursor === qLength) return match;
        } else {
            var _match = nRecord.indexOf(query);
            if (~_match) {
                query = record.substring(_match, _match + query.length);
                _match = highlight ? record.replace(query, mark(query, highlight)) : record;
                return _match;
            }
        }
    };
    var getData = function getData(ctx, query) {
        return new Promise(function($return, $error) {
            var data;
            data = ctx.data;
            if (data.cache && data.store) return $return();
            return new Promise(function($return, $error) {
                if (typeof data.src === "function") return new Promise(function($return, $error) {
                    if (data.src.constructor.name === "AsyncFunction") return data.src(query).then($return, $error);
                    return $return(data.src(query));
                }).then($return, $error);
                return $return(data.src);
            }).then(function($await_7) {
                try {
                    ctx.feedback = data.store = $await_7;
                    eventEmitter("response", ctx);
                    return $return();
                } catch ($boundEx) {
                    return $error($boundEx);
                }
            }, $error);
        });
    };
    var findMatches = function findMatches(query, ctx) {
        var data = ctx.data, searchEngine = ctx.searchEngine;
        var matches = [];
        data.store.forEach(function(value, index) {
            var find = function find(key) {
                var record = key ? value[key] : value;
                var match = typeof searchEngine === "function" ? searchEngine(query, record) : search(query, record, {
                    mode: searchEngine,
                    diacritics: ctx.diacritics,
                    highlight: ctx.resultItem.highlight
                });
                if (!match) return;
                var result = {
                    match: match,
                    value: value
                };
                if (key) result.key = key;
                matches.push(result);
            };
            if (data.keys) {
                var _iterator = _createForOfIteratorHelper(data.keys), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var key = _step.value;
                        find(key);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            } else find();
        });
        if (data.filter) matches = data.filter(matches);
        var results = matches.slice(0, ctx.resultsList.maxResults);
        ctx.feedback = {
            query: query,
            matches: matches,
            results: results
        };
        eventEmitter("results", ctx);
    };
    var Expand = "aria-expanded";
    var Active = "aria-activedescendant";
    var Selected = "aria-selected";
    var feedback = function feedback(ctx, index) {
        ctx.feedback.selection = _objectSpread2({
            index: index
        }, ctx.feedback.results[index]);
    };
    var render = function render(ctx) {
        var resultsList = ctx.resultsList, list = ctx.list, resultItem = ctx.resultItem, feedback = ctx.feedback;
        var matches = feedback.matches, results = feedback.results;
        ctx.cursor = -1;
        list.innerHTML = "";
        if (matches.length || resultsList.noResults) {
            var fragment = new DocumentFragment();
            results.forEach(function(result, index) {
                var element = create(resultItem.tag, _objectSpread2({
                    id: "".concat(resultItem.id, "_").concat(index),
                    role: "option",
                    innerHTML: result.match,
                    inside: fragment
                }, resultItem["class"] && {
                    "class": resultItem["class"]
                }));
                if (resultItem.element) resultItem.element(element, result);
            });
            list.append(fragment);
            if (resultsList.element) resultsList.element(list, feedback);
            open(ctx);
        } else close(ctx);
    };
    var open = function open(ctx) {
        if (ctx.isOpen) return;
        (ctx.wrapper || ctx.input).setAttribute(Expand, true);
        ctx.list.removeAttribute("hidden");
        ctx.isOpen = true;
        eventEmitter("open", ctx);
    };
    var close = function close(ctx) {
        if (!ctx.isOpen) return;
        (ctx.wrapper || ctx.input).setAttribute(Expand, false);
        ctx.input.setAttribute(Active, "");
        ctx.list.setAttribute("hidden", "");
        ctx.isOpen = false;
        eventEmitter("close", ctx);
    };
    var goTo = function goTo(index, ctx) {
        var resultItem = ctx.resultItem;
        var results = ctx.list.getElementsByTagName(resultItem.tag);
        var cls = resultItem.selected ? resultItem.selected.split(" ") : false;
        if (ctx.isOpen && results.length) {
            var _results$index$classL;
            var state = ctx.cursor;
            if (index >= results.length) index = 0;
            if (index < 0) index = results.length - 1;
            ctx.cursor = index;
            if (state > -1) {
                var _results$state$classL;
                results[state].removeAttribute(Selected);
                if (cls) (_results$state$classL = results[state].classList).remove.apply(_results$state$classL, _toConsumableArray(cls));
            }
            results[index].setAttribute(Selected, true);
            if (cls) (_results$index$classL = results[index].classList).add.apply(_results$index$classL, _toConsumableArray(cls));
            ctx.input.setAttribute(Active, results[ctx.cursor].id);
            ctx.list.scrollTop = results[index].offsetTop - ctx.list.clientHeight + results[index].clientHeight + 5;
            ctx.feedback.cursor = ctx.cursor;
            feedback(ctx, index);
            eventEmitter("navigate", ctx);
        }
    };
    var next = function next(ctx) {
        goTo(ctx.cursor + 1, ctx);
    };
    var previous = function previous(ctx) {
        goTo(ctx.cursor - 1, ctx);
    };
    var select = function select(ctx, event, index) {
        index = index >= 0 ? index : ctx.cursor;
        if (index < 0) return;
        ctx.feedback.event = event;
        feedback(ctx, index);
        eventEmitter("selection", ctx);
        close(ctx);
    };
    var click = function click(event, ctx) {
        var itemTag = ctx.resultItem.tag.toUpperCase();
        var items = Array.from(ctx.list.querySelectorAll(itemTag));
        var item = event.target.closest(itemTag);
        if (item && item.nodeName === itemTag) select(ctx, event, items.indexOf(item));
    };
    var navigate = function navigate(event, ctx) {
        switch(event.keyCode){
            case 40:
            case 38:
                event.preventDefault();
                event.keyCode === 40 ? next(ctx) : previous(ctx);
                break;
            case 13:
                if (!ctx.submit) event.preventDefault();
                if (ctx.cursor >= 0) select(ctx, event);
                break;
            case 9:
                if (ctx.resultsList.tabSelect && ctx.cursor >= 0) select(ctx, event);
                break;
            case 27:
                ctx.input.value = "";
                eventEmitter('clear', ctx);
                close(ctx);
                break;
        }
    };
    function start(ctx, q) {
        var _this = this;
        return new Promise(function($return, $error) {
            var queryVal, condition;
            queryVal = q || getQuery(ctx.input);
            queryVal = ctx.query ? ctx.query(queryVal) : queryVal;
            condition = checkTrigger(queryVal, ctx.trigger, ctx.threshold);
            if (condition) return getData(ctx, queryVal).then(function($await_2) {
                try {
                    if (ctx.feedback instanceof Error) return $return();
                    findMatches(queryVal, ctx);
                    if (ctx.resultsList) render(ctx);
                    return $If_1.call(_this);
                } catch ($boundEx) {
                    return $error($boundEx);
                }
            }, $error);
            else {
                close(ctx);
                return $If_1.call(_this);
            }
            function $If_1() {
                return $return();
            }
        });
    }
    var eventsManager = function eventsManager(events, callback) {
        for(var element in events)for(var event in events[element])callback(element, event);
    };
    var addEvents = function addEvents(ctx) {
        var events = ctx.events;
        var run = debounce(function() {
            return start(ctx);
        }, ctx.debounce);
        var publicEvents = ctx.events = _objectSpread2({
            input: _objectSpread2({}, events && events.input)
        }, ctx.resultsList && {
            list: events ? _objectSpread2({}, events.list) : {}
        });
        var privateEvents = {
            input: {
                input: function input() {
                    run();
                },
                keydown: function keydown(event) {
                    navigate(event, ctx);
                },
                blur: function blur() {
                    close(ctx);
                }
            },
            list: {
                mousedown: function mousedown(event) {
                    event.preventDefault();
                },
                click: function click$1(event) {
                    click(event, ctx);
                }
            }
        };
        eventsManager(privateEvents, function(element, event) {
            if (!ctx.resultsList && event !== "input") return;
            if (publicEvents[element][event]) return;
            publicEvents[element][event] = privateEvents[element][event];
        });
        eventsManager(publicEvents, function(element, event) {
            ctx[element].addEventListener(event, publicEvents[element][event]);
        });
    };
    var removeEvents = function removeEvents(ctx) {
        eventsManager(ctx.events, function(element, event) {
            ctx[element].removeEventListener(event, ctx.events[element][event]);
        });
    };
    function init(ctx) {
        var _this = this;
        return new Promise(function($return, $error) {
            var placeHolder, resultsList, parentAttrs;
            placeHolder = ctx.placeHolder;
            resultsList = ctx.resultsList;
            parentAttrs = {
                role: "combobox",
                "aria-owns": resultsList.id,
                "aria-haspopup": true,
                "aria-expanded": false
            };
            create(ctx.input, _objectSpread2(_objectSpread2({
                "aria-controls": resultsList.id,
                "aria-autocomplete": "both"
            }, placeHolder && {
                placeholder: placeHolder
            }), !ctx.wrapper && _objectSpread2({}, parentAttrs)));
            if (ctx.wrapper) ctx.wrapper = create("div", _objectSpread2({
                around: ctx.input,
                "class": ctx.name + "_wrapper"
            }, parentAttrs));
            if (resultsList) ctx.list = create(resultsList.tag, _objectSpread2({
                dest: [
                    resultsList.destination,
                    resultsList.position
                ],
                id: resultsList.id,
                role: "listbox",
                hidden: "hidden"
            }, resultsList["class"] && {
                "class": resultsList["class"]
            }));
            addEvents(ctx);
            if (ctx.data.cache) return getData(ctx).then(function($await_2) {
                try {
                    return $If_1.call(_this);
                } catch ($boundEx) {
                    return $error($boundEx);
                }
            }, $error);
            function $If_1() {
                eventEmitter("init", ctx);
                return $return();
            }
            return $If_1.call(_this);
        });
    }
    function extend(autoComplete) {
        var prototype = autoComplete.prototype;
        prototype.init = function() {
            init(this);
        };
        prototype.start = function(query) {
            start(this, query);
        };
        prototype.unInit = function() {
            if (this.wrapper) {
                var parentNode = this.wrapper.parentNode;
                parentNode.insertBefore(this.input, this.wrapper);
                parentNode.removeChild(this.wrapper);
            }
            removeEvents(this);
        };
        prototype.open = function() {
            open(this);
        };
        prototype.close = function() {
            close(this);
        };
        prototype.goTo = function(index) {
            goTo(index, this);
        };
        prototype.next = function() {
            next(this);
        };
        prototype.previous = function() {
            previous(this);
        };
        prototype.select = function(index) {
            select(this, null, index);
        };
        prototype.search = function(query, record, options) {
            return search(query, record, options);
        };
    }
    function autoComplete(config) {
        this.options = config;
        this.id = autoComplete.instances = (autoComplete.instances || 0) + 1;
        this.name = "autoComplete";
        this.wrapper = 1;
        this.threshold = 1;
        this.debounce = 0;
        this.resultsList = {
            position: "afterend",
            tag: "ul",
            maxResults: 5
        };
        this.resultItem = {
            tag: "li"
        };
        configure(this);
        extend.call(this, autoComplete);
        init(this);
    }
    return autoComplete;
});




class $fea70e6de74e95e1$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    constructor(){
        super();
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this._inputRef = (0, $7Do5B.createRef)();
    }
    componentDidMount() {
        const { placeholder: placeholder, src: src, keys: keys, callbackSelect: callbackSelect, defaultValue: defaultValue, isMobileView: isMobileView, disableAutoFocus: disableAutoFocus, onClose: onClose, clearInputOnSelection: clearInputOnSelection } = this.props;
        const autoCompleteJS = new (0, (/*@__PURE__*/$parcel$interopDefault($4221174f429b1082$exports)))({
            debounce: 300,
            selector: ()=>{
                return this._inputRef.current;
            },
            placeHolder: placeholder,
            trigger: ()=>true,
            searchEngine: (_query, record)=>{
                return record;
            },
            data: {
                src: src,
                keys: keys
            },
            resultItem: {
                tag: "li",
                element: (element, data)=>{
                    const div = document.createElement('div');
                    (0, $7Do5B.render)(/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        icon: "stairs-thick",
                        size: 18,
                        className: "ac-results-level--icon"
                    }), div);
                    const distance = data.value.distance !== null && data.value.distance !== undefined ? `${Math.round(data.value.distance)}m` : '';
                    element.innerHTML = data.value.building ? `<div class="ac-results-name" title="${data.value.name} - ${data.value.building}"><span class="ac-results-name--building">${data.value.building}</span><span class="ac-results-name--poi">${data.value.name}</span>${distance ? `<span class="ac-results-distance">${distance}</span>` : ''}</div><div class="ac-results-level">${div.innerHTML}<span class="ac-results-level--number">${data.value.level}</span>` : `<div class="ac-results-name" title="${data.value.name}"><span class="ac-results-name--poi" title="${data.value.name}">${data.value.name}</span>${distance ? `<span class="ac-results-distance">${distance}</span>` : ''}</div><div class="ac-results-level">${div.innerHTML}<span class="ac-results-level--number">${data.value.level}</span>`;
                }
            },
            resultsList: {
                maxResults: 11
            },
            events: {
                input: {
                    selection: (event)=>{
                        const feedback = event.detail;
                        autoCompleteJS.input.blur();
                        const selection = `${feedback.selection.value.name} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['at Level']} (${feedback.selection.value.level})`;
                        autoCompleteJS.input.value = selection;
                        if (clearInputOnSelection) autoCompleteJS.input.value = '';
                        callbackSelect(feedback.selection.value);
                    },
                    search: ()=>{
                        callbackSelect();
                    },
                    click () {
                        autoCompleteJS.start('');
                    },
                    change: ()=>{
                        callbackSelect();
                    },
                    response: (event)=>{
                        if (event.detail && event.detail.length >= 1) setTimeout(()=>{
                            autoCompleteJS.goTo(0);
                        }, 100);
                    },
                    close: ()=>{
                        onClose();
                    }
                }
            }
        });
        this.autoCompleteJS = autoCompleteJS;
        if (!isMobileView && !disableAutoFocus) this.autoCompleteJS.input.focus();
        if (defaultValue) this.autoCompleteJS.input.value = defaultValue;
        else this.autoCompleteJS.input.value = '';
    }
    componentDidUpdate(prevProps) {
        const { value: value } = this.props;
        if (prevProps.value !== value) this.autoCompleteJS.input.value = value;
    }
    componentWillUnmount() {
        this.autoCompleteJS.unInit();
    }
    render() {
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
            ref: this._inputRef,
            type: "search",
            dir: "ltr",
            spellcheck: false,
            autoCorrect: "off",
            autoComplete: "off",
            autoCapitalize: "off",
            maxLength: 2048,
            tabIndex: 1
        });
    }
}






var $7Do5B = parcelRequire("7Do5B");
class $1d148e12fc214f1e$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    handleKeyPress(e) {
        if (e.keyCode === 32 || e.code === '32') {
            const { checked: checked, onChange: onChange } = this.props;
            e.preventDefault();
            onChange(!checked);
        }
    }
    render() {
        const { id: id, text: text, checked: checked, onChange: onChange, name: name, optionLabels: optionLabels, isSmall: isSmall, disabled: disabled } = this.props;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: isSmall ? 'switch--small' : 'switch',
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "switch__container",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                            type: "checkbox",
                            name: name,
                            className: "switch__checkbox",
                            id: id,
                            checked: checked,
                            onChange: (e)=>onChange(e.target.checked),
                            disabled: disabled,
                            onClick: (e)=>{
                                e.stopPropagation();
                            }
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            role: "switch",
                            "aria-checked": checked,
                            className: "switch__label",
                            htmlFor: id,
                            tabIndex: disabled ? -1 : 1,
                            onKeyDown: this.handleKeyPress,
                            onClick: (e)=>{
                                e.stopPropagation();
                            },
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    className: "switch__inner",
                                    "data-yes": optionLabels[0],
                                    "data-no": optionLabels[1],
                                    tabIndex: -1
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    className: "switch__controller",
                                    tabIndex: -1
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                    className: "switch__text",
                    children: text
                })
            ]
        });
    }
}
// Set optionLabels for rendering.
$1d148e12fc214f1e$export$2e2bcd8739ae039.defaultProps = {
    optionLabels: [
        '',
        ''
    ],
    name: null,
    disabled: false,
    text: '',
    isSmall: false
};


// @flow
var $c638b168c37c7886$exports = {};
/*
 (c) 2011-2015, Vladimir Agafonkin
 SunCalc is a JavaScript library for calculating sun/moon position and light phases.
 https://github.com/mourner/suncalc
*/ (function() {
    'use strict';
    // shortcuts for easier to read formulas
    var PI = Math.PI, sin = Math.sin, cos = Math.cos, tan = Math.tan, asin = Math.asin, atan = Math.atan2, acos = Math.acos, rad = PI / 180;
    // sun calculations are based on http://aa.quae.nl/en/reken/zonpositie.html formulas
    // date/time constants and conversions
    var dayMs = 86400000, J1970 = 2440588, J2000 = 2451545;
    function toJulian(date) {
        return date.valueOf() / dayMs - 0.5 + J1970;
    }
    function fromJulian(j) {
        return new Date((j + 0.5 - J1970) * dayMs);
    }
    function toDays(date) {
        return toJulian(date) - J2000;
    }
    // general calculations for position
    var e = rad * 23.4397; // obliquity of the Earth
    function rightAscension(l, b) {
        return atan(sin(l) * cos(e) - tan(b) * sin(e), cos(l));
    }
    function declination(l, b) {
        return asin(sin(b) * cos(e) + cos(b) * sin(e) * sin(l));
    }
    function azimuth(H, phi, dec) {
        return atan(sin(H), cos(H) * sin(phi) - tan(dec) * cos(phi));
    }
    function altitude(H, phi, dec) {
        return asin(sin(phi) * sin(dec) + cos(phi) * cos(dec) * cos(H));
    }
    function siderealTime(d, lw) {
        return rad * (280.16 + 360.9856235 * d) - lw;
    }
    function astroRefraction(h) {
        if (h < 0) h = 0; // if h = -0.08901179 a div/0 would occur.
        // formula 16.4 of "Astronomical Algorithms" 2nd edition by Jean Meeus (Willmann-Bell, Richmond) 1998.
        // 1.02 / tan(h + 10.26 / (h + 5.10)) h in degrees, result in arc minutes -> converted to rad:
        return 0.0002967 / Math.tan(h + 0.00312536 / (h + 0.08901179));
    }
    // general sun calculations
    function solarMeanAnomaly(d) {
        return rad * (357.5291 + 0.98560028 * d);
    }
    function eclipticLongitude(M) {
        var C = rad * (1.9148 * sin(M) + 0.02 * sin(2 * M) + 0.0003 * sin(3 * M)), P = rad * 102.9372; // perihelion of the Earth
        return M + C + P + PI;
    }
    function sunCoords(d) {
        var M = solarMeanAnomaly(d), L = eclipticLongitude(M);
        return {
            dec: declination(L, 0),
            ra: rightAscension(L, 0)
        };
    }
    var SunCalc = {};
    // calculates sun position for a given date and latitude/longitude
    SunCalc.getPosition = function(date, lat, lng) {
        var lw = rad * -lng, phi = rad * lat, d = toDays(date), c = sunCoords(d), H = siderealTime(d, lw) - c.ra;
        return {
            azimuth: azimuth(H, phi, c.dec),
            altitude: altitude(H, phi, c.dec)
        };
    };
    // sun times configuration (angle, morning name, evening name)
    var times = SunCalc.times = [
        [
            -0.833,
            'sunrise',
            'sunset'
        ],
        [
            -0.3,
            'sunriseEnd',
            'sunsetStart'
        ],
        [
            -6,
            'dawn',
            'dusk'
        ],
        [
            -12,
            'nauticalDawn',
            'nauticalDusk'
        ],
        [
            -18,
            'nightEnd',
            'night'
        ],
        [
            6,
            'goldenHourEnd',
            'goldenHour'
        ]
    ];
    // adds a custom time to the times config
    SunCalc.addTime = function(angle, riseName, setName) {
        times.push([
            angle,
            riseName,
            setName
        ]);
    };
    // calculations for sun times
    var J0 = 0.0009;
    function julianCycle(d, lw) {
        return Math.round(d - J0 - lw / (2 * PI));
    }
    function approxTransit(Ht, lw, n) {
        return J0 + (Ht + lw) / (2 * PI) + n;
    }
    function solarTransitJ(ds, M, L) {
        return J2000 + ds + 0.0053 * sin(M) - 0.0069 * sin(2 * L);
    }
    function hourAngle(h, phi, d) {
        return acos((sin(h) - sin(phi) * sin(d)) / (cos(phi) * cos(d)));
    }
    function observerAngle(height) {
        return -2.076 * Math.sqrt(height) / 60;
    }
    // returns set time for the given sun altitude
    function getSetJ(h, lw, phi, dec, n, M, L) {
        var w = hourAngle(h, phi, dec), a = approxTransit(w, lw, n);
        return solarTransitJ(a, M, L);
    }
    // calculates sun times for a given date, latitude/longitude, and, optionally,
    // the observer height (in meters) relative to the horizon
    SunCalc.getTimes = function(date, lat, lng, height) {
        height = height || 0;
        var lw = rad * -lng, phi = rad * lat, dh = observerAngle(height), d = toDays(date), n = julianCycle(d, lw), ds = approxTransit(0, lw, n), M = solarMeanAnomaly(ds), L = eclipticLongitude(M), dec = declination(L, 0), Jnoon = solarTransitJ(ds, M, L), i, len, time, h0, Jset, Jrise;
        var result = {
            solarNoon: fromJulian(Jnoon),
            nadir: fromJulian(Jnoon - 0.5)
        };
        for(i = 0, len = times.length; i < len; i += 1){
            time = times[i];
            h0 = (time[0] + dh) * rad;
            Jset = getSetJ(h0, lw, phi, dec, n, M, L);
            Jrise = Jnoon - (Jset - Jnoon);
            result[time[1]] = fromJulian(Jrise);
            result[time[2]] = fromJulian(Jset);
        }
        return result;
    };
    // moon calculations, based on http://aa.quae.nl/en/reken/hemelpositie.html formulas
    function moonCoords(d) {
        var L = rad * (218.316 + 13.176396 * d), M = rad * (134.963 + 13.064993 * d), F = rad * (93.272 + 13.229350 * d), l = L + rad * 6.289 * sin(M), b = rad * 5.128 * sin(F), dt = 385001 - 20905 * cos(M); // distance to the moon in km
        return {
            ra: rightAscension(l, b),
            dec: declination(l, b),
            dist: dt
        };
    }
    SunCalc.getMoonPosition = function(date, lat, lng) {
        var lw = rad * -lng, phi = rad * lat, d = toDays(date), c = moonCoords(d), H = siderealTime(d, lw) - c.ra, h = altitude(H, phi, c.dec), // formula 14.1 of "Astronomical Algorithms" 2nd edition by Jean Meeus (Willmann-Bell, Richmond) 1998.
        pa = atan(sin(H), tan(phi) * cos(c.dec) - sin(c.dec) * cos(H));
        h = h + astroRefraction(h); // altitude correction for refraction
        return {
            azimuth: azimuth(H, phi, c.dec),
            altitude: h,
            distance: c.dist,
            parallacticAngle: pa
        };
    };
    // calculations for illumination parameters of the moon,
    // based on http://idlastro.gsfc.nasa.gov/ftp/pro/astro/mphase.pro formulas and
    // Chapter 48 of "Astronomical Algorithms" 2nd edition by Jean Meeus (Willmann-Bell, Richmond) 1998.
    SunCalc.getMoonIllumination = function(date) {
        var d = toDays(date || new Date()), s = sunCoords(d), m = moonCoords(d), sdist = 149598000, phi = acos(sin(s.dec) * sin(m.dec) + cos(s.dec) * cos(m.dec) * cos(s.ra - m.ra)), inc = atan(sdist * sin(phi), m.dist - sdist * cos(phi)), angle = atan(cos(s.dec) * sin(s.ra - m.ra), sin(s.dec) * cos(m.dec) - cos(s.dec) * sin(m.dec) * cos(s.ra - m.ra));
        return {
            fraction: (1 + cos(inc)) / 2,
            phase: 0.5 + 0.5 * inc * (angle < 0 ? -1 : 1) / Math.PI,
            angle: angle
        };
    };
    function hoursLater(date, h) {
        return new Date(date.valueOf() + h * dayMs / 24);
    }
    // calculations for moon rise/set times are based on http://www.stargazing.net/kepler/moonrise.html article
    SunCalc.getMoonTimes = function(date, lat, lng, inUTC) {
        var t = new Date(date);
        if (inUTC) t.setUTCHours(0, 0, 0, 0);
        else t.setHours(0, 0, 0, 0);
        var hc = 0.133 * rad, h0 = SunCalc.getMoonPosition(t, lat, lng).altitude - hc, h1, h2, rise, set, a, b, xe, ye, d, roots, x1, x2, dx;
        // go in 2-hour chunks, each time seeing if a 3-point quadratic curve crosses zero (which means rise or set)
        for(var i = 1; i <= 24; i += 2){
            h1 = SunCalc.getMoonPosition(hoursLater(t, i), lat, lng).altitude - hc;
            h2 = SunCalc.getMoonPosition(hoursLater(t, i + 1), lat, lng).altitude - hc;
            a = (h0 + h2) / 2 - h1;
            b = (h2 - h0) / 2;
            xe = -b / (2 * a);
            ye = (a * xe + b) * xe + h1;
            d = b * b - 4 * a * h1;
            roots = 0;
            if (d >= 0) {
                dx = Math.sqrt(d) / (Math.abs(a) * 2);
                x1 = xe - dx;
                x2 = xe + dx;
                if (Math.abs(x1) <= 1) roots++;
                if (Math.abs(x2) <= 1) roots++;
                if (x1 < -1) x1 = x2;
            }
            if (roots === 1) {
                if (h0 < 0) rise = i + x1;
                else set = i + x1;
            } else if (roots === 2) {
                rise = i + (ye < 0 ? x2 : x1);
                set = i + (ye < 0 ? x1 : x2);
            }
            if (rise && set) break;
            h0 = h2;
        }
        var result = {};
        if (rise) result.rise = hoursLater(t, rise);
        if (set) result.set = hoursLater(t, set);
        if (!rise && !set) result[ye > 0 ? 'alwaysUp' : 'alwaysDown'] = true;
        return result;
    };
    $c638b168c37c7886$exports = SunCalc;
})();


const $5abb203460cfd110$var$isString = (obj)=>typeof obj === 'string';
const $5abb203460cfd110$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $5abb203460cfd110$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $5abb203460cfd110$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $5abb203460cfd110$var$lastOfPathSeparatorRegExp = /###/g;
const $5abb203460cfd110$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($5abb203460cfd110$var$lastOfPathSeparatorRegExp, '.') : key;
const $5abb203460cfd110$var$canNotTraverseDeeper = (object)=>!object || $5abb203460cfd110$var$isString(object);
const $5abb203460cfd110$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$5abb203460cfd110$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($5abb203460cfd110$var$canNotTraverseDeeper(object)) return {};
        const key = $5abb203460cfd110$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($5abb203460cfd110$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $5abb203460cfd110$var$cleanKey(stack[stackIndex])
    };
};
const $5abb203460cfd110$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $5abb203460cfd110$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $5abb203460cfd110$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $5abb203460cfd110$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $5abb203460cfd110$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $5abb203460cfd110$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $5abb203460cfd110$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $5abb203460cfd110$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $5abb203460cfd110$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $5abb203460cfd110$var$getPath(data, key);
    if (value !== undefined) return value;
    return $5abb203460cfd110$var$getPath(defaultData, key);
};
const $5abb203460cfd110$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($5abb203460cfd110$var$isString(target[prop]) || target[prop] instanceof String || $5abb203460cfd110$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $5abb203460cfd110$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $5abb203460cfd110$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $5abb203460cfd110$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $5abb203460cfd110$var$escape = (data)=>{
    if ($5abb203460cfd110$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$5abb203460cfd110$var$_entityMap[s]);
    return data;
};
class $5abb203460cfd110$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $5abb203460cfd110$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $5abb203460cfd110$var$looksLikeObjectPathRegExpCache = new $5abb203460cfd110$var$RegExpCache(20);
const $5abb203460cfd110$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $5abb203460cfd110$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $5abb203460cfd110$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $5abb203460cfd110$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $5abb203460cfd110$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $5abb203460cfd110$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $5abb203460cfd110$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $5abb203460cfd110$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($5abb203460cfd110$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $5abb203460cfd110$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $5abb203460cfd110$var$Logger(this.logger, options);
    }
}
var $5abb203460cfd110$var$baseLogger = new $5abb203460cfd110$var$Logger();
class $5abb203460cfd110$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $5abb203460cfd110$var$ResourceStore extends $5abb203460cfd110$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($5abb203460cfd110$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $5abb203460cfd110$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$5abb203460cfd110$var$isString(key)) return result;
        return $5abb203460cfd110$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $5abb203460cfd110$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($5abb203460cfd110$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $5abb203460cfd110$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $5abb203460cfd110$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $5abb203460cfd110$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $5abb203460cfd110$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $5abb203460cfd110$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $5abb203460cfd110$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $5abb203460cfd110$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $5abb203460cfd110$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$5abb203460cfd110$var$PATH_KEY]: path } = selector($5abb203460cfd110$var$createProxy());
    return path.join(opts?.keySeparator ?? '.');
}
const $5abb203460cfd110$var$checkedLoadedFor = {};
const $5abb203460cfd110$var$shouldHandleAsObject = (res)=>!$5abb203460cfd110$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $5abb203460cfd110$var$Translator extends $5abb203460cfd110$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $5abb203460cfd110$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $5abb203460cfd110$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $5abb203460cfd110$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$5abb203460cfd110$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $5abb203460cfd110$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $5abb203460cfd110$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $5abb203460cfd110$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$5abb203460cfd110$var$isString(opt.count);
        const hasDefaultValue = $5abb203460cfd110$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $5abb203460cfd110$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($5abb203460cfd110$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $5abb203460cfd110$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $5abb203460cfd110$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $5abb203460cfd110$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$5abb203460cfd110$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $5abb203460cfd110$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $5abb203460cfd110$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($5abb203460cfd110$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$5abb203460cfd110$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($5abb203460cfd110$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$5abb203460cfd110$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $5abb203460cfd110$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$5abb203460cfd110$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $5abb203460cfd110$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $5abb203460cfd110$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $5abb203460cfd110$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $5abb203460cfd110$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($5abb203460cfd110$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($5abb203460cfd110$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($5abb203460cfd110$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($5abb203460cfd110$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $5abb203460cfd110$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $5abb203460cfd110$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $5abb203460cfd110$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $5abb203460cfd110$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $5abb203460cfd110$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $5abb203460cfd110$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $5abb203460cfd110$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$5abb203460cfd110$var$suffixesOrder[pluralCategory1] - $5abb203460cfd110$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $5abb203460cfd110$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $5abb203460cfd110$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $5abb203460cfd110$var$isString(key)) {
        path = $5abb203460cfd110$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $5abb203460cfd110$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $5abb203460cfd110$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $5abb203460cfd110$var$Interpolator {
    constructor(options = {}){
        this.logger = $5abb203460cfd110$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $5abb203460cfd110$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $5abb203460cfd110$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $5abb203460cfd110$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $5abb203460cfd110$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $5abb203460cfd110$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $5abb203460cfd110$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $5abb203460cfd110$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $5abb203460cfd110$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($5abb203460cfd110$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$5abb203460cfd110$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $5abb203460cfd110$var$regexSafe(this.escape(val)) : $5abb203460cfd110$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $5abb203460cfd110$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$5abb203460cfd110$var$isString(value) && !this.useRawValueToEscape) value = $5abb203460cfd110$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$5abb203460cfd110$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$5abb203460cfd110$var$isString(value)) return value;
            if (!$5abb203460cfd110$var$isString(value)) value = $5abb203460cfd110$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $5abb203460cfd110$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $5abb203460cfd110$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($5abb203460cfd110$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $5abb203460cfd110$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($5abb203460cfd110$var$getCleanedCode(l), o)(v);
class $5abb203460cfd110$var$Formatter {
    constructor(options = {}){
        this.logger = $5abb203460cfd110$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $5abb203460cfd110$var$createCachedFormatter : $5abb203460cfd110$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $5abb203460cfd110$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $5abb203460cfd110$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $5abb203460cfd110$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $5abb203460cfd110$var$Connector extends $5abb203460cfd110$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $5abb203460cfd110$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $5abb203460cfd110$var$pushPath(q.loaded, [
                lng
            ], ns);
            $5abb203460cfd110$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($5abb203460cfd110$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($5abb203460cfd110$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $5abb203460cfd110$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($5abb203460cfd110$var$isString(args[1])) ret.defaultValue = args[1];
            if ($5abb203460cfd110$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $5abb203460cfd110$var$transformOptions = (options)=>{
    if ($5abb203460cfd110$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($5abb203460cfd110$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($5abb203460cfd110$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $5abb203460cfd110$var$noop = ()=>{};
const $5abb203460cfd110$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $5abb203460cfd110$var$I18n extends $5abb203460cfd110$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $5abb203460cfd110$var$transformOptions(options);
        this.services = {};
        this.logger = $5abb203460cfd110$var$baseLogger;
        this.modules = {
            external: []
        };
        $5abb203460cfd110$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($5abb203460cfd110$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $5abb203460cfd110$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$5abb203460cfd110$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $5abb203460cfd110$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $5abb203460cfd110$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $5abb203460cfd110$var$Formatter;
            const lu = new $5abb203460cfd110$var$LanguageUtil(this.options);
            this.store = new $5abb203460cfd110$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $5abb203460cfd110$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $5abb203460cfd110$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $5abb203460cfd110$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $5abb203460cfd110$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $5abb203460cfd110$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $5abb203460cfd110$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $5abb203460cfd110$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $5abb203460cfd110$var$noop) {
        let usedCallback = callback;
        const usedLng = $5abb203460cfd110$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $5abb203460cfd110$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $5abb203460cfd110$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $5abb203460cfd110$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $5abb203460cfd110$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $5abb203460cfd110$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($5abb203460cfd110$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $5abb203460cfd110$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $5abb203460cfd110$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($5abb203460cfd110$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $5abb203460cfd110$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($5abb203460cfd110$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $5abb203460cfd110$var$defer();
        if ($5abb203460cfd110$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $5abb203460cfd110$var$LanguageUtil($5abb203460cfd110$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $5abb203460cfd110$var$I18n(options, callback);
        instance.createInstance = $5abb203460cfd110$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $5abb203460cfd110$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $5abb203460cfd110$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $5abb203460cfd110$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) clone.services.interpolator = new $5abb203460cfd110$var$Interpolator(mergedOptions);
        clone.translator = new $5abb203460cfd110$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $5abb203460cfd110$export$2e2bcd8739ae039 = $5abb203460cfd110$var$I18n.createInstance();
const $5abb203460cfd110$export$99152e8d49ca4e7d = $5abb203460cfd110$export$2e2bcd8739ae039.createInstance;
const $5abb203460cfd110$export$147ec2801e896265 = $5abb203460cfd110$export$2e2bcd8739ae039.dir;
const $5abb203460cfd110$export$2cd8252107eb640b = $5abb203460cfd110$export$2e2bcd8739ae039.init;
const $5abb203460cfd110$export$d3d08d944062d7e = $5abb203460cfd110$export$2e2bcd8739ae039.loadResources;
const $5abb203460cfd110$export$a5d9bf5d83fcab09 = $5abb203460cfd110$export$2e2bcd8739ae039.reloadResources;
const $5abb203460cfd110$export$1f96ae73734a86cc = $5abb203460cfd110$export$2e2bcd8739ae039.use;
const $5abb203460cfd110$export$61465194746e7fd2 = $5abb203460cfd110$export$2e2bcd8739ae039.changeLanguage;
const $5abb203460cfd110$export$f90d180fc7da3b3b = $5abb203460cfd110$export$2e2bcd8739ae039.getFixedT;
const $5abb203460cfd110$export$625550452a3fa3ec = $5abb203460cfd110$export$2e2bcd8739ae039.t;
const $5abb203460cfd110$export$f7e9f41ea797a17 = $5abb203460cfd110$export$2e2bcd8739ae039.exists;
const $5abb203460cfd110$export$2b4b218e406d2d00 = $5abb203460cfd110$export$2e2bcd8739ae039.setDefaultNamespace;
const $5abb203460cfd110$export$93d9ee97c1ad3f31 = $5abb203460cfd110$export$2e2bcd8739ae039.hasLoadedNamespace;
const $5abb203460cfd110$export$83be934b53fff43b = $5abb203460cfd110$export$2e2bcd8739ae039.loadNamespaces;
const $5abb203460cfd110$export$8cd7e7a54fa865bc = $5abb203460cfd110$export$2e2bcd8739ae039.loadLanguages;


var $0e3b0f6e50344df5$var$data$D = {
    PH: [
        {
            name: "A\xf1o Nuevo",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Carnaval",
            variable_date: "easter",
            offset: -48
        },
        {
            name: "Carnaval",
            variable_date: "easter",
            offset: -47
        },
        {
            name: "D\xeda Nacional de la Memoria por la Verdad y la Justicia",
            fixed_date: [
                3,
                24
            ]
        },
        {
            name: "Viernes Santo",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Feriado con fines tur\xedsticos",
            fixed_date: [
                4,
                1
            ]
        },
        {
            name: "D\xeda del Veterano y de los Ca\xeddos en la Guerra de Malvinas",
            fixed_date: [
                4,
                2
            ]
        },
        {
            name: "D\xeda del Trabajador",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "D\xeda de la Revoluci\xf3n de Mayo",
            fixed_date: [
                5,
                25
            ]
        },
        {
            name: "Paso a la Inmortalidad del Gral. Don Mart\xedn Miguel de G\xfcemes",
            fixed_date: [
                6,
                17
            ]
        },
        {
            name: "Paso a la Inmortalidad del General Manuel Belgrano",
            fixed_date: [
                6,
                20
            ]
        },
        {
            name: "Feriado con fines tur\xedsticos",
            fixed_date: [
                6,
                21
            ]
        },
        {
            name: "D\xeda de la Independencia",
            fixed_date: [
                7,
                9
            ]
        },
        {
            name: "Paso a la Inmortalidad del Gral. Jos\xe9 de San Mart\xedn",
            fixed_date: [
                8,
                17
            ]
        },
        {
            name: "Feriado con fines tur\xedsticos",
            fixed_date: [
                10,
                11
            ]
        },
        {
            name: "D\xeda del Respeto a la Diversidad Cultural",
            fixed_date: [
                10,
                12
            ]
        },
        {
            name: "D\xeda de la Soberan\xeda Nacional",
            fixed_date: [
                11,
                18
            ]
        },
        {
            name: "Inmaculada Concepci\xf3n de Mar\xeda",
            fixed_date: [
                12,
                8
            ]
        },
        {
            name: "Navidad",
            fixed_date: [
                12,
                25
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$D.PH;
var $0e3b0f6e50344df5$var$data$C = {
    PH: [
        {
            name: "Neujahrstag",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Heilige Drei K\xf6nige",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "Ostermontag",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Staatsfeiertag",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Christi Himmelfahrt",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pfingstmontag",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Fronleichnam",
            variable_date: "easter",
            offset: 60
        },
        {
            name: "Mari\xe4 Himmelfahrt",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Nationalfeiertag",
            fixed_date: [
                10,
                26
            ]
        },
        {
            name: "Allerheiligen",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Mari\xe4 Empf\xe4ngnis",
            fixed_date: [
                12,
                8
            ]
        },
        {
            name: "Christtag",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Stefanitag",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2017: [
                4,
                8,
                4,
                18
            ],
            2018: [
                3,
                24,
                4,
                3
            ],
            2019: [
                4,
                13,
                4,
                23
            ],
            2020: [
                4,
                4,
                4,
                14
            ],
            2021: [
                3,
                27,
                4,
                5
            ],
            2022: [
                4,
                9,
                4,
                18
            ],
            2023: [
                4,
                1,
                4,
                10
            ],
            2024: [
                3,
                23,
                4,
                1
            ],
            2025: [
                4,
                12,
                4,
                21
            ],
            2026: [
                3,
                28,
                4,
                6
            ],
            name: "Osterferien"
        },
        {
            2017: [
                6,
                3,
                6,
                6
            ],
            2018: [
                5,
                19,
                5,
                22
            ],
            2019: [
                6,
                8,
                6,
                11
            ],
            2020: [
                5,
                30,
                6,
                2
            ],
            2021: [
                5,
                22,
                5,
                24
            ],
            2022: [
                6,
                4,
                6,
                6
            ],
            2023: [
                5,
                27,
                5,
                29
            ],
            2024: [
                5,
                18,
                5,
                20
            ],
            2025: [
                6,
                7,
                6,
                9
            ],
            2026: [
                5,
                23,
                5,
                25
            ],
            name: "Pfingstferien"
        },
        {
            2021: [
                10,
                27,
                10,
                31
            ],
            2022: [
                10,
                27,
                10,
                31
            ],
            2023: [
                10,
                27,
                10,
                31
            ],
            2024: [
                10,
                28,
                10,
                31
            ],
            2025: [
                10,
                27,
                10,
                31
            ],
            2026: [
                10,
                27,
                10,
                31
            ],
            name: "Herbstferien"
        },
        {
            2016: [
                11,
                2
            ],
            2017: [
                11,
                2
            ],
            2018: [
                11,
                2
            ],
            2019: [
                11,
                2
            ],
            2020: [
                11,
                2
            ],
            2021: [
                11,
                2
            ],
            2022: [
                11,
                2
            ],
            2023: [
                11,
                2
            ],
            2024: [
                11,
                2
            ],
            2025: [
                11,
                2
            ],
            2026: [
                11,
                2
            ],
            name: "Allerseelen"
        },
        {
            2016: [
                12,
                24,
                1,
                7
            ],
            2017: [
                12,
                24,
                1,
                6
            ],
            2018: [
                12,
                24,
                1,
                6
            ],
            2019: [
                12,
                23,
                1,
                6
            ],
            2020: [
                12,
                24,
                1,
                6
            ],
            2021: [
                12,
                24,
                1,
                6
            ],
            2022: [
                12,
                24,
                1,
                6
            ],
            2023: [
                12,
                23,
                1,
                6
            ],
            2024: [
                12,
                23,
                1,
                6
            ],
            2025: [
                12,
                24,
                1,
                6
            ],
            2026: [
                12,
                24,
                1,
                6
            ],
            name: "Weihnachtsferien"
        }
    ],
    Burgenland: {
        _state_code: 1,
        SH: [
            {
                2016: [
                    2,
                    8,
                    2,
                    13
                ],
                2017: [
                    2,
                    13,
                    2,
                    18
                ],
                2018: [
                    2,
                    12,
                    2,
                    17
                ],
                2019: [
                    2,
                    11,
                    2,
                    16
                ],
                2020: [
                    2,
                    10,
                    2,
                    15
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    14,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    18
                ],
                2024: [
                    2,
                    12,
                    2,
                    17
                ],
                2025: [
                    2,
                    10,
                    2,
                    15
                ],
                2026: [
                    2,
                    9,
                    2,
                    14
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    2,
                    9,
                    3
                ],
                2017: [
                    7,
                    1,
                    9,
                    3
                ],
                2018: [
                    6,
                    30,
                    9,
                    2
                ],
                2019: [
                    6,
                    29,
                    9,
                    1
                ],
                2020: [
                    7,
                    4,
                    9,
                    6
                ],
                2021: [
                    7,
                    3,
                    9,
                    5
                ],
                2022: [
                    7,
                    2,
                    9,
                    4
                ],
                2023: [
                    7,
                    1,
                    9,
                    3
                ],
                2024: [
                    6,
                    29,
                    9,
                    1
                ],
                2025: [
                    6,
                    28,
                    8,
                    31
                ],
                2026: [
                    7,
                    4,
                    9,
                    6
                ],
                name: "Sommerferien"
            }
        ]
    },
    "K\xe4rnten": {
        _state_code: 2,
        SH: [
            {
                2016: [
                    2,
                    8,
                    2,
                    13
                ],
                2017: [
                    2,
                    13,
                    2,
                    18
                ],
                2018: [
                    2,
                    12,
                    2,
                    17
                ],
                2019: [
                    2,
                    11,
                    2,
                    16
                ],
                2020: [
                    2,
                    10,
                    2,
                    15
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    14,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    18
                ],
                2024: [
                    2,
                    12,
                    2,
                    17
                ],
                2025: [
                    2,
                    10,
                    2,
                    15
                ],
                2026: [
                    2,
                    9,
                    2,
                    14
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    "Nieder\xf6sterreich": {
        _state_code: 3,
        SH: [
            {
                2016: [
                    2,
                    1,
                    2,
                    6
                ],
                2017: [
                    2,
                    6,
                    2,
                    11
                ],
                2018: [
                    2,
                    5,
                    2,
                    10
                ],
                2019: [
                    2,
                    4,
                    2,
                    9
                ],
                2020: [
                    2,
                    3,
                    2,
                    8
                ],
                2021: [
                    2,
                    1,
                    2,
                    6
                ],
                2022: [
                    2,
                    7,
                    2,
                    12
                ],
                2023: [
                    2,
                    6,
                    2,
                    11
                ],
                2024: [
                    2,
                    5,
                    2,
                    10
                ],
                2025: [
                    2,
                    3,
                    2,
                    8
                ],
                2026: [
                    2,
                    2,
                    2,
                    7
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    2,
                    9,
                    3
                ],
                2017: [
                    7,
                    1,
                    9,
                    3
                ],
                2018: [
                    6,
                    30,
                    9,
                    2
                ],
                2019: [
                    6,
                    29,
                    9,
                    1
                ],
                2020: [
                    7,
                    4,
                    9,
                    6
                ],
                2021: [
                    7,
                    3,
                    9,
                    5
                ],
                2022: [
                    7,
                    2,
                    9,
                    4
                ],
                2023: [
                    7,
                    1,
                    9,
                    3
                ],
                2024: [
                    6,
                    29,
                    9,
                    1
                ],
                2025: [
                    6,
                    28,
                    8,
                    31
                ],
                2026: [
                    7,
                    4,
                    9,
                    6
                ],
                name: "Sommerferien"
            }
        ]
    },
    "Ober\xf6sterreich": {
        _state_code: 4,
        SH: [
            {
                2016: [
                    2,
                    15,
                    2,
                    20
                ],
                2017: [
                    2,
                    20,
                    2,
                    25
                ],
                2018: [
                    2,
                    19,
                    2,
                    24
                ],
                2019: [
                    2,
                    18,
                    2,
                    23
                ],
                2020: [
                    2,
                    17,
                    2,
                    22
                ],
                2021: [
                    2,
                    15,
                    2,
                    20
                ],
                2022: [
                    2,
                    21,
                    2,
                    26
                ],
                2023: [
                    2,
                    20,
                    2,
                    25
                ],
                2024: [
                    2,
                    19,
                    2,
                    24
                ],
                2025: [
                    2,
                    17,
                    2,
                    22
                ],
                2026: [
                    2,
                    16,
                    2,
                    21
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    Salzburg: {
        _state_code: 5,
        SH: [
            {
                2016: [
                    2,
                    8,
                    2,
                    13
                ],
                2017: [
                    2,
                    13,
                    2,
                    18
                ],
                2018: [
                    2,
                    12,
                    2,
                    17
                ],
                2019: [
                    2,
                    11,
                    2,
                    16
                ],
                2020: [
                    2,
                    10,
                    2,
                    15
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    14,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    18
                ],
                2024: [
                    2,
                    12,
                    2,
                    17
                ],
                2025: [
                    2,
                    10,
                    2,
                    15
                ],
                2026: [
                    2,
                    9,
                    2,
                    14
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    Steiermark: {
        _state_code: 6,
        SH: [
            {
                2016: [
                    2,
                    15,
                    2,
                    20
                ],
                2017: [
                    2,
                    20,
                    2,
                    25
                ],
                2018: [
                    2,
                    19,
                    2,
                    24
                ],
                2019: [
                    2,
                    18,
                    2,
                    23
                ],
                2020: [
                    2,
                    17,
                    2,
                    22
                ],
                2021: [
                    2,
                    15,
                    2,
                    20
                ],
                2022: [
                    2,
                    21,
                    2,
                    26
                ],
                2023: [
                    2,
                    20,
                    2,
                    25
                ],
                2024: [
                    2,
                    19,
                    2,
                    24
                ],
                2025: [
                    2,
                    17,
                    2,
                    22
                ],
                2026: [
                    2,
                    16,
                    2,
                    21
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    Tirol: {
        _state_code: 7,
        SH: [
            {
                2016: [
                    2,
                    8,
                    2,
                    13
                ],
                2017: [
                    2,
                    13,
                    2,
                    18
                ],
                2018: [
                    2,
                    12,
                    2,
                    17
                ],
                2019: [
                    2,
                    11,
                    2,
                    16
                ],
                2020: [
                    2,
                    10,
                    2,
                    15
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    14,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    18
                ],
                2024: [
                    2,
                    12,
                    2,
                    17
                ],
                2025: [
                    2,
                    10,
                    2,
                    15
                ],
                2026: [
                    2,
                    9,
                    2,
                    14
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    Vorarlberg: {
        _state_code: 8,
        SH: [
            {
                2016: [
                    2,
                    15,
                    2,
                    20
                ],
                2017: [
                    2,
                    13,
                    2,
                    18
                ],
                2018: [
                    2,
                    5,
                    2,
                    10
                ],
                2019: [
                    2,
                    11,
                    2,
                    16
                ],
                2020: [
                    2,
                    10,
                    2,
                    15
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    14,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    18
                ],
                2024: [
                    2,
                    5,
                    2,
                    10
                ],
                2025: [
                    2,
                    10,
                    2,
                    15
                ],
                2026: [
                    2,
                    9,
                    2,
                    14
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    9,
                    9,
                    10
                ],
                2017: [
                    7,
                    8,
                    9,
                    10
                ],
                2018: [
                    7,
                    7,
                    9,
                    9
                ],
                2019: [
                    7,
                    6,
                    9,
                    8
                ],
                2020: [
                    7,
                    11,
                    9,
                    13
                ],
                2021: [
                    7,
                    10,
                    9,
                    12
                ],
                2022: [
                    7,
                    9,
                    9,
                    11
                ],
                2023: [
                    7,
                    8,
                    9,
                    10
                ],
                2024: [
                    7,
                    6,
                    9,
                    8
                ],
                2025: [
                    7,
                    5,
                    9,
                    7
                ],
                2026: [
                    7,
                    11,
                    9,
                    13
                ],
                name: "Sommerferien"
            }
        ]
    },
    Wien: {
        _state_code: 9,
        SH: [
            {
                2016: [
                    2,
                    1,
                    2,
                    6
                ],
                2017: [
                    2,
                    6,
                    2,
                    11
                ],
                2018: [
                    2,
                    5,
                    2,
                    10
                ],
                2019: [
                    2,
                    4,
                    2,
                    9
                ],
                2020: [
                    2,
                    3,
                    2,
                    8
                ],
                2021: [
                    2,
                    1,
                    2,
                    6
                ],
                2022: [
                    2,
                    7,
                    2,
                    12
                ],
                2023: [
                    2,
                    6,
                    2,
                    11
                ],
                2024: [
                    2,
                    5,
                    2,
                    10
                ],
                2025: [
                    2,
                    3,
                    2,
                    8
                ],
                2026: [
                    2,
                    2,
                    2,
                    7
                ],
                name: "Semesterferien"
            },
            {
                2016: [
                    7,
                    2,
                    9,
                    3
                ],
                2017: [
                    7,
                    1,
                    9,
                    3
                ],
                2018: [
                    6,
                    30,
                    9,
                    2
                ],
                2019: [
                    6,
                    29,
                    9,
                    1
                ],
                2020: [
                    7,
                    4,
                    9,
                    6
                ],
                2021: [
                    7,
                    3,
                    9,
                    5
                ],
                2022: [
                    7,
                    2,
                    9,
                    4
                ],
                2023: [
                    7,
                    1,
                    9,
                    3
                ],
                2024: [
                    6,
                    29,
                    9,
                    1
                ],
                2025: [
                    6,
                    28,
                    8,
                    31
                ],
                2026: [
                    7,
                    4,
                    9,
                    6
                ],
                name: "Sommerferien"
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$C.PH;
$0e3b0f6e50344df5$var$data$C.SH;
$0e3b0f6e50344df5$var$data$C.Burgenland;
$0e3b0f6e50344df5$var$data$C.Salzburg;
$0e3b0f6e50344df5$var$data$C.Steiermark;
$0e3b0f6e50344df5$var$data$C.Tirol;
$0e3b0f6e50344df5$var$data$C.Vorarlberg;
$0e3b0f6e50344df5$var$data$C.Wien;
var $0e3b0f6e50344df5$var$data$B = {
    PH: [
        {
            name: "New Years Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Australia Day",
            fixed_date: [
                1,
                26
            ]
        },
        {
            name: "Good Friday",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Easter Monday",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "ANZAC Day",
            fixed_date: [
                4,
                25
            ]
        },
        {
            name: "Christmas Day",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Boxing Day",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    "Australian Capital Territory": {
        _state_code: "act",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Canberra Day",
                variable_date: "firstMarchMonday",
                offset: 7
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Sunday",
                variable_date: "easter"
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Reconciliation Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "Family and Community Day",
                variable_date: "lastSeptemberMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstOctoberMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "New South Wales": {
        _state_code: "nsw",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Sunday",
                variable_date: "easter"
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "Labour Day",
                variable_date: "firstOctoberMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "Northern Territory": {
        _state_code: "nt",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "May Day",
                variable_date: "firstMayMonday"
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "Picnic Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Queensland: {
        _state_code: "qld",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Labour Day",
                variable_date: "firstMayMonday"
            },
            {
                name: "Queens Birthday",
                variable_date: "firstOctoberMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "South Australia": {
        _state_code: "sa",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Adelaide Cup",
                variable_date: "firstMarchMonday",
                offset: 7
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "Labour Day",
                variable_date: "firstOctoberMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Tasmania: {
        _state_code: "tas",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Eight Hours Day",
                variable_date: "firstMarchMonday",
                offset: 7
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Victoria: {
        _state_code: "vic",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Labour Day",
                variable_date: "firstMarchMonday",
                offset: 7
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Saturday",
                variable_date: "easter",
                offset: -1
            },
            {
                name: "Easter Sunday",
                variable_date: "easter"
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Queens Birthday",
                variable_date: "firstJuneMonday",
                offset: 7
            },
            {
                name: "AFL Grand Final",
                variable_date: "lastSeptemberFriday"
            },
            {
                name: "Melbourne Cup",
                variable_date: "firstNovemberTuesday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "Western Australia": {
        _state_code: "wa",
        PH: [
            {
                name: "New Years Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Australia Day",
                fixed_date: [
                    1,
                    26
                ]
            },
            {
                name: "Labour Day",
                variable_date: "firstMarchMonday"
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "ANZAC Day",
                fixed_date: [
                    4,
                    25
                ]
            },
            {
                name: "Western Australia Day",
                variable_date: "firstJuneMonday"
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$B.PH;
$0e3b0f6e50344df5$var$data$B.Queensland;
$0e3b0f6e50344df5$var$data$B.Tasmania;
$0e3b0f6e50344df5$var$data$B.Victoria;
var $0e3b0f6e50344df5$var$data$A = {
    PH: [
        {
            name: "Nieuwjaar - Jour de l'an",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Paasmaandag - Lundi de P\xe2ques",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Dag van de Arbeid - F\xeate du Travail",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Onze-Lieve-Heer-Hemelvaart - Jeudi de l'Ascensionn",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pinkstermaandag - Lundi de Pentec\xf4te",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Nationale feestdag van Belgi\xeb - F\xeate nationale",
            fixed_date: [
                7,
                21
            ]
        },
        {
            name: "Onze-Lieve-Vrouw-Hemelvaart - Assomption",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Allerheiligen - Toussaint",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Wapenstilstand - Armistice",
            fixed_date: [
                11,
                11
            ]
        },
        {
            name: "Kerstmis - No\xebl",
            fixed_date: [
                12,
                25
            ]
        }
    ],
    SH: [
        {
            2020: [
                2,
                24,
                3,
                1
            ],
            2021: [
                2,
                15,
                2,
                21
            ],
            2022: [
                2,
                28,
                3,
                6
            ],
            2023: [
                2,
                20,
                2,
                26
            ],
            2024: [
                2,
                12,
                2,
                18
            ],
            2025: [
                3,
                3,
                3,
                9
            ],
            2026: [
                2,
                16,
                2,
                22
            ],
            2027: [
                2,
                8,
                2,
                14
            ],
            2028: [
                2,
                28,
                3,
                5
            ],
            2029: [
                2,
                12,
                2,
                18
            ],
            name: "Krokusvakantie - Vacances de carnaval"
        },
        {
            2020: [
                4,
                6,
                4,
                19
            ],
            2021: [
                4,
                5,
                4,
                18
            ],
            2022: [
                4,
                4,
                4,
                18
            ],
            2023: [
                4,
                3,
                4,
                16
            ],
            2024: [
                4,
                1,
                4,
                14
            ],
            2025: [
                4,
                7,
                4,
                21
            ],
            2026: [
                4,
                6,
                4,
                19
            ],
            2027: [
                3,
                29,
                4,
                11
            ],
            2028: [
                4,
                3,
                4,
                17
            ],
            2029: [
                4,
                2,
                4,
                15
            ],
            name: "Paasvakantie - Vacances de p\xe2ques"
        },
        {
            2020: [
                7,
                1,
                8,
                31
            ],
            2021: [
                7,
                1,
                8,
                31
            ],
            2022: [
                7,
                1,
                8,
                31
            ],
            2023: [
                7,
                1,
                8,
                31
            ],
            2024: [
                7,
                1,
                8,
                31
            ],
            2025: [
                7,
                1,
                8,
                31
            ],
            2026: [
                7,
                1,
                8,
                31
            ],
            2027: [
                7,
                1,
                8,
                31
            ],
            2028: [
                7,
                1,
                8,
                31
            ],
            2029: [
                7,
                1,
                8,
                31
            ],
            name: "Zomervakantie - Vacances d'\xe9t\xe9"
        },
        {
            2019: [
                10,
                28,
                11,
                3
            ],
            2020: [
                11,
                2,
                11,
                15
            ],
            2021: [
                11,
                1,
                11,
                7
            ],
            2022: [
                10,
                31,
                11,
                6
            ],
            2023: [
                10,
                30,
                11,
                5
            ],
            2024: [
                10,
                28,
                11,
                3
            ],
            2025: [
                10,
                27,
                11,
                2
            ],
            2026: [
                11,
                2,
                11,
                8
            ],
            2027: [
                11,
                1,
                11,
                7
            ],
            2028: [
                10,
                30,
                11,
                5
            ],
            name: "Herfstvakantie - Vacances automne"
        },
        {
            2019: [
                12,
                23,
                1,
                5
            ],
            2020: [
                12,
                21,
                1,
                3
            ],
            2021: [
                12,
                27,
                1,
                9
            ],
            2022: [
                12,
                26,
                1,
                8
            ],
            2023: [
                12,
                25,
                1,
                7
            ],
            2024: [
                12,
                23,
                1,
                5
            ],
            2025: [
                12,
                22,
                1,
                4
            ],
            2026: [
                12,
                21,
                1,
                3
            ],
            2027: [
                12,
                27,
                1,
                9
            ],
            2028: [
                12,
                25,
                1,
                7
            ],
            name: "Kerstvakantie - Vacances de No\xebl"
        }
    ]
};
$0e3b0f6e50344df5$var$data$A.PH;
$0e3b0f6e50344df5$var$data$A.SH;
var $0e3b0f6e50344df5$var$data$z = {
    PH: [
        {
            name: "Ano Novo",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Carnaval",
            variable_date: "easter",
            offset: -47
        },
        {
            name: "Sexta-feira santa",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Tiradentes",
            fixed_date: [
                4,
                21
            ]
        },
        {
            name: "Dia do Trabalhador",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Corpus Christi",
            variable_date: "easter",
            offset: 60
        },
        {
            name: "Independ\xeancia",
            fixed_date: [
                9,
                7
            ]
        },
        {
            name: "Nossa Senhora Aparecida",
            fixed_date: [
                10,
                12
            ]
        },
        {
            name: "Finados",
            fixed_date: [
                11,
                2
            ]
        },
        {
            name: "Proclama\xe7\xe3o da Rep\xfablica",
            fixed_date: [
                11,
                15
            ]
        },
        {
            name: "Natal",
            fixed_date: [
                12,
                25
            ]
        }
    ],
    Acre: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Dia do evang\xe9lico",
                fixed_date: [
                    1,
                    23
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Alusivo ao Dia Internacional da Mulher",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Anivers\xe1rio do estado",
                fixed_date: [
                    6,
                    15
                ]
            },
            {
                name: "Dia da Amaz\xf4nia",
                fixed_date: [
                    9,
                    5
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Assinatura do Tratado de Petr\xf3polis",
                fixed_date: [
                    11,
                    17
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Alagoas: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "S\xe3o Jo\xe3o",
                fixed_date: [
                    6,
                    24
                ]
            },
            {
                name: "S\xe3o Pedro",
                fixed_date: [
                    6,
                    29
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Emancipa\xe7\xe3o pol\xedtica",
                fixed_date: [
                    9,
                    16
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Morte de Zumbi dos Palmares",
                fixed_date: [
                    11,
                    20
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Amap\xe1": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Dia de S\xe3o Jos\xe9",
                fixed_date: [
                    3,
                    19
                ]
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Data Magna do estado",
                fixed_date: [
                    9,
                    13
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Amazonas: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data Magna do estado",
                fixed_date: [
                    9,
                    5
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Dia da Consci\xeancia Negra",
                fixed_date: [
                    11,
                    20
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Bahia: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    2,
                    7
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Cear\xe1": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    3,
                    25
                ]
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Distrito Federal": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Dia do evang\xe9lico",
                fixed_date: [
                    11,
                    30
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Esp\xedrito Santo": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Goi\xe1s": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Maranh\xe3o": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Mato Grosso": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Dia da Consci\xeancia Negra",
                fixed_date: [
                    11,
                    20
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Mato Grosso do Sul": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Cria\xe7\xe3o do estado",
                fixed_date: [
                    10,
                    11
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Minas Gerais": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Par\xe1": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    8,
                    15
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Para\xedba": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Homenagem a Jo\xe3o Pessoa",
                fixed_date: [
                    7,
                    26
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    8,
                    5
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Paran\xe1": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    12,
                    19
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Pernambuco: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Data magna do estado",
                variable_date: "firstMarchSunday"
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Piau\xed": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    10,
                    19
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Rio de Janeiro": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Dia da Consci\xeancia Negra",
                fixed_date: [
                    11,
                    20
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Rio Grande do Norte": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "S\xe3o Jorge",
                fixed_date: [
                    4,
                    23
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "M\xe1rtires de Cunha\xfa e Urua\xe7u",
                fixed_date: [
                    10,
                    3
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Rio Grande do Sul": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica Rio-Grandense",
                fixed_date: [
                    9,
                    20
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Rond\xf4nia": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Dia do evang\xe9lico",
                fixed_date: [
                    6,
                    18
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Roraima: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    10,
                    5
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Santa Catarina": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    8,
                    11
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Santa Catarina de Alexandria",
                fixed_date: [
                    11,
                    25
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "S\xe3o Paulo": {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    7,
                    9
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Sergipe: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Anivers\xe1rio de Aracaju",
                fixed_date: [
                    3,
                    17
                ]
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "S\xe3o Jo\xe3o",
                fixed_date: [
                    6,
                    24
                ]
            },
            {
                name: "Data magna do estado",
                fixed_date: [
                    7,
                    8
                ]
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Nossa Senhora da Concei\xe7\xe3o",
                fixed_date: [
                    12,
                    8
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Tocantins: {
        PH: [
            {
                name: "Ano Novo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Carnaval",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Autonomia do estado",
                fixed_date: [
                    3,
                    18
                ]
            },
            {
                name: "Sexta-feira santa",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Tiradentes",
                fixed_date: [
                    4,
                    21
                ]
            },
            {
                name: "Dia do Trabalhador",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "Corpus Christi",
                variable_date: "easter",
                offset: 60
            },
            {
                name: "Independ\xeancia",
                fixed_date: [
                    9,
                    7
                ]
            },
            {
                name: "Nossa Senhora da Natividade",
                fixed_date: [
                    9,
                    8
                ]
            },
            {
                name: "Cria\xe7\xe3o do estado",
                fixed_date: [
                    10,
                    5
                ]
            },
            {
                name: "Nossa Senhora Aparecida",
                fixed_date: [
                    10,
                    12
                ]
            },
            {
                name: "Finados",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Proclama\xe7\xe3o da Rep\xfablica",
                fixed_date: [
                    11,
                    15
                ]
            },
            {
                name: "Natal",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$z.PH;
$0e3b0f6e50344df5$var$data$z.Acre;
$0e3b0f6e50344df5$var$data$z.Alagoas;
$0e3b0f6e50344df5$var$data$z.Amazonas;
$0e3b0f6e50344df5$var$data$z.Bahia;
$0e3b0f6e50344df5$var$data$z.Pernambuco;
$0e3b0f6e50344df5$var$data$z.Roraima;
$0e3b0f6e50344df5$var$data$z.Sergipe;
$0e3b0f6e50344df5$var$data$z.Tocantins;
var $0e3b0f6e50344df5$var$data$y = {
    PH: [
        {
            name: "New Year's Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Good Friday",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Canada Day",
            variable_date: "canadaDay"
        },
        {
            name: "Labour Day",
            variable_date: "firstSeptemberMonday"
        },
        {
            name: "Christmas Day",
            fixed_date: [
                12,
                25
            ]
        }
    ],
    Alberta: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Alberta Family Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Heritage Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "British Columbia": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Family Day",
                variable_date: "firstFebruaryMonday",
                offset: 7
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "British Columbia Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Manitoba: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Louis Riel Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Civic Holiday",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "New Brunswick": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "New Brunswick Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "Newfoundland and Labrador": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Saint Patrick's Day",
                fixed_date: [
                    3,
                    17
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Saint George's Day",
                fixed_date: [
                    4,
                    23
                ]
            },
            {
                name: "Discovery Day",
                fixed_date: [
                    6,
                    24
                ]
            },
            {
                name: "Memorial Day",
                fixed_date: [
                    7,
                    1
                ]
            },
            {
                name: "Orangemen's Day",
                fixed_date: [
                    7,
                    12
                ]
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Armistice Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Northwest Territories": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "National Aboriginal Day",
                fixed_date: [
                    6,
                    21
                ]
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Civic Holiday",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Nova Scotia": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Natal Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Nunavut: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Nunavut Day",
                fixed_date: [
                    7,
                    9
                ]
            },
            {
                name: "Civic Holiday",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Ontario: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Family Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "August Civic Public Holiday",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "Prince Edward Island": {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Islander Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Civic Holiday",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Gold Cup Parade Day",
                variable_date: "firstAugustMonday",
                offset: 18
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Quebec: {
        PH: [
            {
                name: "Jour de l'an",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Vendredi saint",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Lundi de P\xe2ques",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Journ\xe9e nationale des patriotes",
                variable_date: "victoriaDay"
            },
            {
                name: "F\xeate nationale du Qu\xe9bec",
                fixed_date: [
                    6,
                    24
                ]
            },
            {
                name: "F\xeate du Canada",
                variable_date: "canadaDay"
            },
            {
                name: "F\xeate du Travail",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Jour de l'Action de gr\xe2ce",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "No\xebl",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Saskatchewan: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Family Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Saskatchewan Day",
                variable_date: "firstAugustMonday"
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Yukon: {
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Heritage Day",
                variable_date: "lastFebruarySunday",
                offset: -2
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Victoria Day",
                variable_date: "victoriaDay"
            },
            {
                name: "Canada Day",
                variable_date: "canadaDay"
            },
            {
                name: "Discovery Day",
                variable_date: "firstAugustMonday",
                offset: 14
            },
            {
                name: "Labour Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Thanksgiving",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Remembrance Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$y.PH;
$0e3b0f6e50344df5$var$data$y.Alberta;
$0e3b0f6e50344df5$var$data$y.Manitoba;
$0e3b0f6e50344df5$var$data$y.Nunavut;
$0e3b0f6e50344df5$var$data$y.Ontario;
$0e3b0f6e50344df5$var$data$y.Quebec;
$0e3b0f6e50344df5$var$data$y.Saskatchewan;
$0e3b0f6e50344df5$var$data$y.Yukon;
var $0e3b0f6e50344df5$var$data$x = {
    PH: [
        {
            name: "Neujahrstag/Nouvel an/Capo d'anno",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Berchtoldstag/2 janvier",
            fixed_date: [
                1,
                2
            ],
            only_states: [
                "Z\xfcrich",
                "Bern",
                "Luzern",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Schaffhausen",
                "Graub\xfcnden",
                "Aargau",
                "Thurgau",
                "Waadt",
                "Neuenburg",
                "Genf",
                "Jura",
                "Sankt Gallen",
                "Wallis"
            ]
        },
        {
            name: "Heilige Drei K\xf6nige/Epifania",
            fixed_date: [
                1,
                6
            ],
            only_states: [
                "Uri",
                "Schwyz",
                "Graub\xfcnden",
                "Tessin"
            ]
        },
        {
            name: "Instauration de la R\xe9publique",
            fixed_date: [
                3,
                1
            ],
            only_states: [
                "Neuenburg"
            ]
        },
        {
            name: "Josefstag/Saint-Joseph/San Giuseppe",
            fixed_date: [
                3,
                19
            ],
            only_states: [
                "Luzern",
                "Uri",
                "Schwyz",
                "Nidwalden",
                "Zug",
                "Graub\xfcnden",
                "Tessin",
                "Wallis"
            ]
        },
        {
            name: "Karfreitag/Vendredi saint",
            variable_date: "easter",
            offset: -2,
            only_states: [
                "Z\xfcrich",
                "Bern",
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Stadt",
                "Basel-Landschaft",
                "Schaffhausen",
                "Appenzell Ausserrhoden",
                "Appenzell Innerrhoden",
                "Sankt Gallen",
                "Graub\xfcnden",
                "Aargau",
                "Thurgau",
                "Waadt",
                "Neuenburg",
                "Genf",
                "Jura"
            ]
        },
        {
            name: "Ostermontag/Lundi de P\xe2ques/Lunedi di Pasqua",
            variable_date: "easter",
            offset: 1,
            only_states: [
                "Z\xfcrich",
                "Bern",
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Stadt",
                "Basel-Landschaft",
                "Schaffhausen",
                "Appenzell Ausserrhoden",
                "Appenzell Innerrhoden",
                "Sankt Gallen",
                "Graub\xfcnden",
                "Aargau",
                "Thurgau",
                "Tessin",
                "Waadt",
                "Neuenburg",
                "Genf",
                "Jura",
                "Wallis"
            ]
        },
        {
            name: "Tag der Arbeit/Festa dei lavoratori",
            fixed_date: [
                5,
                1
            ],
            only_states: [
                "Z\xfcrich",
                "Freiburg",
                "Solothurn",
                "Basel-Stadt",
                "Basel-Landschaft",
                "Schaffhausen",
                "Aargau",
                "Thurgau",
                "Tessin",
                "Neuenburg",
                "Jura"
            ]
        },
        {
            name: "Auffahrt/Ascension/Ascensione",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pfingstmontag/Lundi de Pentec\xf4te/Lunedi di Pentecoste",
            variable_date: "easter",
            offset: 50,
            only_states: [
                "Z\xfcrich",
                "Bern",
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Stadt",
                "Basel-Landschaft",
                "Schaffhausen",
                "Appenzell Ausserrhoden",
                "Appenzell Innerrhoden",
                "Sankt Gallen",
                "Graub\xfcnden",
                "Aargau",
                "Thurgau",
                "Tessin",
                "Waadt",
                "Neuenburg",
                "Genf",
                "Jura",
                "Wallis"
            ]
        },
        {
            name: "Fronleichnam/F\xeate-Dieu/Corpus domini",
            variable_date: "easter",
            offset: 60,
            only_states: [
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Landschaft",
                "Appenzell Innerrhoden",
                "Graub\xfcnden",
                "Aargau",
                "Tessin",
                "Wallis",
                "Neuenburg",
                "Jura"
            ]
        },
        {
            name: "Comm\xe9moration du pl\xe9biscite jurassien",
            fixed_date: [
                6,
                23
            ],
            only_states: [
                "Jura"
            ]
        },
        {
            name: "San Pietro e Paolo",
            fixed_date: [
                6,
                29
            ],
            only_states: [
                "Tessin"
            ]
        },
        {
            name: "Bundesfeiertag/Jour de la f\xeate nationale/Giorno festivo federale",
            fixed_date: [
                8,
                1
            ]
        },
        {
            name: "Mari\xe4 Himmelfahrt/Assomption/Assunzione",
            fixed_date: [
                8,
                15
            ],
            only_states: [
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Landschaft",
                "Appenzell Innerrhoden",
                "Graub\xfcnden",
                "Aargau",
                "Tessin",
                "Wallis",
                "Jura"
            ]
        },
        {
            name: "Mauritiustag",
            fixed_date: [
                9,
                22
            ],
            only_states: [
                "Appenzell Innerrhoden"
            ]
        },
        {
            name: "Bruderklausenfest",
            fixed_date: [
                9,
                25
            ],
            only_states: [
                "Obwalden"
            ]
        },
        {
            name: "Allerheiligen/Toussaint/Ognissanti",
            fixed_date: [
                11,
                1
            ],
            only_states: [
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Appenzell Innerrhoden",
                "Sankt Gallen",
                "Graub\xfcnden",
                "Aargau",
                "Tessin",
                "Wallis",
                "Jura"
            ]
        },
        {
            name: "Mari\xe4 Empf\xe4ngnis/Immacul\xe9e Conception/Ognissanti",
            fixed_date: [
                12,
                8
            ],
            only_states: [
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Appenzell Innerrhoden",
                "Graub\xfcnden",
                "Aargau",
                "Tessin",
                "Wallis"
            ]
        },
        {
            name: "Weihnachtstag/No\xebl/Natale",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Stephanstag/Saint-Etienne/Santo Stefano",
            fixed_date: [
                12,
                26
            ],
            only_states: [
                "Z\xfcrich",
                "Bern",
                "Luzern",
                "Uri",
                "Schwyz",
                "Obwalden",
                "Nidwalden",
                "Glarus",
                "Zug",
                "Freiburg",
                "Solothurn",
                "Basel-Stadt",
                "Basel-Landschaft",
                "Schaffhausen",
                "Appenzell Ausserrhoden",
                "Appenzell Innerrhoden",
                "Sankt Gallen",
                "Graub\xfcnden",
                "Aargau",
                "Thurgau",
                "Tessin",
                "Wallis"
            ]
        },
        {
            name: "Restauration de la R\xe9publique",
            fixed_date: [
                12,
                31
            ],
            only_states: [
                "Genf"
            ]
        }
    ],
    Aargau: {
        _state_code: "ag"
    },
    "Appenzell Ausserrhoden": {
        _state_code: "ar"
    },
    "Appenzell Innerrhoden": {
        _state_code: "ai"
    },
    "Basel-Landschaft": {
        _state_code: "bl"
    },
    "Basel-Stadt": {
        _state_code: "bs"
    },
    Bern: {
        _state_code: "be"
    },
    Freiburg: {
        _state_code: "fr"
    },
    Genf: {
        _state_code: "ge"
    },
    Glarus: {
        _state_code: "gl"
    },
    "Graub\xfcnden": {
        _state_code: "gr"
    },
    Jura: {
        _state_code: "ju"
    },
    Luzern: {
        _state_code: "lu"
    },
    Neuenburg: {
        _state_code: "ne"
    },
    Nidwalden: {
        _state_code: "nw"
    },
    Obwalden: {
        _state_code: "ow"
    },
    Schaffhausen: {
        _state_code: "sh"
    },
    Schwyz: {
        _state_code: "sz"
    },
    Solothurn: {
        _state_code: "so"
    },
    "Sankt Gallen": {
        _state_code: "sg"
    },
    Tessin: {
        _state_code: "ti"
    },
    Thurgau: {
        _state_code: "tg"
    },
    Uri: {
        _state_code: "ur"
    },
    Waadt: {
        _state_code: "vd"
    },
    Wallis: {
        _state_code: "vs"
    },
    Zug: {
        _state_code: "zg"
    },
    "Z\xfcrich": {
        _state_code: "zh"
    }
};
$0e3b0f6e50344df5$var$data$x.PH;
$0e3b0f6e50344df5$var$data$x.Aargau;
$0e3b0f6e50344df5$var$data$x.Bern;
$0e3b0f6e50344df5$var$data$x.Freiburg;
$0e3b0f6e50344df5$var$data$x.Genf;
$0e3b0f6e50344df5$var$data$x.Glarus;
$0e3b0f6e50344df5$var$data$x.Jura;
$0e3b0f6e50344df5$var$data$x.Luzern;
$0e3b0f6e50344df5$var$data$x.Neuenburg;
$0e3b0f6e50344df5$var$data$x.Nidwalden;
$0e3b0f6e50344df5$var$data$x.Obwalden;
$0e3b0f6e50344df5$var$data$x.Schaffhausen;
$0e3b0f6e50344df5$var$data$x.Schwyz;
$0e3b0f6e50344df5$var$data$x.Solothurn;
$0e3b0f6e50344df5$var$data$x.Tessin;
$0e3b0f6e50344df5$var$data$x.Thurgau;
$0e3b0f6e50344df5$var$data$x.Uri;
$0e3b0f6e50344df5$var$data$x.Waadt;
$0e3b0f6e50344df5$var$data$x.Wallis;
$0e3b0f6e50344df5$var$data$x.Zug;
var $0e3b0f6e50344df5$var$data$w = {
    PH: [
        {
            name: "F\xeate du 1\u1D49\u02B3 janvier",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Lundi de P\xe2ques",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "F\xeate du travail",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Lendemain de la F\xeate du travail",
            variable_date: "nextMo-Sa01May"
        },
        {
            name: "Jour de l\u2019Ascension",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Lundi de la Pentec\xf4te",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "F\xeate nationale",
            fixed_date: [
                8,
                7
            ]
        },
        {
            name: "Lendemain de la F\xeate nationale",
            variable_date: "nextMo-Sa07August"
        },
        {
            name: "F\xeate de l\u2019Assomption",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "F\xeate de la Toussaint",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Journ\xe9e Nationale de la Paix",
            fixed_date: [
                11,
                15
            ]
        },
        {
            name: "F\xeate de No\xebl",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Lendemain de la F\xeate de No\xebl",
            variable_date: "nextMo-Sa25December"
        }
    ]
};
$0e3b0f6e50344df5$var$data$w.PH;
var $0e3b0f6e50344df5$var$data$v = {
    PH: [
        {
            name: "\u5143\u65E6",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "\u5987\u5973\u8282",
            fixed_date: [
                3,
                8
            ]
        },
        {
            name: "\u52B3\u52A8\u8282",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "\u9752\u5E74\u8282",
            fixed_date: [
                5,
                4
            ]
        },
        {
            name: "\u513F\u7AE5\u8282",
            fixed_date: [
                6,
                1
            ]
        },
        {
            name: "\u56FD\u5E86\u8282",
            fixed_date: [
                10,
                1
            ]
        },
        {
            name: "\u56FD\u5E86\u8282\u4F11\u606F\u65E5",
            fixed_date: [
                10,
                2
            ]
        },
        {
            name: "\u56FD\u5E86\u8282\u4F11\u606F\u65E5",
            fixed_date: [
                10,
                3
            ]
        }
    ],
    "\u897F\u85CF\u81EA\u6CBB\u533A": {
        PH: [
            {
                name: "\u5143\u65E6",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "\u897F\u85CF\u767E\u4E07\u519C\u5974\u89E3\u653E\u7EAA\u5FF5\u65E5",
                fixed_date: [
                    3,
                    28
                ]
            },
            {
                name: "\u5987\u5973\u8282",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u52B3\u52A8\u8282",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u9752\u5E74\u8282",
                fixed_date: [
                    5,
                    4
                ]
            },
            {
                name: "\u513F\u7AE5\u8282",
                fixed_date: [
                    6,
                    1
                ]
            },
            {
                name: "\u56FD\u5E86\u8282",
                fixed_date: [
                    10,
                    1
                ]
            },
            {
                name: "\u56FD\u5E86\u8282\u4F11\u606F\u65E5",
                fixed_date: [
                    10,
                    2
                ]
            },
            {
                name: "\u56FD\u5E86\u8282\u4F11\u606F\u65E5",
                fixed_date: [
                    10,
                    3
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$v.PH;
var $0e3b0f6e50344df5$var$data$u = {
    PH: [
        {
            name: "Den obnovy samostatn\xe9ho \u010Desk\xe9ho st\xe1tu",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Velk\xfd p\xe1tek",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Velikono\u010Dn\xed pond\u011Bl\xed",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Sv\xe1tek pr\xe1ce",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Den v\xedt\u011Bzstv\xed",
            fixed_date: [
                5,
                8
            ]
        },
        {
            name: "Den slovansk\xfdch v\u011Brozv\u011Bst\u016F Cyrila a Metod\u011Bje",
            fixed_date: [
                7,
                5
            ]
        },
        {
            name: "Den up\xe1len\xed mistra Jana Husa",
            fixed_date: [
                7,
                6
            ]
        },
        {
            name: "Den \u010Desk\xe9 st\xe1tnosti",
            fixed_date: [
                9,
                28
            ]
        },
        {
            name: "Den vzniku samostatn\xe9ho \u010Deskoslovensk\xe9ho st\xe1tu",
            fixed_date: [
                10,
                28
            ]
        },
        {
            name: "Den boje za svobodu a demokracii",
            fixed_date: [
                11,
                17
            ]
        },
        {
            name: "\u0160t\u011Bdr\xfd den",
            fixed_date: [
                12,
                24
            ]
        },
        {
            name: "1. sv\xe1tek v\xe1no\u010Dn\xed",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "2. sv\xe1tek v\xe1no\u010Dn\xed",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$u.PH;
var $0e3b0f6e50344df5$var$data$t = {
    PH: [
        {
            name: "Neujahrstag",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Heilige Drei K\xf6nige",
            fixed_date: [
                1,
                6
            ],
            only_states: [
                "Baden-W\xfcrttemberg",
                "Bayern",
                "Sachsen-Anhalt"
            ]
        },
        {
            name: "Frauentag",
            fixed_date: [
                3,
                8
            ],
            only_states: [
                "Berlin",
                "Mecklenburg-Vorpommern"
            ]
        },
        {
            name: "Tag der Arbeit",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Karfreitag",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Ostersonntag",
            variable_date: "easter",
            only_states: [
                "Brandenburg"
            ]
        },
        {
            name: "Ostermontag",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Christi Himmelfahrt",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pfingstsonntag",
            variable_date: "easter",
            offset: 49,
            only_states: [
                "Brandenburg"
            ]
        },
        {
            name: "Pfingstmontag",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Fronleichnam",
            variable_date: "easter",
            offset: 60,
            only_states: [
                "Baden-W\xfcrttemberg",
                "Bayern",
                "Hessen",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland"
            ]
        },
        {
            name: "Mari\xe4 Himmelfahrt",
            fixed_date: [
                8,
                15
            ],
            only_states: [
                "Saarland"
            ]
        },
        {
            name: "Weltkindertag",
            fixed_date: [
                9,
                20
            ],
            only_states: [
                "Th\xfcringen"
            ]
        },
        {
            name: "Tag der Deutschen Einheit",
            fixed_date: [
                10,
                3
            ]
        },
        {
            name: "Reformationstag",
            fixed_date: [
                10,
                31
            ],
            only_states: [
                "Brandenburg",
                "Bremen",
                "Hamburg",
                "Mecklenburg-Vorpommern",
                "Niedersachsen",
                "Sachsen",
                "Sachsen-Anhalt",
                "Schleswig-Holstein",
                "Th\xfcringen"
            ]
        },
        {
            name: "Allerheiligen",
            fixed_date: [
                11,
                1
            ],
            only_states: [
                "Baden-W\xfcrttemberg",
                "Bayern",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland"
            ]
        },
        {
            name: "Bu\xdf- und Bettag",
            variable_date: "nextWednesday16Nov",
            only_states: [
                "Sachsen"
            ]
        },
        {
            name: "1. Weihnachtstag",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "2. Weihnachtstag",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    "Baden-W\xfcrttemberg": {
        _state_code: "bw",
        SH: [
            {
                2012: [
                    4,
                    2,
                    4,
                    13
                ],
                2013: [
                    3,
                    25,
                    4,
                    5
                ],
                2014: [
                    4,
                    14,
                    4,
                    25
                ],
                2015: [
                    3,
                    30,
                    4,
                    10
                ],
                2016: [
                    3,
                    24,
                    3,
                    24,
                    3,
                    29,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    21
                ],
                2018: [
                    3,
                    26,
                    4,
                    6
                ],
                2019: [
                    4,
                    15,
                    4,
                    27
                ],
                2020: [
                    4,
                    6,
                    4,
                    18
                ],
                2022: [
                    4,
                    14,
                    4,
                    14
                ],
                2023: [
                    4,
                    6,
                    4,
                    6,
                    4,
                    11,
                    4,
                    15
                ],
                2024: [
                    3,
                    23,
                    4,
                    5
                ],
                2025: [
                    4,
                    14,
                    4,
                    26
                ],
                2026: [
                    3,
                    30,
                    4,
                    11
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    29,
                    6,
                    9
                ],
                2013: [
                    5,
                    21,
                    6,
                    1
                ],
                2014: [
                    6,
                    10,
                    6,
                    21
                ],
                2015: [
                    5,
                    26,
                    6,
                    6
                ],
                2016: [
                    5,
                    17,
                    5,
                    28
                ],
                2017: [
                    6,
                    6,
                    6,
                    16
                ],
                2018: [
                    5,
                    22,
                    6,
                    2
                ],
                2019: [
                    6,
                    11,
                    6,
                    21
                ],
                2020: [
                    6,
                    2,
                    6,
                    13
                ],
                2022: [
                    6,
                    7,
                    6,
                    18
                ],
                2023: [
                    5,
                    30,
                    6,
                    9
                ],
                2024: [
                    5,
                    21,
                    5,
                    31
                ],
                2025: [
                    6,
                    10,
                    6,
                    20
                ],
                2026: [
                    5,
                    26,
                    6,
                    5
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    26,
                    9,
                    8
                ],
                2013: [
                    7,
                    25,
                    9,
                    7
                ],
                2014: [
                    7,
                    31,
                    9,
                    13
                ],
                2015: [
                    7,
                    30,
                    9,
                    12
                ],
                2016: [
                    7,
                    28,
                    9,
                    10
                ],
                2017: [
                    7,
                    27,
                    9,
                    9
                ],
                2018: [
                    7,
                    26,
                    9,
                    8
                ],
                2019: [
                    7,
                    29,
                    9,
                    10
                ],
                2020: [
                    7,
                    30,
                    9,
                    12
                ],
                2021: [
                    7,
                    29,
                    9,
                    11
                ],
                2022: [
                    7,
                    28,
                    9,
                    10
                ],
                2023: [
                    7,
                    27,
                    9,
                    9
                ],
                2024: [
                    7,
                    25,
                    9,
                    7
                ],
                2025: [
                    7,
                    31,
                    9,
                    13
                ],
                2026: [
                    7,
                    30,
                    9,
                    12
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    29,
                    11,
                    2
                ],
                2013: [
                    10,
                    28,
                    10,
                    30
                ],
                2014: [
                    10,
                    27,
                    10,
                    30
                ],
                2015: [
                    10,
                    31,
                    10,
                    31,
                    11,
                    2,
                    11,
                    6
                ],
                2016: [
                    10,
                    31,
                    10,
                    31,
                    11,
                    2,
                    11,
                    4
                ],
                2017: [
                    10,
                    30,
                    11,
                    3
                ],
                2018: [
                    10,
                    29,
                    11,
                    2
                ],
                2019: [
                    10,
                    28,
                    10,
                    30
                ],
                2022: [
                    10,
                    31,
                    10,
                    31
                ],
                2023: [
                    10,
                    30,
                    11,
                    3
                ],
                2024: [
                    10,
                    28,
                    10,
                    30,
                    10,
                    31,
                    10,
                    31
                ],
                2025: [
                    10,
                    27,
                    10,
                    30,
                    10,
                    31,
                    10,
                    31
                ],
                2026: [
                    10,
                    26,
                    10,
                    30,
                    10,
                    31,
                    10,
                    31
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    5
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    4
                ],
                2014: [
                    12,
                    22,
                    1,
                    5
                ],
                2015: [
                    12,
                    23,
                    1,
                    9
                ],
                2016: [
                    12,
                    23,
                    1,
                    7
                ],
                2017: [
                    12,
                    22,
                    1,
                    5
                ],
                2018: [
                    12,
                    24,
                    1,
                    5
                ],
                2019: [
                    12,
                    23,
                    1,
                    4
                ],
                2022: [
                    12,
                    21,
                    1,
                    7
                ],
                2023: [
                    12,
                    23,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    4
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    23,
                    1,
                    9
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Bayern: {
        _state_code: "by",
        SH: [
            {
                2012: [
                    2,
                    20,
                    2,
                    24
                ],
                2013: [
                    2,
                    11,
                    2,
                    15
                ],
                2014: [
                    3,
                    3,
                    3,
                    7
                ],
                2015: [
                    2,
                    16,
                    2,
                    20
                ],
                2016: [
                    2,
                    8,
                    2,
                    12
                ],
                2017: [
                    2,
                    27,
                    3,
                    3
                ],
                2018: [
                    2,
                    12,
                    2,
                    16
                ],
                2019: [
                    3,
                    4,
                    3,
                    8
                ],
                2020: [
                    2,
                    24,
                    2,
                    28
                ],
                2021: [
                    2,
                    15,
                    2,
                    19
                ],
                2022: [
                    2,
                    28,
                    3,
                    4
                ],
                2023: [
                    2,
                    20,
                    2,
                    24
                ],
                2024: [
                    2,
                    12,
                    2,
                    16
                ],
                2025: [
                    3,
                    3,
                    3,
                    7
                ],
                2026: [
                    2,
                    16,
                    2,
                    20
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    14
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    14,
                    4,
                    26
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    21,
                    4,
                    1
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    26,
                    4,
                    7
                ],
                2019: [
                    4,
                    15,
                    4,
                    27
                ],
                2020: [
                    4,
                    6,
                    4,
                    18
                ],
                2021: [
                    3,
                    29,
                    4,
                    10
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    15
                ],
                2024: [
                    3,
                    25,
                    4,
                    6
                ],
                2025: [
                    4,
                    14,
                    4,
                    25
                ],
                2026: [
                    3,
                    30,
                    4,
                    10
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    29,
                    6,
                    9
                ],
                2013: [
                    5,
                    21,
                    5,
                    31
                ],
                2014: [
                    6,
                    10,
                    6,
                    21
                ],
                2015: [
                    5,
                    26,
                    6,
                    5
                ],
                2016: [
                    5,
                    17,
                    5,
                    28
                ],
                2017: [
                    6,
                    6,
                    6,
                    16
                ],
                2018: [
                    5,
                    22,
                    6,
                    2
                ],
                2019: [
                    6,
                    11,
                    6,
                    21
                ],
                2020: [
                    6,
                    2,
                    6,
                    13
                ],
                2021: [
                    5,
                    25,
                    6,
                    4
                ],
                2022: [
                    6,
                    7,
                    6,
                    18
                ],
                2023: [
                    5,
                    30,
                    6,
                    9
                ],
                2024: [
                    5,
                    21,
                    6,
                    1
                ],
                2025: [
                    6,
                    10,
                    6,
                    20
                ],
                2026: [
                    5,
                    26,
                    6,
                    5
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    8,
                    1,
                    9,
                    12
                ],
                2013: [
                    7,
                    31,
                    9,
                    11
                ],
                2014: [
                    7,
                    30,
                    9,
                    15
                ],
                2015: [
                    8,
                    1,
                    9,
                    14
                ],
                2016: [
                    7,
                    30,
                    9,
                    12
                ],
                2017: [
                    7,
                    29,
                    9,
                    11
                ],
                2018: [
                    7,
                    30,
                    9,
                    10
                ],
                2019: [
                    7,
                    29,
                    9,
                    9
                ],
                2020: [
                    7,
                    27,
                    9,
                    7
                ],
                2021: [
                    7,
                    30,
                    9,
                    13
                ],
                2022: [
                    8,
                    1,
                    9,
                    12
                ],
                2023: [
                    7,
                    31,
                    9,
                    11
                ],
                2024: [
                    7,
                    29,
                    9,
                    9
                ],
                2025: [
                    8,
                    1,
                    9,
                    15
                ],
                2026: [
                    8,
                    3,
                    9,
                    14
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    29,
                    11,
                    3
                ],
                2013: [
                    10,
                    28,
                    10,
                    31
                ],
                2014: [
                    10,
                    27,
                    10,
                    31,
                    11,
                    19,
                    11,
                    19
                ],
                2015: [
                    11,
                    2,
                    11,
                    7,
                    11,
                    18,
                    11,
                    18
                ],
                2016: [
                    10,
                    31,
                    11,
                    4,
                    11,
                    16,
                    11,
                    16
                ],
                2017: [
                    10,
                    30,
                    11,
                    3,
                    11,
                    22,
                    11,
                    22
                ],
                2018: [
                    10,
                    29,
                    11,
                    2,
                    11,
                    21,
                    11,
                    21
                ],
                2019: [
                    10,
                    28,
                    10,
                    31,
                    11,
                    20,
                    11,
                    20
                ],
                2020: [
                    10,
                    31,
                    11,
                    6,
                    11,
                    18,
                    11,
                    18
                ],
                2021: [
                    11,
                    2,
                    11,
                    5,
                    11,
                    17,
                    11,
                    17
                ],
                2022: [
                    10,
                    31,
                    11,
                    4,
                    11,
                    16,
                    11,
                    16
                ],
                2023: [
                    10,
                    30,
                    11,
                    3,
                    11,
                    22,
                    11,
                    22
                ],
                2024: [
                    10,
                    28,
                    10,
                    31,
                    11,
                    20,
                    11,
                    20
                ],
                2025: [
                    11,
                    3,
                    11,
                    7,
                    11,
                    19,
                    11,
                    19
                ],
                2026: [
                    11,
                    2,
                    11,
                    6,
                    11,
                    18,
                    11,
                    18
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    27,
                    1,
                    5
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    4
                ],
                2014: [
                    12,
                    24,
                    1,
                    5
                ],
                2015: [
                    12,
                    24,
                    1,
                    5
                ],
                2016: [
                    12,
                    24,
                    1,
                    5
                ],
                2017: [
                    12,
                    23,
                    1,
                    5
                ],
                2018: [
                    12,
                    22,
                    1,
                    5
                ],
                2019: [
                    12,
                    23,
                    1,
                    4
                ],
                2020: [
                    12,
                    23,
                    1,
                    9
                ],
                2021: [
                    12,
                    24,
                    1,
                    8
                ],
                2022: [
                    12,
                    24,
                    1,
                    7
                ],
                2023: [
                    12,
                    23,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    3
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    24,
                    1,
                    8
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Berlin: {
        _state_code: "be",
        SH: [
            {
                2012: [
                    1,
                    30,
                    2,
                    4
                ],
                2013: [
                    2,
                    4,
                    2,
                    9
                ],
                2014: [
                    2,
                    3,
                    2,
                    8
                ],
                2015: [
                    2,
                    2,
                    2,
                    7
                ],
                2016: [
                    2,
                    1,
                    2,
                    6
                ],
                2017: [
                    1,
                    30,
                    2,
                    3
                ],
                2018: [
                    2,
                    5,
                    2,
                    10
                ],
                2019: [
                    2,
                    4,
                    2,
                    9
                ],
                2020: [
                    2,
                    3,
                    2,
                    8
                ],
                2021: [
                    2,
                    1,
                    2,
                    6
                ],
                2022: [
                    1,
                    29,
                    2,
                    5
                ],
                2023: [
                    1,
                    30,
                    2,
                    4
                ],
                2024: [
                    2,
                    5,
                    2,
                    10
                ],
                2025: [
                    2,
                    3,
                    2,
                    8
                ],
                2026: [
                    2,
                    2,
                    2,
                    7
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    14,
                    4,
                    30,
                    4,
                    30
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    14,
                    4,
                    26,
                    5,
                    2,
                    5,
                    2
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    21,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    18
                ],
                2018: [
                    3,
                    26,
                    4,
                    6
                ],
                2019: [
                    4,
                    15,
                    4,
                    26
                ],
                2020: [
                    4,
                    6,
                    4,
                    17
                ],
                2021: [
                    3,
                    29,
                    4,
                    10
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    14
                ],
                2024: [
                    3,
                    25,
                    4,
                    5
                ],
                2025: [
                    4,
                    14,
                    4,
                    25,
                    5,
                    2,
                    5,
                    2,
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    3,
                    30,
                    4,
                    10,
                    5,
                    15,
                    5,
                    15
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18
                ],
                2013: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    21,
                    5,
                    21
                ],
                2014: [
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    26,
                    5,
                    26
                ],
                2016: [
                    5,
                    6,
                    5,
                    6,
                    5,
                    17,
                    5,
                    18
                ],
                2017: [
                    5,
                    24,
                    5,
                    24,
                    5,
                    26,
                    5,
                    26,
                    6,
                    6,
                    6,
                    9
                ],
                2018: [
                    4,
                    30,
                    4,
                    30,
                    5,
                    11,
                    5,
                    11,
                    5,
                    22,
                    5,
                    22
                ],
                2019: [
                    5,
                    31,
                    5,
                    31,
                    6,
                    11,
                    6,
                    11
                ],
                2020: [
                    5,
                    22,
                    5,
                    22
                ],
                2021: [
                    5,
                    14,
                    5,
                    14
                ],
                2022: [
                    5,
                    27,
                    5,
                    27,
                    6,
                    7,
                    6,
                    7
                ],
                2023: [
                    5,
                    19,
                    5,
                    19,
                    5,
                    30,
                    5,
                    30
                ],
                2024: [
                    5,
                    10,
                    5,
                    10
                ],
                2025: [
                    6,
                    10,
                    6,
                    10
                ],
                2026: [
                    5,
                    26,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    6,
                    20,
                    8,
                    3
                ],
                2013: [
                    6,
                    19,
                    8,
                    2
                ],
                2014: [
                    7,
                    9,
                    8,
                    22
                ],
                2015: [
                    7,
                    16,
                    8,
                    28
                ],
                2016: [
                    7,
                    21,
                    9,
                    2
                ],
                2017: [
                    7,
                    20,
                    9,
                    1
                ],
                2018: [
                    7,
                    5,
                    8,
                    17
                ],
                2019: [
                    6,
                    20,
                    8,
                    2
                ],
                2020: [
                    6,
                    25,
                    8,
                    7
                ],
                2021: [
                    6,
                    24,
                    8,
                    6
                ],
                2022: [
                    7,
                    7,
                    8,
                    19
                ],
                2023: [
                    7,
                    13,
                    8,
                    25
                ],
                2024: [
                    7,
                    18,
                    8,
                    30
                ],
                2025: [
                    7,
                    24,
                    9,
                    6
                ],
                2026: [
                    7,
                    9,
                    8,
                    22
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    1,
                    10,
                    13
                ],
                2013: [
                    9,
                    30,
                    10,
                    12
                ],
                2014: [
                    10,
                    20,
                    11,
                    1
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    17,
                    10,
                    28
                ],
                2017: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    23,
                    11,
                    4
                ],
                2018: [
                    10,
                    22,
                    11,
                    2
                ],
                2019: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    7,
                    10,
                    19
                ],
                2020: [
                    10,
                    12,
                    10,
                    24
                ],
                2021: [
                    10,
                    11,
                    10,
                    23
                ],
                2022: [
                    10,
                    24,
                    11,
                    5
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    23,
                    11,
                    4
                ],
                2024: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    21,
                    11,
                    2
                ],
                2025: [
                    10,
                    20,
                    11,
                    1
                ],
                2026: [
                    10,
                    19,
                    10,
                    31
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    3
                ],
                2012: [
                    12,
                    24,
                    1,
                    4
                ],
                2013: [
                    12,
                    23,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    2
                ],
                2015: [
                    12,
                    23,
                    1,
                    2
                ],
                2016: [
                    12,
                    23,
                    1,
                    3
                ],
                2017: [
                    12,
                    21,
                    1,
                    2
                ],
                2018: [
                    12,
                    22,
                    1,
                    5
                ],
                2019: [
                    12,
                    23,
                    1,
                    4
                ],
                2020: [
                    12,
                    21,
                    1,
                    2
                ],
                2021: [
                    12,
                    23,
                    12,
                    31
                ],
                2022: [
                    12,
                    22,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    12,
                    31
                ],
                2025: [
                    12,
                    22,
                    1,
                    2
                ],
                2026: [
                    12,
                    23,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Brandenburg: {
        _state_code: "bb",
        SH: [
            {
                2012: [
                    1,
                    30,
                    2,
                    4
                ],
                2013: [
                    2,
                    4,
                    2,
                    9
                ],
                2014: [
                    2,
                    3,
                    2,
                    8
                ],
                2015: [
                    2,
                    2,
                    2,
                    7
                ],
                2016: [
                    2,
                    1,
                    2,
                    6
                ],
                2017: [
                    1,
                    30,
                    2,
                    4
                ],
                2018: [
                    2,
                    5,
                    2,
                    10
                ],
                2019: [
                    2,
                    4,
                    2,
                    9
                ],
                2020: [
                    2,
                    3,
                    2,
                    8
                ],
                2021: [
                    2,
                    1,
                    2,
                    6
                ],
                2022: [
                    1,
                    31,
                    2,
                    5
                ],
                2023: [
                    1,
                    30,
                    2,
                    3
                ],
                2024: [
                    2,
                    5,
                    2,
                    9
                ],
                2025: [
                    2,
                    3,
                    2,
                    8
                ],
                2026: [
                    2,
                    2,
                    2,
                    7
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    4,
                    4,
                    14,
                    4,
                    30,
                    4,
                    30
                ],
                2013: [
                    3,
                    27,
                    4,
                    6
                ],
                2014: [
                    4,
                    16,
                    4,
                    26,
                    5,
                    2,
                    5,
                    2
                ],
                2015: [
                    4,
                    1,
                    4,
                    11
                ],
                2016: [
                    3,
                    23,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    26,
                    4,
                    6
                ],
                2019: [
                    4,
                    15,
                    4,
                    26
                ],
                2020: [
                    4,
                    6,
                    4,
                    17
                ],
                2021: [
                    3,
                    29,
                    4,
                    9
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    14
                ],
                2024: [
                    3,
                    25,
                    4,
                    5
                ],
                2025: [
                    4,
                    14,
                    4,
                    25,
                    5,
                    2,
                    5,
                    2,
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    3,
                    30,
                    4,
                    10,
                    5,
                    15,
                    5,
                    15
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18
                ],
                2013: [
                    5,
                    10,
                    5,
                    10
                ],
                2014: [
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    15,
                    5,
                    15
                ],
                2016: [
                    5,
                    6,
                    5,
                    6,
                    5,
                    17,
                    5,
                    17
                ],
                2017: [
                    5,
                    26,
                    5,
                    26
                ],
                2018: [
                    4,
                    30,
                    4,
                    30,
                    5,
                    11,
                    5,
                    11
                ],
                2019: [
                    5,
                    31,
                    5,
                    31
                ],
                2020: [
                    5,
                    22,
                    5,
                    22
                ],
                2021: [
                    5,
                    14,
                    5,
                    14
                ],
                2022: [
                    5,
                    27,
                    5,
                    27
                ],
                2023: [
                    5,
                    19,
                    5,
                    19
                ],
                2024: [
                    5,
                    10,
                    5,
                    10
                ],
                2025: [
                    6,
                    10,
                    6,
                    10
                ],
                2026: [
                    5,
                    26,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    6,
                    21,
                    8,
                    3
                ],
                2013: [
                    6,
                    20,
                    8,
                    2
                ],
                2014: [
                    7,
                    10,
                    8,
                    22
                ],
                2015: [
                    7,
                    16,
                    8,
                    28
                ],
                2016: [
                    7,
                    21,
                    9,
                    3
                ],
                2017: [
                    7,
                    20,
                    9,
                    1
                ],
                2018: [
                    7,
                    5,
                    8,
                    18
                ],
                2019: [
                    6,
                    20,
                    8,
                    3
                ],
                2020: [
                    6,
                    25,
                    8,
                    8
                ],
                2021: [
                    6,
                    24,
                    8,
                    7
                ],
                2022: [
                    7,
                    7,
                    8,
                    20
                ],
                2023: [
                    7,
                    13,
                    8,
                    26
                ],
                2024: [
                    7,
                    18,
                    8,
                    31
                ],
                2025: [
                    7,
                    24,
                    9,
                    6
                ],
                2026: [
                    7,
                    9,
                    8,
                    22
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    1,
                    10,
                    13
                ],
                2013: [
                    9,
                    30,
                    10,
                    12,
                    11,
                    1,
                    11,
                    1
                ],
                2014: [
                    10,
                    20,
                    11,
                    1
                ],
                2015: [
                    10,
                    19,
                    10,
                    30
                ],
                2016: [
                    10,
                    17,
                    10,
                    28
                ],
                2017: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    23,
                    11,
                    4
                ],
                2018: [
                    10,
                    22,
                    11,
                    2
                ],
                2019: [
                    10,
                    4,
                    10,
                    18,
                    11,
                    1,
                    11,
                    1
                ],
                2020: [
                    10,
                    12,
                    10,
                    24
                ],
                2021: [
                    10,
                    11,
                    10,
                    23
                ],
                2022: [
                    10,
                    24,
                    11,
                    5
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    23,
                    11,
                    4
                ],
                2024: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    21,
                    11,
                    2
                ],
                2025: [
                    10,
                    20,
                    11,
                    1
                ],
                2026: [
                    10,
                    19,
                    10,
                    30
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    3
                ],
                2012: [
                    12,
                    24,
                    1,
                    4
                ],
                2013: [
                    12,
                    23,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    2
                ],
                2015: [
                    12,
                    23,
                    1,
                    2
                ],
                2016: [
                    12,
                    23,
                    1,
                    3
                ],
                2017: [
                    12,
                    21,
                    1,
                    2
                ],
                2018: [
                    12,
                    21,
                    1,
                    5
                ],
                2019: [
                    12,
                    23,
                    1,
                    3
                ],
                2020: [
                    12,
                    21,
                    1,
                    2
                ],
                2021: [
                    12,
                    23,
                    12,
                    31
                ],
                2022: [
                    12,
                    22,
                    1,
                    3
                ],
                2023: [
                    12,
                    23,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    12,
                    31
                ],
                2025: [
                    12,
                    22,
                    1,
                    2
                ],
                2026: [
                    12,
                    23,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Bremen: {
        _state_code: "hb",
        SH: [
            {
                2012: [
                    1,
                    30,
                    1,
                    31
                ],
                2013: [
                    1,
                    31,
                    2,
                    1
                ],
                2014: [
                    1,
                    30,
                    1,
                    31
                ],
                2015: [
                    2,
                    2,
                    2,
                    3
                ],
                2016: [
                    1,
                    28,
                    1,
                    29
                ],
                2017: [
                    1,
                    30,
                    1,
                    31
                ],
                2018: [
                    2,
                    1,
                    2,
                    2
                ],
                2019: [
                    1,
                    31,
                    2,
                    1
                ],
                2020: [
                    2,
                    3,
                    2,
                    4
                ],
                2021: [
                    2,
                    1,
                    2,
                    2
                ],
                2022: [
                    1,
                    31,
                    2,
                    1
                ],
                2023: [
                    1,
                    30,
                    1,
                    31
                ],
                2024: [
                    2,
                    1,
                    2,
                    2
                ],
                2025: [
                    2,
                    3,
                    2,
                    4
                ],
                2026: [
                    2,
                    2,
                    2,
                    3
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    3,
                    26,
                    4,
                    11,
                    4,
                    30,
                    4,
                    30
                ],
                2013: [
                    3,
                    16,
                    4,
                    2
                ],
                2014: [
                    4,
                    3,
                    4,
                    22,
                    5,
                    2,
                    5,
                    2
                ],
                2015: [
                    3,
                    25,
                    4,
                    10
                ],
                2016: [
                    3,
                    18,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    19,
                    4,
                    3
                ],
                2019: [
                    4,
                    6,
                    4,
                    23
                ],
                2020: [
                    3,
                    28,
                    4,
                    14
                ],
                2021: [
                    3,
                    27,
                    4,
                    10
                ],
                2022: [
                    4,
                    4,
                    4,
                    19
                ],
                2023: [
                    3,
                    27,
                    4,
                    11
                ],
                2024: [
                    3,
                    18,
                    3,
                    28
                ],
                2025: [
                    4,
                    7,
                    4,
                    19
                ],
                2026: [
                    3,
                    23,
                    4,
                    7
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18,
                    5,
                    29,
                    5,
                    29
                ],
                2013: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    21,
                    5,
                    21
                ],
                2014: [
                    5,
                    30,
                    5,
                    30,
                    6,
                    10,
                    6,
                    10
                ],
                2015: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    26,
                    5,
                    26
                ],
                2016: [
                    5,
                    6,
                    5,
                    6,
                    5,
                    17,
                    5,
                    17
                ],
                2017: [
                    5,
                    26,
                    5,
                    26,
                    6,
                    6,
                    6,
                    6
                ],
                2018: [
                    4,
                    30,
                    4,
                    30,
                    5,
                    11,
                    5,
                    11,
                    5,
                    22,
                    5,
                    22
                ],
                2019: [
                    5,
                    31,
                    5,
                    31,
                    6,
                    11,
                    6,
                    11
                ],
                2020: [
                    5,
                    22,
                    5,
                    22,
                    6,
                    2,
                    6,
                    2
                ],
                2021: [
                    5,
                    14,
                    5,
                    14,
                    5,
                    25,
                    5,
                    25
                ],
                2022: [
                    5,
                    27,
                    5,
                    27,
                    6,
                    7,
                    6,
                    7
                ],
                2023: [
                    5,
                    19,
                    5,
                    19,
                    5,
                    30,
                    5,
                    30
                ],
                2024: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    21,
                    5,
                    21
                ],
                2025: [
                    4,
                    30,
                    4,
                    30,
                    5,
                    2,
                    5,
                    2,
                    5,
                    30,
                    5,
                    30,
                    6,
                    10,
                    6,
                    10
                ],
                2026: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    26,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    23,
                    8,
                    31
                ],
                2013: [
                    6,
                    27,
                    8,
                    7
                ],
                2014: [
                    7,
                    31,
                    9,
                    10
                ],
                2015: [
                    7,
                    23,
                    9,
                    2
                ],
                2016: [
                    6,
                    23,
                    8,
                    3
                ],
                2017: [
                    6,
                    22,
                    8,
                    2
                ],
                2018: [
                    6,
                    28,
                    8,
                    8
                ],
                2019: [
                    7,
                    4,
                    8,
                    14
                ],
                2020: [
                    7,
                    16,
                    8,
                    26
                ],
                2021: [
                    7,
                    22,
                    9,
                    1
                ],
                2022: [
                    7,
                    14,
                    8,
                    24
                ],
                2023: [
                    7,
                    6,
                    8,
                    16
                ],
                2024: [
                    6,
                    24,
                    8,
                    2
                ],
                2025: [
                    7,
                    3,
                    8,
                    13
                ],
                2026: [
                    7,
                    2,
                    8,
                    12
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    22,
                    11,
                    3
                ],
                2013: [
                    10,
                    4,
                    10,
                    18
                ],
                2014: [
                    10,
                    27,
                    11,
                    8
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    4,
                    10,
                    15
                ],
                2017: [
                    10,
                    2,
                    10,
                    14,
                    10,
                    30,
                    10,
                    30
                ],
                2018: [
                    10,
                    1,
                    10,
                    13
                ],
                2019: [
                    10,
                    4,
                    10,
                    18
                ],
                2020: [
                    10,
                    12,
                    10,
                    24
                ],
                2021: [
                    10,
                    18,
                    10,
                    30
                ],
                2022: [
                    10,
                    17,
                    10,
                    29
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    16,
                    10,
                    28
                ],
                2024: [
                    10,
                    4,
                    10,
                    19,
                    11,
                    1,
                    11,
                    1
                ],
                2025: [
                    10,
                    13,
                    10,
                    25
                ],
                2026: [
                    10,
                    12,
                    10,
                    24
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    4
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    5
                ],
                2015: [
                    12,
                    23,
                    1,
                    6
                ],
                2016: [
                    12,
                    21,
                    1,
                    6
                ],
                2017: [
                    12,
                    22,
                    1,
                    6
                ],
                2018: [
                    12,
                    24,
                    1,
                    4
                ],
                2019: [
                    12,
                    21,
                    1,
                    6
                ],
                2020: [
                    12,
                    23,
                    1,
                    8
                ],
                2021: [
                    12,
                    23,
                    1,
                    8
                ],
                2022: [
                    12,
                    23,
                    1,
                    6
                ],
                2023: [
                    12,
                    23,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    4
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    23,
                    1,
                    9
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Hamburg: {
        _state_code: "hh",
        SH: [
            {
                2012: [
                    1,
                    30,
                    1,
                    30
                ],
                2013: [
                    2,
                    1,
                    2,
                    1
                ],
                2014: [
                    1,
                    31,
                    1,
                    31
                ],
                2015: [
                    1,
                    30,
                    1,
                    30
                ],
                2016: [
                    1,
                    29,
                    1,
                    29
                ],
                2017: [
                    1,
                    30,
                    1,
                    30
                ],
                2018: [
                    2,
                    2,
                    2,
                    2
                ],
                2019: [
                    2,
                    1,
                    2,
                    1
                ],
                2020: [
                    1,
                    31,
                    1,
                    31
                ],
                2021: [
                    1,
                    29,
                    1,
                    29
                ],
                2022: [
                    1,
                    28,
                    1,
                    28
                ],
                2023: [
                    1,
                    27,
                    1,
                    27
                ],
                2024: [
                    2,
                    2,
                    2,
                    2
                ],
                2025: [
                    1,
                    31,
                    1,
                    31
                ],
                2026: [
                    1,
                    30,
                    1,
                    30
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    3,
                    5,
                    3,
                    16
                ],
                2013: [
                    3,
                    4,
                    3,
                    15
                ],
                2014: [
                    3,
                    3,
                    3,
                    14
                ],
                2015: [
                    3,
                    2,
                    3,
                    13
                ],
                2016: [
                    3,
                    7,
                    3,
                    18
                ],
                2017: [
                    3,
                    6,
                    3,
                    17
                ],
                2018: [
                    3,
                    5,
                    3,
                    16,
                    4,
                    30,
                    4,
                    30
                ],
                2019: [
                    3,
                    4,
                    3,
                    15
                ],
                2020: [
                    3,
                    2,
                    3,
                    13
                ],
                2021: [
                    3,
                    1,
                    3,
                    12
                ],
                2022: [
                    3,
                    7,
                    3,
                    18
                ],
                2023: [
                    3,
                    6,
                    3,
                    17
                ],
                2024: [
                    3,
                    18,
                    3,
                    28
                ],
                2025: [
                    3,
                    10,
                    3,
                    21
                ],
                2026: [
                    3,
                    2,
                    3,
                    13
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    4,
                    30,
                    5,
                    4,
                    5,
                    18,
                    5,
                    18
                ],
                2013: [
                    5,
                    2,
                    5,
                    10
                ],
                2014: [
                    4,
                    28,
                    5,
                    2,
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    11,
                    5,
                    15
                ],
                2016: [
                    5,
                    6,
                    5,
                    6,
                    5,
                    17,
                    5,
                    20
                ],
                2017: [
                    5,
                    22,
                    5,
                    26
                ],
                2018: [
                    5,
                    7,
                    5,
                    11
                ],
                2019: [
                    5,
                    13,
                    5,
                    17,
                    5,
                    31,
                    5,
                    31
                ],
                2020: [
                    5,
                    4,
                    5,
                    8
                ],
                2021: [
                    5,
                    10,
                    5,
                    14
                ],
                2022: [
                    5,
                    23,
                    5,
                    27
                ],
                2023: [
                    5,
                    15,
                    5,
                    19
                ],
                2024: [
                    5,
                    21,
                    5,
                    24
                ],
                2025: [
                    5,
                    2,
                    5,
                    2,
                    5,
                    26,
                    5,
                    30
                ],
                2026: [
                    5,
                    11,
                    5,
                    15
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    6,
                    21,
                    8,
                    1
                ],
                2013: [
                    6,
                    20,
                    7,
                    31
                ],
                2014: [
                    7,
                    10,
                    8,
                    20
                ],
                2015: [
                    7,
                    16,
                    8,
                    26
                ],
                2016: [
                    7,
                    21,
                    8,
                    31
                ],
                2017: [
                    7,
                    20,
                    8,
                    30
                ],
                2018: [
                    7,
                    5,
                    8,
                    15
                ],
                2019: [
                    6,
                    27,
                    8,
                    7
                ],
                2020: [
                    6,
                    25,
                    8,
                    5
                ],
                2021: [
                    6,
                    24,
                    8,
                    4
                ],
                2022: [
                    7,
                    7,
                    8,
                    17
                ],
                2023: [
                    7,
                    13,
                    8,
                    23
                ],
                2024: [
                    7,
                    18,
                    8,
                    28
                ],
                2025: [
                    7,
                    24,
                    9,
                    3
                ],
                2026: [
                    7,
                    9,
                    8,
                    19
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    1,
                    10,
                    12
                ],
                2013: [
                    9,
                    30,
                    10,
                    11
                ],
                2014: [
                    10,
                    13,
                    10,
                    24
                ],
                2015: [
                    10,
                    19,
                    10,
                    30
                ],
                2016: [
                    10,
                    17,
                    10,
                    28
                ],
                2017: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    16,
                    10,
                    27
                ],
                2018: [
                    10,
                    1,
                    10,
                    12
                ],
                2019: [
                    10,
                    4,
                    10,
                    18
                ],
                2020: [
                    10,
                    5,
                    10,
                    16
                ],
                2021: [
                    10,
                    4,
                    10,
                    15
                ],
                2022: [
                    10,
                    10,
                    10,
                    21
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    16,
                    10,
                    27
                ],
                2024: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    21,
                    11,
                    1
                ],
                2025: [
                    10,
                    20,
                    10,
                    31
                ],
                2026: [
                    10,
                    19,
                    10,
                    30
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    27,
                    1,
                    6
                ],
                2012: [
                    12,
                    21,
                    1,
                    4
                ],
                2013: [
                    12,
                    19,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    6
                ],
                2015: [
                    12,
                    21,
                    1,
                    1
                ],
                2016: [
                    12,
                    27,
                    1,
                    6
                ],
                2017: [
                    12,
                    22,
                    1,
                    5
                ],
                2018: [
                    12,
                    20,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    3
                ],
                2020: [
                    12,
                    21,
                    1,
                    4
                ],
                2021: [
                    12,
                    23,
                    1,
                    4
                ],
                2022: [
                    12,
                    23,
                    1,
                    6
                ],
                2023: [
                    12,
                    22,
                    1,
                    5
                ],
                2024: [
                    12,
                    20,
                    1,
                    3
                ],
                2025: [
                    12,
                    17,
                    1,
                    2
                ],
                2026: [
                    12,
                    21,
                    1,
                    1
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Hessen: {
        _state_code: "he",
        SH: [
            {
                2012: [
                    4,
                    2,
                    4,
                    14
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    14,
                    4,
                    26
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    29,
                    4,
                    9
                ],
                2017: [
                    4,
                    3,
                    4,
                    15
                ],
                2018: [
                    3,
                    26,
                    4,
                    7
                ],
                2019: [
                    4,
                    14,
                    4,
                    27
                ],
                2020: [
                    4,
                    6,
                    4,
                    18
                ],
                2021: [
                    4,
                    6,
                    4,
                    16
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    22
                ],
                2024: [
                    3,
                    25,
                    4,
                    13
                ],
                2025: [
                    4,
                    7,
                    4,
                    21
                ],
                2026: [
                    3,
                    30,
                    4,
                    10
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    7,
                    2,
                    8,
                    10
                ],
                2013: [
                    7,
                    8,
                    8,
                    16
                ],
                2014: [
                    7,
                    28,
                    9,
                    5
                ],
                2015: [
                    7,
                    27,
                    9,
                    4
                ],
                2016: [
                    7,
                    18,
                    8,
                    26
                ],
                2017: [
                    7,
                    3,
                    8,
                    11
                ],
                2018: [
                    6,
                    25,
                    8,
                    3
                ],
                2019: [
                    7,
                    1,
                    8,
                    9
                ],
                2020: [
                    7,
                    6,
                    8,
                    14
                ],
                2021: [
                    7,
                    19,
                    8,
                    27
                ],
                2022: [
                    7,
                    25,
                    9,
                    2
                ],
                2023: [
                    7,
                    24,
                    9,
                    1
                ],
                2024: [
                    7,
                    15,
                    8,
                    23
                ],
                2025: [
                    7,
                    7,
                    8,
                    15
                ],
                2026: [
                    6,
                    29,
                    8,
                    7
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    15,
                    10,
                    27
                ],
                2013: [
                    10,
                    14,
                    10,
                    26
                ],
                2014: [
                    10,
                    20,
                    11,
                    1
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    17,
                    10,
                    29
                ],
                2017: [
                    10,
                    9,
                    10,
                    21
                ],
                2018: [
                    10,
                    1,
                    10,
                    13
                ],
                2019: [
                    9,
                    30,
                    10,
                    12
                ],
                2020: [
                    10,
                    5,
                    10,
                    17
                ],
                2021: [
                    10,
                    11,
                    10,
                    23
                ],
                2022: [
                    10,
                    24,
                    10,
                    29
                ],
                2023: [
                    10,
                    23,
                    10,
                    28
                ],
                2024: [],
                2025: [
                    10,
                    6,
                    10,
                    18
                ],
                2026: [
                    10,
                    5,
                    10,
                    17
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    21,
                    1,
                    6
                ],
                2012: [
                    12,
                    24,
                    1,
                    12
                ],
                2013: [
                    12,
                    23,
                    1,
                    11
                ],
                2014: [
                    12,
                    22,
                    1,
                    10
                ],
                2015: [
                    12,
                    23,
                    1,
                    9
                ],
                2016: [
                    12,
                    22,
                    1,
                    7
                ],
                2017: [
                    12,
                    24,
                    1,
                    13
                ],
                2018: [
                    12,
                    24,
                    1,
                    12
                ],
                2019: [
                    12,
                    23,
                    1,
                    11
                ],
                2020: [
                    12,
                    21,
                    1,
                    9
                ],
                2021: [
                    12,
                    23,
                    1,
                    8
                ],
                2022: [
                    12,
                    22,
                    1,
                    7
                ],
                2023: [
                    12,
                    27,
                    1,
                    13
                ],
                2024: [],
                2025: [
                    12,
                    22,
                    1,
                    10
                ],
                2026: [
                    12,
                    23,
                    1,
                    12
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    "Mecklenburg-Vorpommern": {
        _state_code: "mv",
        SH: [
            {
                2012: [
                    2,
                    6,
                    2,
                    17
                ],
                2013: [
                    2,
                    4,
                    2,
                    15
                ],
                2014: [
                    2,
                    3,
                    2,
                    15
                ],
                2015: [
                    2,
                    2,
                    2,
                    14
                ],
                2016: [
                    2,
                    1,
                    2,
                    13
                ],
                2017: [
                    2,
                    6,
                    2,
                    18
                ],
                2018: [
                    2,
                    5,
                    2,
                    16
                ],
                2019: [
                    2,
                    4,
                    2,
                    15
                ],
                2020: [
                    2,
                    10,
                    2,
                    21
                ],
                2021: [
                    2,
                    6,
                    2,
                    19
                ],
                2022: [
                    2,
                    5,
                    2,
                    17
                ],
                2023: [
                    2,
                    6,
                    2,
                    18
                ],
                2024: [
                    2,
                    5,
                    2,
                    16
                ],
                2025: [
                    2,
                    3,
                    2,
                    14
                ],
                2026: [
                    2,
                    9,
                    2,
                    20
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    11
                ],
                2013: [
                    3,
                    25,
                    4,
                    3
                ],
                2014: [
                    4,
                    14,
                    4,
                    23
                ],
                2015: [
                    3,
                    30,
                    4,
                    8
                ],
                2016: [
                    3,
                    21,
                    3,
                    30
                ],
                2017: [
                    4,
                    10,
                    4,
                    19
                ],
                2018: [
                    3,
                    26,
                    4,
                    4
                ],
                2019: [
                    4,
                    15,
                    4,
                    24
                ],
                2020: [
                    4,
                    6,
                    4,
                    15
                ],
                2021: [
                    3,
                    29,
                    4,
                    7
                ],
                2022: [
                    4,
                    11,
                    4,
                    20
                ],
                2023: [
                    4,
                    3,
                    4,
                    12
                ],
                2024: [
                    3,
                    25,
                    4,
                    3
                ],
                2025: [
                    4,
                    14,
                    4,
                    23,
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    3,
                    30,
                    4,
                    8
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    25,
                    5,
                    29
                ],
                2013: [
                    5,
                    17,
                    5,
                    21
                ],
                2014: [
                    6,
                    6,
                    6,
                    10
                ],
                2015: [
                    5,
                    22,
                    5,
                    26
                ],
                2016: [
                    5,
                    14,
                    5,
                    17
                ],
                2017: [
                    6,
                    2,
                    6,
                    6
                ],
                2018: [
                    5,
                    11,
                    5,
                    11,
                    5,
                    18,
                    5,
                    22
                ],
                2019: [
                    5,
                    22,
                    5,
                    22,
                    6,
                    7,
                    6,
                    11
                ],
                2020: [
                    5,
                    22,
                    5,
                    22,
                    5,
                    29,
                    6,
                    2
                ],
                2021: [
                    5,
                    14,
                    5,
                    14,
                    5,
                    21,
                    5,
                    25
                ],
                2022: [
                    5,
                    27,
                    5,
                    27,
                    6,
                    3,
                    6,
                    7
                ],
                2023: [
                    5,
                    19,
                    5,
                    19,
                    5,
                    26,
                    5,
                    30
                ],
                2024: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    17,
                    5,
                    21
                ],
                2025: [
                    6,
                    6,
                    6,
                    10
                ],
                2026: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    22,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    6,
                    23,
                    8,
                    4
                ],
                2013: [
                    6,
                    22,
                    8,
                    3
                ],
                2014: [
                    7,
                    14,
                    8,
                    23
                ],
                2015: [
                    7,
                    20,
                    8,
                    29
                ],
                2016: [
                    7,
                    25,
                    9,
                    3
                ],
                2017: [
                    7,
                    24,
                    9,
                    2
                ],
                2018: [
                    7,
                    9,
                    8,
                    18
                ],
                2019: [
                    7,
                    1,
                    8,
                    10
                ],
                2020: [
                    6,
                    22,
                    8,
                    1
                ],
                2021: [
                    6,
                    21,
                    7,
                    31
                ],
                2022: [
                    7,
                    4,
                    8,
                    13
                ],
                2023: [
                    7,
                    17,
                    8,
                    26
                ],
                2024: [
                    7,
                    22,
                    8,
                    31
                ],
                2025: [
                    7,
                    28,
                    9,
                    6
                ],
                2026: [
                    7,
                    13,
                    8,
                    22
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    1,
                    10,
                    5
                ],
                2013: [
                    10,
                    14,
                    10,
                    19
                ],
                2014: [
                    10,
                    20,
                    10,
                    25
                ],
                2015: [
                    10,
                    24,
                    10,
                    30
                ],
                2016: [
                    10,
                    24,
                    10,
                    28
                ],
                2017: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    23,
                    10,
                    30
                ],
                2018: [
                    10,
                    8,
                    10,
                    13,
                    11,
                    1,
                    11,
                    2
                ],
                2019: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    7,
                    10,
                    12,
                    11,
                    1,
                    11,
                    1
                ],
                2020: [
                    10,
                    5,
                    10,
                    10,
                    11,
                    2,
                    11,
                    3
                ],
                2021: [
                    10,
                    2,
                    10,
                    9,
                    11,
                    1,
                    11,
                    2
                ],
                2022: [
                    10,
                    10,
                    10,
                    14,
                    11,
                    1,
                    11,
                    2
                ],
                2023: [
                    10,
                    9,
                    10,
                    14,
                    10,
                    30,
                    10,
                    30,
                    11,
                    1,
                    11,
                    1
                ],
                2024: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    21,
                    10,
                    26,
                    11,
                    1,
                    11,
                    1
                ],
                2025: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    20,
                    10,
                    25,
                    11,
                    3,
                    11,
                    3
                ],
                2026: [
                    10,
                    19,
                    10,
                    24,
                    11,
                    26,
                    11,
                    27
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    3
                ],
                2012: [
                    12,
                    21,
                    1,
                    4
                ],
                2013: [
                    12,
                    23,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    2
                ],
                2015: [
                    12,
                    21,
                    1,
                    2
                ],
                2016: [
                    12,
                    22,
                    1,
                    2
                ],
                2017: [
                    12,
                    21,
                    1,
                    3
                ],
                2018: [
                    12,
                    24,
                    1,
                    5
                ],
                2019: [
                    12,
                    23,
                    1,
                    4
                ],
                2020: [
                    12,
                    21,
                    1,
                    2
                ],
                2021: [
                    12,
                    22,
                    12,
                    31
                ],
                2022: [
                    12,
                    22,
                    1,
                    2
                ],
                2023: [
                    12,
                    21,
                    1,
                    3
                ],
                2024: [
                    12,
                    23,
                    1,
                    6
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    19,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Niedersachsen: {
        _state_code: "ni",
        SH: [
            {
                2012: [
                    1,
                    30,
                    1,
                    31
                ],
                2013: [
                    1,
                    31,
                    2,
                    1
                ],
                2014: [
                    1,
                    30,
                    1,
                    31
                ],
                2015: [
                    2,
                    2,
                    2,
                    3
                ],
                2016: [
                    1,
                    28,
                    1,
                    29
                ],
                2017: [
                    1,
                    30,
                    1,
                    31
                ],
                2018: [
                    2,
                    1,
                    2,
                    2
                ],
                2019: [
                    1,
                    31,
                    2,
                    1
                ],
                2020: [
                    2,
                    3,
                    2,
                    4
                ],
                2021: [
                    2,
                    1,
                    2,
                    2
                ],
                2022: [
                    1,
                    31,
                    2,
                    1
                ],
                2023: [
                    1,
                    30,
                    1,
                    31
                ],
                2024: [
                    2,
                    1,
                    2,
                    2
                ],
                2025: [
                    2,
                    3,
                    2,
                    4
                ],
                2026: [
                    2,
                    2,
                    2,
                    3
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    3,
                    26,
                    4,
                    11,
                    4,
                    30,
                    4,
                    30
                ],
                2013: [
                    3,
                    16,
                    4,
                    2
                ],
                2014: [
                    4,
                    3,
                    4,
                    22,
                    5,
                    2,
                    5,
                    2
                ],
                2015: [
                    3,
                    25,
                    4,
                    10
                ],
                2016: [
                    3,
                    18,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    19,
                    4,
                    3
                ],
                2019: [
                    4,
                    8,
                    4,
                    23
                ],
                2020: [
                    3,
                    30,
                    4,
                    14
                ],
                2021: [
                    3,
                    29,
                    4,
                    9
                ],
                2022: [
                    4,
                    4,
                    4,
                    19
                ],
                2023: [
                    3,
                    27,
                    4,
                    11
                ],
                2024: [
                    3,
                    18,
                    4,
                    2
                ],
                2025: [
                    4,
                    7,
                    4,
                    19,
                    4,
                    30,
                    4,
                    30
                ],
                2026: [
                    3,
                    23,
                    4,
                    7
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18,
                    5,
                    29,
                    5,
                    29
                ],
                2013: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    21,
                    5,
                    21
                ],
                2014: [
                    5,
                    30,
                    5,
                    30,
                    6,
                    10,
                    6,
                    10
                ],
                2015: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    26,
                    5,
                    26
                ],
                2016: [
                    5,
                    6,
                    5,
                    6,
                    5,
                    17,
                    5,
                    17
                ],
                2017: [
                    5,
                    26,
                    5,
                    26,
                    6,
                    6,
                    6,
                    6
                ],
                2018: [
                    4,
                    30,
                    4,
                    30,
                    5,
                    11,
                    5,
                    11,
                    5,
                    22,
                    5,
                    22
                ],
                2019: [
                    5,
                    31,
                    5,
                    31,
                    6,
                    11,
                    6,
                    11
                ],
                2020: [
                    5,
                    22,
                    5,
                    22,
                    6,
                    2,
                    6,
                    2
                ],
                2021: [
                    5,
                    14,
                    5,
                    14,
                    5,
                    25,
                    5,
                    25
                ],
                2022: [
                    5,
                    27,
                    5,
                    27,
                    6,
                    7,
                    6,
                    7
                ],
                2023: [
                    5,
                    19,
                    5,
                    19,
                    5,
                    30,
                    5,
                    30
                ],
                2024: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    21,
                    5,
                    21
                ],
                2025: [
                    5,
                    2,
                    5,
                    2,
                    5,
                    30,
                    5,
                    30,
                    6,
                    10,
                    6,
                    10
                ],
                2026: [
                    5,
                    15,
                    5,
                    15,
                    5,
                    26,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    23,
                    8,
                    31
                ],
                2013: [
                    6,
                    27,
                    8,
                    7
                ],
                2014: [
                    7,
                    31,
                    9,
                    10
                ],
                2015: [
                    7,
                    23,
                    9,
                    2
                ],
                2016: [
                    6,
                    23,
                    8,
                    3
                ],
                2017: [
                    6,
                    22,
                    8,
                    2
                ],
                2018: [
                    6,
                    28,
                    8,
                    8
                ],
                2019: [
                    7,
                    4,
                    8,
                    14
                ],
                2020: [
                    7,
                    16,
                    8,
                    26
                ],
                2021: [
                    7,
                    22,
                    9,
                    1
                ],
                2022: [
                    7,
                    14,
                    8,
                    24
                ],
                2023: [
                    7,
                    6,
                    8,
                    16
                ],
                2024: [
                    6,
                    24,
                    8,
                    2
                ],
                2025: [
                    7,
                    3,
                    8,
                    13
                ],
                2026: [
                    7,
                    2,
                    8,
                    12
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    22,
                    11,
                    3
                ],
                2013: [
                    10,
                    4,
                    10,
                    18
                ],
                2014: [
                    10,
                    27,
                    11,
                    8
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    4,
                    10,
                    15
                ],
                2017: [
                    10,
                    2,
                    10,
                    13,
                    10,
                    30,
                    10,
                    30
                ],
                2018: [
                    10,
                    1,
                    10,
                    12
                ],
                2019: [
                    10,
                    4,
                    10,
                    18
                ],
                2020: [
                    10,
                    12,
                    10,
                    23
                ],
                2021: [
                    10,
                    18,
                    10,
                    29
                ],
                2022: [
                    10,
                    17,
                    10,
                    28
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    16,
                    10,
                    27
                ],
                2024: [
                    10,
                    4,
                    10,
                    19,
                    11,
                    1,
                    11,
                    1
                ],
                2025: [
                    10,
                    13,
                    10,
                    25
                ],
                2026: [
                    10,
                    12,
                    10,
                    24
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    4
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    5
                ],
                2015: [
                    12,
                    23,
                    1,
                    6
                ],
                2016: [
                    12,
                    21,
                    1,
                    6
                ],
                2017: [
                    12,
                    22,
                    1,
                    5
                ],
                2018: [
                    12,
                    24,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    6
                ],
                2020: [
                    12,
                    23,
                    1,
                    8
                ],
                2021: [
                    12,
                    23,
                    1,
                    7
                ],
                2022: [
                    12,
                    23,
                    1,
                    6
                ],
                2023: [
                    12,
                    27,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    4
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    23,
                    1,
                    9
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    "Nordrhein-Westfalen": {
        _state_code: "nw",
        SH: [
            {
                2012: [
                    4,
                    2,
                    4,
                    14
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    14,
                    4,
                    26
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    21,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    26,
                    4,
                    7
                ],
                2019: [
                    4,
                    15,
                    4,
                    27
                ],
                2020: [
                    4,
                    6,
                    4,
                    18
                ],
                2021: [
                    3,
                    29,
                    4,
                    10
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    15
                ],
                2024: [
                    3,
                    25,
                    4,
                    6
                ],
                2025: [
                    4,
                    14,
                    4,
                    26
                ],
                2026: [
                    3,
                    30,
                    4,
                    11
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    29,
                    5,
                    29
                ],
                2013: [
                    5,
                    21,
                    5,
                    21
                ],
                2014: [
                    6,
                    10,
                    6,
                    10
                ],
                2015: [
                    5,
                    26,
                    5,
                    26
                ],
                2016: [
                    5,
                    17,
                    5,
                    17
                ],
                2017: [
                    6,
                    6,
                    6,
                    6
                ],
                2018: [
                    5,
                    22,
                    5,
                    25
                ],
                2019: [
                    6,
                    11,
                    6,
                    11
                ],
                2020: [
                    6,
                    2,
                    6,
                    2
                ],
                2021: [
                    5,
                    25,
                    5,
                    25
                ],
                2022: [],
                2023: [
                    5,
                    30,
                    5,
                    30
                ],
                2024: [
                    5,
                    21,
                    5,
                    21
                ],
                2025: [
                    6,
                    10,
                    6,
                    10
                ],
                2026: [
                    5,
                    26,
                    5,
                    26
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    9,
                    8,
                    21
                ],
                2013: [
                    7,
                    22,
                    9,
                    3
                ],
                2014: [
                    7,
                    7,
                    8,
                    19
                ],
                2015: [
                    6,
                    29,
                    8,
                    11
                ],
                2016: [
                    7,
                    11,
                    8,
                    23
                ],
                2017: [
                    7,
                    17,
                    8,
                    29
                ],
                2018: [
                    7,
                    16,
                    8,
                    28
                ],
                2019: [
                    7,
                    15,
                    8,
                    27
                ],
                2020: [
                    6,
                    29,
                    8,
                    11
                ],
                2021: [
                    7,
                    5,
                    8,
                    17
                ],
                2022: [
                    6,
                    27,
                    8,
                    9
                ],
                2023: [
                    6,
                    22,
                    8,
                    4
                ],
                2024: [
                    7,
                    8,
                    8,
                    20
                ],
                2025: [
                    7,
                    14,
                    8,
                    26
                ],
                2026: [
                    7,
                    20,
                    9,
                    1
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    8,
                    10,
                    20
                ],
                2013: [
                    10,
                    21,
                    11,
                    2
                ],
                2014: [
                    10,
                    6,
                    10,
                    18
                ],
                2015: [
                    10,
                    5,
                    10,
                    17
                ],
                2016: [
                    10,
                    10,
                    10,
                    21
                ],
                2017: [
                    10,
                    23,
                    11,
                    4
                ],
                2018: [
                    10,
                    15,
                    10,
                    27
                ],
                2019: [
                    10,
                    14,
                    10,
                    26
                ],
                2020: [
                    10,
                    12,
                    10,
                    24
                ],
                2021: [
                    10,
                    11,
                    10,
                    23
                ],
                2022: [
                    10,
                    4,
                    10,
                    15
                ],
                2023: [
                    10,
                    2,
                    10,
                    14
                ],
                2024: [
                    10,
                    14,
                    10,
                    26
                ],
                2025: [
                    10,
                    13,
                    10,
                    25
                ],
                2026: [
                    10,
                    17,
                    10,
                    31
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    6
                ],
                2012: [
                    12,
                    21,
                    1,
                    4
                ],
                2013: [
                    12,
                    23,
                    1,
                    7
                ],
                2014: [
                    12,
                    22,
                    1,
                    6
                ],
                2015: [
                    12,
                    23,
                    1,
                    6
                ],
                2016: [
                    12,
                    23,
                    1,
                    6
                ],
                2017: [
                    12,
                    27,
                    1,
                    6
                ],
                2018: [
                    12,
                    21,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    6
                ],
                2020: [
                    12,
                    23,
                    1,
                    6
                ],
                2021: [
                    12,
                    24,
                    1,
                    8
                ],
                2022: [
                    12,
                    23,
                    1,
                    6
                ],
                2023: [
                    12,
                    21,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    6
                ],
                2025: [
                    12,
                    22,
                    1,
                    6
                ],
                2026: [
                    12,
                    23,
                    1,
                    6
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    "Rheinland-Pfalz": {
        _state_code: "rp",
        SH: [
            {
                2019: [
                    2,
                    25,
                    3,
                    1
                ],
                2020: [
                    2,
                    17,
                    2,
                    21
                ],
                2022: [
                    2,
                    21,
                    2,
                    25
                ],
                2023: [],
                2024: [],
                2025: [],
                2026: [],
                name: "Winterferien"
            },
            {
                2012: [
                    3,
                    29,
                    4,
                    13
                ],
                2013: [
                    3,
                    20,
                    4,
                    5
                ],
                2014: [
                    4,
                    11,
                    4,
                    25
                ],
                2015: [
                    3,
                    26,
                    4,
                    10
                ],
                2016: [
                    3,
                    18,
                    4,
                    1
                ],
                2017: [
                    4,
                    10,
                    4,
                    21
                ],
                2018: [
                    3,
                    26,
                    4,
                    6
                ],
                2019: [
                    4,
                    23,
                    4,
                    30
                ],
                2020: [
                    4,
                    9,
                    4,
                    17
                ],
                2021: [
                    3,
                    29,
                    4,
                    6
                ],
                2022: [
                    4,
                    13,
                    4,
                    22
                ],
                2023: [
                    4,
                    3,
                    4,
                    6
                ],
                2024: [
                    3,
                    25,
                    4,
                    2
                ],
                2025: [
                    4,
                    14,
                    4,
                    25
                ],
                2026: [
                    3,
                    30,
                    4,
                    10
                ],
                name: "Osterferien"
            },
            {
                2021: [
                    5,
                    25,
                    6,
                    2
                ],
                2022: [],
                2023: [
                    5,
                    30,
                    6,
                    7
                ],
                2024: [
                    5,
                    21,
                    5,
                    29
                ],
                2025: [],
                2026: [],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    2,
                    8,
                    10
                ],
                2013: [
                    7,
                    8,
                    8,
                    16
                ],
                2014: [
                    7,
                    28,
                    9,
                    5
                ],
                2015: [
                    7,
                    27,
                    9,
                    4
                ],
                2016: [
                    7,
                    18,
                    8,
                    26
                ],
                2017: [
                    7,
                    3,
                    8,
                    11
                ],
                2018: [
                    6,
                    25,
                    8,
                    3
                ],
                2019: [
                    7,
                    1,
                    8,
                    9
                ],
                2020: [
                    7,
                    6,
                    8,
                    14
                ],
                2021: [
                    7,
                    19,
                    8,
                    27
                ],
                2022: [
                    7,
                    25,
                    9,
                    2
                ],
                2023: [
                    7,
                    24,
                    9,
                    1
                ],
                2024: [
                    7,
                    15,
                    8,
                    23
                ],
                2025: [
                    7,
                    7,
                    8,
                    15
                ],
                2026: [
                    6,
                    29,
                    8,
                    7
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    1,
                    10,
                    12
                ],
                2013: [
                    10,
                    4,
                    10,
                    18
                ],
                2014: [
                    10,
                    20,
                    10,
                    31
                ],
                2015: [
                    10,
                    19,
                    10,
                    30
                ],
                2016: [
                    10,
                    10,
                    10,
                    21
                ],
                2017: [
                    10,
                    2,
                    10,
                    13
                ],
                2018: [
                    10,
                    1,
                    10,
                    12
                ],
                2019: [
                    9,
                    30,
                    10,
                    11
                ],
                2020: [
                    10,
                    12,
                    10,
                    23
                ],
                2021: [
                    10,
                    11,
                    10,
                    22
                ],
                2022: [
                    10,
                    17,
                    10,
                    31
                ],
                2023: [
                    10,
                    16,
                    10,
                    27
                ],
                2024: [
                    10,
                    14,
                    10,
                    25
                ],
                2025: [
                    10,
                    13,
                    10,
                    24
                ],
                2026: [
                    10,
                    5,
                    10,
                    16
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    22,
                    1,
                    6
                ],
                2012: [
                    12,
                    20,
                    1,
                    4
                ],
                2013: [
                    12,
                    23,
                    1,
                    7
                ],
                2014: [
                    12,
                    22,
                    1,
                    7
                ],
                2015: [
                    12,
                    23,
                    1,
                    8
                ],
                2016: [
                    12,
                    22,
                    1,
                    6
                ],
                2017: [
                    12,
                    22,
                    1,
                    9
                ],
                2018: [
                    12,
                    20,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    6
                ],
                2020: [
                    12,
                    21,
                    12,
                    31
                ],
                2021: [
                    12,
                    23,
                    12,
                    31
                ],
                2022: [
                    12,
                    23,
                    1,
                    2
                ],
                2023: [
                    12,
                    27,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    8
                ],
                2025: [
                    12,
                    22,
                    1,
                    7
                ],
                2026: [
                    12,
                    23,
                    1,
                    8
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Saarland: {
        _state_code: "sl",
        SH: [
            {
                2012: [
                    2,
                    20,
                    2,
                    25
                ],
                2013: [
                    2,
                    11,
                    2,
                    16
                ],
                2014: [
                    3,
                    3,
                    3,
                    8
                ],
                2015: [
                    2,
                    16,
                    2,
                    21
                ],
                2016: [
                    2,
                    8,
                    2,
                    13
                ],
                2017: [
                    2,
                    27,
                    3,
                    4
                ],
                2018: [
                    2,
                    12,
                    2,
                    17
                ],
                2019: [
                    2,
                    25,
                    3,
                    5
                ],
                2020: [
                    2,
                    17,
                    2,
                    25
                ],
                2021: [
                    2,
                    15,
                    2,
                    19
                ],
                2022: [
                    2,
                    21,
                    3,
                    1
                ],
                2023: [
                    2,
                    20,
                    2,
                    24
                ],
                2024: [
                    2,
                    12,
                    2,
                    16
                ],
                2025: [
                    2,
                    24,
                    3,
                    4
                ],
                2026: [
                    2,
                    16,
                    2,
                    20
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    14
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    14,
                    4,
                    26
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    29,
                    4,
                    9
                ],
                2017: [
                    4,
                    10,
                    4,
                    22
                ],
                2018: [
                    3,
                    26,
                    4,
                    6
                ],
                2019: [
                    4,
                    17,
                    4,
                    26
                ],
                2020: [
                    4,
                    14,
                    4,
                    24
                ],
                2021: [
                    3,
                    29,
                    4,
                    7
                ],
                2022: [
                    4,
                    14,
                    4,
                    22
                ],
                2023: [
                    4,
                    3,
                    4,
                    12
                ],
                2024: [
                    3,
                    25,
                    4,
                    5
                ],
                2025: [
                    4,
                    14,
                    4,
                    25
                ],
                2026: [
                    4,
                    7,
                    4,
                    17
                ],
                name: "Osterferien"
            },
            {
                2021: [
                    5,
                    25,
                    5,
                    28
                ],
                2022: [
                    6,
                    7,
                    6,
                    10
                ],
                2023: [
                    5,
                    30,
                    6,
                    2
                ],
                2024: [
                    5,
                    21,
                    5,
                    24
                ],
                2025: [],
                2026: [],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    2,
                    8,
                    14
                ],
                2013: [
                    7,
                    8,
                    8,
                    17
                ],
                2014: [
                    7,
                    28,
                    9,
                    6
                ],
                2015: [
                    7,
                    27,
                    9,
                    5
                ],
                2016: [
                    7,
                    18,
                    8,
                    27
                ],
                2017: [
                    7,
                    3,
                    8,
                    14
                ],
                2018: [
                    6,
                    25,
                    8,
                    3
                ],
                2019: [
                    7,
                    1,
                    8,
                    9
                ],
                2020: [
                    7,
                    6,
                    8,
                    14
                ],
                2021: [
                    7,
                    19,
                    8,
                    27
                ],
                2022: [
                    7,
                    25,
                    9,
                    2
                ],
                2023: [
                    7,
                    24,
                    9,
                    1
                ],
                2024: [
                    7,
                    15,
                    8,
                    23
                ],
                2025: [
                    7,
                    7,
                    8,
                    14
                ],
                2026: [
                    6,
                    29,
                    8,
                    7
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    22,
                    11,
                    3
                ],
                2013: [
                    10,
                    21,
                    11,
                    2
                ],
                2014: [
                    10,
                    20,
                    10,
                    31
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    10,
                    10,
                    22
                ],
                2017: [
                    10,
                    2,
                    10,
                    14
                ],
                2018: [
                    10,
                    1,
                    10,
                    12
                ],
                2019: [
                    10,
                    7,
                    10,
                    18
                ],
                2020: [
                    10,
                    12,
                    10,
                    23
                ],
                2021: [
                    10,
                    18,
                    10,
                    29
                ],
                2022: [
                    10,
                    24,
                    11,
                    4
                ],
                2023: [
                    10,
                    23,
                    11,
                    3
                ],
                2024: [
                    10,
                    14,
                    10,
                    25
                ],
                2025: [
                    10,
                    13,
                    10,
                    24
                ],
                2026: [
                    10,
                    5,
                    10,
                    16
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    4
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    20,
                    1,
                    4
                ],
                2014: [
                    12,
                    22,
                    1,
                    7
                ],
                2015: [
                    12,
                    21,
                    1,
                    2
                ],
                2016: [
                    12,
                    19,
                    12,
                    31
                ],
                2017: [
                    12,
                    21,
                    1,
                    5
                ],
                2018: [
                    12,
                    20,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    3
                ],
                2020: [
                    12,
                    21,
                    12,
                    31
                ],
                2021: [
                    12,
                    23,
                    1,
                    3
                ],
                2022: [
                    12,
                    22,
                    1,
                    4
                ],
                2023: [
                    12,
                    21,
                    1,
                    2
                ],
                2024: [
                    12,
                    23,
                    1,
                    3
                ],
                2025: [
                    12,
                    22,
                    1,
                    2
                ],
                2026: [
                    12,
                    21,
                    12,
                    31
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    Sachsen: {
        _state_code: "sn",
        SH: [
            {
                2012: [
                    2,
                    13,
                    2,
                    25
                ],
                2013: [
                    2,
                    4,
                    2,
                    15
                ],
                2014: [
                    2,
                    17,
                    3,
                    1
                ],
                2015: [
                    2,
                    9,
                    2,
                    21
                ],
                2016: [
                    2,
                    8,
                    2,
                    20
                ],
                2017: [
                    2,
                    13,
                    2,
                    24
                ],
                2018: [
                    2,
                    12,
                    2,
                    23
                ],
                2019: [
                    2,
                    18,
                    3,
                    2
                ],
                2020: [
                    2,
                    10,
                    2,
                    22
                ],
                2021: [
                    2,
                    8,
                    2,
                    20
                ],
                2022: [
                    2,
                    12,
                    2,
                    26
                ],
                2023: [
                    2,
                    13,
                    2,
                    24
                ],
                2024: [
                    2,
                    12,
                    2,
                    23
                ],
                2025: [
                    2,
                    17,
                    3,
                    1
                ],
                2026: [
                    2,
                    9,
                    2,
                    21
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    6,
                    4,
                    14
                ],
                2013: [
                    3,
                    29,
                    4,
                    6
                ],
                2014: [
                    4,
                    18,
                    4,
                    26
                ],
                2015: [
                    4,
                    2,
                    4,
                    11
                ],
                2016: [
                    3,
                    25,
                    4,
                    2
                ],
                2017: [
                    4,
                    13,
                    4,
                    22
                ],
                2018: [
                    3,
                    29,
                    4,
                    6
                ],
                2019: [
                    4,
                    19,
                    4,
                    26
                ],
                2020: [
                    4,
                    10,
                    4,
                    18
                ],
                2021: [
                    4,
                    2,
                    4,
                    10
                ],
                2022: [
                    4,
                    15,
                    4,
                    23
                ],
                2023: [
                    4,
                    7,
                    4,
                    15
                ],
                2024: [
                    3,
                    28,
                    4,
                    5
                ],
                2025: [
                    4,
                    18,
                    4,
                    25,
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    4,
                    3,
                    4,
                    10,
                    5,
                    15,
                    5,
                    15
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18
                ],
                2013: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    18,
                    5,
                    22
                ],
                2014: [
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    15,
                    5,
                    15
                ],
                2016: [
                    5,
                    6,
                    5,
                    6
                ],
                2017: [
                    5,
                    26,
                    5,
                    26
                ],
                2018: [
                    5,
                    11,
                    5,
                    11,
                    5,
                    19,
                    5,
                    22
                ],
                2019: [
                    5,
                    31,
                    5,
                    31
                ],
                2020: [
                    5,
                    22,
                    5,
                    22
                ],
                2021: [
                    5,
                    14,
                    5,
                    14
                ],
                2022: [
                    5,
                    27,
                    5,
                    27
                ],
                2023: [
                    5,
                    19,
                    5,
                    19
                ],
                2024: [
                    5,
                    10,
                    5,
                    10,
                    5,
                    18,
                    5,
                    21
                ],
                2025: [],
                2026: [],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    23,
                    8,
                    31
                ],
                2013: [
                    7,
                    15,
                    8,
                    23
                ],
                2014: [
                    7,
                    21,
                    8,
                    29
                ],
                2015: [
                    7,
                    13,
                    8,
                    21
                ],
                2016: [
                    6,
                    27,
                    8,
                    5
                ],
                2017: [
                    6,
                    26,
                    8,
                    4
                ],
                2018: [
                    7,
                    2,
                    8,
                    10
                ],
                2019: [
                    7,
                    8,
                    8,
                    16
                ],
                2020: [
                    7,
                    20,
                    8,
                    28
                ],
                2021: [
                    7,
                    26,
                    9,
                    3
                ],
                2022: [
                    7,
                    18,
                    8,
                    26
                ],
                2023: [
                    7,
                    10,
                    8,
                    18
                ],
                2024: [
                    6,
                    20,
                    7,
                    31
                ],
                2025: [
                    6,
                    28,
                    8,
                    8
                ],
                2026: [
                    7,
                    4,
                    8,
                    14
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    22,
                    11,
                    2
                ],
                2013: [
                    10,
                    21,
                    11,
                    1
                ],
                2014: [
                    10,
                    20,
                    10,
                    31
                ],
                2015: [
                    10,
                    12,
                    10,
                    24
                ],
                2016: [
                    10,
                    3,
                    10,
                    15
                ],
                2017: [
                    10,
                    2,
                    10,
                    14,
                    10,
                    30,
                    10,
                    30
                ],
                2018: [
                    10,
                    8,
                    10,
                    20
                ],
                2019: [
                    10,
                    14,
                    10,
                    25
                ],
                2020: [
                    10,
                    19,
                    10,
                    31
                ],
                2021: [
                    10,
                    18,
                    10,
                    30
                ],
                2022: [
                    10,
                    17,
                    10,
                    29
                ],
                2023: [
                    10,
                    2,
                    10,
                    14,
                    10,
                    30,
                    10,
                    30
                ],
                2024: [
                    10,
                    7,
                    10,
                    19
                ],
                2025: [
                    10,
                    6,
                    10,
                    18
                ],
                2026: [
                    10,
                    12,
                    10,
                    24
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    2
                ],
                2012: [
                    12,
                    22,
                    1,
                    2
                ],
                2013: [
                    12,
                    21,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    3
                ],
                2015: [
                    12,
                    21,
                    1,
                    2
                ],
                2016: [
                    12,
                    23,
                    1,
                    2
                ],
                2017: [
                    12,
                    23,
                    1,
                    2
                ],
                2018: [
                    12,
                    22,
                    1,
                    4
                ],
                2019: [
                    12,
                    21,
                    1,
                    3
                ],
                2020: [
                    12,
                    23,
                    1,
                    2
                ],
                2021: [
                    12,
                    23,
                    1,
                    1
                ],
                2022: [
                    12,
                    22,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    2
                ],
                2024: [
                    12,
                    23,
                    1,
                    3
                ],
                2025: [
                    12,
                    22,
                    1,
                    2
                ],
                2026: [
                    12,
                    23,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    "Sachsen-Anhalt": {
        _state_code: "st",
        SH: [
            {
                2012: [
                    2,
                    4,
                    2,
                    11
                ],
                2013: [
                    2,
                    1,
                    2,
                    8
                ],
                2014: [
                    2,
                    1,
                    2,
                    12
                ],
                2015: [
                    2,
                    2,
                    2,
                    14
                ],
                2016: [
                    2,
                    1,
                    2,
                    10
                ],
                2017: [
                    2,
                    4,
                    2,
                    11
                ],
                2018: [
                    2,
                    5,
                    2,
                    9
                ],
                2019: [
                    2,
                    11,
                    2,
                    15
                ],
                2020: [
                    2,
                    10,
                    2,
                    14
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    12,
                    2,
                    19
                ],
                2023: [
                    2,
                    6,
                    2,
                    11
                ],
                2024: [
                    2,
                    5,
                    2,
                    10
                ],
                2025: [
                    1,
                    27,
                    1,
                    31
                ],
                2026: [
                    1,
                    31,
                    2,
                    6
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    7
                ],
                2013: [
                    3,
                    25,
                    3,
                    30
                ],
                2014: [
                    4,
                    14,
                    4,
                    17
                ],
                2015: [
                    4,
                    2,
                    4,
                    2
                ],
                2016: [
                    3,
                    24,
                    3,
                    24
                ],
                2017: [
                    4,
                    10,
                    4,
                    13
                ],
                2018: [
                    3,
                    26,
                    3,
                    31,
                    4,
                    30,
                    4,
                    30
                ],
                2019: [
                    4,
                    18,
                    4,
                    30
                ],
                2020: [
                    4,
                    6,
                    4,
                    11
                ],
                2021: [
                    3,
                    29,
                    4,
                    3
                ],
                2022: [
                    4,
                    11,
                    4,
                    16
                ],
                2023: [
                    4,
                    3,
                    4,
                    8
                ],
                2024: [
                    3,
                    25,
                    3,
                    30
                ],
                2025: [
                    4,
                    7,
                    4,
                    19
                ],
                2026: [
                    3,
                    30,
                    4,
                    4
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    25
                ],
                2013: [
                    5,
                    10,
                    5,
                    18
                ],
                2014: [
                    5,
                    30,
                    6,
                    7
                ],
                2015: [
                    5,
                    15,
                    5,
                    23
                ],
                2016: [
                    5,
                    6,
                    5,
                    14
                ],
                2017: [
                    5,
                    26,
                    5,
                    26
                ],
                2018: [
                    5,
                    11,
                    5,
                    19
                ],
                2019: [
                    5,
                    31,
                    6,
                    1
                ],
                2020: [
                    5,
                    18,
                    5,
                    30
                ],
                2021: [
                    5,
                    10,
                    5,
                    22
                ],
                2022: [
                    5,
                    23,
                    5,
                    28
                ],
                2023: [
                    5,
                    15,
                    5,
                    19
                ],
                2024: [
                    5,
                    21,
                    5,
                    24
                ],
                2025: [
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    5,
                    26,
                    5,
                    29
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    23,
                    9,
                    5
                ],
                2013: [
                    7,
                    15,
                    8,
                    28
                ],
                2014: [
                    7,
                    21,
                    9,
                    3
                ],
                2015: [
                    7,
                    13,
                    8,
                    26
                ],
                2016: [
                    6,
                    27,
                    8,
                    10
                ],
                2017: [
                    6,
                    26,
                    8,
                    9
                ],
                2018: [
                    6,
                    28,
                    8,
                    8
                ],
                2019: [
                    7,
                    4,
                    8,
                    14
                ],
                2020: [
                    7,
                    16,
                    8,
                    26
                ],
                2021: [
                    7,
                    22,
                    9,
                    1
                ],
                2022: [
                    7,
                    14,
                    8,
                    24
                ],
                2023: [
                    7,
                    6,
                    8,
                    16
                ],
                2024: [
                    6,
                    24,
                    8,
                    3
                ],
                2025: [
                    6,
                    28,
                    8,
                    8
                ],
                2026: [
                    7,
                    4,
                    8,
                    14
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    29,
                    11,
                    2
                ],
                2013: [
                    10,
                    21,
                    10,
                    25
                ],
                2014: [
                    10,
                    27,
                    10,
                    30
                ],
                2015: [
                    10,
                    17,
                    10,
                    24
                ],
                2016: [
                    10,
                    4,
                    10,
                    15
                ],
                2017: [
                    10,
                    2,
                    10,
                    13,
                    10,
                    30,
                    10,
                    30
                ],
                2018: [
                    10,
                    1,
                    10,
                    12
                ],
                2019: [
                    10,
                    4,
                    10,
                    11,
                    11,
                    1,
                    11,
                    1
                ],
                2020: [
                    10,
                    19,
                    10,
                    24
                ],
                2021: [
                    10,
                    25,
                    10,
                    30
                ],
                2022: [
                    10,
                    24,
                    11,
                    4
                ],
                2023: [
                    10,
                    2,
                    10,
                    2,
                    10,
                    16,
                    10,
                    30
                ],
                2024: [
                    9,
                    30,
                    10,
                    12,
                    11,
                    1,
                    11,
                    1
                ],
                2025: [
                    10,
                    13,
                    10,
                    25
                ],
                2026: [
                    10,
                    19,
                    10,
                    30
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    22,
                    1,
                    7
                ],
                2012: [
                    12,
                    19,
                    1,
                    4
                ],
                2013: [
                    12,
                    21,
                    1,
                    3
                ],
                2014: [
                    12,
                    22,
                    1,
                    5
                ],
                2015: [
                    12,
                    21,
                    1,
                    5
                ],
                2016: [
                    12,
                    19,
                    1,
                    2
                ],
                2017: [
                    12,
                    21,
                    1,
                    3
                ],
                2018: [
                    12,
                    19,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    4
                ],
                2020: [
                    12,
                    19,
                    1,
                    5
                ],
                2021: [
                    12,
                    22,
                    1,
                    8
                ],
                2022: [
                    12,
                    21,
                    1,
                    5
                ],
                2023: [
                    12,
                    21,
                    1,
                    3
                ],
                2024: [
                    12,
                    23,
                    1,
                    4
                ],
                2025: [
                    12,
                    22,
                    1,
                    5
                ],
                2026: [
                    12,
                    21,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    },
    "Schleswig-Holstein": {
        _state_code: "sh",
        SH: [
            {
                2012: [
                    3,
                    30,
                    4,
                    13
                ],
                2013: [
                    3,
                    25,
                    4,
                    9
                ],
                2014: [
                    4,
                    16,
                    5,
                    2
                ],
                2015: [
                    4,
                    1,
                    4,
                    17
                ],
                2016: [
                    3,
                    24,
                    4,
                    9
                ],
                2017: [
                    4,
                    7,
                    4,
                    21
                ],
                2018: [
                    3,
                    29,
                    4,
                    13
                ],
                2019: [
                    4,
                    4,
                    4,
                    18
                ],
                2020: [
                    3,
                    30,
                    4,
                    17
                ],
                2021: [
                    4,
                    1,
                    4,
                    16
                ],
                2022: [
                    4,
                    4,
                    4,
                    16
                ],
                2023: [
                    4,
                    6,
                    4,
                    22
                ],
                2024: [
                    4,
                    2,
                    4,
                    19
                ],
                2025: [
                    4,
                    11,
                    4,
                    25,
                    5,
                    2,
                    5,
                    2
                ],
                2026: [
                    3,
                    26,
                    4,
                    10
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    18,
                    5,
                    18
                ],
                2013: [
                    5,
                    10,
                    5,
                    10
                ],
                2014: [
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    15,
                    5,
                    15
                ],
                2016: [
                    5,
                    6,
                    5,
                    6
                ],
                2017: [
                    5,
                    26,
                    5,
                    26
                ],
                2018: [
                    5,
                    11,
                    5,
                    11
                ],
                2019: [
                    5,
                    31,
                    5,
                    31
                ],
                2020: [
                    5,
                    22,
                    5,
                    22
                ],
                2021: [
                    5,
                    14,
                    5,
                    14
                ],
                2022: [
                    5,
                    27,
                    5,
                    27
                ],
                2023: [
                    5,
                    19,
                    5,
                    20
                ],
                2024: [
                    5,
                    10,
                    5,
                    11
                ],
                2025: [
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    5,
                    15,
                    5,
                    15
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    6,
                    25,
                    8,
                    4
                ],
                2013: [
                    6,
                    24,
                    8,
                    3
                ],
                2014: [
                    7,
                    14,
                    8,
                    23
                ],
                2015: [
                    7,
                    20,
                    8,
                    29
                ],
                2016: [
                    7,
                    25,
                    9,
                    3
                ],
                2017: [
                    7,
                    24,
                    9,
                    2
                ],
                2018: [
                    7,
                    9,
                    8,
                    18
                ],
                2019: [
                    7,
                    1,
                    8,
                    10
                ],
                2020: [
                    6,
                    29,
                    8,
                    8
                ],
                2021: [
                    6,
                    21,
                    7,
                    31
                ],
                2022: [
                    7,
                    4,
                    8,
                    13
                ],
                2023: [
                    7,
                    17,
                    8,
                    26
                ],
                2024: [
                    7,
                    22,
                    8,
                    31
                ],
                2025: [
                    7,
                    28,
                    9,
                    6
                ],
                2026: [
                    7,
                    4,
                    8,
                    15
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    4,
                    10,
                    19
                ],
                2013: [
                    10,
                    4,
                    10,
                    18
                ],
                2014: [
                    10,
                    13,
                    10,
                    25
                ],
                2015: [
                    10,
                    19,
                    10,
                    31
                ],
                2016: [
                    10,
                    17,
                    10,
                    29
                ],
                2017: [
                    10,
                    16,
                    10,
                    27
                ],
                2018: [
                    10,
                    1,
                    10,
                    19
                ],
                2019: [
                    10,
                    4,
                    10,
                    18
                ],
                2020: [
                    10,
                    5,
                    10,
                    17
                ],
                2021: [
                    10,
                    4,
                    10,
                    16
                ],
                2022: [
                    10,
                    10,
                    10,
                    21
                ],
                2023: [
                    10,
                    16,
                    10,
                    27
                ],
                2024: [
                    10,
                    4,
                    10,
                    4,
                    10,
                    21,
                    11,
                    1
                ],
                2025: [
                    10,
                    20,
                    10,
                    30,
                    11,
                    28,
                    11,
                    28
                ],
                2026: [
                    10,
                    12,
                    10,
                    24
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    6
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    6
                ],
                2014: [
                    12,
                    22,
                    1,
                    6
                ],
                2015: [
                    12,
                    21,
                    1,
                    6
                ],
                2016: [
                    12,
                    23,
                    1,
                    6
                ],
                2017: [
                    12,
                    21,
                    1,
                    6
                ],
                2018: [
                    12,
                    21,
                    1,
                    4
                ],
                2019: [
                    12,
                    23,
                    1,
                    6
                ],
                2020: [
                    12,
                    21,
                    1,
                    6
                ],
                2021: [
                    12,
                    23,
                    1,
                    8
                ],
                2022: [
                    12,
                    23,
                    1,
                    7
                ],
                2023: [
                    12,
                    27,
                    1,
                    6
                ],
                2024: [
                    12,
                    19,
                    1,
                    7
                ],
                2025: [
                    12,
                    19,
                    1,
                    6
                ],
                2026: [
                    12,
                    21,
                    1,
                    6
                ],
                name: "Weihnachtsferien"
            },
            {
                2022: [],
                2023: [],
                2024: [],
                2025: [
                    2,
                    3,
                    2,
                    3
                ],
                2026: [
                    2,
                    2,
                    2,
                    3
                ],
                name: "Winterferien"
            }
        ]
    },
    "Th\xfcringen": {
        _state_code: "th",
        SH: [
            {
                2012: [
                    2,
                    6,
                    2,
                    11
                ],
                2013: [
                    2,
                    18,
                    2,
                    23
                ],
                2014: [
                    2,
                    17,
                    2,
                    22
                ],
                2015: [
                    2,
                    2,
                    2,
                    7
                ],
                2016: [
                    2,
                    1,
                    2,
                    6
                ],
                2017: [
                    2,
                    6,
                    2,
                    11
                ],
                2018: [
                    2,
                    5,
                    2,
                    9
                ],
                2019: [
                    2,
                    11,
                    2,
                    15
                ],
                2020: [
                    2,
                    10,
                    2,
                    14
                ],
                2021: [
                    2,
                    8,
                    2,
                    13
                ],
                2022: [
                    2,
                    12,
                    2,
                    19
                ],
                2023: [
                    2,
                    13,
                    2,
                    17
                ],
                2024: [
                    2,
                    12,
                    2,
                    16
                ],
                2025: [
                    2,
                    3,
                    2,
                    8
                ],
                2026: [
                    2,
                    16,
                    2,
                    21
                ],
                name: "Winterferien"
            },
            {
                2012: [
                    4,
                    2,
                    4,
                    13
                ],
                2013: [
                    3,
                    25,
                    4,
                    6
                ],
                2014: [
                    4,
                    19,
                    5,
                    2
                ],
                2015: [
                    3,
                    30,
                    4,
                    11
                ],
                2016: [
                    3,
                    24,
                    4,
                    2
                ],
                2017: [
                    4,
                    10,
                    4,
                    21
                ],
                2018: [
                    3,
                    26,
                    4,
                    7
                ],
                2019: [
                    4,
                    15,
                    4,
                    27
                ],
                2020: [
                    4,
                    6,
                    4,
                    18
                ],
                2021: [
                    3,
                    29,
                    4,
                    10
                ],
                2022: [
                    4,
                    11,
                    4,
                    23
                ],
                2023: [
                    4,
                    3,
                    4,
                    15
                ],
                2024: [
                    3,
                    25,
                    4,
                    6
                ],
                2025: [
                    4,
                    7,
                    4,
                    19
                ],
                2026: [
                    4,
                    7,
                    4,
                    17
                ],
                name: "Osterferien"
            },
            {
                2012: [
                    5,
                    25,
                    5,
                    29
                ],
                2013: [
                    5,
                    10,
                    5,
                    10
                ],
                2014: [
                    5,
                    30,
                    5,
                    30
                ],
                2015: [
                    5,
                    15,
                    5,
                    15
                ],
                2016: [
                    5,
                    6,
                    5,
                    6
                ],
                2017: [
                    5,
                    26,
                    5,
                    26
                ],
                2018: [
                    5,
                    11,
                    5,
                    11
                ],
                2019: [
                    5,
                    31,
                    5,
                    31
                ],
                2020: [
                    5,
                    22,
                    5,
                    22
                ],
                2021: [
                    5,
                    14,
                    5,
                    14
                ],
                2022: [
                    5,
                    27,
                    5,
                    27
                ],
                2023: [
                    5,
                    19,
                    5,
                    19
                ],
                2024: [
                    5,
                    10,
                    5,
                    10
                ],
                2025: [
                    5,
                    30,
                    5,
                    30
                ],
                2026: [
                    5,
                    15,
                    5,
                    15
                ],
                name: "Pfingstferien"
            },
            {
                2012: [
                    7,
                    23,
                    8,
                    31
                ],
                2013: [
                    7,
                    15,
                    8,
                    23
                ],
                2014: [
                    7,
                    21,
                    8,
                    29
                ],
                2015: [
                    7,
                    13,
                    8,
                    21
                ],
                2016: [
                    6,
                    27,
                    8,
                    10
                ],
                2017: [
                    6,
                    26,
                    8,
                    9
                ],
                2018: [
                    7,
                    2,
                    8,
                    11
                ],
                2019: [
                    7,
                    8,
                    8,
                    17
                ],
                2020: [
                    7,
                    20,
                    8,
                    29
                ],
                2021: [
                    7,
                    26,
                    9,
                    4
                ],
                2022: [
                    7,
                    18,
                    8,
                    27
                ],
                2023: [
                    7,
                    10,
                    8,
                    19
                ],
                2024: [
                    6,
                    20,
                    7,
                    31
                ],
                2025: [
                    6,
                    28,
                    8,
                    8
                ],
                2026: [
                    7,
                    4,
                    8,
                    14
                ],
                name: "Sommerferien"
            },
            {
                2012: [
                    10,
                    22,
                    11,
                    3
                ],
                2013: [
                    10,
                    21,
                    11,
                    2
                ],
                2014: [
                    10,
                    6,
                    10,
                    18
                ],
                2015: [
                    10,
                    5,
                    10,
                    17
                ],
                2016: [
                    10,
                    10,
                    10,
                    22
                ],
                2017: [
                    10,
                    2,
                    10,
                    14
                ],
                2018: [
                    10,
                    1,
                    10,
                    13
                ],
                2019: [
                    10,
                    7,
                    10,
                    19
                ],
                2020: [
                    10,
                    17,
                    10,
                    30
                ],
                2021: [
                    10,
                    25,
                    11,
                    6
                ],
                2022: [
                    10,
                    17,
                    10,
                    29
                ],
                2023: [
                    10,
                    2,
                    10,
                    14
                ],
                2024: [
                    9,
                    30,
                    10,
                    12
                ],
                2025: [
                    10,
                    6,
                    10,
                    18
                ],
                2026: [
                    10,
                    12,
                    10,
                    24
                ],
                name: "Herbstferien"
            },
            {
                2011: [
                    12,
                    23,
                    1,
                    1
                ],
                2012: [
                    12,
                    24,
                    1,
                    5
                ],
                2013: [
                    12,
                    23,
                    1,
                    4
                ],
                2014: [
                    12,
                    22,
                    1,
                    3
                ],
                2015: [
                    12,
                    23,
                    1,
                    2
                ],
                2016: [
                    12,
                    23,
                    12,
                    31
                ],
                2017: [
                    12,
                    22,
                    1,
                    5
                ],
                2018: [
                    12,
                    21,
                    1,
                    4
                ],
                2019: [
                    12,
                    21,
                    1,
                    3
                ],
                2020: [
                    12,
                    23,
                    1,
                    2
                ],
                2021: [
                    12,
                    23,
                    12,
                    31
                ],
                2022: [
                    12,
                    22,
                    1,
                    3
                ],
                2023: [
                    12,
                    22,
                    1,
                    5
                ],
                2024: [
                    12,
                    23,
                    1,
                    3
                ],
                2025: [
                    12,
                    22,
                    1,
                    3
                ],
                2026: [
                    12,
                    23,
                    1,
                    2
                ],
                name: "Weihnachtsferien"
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$t.PH;
$0e3b0f6e50344df5$var$data$t.Bayern;
$0e3b0f6e50344df5$var$data$t.Berlin;
$0e3b0f6e50344df5$var$data$t.Brandenburg;
$0e3b0f6e50344df5$var$data$t.Bremen;
$0e3b0f6e50344df5$var$data$t.Hamburg;
$0e3b0f6e50344df5$var$data$t.Hessen;
$0e3b0f6e50344df5$var$data$t.Niedersachsen;
$0e3b0f6e50344df5$var$data$t.Saarland;
$0e3b0f6e50344df5$var$data$t.Sachsen;
var $0e3b0f6e50344df5$var$data$s = {
    PH: [
        {
            name: "Nyt\xe5rsdag",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Sk\xe6rtorsdag",
            variable_date: "easter",
            offset: -3
        },
        {
            name: "Langfredag",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "P\xe5skedag",
            variable_date: "easter"
        },
        {
            name: "2. P\xe5skedag",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Store Bededag",
            variable_date: "easter",
            offset: 26
        },
        {
            name: "Kristi Himmelfartsdag",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pinsedag",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "2. Pinsedag",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Grundlovsdag",
            fixed_date: [
                6,
                5
            ]
        },
        {
            name: "Juleaftensdag",
            fixed_date: [
                12,
                24
            ]
        },
        {
            name: "Juledag",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "2. Juledag",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$s.PH;
var $0e3b0f6e50344df5$var$data$r = {
    PH: [
        {
            name: "Cap d'Any",
            fixed_date: [
                1,
                1
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "A\xf1o Nuevo",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Reis",
            fixed_date: [
                1,
                6
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "Epifan\xeda del Se\xf1or",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "D\xeda de Andaluc\xeda",
            fixed_date: [
                2,
                28
            ],
            only_states: [
                "Andaluc\xeda"
            ]
        },
        {
            name: "Dia de les Illes Balears",
            fixed_date: [
                3,
                1
            ],
            only_states: [
                "Islas Baleares"
            ]
        },
        {
            name: "Sant Josep",
            fixed_date: [
                3,
                19
            ],
            only_states: [
                "Comunidad Valenciana"
            ]
        },
        {
            name: "San Jos\xe9",
            fixed_date: [
                3,
                19
            ],
            only_states: [
                "Murcia"
            ]
        },
        {
            name: "Jueve Santo",
            variable_date: "easter",
            offset: -3,
            only_states: [
                "Andaluc\xeda",
                "Arag\xf3n",
                "Castilla y Le\xf3n",
                "Castilla-La Mancha",
                "Canarias",
                "Extremadura",
                "Galicia",
                "Islas Baleares",
                "La Rioja",
                "Comunidad de Madrid",
                "Regi\xf3n de Murcia",
                "Navarra",
                "Asturias",
                "Pa\xeds Vasco",
                "Cantabria",
                "Ceuta",
                "Melilla"
            ]
        },
        {
            name: "Divendres Sant",
            variable_date: "easter",
            offset: -2,
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "Viernes Santo",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Dilluns de Pasqua Florida",
            variable_date: "easter",
            offset: 1,
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "Lunes de Pascua de Resurrecci\xf3n",
            variable_date: "easter",
            offset: 1,
            only_states: [
                "Pa\xeds Vasco",
                "Navarra"
            ]
        },
        {
            name: "D\xeda de Arag\xf3n",
            fixed_date: [
                4,
                23
            ],
            only_states: [
                "Arag\xf3n"
            ]
        },
        {
            name: "D\xeda de Castilla y Le\xf3n",
            fixed_date: [
                4,
                23
            ],
            only_states: [
                "Castilla y Le\xf3n"
            ]
        },
        {
            name: "Festa del Treball",
            fixed_date: [
                5,
                1
            ],
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "Fiesta del Trabajo",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Fiesta de la Comunidad de Madrid",
            fixed_date: [
                5,
                2
            ],
            only_states: [
                "Comunidad de Madrid"
            ]
        },
        {
            name: "D\xeda das Letras Galegas",
            fixed_date: [
                5,
                2
            ],
            only_states: [
                "Galicia"
            ]
        },
        {
            name: "D\xeda de Canarias",
            fixed_date: [
                5,
                30
            ],
            only_states: [
                "Canarias"
            ]
        },
        {
            name: "D\xeda de la Regi\xf3n Castilla-La Mancha",
            fixed_date: [
                5,
                31
            ],
            only_states: [
                "Castilla-La Mancha"
            ]
        },
        {
            name: "D\xeda de la Regi\xf3n de Murcia",
            fixed_date: [
                6,
                9
            ],
            only_states: [
                "Regi\xf3n de Murcia"
            ]
        },
        {
            name: "D\xeda de la Rioja",
            fixed_date: [
                6,
                9
            ],
            only_states: [
                "La Rioja"
            ]
        },
        {
            name: "San Antonio",
            fixed_date: [
                6,
                13
            ],
            only_states: [
                "Ceuta"
            ]
        },
        {
            name: "Sant Joan",
            fixed_date: [
                6,
                24
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "San Juan",
            fixed_date: [
                6,
                24
            ],
            only_states: [
                "Ceuta"
            ]
        },
        {
            name: "Santiago Ap\xf3stol",
            fixed_date: [
                7,
                25
            ],
            only_states: [
                "Galicia"
            ]
        },
        {
            name: "Santa Mar\xeda de \xc1frica",
            fixed_date: [
                8,
                6
            ],
            only_states: [
                "Ceuta"
            ]
        },
        {
            name: "l'Assumpci\xf3",
            fixed_date: [
                8,
                15
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "Asunci\xf3n de la Virgen",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "D\xeda de Ceuta",
            fixed_date: [
                9,
                2
            ],
            only_states: [
                "Ceuta"
            ]
        },
        {
            name: "D\xeda de Asturias",
            fixed_date: [
                9,
                8
            ],
            only_states: [
                "Asturias"
            ]
        },
        {
            name: "D\xeda de Extremadura",
            fixed_date: [
                9,
                8
            ],
            only_states: [
                "Extremadura"
            ]
        },
        {
            name: "Diada Nacional de Catalunya",
            fixed_date: [
                9,
                11
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "D\xeda de Cantabria",
            fixed_date: [
                9,
                17
            ],
            only_states: [
                "Cantabria"
            ]
        },
        {
            name: "D\xeda de Melilla",
            fixed_date: [
                9,
                15
            ],
            only_states: [
                "Melilla"
            ]
        },
        {
            name: "Dia de la Comunitat Valenciana",
            fixed_date: [
                10,
                9
            ],
            only_states: [
                "Comunidad Valenciana"
            ]
        },
        {
            name: "Festa Nacional d'Espanya",
            fixed_date: [
                10,
                12
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        },
        {
            name: "Fiesta Nacional de Espa\xf1a",
            fixed_date: [
                10,
                12
            ]
        },
        {
            name: "Euskadi Eguna",
            fixed_date: [
                10,
                25
            ],
            only_states: [
                "Pa\xeds Vasco"
            ]
        },
        {
            name: "Tots Sants",
            fixed_date: [
                11,
                1
            ],
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "Todos los Santos",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "D\xeda de la Constituci\xf3n Espa\xf1ola",
            fixed_date: [
                12,
                6
            ]
        },
        {
            name: "La Pur\xedssima",
            fixed_date: [
                12,
                8
            ],
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "La Immaculada Concepci\xf3n",
            fixed_date: [
                12,
                8
            ]
        },
        {
            name: "Nadal",
            fixed_date: [
                12,
                25
            ],
            only_states: [
                "Catalu\xf1a",
                "Comunidad Valenciana",
                "Islas Baleares"
            ]
        },
        {
            name: "Natividad del Se\xf1or",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Sant Esteve",
            fixed_date: [
                12,
                26
            ],
            only_states: [
                "Catalu\xf1a"
            ]
        }
    ],
    "Andaluc\xeda": {
        _state_code: "an"
    },
    "Arag\xf3n": {
        _state_code: "ar"
    },
    "Castilla y Le\xf3n": {
        _state_code: "cl"
    },
    "Castilla-La Mancha": {
        _state_code: "cm"
    },
    Canarias: {
        _state_code: "cn"
    },
    "Catalu\xf1a": {
        _state_code: "ct"
    },
    Extremadura: {
        _state_code: "ex"
    },
    Galicia: {
        _state_code: "ga"
    },
    "Islas Baleares": {
        _state_code: "ib"
    },
    "La Rioja": {
        _state_code: "ri"
    },
    "Comunidad de Madrid": {
        _state_code: "md"
    },
    "Regi\xf3n de Murcia": {
        _state_code: "mc"
    },
    Navarra: {
        _state_code: "nc"
    },
    Asturias: {
        _state_code: "as"
    },
    "Pa\xeds Vasco": {
        _state_code: "pv"
    },
    Cantabria: {
        _state_code: "cb"
    },
    "Comunidad Valenciana": {
        _state_code: "vc"
    },
    Ceuta: {
        _state_code: "ce"
    },
    Melilla: {
        _state_code: "ml"
    }
};
$0e3b0f6e50344df5$var$data$r.PH;
$0e3b0f6e50344df5$var$data$r.Canarias;
$0e3b0f6e50344df5$var$data$r.Extremadura;
$0e3b0f6e50344df5$var$data$r.Galicia;
$0e3b0f6e50344df5$var$data$r.Navarra;
$0e3b0f6e50344df5$var$data$r.Asturias;
$0e3b0f6e50344df5$var$data$r.Cantabria;
$0e3b0f6e50344df5$var$data$r.Ceuta;
$0e3b0f6e50344df5$var$data$r.Melilla;
var $0e3b0f6e50344df5$var$data$q = {
    PH: [
        {
            name: "uudenvuodenp\xe4iv\xe4 - ny\xe5rsdagen",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "loppiainen - trettondedagen",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "pitk\xe4perjantai - l\xe5ngfredagen",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "p\xe4\xe4si\xe4isp\xe4iv\xe4 - p\xe5skdagen",
            variable_date: "easter"
        },
        {
            name: "toinen p\xe4\xe4si\xe4isp\xe4iv\xe4 - annandag p\xe5sk",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "vappu - f\xf6rsta maj",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "helatorstai - Kristi himmelsf\xe4rdsdag",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "helluntai - pingst",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "juhannusp\xe4iv\xe4 - midsommardagen",
            variable_date: "nextSaturday20Jun"
        },
        {
            name: "pyh\xe4inp\xe4iv\xe4 - alla helgons dag",
            variable_date: "nextSaturday31Oct"
        },
        {
            name: "itsen\xe4isyysp\xe4iv\xe4 - sj\xe4lvst\xe4ndighetsdagen",
            fixed_date: [
                12,
                6
            ]
        },
        {
            name: "joulup\xe4iv\xe4 - juldagen",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "toinen joulup\xe4iv\xe4 - annandag jul",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$q.PH;
var $0e3b0f6e50344df5$var$data$p = {
    PH: [
        {
            name: "Jour de l'an",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Vendredi saint",
            variable_date: "easter",
            offset: -2,
            only_states: [
                "Moselle",
                "Bas-Rhin",
                "Haut-Rhin",
                "Guadeloupe",
                "Martinique",
                "Polyn\xe9sie fran\xe7aise"
            ]
        },
        {
            name: "Lundi de P\xe2ques",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Abolition de l'esclavage (Mayotte)",
            fixed_date: [
                4,
                27
            ],
            only_states: [
                "Mayotte"
            ]
        },
        {
            name: "Saint-Pierre-Chanel",
            fixed_date: [
                4,
                28
            ],
            only_states: [
                "Wallis-et-Futuna"
            ]
        },
        {
            name: "F\xeate du Travail",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "F\xeate de la Victoire",
            fixed_date: [
                5,
                8
            ]
        },
        {
            name: "Abolition de l'esclavage (Martinique)",
            fixed_date: [
                5,
                22
            ],
            only_states: [
                "Martinique"
            ]
        },
        {
            name: "Abolition de l'esclavage (Guadeloupe)",
            fixed_date: [
                5,
                27
            ],
            only_states: [
                "Guadeloupe"
            ]
        },
        {
            name: "Abolition de l'esclavage (Saint-Martin)",
            fixed_date: [
                5,
                28
            ],
            only_states: [
                "Saint-Martin (France)"
            ]
        },
        {
            name: "Jeudi de l'Ascension",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Lundi de Pentec\xf4te",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Abolition de l'esclavage (Guyane)",
            fixed_date: [
                6,
                10
            ],
            only_states: [
                "Guyane"
            ]
        },
        {
            name: "F\xeate de l'autonomie",
            fixed_date: [
                6,
                29
            ],
            only_states: [
                "Polyn\xe9sie fran\xe7aise"
            ]
        },
        {
            name: "F\xeate nationale",
            fixed_date: [
                7,
                14
            ]
        },
        {
            name: "F\xeate Victor Schoelcher",
            fixed_date: [
                7,
                21
            ],
            only_states: [
                "Guadeloupe",
                "Martinique"
            ]
        },
        {
            name: "F\xeate du Territoire",
            fixed_date: [
                7,
                29
            ],
            only_states: [
                "Wallis-et-Futuna"
            ]
        },
        {
            name: "Assomption",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "F\xeate de la citoyennet\xe9",
            fixed_date: [
                9,
                24
            ],
            only_states: [
                "Nouvelle-Cal\xe9donie"
            ]
        },
        {
            name: "Abolition de l'esclavage (Saint-Barth\xe9lemy)",
            fixed_date: [
                10,
                9
            ],
            only_states: [
                "Saint-Barth\xe9lemy"
            ]
        },
        {
            name: "Toussaint",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Armistice",
            fixed_date: [
                11,
                11
            ]
        },
        {
            name: "Abolition de l'esclavage (R\xe9union)",
            fixed_date: [
                12,
                20
            ],
            only_states: [
                "R\xe9union"
            ]
        },
        {
            name: "No\xebl",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Saint-\xc9tienne ",
            fixed_date: [
                12,
                26
            ],
            only_states: [
                "Moselle",
                "Bas-Rhin",
                "Haut-Rhin"
            ]
        }
    ],
    "Auvergne-Rh\xf4ne-Alpes": {
        _state_code: "ara",
        SH: [
            {
                2018: [
                    2,
                    11,
                    2,
                    25
                ],
                2019: [
                    2,
                    17,
                    3,
                    3
                ],
                2020: [
                    2,
                    23,
                    3,
                    8
                ],
                2021: [
                    2,
                    7,
                    2,
                    21
                ],
                2022: [
                    2,
                    12,
                    2,
                    27
                ],
                2023: [
                    2,
                    4,
                    2,
                    19
                ],
                2024: [
                    2,
                    17,
                    3,
                    3
                ],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    8,
                    4,
                    22
                ],
                2019: [
                    4,
                    14,
                    4,
                    28
                ],
                2020: [
                    4,
                    19,
                    5,
                    3
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    16,
                    5,
                    1
                ],
                2023: [
                    4,
                    8,
                    4,
                    23
                ],
                2024: [
                    4,
                    13,
                    4,
                    28
                ],
                2025: [
                    4,
                    19,
                    5,
                    4
                ],
                2026: [
                    4,
                    4,
                    4,
                    19
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Bourgogne-Franche-Comt\xe9": {
        _state_code: "bfc",
        SH: [
            {
                2018: [
                    2,
                    11,
                    2,
                    25
                ],
                2019: [
                    2,
                    17,
                    3,
                    3
                ],
                2020: [
                    2,
                    23,
                    3,
                    8
                ],
                2021: [
                    2,
                    7,
                    2,
                    21
                ],
                2022: [
                    2,
                    12,
                    2,
                    27
                ],
                2023: [
                    2,
                    4,
                    2,
                    19
                ],
                2024: [
                    2,
                    17,
                    3,
                    3
                ],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    8,
                    4,
                    22
                ],
                2019: [
                    4,
                    14,
                    4,
                    28
                ],
                2020: [
                    4,
                    19,
                    5,
                    3
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    16,
                    5,
                    1
                ],
                2023: [
                    4,
                    8,
                    4,
                    23
                ],
                2024: [
                    4,
                    13,
                    4,
                    28
                ],
                2025: [
                    4,
                    19,
                    5,
                    4
                ],
                2026: [
                    4,
                    4,
                    4,
                    19
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Nouvelle-Aquitaine": {
        _state_code: "naq",
        SH: [
            {
                2018: [
                    2,
                    11,
                    2,
                    25
                ],
                2019: [
                    2,
                    17,
                    3,
                    3
                ],
                2020: [
                    2,
                    23,
                    3,
                    8
                ],
                2021: [
                    2,
                    7,
                    2,
                    21
                ],
                2022: [
                    2,
                    12,
                    2,
                    27
                ],
                2023: [
                    2,
                    4,
                    2,
                    19
                ],
                2024: [
                    2,
                    17,
                    3,
                    3
                ],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    8,
                    4,
                    22
                ],
                2019: [
                    4,
                    14,
                    4,
                    28
                ],
                2020: [
                    4,
                    19,
                    5,
                    3
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    16,
                    5,
                    1
                ],
                2023: [
                    4,
                    8,
                    4,
                    23
                ],
                2024: [
                    4,
                    13,
                    4,
                    28
                ],
                2025: [
                    4,
                    19,
                    5,
                    4
                ],
                2026: [
                    4,
                    4,
                    4,
                    19
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Bretagne: {
        _state_code: "bre",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Centre-Val de Loire": {
        _state_code: "cvl",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Grand Est": {
        _state_code: "ges",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Hauts-de-France": {
        _state_code: "hdf",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Normandie: {
        _state_code: "nor",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Pays de la Loire": {
        _state_code: "pdl",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Provence-Alpes-C\xf4te d'Azur": {
        _state_code: "pac",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    10,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    21,
                    3,
                    7
                ],
                2022: [
                    2,
                    5,
                    2,
                    20
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    24,
                    3,
                    10
                ],
                2025: [
                    2,
                    8,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    22,
                    5,
                    6
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    4,
                    12,
                    4,
                    26
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    20,
                    5,
                    5
                ],
                2025: [
                    4,
                    5,
                    4,
                    21
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "\xcele-de-France": {
        _state_code: "idf",
        SH: [
            {
                2018: [
                    2,
                    18,
                    3,
                    4
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    9,
                    2,
                    23
                ],
                2021: [
                    2,
                    14,
                    2,
                    28
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    18,
                    3,
                    5
                ],
                2024: [
                    2,
                    10,
                    2,
                    25
                ],
                2025: [
                    2,
                    15,
                    3,
                    2
                ],
                2026: [
                    2,
                    21,
                    3,
                    8
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    15,
                    4,
                    29
                ],
                2019: [
                    4,
                    21,
                    5,
                    5
                ],
                2020: [
                    4,
                    5,
                    4,
                    19
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    23,
                    5,
                    8
                ],
                2023: [
                    4,
                    22,
                    5,
                    8
                ],
                2024: [
                    4,
                    6,
                    4,
                    21
                ],
                2025: [
                    4,
                    12,
                    4,
                    27
                ],
                2026: [
                    4,
                    18,
                    5,
                    3
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Occitanie: {
        _state_code: "occ",
        SH: [
            {
                2018: [
                    2,
                    18,
                    3,
                    4
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    9,
                    2,
                    23
                ],
                2021: [
                    2,
                    14,
                    2,
                    28
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    18,
                    3,
                    5
                ],
                2024: [
                    2,
                    10,
                    2,
                    25
                ],
                2025: [
                    2,
                    15,
                    3,
                    2
                ],
                2026: [
                    2,
                    21,
                    3,
                    8
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    15,
                    4,
                    29
                ],
                2019: [
                    4,
                    21,
                    5,
                    5
                ],
                2020: [
                    4,
                    5,
                    4,
                    19
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    23,
                    5,
                    8
                ],
                2023: [
                    4,
                    22,
                    5,
                    8
                ],
                2024: [
                    4,
                    6,
                    4,
                    21
                ],
                2025: [
                    4,
                    12,
                    4,
                    27
                ],
                2026: [
                    4,
                    18,
                    5,
                    3
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    5,
                    9,
                    1
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Corse: {
        _state_code: "cor",
        SH: [
            {
                2018: [
                    2,
                    27,
                    3,
                    11
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    14,
                    2,
                    28
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    18,
                    3,
                    5
                ],
                2024: [
                    2,
                    26,
                    3,
                    10
                ],
                2025: [
                    2,
                    15,
                    3,
                    2
                ],
                2026: [],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    24,
                    5,
                    6
                ],
                2019: [
                    4,
                    21,
                    5,
                    5
                ],
                2020: [
                    4,
                    19,
                    5,
                    3
                ],
                2021: [
                    4,
                    11,
                    4,
                    25
                ],
                2022: [
                    4,
                    23,
                    5,
                    8
                ],
                2023: [
                    4,
                    15,
                    5,
                    1
                ],
                2024: [
                    4,
                    29,
                    5,
                    12
                ],
                2025: [
                    4,
                    12,
                    4,
                    27
                ],
                2026: [],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    11,
                    9,
                    4
                ],
                2019: [
                    7,
                    7,
                    9,
                    2
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    8,
                    8,
                    30
                ],
                2022: [
                    7,
                    8,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    7,
                    6,
                    9,
                    3
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Guadeloupe: {
        _state_code: "gua",
        SH: [
            {
                2018: [
                    2,
                    9,
                    2,
                    21
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    10,
                    2,
                    21
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    10,
                    2,
                    26
                ],
                2025: [
                    2,
                    22,
                    3,
                    10
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    3,
                    25,
                    4,
                    8
                ],
                2019: [
                    4,
                    19,
                    5,
                    1
                ],
                2020: [
                    4,
                    9,
                    4,
                    22
                ],
                2021: [
                    3,
                    28,
                    4,
                    11
                ],
                2022: [
                    4,
                    13,
                    4,
                    24
                ],
                2023: [
                    4,
                    1,
                    4,
                    16
                ],
                2024: [
                    3,
                    28,
                    4,
                    15
                ],
                2025: [
                    4,
                    17,
                    5,
                    5
                ],
                2026: [
                    4,
                    2,
                    4,
                    19
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [],
                2022: [],
                2023: [],
                2024: [],
                2025: [],
                2026: [],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    7,
                    9,
                    3
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    6,
                    8,
                    30
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    22,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Saint-Martin (France)": {
        _state_code: "mf",
        SH: [
            {
                2018: [
                    2,
                    9,
                    2,
                    21
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    10,
                    2,
                    21
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    10,
                    2,
                    26
                ],
                2025: [
                    2,
                    22,
                    3,
                    10
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    3,
                    25,
                    4,
                    8
                ],
                2019: [
                    4,
                    19,
                    5,
                    1
                ],
                2020: [
                    4,
                    9,
                    4,
                    22
                ],
                2021: [
                    3,
                    28,
                    4,
                    11
                ],
                2022: [
                    4,
                    13,
                    4,
                    24
                ],
                2023: [
                    4,
                    1,
                    4,
                    16
                ],
                2024: [
                    3,
                    28,
                    4,
                    15
                ],
                2025: [
                    4,
                    17,
                    5,
                    5
                ],
                2026: [
                    4,
                    2,
                    4,
                    19
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    13,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    7,
                    9,
                    3
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    6,
                    8,
                    30
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    22,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Saint-Barth\xe9lemy": {
        _state_code: "bl",
        SH: [
            {
                2018: [
                    2,
                    9,
                    2,
                    21
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    10,
                    2,
                    21
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [
                    2,
                    10,
                    2,
                    26
                ],
                2025: [
                    2,
                    22,
                    3,
                    10
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    3,
                    25,
                    4,
                    8
                ],
                2019: [
                    4,
                    19,
                    5,
                    1
                ],
                2020: [
                    4,
                    9,
                    4,
                    22
                ],
                2021: [
                    3,
                    28,
                    4,
                    11
                ],
                2022: [
                    4,
                    13,
                    4,
                    24
                ],
                2023: [
                    4,
                    1,
                    4,
                    16
                ],
                2024: [
                    3,
                    28,
                    4,
                    15
                ],
                2025: [
                    4,
                    17,
                    5,
                    5
                ],
                2026: [
                    4,
                    2,
                    4,
                    19
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    13,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    7,
                    9,
                    3
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    6,
                    8,
                    30
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    22,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Guyane: {
        _state_code: "guf",
        SH: [
            {
                2018: [
                    2,
                    11,
                    2,
                    25
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    16,
                    3,
                    1
                ],
                2021: [
                    2,
                    14,
                    2,
                    28
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    18,
                    3,
                    5
                ],
                2024: [],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    3,
                    30,
                    4,
                    15
                ],
                2019: [
                    4,
                    19,
                    5,
                    1
                ],
                2020: [
                    4,
                    10,
                    4,
                    26
                ],
                2021: [
                    4,
                    2,
                    4,
                    18
                ],
                2022: [
                    4,
                    14,
                    5,
                    1
                ],
                2023: [
                    4,
                    5,
                    4,
                    19
                ],
                2024: [],
                2025: [
                    4,
                    17,
                    5,
                    4
                ],
                2026: [
                    4,
                    1,
                    4,
                    15
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [],
                2025: [
                    5,
                    28,
                    6,
                    1
                ],
                2026: [
                    5,
                    13,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    9,
                    2
                ],
                2019: [
                    7,
                    9,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    4,
                    8,
                    31
                ],
                2022: [
                    7,
                    9,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [
                    7,
                    4
                ],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [
                    10,
                    17,
                    11,
                    1
                ],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [
                    12,
                    19,
                    1,
                    3
                ],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Martinique: {
        _state_code: "mtq",
        SH: [
            {
                2018: [
                    2,
                    8,
                    2,
                    18
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    2,
                    23,
                    3,
                    8
                ],
                2021: [
                    2,
                    7,
                    2,
                    21
                ],
                2022: [
                    2,
                    19,
                    3,
                    6
                ],
                2023: [
                    2,
                    11,
                    2,
                    26
                ],
                2024: [],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    7,
                    2,
                    22
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    3,
                    25,
                    4,
                    8
                ],
                2019: [
                    4,
                    14,
                    4,
                    28
                ],
                2020: [
                    4,
                    5,
                    4,
                    19
                ],
                2021: [
                    3,
                    28,
                    4,
                    11
                ],
                2022: [
                    4,
                    9,
                    4,
                    24
                ],
                2023: [
                    4,
                    1,
                    4,
                    16
                ],
                2024: [],
                2025: [
                    4,
                    12,
                    4,
                    27
                ],
                2026: [
                    3,
                    28,
                    4,
                    12
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    28,
                    6,
                    1
                ],
                2026: [
                    5,
                    13,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    7,
                    9,
                    3
                ],
                2019: [
                    7,
                    7,
                    9,
                    1
                ],
                2020: [
                    7,
                    5,
                    8,
                    31
                ],
                2021: [
                    7,
                    7,
                    8,
                    30
                ],
                2022: [
                    7,
                    7,
                    8,
                    31
                ],
                2023: [
                    7,
                    8,
                    9,
                    3
                ],
                2024: [
                    9,
                    1
                ],
                2025: [
                    7,
                    5,
                    8,
                    31
                ],
                2026: [
                    7,
                    4
                ],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    19,
                    11,
                    3
                ],
                2025: [
                    10,
                    18,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    Mayotte: {
        _state_code: "may",
        SH: [
            {
                2018: [
                    2,
                    25,
                    3,
                    11
                ],
                2019: [
                    2,
                    24,
                    3,
                    10
                ],
                2020: [
                    3,
                    1,
                    3,
                    15
                ],
                2021: [
                    2,
                    28,
                    3,
                    14
                ],
                2022: [
                    2,
                    26,
                    3,
                    13
                ],
                2023: [
                    2,
                    18,
                    3,
                    5
                ],
                2024: [],
                2025: [
                    3,
                    1,
                    3,
                    9
                ],
                2026: [
                    2,
                    28,
                    3,
                    8
                ],
                name: "Vacances de Carnaval"
            },
            {
                2018: [
                    5,
                    6,
                    5,
                    13
                ],
                2019: [
                    4,
                    27,
                    5,
                    5
                ],
                2020: [
                    5,
                    3,
                    5,
                    10
                ],
                2021: [
                    5,
                    1,
                    5,
                    16
                ],
                2022: [
                    4,
                    30,
                    5,
                    15
                ],
                2023: [
                    4,
                    22,
                    5,
                    8
                ],
                2024: [],
                2025: [
                    4,
                    26,
                    5,
                    11
                ],
                2026: [
                    4,
                    30,
                    5,
                    17
                ],
                name: "Vacances de P\xe2ques"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [],
                2022: [],
                2023: [],
                2024: [],
                2025: [],
                2026: [],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    7,
                    8,
                    8,
                    22
                ],
                2019: [
                    7,
                    7,
                    8,
                    22
                ],
                2020: [
                    7,
                    5,
                    8,
                    23
                ],
                2021: [
                    7,
                    7,
                    8,
                    22
                ],
                2022: [
                    7,
                    6,
                    8,
                    23
                ],
                2023: [
                    7,
                    8,
                    8,
                    22
                ],
                2024: [
                    8,
                    25
                ],
                2025: [
                    7,
                    5,
                    8,
                    24
                ],
                2026: [
                    7,
                    4
                ],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    12,
                    10,
                    27
                ],
                2025: [
                    10,
                    11,
                    10,
                    26
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    14,
                    1,
                    12
                ],
                2025: [
                    12,
                    13,
                    1,
                    11
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "La R\xe9union": {
        _state_code: "lre",
        SH: [
            {
                2018: [
                    3,
                    11,
                    3,
                    25
                ],
                2019: [
                    3,
                    10,
                    3,
                    24
                ],
                2020: [
                    3,
                    8,
                    3,
                    22
                ],
                2021: [
                    3,
                    7,
                    3,
                    21
                ],
                2022: [
                    3,
                    12,
                    3,
                    27
                ],
                2023: [
                    3,
                    11,
                    3,
                    26
                ],
                2024: [],
                2025: [
                    3,
                    1,
                    3,
                    16
                ],
                2026: [
                    2,
                    28,
                    3,
                    15
                ],
                name: "Vacances apr\xe8s 3\xe8me p\xe9riode"
            },
            {
                2018: [
                    5,
                    6,
                    5,
                    16
                ],
                2019: [
                    5,
                    8,
                    5,
                    19
                ],
                2020: [
                    5,
                    1,
                    5,
                    13
                ],
                2021: [
                    5,
                    5,
                    5,
                    16
                ],
                2022: [
                    5,
                    14,
                    5,
                    29
                ],
                2023: [
                    5,
                    13,
                    5,
                    29
                ],
                2024: [],
                2025: [
                    5,
                    3,
                    5,
                    18
                ],
                2026: [
                    5,
                    2,
                    5,
                    17
                ],
                name: "Vacances apr\xe8s 4\xe8me p\xe9riode"
            },
            {
                2018: [
                    7,
                    8,
                    8,
                    16
                ],
                2019: [
                    7,
                    7,
                    8,
                    15
                ],
                2020: [
                    7,
                    8,
                    8,
                    15
                ],
                2021: [
                    12,
                    20,
                    1,
                    26
                ],
                2022: [
                    7,
                    9,
                    8,
                    15
                ],
                2023: [
                    7,
                    8,
                    9,
                    16
                ],
                2024: [
                    8,
                    19
                ],
                2025: [
                    7,
                    5,
                    8,
                    18
                ],
                2026: [
                    7,
                    4
                ],
                name: "Vacances hiver austral"
            },
            {
                2018: [
                    10,
                    14,
                    10,
                    28
                ],
                2019: [
                    10,
                    13,
                    10,
                    27
                ],
                2020: [
                    10,
                    11,
                    11,
                    25
                ],
                2021: [],
                2022: [],
                2023: [],
                2024: [
                    10,
                    12,
                    10,
                    27
                ],
                2025: [
                    10,
                    11,
                    10,
                    26
                ],
                2026: [],
                name: "Vacances apr\xe8s 1\xe8re p\xe9riode"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    27
                ],
                2019: [
                    12,
                    20,
                    1,
                    26
                ],
                2020: [
                    12,
                    20,
                    1,
                    24
                ],
                2021: [],
                2022: [],
                2023: [],
                2024: [
                    12,
                    19,
                    1,
                    20
                ],
                2025: [
                    12,
                    19,
                    1,
                    20
                ],
                2026: [],
                name: "Vacances \xe9t\xe9 austral"
            }
        ]
    },
    "Nouvelle-Cal\xe9donie": {
        _state_code: "nc",
        SH: [
            {
                2018: [
                    4,
                    7,
                    4,
                    15
                ],
                2019: [
                    4,
                    6,
                    4,
                    14
                ],
                2020: [
                    4,
                    4,
                    4,
                    13
                ],
                2021: [
                    4,
                    3,
                    4,
                    18
                ],
                2022: [
                    4,
                    2,
                    4,
                    16
                ],
                2023: [
                    4,
                    2,
                    4,
                    16
                ],
                2024: [
                    3,
                    30,
                    4,
                    13
                ],
                2025: [
                    4,
                    5,
                    4,
                    19
                ],
                2026: [],
                name: "Vacances 1\xe8re p\xe9riode"
            },
            {
                2018: [
                    6,
                    9,
                    6,
                    24
                ],
                2019: [
                    6,
                    8,
                    6,
                    23
                ],
                2020: [
                    6,
                    6,
                    6,
                    21
                ],
                2021: [
                    6,
                    5,
                    6,
                    20
                ],
                2022: [
                    6,
                    4,
                    6,
                    18
                ],
                2023: [
                    4,
                    2,
                    4,
                    16
                ],
                2024: [
                    6,
                    1,
                    6,
                    15
                ],
                2025: [
                    6,
                    7,
                    6,
                    21
                ],
                2026: [],
                name: "Vacances 2\xe8me p\xe9riode"
            },
            {
                2018: [
                    8,
                    11,
                    8,
                    26
                ],
                2019: [
                    8,
                    10,
                    8,
                    25
                ],
                2020: [
                    8,
                    8,
                    8,
                    23
                ],
                2021: [
                    8,
                    7,
                    8,
                    22
                ],
                2022: [
                    8,
                    6,
                    8,
                    20
                ],
                2023: [
                    8,
                    5,
                    8,
                    20
                ],
                2024: [
                    8,
                    3,
                    8,
                    17
                ],
                2025: [
                    8,
                    9,
                    9,
                    23
                ],
                2026: [],
                name: "Vacances 3\xe8me p\xe9riode"
            },
            {
                2018: [
                    10,
                    13,
                    10,
                    18
                ],
                2019: [
                    10,
                    12,
                    10,
                    27
                ],
                2020: [
                    10,
                    10,
                    10,
                    25
                ],
                2021: [
                    10,
                    9,
                    10,
                    24
                ],
                2022: [
                    10,
                    8,
                    10,
                    22
                ],
                2023: [
                    10,
                    7,
                    10,
                    22
                ],
                2024: [
                    10,
                    5,
                    10,
                    19
                ],
                2025: [
                    10,
                    11,
                    10,
                    25
                ],
                2026: [],
                name: "Vacances 4\xe8me p\xe9riode"
            },
            {
                2018: [
                    12,
                    15,
                    2,
                    17
                ],
                2019: [
                    12,
                    14,
                    2,
                    16
                ],
                2020: [
                    12,
                    18,
                    2,
                    14
                ],
                2021: [
                    12,
                    18,
                    2,
                    13
                ],
                2022: [
                    12,
                    17,
                    2,
                    12
                ],
                2023: [
                    12,
                    16,
                    2,
                    11
                ],
                2024: [
                    12,
                    14,
                    2,
                    17
                ],
                2025: [
                    12,
                    20
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            }
        ]
    },
    "Polyn\xe9sie fran\xe7aise": {
        _state_code: "pf",
        SH: [
            {
                2018: [
                    2,
                    18,
                    2,
                    25
                ],
                2019: [
                    2,
                    17,
                    2,
                    24
                ],
                2020: [
                    2,
                    16,
                    2,
                    23
                ],
                2021: [
                    2,
                    21,
                    2,
                    28
                ],
                2022: [
                    2,
                    19,
                    2,
                    27
                ],
                2023: [
                    2,
                    18,
                    2,
                    26
                ],
                2024: [
                    2,
                    17,
                    2,
                    25
                ],
                2025: [
                    2,
                    15,
                    2,
                    23
                ],
                2026: [
                    2,
                    14,
                    2,
                    22
                ],
                name: "Vacances de f\xe9vrier"
            },
            {
                2018: [
                    3,
                    30,
                    4,
                    15
                ],
                2019: [
                    4,
                    7,
                    4,
                    22
                ],
                2020: [
                    3,
                    29,
                    4,
                    13
                ],
                2021: [
                    4,
                    6,
                    4,
                    18
                ],
                2022: [
                    4,
                    2,
                    4,
                    18
                ],
                2023: [
                    4,
                    1,
                    4,
                    16
                ],
                2024: [
                    3,
                    30,
                    4,
                    14
                ],
                2025: [
                    3,
                    29,
                    4,
                    13
                ],
                2026: [
                    3,
                    28,
                    4,
                    12
                ],
                name: "Vacances d'avril"
            },
            {
                2018: [
                    5,
                    20,
                    5,
                    27
                ],
                2019: [
                    5,
                    26,
                    6,
                    2
                ],
                2020: [
                    5,
                    17,
                    5,
                    24
                ],
                2021: [
                    5,
                    25,
                    5,
                    30
                ],
                2022: [
                    5,
                    21,
                    5,
                    29
                ],
                2023: [
                    5,
                    20,
                    5,
                    28
                ],
                2024: [
                    5,
                    18,
                    5,
                    26
                ],
                2025: [
                    5,
                    24,
                    6,
                    1
                ],
                2026: [
                    5,
                    23,
                    5,
                    31
                ],
                name: "Vacances de mai"
            },
            {
                2018: [
                    7,
                    7,
                    8,
                    15
                ],
                2019: [
                    7,
                    7,
                    8,
                    13
                ],
                2020: [
                    7,
                    5,
                    8,
                    9
                ],
                2021: [
                    7,
                    3,
                    8,
                    8
                ],
                2022: [
                    7,
                    2,
                    8,
                    7
                ],
                2023: [
                    7,
                    1,
                    8,
                    13
                ],
                2024: [
                    7,
                    6,
                    8,
                    12
                ],
                2025: [
                    7,
                    5,
                    8,
                    12
                ],
                2026: [
                    8,
                    4
                ],
                name: "Grandes Vacances"
            },
            {
                2018: [
                    9,
                    16,
                    9,
                    23
                ],
                2019: [
                    9,
                    15,
                    9,
                    22
                ],
                2020: [
                    9,
                    13,
                    9,
                    20
                ],
                2021: [
                    9,
                    12,
                    9,
                    19
                ],
                2022: [
                    9,
                    10,
                    9,
                    18
                ],
                2023: [
                    9,
                    16,
                    9,
                    24
                ],
                2024: [
                    9,
                    14,
                    9,
                    22
                ],
                2025: [
                    9,
                    13,
                    9,
                    21
                ],
                2026: [],
                name: "Vacances de septembre"
            },
            {
                2018: [
                    10,
                    28,
                    11,
                    11
                ],
                2019: [
                    10,
                    27,
                    11,
                    11
                ],
                2020: [
                    10,
                    25,
                    11,
                    8
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    28,
                    11,
                    12
                ],
                2024: [
                    10,
                    26,
                    11,
                    11
                ],
                2025: [
                    10,
                    25,
                    11,
                    9
                ],
                2026: [],
                name: "Vacances d'octobre-novembre"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    10,
                    1,
                    8
                ],
                2023: [
                    12,
                    16,
                    1,
                    14
                ],
                2024: [
                    12,
                    14,
                    1,
                    12
                ],
                2025: [
                    12,
                    13,
                    1,
                    11
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Saint-Pierre-et-Miquelon": {
        _state_code: "pm",
        SH: [
            {
                2018: [
                    2,
                    24,
                    3,
                    11
                ],
                2019: [
                    2,
                    16,
                    3,
                    3
                ],
                2020: [
                    2,
                    22,
                    3,
                    8
                ],
                2021: [
                    2,
                    19,
                    3,
                    7
                ],
                2022: [],
                2023: [],
                2024: [],
                2025: [
                    2,
                    22,
                    3,
                    9
                ],
                2026: [
                    2,
                    14,
                    3,
                    1
                ],
                name: "Vacances d'Hiver"
            },
            {
                2018: [
                    4,
                    28,
                    5,
                    13
                ],
                2019: [
                    4,
                    20,
                    5,
                    5
                ],
                2020: [
                    4,
                    18,
                    5,
                    3
                ],
                2021: [
                    4,
                    24,
                    5,
                    9
                ],
                2022: [
                    4,
                    15,
                    5,
                    1
                ],
                2023: [],
                2024: [],
                2025: [
                    4,
                    19,
                    5,
                    4
                ],
                2026: [
                    4,
                    11,
                    4,
                    26
                ],
                name: "Vacances de Printemps"
            },
            {
                2018: [
                    5,
                    10,
                    5,
                    10
                ],
                2019: [
                    5,
                    30,
                    6,
                    2
                ],
                2020: [
                    5,
                    21,
                    5,
                    24
                ],
                2021: [
                    5,
                    14,
                    5,
                    16
                ],
                2022: [
                    5,
                    26,
                    5,
                    27
                ],
                2023: [
                    5,
                    17,
                    5,
                    21
                ],
                2024: [
                    5,
                    8,
                    5,
                    12
                ],
                2025: [
                    5,
                    29,
                    6,
                    1
                ],
                2026: [
                    5,
                    14,
                    5,
                    17
                ],
                name: "Pont de l'Ascension"
            },
            {
                2018: [
                    6,
                    30,
                    9,
                    6
                ],
                2019: [
                    7,
                    4,
                    9,
                    4
                ],
                2020: [
                    7,
                    4,
                    9,
                    2
                ],
                2021: [
                    7,
                    3,
                    9,
                    1
                ],
                2022: [
                    7,
                    1,
                    8,
                    31
                ],
                2023: [],
                2024: [
                    9,
                    3
                ],
                2025: [
                    7,
                    4,
                    9,
                    2
                ],
                2026: [
                    7,
                    3
                ],
                name: "Vacances d'\xc9t\xe9"
            },
            {
                2018: [
                    10,
                    21,
                    11,
                    4
                ],
                2019: [
                    10,
                    20,
                    11,
                    3
                ],
                2020: [
                    10,
                    18,
                    11,
                    1
                ],
                2021: [
                    10,
                    24,
                    11,
                    7
                ],
                2022: [
                    10,
                    22,
                    11,
                    6
                ],
                2023: [
                    10,
                    21,
                    11,
                    5
                ],
                2024: [
                    10,
                    23,
                    11,
                    3
                ],
                2025: [
                    10,
                    22,
                    11,
                    2
                ],
                2026: [],
                name: "Vacances de la Toussaint"
            },
            {
                2018: [
                    12,
                    23,
                    1,
                    6
                ],
                2019: [
                    12,
                    22,
                    1,
                    5
                ],
                2020: [
                    12,
                    20,
                    1,
                    3
                ],
                2021: [
                    12,
                    19,
                    1,
                    2
                ],
                2022: [
                    12,
                    17,
                    1,
                    2
                ],
                2023: [
                    12,
                    23,
                    1,
                    7
                ],
                2024: [
                    12,
                    21,
                    1,
                    5
                ],
                2025: [
                    12,
                    20,
                    1,
                    4
                ],
                2026: [],
                name: "Vacances de No\xebl"
            }
        ]
    },
    "Wallis-et-Futuna": {
        _state_code: "wf",
        SH: [
            {
                2018: [
                    4,
                    1,
                    4,
                    15
                ],
                2019: [
                    3,
                    31,
                    4,
                    14
                ],
                2020: [
                    3,
                    29,
                    4,
                    13
                ],
                2021: [
                    4,
                    3,
                    4,
                    18
                ],
                2022: [],
                2023: [],
                2024: [
                    3,
                    30,
                    4,
                    14
                ],
                2025: [
                    4,
                    5,
                    4,
                    20
                ],
                2026: [],
                name: "Vacances 1\xe8re p\xe9riode"
            },
            {
                2018: [
                    6,
                    8,
                    6,
                    24
                ],
                2019: [
                    6,
                    9,
                    6,
                    23
                ],
                2020: [
                    6,
                    5,
                    6,
                    21
                ],
                2021: [
                    6,
                    5,
                    6,
                    20
                ],
                2022: [],
                2023: [],
                2024: [
                    6,
                    1,
                    6,
                    16
                ],
                2025: [
                    6,
                    7,
                    6,
                    22
                ],
                2026: [],
                name: "Vacances 2\xe8me p\xe9riode"
            },
            {
                2018: [
                    8,
                    10,
                    8,
                    26
                ],
                2019: [
                    8,
                    11,
                    8,
                    25
                ],
                2020: [
                    8,
                    9,
                    8,
                    23
                ],
                2021: [
                    8,
                    7,
                    8,
                    22
                ],
                2022: [],
                2023: [],
                2024: [
                    8,
                    3,
                    8,
                    18
                ],
                2025: [
                    8,
                    9,
                    8,
                    24
                ],
                2026: [],
                name: "Vacances 3\xe8me p\xe9riode"
            },
            {
                2018: [
                    10,
                    14,
                    10,
                    28
                ],
                2019: [
                    10,
                    13,
                    10,
                    27
                ],
                2020: [
                    10,
                    11,
                    10,
                    25
                ],
                2021: [
                    10,
                    9,
                    10,
                    24
                ],
                2022: [],
                2023: [],
                2024: [
                    10,
                    5,
                    10,
                    20
                ],
                2025: [
                    10,
                    11,
                    10,
                    26
                ],
                2026: [],
                name: "Vacances 4\xe8me p\xe9riode"
            },
            {
                2018: [
                    12,
                    16,
                    2,
                    10
                ],
                2019: [
                    12,
                    15,
                    2,
                    9
                ],
                2020: [
                    12,
                    13,
                    2,
                    14
                ],
                2021: [
                    12,
                    18,
                    2,
                    19
                ],
                2022: [],
                2023: [
                    2,
                    12
                ],
                2024: [
                    12,
                    14,
                    2,
                    16
                ],
                2025: [
                    12,
                    20
                ],
                2026: [],
                name: "Vacances d'\xc9t\xe9"
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$p.PH;
$0e3b0f6e50344df5$var$data$p.Bretagne;
$0e3b0f6e50344df5$var$data$p.Normandie;
$0e3b0f6e50344df5$var$data$p.Occitanie;
$0e3b0f6e50344df5$var$data$p.Corse;
$0e3b0f6e50344df5$var$data$p.Guadeloupe;
$0e3b0f6e50344df5$var$data$p.Guyane;
$0e3b0f6e50344df5$var$data$p.Martinique;
$0e3b0f6e50344df5$var$data$p.Mayotte;
var $0e3b0f6e50344df5$var$data$o = {
    England: {
        PH: [
            {
                name: "New Year\u2019s Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Early May bank holiday",
                variable_date: "firstMayMonday"
            },
            {
                name: "Spring bank holiday",
                variable_date: "lastMayMonday"
            },
            {
                name: "Summer bank holiday",
                variable_date: "lastAugustMonday"
            },
            {
                name: "Christmas",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Wales: {
        PH: [
            {
                name: "New Year\u2019s Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Early May bank holiday",
                variable_date: "firstMayMonday"
            },
            {
                name: "Spring bank holiday",
                variable_date: "lastMayMonday"
            },
            {
                name: "Summer bank holiday",
                variable_date: "lastAugustMonday"
            },
            {
                name: "Christmas",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "Northern Ireland": {
        PH: [
            {
                name: "New Year\u2019s Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "St Patrick\u2019s Day",
                variable_date: "nextMo-Fr17March"
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Early May bank holiday",
                variable_date: "firstMayMonday"
            },
            {
                name: "Spring bank holiday",
                variable_date: "lastMayMonday"
            },
            {
                name: "Battle of the Boyne",
                variable_date: "nextMo-Fr12July"
            },
            {
                name: "Summer bank holiday",
                variable_date: "lastAugustMonday"
            },
            {
                name: "Christmas",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    Scotland: {
        PH: [
            {
                name: "New Year\u2019s Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2nd January",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Early May bank holiday",
                variable_date: "firstMayMonday"
            },
            {
                name: "Spring bank holiday",
                variable_date: "lastMayMonday"
            },
            {
                name: "Summer bank holiday",
                variable_date: "lastAugustMonday"
            },
            {
                name: "St. Andrew\u2019s Day",
                variable_date: "nextMo-Fr30November"
            },
            {
                name: "Christmas",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Boxing Day",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$o.England;
$0e3b0f6e50344df5$var$data$o.Wales;
$0e3b0f6e50344df5$var$data$o.Scotland;
var $0e3b0f6e50344df5$var$data$n = {
    PH: [
        {
            name: "\u03A0\u03C1\u03C9\u03C4\u03BF\u03C7\u03C1\u03BF\u03BD\u03B9\u03AC",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "\u0398\u03B5\u03BF\u03C6\u03AC\u03BD\u03B9\u03B1",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
            variable_date: "orthodox easter",
            offset: -48
        },
        {
            name: "25\u03B7 \u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
            fixed_date: [
                3,
                25
            ]
        },
        {
            name: "\u039C\u03B5\u03B3\u03AC\u03BB\u03B7 \u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
            variable_date: "orthodox easter",
            offset: -2
        },
        {
            name: "\u03A0\u03AC\u03C3\u03C7\u03B1",
            variable_date: "orthodox easter",
            offset: 0
        },
        {
            name: "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1 \u03C4\u03BF\u03C5 \u03A0\u03AC\u03C3\u03C7\u03B1",
            variable_date: "orthodox easter",
            offset: 1
        },
        {
            name: "\u03A0\u03C1\u03C9\u03C4\u03BF\u03BC\u03B1\u03B3\u03B9\u03AC",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "\u039A\u03BF\u03AF\u03BC\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u0398\u03B5\u03BF\u03C4\u03CC\u03BA\u03BF\u03C5",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "28\u03B7 \u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
            fixed_date: [
                10,
                28
            ]
        },
        {
            name: "\u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03B3\u03B5\u03BD\u03BD\u03B1",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "2\u03B7 \u03BC\u03AD\u03C1\u03B1 \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03C5\u03B3\u03AD\u03BD\u03BD\u03C9\u03BD",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2019: [
                1,
                30,
                1,
                30
            ],
            2020: [
                1,
                30,
                1,
                30
            ],
            name: "\u03A4\u03C1\u03B9\u03CE\u03BD \u0399\u03B5\u03C1\u03B1\u03C1\u03C7\u03CE\u03BD"
        },
        {
            2019: [
                4,
                22,
                5,
                6
            ],
            2020: [
                4,
                13,
                4,
                26
            ],
            name: "\u03A0\u03AC\u03C3\u03C7\u03B1"
        },
        {
            2019: [
                6,
                17,
                6,
                17
            ],
            2020: [
                6,
                8,
                6,
                8
            ],
            name: "\u0391\u03B3\u03AF\u03BF\u03C5 \u03A0\u03BD\u03B5\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2"
        },
        {
            2019: [
                7,
                1,
                8,
                31
            ],
            2020: [
                7,
                1,
                8,
                31
            ],
            name: "\u039A\u03B1\u03BB\u03BF\u03BA\u03B1\u03AF\u03C1\u03B9"
        },
        {
            2019: [
                11,
                17,
                11,
                17
            ],
            name: "\u03A0\u03BF\u03BB\u03C5\u03C4\u03B5\u03C7\u03BD\u03B5\u03AF\u03BF"
        },
        {
            2018: [
                12,
                24,
                1,
                7
            ],
            2019: [
                12,
                24,
                1,
                7
            ],
            2020: [
                12,
                24,
                1,
                7
            ],
            name: "\u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03B3\u03B5\u03BD\u03BD\u03B1"
        }
    ]
};
$0e3b0f6e50344df5$var$data$n.PH;
$0e3b0f6e50344df5$var$data$n.SH;
var $0e3b0f6e50344df5$var$data$m = {
    PH: [
        {
            name: "Nova godina",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Sveta tri kralja",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "Uskr\u0161nji ponedjeljak",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Praznik rada",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Tijelovo",
            variable_date: "easter",
            offset: 60
        },
        {
            name: "Dan antifa\u0161isti\u010Dke borbe",
            fixed_date: [
                6,
                22
            ]
        },
        {
            name: "Dan pobjede i domovinske zahvalnosti",
            fixed_date: [
                8,
                5
            ]
        },
        {
            name: "Velika Gospa",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Svi sveti",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Dan sje\u0107anja na \u017Ertve Domovinskog rata",
            fixed_date: [
                11,
                18
            ]
        },
        {
            name: "Bo\u017Ei\u0107",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Sveti Stjepan",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2022: [
                2,
                21,
                2,
                27
            ],
            2023: [
                2,
                20,
                2,
                26
            ],
            name: "Drugi dio zimskog odmora"
        },
        {
            2022: [
                4,
                14,
                4,
                24
            ],
            2023: [
                4,
                6,
                4,
                16
            ],
            name: "Proljetni odmor"
        },
        {
            2022: [
                6,
                23,
                9,
                3
            ],
            2023: [
                6,
                23,
                9,
                4
            ],
            name: "Ljetni praznici"
        },
        {
            2021: [
                11,
                2,
                11,
                3
            ],
            2022: [
                10,
                31,
                11,
                1
            ],
            name: "Jesenski odmor"
        },
        {
            2021: [
                12,
                24,
                1,
                9
            ],
            2022: [
                12,
                27,
                1,
                8
            ],
            name: "Prvi dio zimskog odmora"
        }
    ]
};
$0e3b0f6e50344df5$var$data$m.PH;
$0e3b0f6e50344df5$var$data$m.SH;
var $0e3b0f6e50344df5$var$data$l = {
    PH: [
        {
            name: "\xfaj\xe9v",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "az 1848-as forradalom \xfcnnepe",
            fixed_date: [
                3,
                15
            ]
        },
        {
            name: "nagyp\xe9ntek",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "h\xfasv\xe9tvas\xe1rnap",
            variable_date: "easter"
        },
        {
            name: "h\xfasv\xe9th\xe9tf\u0151",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "p\xfcnk\xf6sdvas\xe1rnap",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "p\xfcnk\xf6sdh\xe9tf\u0151",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "a munka \xfcnnepe",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "az \xe1llamalap\xedt\xe1s \xfcnnepe",
            fixed_date: [
                8,
                20
            ]
        },
        {
            name: "az 1956-os forradalom \xfcnnepe",
            fixed_date: [
                10,
                23
            ]
        },
        {
            name: "mindenszentek",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "kar\xe1csony",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "kar\xe1csony m\xe1snap",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2014: [
                10,
                23,
                11,
                2
            ],
            2015: [
                10,
                23,
                11,
                1
            ],
            2016: [
                10,
                29,
                11,
                6
            ],
            2017: [
                10,
                28,
                11,
                5
            ],
            2018: [
                10,
                27,
                11,
                4
            ],
            2019: [
                10,
                26,
                11,
                3
            ],
            2020: [
                10,
                23,
                11,
                1
            ],
            2021: [
                10,
                23,
                11,
                1
            ],
            2023: [
                10,
                28,
                11,
                5
            ],
            2024: [
                10,
                26,
                11,
                3
            ],
            2025: [
                10,
                23,
                11,
                2
            ],
            name: "\u0151szi sz\xfcnet"
        },
        {
            2014: [
                12,
                20,
                1,
                4
            ],
            2015: [
                12,
                19,
                1,
                3
            ],
            2016: [
                12,
                22,
                1,
                2
            ],
            2017: [
                12,
                23,
                1,
                2
            ],
            2018: [
                12,
                22,
                1,
                2
            ],
            2019: [
                12,
                21,
                1,
                5
            ],
            2020: [
                12,
                19,
                1,
                3
            ],
            2021: [
                12,
                22,
                1,
                2
            ],
            2022: [
                12,
                22,
                1,
                8
            ],
            2023: [
                12,
                22,
                1,
                7
            ],
            2024: [
                12,
                21,
                1,
                5
            ],
            2025: [
                12,
                20,
                1,
                4
            ],
            name: "t\xe9li sz\xfcnet"
        },
        {
            2015: [
                4,
                2,
                4,
                7
            ],
            2016: [
                3,
                24,
                3,
                29
            ],
            2017: [
                4,
                13,
                4,
                18
            ],
            2018: [
                3,
                29,
                4,
                3
            ],
            2019: [
                4,
                18,
                4,
                23
            ],
            2020: [
                4,
                7,
                4,
                14
            ],
            2021: [
                4,
                1,
                4,
                6
            ],
            2022: [
                4,
                14,
                4,
                19
            ],
            2023: [
                4,
                6,
                4,
                11
            ],
            2024: [
                3,
                28,
                4,
                7
            ],
            2025: [
                4,
                17,
                4,
                27
            ],
            2026: [
                4,
                2,
                4,
                12
            ],
            name: "tavaszi sz\xfcnet"
        },
        {
            2015: [
                6,
                16,
                8,
                31
            ],
            2016: [
                6,
                16,
                8,
                31
            ],
            2017: [
                6,
                16,
                8,
                31
            ],
            2018: [
                6,
                16,
                9,
                2
            ],
            2019: [
                6,
                15,
                9,
                1
            ],
            2020: [
                6,
                16,
                8,
                31
            ],
            2021: [
                6,
                16,
                8,
                31
            ],
            2022: [
                6,
                16,
                8,
                31
            ],
            2023: [
                6,
                17,
                8,
                31
            ],
            2024: [
                6,
                22,
                9,
                1
            ],
            2025: [
                6,
                21,
                8,
                31
            ],
            2026: [
                6,
                20,
                8,
                31
            ],
            name: "ny\xe1ri sz\xfcnet"
        }
    ]
};
$0e3b0f6e50344df5$var$data$l.PH;
$0e3b0f6e50344df5$var$data$l.SH;
var $0e3b0f6e50344df5$var$data$k = {
    PH: [
        {
            name: "New Year\u2019s Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "St Patrick\u2019s Day",
            fixed_date: [
                3,
                17
            ]
        },
        {
            name: "St Patrick\u2019s Day",
            variable_date: "nextMo-Fr17March"
        },
        {
            name: "Good Friday",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Easter Monday",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "May Bank Holiday",
            variable_date: "firstMayMonday"
        },
        {
            name: "June Bank Holiday",
            variable_date: "firstJuneMonday"
        },
        {
            name: "August Bank Holiday",
            variable_date: "firstAugustMonday"
        },
        {
            name: "October Bank Holiday (Halloween)",
            variable_date: "lastOctoberMonday"
        },
        {
            name: "Christmas",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "St Stephen\u2019s Day",
            fixed_date: [
                12,
                26
            ]
        },
        {
            name: "Bank Holiday",
            fixed_date: [
                12,
                27
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$k.PH;
var $0e3b0f6e50344df5$var$data$j = {
    PH: [
        {
            name: "Capodanno",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Epifania",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "Liberazione dal nazifascismo (1945)",
            fixed_date: [
                4,
                25
            ]
        },
        {
            name: "Pasqua",
            variable_date: "easter"
        },
        {
            name: "Luned\xec di Pasqua",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Festa del lavoro",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Festa della Repubblica",
            fixed_date: [
                6,
                2
            ]
        },
        {
            name: "Assunzione di Maria",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Ognissanti",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Immacolata Concezione",
            fixed_date: [
                12,
                8
            ]
        },
        {
            name: "Natale di Ges\xf9",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Santo Stefano",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$j.PH;
var $0e3b0f6e50344df5$var$data$i = {
    PH: [
        {
            name: "\u5143\u65E5",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "\u6210\u4EBA\u306E\u65E5",
            variable_date: "firstJanuaryMonday",
            offset: 7
        },
        {
            name: "\u5EFA\u56FD\u8A18\u5FF5\u306E\u65E5",
            fixed_date: [
                2,
                11
            ]
        },
        {
            name: "\u5929\u7687\u8A95\u751F\u65E5",
            fixed_date: [
                2,
                23
            ]
        },
        {
            name: "\u662D\u548C\u306E\u65E5",
            fixed_date: [
                4,
                29
            ]
        },
        {
            name: "\u61B2\u6CD5\u8A18\u5FF5\u65E5",
            fixed_date: [
                5,
                3
            ]
        },
        {
            name: "\u307F\u3069\u308A\u306E\u65E5",
            fixed_date: [
                5,
                4
            ]
        },
        {
            name: "\u3053\u3069\u3082\u306E\u65E5",
            fixed_date: [
                5,
                5
            ]
        },
        {
            name: "\u6D77\u306E\u65E5",
            variable_date: "firstJulyMonday",
            offset: 14
        },
        {
            name: "\u5C71\u306E\u65E5",
            fixed_date: [
                8,
                11
            ]
        },
        {
            name: "\u656C\u8001\u306E\u65E5",
            variable_date: "firstSeptemberMonday",
            offset: 14
        },
        {
            name: "\u30B9\u30DD\u30FC\u30C4\u306E\u65E5",
            variable_date: "firstNovemberMonday",
            offset: 7
        },
        {
            name: "\u6587\u5316\u306E\u65E5",
            fixed_date: [
                11,
                3
            ]
        },
        {
            name: "\u52E4\u52B4\u611F\u8B1D\u306E\u65E5",
            fixed_date: [
                11,
                23
            ]
        },
        {
            name: "\u6625\u5206\u306E\u65E5",
            variable_date: "springEquinox"
        },
        {
            name: "\u79CB\u5206\u306E\u65E5",
            variable_date: "autumnalEquinox"
        }
    ]
};
$0e3b0f6e50344df5$var$data$i.PH;
var $0e3b0f6e50344df5$var$data$h = {
    PH: [
        {
            name: "Neijoerschdag - Neujahr - Nouvel An",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Ouschterm\xe9indeg - Ostermontag - Lundi de P\xe2ques",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Dag vun der Aarbecht - Tag der Arbeit - Premier Mai",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Europadag - Europatag - Journ\xe9e de l'Europe",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Christi Himmelfaart - Christi Himmelfahrt - Ascension",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "P\xe9ngschtm\xe9indeg - Pfingstmontag - Lundi de Pentec\xf4te",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Nationalfeierdag - Nationalfeiertag - F\xeate nationale",
            fixed_date: [
                6,
                23
            ]
        },
        {
            name: "Mari\xe4 Himmelfaart - Maria Himmelfahrt - Assomption",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Allerhellgen - Weihnachten - Allerheiligen - Toussaint",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "Chr\xebschtdag - No\xebl",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Stiefesdag - Zweiter Weihnachtsfeiertag - St. Etienne",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2023: [
                10,
                28,
                11,
                5
            ],
            2024: [
                10,
                26,
                11,
                3
            ],
            2025: [
                11,
                1,
                11,
                9
            ],
            name: "Allerhellegen - Allerheiligenurlaub - Cong\xe9 de la Toussaint"
        },
        {
            2023: [
                12,
                6
            ],
            2024: [
                12,
                6
            ],
            2025: [
                12,
                6
            ],
            name: "Fest vum Hellege Nikolaus (n\xebmme fir Grondausbildung) - Nikolausfest (nur f\xfcr die Grundschule) - F\xeate de Saint Nicolas (uniquement pour l'enseignement fondamental)"
        },
        {
            2023: [
                12,
                23,
                1,
                7
            ],
            2024: [
                12,
                21,
                1,
                5
            ],
            2025: [
                12,
                20,
                1,
                4
            ],
            name: "Chr\xebschtdag Vakanz - Weihnachtsferien - Vacances de No\xebl"
        },
        {
            2024: [
                2,
                10,
                2,
                18
            ],
            2025: [
                2,
                15,
                2,
                23
            ],
            2026: [
                2,
                14,
                2,
                22
            ],
            name: "Karneval Vakanz - Karnevalsferien - Cong\xe9 de Carnaval"
        },
        {
            2024: [
                3,
                30,
                4,
                14
            ],
            2025: [
                4,
                5,
                4,
                20
            ],
            2026: [
                3,
                28,
                4,
                12
            ],
            name: "Ouschtervakanz - Osterferien - Vacances de P\xe2ques"
        },
        {
            2024: [
                5,
                25,
                6,
                2
            ],
            2025: [
                5,
                24,
                6,
                1
            ],
            2026: [
                5,
                23,
                5,
                31
            ],
            name: "P\xe4ischtvakanz - Pfingstferien - Cong\xe9 de la Pentec\xf4te"
        },
        {
            2025: [
                6,
                23
            ],
            2026: [
                6,
                23
            ],
            name: "Gebuertsdag vum Grand-Duc - Geburtstag des Gro\xdfherzogs - l'anniversaire du Grand-Duc"
        },
        {
            2024: [
                7,
                16,
                9,
                15
            ],
            2025: [
                7,
                16,
                9,
                14
            ],
            2026: [
                7,
                16,
                9,
                14
            ],
            name: "Summervakanz - Sommerferien - Vacances d\u2019\xe9t\xe9"
        }
    ]
};
$0e3b0f6e50344df5$var$data$h.PH;
$0e3b0f6e50344df5$var$data$h.SH;
var $0e3b0f6e50344df5$var$data$g = {
    PH: [
        {
            name: "New Year\u2019s Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Independence Day",
            fixed_date: [
                3,
                21
            ]
        },
        {
            name: "Good Friday",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Easter Monday",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Worker\u2019s Day",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Cassinga Day",
            fixed_date: [
                5,
                4
            ]
        },
        {
            name: "Ascension Day",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Africa Day",
            fixed_date: [
                5,
                25
            ]
        },
        {
            name: "Heroes\u2019 Day",
            fixed_date: [
                8,
                26
            ]
        },
        {
            name: "Human Rights Day",
            fixed_date: [
                12,
                10
            ]
        },
        {
            name: "Christmas Day",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Family Day",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$g.PH;
var $0e3b0f6e50344df5$var$data$f = {
    PH: [
        {
            name: "Nieuwjaarsdag",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Goede vrijdag",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Tweede Paasdag",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Koningsdag",
            fixed_date: [
                4,
                27
            ]
        },
        {
            name: "Bevrijdingsdag",
            fixed_date: [
                5,
                5
            ]
        },
        {
            name: "Hemelvaartsdag",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Tweede Pinksterdag",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Eerste Kerstdag",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Tweede Kerstdag",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$f.PH;
var $0e3b0f6e50344df5$var$data$e = {
    PH: [
        {
            name: "Nytt\xe5rsdag",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Skj\xe6rtorsdag",
            variable_date: "easter",
            offset: -3
        },
        {
            name: "Langfredag",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "P\xe5skedag",
            variable_date: "easter"
        },
        {
            name: "2. P\xe5skedag",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "1. Mai",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Grunnlovsdagen",
            fixed_date: [
                5,
                17
            ]
        },
        {
            name: "Kristi Himmelfartsdag",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "Pinsedag",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "2. Pinsedag",
            variable_date: "easter",
            offset: 50
        },
        {
            name: "Juledag",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "2. Juledag",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$e.PH;
var $0e3b0f6e50344df5$var$data$d = {
    PH: [
        {
            name: "New Year's Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Day after New Year's Day",
            fixed_date: [
                1,
                2
            ]
        },
        {
            name: "Waitangi Day",
            fixed_date: [
                2,
                6
            ]
        },
        {
            name: "Good Friday",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Easter Monday",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Anzac Day",
            fixed_date: [
                4,
                25
            ]
        },
        {
            name: "Queen's Birthday",
            variable_date: "firstJuneMonday"
        },
        {
            name: "Labour Day",
            variable_date: "firstOctoberMonday",
            offset: 21
        },
        {
            name: "Christmas Day",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Boxing Day",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$d.PH;
var $0e3b0f6e50344df5$var$data$c = {
    PH: [
        {
            name: "Nowy Rok",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "\u015Awi\u0119to Trzech Kr\xf3li",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "Wielkanoc",
            variable_date: "easter"
        },
        {
            name: "Lany Poniedzia\u0142ek - drugi dzie\u0144 Wielkiej Nocy",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Pierwszy Maja",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Trzeci Maja",
            fixed_date: [
                5,
                3
            ]
        },
        {
            name: "Zielone \u015Awi\u0105tki",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "Bo\u017Ce Cia\u0142o",
            variable_date: "easter",
            offset: 60
        },
        {
            name: "Wniebowzi\u0119cie Naj\u015Bwi\u0119tszej Maryi Panny",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Wszystkich \u015Awi\u0119tych",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "\u015Awi\u0119to Niepodleg\u0142o\u015Bci",
            fixed_date: [
                11,
                11
            ]
        },
        {
            name: "Wigilia Bo\u017Cego Narodzenia",
            fixed_date: [
                12,
                24
            ]
        },
        {
            name: "pierwszy dzie\u0144 Bo\u017Cego Narodzenia",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "drugi dzie\u0144 Bo\u017Cego Narodzenia",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$c.PH;
var $0e3b0f6e50344df5$var$data$b = {
    PH: [
        {
            name: "Anul Nou",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "A doua zi de Anul Nou",
            fixed_date: [
                1,
                2
            ]
        },
        {
            name: "Ziua Unirii Principatelor Rom\xe2ne (Ziua Unirii)",
            fixed_date: [
                1,
                24
            ]
        },
        {
            name: "Pa\u0219tele ortodox",
            variable_date: "orthodox easter"
        },
        {
            name: "A doua zi de Pa\u0219te ortodox",
            variable_date: "orthodox easter",
            offset: 1
        },
        {
            name: "Ziua Muncii",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Rusaliile",
            variable_date: "orthodox easter",
            offset: 50
        },
        {
            name: "A doua zi de Rusalii",
            variable_date: "orthodox easter",
            offset: 51
        },
        {
            name: "Adormirea Maicii Domnului",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "Sf\xe2ntul Apostol Andrei",
            fixed_date: [
                11,
                30
            ]
        },
        {
            name: "Ziua Na\u021Bional\u0103 (Ziua Marii Uniri)",
            fixed_date: [
                12,
                1
            ]
        },
        {
            name: "Cr\u0103ciunul",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "A doua zi de Cr\u0103ciun",
            fixed_date: [
                12,
                26
            ]
        }
    ],
    SH: [
        {
            2015: [
                1,
                31,
                2,
                8
            ],
            2016: [
                1,
                30,
                2,
                7
            ],
            2021: [
                1,
                30,
                2,
                7
            ],
            name: "Vacan\u0163a intersemestrial\u0103"
        },
        {
            2015: [
                4,
                11,
                4,
                19
            ],
            2016: [
                4,
                23,
                5,
                3
            ],
            2021: [
                4,
                30,
                5,
                9
            ],
            name: "Vacan\u021Ba de prim\u0103var\u0103"
        },
        {
            2015: [
                6,
                20,
                9,
                13
            ],
            2016: [
                6,
                18,
                9,
                4
            ],
            2021: [
                6,
                26,
                9,
                13
            ],
            name: "Vacan\u021Ba de var\u0103"
        },
        {
            2014: [
                12,
                20,
                1,
                4
            ],
            2015: [
                12,
                19,
                1,
                3
            ],
            2020: [
                12,
                23,
                1,
                10
            ],
            2021: [
                12,
                23,
                1,
                9
            ],
            name: "Vacan\u021Ba de iarn\u0103"
        }
    ]
};
$0e3b0f6e50344df5$var$data$b.PH;
$0e3b0f6e50344df5$var$data$b.SH;
var $0e3b0f6e50344df5$var$data$a = {
    PH: [
        {
            name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                2
            ]
        },
        {
            name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                3
            ]
        },
        {
            name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                4
            ]
        },
        {
            name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                5
            ]
        },
        {
            name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
            fixed_date: [
                1,
                7
            ]
        },
        {
            name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
            fixed_date: [
                1,
                8
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
            fixed_date: [
                2,
                23
            ]
        },
        {
            name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
            fixed_date: [
                3,
                8
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
            fixed_date: [
                5,
                9
            ]
        },
        {
            name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
            fixed_date: [
                11,
                4
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
            fixed_date: [
                6,
                12
            ]
        }
    ],
    "\u0422\u0430\u0442\u0430\u0440\u0441\u0442\u0430\u043D": {
        _state_code: "tatarstan",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0422\u0430\u0442\u0430\u0440\u0441\u0442\u0430\u043D",
                fixed_date: [
                    8,
                    30
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u0438 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0422\u0430\u0442\u0430\u0440\u0441\u0442\u0430\u043D",
                fixed_date: [
                    11,
                    6
                ]
            }
        ]
    },
    "\u0411\u0430\u0448\u043A\u043E\u0440\u0442\u043E\u0441\u0442\u0430\u043D": {
        _state_code: "bashkortostan",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0411\u0430\u0448\u043A\u0438\u0440\u0438\u0438",
                fixed_date: [
                    10,
                    11
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u0438 \u0411\u0430\u0448\u043A\u043E\u0440\u0442\u043E\u0441\u0442\u0430\u043D\u0430",
                fixed_date: [
                    12,
                    24
                ]
            }
        ]
    },
    "\u0427\u0443\u0432\u0430\u0448\u0438\u044F": {
        _state_code: "chuvashia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0427\u0443\u0432\u0430\u0448\u0441\u043A\u043E\u0439 \u0440\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438",
                fixed_date: [
                    6,
                    24
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0430\u0445\u0430 (\u042F\u043A\u0443\u0442\u0438\u044F)": {
        _state_code: "sakha",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0421\u0430\u0445\u0430",
                fixed_date: [
                    4,
                    27
                ]
            },
            {
                name: "\u042B\u0441\u044B\u0430\u0445",
                fixed_date: [
                    6,
                    23
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0421\u0430\u0445\u0430",
                fixed_date: [
                    9,
                    27
                ]
            }
        ]
    },
    "\u041A\u0430\u043B\u043C\u044B\u043A\u0438\u044F": {
        _state_code: "kalmykia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0426\u0430\u0433\u0430\u043D \u0421\u0430\u0440",
                fixed_date: [
                    1,
                    14
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u0421\u0442\u0435\u043F\u043D\u043E\u0433\u043E \u0423\u043B\u043E\u0436\u0435\u043D\u0438\u044F (\u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u0438) \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0430\u043B\u043C\u044B\u043A\u0438\u044F",
                fixed_date: [
                    4,
                    5
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0411\u0443\u0434\u0434\u044B \u0428\u0430\u043A\u044C\u044F\u043C\u0443\u043D",
                fixed_date: [
                    6,
                    6
                ]
            },
            {
                name: "\u0417\u0443\u043B",
                fixed_date: [
                    12,
                    15
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043F\u0430\u043C\u044F\u0442\u0438 \u0436\u0435\u0440\u0442\u0432 \u0434\u0435\u043F\u043E\u0440\u0442\u0430\u0446\u0438\u0438 \u043A\u0430\u043B\u043C\u044B\u0446\u043A\u043E\u0433\u043E \u043D\u0430\u0440\u043E\u0434\u0430",
                fixed_date: [
                    12,
                    28
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0443\u0440\u044F\u0442\u0438\u044F": {
        _state_code: "buryatia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0421\u0430\u0433\u0430\u0430\u043B\u0433\u0430\u043D",
                fixed_date: [
                    1,
                    14
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0440\u0435\u043B\u0438\u044F": {
        _state_code: "karelia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0430\u0440\u0435\u043B\u0438\u044F",
                fixed_date: [
                    6,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u041A\u0430\u0440\u0435\u043B\u0438\u0438 \u043E\u0442 \u0444\u0430\u0448\u0438\u0441\u0442\u0441\u043A\u0438\u0445 \u0437\u0430\u0445\u0432\u0430\u0442\u0447\u0438\u043A\u043E\u0432",
                fixed_date: [
                    9,
                    30
                ]
            }
        ]
    },
    "\u041F\u0440\u0438\u0432\u043E\u043B\u0436\u0441\u043A\u0438\u0439 \u0444\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433": {
        _state_code: "udmurtia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0423\u0434\u043C\u0443\u0440\u0442\u0441\u043A\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438",
                fixed_date: [
                    5,
                    31
                ]
            }
        ]
    },
    "\u0410\u0434\u044B\u0433\u0435\u044F": {
        _state_code: "adygea",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0410\u0434\u044B\u0433\u0435\u044F",
                fixed_date: [
                    10,
                    5
                ]
            }
        ]
    },
    "\u0414\u0430\u0433\u0435\u0441\u0442\u0430\u043D": {
        _state_code: "dagestan",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u0438 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0414\u0430\u0433\u0435\u0441\u0442\u0430\u043D",
                fixed_date: [
                    7,
                    26
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430 \u043D\u0430\u0440\u043E\u0434\u043E\u0432 \u0414\u0430\u0433\u0435\u0441\u0442\u0430\u043D\u0430",
                fixed_date: [
                    9,
                    15
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            }
        ]
    },
    "\u0418\u043D\u0433\u0443\u0448\u0435\u0442\u0438\u044F": {
        _state_code: "ingushetia",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0418\u043D\u0433\u0443\u0448\u0435\u0442\u0438\u044F",
                fixed_date: [
                    6,
                    4
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            }
        ]
    },
    "\u041A\u0430\u0440\u0430\u0447\u0430\u0435\u0432\u043E-\u0427\u0435\u0440\u043A\u0435\u0441\u0438\u044F": {
        _state_code: "karachay_cherkess",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0432\u043E\u0437\u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043A\u0430\u0440\u0430\u0447\u0430\u0435\u0432\u0441\u043A\u043E\u0433\u043E \u043D\u0430\u0440\u043E\u0434\u0430",
                fixed_date: [
                    5,
                    3
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            }
        ]
    },
    "\u0427\u0435\u0447\u043D\u044F": {
        _state_code: "chechnya",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043C\u0438\u0440\u0430 \u0432 \u0427\u0435\u0447\u0435\u043D\u0441\u043A\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0435",
                fixed_date: [
                    4,
                    16
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            }
        ]
    },
    "\u041A\u0430\u0431\u0430\u0440\u0434\u0438\u043D\u043E-\u0411\u0430\u043B\u043A\u0430\u0440\u0438\u044F": {
        _state_code: "kabardino_balkaria",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0432\u043E\u0437\u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0431\u0430\u043B\u043A\u0430\u0440\u0441\u043A\u043E\u0433\u043E \u043D\u0430\u0440\u043E\u0434\u0430",
                fixed_date: [
                    3,
                    28
                ]
            },
            {
                name: "\u0427\u0435\u0440\u043A\u0435\u0441\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C \u0442\u0440\u0430\u0443\u0440\u0430",
                fixed_date: [
                    5,
                    21
                ]
            },
            {
                name: "\u0423\u0440\u0430\u0437\u0430-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    7,
                    28
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u041A\u0430\u0431\u0430\u0440\u0434\u0438\u043D\u043E-\u0411\u0430\u043B\u043A\u0430\u0440\u0441\u043A\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438",
                fixed_date: [
                    9,
                    1
                ]
            },
            {
                name: "\u041A\u0443\u0440\u0431\u0430\u043D-\u0431\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    10,
                    4
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u043B\u0442\u0430\u0439": {
        _state_code: "altai",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0427\u0430\u0433\u0430-\u0411\u0430\u0439\u0440\u0430\u043C",
                fixed_date: [
                    1,
                    14
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u044B\u0432\u0430": {
        _state_code: "tuva",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u041D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0428\u0430\u0433\u0430\u0430",
                fixed_date: [
                    1,
                    14
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0422\u044B\u0432\u0430",
                fixed_date: [
                    8,
                    15
                ]
            }
        ]
    },
    "\u0421\u0430\u0440\u0430\u0442\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C": {
        _state_code: "saratov",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0420\u0430\u0434\u043E\u043D\u0438\u0446\u0430",
                fixed_date: [
                    4,
                    29
                ]
            }
        ]
    },
    "\u0411\u0440\u044F\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C": {
        _state_code: "bryansk",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0420\u0430\u0434\u043E\u043D\u0438\u0446\u0430",
                fixed_date: [
                    4,
                    29
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0433\u043E\u0440\u043E\u0434\u0430 \u0411\u0440\u044F\u043D\u0441\u043A\u0430",
                fixed_date: [
                    9,
                    17
                ]
            }
        ]
    },
    "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043C\u0438": {
        _state_code: "komi",
        PH: [
            {
                name: "1. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "2. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    2
                ]
            },
            {
                name: "3. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    3
                ]
            },
            {
                name: "4. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    4
                ]
            },
            {
                name: "5. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    5
                ]
            },
            {
                name: "6. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                fixed_date: [
                    1,
                    7
                ]
            },
            {
                name: "8. \u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                fixed_date: [
                    1,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                fixed_date: [
                    2,
                    23
                ]
            },
            {
                name: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                fixed_date: [
                    3,
                    8
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                fixed_date: [
                    5,
                    9
                ]
            },
            {
                name: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0412\u0435\u0441\u043D\u044B \u0438 \u0422\u0440\u0443\u0434\u0430",
                fixed_date: [
                    5,
                    1
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                fixed_date: [
                    11,
                    4
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                fixed_date: [
                    6,
                    12
                ]
            },
            {
                name: "\u0414\u0435\u043D\u044C \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u043E\u043C\u0438",
                fixed_date: [
                    8,
                    22
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$a.PH;
var $0e3b0f6e50344df5$var$data$9 = {
    PH: [
        {
            name: "ny\xe5rsdagen",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "trettondedag jul",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "l\xe5ngfredagen",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "p\xe5skdagen",
            variable_date: "easter"
        },
        {
            name: "annandag p\xe5sk",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "f\xf6rsta maj",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Kristi himmelsf\xe4rdsdag",
            variable_date: "easter",
            offset: 39
        },
        {
            name: "pingstdagen",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "nationaldagen",
            fixed_date: [
                6,
                6
            ]
        },
        {
            name: "midsommardagen",
            variable_date: "nextSaturday20Jun"
        },
        {
            name: "alla helgons dag",
            variable_date: "nextSaturday31Oct"
        },
        {
            name: "juldagen",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "annandag jul",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$9.PH;
var $0e3b0f6e50344df5$var$data$8 = {
    PH: [
        {
            name: "novo leto",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Pre\u0161ernov dan, slovenski kulturni praznik",
            fixed_date: [
                2,
                8
            ]
        },
        {
            name: "velikono\u010Dna nedelja",
            variable_date: "easter"
        },
        {
            name: "velikono\u010Dni ponedeljek",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "dan upora proti okupatorju",
            fixed_date: [
                4,
                27
            ]
        },
        {
            name: "praznik dela 1",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "praznik dela 2",
            fixed_date: [
                5,
                2
            ]
        },
        {
            name: "binko\u0161tna nedelja - binko\u0161ti",
            variable_date: "easter",
            offset: 49
        },
        {
            name: "dan dr\u017Eavnosti",
            fixed_date: [
                6,
                25
            ]
        },
        {
            name: "Marijino vnebovzetje",
            fixed_date: [
                8,
                15
            ]
        },
        {
            name: "dan reformacije",
            fixed_date: [
                10,
                31
            ]
        },
        {
            name: "dan spomina na mrtve",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "bo\u017Ei\u010D",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "dan samostojnosti in enotnosti",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$8.PH;
var $0e3b0f6e50344df5$var$data$7 = {
    PH: [
        {
            name: "De\u0148 vzniku Slovenskej republiky",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Zjavenie P\xe1na",
            fixed_date: [
                1,
                6
            ]
        },
        {
            name: "Ve\u013Ek\xfd piatok",
            variable_date: "easter",
            offset: -2
        },
        {
            name: "Ve\u013Ekono\u010Dn\xe1 nede\u013Ea",
            variable_date: "easter"
        },
        {
            name: "Ve\u013Ekono\u010Dn\xfd pondelok",
            variable_date: "easter",
            offset: 1
        },
        {
            name: "Sviatok pr\xe1ce",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "De\u0148 v\xed\u0165azstva nad fa\u0161izmom",
            fixed_date: [
                5,
                8
            ]
        },
        {
            name: "Sviatok sv\xe4t\xe9ho Cyrila a Metoda",
            fixed_date: [
                7,
                5
            ]
        },
        {
            name: "V\xfdro\u010Die Slovensk\xe9ho n\xe1rodn\xe9ho povstania",
            fixed_date: [
                8,
                29
            ]
        },
        {
            name: "De\u0148 \xdastavy Slovenskej republiky",
            fixed_date: [
                9,
                1
            ]
        },
        {
            name: "Sviatok Panny M\xe1rie Sedembolestnej",
            fixed_date: [
                9,
                15
            ]
        },
        {
            name: "Sviatok v\u0161etk\xfdch sv\xe4t\xfdch",
            fixed_date: [
                11,
                1
            ]
        },
        {
            name: "De\u0148 boja za slobodu a demokraciu",
            fixed_date: [
                11,
                17
            ]
        },
        {
            name: "\u0160tedr\xfd de\u0148",
            fixed_date: [
                12,
                24
            ]
        },
        {
            name: "Prv\xfd sviatok viano\u010Dn\xfd",
            fixed_date: [
                12,
                25
            ]
        },
        {
            name: "Druh\xfd sviatok viano\u010Dn\xfd",
            fixed_date: [
                12,
                26
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$7.PH;
var $0e3b0f6e50344df5$var$data$6 = {
    PH: [
        {
            name: "\u041D\u043E\u0432\u0438\u0439 \u0440\u0456\u043A",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "\u0420\u0456\u0437\u0434\u0432\u043E",
            fixed_date: [
                1,
                7
            ]
        },
        {
            name: "\u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u0436\u0456\u043D\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C",
            fixed_date: [
                3,
                8
            ]
        },
        {
            name: "\u0412\u0435\u043B\u0438\u043A\u0434\u0435\u043D\u044C",
            variable_date: "orthodox easter",
            offset: 1
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041F\u0440\u0430\u0446\u0456 1",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041F\u0440\u0430\u0446\u0456 2",
            fixed_date: [
                5,
                2
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041F\u0435\u0440\u0435\u043C\u043E\u0433\u0438",
            fixed_date: [
                5,
                9
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0456\u0457 \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
            fixed_date: [
                6,
                28
            ]
        },
        {
            name: "\u0414\u0435\u043D\u044C \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0456 \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
            fixed_date: [
                8,
                24
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$6.PH;
var $0e3b0f6e50344df5$var$data$5 = {
    PH: [
        {
            name: "New Year's Day",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Memorial Day",
            variable_date: "lastMayMonday"
        },
        {
            name: "Independence Day",
            fixed_date: [
                7,
                4
            ]
        },
        {
            name: "Labor Day",
            variable_date: "firstSeptemberMonday"
        },
        {
            name: "Veterans Day",
            fixed_date: [
                11,
                11
            ]
        },
        {
            name: "Thanksgiving",
            variable_date: "firstNovemberThursday",
            offset: 21
        },
        {
            name: "Christmas Day",
            fixed_date: [
                12,
                25
            ]
        }
    ],
    Alabama: {
        _state_code: "al",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Robert E. Lee/Martin Luther King Birthday",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "George Washington/Thomas Jefferson Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Confederate Memorial Day",
                variable_date: "firstAprilMonday",
                offset: 21
            },
            {
                name: "Jefferson Davis' Birthday",
                variable_date: "firstJuneMonday"
            }
        ]
    },
    Alaska: {
        _state_code: "ak",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Seward's Day",
                variable_date: "lastMarchMonday"
            },
            {
                name: "Alaska Day",
                fixed_date: [
                    10,
                    18
                ]
            }
        ]
    },
    Arizona: {
        _state_code: "az",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Dr. Martin Luther King Jr./Civil Rights Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Arkansas: {
        _state_code: "ar",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Dr. Martin Luther King Jr. and Robert E. Lee's Birthdays",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "George Washington's Birthday and Daisy Gatson Bates Day",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    California: {
        _state_code: "ca",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "C\xe9sar Ch\xe1vez Day",
                fixed_date: [
                    3,
                    31
                ]
            }
        ]
    },
    Colorado: {
        _state_code: "co",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Connecticut: {
        _state_code: "ct",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Lincoln's Birthday",
                fixed_date: [
                    2,
                    12
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            }
        ]
    },
    Delaware: {
        _state_code: "de",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Day After Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            }
        ]
    },
    "District of Columbia": {
        _state_code: "dc",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Emancipation Day",
                fixed_date: [
                    4,
                    16
                ]
            }
        ]
    },
    Florida: {
        _state_code: "fl",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Friday after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Georgia: {
        _state_code: "ga",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Robert E. Lee's Birthday",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Washington's Birthday",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Confederate Memorial Day",
                variable_date: "lastAprilMonday"
            }
        ]
    },
    Guam: {
        _state_code: "gu",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Guam Discovery Day",
                fixed_date: [
                    3,
                    5
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Liberation Day",
                fixed_date: [
                    7,
                    21
                ]
            },
            {
                name: "All Souls' Day",
                fixed_date: [
                    11,
                    2
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Lady of Camarin Day",
                fixed_date: [
                    12,
                    8
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Hawaii: {
        _state_code: "hi",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Prince Jonah Kuhio Kalanianaole Day",
                fixed_date: [
                    3,
                    26
                ]
            },
            {
                name: "Kamehameha Day",
                fixed_date: [
                    6,
                    11
                ]
            },
            {
                name: "Statehood Day",
                variable_date: "firstAugustFriday",
                offset: 14
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    Idaho: {
        _state_code: "id",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr.-Idaho Human Rights Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Illinois: {
        _state_code: "il",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Lincoln's Birthday",
                fixed_date: [
                    2,
                    12
                ]
            },
            {
                name: "Casimir Pulaski Day",
                variable_date: "firstMarchMonday"
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    Indiana: {
        _state_code: "in",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Lincoln's Birthday",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Primary Election Day",
                variable_date: "firstMayMonday",
                offset: 1
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    Iowa: {
        _state_code: "ia",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Lincoln's Birthday",
                fixed_date: [
                    2,
                    12
                ]
            }
        ]
    },
    Kansas: {
        _state_code: "ks",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Kentucky: {
        _state_code: "ky",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "New Year's Eve",
                fixed_date: [
                    12,
                    31
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            }
        ]
    },
    Louisiana: {
        _state_code: "la",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Mardi Gras",
                variable_date: "easter",
                offset: -47
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    Maine: {
        _state_code: "me",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Patriots' Day",
                variable_date: "firstAprilMonday",
                offset: 14
            }
        ]
    },
    Maryland: {
        _state_code: "md",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Native American Heritage Day",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Massachusetts: {
        _state_code: "ma",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Patriots' Day",
                variable_date: "firstAprilMonday",
                offset: 14
            }
        ]
    },
    Michigan: {
        _state_code: "mi",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "New Year's Eve",
                fixed_date: [
                    12,
                    31
                ]
            }
        ]
    },
    Minnesota: {
        _state_code: "mn",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Mississippi: {
        _state_code: "ms",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King's and Robert E. Lee's Birthdays",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Confederate Memorial Day",
                variable_date: "lastAprilMonday"
            }
        ]
    },
    Missouri: {
        _state_code: "mo",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Truman Day",
                fixed_date: [
                    5,
                    8
                ]
            }
        ]
    },
    Montana: {
        _state_code: "mt",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "New Year's Eve",
                fixed_date: [
                    12,
                    31
                ]
            }
        ]
    },
    Nebraska: {
        _state_code: "ne",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Arbor Day",
                variable_date: "lastAprilFriday"
            }
        ]
    },
    Nevada: {
        _state_code: "nv",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Nevada Day",
                variable_date: "lastOctoberFriday"
            },
            {
                name: "Family Day",
                variable_date: "firstNovemberThursday",
                offset: 22
            }
        ]
    },
    "New Hampshire": {
        _state_code: "nh",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Civil Rights Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Day after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    "New Jersey": {
        _state_code: "nj",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Lincoln's Birthday",
                fixed_date: [
                    2,
                    12
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    "New Mexico": {
        _state_code: "nm",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Day after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "New York": {
        _state_code: "ny",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Lincoln's Birthday",
                fixed_date: [
                    2,
                    12
                ]
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    "North Carolina": {
        _state_code: "nc",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Day after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Day after Christmas",
                fixed_date: [
                    12,
                    26
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            }
        ]
    },
    "North Dakota": {
        _state_code: "nd",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Ohio: {
        _state_code: "oh",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Oklahoma: {
        _state_code: "ok",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Day after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Oregon: {
        _state_code: "or",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Pennsylvania: {
        _state_code: "pa",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Flag Day",
                fixed_date: [
                    6,
                    14
                ]
            }
        ]
    },
    "Puerto Rico": {
        _state_code: "pr",
        PH: [
            {
                name: "D\xeda de A\xf1o Nuevo",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "D\xeda de Reyes",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "Natalicio de Eugenio Mar\xeda de Hostos",
                variable_date: "firstJanuaryMonday",
                offset: 7
            },
            {
                name: "Natalicio de Martin Luther King, Jr.",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "D\xeda de los Presidentes",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "D\xeda de la Abolici\xf3n de Esclavitud",
                fixed_date: [
                    3,
                    22
                ]
            },
            {
                name: "Viernes Santo",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Natalicio de Jos\xe9 de Diego",
                variable_date: "firstAprilMonday",
                offset: 14
            },
            {
                name: "Recordaci\xf3n de los Muertos de la Guerra",
                variable_date: "lastMayMonday"
            },
            {
                name: "D\xeda de la Independencia",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Constituci\xf3n de Puerto Rico",
                fixed_date: [
                    7,
                    25
                ]
            },
            {
                name: "Natalicio de Dr. Jos\xe9 Celso Barbosa",
                fixed_date: [
                    7,
                    27
                ]
            },
            {
                name: "D\xeda del Trabajo",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "D\xeda de la Raza Descubrimiento de Am\xe9rica",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "D\xeda del Veterano",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "D\xeda del Descubrimiento de Puerto Rico",
                fixed_date: [
                    11,
                    19
                ]
            },
            {
                name: "D\xeda de Acci\xf3n de Gracias",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Noche Buena",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "D\xeda de Navidad",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "Rhode Island": {
        _state_code: "ri",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Victory Day",
                variable_date: "firstAugustMonday",
                offset: 7
            }
        ]
    },
    "South Carolina": {
        _state_code: "sc",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Confederate Memorial Day",
                fixed_date: [
                    5,
                    10
                ]
            }
        ]
    },
    "South Dakota": {
        _state_code: "sd",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Native American Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Tennessee: {
        _state_code: "tn",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            }
        ]
    },
    Texas: {
        _state_code: "tx",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Friday after Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 22
            },
            {
                name: "Christmas Eve",
                fixed_date: [
                    12,
                    24
                ]
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Day after Christmas",
                fixed_date: [
                    12,
                    26
                ]
            }
        ]
    },
    "United States Virgin Islands": {
        _state_code: "vi",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Virgin Islands-Puerto Rico Friendship Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Three Kings Day",
                fixed_date: [
                    1,
                    6
                ]
            },
            {
                name: "Transfer Day",
                fixed_date: [
                    3,
                    31
                ]
            },
            {
                name: "Holy Thursday",
                variable_date: "easter",
                offset: -3
            },
            {
                name: "Good Friday",
                variable_date: "easter",
                offset: -2
            },
            {
                name: "Easter Monday",
                variable_date: "easter",
                offset: 1
            },
            {
                name: "Emancipation Day",
                fixed_date: [
                    7,
                    3
                ]
            },
            {
                name: "Hurricane Supplication Day",
                variable_date: "firstJulyMonday",
                offset: 21
            },
            {
                name: "Hurricane Thanksgiving",
                fixed_date: [
                    10,
                    25
                ]
            },
            {
                name: "Liberty Day",
                fixed_date: [
                    11,
                    1
                ]
            },
            {
                name: "Christmas Second Day",
                fixed_date: [
                    12,
                    26
                ]
            },
            {
                name: "New Year's Eve",
                fixed_date: [
                    12,
                    31
                ]
            }
        ]
    },
    Utah: {
        _state_code: "ut",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Pioneer Day",
                fixed_date: [
                    7,
                    24
                ]
            }
        ]
    },
    Vermont: {
        _state_code: "vt",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Town Meeting Day",
                variable_date: "firstMarchTuesday"
            },
            {
                name: "Battle of Bennington",
                variable_date: "firstAugustMonday",
                offset: 14
            }
        ]
    },
    Virginia: {
        _state_code: "va",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    Washington: {
        _state_code: "wa",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    },
    "West Virginia": {
        _state_code: "wv",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "West Virginia Day",
                fixed_date: [
                    6,
                    20
                ]
            },
            {
                name: "Lincoln's Day",
                variable_date: "firstNovemberThursday",
                offset: 22
            }
        ]
    },
    Wisconsin: {
        _state_code: "wi",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            },
            {
                name: "Primary Election Day",
                variable_date: "firstAugustTuesday",
                offset: 7
            },
            {
                name: "Election Day",
                variable_date: "firstNovemberMonday",
                offset: 1
            }
        ]
    },
    Wyoming: {
        _state_code: "wy",
        PH: [
            {
                name: "New Year's Day",
                fixed_date: [
                    1,
                    1
                ]
            },
            {
                name: "Martin Luther King, Jr. Day",
                variable_date: "firstJanuaryMonday",
                offset: 14
            },
            {
                name: "Washington's Birthday",
                variable_date: "firstFebruaryMonday",
                offset: 14
            },
            {
                name: "Memorial Day",
                variable_date: "lastMayMonday"
            },
            {
                name: "Independence Day",
                fixed_date: [
                    7,
                    4
                ]
            },
            {
                name: "Labor Day",
                variable_date: "firstSeptemberMonday"
            },
            {
                name: "Columbus Day",
                variable_date: "firstOctoberMonday",
                offset: 7
            },
            {
                name: "Veterans Day",
                fixed_date: [
                    11,
                    11
                ]
            },
            {
                name: "Thanksgiving",
                variable_date: "firstNovemberThursday",
                offset: 21
            },
            {
                name: "Christmas Day",
                fixed_date: [
                    12,
                    25
                ]
            }
        ]
    }
};
$0e3b0f6e50344df5$var$data$5.PH;
$0e3b0f6e50344df5$var$data$5.Alabama;
$0e3b0f6e50344df5$var$data$5.Alaska;
$0e3b0f6e50344df5$var$data$5.Arizona;
$0e3b0f6e50344df5$var$data$5.Arkansas;
$0e3b0f6e50344df5$var$data$5.California;
$0e3b0f6e50344df5$var$data$5.Colorado;
$0e3b0f6e50344df5$var$data$5.Connecticut;
$0e3b0f6e50344df5$var$data$5.Delaware;
$0e3b0f6e50344df5$var$data$5.Florida;
$0e3b0f6e50344df5$var$data$5.Georgia;
$0e3b0f6e50344df5$var$data$5.Guam;
$0e3b0f6e50344df5$var$data$5.Hawaii;
$0e3b0f6e50344df5$var$data$5.Idaho;
$0e3b0f6e50344df5$var$data$5.Illinois;
$0e3b0f6e50344df5$var$data$5.Indiana;
$0e3b0f6e50344df5$var$data$5.Iowa;
$0e3b0f6e50344df5$var$data$5.Kansas;
$0e3b0f6e50344df5$var$data$5.Kentucky;
$0e3b0f6e50344df5$var$data$5.Louisiana;
$0e3b0f6e50344df5$var$data$5.Maine;
$0e3b0f6e50344df5$var$data$5.Maryland;
$0e3b0f6e50344df5$var$data$5.Massachusetts;
$0e3b0f6e50344df5$var$data$5.Michigan;
$0e3b0f6e50344df5$var$data$5.Minnesota;
$0e3b0f6e50344df5$var$data$5.Mississippi;
$0e3b0f6e50344df5$var$data$5.Missouri;
$0e3b0f6e50344df5$var$data$5.Montana;
$0e3b0f6e50344df5$var$data$5.Nebraska;
$0e3b0f6e50344df5$var$data$5.Nevada;
$0e3b0f6e50344df5$var$data$5.Ohio;
$0e3b0f6e50344df5$var$data$5.Oklahoma;
$0e3b0f6e50344df5$var$data$5.Oregon;
$0e3b0f6e50344df5$var$data$5.Pennsylvania;
$0e3b0f6e50344df5$var$data$5.Tennessee;
$0e3b0f6e50344df5$var$data$5.Texas;
$0e3b0f6e50344df5$var$data$5.Utah;
$0e3b0f6e50344df5$var$data$5.Vermont;
$0e3b0f6e50344df5$var$data$5.Virginia;
$0e3b0f6e50344df5$var$data$5.Washington;
$0e3b0f6e50344df5$var$data$5.Wisconsin;
$0e3b0f6e50344df5$var$data$5.Wyoming;
var $0e3b0f6e50344df5$var$data$4 = {
    PH: [
        {
            name: "T\u1EBFt D\u01B0\u01A1ng L\u1ECBch",
            fixed_date: [
                1,
                1
            ]
        },
        {
            name: "Ng\xe0y Qu\u1ED1c t\u1EBF Ph\u1EE5 n\u1EEF",
            fixed_date: [
                3,
                8
            ]
        },
        {
            name: "Ng\xe0y th\xe0nh l\u1EADp \u0110o\xe0n Thanh ni\xean C\u1ED9ng s\u1EA3n H\u1ED3 Ch\xed Minh",
            fixed_date: [
                3,
                26
            ]
        },
        {
            name: "Ng\xe0y Qu\u1ED1c t\u1EBF Thi\u1EBFu nhi",
            fixed_date: [
                6,
                1
            ]
        },
        {
            name: "Ng\xe0y Nh\xe0 gi\xe1o Vi\u1EC7t Nam",
            fixed_date: [
                11,
                20
            ]
        },
        {
            name: "Ng\xe0y Gi\u1EA3i ph\xf3ng mi\u1EC1n Nam, Th\u1ED1ng nh\u1EA5t \u0110\u1EA5t n\u01B0\u1EDBc",
            fixed_date: [
                4,
                30
            ]
        },
        {
            name: "Ng\xe0y Qu\u1ED1c t\u1EBF lao \u0111\u1ED9ng",
            fixed_date: [
                5,
                1
            ]
        },
        {
            name: "Qu\u1ED1c Kh\xe1nh",
            fixed_date: [
                9,
                2
            ]
        },
        {
            name: "L\u1EC5 Gi\xe1ng Sinh",
            fixed_date: [
                12,
                25
            ]
        }
    ]
};
$0e3b0f6e50344df5$var$data$4.PH;
var $0e3b0f6e50344df5$var$data$3 = {
    PH: [
        {
            name: "New Year",
            fixed_date: [
                1,
                1
            ]
        }
    ],
    SH: [
        {
            2020: [
                6,
                21,
                9,
                23
            ],
            2021: [
                6,
                21,
                9,
                23
            ],
            2022: [
                6,
                21,
                9,
                23
            ],
            2023: [
                6,
                21,
                9,
                23
            ],
            2024: [
                6,
                21,
                9,
                23
            ],
            2025: [
                6,
                21,
                9,
                23
            ],
            2026: [
                6,
                21,
                9,
                23
            ],
            2027: [
                6,
                21,
                9,
                23
            ],
            2028: [
                6,
                21,
                9,
                23
            ],
            2029: [
                6,
                21,
                9,
                23
            ],
            2030: [
                6,
                21,
                9,
                23
            ],
            2031: [
                6,
                21,
                9,
                23
            ],
            2032: [
                6,
                21,
                9,
                23
            ],
            name: "Summer"
        }
    ]
};
$0e3b0f6e50344df5$var$data$3.PH;
$0e3b0f6e50344df5$var$data$3.SH;
var $0e3b0f6e50344df5$var$holiday_definitions = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ar: $0e3b0f6e50344df5$var$data$D,
    at: $0e3b0f6e50344df5$var$data$C,
    au: $0e3b0f6e50344df5$var$data$B,
    be: $0e3b0f6e50344df5$var$data$A,
    br: $0e3b0f6e50344df5$var$data$z,
    ca: $0e3b0f6e50344df5$var$data$y,
    ch: $0e3b0f6e50344df5$var$data$x,
    ci: $0e3b0f6e50344df5$var$data$w,
    cn: $0e3b0f6e50344df5$var$data$v,
    cz: $0e3b0f6e50344df5$var$data$u,
    de: $0e3b0f6e50344df5$var$data$t,
    dk: $0e3b0f6e50344df5$var$data$s,
    es: $0e3b0f6e50344df5$var$data$r,
    fi: $0e3b0f6e50344df5$var$data$q,
    fr: $0e3b0f6e50344df5$var$data$p,
    gb: $0e3b0f6e50344df5$var$data$o,
    gr: $0e3b0f6e50344df5$var$data$n,
    hr: $0e3b0f6e50344df5$var$data$m,
    hu: $0e3b0f6e50344df5$var$data$l,
    ie: $0e3b0f6e50344df5$var$data$k,
    it: $0e3b0f6e50344df5$var$data$j,
    jp: $0e3b0f6e50344df5$var$data$i,
    lu: $0e3b0f6e50344df5$var$data$h,
    na: $0e3b0f6e50344df5$var$data$g,
    nl: $0e3b0f6e50344df5$var$data$f,
    no: $0e3b0f6e50344df5$var$data$e,
    nz: $0e3b0f6e50344df5$var$data$d,
    pl: $0e3b0f6e50344df5$var$data$c,
    ro: $0e3b0f6e50344df5$var$data$b,
    ru: $0e3b0f6e50344df5$var$data$a,
    se: $0e3b0f6e50344df5$var$data$9,
    si: $0e3b0f6e50344df5$var$data$8,
    sk: $0e3b0f6e50344df5$var$data$7,
    ua: $0e3b0f6e50344df5$var$data$6,
    us: $0e3b0f6e50344df5$var$data$5,
    vn: $0e3b0f6e50344df5$var$data$4,
    xa: $0e3b0f6e50344df5$var$data$3
});
var $0e3b0f6e50344df5$var$data$2 = {
    "assuming ok for ko": {
        daytime: "sunrise-sunset",
        spring: "Mar-May",
        summer: "Jun-Aug",
        autumn: "Sep-Nov",
        winter: "Dec-Feb",
        _: "-",
        "=": "-",
        "fr\xfchling": "Mar-May",
        "fr\xfchjahr": "Mar-May",
        sommer: "Jun-Aug",
        herbst: "Sep-Nov",
        gesloten: "off",
        feestdag: "PH",
        feestdagen: "PH",
        m: "Mo",
        w: "We",
        f: "Fr",
        primavera: "Mar-May",
        estate: "Jun-Aug",
        autunno: "Sep-Nov",
        inverno: "Dec-Feb"
    },
    "please use English written ok for ko": {
        "(?:an )?feiertag(?:s|en?)?": "PH"
    },
    "please use off for ko": {
        "ruhetage?": "off",
        geschlossen: "off",
        geschl: "off",
        except: "off"
    },
    "please use ok for workday": {
        wd: "Mo-Fr",
        "on work days?": "Mo-Fr",
        "weekdays?": "Mo-Fr",
        "werktags?": "Mo-Sa",
        vardagar: "Mo-Fr"
    },
    "omit hour keyword": {
        h: ""
    },
    "omit ko": {
        season: "",
        hs: "",
        hrs: "",
        hours: "",
        uhr: "",
        "ge\xf6ffnet": "",
        zwischen: "",
        ist: "",
        durchgehend: "",
        "\xf6ffnungszeit(?:en)?:?": ""
    },
    "omit tag key": {
        "opening_hours\\s*=": ""
    },
    "omit wrong keyword open end": {
        from: "",
        ab: "",
        von: ""
    },
    "assuming open end for ko": {
        "(?:bis|till?|-|\u2013)? ?(?:open ?end|late)": "+"
    },
    "please use ok for uncertainty": {
        "~": "-",
        "\uFF5E": "-"
    },
    "please use fallback rule": {
        otherwise: "||"
    },
    "please use ok for missing data": {
        "\\?": ""
    },
    "please use ok for ko": {
        "\u2192": "-",
        "\u2212": "-",
        "\u2014": "-",
        "\u30FC": "-",
        to: "-",
        "\u0434\u043E": "-",
        a: "-",
        as: "-",
        "\xe1": "-",
        "\xe1s": "-",
        "\xe0s": "-",
        ate: "-",
        "till?": "-",
        until: "-",
        through: "-",
        and: ",",
        "&": ",",
        "\uFF1A": ":",
        "'": "\"",
        always: "24/7",
        "always open": "24/7",
        "always closed": "closed",
        nonstop: "24/7",
        "24x7": "24/7",
        anytime: "24/7",
        "all day": "24/7",
        daily: "Mo-Su",
        everyday: "Mo-Su",
        "every day": "Mo-Su",
        "all days": "Mo-Su",
        "7j/7": "Mo-Su",
        "7/7": "Mo-Su",
        "7days": "Mo-Su",
        "7 days": "Mo-Su",
        "7 days a week": "Mo-Su",
        "7 days/week": "Mo-Su",
        "24 hours 7 days a week": "24/7",
        "24 hours": "00:00-24:00",
        midday: "12:00",
        midnight: "00:00",
        "(?:public )?holidays?": "PH",
        "(?:one )?day after public holiday": "PH +1 day",
        "(?:one )?day before public holiday": "PH -1 day",
        "school ?holidays?": "SH",
        "weekends?": "Sa,Su",
        daylight: "sunrise-sunset",
        "on(?:_| )?appointments?": "\"on appointment\"",
        "by(?:_| )?appointments?": "\"by appointment\"",
        "nach(?: |_)vereinbarung": "\"Nach Vereinbarung\"",
        "nach(?: |_)absprache": "\"Nach Absprache\"",
        bis: "-",
        "t\xe4glich": "Mo-Su",
        "(?:schul)?ferien": "SH",
        "(?:an|nur)? ?sonn-?(?: und |/)feiertag(?:s|en?)?": "PH,Su",
        und: ",",
        u: ",",
        auch: ",",
        "ferm\xe9": "off",
        et: ",",
        "\xe0": "-",
        "jours f\xe9ri\xe9s": "PH",
        sundown: "sunset",
        "morgend\xe4mmerung": "dawn",
        "abendd\xe4mmerung": "dusk",
        sonnenaufgang: "sunrise",
        sonnenuntergang: "sunset",
        ostern: "easter"
    },
    "please use English abbreviation ok for so": {
        so: "Su"
    },
    "please use English abbreviation ok for ko": {
        sun: "Su",
        "sundays?": "Su",
        mon: "Mo",
        "mondays?": "Mo",
        "tues?": "Tu",
        "tuesdays?": "Tu",
        "weds?": "We",
        "wednesdays?": "We",
        thu: "Th",
        "thurs?": "Th",
        "thursdays?": "Th",
        fri: "Fr",
        "fridays?": "Fr",
        sat: "Sa",
        "saturdays?": "Sa",
        son: "Su",
        "sonn-": "Su",
        "sonntags?": "Su",
        "montags?": "Mo",
        di: "Tu",
        "die?": "Tu",
        "dienstags?": "Tu",
        mi: "We",
        "mit?": "We",
        "mittwochs?": "We",
        "don?": "Th",
        "donnerstags?": "Th",
        fre: "Fr",
        "freitags?": "Fr",
        sam: "Sa",
        "samstags?": "Sa",
        dim: "Su",
        dimanche: "Su",
        "lun?": "Mo",
        lundi: "Mo",
        mardi: "Tu",
        mer: "We",
        mercredi: "We",
        "jeu?": "Th",
        jeudi: "Th",
        "ven?": "Fr",
        vendredi: "Fr",
        samedi: "Sa",
        "zon?": "Su",
        zontag: "Su",
        zondag: "Su",
        maandag: "Mo",
        din: "Tu",
        dinsdag: "Tu",
        "woe?": "We",
        woensdag: "We",
        donderdag: "Th",
        "vri?": "Fr",
        vrijdag: "Fr",
        "zat?": "Sa",
        zaterdag: "Sa",
        "ned\u011Ble": "Su",
        ne: "Su",
        "pond\u011Bl\xed": "Mo",
        po: "Mo",
        "\xfater\xfd": "Tu",
        "\xfat": "Tu",
        "st\u0159eda": "We",
        st: "We",
        "\u010Dtvrtek": "Th",
        "\u010Dt": "Th",
        "p\xe1tek": "Fr",
        "p\xe1": "Fr",
        sobota: "Sa",
        martes: "Tu",
        "mi\xe9rcoles": "We",
        jueves: "Th",
        viernes: "Fr",
        "s\xe1bado": "Sa",
        domingo: "Su",
        lunes: "Mo",
        selasa: "Su",
        rabu: "Mo",
        kami: "Tu",
        jumat: "We",
        sabtu: "Th",
        minggu: "Fr",
        senin: "Sa",
        "s\xf6ndag": "Su",
        "s\xf6ndagar": "Su",
        "m\xe5ndag": "Mo",
        ma: "Mo",
        tisdag: "Tu",
        onsdag: "We",
        torsdag: "Th",
        fredag: "Fr",
        "l\xf6rdag": "Sa",
        "l\xf6rdagar": "Sa",
        niedziela: "Su",
        niedz: "Su",
        n: "Su",
        ndz: "Su",
        "poniedzia\u0142ek": "Mo",
        poniedzialek: "Mo",
        pon: "Mo",
        pn: "Mo",
        wtorek: "Tu",
        wt: "Tu",
        "\u015Broda": "We",
        sroda: "We",
        "\u015Br": "We",
        sr: "We",
        czwartek: "Th",
        czw: "Th",
        cz: "Th",
        "pi\u0105tek": "Fr",
        piatek: "Fr",
        pt: "Fr",
        sob: "Sa",
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435": "Su",
        "\u0412\u0441": "Su",
        "voskresen'ye": "Su",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A": "Mo",
        "\u041F\u043D": "Mo",
        "ponedel'nik": "Mo",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A": "Tu",
        vtornik: "Tu",
        "\u0441\u0440\u0435\u0434\u0430": "We",
        sreda: "We",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433": "Th",
        chetverk: "Th",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430": "Fr",
        pyatnitsa: "Fr",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430": "Sa",
        subbota: "Sa",
        "s\xf8ndag": "Su",
        mandag: "Mo",
        tirsdag: "Tu",
        "l\xf8rdag": "Sa",
        dom: "Su",
        "domenica?": "Su",
        "domeniche?": "Su",
        lun: "Mo",
        "luned\xec?": "Mo",
        "mar?": "Tu",
        "marted\xec?": "Tu",
        "mer?": "We",
        "mercoled\xec?": "We",
        gio: "Th",
        "gioved\xec?": "Th",
        ven: "Fr",
        "venerd\xec?": "Fr",
        sab: "Sa",
        "sabato?": "Sa",
        "j\xe4nner": "Jan",
        january: "Jan",
        february: "Feb",
        march: "Mar",
        april: "Apr",
        "june?": "Jun",
        "july?": "Jul",
        august: "Aug",
        september: "Sep",
        sept: "Sep",
        october: "Oct",
        november: "Nov",
        december: "Dec",
        januar: "Jan",
        februar: "Feb",
        "m\xe4rz?": "Mar",
        maerz: "Mar",
        mai: "May",
        juni: "Jun",
        juli: "Jul",
        okt: "Oct",
        oktober: "Oct",
        dez: "Dec",
        dezember: "Dec",
        janvier: "Jan",
        "f\xe9vrier": "Feb",
        "f\xe9v": "Feb",
        mars: "Mar",
        avril: "Apr",
        avr: "Apr",
        juin: "Jun",
        juillet: "Jul",
        "ao\xfbt": "Aug",
        "ao\xfb": "Aug",
        septembre: "Sep",
        octobre: "Oct",
        novembre: "Nov",
        "d\xe9cembre": "Dec",
        januari: "Jan",
        februari: "Feb",
        maart: "Mar",
        mei: "May",
        augustus: "Aug",
        gennaio: "Jan",
        febbraio: "Feb",
        marzo: "Mar",
        aprile: "Apr",
        "giugno?": "Jun",
        "luglio?": "Jul",
        agosto: "Aug",
        settembre: "Sep",
        ottobre: "Oct",
        dicembre: "Dec"
    },
    "please use ok for similar looking ko": {
        "\u043Eff": "off"
    },
    "please use 24 hours time for ko": {
        pm: "pm",
        "p.m.": "pm",
        "\u0440\u043C": "pm",
        am: "am",
        "a.m.": "am",
        "\u0430\u043C": "am"
    },
    "please use restriction comment time for ko": {
        damen: "open \"Damen\"",
        herren: "open \"Herren\""
    },
    "please use ok for typographically correct": {
        "\u2013": "-",
        "\u201E": "\"",
        "\u201C": "\"",
        "\u201D": "\"",
        "\xab": "\"",
        "\xbb": "\"",
        "\u201A": "\"",
        "\u2018": "\"",
        "\u2019": "\"",
        "\u300C": "\"",
        "\u300D": "\"",
        "\u300E": "\"",
        "\u300F": "\""
    }
};
var $0e3b0f6e50344df5$var$data$1 = {
    "unexpected token": "Unexpected token: \"{{token}}\" This means that the syntax is not valid at that point or it is currently not supported.",
    "no string": "The value (first parameter) is not a string.",
    nothing: "The value contains nothing meaningful which can be parsed.",
    "nothing useful": "This rule does not contain anything useful. Please remove this empty rule.",
    "combine rules": "Separate rules detected each of which only consists of a time selector. These rules should be written as one rule by combining them using \"{{ok}}\".",
    "value ends with token": "The value ends with \"{{token}}\". Please either continue after \"{{token}}\" or remove \"{{token}}\".",
    "programmers joke": "Might it be possible that you are a programmer and adding a semicolon after each statement is hardwired in your muscle memory ;) ? The thing is that the semicolon in the opening_hours syntax is defined as rule separator. So for compatibility reasons you should omit this last semicolon.",
    "interpreted as year": "The number {{number}} will be interpreted as year. This is probably not intended. Times can be specified as \"12:00\".",
    "rule before fallback empty": "Rule before fallback rule does not contain anything useful",
    "hour min separator": "Please use \":\" as hour/minute-separator",
    "warnings severity": "The parameter optional_conf_parm[\"warnings_severity\"] must be an integer number between 0 and 7 (inclusive). Given {{severity}}, expected one of the following numbers: {{allowed}}.",
    "optional conf parm type": "The optional_conf_parm parameter is of unknown type. Given {{given}}",
    "conf param tag key missing": "The optional_conf_parm[\"tag_key\"] is missing, required by optional_conf_parm[\"map_value\"].",
    "conf param mode invalid": "The optional_conf_parm[\"mode\"] parameter is a invalid number. Gave {{given}}, expected one of the following numbers: {{allowed}}.",
    "conf param unknown type": "The optional_conf_parm[\"{{key}}\"] parameter is of unknown type. Given {{given}}, expected {{expected}}.",
    "library bug": "An error occurred during evaluation of the value \"{{value}}\". Please file a bug report or pull request: {{url}}.{{message}}",
    "library bug PR only": "An error occurred during evaluation of the value \"{{value}}\". Please submit a pull request: {{url}}.{{message}}",
    "use multi": "You have used {{count}} {{part2}} Rules can be separated by \";\".",
    "selector multi 2a": "{{what}} in one rule. You may only use one in one rule.",
    "selector multi 2b": "not connected {{what}} in one rule. This is probably an error. Equal selector types can (and should) always be written in conjunction separated by comma. Example for time ranges \"12:00-13:00,15:00-18:00\". Example for weekdays \"Mo-We,Fr\".",
    "selector state": "state keywords",
    comments: "comments",
    "holiday ranges": "holiday ranges",
    months: "months",
    weekdays: "weekdays",
    ranges: "ranges",
    "default state": "This rule which changes the default state (which is closed) for all following rules is not the first rule. The rule will overwrite all previous rules. It can be legitimate to change the default state to open for example and then only specify for which times the facility is closed.",
    vague: "This rule is not very explicit because there is no time selector being used. A time selector is the part specifying hours when the object is opened, for example \"10:00-19:00\". Please add a time selector to this rule or use a comment to make it more explicit.",
    "empty comment": "You have used an empty comment. Please either write something in the comment or use the keyword unknown instead.",
    separator_for_readability: "You have used the optional symbol <separator_for_readability> in the wrong place. Please check the syntax specification to see where it could be used or remove it.",
    "strange 24/7": "You used 24/7 in a way that is probably not interpreted as \"24 hours 7 days a week\". For correctness you might want to use \"open\" or \"closed\" for this rule and then write your exceptions which should achieve the same goal and is more clear e.g. \"open; Mo 12:00-14:00 off\".",
    "public holiday": 'There was no PH (public holiday) specified. This is not very explicit.{{part2}} Please either append a "PH off" rule if the amenity is closed on all public holidays or use something like "Sa,Su,PH 12:00-16:00" to say that on Saturdays, Sundays and on public holidays the amenity is open 12:00-16:00. Be careful with opening hours like "Fr-Sa 18:00-06:00" because "PH off" applies to 00:00-24:00. So "Fr-Sa 18:00-06:00; PH 18:00-06:00 off" is probably what you want. If the amenity is open everyday including public holidays then you can make this explicit by writing "Mo-Su,PH". If you are not certain try to find it out. If you can\u2019t then do not add PH to the value and ignore this warning.',
    "public holiday part2": " Unfortunately the tag key (e.g. \"opening_hours\", or \"lit\") is unknown to opening_hours.js. This warning only applies to the key {{keys}}. If your value is for that key than read on. If not you can ignore the following.",
    "additional_rule_separator not used after time wrapping midnight": "This rule overwrites parts of the previous rule. This happens because normal rules apply to the whole day and overwrite any definition made by previous rules. You can make this rule an additional rule by using a \",\" instead of the normal \";\" to separate the rules. Note that the overwriting can also be desirable in which case you can ignore this warning.",
    "additional rule which evaluates to closed": "This rule will be evaluated as closed but it was specified as additional rule. It should be specified as normal rule using \";\" as rule separator. See https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:rule_modifier:closed.",
    switched: "The selector \"{{first}}\" was switched with the selector \"{{second}}\" for readability and compatibility reasons.",
    "no colon after": 'Please don\u2019t use ":" after {{token}}.',
    "number -5 to 5": "Number between -5 and 5 (except 0) expected.",
    "one weekday constraint": "You can not use more than one constrained weekday in a month range",
    "range constrained weekdays": "You can not use a range of constrained weekdays in a month range",
    expected: "\"{{symbol}}\" expected.",
    "range zero": "You can not use {{type}} ranges with period equals zero.",
    "period one year+": 'Please don\u2019t use {{type}} ranges with period equals one. If you want to express that a facility is open starting from a year without limit use "<year>+".',
    "period one": "Please don\u2019t use {{type}} ranges with period equals one.",
    "month 31": "The day for {{month}} must be between 1 and 31.",
    "month 30": "Month {{month}} doesn't have 31 days. The last day of {{month}} is day 30.",
    "month feb": "Month {{month}} either has 28 or 29 days (leap years).",
    "point in time": "hyphen (-) or open end (+) in time range {{calc}}expected. For working with points in time, the mode for {{libraryname}} has to be altered. Maybe wrong tag?",
    calculation: "calculation",
    "time range continue": "Time range does not continue as expected",
    "period continue": "Time period does not continue as expected. Example \"/01:30\".",
    "time range mode": "{{libraryname}} is running in \"time range mode\". Found point in time.",
    "point in time mode": "{{libraryname}} is running in \"points in time mode\". Found time range.",
    "outside current day": "Time range starts outside of the current day",
    "two midnights": "Time spanning more than two midnights not supported",
    "without minutes": "Time range without minutes specified. Not very explicit! Please use this syntax instead \"{{syntax}}\".",
    "outside day": "Time range starts outside of the current day",
    "zero calculation": "Adding zero in a variable time calculation does not change the variable time. Please omit the calculation (example: \"sunrise-(sunset-00:00)\").",
    "calculation syntax": "Calculation with variable time is not in the right syntax",
    missing: "Missing \"{{symbol}}\"",
    "(time)": "(time)",
    "bad range": "Bad range: {{from}}-{{to}}",
    "] or more numbers": "\"]\" or more numbers expected.",
    "additional rule no sense": "An additional rule does not make sense here. Just use a \";\" as rule separator. See https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:additional_rule_separator",
    "unexpected token weekday range": "Unexpected token in weekday range: {{token}}",
    "max differ": "There should be no reason to differ more than {{maxdiffer}} days from a {{name}}. If so tell us \u2026",
    "adding 0": "Adding 0 does not change the date. Please omit this.",
    "unexpected token holiday": "Unexpected token (holiday parser): {{token}}",
    "no holiday definition": "There are no holidays ({{name}}) defined for country {{cc}}.",
    "no holiday definition state": "There are no holidays ({{name}}) defined for country {{cc}} and state {{state}}.",
    "no country code": "Country code missing which is needed to select the correct holidays (see README how to provide it)",
    "no SH definition": "School holiday {{name}}not defined for the year {{year}}.",
    "movable no formula": "Movable day {{name}} can not not be calculated. Please add the formula how to calculate it.",
    "movable not in year": "The movable day {{name}} plus {{days}} days is not in the year of the movable day anymore. Currently not supported.",
    "year range one year": "A year range in which the start year is equal to the end year does not make sense. Please remove the end year. E.g. \"{{year}} May 23\"",
    "year range reverse": "A year range in which the start year is greater than the end year does not make sense. Please turn it over.",
    "year past": "The year is in the past.",
    "unexpected token year range": "Unexpected token in year range: {{token}}",
    "week range reverse": "You have specified a week range in reverse order or leaping over a year. This is (currently) not supported.",
    "week negative": "You have specified a week date less then one. A valid week date range is 1-53.",
    "week exceed": "You have specified a week date greater then 53. A valid week date range is 1-53.",
    "week period less than 2": "You have specified a week period which is less than two. If you want to select the whole range from week {{weekfrom}} to week {{weekto}} then just omit the \"/{{period}}\".",
    "week period greater than 26": "You have specified a week period which is greater than 26. 26.5 is the half of the maximum 53 week dates per year so a week date period greater than 26 would only apply once per year. Please specify the week selector as \"week {{weekfrom}}\" if that is what you want to express.",
    "unexpected token week range": "Unexpected token in week range: {{token}}",
    "unexpected token month range": "Unexpected token in month range: {{token}}",
    "day range reverse": "Range in wrong order. From day is greater than to day.",
    "open end": "Specified as open end. Closing time was guessed.",
    "date parameter needed": "Date parameter needed.",
    "assuming ok for ko": "Assuming \"{{ok}}\" for \"{{ko}}\".",
    "please use ok for ko": "Please use notation \"{{ok}}\" for \"{{ko}}\".",
    "please use ok for similar looking ko": "Please use notation \"{{ok}}\" for \"{{ko}}\". Those characters look very similar but are not the same!",
    "rant degree sign used for zero": "Note that this is not a (superscript) zero but a degree sign which is misused as zero. A superscript zero is defined in Unicode (\xb0) and would have been more appropriate/uniform here. But note that the use of none-ASCII digits is not allowed.",
    "please use English written ok for ko": "Please use the English written \"{{ok}}\" for \"{{ko}}\".",
    "please use English abbreviation ok for ko": "Please use the English abbreviation \"{{ok}}\" for \"{{ko}}\".",
    "please use English abbreviation ok for so": "Please use the English abbreviation \"{{ok}}\" for \"{{ko}}\". Note that it might also mean Saturday in Polish.",
    "please use off for ko": "Please use \"{{ok}}\" for \"{{ko}}\". Example: \"Mo-Fr 08:00-12:00; Tu off\".",
    "please use ok for workday": "Assuming \"{{ok}}\" for \"{{ko}}\". Please avoid using \"workday\": https://wiki.openstreetmap.org/wiki/Talk:Key:opening_hours#need_syntax_for_holidays_and_workingdays",
    "omit hour keyword": "Please omit \"{{ko}}\" or use a colon instead. Example: \"12:00-14:00\".",
    "omit ko": "Please omit \"{{ko}}\".",
    "omit tag key": "Please omit \"{{ko}}\". The tag key must not be in the tag value.",
    "omit wrong keyword open end": "Please omit \"{{ko}}\". The tag key must not be in the tag value.",
    "assuming open end for ko": "Assuming \"{{ok}}\" (open end time) for \"{{ko}}\". Example: \"12:00+\".",
    "please use ok for uncertainty": "Please use notation \"{{ok}}\" for \"{{ko}}\". If there is reason to suspect uncertainty consider adding a comment. Example: 12:00-14:00 \"only on sunshine\".",
    "please use fallback rule": "Please use notation \"{{ok}}\" (Fallback rule) for \"{{ko}}\". Example: Mo-Fr 12:00-14:00; PH off || \"by appointment\"",
    "please use ok for missing data": "Please consider adding a FIXME tag instead.",
    "please use 24 hours time for ko": "Please use time format in 24 hours notation instead of the legacy 12 hours variant. If the 12 hours variant is used you might have to convert the hours to the 24 hours notation.",
    "please use restriction comment time for ko": "It looks like you might want to define additional restrictions. If that is the case and they can not be expressed by other syntax elements then you could use a comment together with the `open` keyword. Example: open \"female only\"",
    "please use ok for typographically correct": 'Please use notation "{{ok}}" for "{{ko}}". Although using "{{ko}}" is typographical correct, it is not defined in the opening_hours syntax. Correct typography should be done on application level \u2026'
};
var $0e3b0f6e50344df5$var$data = {
    en: {
        opening_hours: {
            pretty: {
                off: "closed",
                SH: "school holidays",
                PH: "public holidays"
            }
        }
    },
    de: {
        opening_hours: {
            texts: {
                "unexpected token": "Unerwartetes Zeichen: \"{{token}}\" Das bedeutet, dass die Syntax an dieser Stelle nicht erkannt werden konnte.",
                "no string": "Der Wert (erster Parameter) ist kein String",
                nothing: "Der Wert enth\xe4lt nichts, was ausgewertet werden k\xf6nnte.",
                "nothing useful": "Diese Regel enth\xe4lt nichts n\xfctzliches. Bitte entferne diese leere Regel.",
                "combine rules": "Getrennte Regeln erkannt welche jeweils nur aus einer Zeit Bereichsdefinition bestehen. Diese Regeln sollten mittels \"{{ok}}\" zu einer Regel kombiniert werden.",
                "value ends with token": 'Der Wert endet mit "{{token}}". Bitte erg\xe4nze den Wert nach "{{token}}" oder l\xf6sche "{{token}}".',
                "programmers joke": "Kann es sein, dass du ein Programmierer bist und das Hinzuf\xfcgen eines Semikolons nach jedem Statement ist zwanghaft ;) ? Es ist so, dass das Semikolon in der opening_hours-Syntax als Trenner f\xfcr Regeln definiert ist. Bitte verzichte an dieser Stelle auf ein Semikolon.",
                "interpreted as year": "Die Zahl {{number}} wird als Jahr interpretiert. Vermutlich ist das nicht beabsichtigt. Uhrzeiten werden als \"12:00\" angegeben.",
                "rule before fallback empty": "Die Regel vor der Fallback-Regel enth\xe4lt nichts n\xfctzliches",
                "hour min separator": "Bitte benutze \":\" als Stunden/Minuten-Trenner",
                "warnings severity": 'Der Parameter optional_conf_parm["warnings_severity"] muss eine ganze Zahl zwischen (einschlie\xdflich) 0 und (einschlie\xdflich) 7 sein. Gegeben: {{severity}}, erwartet: Eine der Zahlen: {{allowed}}.',
                "optional conf parm type": "Der optional_conf_parm Parameter hat einen unbekannten Typ. Gegeben: {{given}}",
                "conf param tag key missing": "Der optional_conf_parm[\"tag_key\"] fehlt, ist aber notwendig wegen optional_conf_parm[\"map_value\"].",
                "conf param mode invalid": 'Der optional_conf_parm["mode"]-Parameter ist eine ung\xfcltige Zahl. Gegeben: {{given}}, erwartet: Eine der Zahlen: {{allowed}}.',
                "conf param unknown type": "Der optional_conf_parm[\"{{key}}\"] Parameter hat einen unbekannten Typ. Gegeben: {{given}}, erwartet: {{expected}}.",
                "library bug": "Bei der Auswertung des Wertes \"{{value}}\" ist ein Fehler aufgetreten. Bitte melde diesen Fehler oder korrigiere diesen mittels eines Pull Requests oder Patches: {{-url}}.{{message}}",
                "library bug PR only": 'Bei der Auswertung des Wertes "{{value}}" ist ein Fehler aufgetreten. Du kannst dies korrigieren, indem du das Problem l\xf6st und in Form eines Pull Requests oder Patches zum Projekt beitr\xe4gst: {{-url}}.{{message}}',
                "use multi": 'Du hast {{count}} {{-part2}} Einzelne Regeln k\xf6nnen mit ";" getrennt werden.',
                "selector multi 2a": "{{what}} in einer Regel benutzt. Du kannst nur einen davon je Regel verwenden",
                "selector multi 2b": 'nicht verbundene {{what}} in einer Regel benutzt. Das ist vermutlich ein Fehler. Gleiche Selektoren k\xf6nnen (und sollten) immer zusammen und durch Kommas getrennt geschrieben werden. Beispiel f\xfcr Zeitspannen "12:00-13:00,15:00-18:00". Beispiel f\xfcr Wochentage "Mo-We,Fr".',
                "selector state": "Status-Schl\xfcsselw\xf6rter (offen, geschlossen)",
                comments: "Kommentare",
                months: "Monate",
                weekdays: "Wochentage",
                ranges: "Zeitspannen",
                "default state": "Diese Regel, welche den Standard-Status (d.h. geschlossen) f\xfcr alle folgenden Regeln \xe4ndert, ist nicht die erste Regel. Diese Regel \xfcberschreibt alle vorherigen Regeln. Es kann legitim sein, den Standard-Status z.B. auf ge\xf6ffnet festzulegen und dann nur die Zeiten, zu denen geschlossen ist, anzugeben.",
                vague: 'Diese Regel ist nicht sehr aussagekr\xe4ftig, da kein Zeit Selektor angegeben wurde. Ein Zeit Selektor ist die Komponente die angibt, zu welcher Tageszeit ein Objekt ge\xf6ffnet hat, zum Beispiel "10:00-19:00". Bitte f\xfcge eine Zeitangabe oder einen Kommentar hinzu, um dies zu verbessern.',
                "empty comment": 'Du hast einen leeren Kommentar verwendet." Bitte schreibe entweder einen Kommentar-Text oder benutze stattdessen das Schl\xfcsselwort "unknown".',
                separator_for_readability: "Du hast das optionale Symbol <separator_for_readability> an der falschen Stelle benutzt. Bitte lies die Syntax-Spezifikation um zu sehen, wo es verwendet werden kann, oder entferne es.",
                "strange 24/7": 'Du hast 24/7 in einer Art verwendet, welche wahrscheinlich nicht als "24 Stunden, 7 Tage die Woche" interpretiert wird. Der Richtigkeit halber solltest du "open" oder "closed" f\xfcr diese Regel verwenden und dann die Ausnahmen angeben um das selbe Ziel zu erreichen. So ist es klarer \u2013 zum Beispiel "open; Mo 12:00-14:00 off".',
                "public holiday": 'Es wurde keine Regel f\xfcr "PH" (feiertags) angegeben. Dies ist nicht sehr aussagekr\xe4ftig.{{-part2}} Bitte f\xfcge die Regel "PH off" an, wenn die Einrichtung an allen Feiertagen geschlossen ist oder schreibe "Sa,Su,PH 12:00-16:00" um auszudr\xfccken, dass Samstags, Sonntags und feiertags von 12:00-16:00 ge\xf6ffnet ist. Bei einer \xd6ffnungszeit wie "Fr-Sa 18:00-06:00" ist Vorsicht geboten, da "PH off" auf 00:00-24:00 zutrifft. Hier kann "Fr-Sa 18:00-06:00; PH 18:00-06:00 off" verwendet werden. Falls die Einrichtung t\xe4glich und an Feiertagen ge\xf6ffnet ist, kann dies explizit mittels "Mo-Su,PH" ausgedr\xfcckt werden. Wenn du dir im Unklaren bist, versuche die \xd6ffnungszeit zu kl\xe4ren. Falls das nicht m\xf6glich ist, lass die Angabe weg und ignoriere diese Warnung.',
                "public holiday part2": ' Leider ist der "tag key" (beispielsweise "opening_hours", oder "lit") in opening_hours.js nicht bekannt. Diese Warnung betrifft nur die Keys: {{keys}}. Falls deine Angabe nicht f\xfcr einen dieser ist, ignoriere bitte folgenden Hinweis:',
                "additional_rule_separator not used after time wrapping midnight": 'Diese Regel \xfcberschreibt Teile der vorherigen Regel. Der Grund daf\xfcr ist, dass normale Regeln auf den ganzen Tag zutreffen und alle Definitionen von vorhergehenden Regeln f\xfcr diesen Tag \xfcberschreiben. Du kannst diese Regel als additive Regel deklarieren indem du ein "," anstelle des \xfcblichen ";" f\xfcr diese Regel verwendest. Beachte das die \xdcberschreibung auch gew\xfcnscht sein kann und in so einem Fall diese Warnung ignoriert werden kann.',
                "additional rule which evaluates to closed": "Diese Regel wird als geschlossen ausgewertet aber wurde als additive Regel angegeben. Sie sollte als normale Regel mittels \";\" definiert sein. Siehe https://wiki.openstreetmap.org/wiki/DE:Key:opening_hours/specification#explain:rule_modifier:closed.",
                switched: 'Der Selektor "{{first}}" wurde f\xfcr eine bessere Lesbarkeit und der Vollst\xe4ndigkeit halber mit "{{second}}" getauscht.',
                "no colon after": "Bitte Benutze kein \":\" nach dem Token {{token}}.",
                "number -5 to 5": "Zahl zwischen -5 und 5 (au\xdfer 0) erwartet.",
                "one weekday constraint": "Du kannst h\xf6chstens einen beschr\xe4nkten Wochentag in einer Monats-Spanne verwenden",
                "range constrained weekdays": "Du kannst keine Wochentags-Spanne als Beschr\xe4nkung in einer Monats-Spanne verwenden",
                expected: "\"{{-symbol}}\" erwartet.",
                "range zero": "Du kannst keine {{type}}-Spanne mit Periode \"0\" verwenden.",
                "period one year+": 'Bitte verwende keine {{type}}-Spannen mit Periode "1". Wenn du ausdr\xfccken willst, das eine Einrichtung ab einem bestimmten Jahr immer offen ist, benutze bitte "<year>+".',
                "period one": "Bitte verwende keine {{type}}-Spannen mit Periode \"1\".",
                "month 31": "Die Tagesangabe f\xfcr {{month}} muss zwischen 1 und 31 liegen.",
                "month 30": "Der Monat {{month}} hat keine 31 Tage. Der letzte Tag von {{month}} ist Tag 30.",
                "month feb": "\"Der Monat {{month}} hat entweder 28 oder 29 Tage (Schaltjahre).\"",
                "point in time": "Erwarte Bindestrich (-) oder offenes Ende (+) in der Zeitspanne {{calc}}. Um mit Zeitpunkten zu arbeiten, muss der Modus f\xfcr  {{libraryname}} umgestellt werden. Vielleicht falsches OSM-tag verwendet?",
                calculation: "Berechnung",
                "time range continue": "Die Zeitspanne geht nicht wie erwartet weiter",
                "period continue": "Die Zeitspannen-Periode geht nicht wie erwartet weiter. Beispiel \"/01:30\".",
                "time range mode": "{{libraryname}} wurde im \"Zeitspannen-Modus\" aufgerufen. Zeitpunkt gefunden.",
                "time ranges": "Zeitspannen",
                "holiday ranges": "Feiertagen",
                "point in time mode": "{{libraryname}} wurde im \"Zeitpunkt-Modus\" aufgerufen. Zeitspanne gefunden.",
                "outside current day": "Zeitspanne beginnt au\xdferhalb des aktuellen Tages",
                "two midnights": "Zeitspanne welche mehrmals Mitternacht beinhaltet wird nicht unterst\xfctzt",
                "without minutes": "Zeitspanne ohne Minutenangabe angegeben. Das ist nicht sehr eindeutig! Bitte verwende stattdessen folgende Syntax \"{{syntax}}\".",
                "outside day": "Die Zeitspanne beginnt au\xdferhalb des aktuellen Tages",
                "zero calculation": 'Das Hinzuf\xfcgen von 0 in einer variablen Zeitberechnung \xe4ndert die variable Zeit nicht. Bitte entferne die Zeitberechnung (Beispiel: "sunrise-(sunset-00:00)").',
                "calculation syntax": "Berechnung mit variabler Zeit hat nicht die korrekte Syntax",
                missing: "Fehlendes \"{{symbol}}\"",
                "(time)": "(Zeit)",
                "bad range": "Ung\xfcltige Zeitspanne: {{from}}-{{to}}",
                "] or more numbers": "\"]\" oder weitere Zahlen erwartet.",
                "additional rule no sense": 'Eine weitere Regel an dieser Stelle ergibt keinen Sinn. Benutze einfach ";" als Trenner f\xfcr Regeln. Siehe https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:additional_rule_separator',
                "unexpected token weekday range": "Unerwartes Token in Tages-Spanne: {{token}}",
                "max differ": "Es sollte keinen Grund geben, mehr als {{maxdiffer}} Tage von einem {{name}} abzuweichen. Wenn n\xf6tig, teile uns dies bitte mit \u2026",
                "adding 0": "Addition von 0 ver\xe4ndert das Datum nicht. Bitte weglassen.",
                "unexpected token holiday": "Unerwarteter Token (in Feiertags-Auswertung): {{token}}",
                "no holiday definition": "{{name}} ist f\xfcr das Land {{cc}} nicht definiert.",
                "no holiday definition state": "{{name}} ist f\xfcr das Land {{cc}} und Bundesland {{state}} nicht definiert.",
                "no country code": "Der L\xe4ndercode fehlt. Dieser wird ben\xf6tigt um die korrekten Feiertage zu bestimmen (siehe in der README wie dieser anzugeben ist)",
                "no SH definition": "Die Schulferien {{name}}sind f\xfcr das Jahr {{year}} nicht definiert",
                "movable no formula": "Der bewegliche Feiertag {{name}} kann nicht berechnet werden. Bitte f\xfcge eine entsprechende Formel hinzu.",
                "movable not in year": "Der bewegliche Feiertag {{name}} plus {{days}} Tage befindet sich nicht mehr im selben Jahr. Aktuell nicht unterst\xfctzt.",
                "year range one year": "Eine Jahres-Spanne mit gleichem Jahr als Beginn und Ende ergibt keinen Sinn. Bitte entferne das Ende-Jahr. zum Beispiel: \"{{year}} May 23\"",
                "year range reverse": "Eine Jahres-Spanne mit Beginn gr\xf6\xdfer als Ende ergibt keinen Sinn. Bitte umdrehen.",
                "year past": "Das Jahr liegt in der Vergangenheit.",
                "unexpected token year range": "Unerwartetes Token in der Jahres-Spanne: {{token}}",
                "week range reverse": "Du hast eine Wochen-Spanne in umgekehrter Reihenfolge oder mehrere Jahre umfassende angegeben. Dies ist aktuell nicht unterst\xfctzt.",
                "week negative": "Du hast eine Kalenderwoche kleiner 1 angegeben. Korrekte Angaben sind 1-53.",
                "week exceed": "Du hast eine Kalenderwoche gr\xf6\xdfer als 53 angegeben. Korrekte Angaben sind 1-53.",
                "week period less than 2": "Du hast eine Wochenperiode kleiner 2 angegeben. Wenn du die gesamte Spanne von {{weekfrom}} bis {{weekto}} angeben willst, lasse \"/{{period}}\" einfach weg.",
                "week period greater than 26": 'Du hast eine Wochen-Periode gr\xf6\xdfer als 26 angegeben. 26,5 ist die H\xe4lfte des Maximums von 53 Wochen pro Jahr. Damit w\xfcrde eine Periode gr\xf6\xdfer als 26 nur einmal pro Jahr auftreten. Bitte gibt den Wochen-Selektor als "week {{weekfrom}}" an, wenn es das ist, was du ausdr\xfccken m\xf6chtest.',
                "unexpected token week range": "Unerwartetes Token in Wochen-Spanne: {{token}}",
                "unexpected token month range": "Unerwartetes Token in Monats-Spanne: {{token}}",
                "day range reverse": "Zeitspanne in falscher Reihenfolge. Beginn ist gr\xf6\xdfer als Ende.",
                "open end": 'Angegeben als "open end". Schlie\xdfzeit wurde geraten.',
                "date parameter needed": "Datumsparameter n\xf6tig.",
                "assuming ok for ko": "\"{{ko}}\" wird als \"{{ok}}\" interpretiert.",
                "please use ok for ko": "Bitte verwende \"{{-ok}}\" anstelle von \"{{-ko}}\".",
                "please use ok for similar looking ko": "Please use notation \"{{ok}}\" for \"{{ko}}\". Those characters look very similar but are not the same!",
                "rant degree sign used for zero": "Beachte das dies ein Gradzeichen ist, welches als (hochgestellte) Null missbraucht wurde. Eine hochgestellte Null ist in Unicode definiert (\xb0) und w\xe4re angebrachter/einheitlicher an dieser Stelle. Allerdings ist die Verwendung von nicht ASCII Ziffern nicht erlaubt.",
                "please use English written ok for ko": 'Bitte benutze die englische Schreibweise "{{ok}}" f\xfcr "{{ko}}".',
                "please use English abbreviation ok for ko": 'Bitte benutze die englische Abk\xfcrzung "{{ok}}" f\xfcr "{{ko}}".',
                "please use English abbreviation ok for so": 'Bitte benutze die englische Abk\xfcrzung "{{ok}}" f\xfcr "{{ko}}". Beachte das Samstag in Polnisch gemeint sein kann.',
                "please use off for ko": 'Bitte benutze "{{ok}}" f\xfcr "{{ko}}". Beispiel: "Mo-Fr 08:00-12:00; Tu off".',
                "please use ok for workday": "\"{{ko}}\" wird als \"{{ok}}\" interpretiert. Werktag sollte nicht verwendet werden. Siehe https://wiki.openstreetmap.org/wiki/Talk:Key:opening_hours#need_syntax_for_holidays_and_workingdays",
                "omit hour keyword": "Bitte lasse \"{{ko}}\" weg oder verwende einen Doppelpunkt. Beispiel: \"12:00-14:00\".",
                "omit ko": "Bitte verzichte auf \"{{ko}}\".",
                "omit tag key": 'Bitte lasse "{{ko}}" weg. Der Tag Schl\xfcssel darf nicht im Tag Wert sein.',
                "omit wrong keyword open end": 'Bitte lasse "{{ko}}" weg. Falls du "open end" ausdr\xfccken m\xf6chtest verwende bitte ein "+". Beispiel: "12:00+".',
                "assuming open end for ko": "\"{{ko}}\" wird als \"{{ok}}\" (\"open end\") interpretiert. Example: \"12:00+\".",
                "please use ok for uncertainty": 'Bitte verwende "{{ok}}" f\xfcr "{{ko}}". Falls der begr\xfcndete Verdacht der Ungewissheit vorliegt ziehe die Verwendung eines Kommentars in Betracht. Beispiel: 12:00-14:00 "only on sunshine".',
                "please use fallback rule": 'Bitte verwende "{{ok}}" (Fallback Regel) f\xfcr "{{ko}}". Beispiel: Mo-Fr 12:00-14:00; PH off || "nach Vereinbarung"',
                "please use ok for missing data": "Bitte verwende eine FIXME Notiz.",
                "please use 24 hours time for ko": "Bitte verwende 24 Stunden Zeitangaben anstelle der veralteten 12 Stunden Variante. Falls die 12 Stunden Variante verwendet wird ist eventuelle eine Konvertierung notwendig.",
                "please use restriction comment time for ko": 'Es sieht so aus also m\xf6chtest du zus\xe4tzliche Einschr\xe4nkungen f\xfcr eine \xd6ffnungszeit geben. Falls sich dies nicht mit der Syntax ausdr\xfccken l\xe4sst k\xf6nnen Kommentare verwendet werden. Zus\xe4tzlich sollte eventuell das Schl\xfcsselwort `open` benutzt werden. Beispiel: open "Nur Frauen".',
                "please use ok for typographically correct": 'Bitte verwende "{{-ok}}" f\xfcr "{{ko}}". Auch wenn "{{ko}}" typografisch korrekt ist, ist dies in der opening_hours Syntax nicht definiert. Korrekte Typographie sollte auf Anwendungsebene sichergestellt werden \u2026'
            },
            pretty: {
                off: "geschlossen",
                SH: "Schulferien",
                PH: "Feiertags"
            }
        }
    },
    eo: {
        opening_hours: {
            texts: {
                "assuming ok for ko": "\"{{ko}}\" estas interpretita kiel \"{{ok}}\".",
                "please use ok for ko": 'Bonvolu uzi la esprimon "{{-ok}}" anstata\u016D "{{ko}}".',
                "please use English abbreviation ok for ko": 'Bonvolu uzi la anglan mallongigon "{{ok}}" f\xfcr "{{ko}}".'
            },
            pretty: {
                off: "fermita",
                SH: "lernejaj ferioj",
                PH: "festotagoj"
            }
        }
    },
    fi: {
        opening_hours: {
            pretty: {
                off: "suljettu",
                SH: "koululomat",
                PH: "lailliset vapaap\xe4iv\xe4t"
            }
        }
    },
    fr: {
        opening_hours: {
            texts: {
                "assuming ok for ko": "suppose \"{{ok}}\" pour \"{{ko}}\".",
                "please use ok for ko": 'S\'il vous pla\xeet utilisez "{{ok}}" pour "{{ko}}".',
                "please use English abbreviation ok for ko": 'S\'il vous pla\xeet utilise\xe9 l\'abr\xe9viation "{{ok}}" pour "{{ko}}".'
            },
            pretty: {
                off: "ferm\xe9",
                SH: "vacances scolaires",
                PH: "jours f\xe9ri\xe9s"
            }
        }
    },
    nl: {
        opening_hours: {
            texts: {
                "please use English abbreviation ok for ko": "Neem de engelse afkorting \"{{ok}}\" voor \"{{ko}}\" alstublieft."
            },
            pretty: {
                off: "gesloten",
                SH: "schoolvakantie",
                PH: "feestdagen"
            }
        }
    },
    ru: {
        opening_hours: {
            pretty: {
                off: "\u0437\u0430\u043A\u0440\u044B\u0442\u043E",
                SH: "\u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                PH: "\u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A"
            }
        }
    },
    it: {
        opening_hours: {
            pretty: {
                off: "chiuso",
                SH: "festivit\xe0 scolastiche",
                PH: "festivit\xe0"
            }
        }
    }
};
$0e3b0f6e50344df5$var$data.en;
$0e3b0f6e50344df5$var$data.de;
$0e3b0f6e50344df5$var$data.eo;
$0e3b0f6e50344df5$var$data.fi;
$0e3b0f6e50344df5$var$data.fr;
$0e3b0f6e50344df5$var$data.nl;
$0e3b0f6e50344df5$var$data.ru;
$0e3b0f6e50344df5$var$data.it;
if (!(0, $5abb203460cfd110$export$2e2bcd8739ae039).isInitialized) (0, $5abb203460cfd110$export$2e2bcd8739ae039).init({
    fallbackLng: 'en',
    // lngWhitelist: ['en', 'de'],
    resources: $0e3b0f6e50344df5$var$data,
    getAsync: true,
    useCookie: true
});
else // compat with an app that already initializes i18n
for(const lang in $0e3b0f6e50344df5$var$data)(0, $5abb203460cfd110$export$2e2bcd8739ae039).addResourceBundle(lang, 'opening_hours', $0e3b0f6e50344df5$var$data[lang]['opening_hours'], true);
/*
 * SPDX-FileCopyrightText: © 2013 Robin Schneider <ypid@riseup.net>
 *
 * SPDX-License-Identifier: LGPL-3.0-only
 *
 * This file is based on work under the following copyright and
 * BSD-2-Clause permission notice:
 *
 *     SPDX-FileCopyrightText: © 2012 Dmitry Marakasov <amdmi3@amdmi3.ru>
 *     All rights reserved.
 *
 *     Redistribution and use in source and binary forms, with or without
 *     modification, are permitted provided that the following conditions are met:
 *
 *     1. Redistributions of source code must retain the above copyright notice, this
 *     list of conditions and the following disclaimer.
 *
 *     2. Redistributions in binary form must reproduce the above copyright notice,
 *     this list of conditions and the following disclaimer in the documentation
 *     and/or other materials provided with the distribution.
 *
 *     THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 *     ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *     WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *     DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 *     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 *     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 *     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 *     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 *     OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 *     OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ function $0e3b0f6e50344df5$export$2e2bcd8739ae039(value, nominatim_object, optional_conf_parm) {
    // Short constants {{{
    const word_value_replacement = {
        dawn: 330,
        sunrise: 360,
        sunset: 1080,
        dusk: 1110
    };
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    const weekdays = [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ];
    const string_to_token_map = {
        'su': [
            0,
            'weekday'
        ],
        'mo': [
            1,
            'weekday'
        ],
        'tu': [
            2,
            'weekday'
        ],
        'we': [
            3,
            'weekday'
        ],
        'th': [
            4,
            'weekday'
        ],
        'fr': [
            5,
            'weekday'
        ],
        'sa': [
            6,
            'weekday'
        ],
        'jan': [
            0,
            'month'
        ],
        'feb': [
            1,
            'month'
        ],
        'mar': [
            2,
            'month'
        ],
        'apr': [
            3,
            'month'
        ],
        'may': [
            4,
            'month'
        ],
        'jun': [
            5,
            'month'
        ],
        'jul': [
            6,
            'month'
        ],
        'aug': [
            7,
            'month'
        ],
        'sep': [
            8,
            'month'
        ],
        'oct': [
            9,
            'month'
        ],
        'nov': [
            10,
            'month'
        ],
        'dec': [
            11,
            'month'
        ],
        'day': [
            'day',
            'calcday'
        ],
        'days': [
            'days',
            'calcday'
        ],
        'sunrise': [
            'sunrise',
            'timevar'
        ],
        'sunset': [
            'sunset',
            'timevar'
        ],
        'dawn': [
            'dawn',
            'timevar'
        ],
        'dusk': [
            'dusk',
            'timevar'
        ],
        'easter': [
            'easter',
            'event'
        ],
        'week': [
            'week',
            'week'
        ],
        'open': [
            'open',
            'state'
        ],
        'closed': [
            'closed',
            'state'
        ],
        'off': [
            'off',
            'state'
        ],
        'unknown': [
            'unknown',
            'state'
        ]
    };
    const default_prettify_conf = {
        // Update README.md if changed.
        'zero_pad_hour': true,
        'one_zero_if_hour_zero': false,
        'leave_off_closed': true,
        'keyword_for_off_closed': 'off',
        'rule_sep_string': ' ',
        'print_semicolon': true,
        'leave_weekday_sep_one_day_betw': true,
        'sep_one_day_between': ',',
        'zero_pad_month_and_week_numbers': true,
        'locale': 'en',
        'date_format': 'short' // Use short or long date format (for day and month names)
    };
    const osm_tag_defaults = {
        'opening_hours': {
            'mode': 0,
            'warn_for_PH_missing': true
        },
        'collection_times': {
            'mode': 2
        },
        /* oh_mode 2: "including the hyphen because there are post boxes which are
         * emptied several (undefined) times or one (undefined) time in a certain time
         * frame. This shall be covered also.".
         * Ref: https://wiki.openstreetmap.org/wiki/Key:collection_times */ 'opening_hours:.+': {
            'mode': 0
        },
        '.+:opening_hours': {
            'mode': 0
        },
        '.+:opening_hours:.+': {
            'mode': 0
        },
        'smoking_hours': {
            'mode': 0
        },
        'service_times': {
            'mode': 2
        },
        'happy_hours': {
            'mode': 0
        },
        'lit': {
            'mode': 0,
            map: {
                'yes': 'sunset-sunrise open "specified as yes: At night (unknown time schedule or daylight detection)"',
                'automatic': 'unknown "specified as automatic: When someone enters the way the lights are turned on."',
                'no': 'off "specified as no: There are no lights installed."',
                'interval': 'unknown "specified as interval"',
                'limited': 'unknown "specified as limited"'
            }
        }
    };
    const minutes_in_day = 1440;
    const msec_in_day = 60000 * minutes_in_day;
    // let msec_in_week   = msec_in_day * 7;
    const library_name = 'opening_hours.js';
    const repository_url = 'https://github.com/opening-hours/' + library_name;
    // let issues_url     = repository_url + '/issues?state=open';
    /* }}} */ /* Translation function {{{ */ /* Roughly compatibly to i18next so we can replace everything by i18next with
     * sprintf support.
     */ let locale = 'en'; // Default locale
    if (typeof (0, $5abb203460cfd110$export$2e2bcd8739ae039) === 'object') locale = (0, $5abb203460cfd110$export$2e2bcd8739ae039).language;
    const t = function(str, variables) {
        if (typeof (0, $5abb203460cfd110$export$2e2bcd8739ae039) === 'object' && typeof (0, $5abb203460cfd110$export$2e2bcd8739ae039).t === 'function' && typeof locale === 'string' && [
            'de'
        ].indexOf(locale) !== -1) {
            let translatorFunction;
            if ((0, $5abb203460cfd110$export$2e2bcd8739ae039).language !== locale) translatorFunction = (0, $5abb203460cfd110$export$2e2bcd8739ae039).getFixedT(locale);
            else translatorFunction = (0, $5abb203460cfd110$export$2e2bcd8739ae039).t;
            const text = translatorFunction('opening_hours:texts.' + str, variables);
            return text;
        }
        let text = $0e3b0f6e50344df5$var$data$1[str];
        if (typeof text === 'undefined') text = str;
        return text.replace(/{{([^{}]*)}}/g, function(match, c) {
            return typeof variables[c] !== 'undefined' ? variables[c] : match;
        });
    };
    /* }}} */ /* Optional constructor parameters {{{ */ /* nominatim_object {{{
     *
     * Required to reasonably calculate 'sunrise' and holidays.
     */ let location_cc, location_state, lat, lon;
    if (typeof nominatim_object === 'object' && nominatim_object !== null) {
        if (typeof nominatim_object.address === 'object') {
            if (typeof nominatim_object.address.country_code === 'string') location_cc = nominatim_object.address.country_code;
            if (typeof nominatim_object.address.state === 'string') location_state = nominatim_object.address.state;
            else if (typeof nominatim_object.address.county === 'string') location_state = nominatim_object.address.county;
        }
        if (typeof nominatim_object.lon === 'string' && typeof nominatim_object.lat === 'string') {
            lat = nominatim_object.lat;
            lon = nominatim_object.lon;
        }
    } else if (nominatim_object === null) {
        /* Set the location to some random value. This can be used if you don’t
         * care about correct opening hours for more complex opening_hours
         * values.
         */ location_cc = 'de';
        location_state = 'Baden-W\u00fcrttemberg';
        lat = '49.5400039';
        lon = '9.7937133';
    } else if (typeof nominatim_object !== 'undefined') throw "The nominatim_object parameter is of unknown type. Given " + typeof nominatim_object + ', expected object.';
    /* }}} */ /* mode, locale, warnings_severity, tag_key, map_value {{{
     *
     * 0: time ranges (default), tags: opening_hours, lit, …
     * 1: points in time
     * 2: both (time ranges and points in time), tags: collection_times, service_times
     */ let warnings_severity = 4;
    /* Default, currently the highest severity supported.
     * This number is expected to be >= 4. This is not explicitly checked.
     */ let oh_mode;
    let oh_map_value = false;
    let oh_key, oh_regex_key;
    if (typeof optional_conf_parm === 'number') oh_mode = optional_conf_parm;
    else if (typeof optional_conf_parm === 'object') {
        if (typeof optional_conf_parm['locale'] === 'string') /* TODO: The split thing is obviously a workaround. */ locale = optional_conf_parm['locale'].split('-')[0];
        if (checkOptionalConfParm('mode', 'number')) oh_mode = optional_conf_parm['mode'];
        if (checkOptionalConfParm('warnings_severity', 'number')) {
            warnings_severity = optional_conf_parm['warnings_severity'];
            if ([
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7
            ].indexOf(warnings_severity) === -1) throw t('warnings severity', {
                'severity': warnings_severity,
                'allowed': '[ 0, 1, 2, 3, 4, 5, 6, 7 ]'
            });
        }
        if (checkOptionalConfParm('tag_key', 'string')) oh_key = optional_conf_parm['tag_key'];
        if (checkOptionalConfParm('map_value', 'boolean')) oh_map_value = optional_conf_parm.map_value;
    } else if (typeof optional_conf_parm !== 'undefined') throw t('optional conf parm type', {
        'given': typeof optional_conf_parm
    });
    if (typeof oh_key === 'string') {
        oh_regex_key = getRegexKeyForKeyFromOsmDefaults(oh_key);
        if (oh_map_value && typeof osm_tag_defaults[oh_regex_key] === 'object' && typeof osm_tag_defaults[oh_regex_key]['map'] === 'object' && typeof osm_tag_defaults[oh_regex_key]['map'][value] === 'string') value = osm_tag_defaults[oh_regex_key]['map'][value];
    } else if (oh_map_value) throw t('conf param tag key missing');
    if (typeof oh_mode === 'undefined') {
        if (typeof oh_key === 'string' && osm_tag_defaults[oh_regex_key] !== undefined) {
            if (typeof osm_tag_defaults[oh_regex_key]['mode'] === 'number') oh_mode = osm_tag_defaults[oh_regex_key]['mode'];
            else oh_mode = 0;
        } else oh_mode = 0;
    } else if ([
        0,
        1,
        2
    ].indexOf(oh_mode) === -1) throw t('conf param mode invalid', {
        'given': oh_mode,
        'allowed': '[ 0, 1, 2 ]'
    });
    /* }}} */ /* }}} */ // Tokenize value and generate selector functions. {{{
    if (typeof value !== 'string') throw t('no string');
    if (/^(?:\s*;?)+$/.test(value)) throw t('nothing');
    const parsing_warnings = []; // Elements are fed into function formatWarnErrorMessage(nrule, at, message)
    let done_with_warnings = false; // The functions which returns warnings can be called multiple times.
    let done_with_selector_reordering = false;
    let done_with_selector_reordering_warnings = false;
    // eslint-disable-next-line no-var
    var tokens = tokenize(value); // TODO: Figure out why tests fail if this is const or let.
    // console.log(JSON.stringify(tokens, null, '    '));
    let prettified_value = '';
    let week_stable = true;
    let rule, nrule;
    const rules = [];
    const rule_infos = {};
    /* Not reliable because tokens !== new_tokens */ // for (var nrule = 0; nrule < tokens.length; nrule++) {
    //     rule_infos[nrule] = {};
    // }
    const new_tokens = [];
    for(nrule = 0; nrule < tokens.length; nrule++){
        if (tokens[nrule][0].length === 0) {
            // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.
            parsing_warnings.push([
                nrule,
                -1,
                t('nothing useful') + (nrule === tokens.length - 1 && nrule > 0 && !tokens[nrule][1] ? ' ' + t('programmers joke') : '')
            ]);
            continue;
        }
        let continue_at = 0;
        let next_rule_is_additional = false;
        do {
            if (continue_at === tokens[nrule][0].length) break;
            rule = {
                // Time selectors
                time: [],
                // Temporary array of selectors from time wrapped to the next day
                wraptime: [],
                // Date selectors
                weekday: [],
                holiday: [],
                week: [],
                month: [],
                monthday: [],
                year: [],
                // Array with non-empty date selector types, with most optimal ordering
                date: [],
                fallback: tokens[nrule][1],
                additional: continue_at ? true : false,
                meaning: true,
                unknown: false,
                comment: undefined,
                build_from_token_rule: undefined
            };
            rule.build_from_token_rule = [
                nrule,
                continue_at,
                new_tokens.length
            ];
            continue_at = parseGroup(tokens[nrule][0], continue_at, rule, nrule);
            if (typeof continue_at === 'object') continue_at = continue_at[0];
            else continue_at = 0;
            // console.log('Current tokens: ' + JSON.stringify(tokens[nrule], null, '    '));
            new_tokens.push([
                tokens[nrule][0].slice(rule.build_from_token_rule[1], continue_at === 0 ? tokens[nrule][0].length : continue_at),
                tokens[nrule][1],
                tokens[nrule][2]
            ]);
            if (next_rule_is_additional && new_tokens.length > 1) // Move 'rule separator' from last token of last rule to first token of this rule.
            new_tokens[new_tokens.length - 1][0].unshift(new_tokens[new_tokens.length - 2][0].pop());
            next_rule_is_additional = continue_at === 0 ? false : true;
            const optimal_selector_order = [
                'year',
                'holiday',
                'month',
                'monthday',
                'week',
                'weekday'
            ];
            optimal_selector_order.forEach(function(element) {
                if (rule[element].length > 0) {
                    rule.date.push(rule[element]);
                    rule[element] = [];
                }
            });
            // console.log('Rule: ' + JSON.stringify(rule, null, '    '));
            rules.push(rule);
            /* This handles selectors with time ranges wrapping over midnight (e.g. 10:00-02:00).
             * It generates wrappers for all selectors and creates a new rule.
             */ if (rule.wraptime.length > 0) {
                const wrapselectors = {
                    time: rule.wraptime,
                    date: [],
                    meaning: rule.meaning,
                    unknown: rule.unknown,
                    comment: rule.comment,
                    wrapped: true,
                    build_from_token_rule: rule.build_from_token_rule
                };
                for(let dselg = 0; dselg < rule.date.length; dselg++){
                    wrapselectors.date.push([]);
                    for(let dsel = 0; dsel < rule.date[dselg].length; dsel++)wrapselectors.date[wrapselectors.date.length - 1].push(generateDateShifter(rule.date[dselg][dsel], -msec_in_day));
                }
                rules.push(wrapselectors);
            }
        }while (continue_at);
    }
    // console.log(JSON.stringify(tokens, null, '    '));
    // console.log(JSON.stringify(new_tokens, null, '    '));
    /* }}} */ /* Helper functions {{{ */ /* Get regex string key from key osm_tag_defaults. {{{
     *
     * :param key: Tag key e.g. opening_hours:kitchen.
     * :returns: Regex key from osm_tag_defaults e.g. opening_hours:.*
     */ function getRegexKeyForKeyFromOsmDefaults(key) {
        let regex_key;
        let exact_match = false;
        Object.keys(osm_tag_defaults).forEach(function(osm_key) {
            if (exact_match === true) return;
            if (key === osm_key) {
                regex_key = osm_key;
                // We can't just return here as some old browsers
                // don't interpret it as a final return (like a loop break)
                exact_match = true;
            } else if (new RegExp(osm_key).test(key)) regex_key = osm_key;
        });
        return regex_key;
    }
    /* }}} */ /* Check given element in optional_conf_parm. {{{
     *
     * :param key: Key of optional_conf_parm.
     * :param expected_type: Expected `typeof()` the parameter.
     * :returns: True if the expected type matches the given type.
     */ function checkOptionalConfParm(key, expected_type) {
        if (typeof optional_conf_parm[key] === expected_type) return true;
        else if (typeof optional_conf_parm[key] !== 'undefined') throw t('conf param unknown type', {
            'key': key,
            'given': typeof optional_conf_parm[key],
            'expected': expected_type
        });
        return false;
    }
    /* }}} */ /* }}} */ /* Format warning or error message for the user. {{{
     *
     * :param nrule: Rule number starting with 0.
     * :param at: Token position at which the issue occurred.
     * :param message: Human readable string with the message.
     * :param tokens_to_use: List of token objects.
     * :returns: String with position of the warning or error marked for the user.
     */ function formatWarnErrorMessage(nrule, at, message, tokens_to_use) {
        if (typeof tokens_to_use === 'undefined') tokens_to_use = tokens;
        // console.log(`Called formatWarnErrorMessage: ${nrule}, ${at}, ${message}`);
        // FIXME: Change to new_tokens.
        if (typeof nrule === 'number') {
            let pos = 0;
            if (nrule === -1) pos = value.length - at;
            else if (typeof tokens_to_use[nrule][0][at] === 'undefined') {
                if (typeof tokens_to_use[nrule][0] !== 'undefined' && at === -1) {
                    pos = value.length;
                    if (typeof tokens_to_use[nrule + 1] === 'object' && typeof tokens_to_use[nrule + 1][2] === 'number') pos -= tokens_to_use[nrule + 1][2];
                    else if (typeof tokens_to_use[nrule][2] === 'number') pos -= tokens_to_use[nrule][2];
                } else {
                    // Given position is invalid.
                    //
                    formatLibraryBugMessage('Bug in warning generation code which could not determine the exact position of the warning or error in value.');
                    pos = value.length;
                    if (typeof tokens_to_use[nrule][2] === 'number') {
                        // Fallback: Point to last token in the rule which caused the problem.
                        // Run real_test regularly to fix the problem before a user is confronted with it.
                        pos -= tokens_to_use[nrule][2];
                        console.warn('Last token for rule: ' + JSON.stringify(tokens_to_use[nrule]));
                        console.log(value.substring(0, pos) + ' <--- (' + message + ')');
                        console.log('\n');
                    }
                    console.warn('tokens_to_use[nrule][2] is undefined. This is ok if nrule is the last rule.');
                }
            } else {
                pos = value.length;
                if (typeof tokens_to_use[nrule][0][at + 1] === 'object') pos -= tokens_to_use[nrule][0][at + 1][2];
                else if (typeof tokens_to_use[nrule][2] === 'number') pos -= tokens_to_use[nrule][2];
            }
            return value.substring(0, pos) + ' <--- (' + message + ')';
        } else if (typeof nrule === 'string') return nrule.substring(0, at) + ' <--- (' + message + ')';
    }
    /* }}} */ /* Format internal library error message. {{{
     *
     * :param message: Human readable string with the error message.
     * :param text_template: Message template defined in the `lang` variable to use for the error message. Defaults to 'library bug'.
     * :returns: Error message for the user.
     */ function formatLibraryBugMessage(message, text_template) {
        if (typeof message === 'undefined') message = '';
        else message = ' ' + message;
        if (typeof text_template !== 'string') text_template = 'library bug';
        message = t(text_template, {
            'value': value,
            'url': repository_url,
            'message': message
        });
        console.error(message);
        return message;
    } /* }}} */ 
    /* Tokenize input stream {{{
     *
     * :param value: Raw opening_hours value.
     * :returns: Tokenized list object. Complex structure. Check the
     *        internal documentation in the docs/ directory for details.
     */ function tokenize(value) {
        const all_tokens = [];
        let curr_rule_tokens = [];
        let last_rule_fallback_terminated = false;
        while(value !== ''){
            /* Ordered after likelihood of input for performance reasons.
             * Also, error tolerance is supposed to happen at the end.
             */ // console.log("Parsing value: " + value);
            let tmp = value.match(/^([a-z]{2,})\b((?:[.]| before| after)?)/i);
            let token_from_map = undefined;
            if (tmp && tmp[2] === '') token_from_map = string_to_token_map[tmp[1].toLowerCase()];
            if (typeof token_from_map === 'object') {
                curr_rule_tokens.push(token_from_map.concat([
                    value.length
                ]));
                value = value.substr(tmp[1].length);
            } else if (tmp = value.match(/^\s+/)) // whitespace is ignored
            value = value.substr(tmp[0].length);
            else if (tmp = value.match(/^24\/7/)) {
                // Reserved keyword.
                curr_rule_tokens.push([
                    tmp[0],
                    tmp[0],
                    value.length
                ]);
                value = value.substr(tmp[0].length);
            } else if (/^;/.test(value)) {
                // semicolon terminates rule.
                // Next token belong to a new rule.
                all_tokens.push([
                    curr_rule_tokens,
                    last_rule_fallback_terminated,
                    value.length
                ]);
                value = value.substr(1);
                curr_rule_tokens = [];
                last_rule_fallback_terminated = false;
            } else if (/^[:.]/.test(value)) {
                // Time separator (timesep).
                if (value[0] === '.' && !done_with_warnings) parsing_warnings.push([
                    -1,
                    value.length - 1,
                    t('hour min separator')
                ]);
                curr_rule_tokens.push([
                    ':',
                    'timesep',
                    value.length
                ]);
                value = value.substr(1);
            } else if (tmp = value.match(/^(?:PH|SH)/i)) {
                // special day name (holidays)
                curr_rule_tokens.push([
                    tmp[0].toUpperCase(),
                    'holiday',
                    value.length
                ]);
                value = value.substr(2);
            } else if (tmp = value.match(/^[°\u2070-\u209F\u00B2\u00B3\u00B9]{1,2}/)) {
                const unicode_code_point_to_digit = {
                    176: 0,
                    0x2070: 0,
                    185: 1,
                    178: 2,
                    179: 3
                };
                const regular_number = tmp[0].split('').map(function(ch) {
                    const code_point = ch.charCodeAt(0);
                    if (typeof unicode_code_point_to_digit[code_point] === 'number') return unicode_code_point_to_digit[code_point];
                    else if (0x2074 <= code_point && code_point <= 0x2079) return code_point - 0x2070;
                    else if (0x2080 <= code_point && code_point <= 0x2089) return code_point - 0x2080;
                }).join('');
                let ok = '';
                if (curr_rule_tokens.length > 0 && matchTokens(curr_rule_tokens, curr_rule_tokens.length - 1, 'number')) ok += ':';
                ok += regular_number;
                if (!done_with_warnings) {
                    for(let i = 0; i <= tmp[0].length; i++)if (value.charCodeAt(i) === 176) parsing_warnings.push([
                        -1,
                        value.length - (1 + i),
                        t('rant degree sign used for zero')
                    ]);
                    parsing_warnings.push([
                        -1,
                        value.length - tmp[0].length,
                        t('please use ok for ko', {
                            'ko': tmp[0],
                            'ok': ok
                        })
                    ]);
                }
                value = ok + value.substr(tmp[0].length);
            } else if (tmp = value.match(/^(&|_|→|–|−|—|ー|=|·|öffnungszeit(?:en)?:?|opening_hours\s*=|\?|~|～|：|always (?:open|closed)|24x7|24 hours 7 days a week|24 hours|7 ?days(?:(?: a |\/)week)?|7j?\/7|all days?|every day|(?:bis|till?|-|–)? ?(?:open ?end|late)|(?:(?:one )?day (?:before|after) )?(?:school|public) holidays?|days?\b|до|рм|ам|jours fériés|on work days?|sonntags?|(?:nur |an )?sonn-?(?:(?: und |\/)feiertag(?:s|en?)?)?|(?:an )?feiertag(?:s|en?)?|(?:nach|on|by) (?:appointments?|vereinbarung|absprache)|p\.m\.|a\.m\.|[_a-zäößàáéøčěíúýřПнВсо]+\b|à|á|mo|tu|we|th|fr|sa|su|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)(\.?)/i)) {
                /* Handle all remaining words and specific other characters with error tolerance.
                 *
                 * à|á: Word boundary does not work with Unicode chars: 'test à test'.match(/\bà\b/i)
                 * https://stackoverflow.com/questions/10590098/javascript-regexp-word-boundaries-unicode-characters
                 * Order in the regular expression capturing group is important in some cases.
                 *
                 * mo|tu|we|th|fr|sa|su|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec: Prefer defended keywords
                 * if used in cases like 'mo12:00-14:00' (when keyword is followed by number).
                 */ let correct_val = returnCorrectWordOrToken(tmp[1].toLowerCase(), value.length);
                // console.log('Error tolerance for string "' + tmp[1] + '" returned "' + correct_val + '".');
                if (typeof correct_val === 'object') {
                    curr_rule_tokens.push([
                        correct_val[0],
                        correct_val[1],
                        value.length
                    ]);
                    value = value.substr(tmp[0].length);
                } else if (typeof correct_val === 'string') {
                    if (correct_val === 'am' || correct_val === 'pm') {
                        let hours_token_at = curr_rule_tokens.length - 1;
                        let hours_token;
                        if (hours_token_at >= 0) {
                            if (hours_token_at - 2 >= 0 && matchTokens(curr_rule_tokens, hours_token_at - 2, 'number', 'timesep', 'number')) {
                                hours_token_at -= 2;
                                hours_token = curr_rule_tokens[hours_token_at];
                            } else if (matchTokens(curr_rule_tokens, hours_token_at, 'number')) hours_token = curr_rule_tokens[hours_token_at];
                            if (typeof hours_token === 'object') {
                                if (correct_val === 'pm' && hours_token[0] < 12) hours_token[0] += 12;
                                if (correct_val === 'am' && hours_token[0] === 12) hours_token[0] = 0;
                                curr_rule_tokens[hours_token_at] = hours_token;
                            }
                        }
                        correct_val = '';
                    }
                    const correct_tokens = tokenize(correct_val)[0];
                    if (correct_tokens[1] === true) throw formatLibraryBugMessage();
                    for(let i = 0; i < correct_tokens[0].length; i++)curr_rule_tokens.push([
                        correct_tokens[0][i][0],
                        correct_tokens[0][i][1],
                        value.length
                    ]);
                    value = value.substr(tmp[0].length);
                // value = correct_val + value.substr(tmp[0].length);
                // Does not work because it would generate the wrong length for formatWarnErrorMessage.
                } else {
                    // No correction available. Insert as single character token and let the parser handle the error.
                    curr_rule_tokens.push([
                        value[0].toLowerCase(),
                        value[0].toLowerCase(),
                        value.length - 1
                    ]);
                    value = value.substr(1);
                }
                if (typeof tmp[2] === 'string' && tmp[2] !== '' && !done_with_warnings) parsing_warnings.push([
                    -1,
                    value.length,
                    t('omit ko', {
                        'ko': tmp[2]
                    })
                ]);
            } else if (tmp = value.match(/^(\d+)(?:([.])([^\d]))?/)) {
                // number
                if (Number(tmp[1]) > 1900) {
                    curr_rule_tokens.push([
                        Number(tmp[1]),
                        'year',
                        value.length
                    ]);
                    if (Number(tmp[1]) >= 2100) parsing_warnings.push([
                        -1,
                        value.length - 1,
                        t('interpreted as year', {
                            number: Number(tmp[1])
                        })
                    ]);
                } else curr_rule_tokens.push([
                    Number(tmp[1]),
                    'number',
                    value.length
                ]);
                value = value.substr(tmp[1].length + (typeof tmp[2] === 'string' ? tmp[2].length : 0));
                if (typeof tmp[2] === 'string' && tmp[2] !== '' && !done_with_warnings) parsing_warnings.push([
                    -1,
                    value.length,
                    t('omit ko', {
                        'ko': tmp[2]
                    })
                ]);
            } else if (/^\|\|/.test(value)) {
                // || terminates rule.
                // Next token belong to a fallback rule.
                if (curr_rule_tokens.length === 0) throw formatWarnErrorMessage(-1, value.length - 2, t('rule before fallback empty'));
                all_tokens.push([
                    curr_rule_tokens,
                    last_rule_fallback_terminated,
                    value.length
                ]);
                curr_rule_tokens = [];
                // curr_rule_tokens = [ [ '||', 'rule separator', value.length  ] ];
                // FIXME: Use this. Unknown bug needs to be solved in the process.
                value = value.substr(2);
                last_rule_fallback_terminated = true;
            } else if (tmp = value.match(/^"([^"]+)"/)) {
                // Comment following the specification.
                // Any character is allowed inside the comment except " itself.
                curr_rule_tokens.push([
                    tmp[1],
                    'comment',
                    value.length
                ]);
                value = value.substr(tmp[0].length);
            } else if (tmp = value.match(/^(["'„“‚‘’«「『])([^"'“”‘’»」』;|]*)(["'”“‘’»」』])/)) {
                // Comments with error tolerance.
                // The comments still have to be somewhat correct meaning
                // the start and end quote signs used have to be
                // appropriate. So “testing„ will not match as it is not a
                // quote but rather something unknown which the user should
                // fix first.
                // console.log('Matched: ' + JSON.stringify(tmp));
                for(let pos = 1; pos <= 3; pos += 2){
                    // console.log('Pos: ' + pos + ', substring: ' + tmp[pos]);
                    const correct_val = returnCorrectWordOrToken(tmp[pos], value.length - (pos === 3 ? tmp[1].length + tmp[2].length : 0));
                    if (typeof correct_val !== 'string' && tmp[pos] !== '"') throw formatLibraryBugMessage("A character for error tolerance was allowed in the regular expression but is not covered by word_error_correction which is needed to format a proper message for the user.");
                }
                curr_rule_tokens.push([
                    tmp[2],
                    'comment',
                    value.length
                ]);
                value = value.substr(tmp[0].length);
            } else if (/^(?:␣|\s)/.test(value)) // Using "␣" as space is not expected to be a normal
            // mistake. Just ignore it to make using taginfo easier.
            value = value.substr(1);
            else {
                // other single-character tokens
                curr_rule_tokens.push([
                    value[0].toLowerCase(),
                    value[0].toLowerCase(),
                    value.length
                ]);
                value = value.substr(1);
            }
        }
        all_tokens.push([
            curr_rule_tokens,
            last_rule_fallback_terminated
        ]);
        return all_tokens;
    }
    /* }}} */ /* error correction/tolerance function {{{
     * Go through word_error_correction hash and get correct value back.
     *
     * :param word: Wrong word or character.
     * :param value_length: Current value_length (used for warnings).
     * :returns:
     *        * (valid) opening_hours sub string.
     *        * object with [ internal_value, token_name ] if value is correct.
     *        * undefined if word could not be found (and thus is not corrected).
     */ function returnCorrectWordOrToken(word, value_length) {
        let correctWordOrToken;
        const token_from_map = string_to_token_map[word];
        if (typeof token_from_map === 'object') return token_from_map;
        Object.keys($0e3b0f6e50344df5$var$data$2).forEach(function(comment) {
            if (correctWordOrToken) return;
            Object.keys($0e3b0f6e50344df5$var$data$2[comment]).forEach(function(old_val) {
                if (correctWordOrToken) return;
                if (new RegExp('^' + old_val + '$').test(word)) {
                    const val = $0e3b0f6e50344df5$var$data$2[comment][old_val];
                    // Replace wrong words or characters with correct ones.
                    // This will return a string which is then being tokenized.
                    if (!done_with_warnings) parsing_warnings.push([
                        -1,
                        value_length - word.length,
                        t(comment, {
                            'ko': word,
                            'ok': val
                        })
                    ]);
                    correctWordOrToken = val;
                }
            });
        });
        return correctWordOrToken;
    }
    /* }}} */ /* return warnings as list {{{
     *
     * :param it: Iterator object if available (optional).
     * :returns: Warnings as list with one warning per element.
     */ function getWarnings(it) {
        if (warnings_severity < 4) return [];
        if (!done_with_warnings && typeof it === 'object') {
            /* getWarnings was called in a state without critical errors.
             * We can do extended tests.
             */ /* Place all tests in this function if an additional (high
             * level) test is added and this does not require to rewrite
             * big parts of (sub) selector parsers only to get the
             * position. If that is the case, then rather place the test
             * code in the (sub) selector parser function directly.
             */ const wide_range_selector_order = [
                'year',
                'month',
                'week',
                'holiday'
            ];
            const small_range_selector_order = [
                'weekday',
                'time',
                '24/7',
                'state',
                'comment'
            ];
            // How many times was a selector_type used per rule? {{{
            const used_selectors = [];
            const used_selectors_types_array = [];
            const has_token = {};
            for(let nrule = 0; nrule < new_tokens.length; nrule++){
                if (new_tokens[nrule][0].length === 0) continue;
                // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.
                let selector_start_end_type = [
                    0,
                    0,
                    undefined
                ];
                // console.log(new_tokens[nrule][0]);
                used_selectors[nrule] = {};
                used_selectors_types_array[nrule] = [];
                do {
                    selector_start_end_type = getSelectorRange(new_tokens[nrule][0], selector_start_end_type[1]);
                    // console.log(selector_start_end_type, new_tokens[nrule][0].length);
                    for(let token_pos = 0; token_pos <= selector_start_end_type[1]; token_pos++)if (typeof new_tokens[nrule][0][token_pos] === 'object' && new_tokens[nrule][0][token_pos][0] === 'PH') has_token['PH'] = true;
                    if (selector_start_end_type[0] === selector_start_end_type[1] && new_tokens[nrule][0][selector_start_end_type[0]][0] === '24/7') has_token['24/7'] = true;
                    if (typeof used_selectors[nrule][selector_start_end_type[2]] !== 'object') used_selectors[nrule][selector_start_end_type[2]] = [
                        selector_start_end_type[1]
                    ];
                    else used_selectors[nrule][selector_start_end_type[2]].push(selector_start_end_type[1]);
                    used_selectors_types_array[nrule].push(selector_start_end_type[2]);
                    selector_start_end_type[1]++;
                }while (selector_start_end_type[1] < new_tokens[nrule][0].length);
            }
            // console.log('used_selectors: ' + JSON.stringify(used_selectors, null, '    '));
            // console.log('used_selectors_types_array: ' + JSON.stringify(used_selectors_types_array, null, '    '));
            /* }}} */ for(let nrule = 0; nrule < used_selectors.length; nrule++){
                /* Check if more than one not connected selector of the same type is used in one rule {{{ */ Object.keys(used_selectors[nrule]).forEach(function(selector_type) {
                    // console.log(selector_type + ' use at: ' + used_selectors[nrule][selector_type].length);
                    if (used_selectors[nrule][selector_type].length > 1) {
                        parsing_warnings.push([
                            nrule,
                            used_selectors[nrule][selector_type][used_selectors[nrule][selector_type].length - 1],
                            t('use multi', {
                                'count': used_selectors[nrule][selector_type].length,
                                'part2': /^(?:comment|state)/.test(selector_type) ? t('selector multi 2a', {
                                    'what': selector_type === 'state' ? t('selector state') : t('comments')
                                }) : t('selector multi 2b', {
                                    'what': t(selector_type + (/^(?:month|weekday)$/.test(selector_type) ? 's' : ' ranges'))
                                })
                            })
                        ]);
                        done_with_selector_reordering = true; // Correcting the selector order makes no sense if this kind of issue exists.
                    }
                });
                /* }}} */ /* Check if change default state rule is not the first rule {{{ */ if (typeof used_selectors[nrule].state === 'object' && Object.keys(used_selectors[nrule]).length === 1) {
                    if (nrule !== 0) parsing_warnings.push([
                        nrule,
                        new_tokens[nrule][0].length - 1,
                        t('default state')
                    ]);
                } else if (typeof used_selectors[nrule].time === 'undefined') {
                    if (typeof used_selectors[nrule].state === 'object' && new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'open' && typeof used_selectors[nrule].comment === 'undefined' || typeof used_selectors[nrule].comment === 'undefined' && typeof used_selectors[nrule].state === 'undefined' && typeof used_selectors[nrule]['24/7'] === 'undefined') parsing_warnings.push([
                        nrule,
                        new_tokens[nrule][0].length - 1,
                        t('vague')
                    ]);
                }
                /* }}} */ /* Check if empty comment was given {{{ */ if (typeof used_selectors[nrule].comment === 'object' && new_tokens[nrule][0][used_selectors[nrule].comment[0]][0].length === 0) parsing_warnings.push([
                    nrule,
                    used_selectors[nrule].comment[0],
                    t('empty comment')
                ]);
                /* }}} */ /* Check for valid use of <separator_for_readability> {{{ */ for(let i = 0; i < used_selectors_types_array[nrule].length - 1; i++){
                    const selector_type = used_selectors_types_array[nrule][i];
                    const next_selector_type = used_selectors_types_array[nrule][i + 1];
                    if (wide_range_selector_order.indexOf(selector_type) !== -1 && wide_range_selector_order.indexOf(next_selector_type) !== -1 || small_range_selector_order.indexOf(selector_type) !== -1 && small_range_selector_order.indexOf(next_selector_type) !== -1) {
                        if (new_tokens[nrule][0][used_selectors[nrule][selector_type][0]][0] === ':') parsing_warnings.push([
                            nrule,
                            used_selectors[nrule][selector_type][0],
                            t('separator_for_readability')
                        ]);
                    }
                }
                /* }}} */ /* Check for missing use of <additional_rule_separator> for time wrapping midnight {{{ */ if (typeof rule_infos[nrule] === 'object' && typeof rule_infos[nrule]['time_wraps_over_midnight'] === 'boolean' && rule_infos[nrule]['time_wraps_over_midnight'] === true && typeof used_selectors[nrule + 1] === 'object' && typeof used_selectors[nrule + 1]['rule separator'] === 'undefined' // Not an additional rule
                 && new_tokens[nrule + 1][1] === false // Not a fallback rule
                ) {
                    const rules_too_complex = [
                        nrule,
                        nrule + 1
                    ].map(function(nrule) {
                        for(let i = 0; i < wide_range_selector_order.length - 1; i++){
                            if (typeof used_selectors[nrule][wide_range_selector_order[i]] === 'object') return true;
                        }
                        return false;
                    });
                    const rules_too_complex_count = rules_too_complex.filter(function(el) {
                        return el;
                    }).length;
                    let next_rule_selects_next_day = false;
                    if (typeof rule_infos[nrule] === 'object' && typeof rule_infos[nrule] === 'object' && typeof rule_infos[nrule]['week_days'] === 'object' && typeof rule_infos[nrule + 1] === 'object' && typeof rule_infos[nrule + 1]['week_days'] === 'object') for(let i = 0; i < rule_infos[nrule]['week_days'].length; i++){
                        const week_day = rule_infos[nrule]['week_days'][i];
                        // console.log(rule_infos[nrule+1]['week_days']);
                        // console.log(week_day);
                        if (rule_infos[nrule + 1]['week_days'].indexOf(week_day === 6 ? 0 : week_day + 1) !== -1) {
                            next_rule_selects_next_day = true;
                            break;
                        }
                    }
                    else next_rule_selects_next_day = true;
                    // console.log(rule_infos);
                    // console.log(next_rule_selects_next_day);
                    const additional_rule_separator_enabled = (optional_conf_parm || {}).additional_rule_separator !== false;
                    if (rules_too_complex_count < 2 && next_rule_selects_next_day && additional_rule_separator_enabled) parsing_warnings.push([
                        nrule + 1,
                        new_tokens[nrule + 1][0].length - 1,
                        t('additional_rule_separator not used after time wrapping midnight'),
                        new_tokens
                    ]);
                }
                /* }}} */ /* Check if rule with closed|off modifier is additional {{{ */ if (typeof new_tokens[nrule][0][0] === 'object' && new_tokens[nrule][0][0][0] === ',' && new_tokens[nrule][0][0][1] === 'rule separator' && typeof used_selectors[nrule].state === 'object' && (new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'closed' || new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'off')) parsing_warnings.push([
                    nrule,
                    new_tokens[nrule][0].length - 1,
                    t('additional rule which evaluates to closed'),
                    new_tokens
                ]);
            /* }}} */ }
            /* Check if 24/7 is used and it does not mean 24/7 because there are other rules {{{ */ const has_advanced = it.advance();
            if (has_advanced === true && has_token['24/7'] && !done_with_warnings) parsing_warnings.push([
                -1,
                0,
                // Probably because of: "24/7; 12:00-14:00 open", ". Needs extra testing.
                t('strange 24/7')
            ]);
            /* }}} */ /* Check for missing PH. {{{ */ if (warnings_severity >= 5 && !has_token['PH'] && !has_token['24/7'] && !done_with_warnings && (typeof oh_key === 'string' && osm_tag_defaults[oh_regex_key]['warn_for_PH_missing'] || typeof oh_key !== 'string')) {
                const keys_with_warn_for_PH_missing = [];
                Object.keys(osm_tag_defaults).forEach(function(key) {
                    if (osm_tag_defaults[key]['warn_for_PH_missing']) keys_with_warn_for_PH_missing.push(key);
                });
                parsing_warnings.push([
                    -1,
                    0,
                    t('public holiday', {
                        'part2': typeof oh_key !== 'string' ? t('public holiday part2', {
                            'keys': keys_with_warn_for_PH_missing.join(', ')
                        }) : ''
                    })
                ]);
            }
            /* }}} */ /* Check if value consists of multiple rules each only using a time selector {{{ */ if (used_selectors_types_array.length > 1 && used_selectors_types_array.filter(function(el) {
                return el.length === 1 && el[0] === 'time';
            }).length === used_selectors_types_array.length) parsing_warnings.push([
                -1,
                0,
                t('combine rules', {
                    'ok': ','
                })
            ]);
            /* }}} */ prettifyValue();
        }
        done_with_warnings = true;
        const warnings = [];
        // FIXME: Sort based on parsing_warnings[1], tricky …
        for(let i = 0; i < parsing_warnings.length; i++)warnings.push(formatWarnErrorMessage(parsing_warnings[i][0], parsing_warnings[i][1], parsing_warnings[i][2], parsing_warnings[i][3]));
        return warnings;
    }
    /* Helpers for getWarnings {{{ */ /* Check if token is the begin of a selector and why. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns:
     *        * false if the current token is not the begin of a selector.
     *        * Position in token array from where the decision was made that
     *          the token is the start of a selector.
     */ function tokenIsTheBeginOfSelector(tokens, at) {
        if (typeof tokens[at][3] === 'string') return 3;
        else if (tokens[at][1] === 'comment' || tokens[at][1] === 'state' || tokens[at][1] === '24/7' || tokens[at][1] === 'rule separator') return 1;
        else return false;
    }
    /* }}} */ /* Get start and end position of a selector. {{{
     * For example this value 'Mo-We,Fr' will return the position of the
     * token lexeme 'Mo' and 'Fr' e.g. there indexes [ 0, 4 ] in the
     * selector array of tokens.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Array:
     *            0. Index of first token in selector array of tokens.
     *            1. Index of last token in selector array of tokens.
     *            2. Selector type.
     */ function getSelectorRange(tokens, at) {
        let selector_start = at, selector_end, pos_in_token_array;
        for(; selector_start >= 0; selector_start--){
            pos_in_token_array = tokenIsTheBeginOfSelector(tokens, selector_start);
            if (pos_in_token_array) break;
        }
        selector_end = selector_start;
        if (pos_in_token_array === 1) {
            // Selector consists of a single token.
            // Include tailing colon.
            if (selector_end + 1 < tokens.length && tokens[selector_end + 1][0] === ':') selector_end++;
            return [
                selector_start,
                selector_end,
                tokens[selector_start][pos_in_token_array]
            ];
        }
        for(selector_end++; selector_end < tokens.length; selector_end++){
            if (tokenIsTheBeginOfSelector(tokens, selector_end)) return [
                selector_start,
                selector_end - 1,
                tokens[selector_start][pos_in_token_array]
            ];
        }
        return [
            selector_start,
            selector_end - 1,
            tokens[selector_start][pos_in_token_array]
        ];
    }
    /* }}} */ /* }}} */ /* }}} */ /* Prettify raw value from user. {{{
     * The value is generated by putting the tokens back together to a string.
     *
     * :param argument_hash: Hash which can contain:
     *        'conf': Configuration hash.
     *        'get_internals: If true export internal data structures.
     *        'rule_index: Only prettify the rule with this index.
     * :returns: Prettified value string or object if get_internals is true.
     */ function prettifyValue(argument_hash) {
        let user_conf = {};
        let get_internals = false;
        let rule_index;
        prettified_value = '';
        const prettified_value_array = [];
        if (typeof argument_hash === 'object') {
            if (typeof argument_hash.conf === 'object') user_conf = argument_hash.conf;
            if (typeof argument_hash.rule_index === 'number') rule_index = argument_hash.rule_index;
            if (argument_hash.get_internals === true) get_internals = true;
        }
        Object.keys(default_prettify_conf).forEach(function(key) {
            if (typeof user_conf[key] === 'undefined') user_conf[key] = default_prettify_conf[key];
        });
        // use months, weekdays for locales 'en' and 'all'
        // otherwise use Date.toLocaleString, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
        const _is_en_or_all = (user_conf['locale'] === 'en' || user_conf['locale'] === 'all') && user_conf['date_format'] === 'short';
        const months_local = _is_en_or_all ? months : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ].map(function(month) {
            return new Date(2018, month - 1, 1).toLocaleString(user_conf['locale'], {
                month: user_conf['date_format']
            });
        });
        const weekdays_local = _is_en_or_all ? weekdays : [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].map(function(weekday) {
            // 2017-01-01 is Sunday
            return new Date(2017, 0, weekday).toLocaleString(user_conf['locale'], {
                weekday: user_conf['date_format']
            });
        });
        for(let nrule = 0; nrule < new_tokens.length; nrule++){
            if (new_tokens[nrule][0].length === 0) continue;
            // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.
            if (typeof rule_index === 'number') {
                if (rule_index !== nrule) continue;
            } else if (nrule !== 0) prettified_value += new_tokens[nrule][1] ? user_conf.rule_sep_string + '|| ' : (new_tokens[nrule][0][0][1] === 'rule separator' ? ',' : user_conf.print_semicolon ? ';' : '') + user_conf.rule_sep_string;
            let selector_start_end_type = [
                0,
                0,
                undefined
            ];
            const prettified_group_value = [];
            let count = 0;
            // console.log(new_tokens[nrule][0]);
            do {
                selector_start_end_type = getSelectorRange(new_tokens[nrule][0], selector_start_end_type[1]);
                // console.log(selector_start_end_type, new_tokens[nrule][0].length, count);
                if (count > 50) throw formatLibraryBugMessage('Infinite loop.');
                if (selector_start_end_type[2] !== 'rule separator') prettified_group_value.push([
                    selector_start_end_type,
                    prettifySelector(new_tokens[nrule][0], selector_start_end_type[0], selector_start_end_type[1], selector_start_end_type[2], user_conf)
                ]);
                selector_start_end_type[1]++;
                count++;
            // console.log(selector_start_end_type, new_tokens[nrule][0].length, count);
            }while (selector_start_end_type[1] < new_tokens[nrule][0].length);
            // console.log('Prettified value: ' + JSON.stringify(prettified_group_value, null, '    '));
            const not_sorted_prettified_group_value = prettified_group_value.slice();
            if (!done_with_selector_reordering) prettified_group_value.sort(function(a, b) {
                const selector_order = [
                    'year',
                    'month',
                    'week',
                    'holiday',
                    'weekday',
                    'time',
                    '24/7',
                    'state',
                    'comment'
                ];
                return selector_order.indexOf(a[0][2]) - selector_order.indexOf(b[0][2]);
            });
            const old_prettified_value_length = prettified_value.length;
            if (typeof user_conf['locale'] === 'string' && user_conf['locale'] !== 'en') {
                let translatorFunction;
                if ((0, $5abb203460cfd110$export$2e2bcd8739ae039).language !== user_conf['locale']) translatorFunction = (0, $5abb203460cfd110$export$2e2bcd8739ae039).getFixedT(user_conf['locale']);
                else translatorFunction = (0, $5abb203460cfd110$export$2e2bcd8739ae039).t;
                for(let i = 0; i < prettified_group_value.length; i++){
                    const type = prettified_group_value[i][0][2];
                    if (type === 'weekday') weekdays.forEach(function(weekday, key) {
                        prettified_group_value[i][1] = prettified_group_value[i][1].replace(new RegExp(weekday, 'g'), weekdays_local[key]);
                    });
                    else if (type === 'month') months.forEach(function(month, key) {
                        prettified_group_value[i][1] = prettified_group_value[i][1].replace(new RegExp(month, 'g'), months_local[key]);
                    });
                    else {
                        const prettifiedValueIsProbablyTranslatable = prettified_group_value[i][1].indexOf(':') === -1;
                        if (prettifiedValueIsProbablyTranslatable) prettified_group_value[i][1] = translatorFunction([
                            'opening_hours:pretty.' + prettified_group_value[i][1],
                            prettified_group_value[i][1]
                        ]);
                    }
                }
            }
            prettified_value += prettified_group_value.map(function(array) {
                return array[1];
            }).join(' ');
            prettified_value_array.push(prettified_group_value);
            if (!done_with_selector_reordering_warnings) {
                for(let i = 0, l = not_sorted_prettified_group_value.length; i < l; i++)if (not_sorted_prettified_group_value[i] !== prettified_group_value[i]) {
                    // console.log(i + ': ' + prettified_group_value[i][0][2]);
                    let length = i + old_prettified_value_length; // i: Number of spaces in string.
                    for(let x = 0; x <= i; x++)length += prettified_group_value[x][1].length;
                    // console.log(length);
                    parsing_warnings.push([
                        prettified_value,
                        length,
                        t('switched', {
                            'first': prettified_group_value[i][0][2],
                            'second': not_sorted_prettified_group_value[i][0][2]
                        })
                    ]);
                }
            }
        }
        done_with_selector_reordering_warnings = true;
        // console.log(JSON.stringify(prettified_value_array, null, '    '));
        if (get_internals) return [
            prettified_value_array,
            new_tokens
        ];
        else return prettified_value;
    }
    /* }}} */ /* Check selector array of tokens for specific token name pattern. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position at which the matching should begin.
     * :param token_name(s): One or many token_name strings which have to match in that order.
     * :returns: true if token_name(s) match in order false otherwise.
     */ function matchTokens(tokens, at /*, matches... */ ) {
        if (at + arguments.length - 2 > tokens.length) return false;
        for(let i = 0; i < arguments.length - 2; i++){
            if (tokens[at + i][1] !== arguments[i + 2]) return false;
        }
        return true;
    }
    /* }}} */ /* Generate selector wrapper with time offset {{{
     *
     * :param func: Generated selector code function.
     * :param shirt: Time to shift in milliseconds.
     * :param token_name(s): One or many token_name strings which have to match in that order.
     * :returns: See selector code.
     */ function generateDateShifter(func, shift) {
        return function(date) {
            const res = func(new Date(date.getTime() + shift));
            if (typeof res[1] === 'undefined') return res;
            return [
                res[0],
                new Date(res[1].getTime() - shift)
            ];
        };
    }
    /* }}} */ /* Top-level parser {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param nrule: Rule number starting with 0.
     * :returns: See selector code.
     */ function parseGroup(tokens, at, rule, nrule) {
        let rule_modifier_specified = false;
        // console.log(tokens); // useful for debugging of tokenize
        let last_selector = [];
        while(at < tokens.length){
            // console.log('Parsing at position', at +':', tokens[at]);
            if (matchTokens(tokens, at, 'weekday')) at = parseWeekdayRange(tokens, at, rule, undefined, nrule);
            else if (matchTokens(tokens, at, '24/7')) {
                rule.time.push(function() {
                    return [
                        true
                    ];
                });
                // Not needed. If there is no selector it automatically matches everything.
                // WRONG: This only works if there is no other selector in this selector group ...
                at++;
            } else if (matchTokens(tokens, at, 'holiday')) {
                if (matchTokens(tokens, at + 1, ',')) at = parseHoliday(tokens, at, rule, true);
                else at = parseHoliday(tokens, at, rule, false);
                week_stable = false;
            } else if (matchTokens(tokens, at, 'month', 'number') || matchTokens(tokens, at, 'month', 'weekday') || matchTokens(tokens, at, 'year', 'month', 'number') || matchTokens(tokens, at, 'year', 'event') || matchTokens(tokens, at, 'event')) {
                at = parseMonthdayRange(tokens, at, nrule);
                week_stable = false;
            } else if (matchTokens(tokens, at, 'year')) {
                at = parseYearRange(tokens, at);
                week_stable = false;
            } else if (matchTokens(tokens, at, 'month')) at = parseMonthRange(tokens, at);
            else if (matchTokens(tokens, at, 'week')) {
                tokens[at][3] = 'week';
                at = parseWeekRange(tokens, at);
            } else if (at !== 0 && at !== tokens.length - 1 && tokens[at][0] === ':' && !(typeof last_selector[1] === 'string' && last_selector[1] === 'time')) {
                /* Ignore colon if they appear somewhere else than as time separator.
                 * Except the start or end of the value.
                 * This provides compatibility with the syntax proposed by Netzwolf:
                 * https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#separator_for_readability
                 * Check for valid use of <separator_for_readability> is implemented in function getWarnings().
                 */ if (!done_with_warnings && matchTokens(tokens, at - 1, 'holiday')) parsing_warnings.push([
                    nrule,
                    at,
                    t('no colon after', {
                        'token': tokens[at - 1][1]
                    })
                ]);
                at++;
            } else if (matchTokens(tokens, at, 'number', 'timesep') || matchTokens(tokens, at, 'timevar') || matchTokens(tokens, at, '(', 'timevar') || matchTokens(tokens, at, 'number', '-')) {
                at = parseTimeRange(tokens, at, rule, false, nrule);
                last_selector = [
                    at,
                    'time'
                ];
            } else if (matchTokens(tokens, at, 'state')) {
                if (tokens[at][0] === 'open') rule.meaning = true;
                else if (tokens[at][0] === 'closed' || tokens[at][0] === 'off') rule.meaning = false;
                else {
                    rule.meaning = false;
                    rule.unknown = true;
                }
                rule_modifier_specified = true;
                at++;
                if (typeof tokens[at] === 'object' && tokens[at][0] === ',') at = [
                    at + 1
                ];
            } else if (matchTokens(tokens, at, 'comment')) {
                rule.comment = tokens[at][0];
                if (!rule_modifier_specified) {
                    // Then it is unknown. Either with unknown explicitly
                    // specified or just a comment.
                    rule.meaning = false;
                    rule.unknown = true;
                }
                rule_modifier_specified = true;
                at++;
                if (typeof tokens[at] === 'object' && tokens[at][0] === ',') at = [
                    at + 1
                ];
            } else if ((at === 0 || at === tokens.length - 1) && matchTokens(tokens, at, 'rule separator')) at++;
            else {
                const warnings = getWarnings();
                throw formatWarnErrorMessage(nrule, at, t('unexpected token', {
                    token: tokens[at][1]
                })) + (warnings ? ' ' + warnings.join('; ') : '');
            }
            if (typeof at === 'object') {
                tokens[at[0] - 1][1] = 'rule separator';
                break;
            }
            if (typeof last_selector[0] === 'number' && last_selector[0] !== at) last_selector = [];
        }
        return at;
    }
    /* Not used
    function get_last_token_pos_in_token_group(tokens, at, last_at) {
        for (at++; at < last_at; at++) {
            if (typeof tokens[at] === 'object') {
                if (typeof tokens[at][3] === 'string'
                        || tokens[at][1] === 'comment'
                        || tokens[at][1] === 'state'){

                        return at - 1;
                }
            }
        }
        return last_at;
    }
    */ /* }}} */ // helper functions for sub parser {{{
    /* For given date, returns date moved to the start of the day with an offset specified in minutes. {{{
     * For example, if date is 2014-05-19_18:17:12, dateAtDayMinutes would
     * return 2014-05-19_02:00:00 for minutes=120.
     *
     * :param date: Date object.
     * :param minutes: Minutes used as offset starting from midnight of current day.
     * :returns: Moved date object.
     */ function dateAtDayMinutes(date, minutes) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, minutes);
    }
    /* }}} */ /* For given date, returns date moved to the specific day of week {{{
     *
     * :param date: Date object.
     * :param weekday: Integer number for day of week. Starting with zero (Sunday).
     * :returns: Moved date object.
     */ function dateAtNextWeekday(date, weekday) {
        const delta = weekday - date.getDay();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + delta + (delta < 0 ? 7 : 0));
    }
    /* }}} */ /* Numeric list parser (1,2,3-4,-1) {{{
     * Used in weekday parser above.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param func: Function func(from, to, at).
     * :returns: Position at which the token does not belong to the list any more.
     */ function parseNumRange(tokens, at, func) {
        for(; at < tokens.length; at++){
            if (matchTokens(tokens, at, 'number', '-', 'number')) {
                // Number range
                func(tokens[at][0], tokens[at + 2][0], at);
                at += 3;
            } else if (matchTokens(tokens, at, '-', 'number')) {
                // Negative number
                func(-tokens[at + 1][0], -tokens[at + 1][0], at);
                at += 2;
            } else if (matchTokens(tokens, at, 'number')) {
                // Single number
                func(tokens[at][0], tokens[at][0], at);
                at++;
            } else throw formatWarnErrorMessage(nrule, at + matchTokens(tokens, at, '-'), 'Unexpected token in number range: ' + tokens[at][1]);
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    /* }}} */ /* List parser for constrained weekdays in month range {{{
     * e.g. Su[-1] which selects the last Sunday of the month.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Array:
     *            0. Constrained weekday number.
     *            1. Position at which the token does not belong to the list any more (after ']' token).
     */ function getConstrainedWeekday(tokens, at) {
        let number = 0;
        const endat = parseNumRange(tokens, at, function(from, to, at) {
            // bad number
            if (from === 0 || from < -5 || from > 5) throw formatWarnErrorMessage(nrule, at, t('number -5 to 5'));
            if (from === to) {
                if (number !== 0) throw formatWarnErrorMessage(nrule, at, t('one weekday constraint'));
                number = from;
            } else throw formatWarnErrorMessage(nrule, at + 2, t('range constrained weekdays'));
        });
        for(let i = at; i < endat; i++)tokens[i][4] = 'positive_number';
        if (!matchTokens(tokens, endat, ']')) throw formatWarnErrorMessage(nrule, endat, t('expected', {
            symbol: ']'
        }));
        return [
            number,
            endat + 1
        ];
    }
    /* }}} */ // Check if period is ok. Period 0 or 1 don’t make much sense.
    function checkPeriod(at, period, period_type, parm_string) {
        if (done_with_warnings) return;
        if (period === 0) throw formatWarnErrorMessage(nrule, at, t('range zero', {
            'type': period_type
        }));
        else if (period === 1) {
            if (typeof parm_string === 'string' && parm_string === 'no_end_year') parsing_warnings.push([
                nrule,
                at,
                t('period one year+', {
                    'type': period_type
                })
            ]);
            else parsing_warnings.push([
                nrule,
                at,
                t('period one', {
                    'type': period_type
                })
            ]);
        }
    }
    /* Get date moved to constrained weekday (and moved for add_days. {{{
     * E.g. used for 'Aug Su[-1] -1 day'.
     *
     * :param year: Year as integer.
     * :param month: Month as integer starting with zero.
     * :param weekday: Integer number for day of week. Starting with zero (Sunday).
     * :param constrained_weekday: Position where to start.
     * :returns: Date object.
     */ function getDateForConstrainedWeekday(year, month, weekday, constrained_weekday, add_days) {
        const tmp_date = dateAtNextWeekday(new Date(year, month + (constrained_weekday[0] > 0 ? 0 : 1), 1), weekday);
        tmp_date.setDate(tmp_date.getDate() + (constrained_weekday[0] + (constrained_weekday[0] > 0 ? -1 : 0)) * 7);
        if (typeof add_days === 'object' && add_days[1]) tmp_date.setDate(tmp_date.getDate() + add_days[0]);
        return tmp_date;
    }
    /* }}} */ /* Check if date is valid. {{{
     *
     * :param month: Month as integer starting with zero.
     * :param date: Day of month as integer.
     * :param nrule: Rule number starting with 0.
     * :param at: Position at which the matching should begin.
     * :returns: undefined. There is no real return value. This function just throws an exception if something is wrong.
     */ function checkIfDateIsValid(month, day, nrule, at) {
        // May use this instead. The problem is that this does not give feedback as precise as the code which is used in this function.
        // let testDate = new Date(year, month, day);
        // if (testDate.getDate() !== day || testDate.getMonth() !== month || testDate.getFullYear() !== year) {
        //     console.error('date not valid');
        // }
        // https://en.wikipedia.org/wiki/Month#Julian_and_Gregorian_calendars
        if (day < 1 || day > 31) throw formatWarnErrorMessage(nrule, at, t('month 31', {
            'month': months[month]
        }));
        else if ((month === 3 || month === 5 || month === 8 || month === 10) && day === 31) throw formatWarnErrorMessage(nrule, at, t('month 30', {
            'month': months[month]
        }));
        else if (month === 1 && day === 30) throw formatWarnErrorMessage(nrule, at, t('month feb', {
            'month': months[month]
        }));
    }
    /* }}} */ /* }}} */ /* Time range parser (10:00-12:00,14:00-16:00) {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param extended_open_end: Used for combined time range with open end.
     * :param nrule: Rule number starting with 0.
     * extended_open_end: <time> - <time> +
     *        parameter at is here A (if extended_open_end is true)
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseTimeRange(tokens, at, rule, extended_open_end, nrule) {
        if (!extended_open_end) tokens[at][3] = 'time';
        for(; at < tokens.length; at++){
            const has_time_var_calc = [], has_normal_time = []; // element 0: start time, 1: end time
            has_normal_time[0] = matchTokens(tokens, at, 'number', 'timesep', 'number');
            has_time_var_calc[0] = matchTokens(tokens, at, '(', 'timevar');
            let minutes_from, minutes_to, has_open_end = false; // default no open end
            if (has_normal_time[0] || matchTokens(tokens, at, 'timevar') || has_time_var_calc[0]) {
                // relying on the fact that always *one* of them is true
                let is_point_in_time = false; // default no time range
                const timevar_add = [
                    0,
                    0
                ];
                let timevar_string = []; // capture timevar string like 'sunrise' to calculate it for the current date.
                let point_in_time_period;
                // minutes_from
                if (has_normal_time[0]) minutes_from = getMinutesByHoursMinutes(tokens, nrule, at + has_time_var_calc[0]);
                else {
                    timevar_string[0] = tokens[at + has_time_var_calc[0]][0];
                    minutes_from = word_value_replacement[timevar_string[0]];
                    if (has_time_var_calc[0]) {
                        timevar_add[0] = parseTimevarCalc(tokens, at);
                        minutes_from += timevar_add[0];
                    }
                }
                const at_end_time = at + (has_normal_time[0] ? 3 : has_time_var_calc[0] ? 7 : 1) + 1; // after '-'
                if (!matchTokens(tokens, at_end_time - 1, '-')) {
                    if (matchTokens(tokens, at_end_time - 1, '+')) has_open_end = true;
                    else {
                        if (oh_mode === 0) throw formatWarnErrorMessage(nrule, at + (has_normal_time[0] ? typeof tokens[at + 3] === 'object' ? 3 : 2 : has_time_var_calc[0] ? 2 : typeof tokens[at + 1] === 'object' ? 1 : 0), t('point in time', {
                            'calc': has_time_var_calc[0] ? t('calculation') + ' ' : '',
                            'libraryname': library_name
                        }));
                        else {
                            minutes_to = minutes_from + 1;
                            is_point_in_time = true;
                        }
                    }
                }
                // minutes_to
                if (has_open_end) {
                    if (extended_open_end === 1) minutes_from += minutes_in_day;
                    if (minutes_from >= 1320) minutes_to = minutes_from + 480;
                    else if (minutes_from >= 1020) minutes_to = minutes_from + 600;
                    else minutes_to = minutes_in_day;
                } else if (!is_point_in_time) {
                    has_normal_time[1] = matchTokens(tokens, at_end_time, 'number', 'timesep', 'number');
                    has_time_var_calc[1] = matchTokens(tokens, at_end_time, '(', 'timevar');
                    if (!has_normal_time[1] && !matchTokens(tokens, at_end_time, 'timevar') && !has_time_var_calc[1]) throw formatWarnErrorMessage(nrule, at_end_time - (typeof tokens[at_end_time] === 'object' ? 0 : 1), t('time range continue'));
                    else {
                        if (has_normal_time[1]) minutes_to = getMinutesByHoursMinutes(tokens, nrule, at_end_time);
                        else {
                            timevar_string[1] = tokens[at_end_time + has_time_var_calc[1]][0];
                            minutes_to = word_value_replacement[timevar_string[1]];
                        }
                        if (has_time_var_calc[1]) {
                            timevar_add[1] = parseTimevarCalc(tokens, at_end_time);
                            minutes_to += timevar_add[1];
                        }
                    }
                }
                at = at_end_time + (is_point_in_time ? -1 : has_normal_time[1] ? 3 : has_time_var_calc[1] ? 7 : !has_open_end);
                if (matchTokens(tokens, at, '/', 'number')) {
                    if (matchTokens(tokens, at + 2, 'timesep', 'number')) {
                        point_in_time_period = getMinutesByHoursMinutes(tokens, nrule, at + 1);
                        at += 4;
                    } else {
                        point_in_time_period = tokens[at + 1][0];
                        at += 2;
                        if (matchTokens(tokens, at, 'timesep')) throw formatWarnErrorMessage(nrule, at, t('period continue'));
                    }
                    // Check at this later state in the if condition to get the correct position.
                    if (oh_mode === 0) throw formatWarnErrorMessage(nrule, at - 1, t('time range mode', {
                        'libraryname': library_name
                    }));
                    is_point_in_time = true;
                } else if (matchTokens(tokens, at, '+')) {
                    parseTimeRange(tokens, at_end_time, rule, minutes_to < minutes_from ? 1 : true, nrule);
                    at++;
                } else if (oh_mode === 1 && !is_point_in_time) throw formatWarnErrorMessage(nrule, at_end_time, t('point in time mode', {
                    'libraryname': library_name
                }));
                if (typeof lat === 'string') {
                    if (!has_normal_time[0] || !(has_normal_time[1] || has_open_end || is_point_in_time)) week_stable = false;
                } else timevar_string = [];
                // Normalize minutes into range.
                if (!extended_open_end && minutes_from >= minutes_in_day) throw formatWarnErrorMessage(nrule, at_end_time - 2, t('outside current day'));
                if (minutes_to < minutes_from || has_normal_time[0] && has_normal_time[1] && minutes_from === minutes_to) minutes_to += minutes_in_day;
                if (minutes_to > minutes_in_day * 2) throw formatWarnErrorMessage(nrule, at_end_time + (has_normal_time[1] ? 4 : has_time_var_calc[1] ? 7 : 1) - 2, t('two midnights'));
                // This shortcut makes always-open range check faster.
                if (minutes_from === 0 && minutes_to === minutes_in_day) rule.time.push(function() {
                    return [
                        true
                    ];
                });
                else if (minutes_to > minutes_in_day) {
                    rule.time.push(function(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period, extended_open_end) {
                        return function(date) {
                            const ourminutes = date.getHours() * 60 + date.getMinutes();
                            if (timevar_string[0]) {
                                const date_from = (0, (/*@__PURE__*/$parcel$interopDefault($c638b168c37c7886$exports))).getTimes(date, lat, lon)[timevar_string[0]];
                                minutes_from = date_from.getHours() * 60 + date_from.getMinutes() + timevar_add[0];
                            }
                            if (timevar_string[1]) {
                                const date_to = (0, (/*@__PURE__*/$parcel$interopDefault($c638b168c37c7886$exports))).getTimes(date, lat, lon)[timevar_string[1]];
                                minutes_to = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                                minutes_to += minutes_in_day;
                            // Needs to be added because it was added by
                            // normal times: if (minutes_to < minutes_from)
                            // above the selector construction.
                            } else if (is_point_in_time && typeof point_in_time_period !== 'number') minutes_to = minutes_from + 1;
                            if (typeof point_in_time_period === 'number') {
                                if (ourminutes < minutes_from) return [
                                    false,
                                    dateAtDayMinutes(date, minutes_from)
                                ];
                                else if (ourminutes <= minutes_to) for(let cur_min = minutes_from; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period){
                                    if (cur_min === ourminutes) return [
                                        true,
                                        dateAtDayMinutes(date, ourminutes + 1)
                                    ];
                                    else if (ourminutes < cur_min) return [
                                        false,
                                        dateAtDayMinutes(date, cur_min)
                                    ];
                                }
                                return [
                                    false,
                                    dateAtDayMinutes(date, minutes_in_day)
                                ];
                            } else {
                                if (ourminutes < minutes_from) return [
                                    false,
                                    dateAtDayMinutes(date, minutes_from)
                                ];
                                else return [
                                    true,
                                    dateAtDayMinutes(date, minutes_to),
                                    has_open_end,
                                    extended_open_end
                                ];
                            }
                        };
                    }(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period, extended_open_end));
                    if (minutes_to - minutes_in_day > 0) {
                        if (typeof rule_infos[nrule] === 'undefined') rule_infos[nrule] = {};
                        rule_infos[nrule]['time_wraps_over_midnight'] = true;
                        rule.wraptime.push(function(minutes_to, timevar_string, timevar_add, has_open_end, point_in_time_period, extended_open_end) {
                            return function(date) {
                                const ourminutes = date.getHours() * 60 + date.getMinutes();
                                if (timevar_string[1]) {
                                    const date_to = (0, (/*@__PURE__*/$parcel$interopDefault($c638b168c37c7886$exports))).getTimes(date, lat, lon)[timevar_string[1]];
                                    minutes_to = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                                // minutes_in_day does not need to be added.
                                // For normal times in it was added in: if (minutes_to < // minutes_from)
                                // above the selector construction and
                                // subtracted in the selector construction call
                                // which returns the selector function.
                                }
                                if (typeof point_in_time_period === 'number') {
                                    if (ourminutes <= minutes_to) for(let cur_min = 0; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period){
                                        if (cur_min === ourminutes) return [
                                            true,
                                            dateAtDayMinutes(date, ourminutes + 1)
                                        ];
                                        else if (ourminutes < cur_min) return [
                                            false,
                                            dateAtDayMinutes(date, cur_min)
                                        ];
                                    }
                                } else {
                                    if (ourminutes < minutes_to) return [
                                        true,
                                        dateAtDayMinutes(date, minutes_to),
                                        has_open_end,
                                        extended_open_end
                                    ];
                                }
                                return [
                                    false,
                                    undefined
                                ];
                            };
                        }(minutes_to - minutes_in_day, timevar_string, timevar_add, has_open_end, point_in_time_period, extended_open_end));
                    }
                } else rule.time.push(function(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period) {
                    return function(date) {
                        const ourminutes = date.getHours() * 60 + date.getMinutes();
                        if (timevar_string[0]) {
                            const date_from = (0, (/*@__PURE__*/$parcel$interopDefault($c638b168c37c7886$exports))).getTimes(date, lat, lon)[timevar_string[0]];
                            minutes_from = date_from.getHours() * 60 + date_from.getMinutes() + timevar_add[0];
                        }
                        if (timevar_string[1]) {
                            const date_to = (0, (/*@__PURE__*/$parcel$interopDefault($c638b168c37c7886$exports))).getTimes(date, lat, lon)[timevar_string[1]];
                            minutes_to = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                        } else if (is_point_in_time && typeof point_in_time_period !== 'number') minutes_to = minutes_from + 1;
                        if (typeof point_in_time_period === 'number') {
                            if (ourminutes < minutes_from) return [
                                false,
                                dateAtDayMinutes(date, minutes_from)
                            ];
                            else if (ourminutes <= minutes_to) for(let cur_min = minutes_from; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period){
                                if (cur_min === ourminutes) return [
                                    true,
                                    dateAtDayMinutes(date, ourminutes + 1)
                                ];
                                else if (ourminutes < cur_min) return [
                                    false,
                                    dateAtDayMinutes(date, cur_min)
                                ];
                            }
                            return [
                                false,
                                dateAtDayMinutes(date, minutes_in_day)
                            ];
                        } else {
                            if (ourminutes < minutes_from) return [
                                false,
                                dateAtDayMinutes(date, minutes_from)
                            ];
                            else if (ourminutes < minutes_to) return [
                                true,
                                dateAtDayMinutes(date, minutes_to),
                                has_open_end
                            ];
                            else return [
                                false,
                                dateAtDayMinutes(date, minutes_from + minutes_in_day)
                            ];
                        }
                    };
                }(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period));
            } else if (matchTokens(tokens, at, 'number', '-', 'number')) {
                minutes_from = tokens[at][0] * 60;
                minutes_to = tokens[at + 2][0] * 60;
                if (!done_with_warnings) parsing_warnings.push([
                    nrule,
                    at + 2,
                    t('without minutes', {
                        'syntax': (tokens[at][0] < 10 ? '0' : '') + tokens[at][0] + ':00-' + (tokens[at + 2][0] < 10 ? '0' : '') + tokens[at + 2][0] + ':00'
                    })
                ]);
                if (minutes_from >= minutes_in_day) throw formatWarnErrorMessage(nrule, at, t('outside day'));
                if (minutes_to < minutes_from) minutes_to += minutes_in_day;
                if (minutes_to > minutes_in_day * 2) throw formatWarnErrorMessage(nrule, at + 2, t('two midnights'));
                if (minutes_to > minutes_in_day) {
                    rule.time.push(function(minutes_from, minutes_to) {
                        return function(date) {
                            const ourminutes = date.getHours() * 60 + date.getMinutes();
                            if (ourminutes < minutes_from) return [
                                false,
                                dateAtDayMinutes(date, minutes_from)
                            ];
                            else return [
                                true,
                                dateAtDayMinutes(date, minutes_to)
                            ];
                        };
                    }(minutes_from, minutes_to));
                    if (minutes_to - minutes_in_day > 0) {
                        if (typeof rule_infos[nrule] === 'undefined') rule_infos[nrule] = {};
                        rule_infos[nrule]['time_wraps_over_midnight'] = true;
                        rule.wraptime.push(function(minutes_to) {
                            return function(date) {
                                const ourminutes = date.getHours() * 60 + date.getMinutes();
                                if (ourminutes < minutes_to) return [
                                    true,
                                    dateAtDayMinutes(date, minutes_to)
                                ];
                                else return [
                                    false,
                                    undefined
                                ];
                            };
                        }(minutes_to - minutes_in_day));
                    }
                } else rule.time.push(function(minutes_from, minutes_to) {
                    return function(date) {
                        const ourminutes = date.getHours() * 60 + date.getMinutes();
                        if (ourminutes < minutes_from) return [
                            false,
                            dateAtDayMinutes(date, minutes_from)
                        ];
                        else if (ourminutes < minutes_to) return [
                            true,
                            dateAtDayMinutes(date, minutes_to),
                            has_open_end
                        ];
                        else return [
                            false,
                            dateAtDayMinutes(date, minutes_from + minutes_in_day)
                        ];
                    };
                }(minutes_from, minutes_to));
                at += 3;
            } else {
                if (matchTokens(tokens, at, '(')) throw formatWarnErrorMessage(nrule, at, 'Missing variable time (e.g. sunrise) after: "' + tokens[at][1] + '"');
                if (matchTokens(tokens, at, 'number', 'timesep')) throw formatWarnErrorMessage(nrule, at + 1, 'Missing minutes in time range after: "' + tokens[at + 1][1] + '"');
                if (matchTokens(tokens, at, 'number')) throw formatWarnErrorMessage(nrule, at + (typeof tokens[at + 1] === 'object' ? 1 : 0), 'Missing time separator in time range after: "' + tokens[at][1] + '"');
                return [
                    at
                ];
            }
            if (!matchTokens(tokens, at, ',')) break;
            if (typeof tokens[at + 1] === 'undefined' && !done_with_warnings) parsing_warnings.push([
                nrule,
                at,
                t('value ends with token', {
                    'token': tokens[at][1]
                })
            ]);
        }
        return at;
    }
    /* }}} */ /* Helpers for time range parser {{{ */ /* Get time in minutes from <hour>:<minute> (tokens). {{{
     * Only used if throwing an error is wanted.
     *
     * :param tokens: List of token objects.
     * :param nrule: Rule number starting with 0.
     * :param at: Position at which the time begins.
     * :returns: Time in minutes.
     */ function getMinutesByHoursMinutes(tokens, nrule, at) {
        if (tokens[at + 2][0] > 59) throw formatWarnErrorMessage(nrule, at + 2, 'Minutes are greater than 59.');
        return tokens[at][0] * 60 + tokens[at + 2][0];
    }
    /* }}} */ /* Get time in minutes from "(sunrise-01:30)" {{{
     * Extract the added or subtracted time from "(sunrise-01:30)"
     * returns time in minutes e.g. -90.
     *
     * :param tokens: List of token objects.
     * :param at: Position where the specification for the point in time could be.
     * :returns: Time in minutes on suggest, throws an exception otherwise.
    */ function parseTimevarCalc(tokens, at) {
        let error;
        if (matchTokens(tokens, at + 2, '+') || matchTokens(tokens, at + 2, '-')) {
            if (matchTokens(tokens, at + 3, 'number', 'timesep', 'number')) {
                if (matchTokens(tokens, at + 6, ')')) {
                    const add_or_subtract = tokens[at + 2][0] === '+' ? '1' : '-1';
                    const minutes = getMinutesByHoursMinutes(tokens, nrule, at + 3) * add_or_subtract;
                    if (minutes === 0) parsing_warnings.push([
                        nrule,
                        at + 5,
                        t('zero calculation')
                    ]);
                    return minutes;
                } else error = [
                    at + 6,
                    '. ' + t('missing', {
                        'symbol': ')'
                    }) + '.'
                ];
            } else error = [
                at + 5,
                ' ' + t('(time)') + '.'
            ];
        } else error = [
            at + 2,
            '. ' + t('expected', {
                'symbol': '+" or "-'
            })
        ];
        if (error) throw formatWarnErrorMessage(nrule, error[0], t('calculation syntax') + error[1]);
    }
    /* }}} */ /* }}} */ /* Weekday range parser (Mo,We-Fr,Sa[1-2,-1],PH). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where the weekday tokens could be.
     * :param rule: Reference to rule object.
     * :param nrule: Rule number starting with 0.
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseWeekdayRange(tokens, at, rule, in_holiday_selector, nrule) {
        if (!in_holiday_selector) {
            in_holiday_selector = true;
            tokens[at][3] = 'weekday';
        }
        for(; at < tokens.length; at++){
            if (matchTokens(tokens, at, 'weekday', '[')) {
                // Conditional weekday (Mo[3])
                const numbers = [];
                // Get list of constraints
                const endat = parseNumRange(tokens, at + 2, function(from, to, at) {
                    // bad number
                    if (from === 0 || from < -5 || from > 5) throw formatWarnErrorMessage(nrule, at, t('number -5 to 5'));
                    if (from === to) numbers.push(from);
                    else if (from < to) for(let i = from; i <= to; i++){
                        // bad number
                        if (i === 0 || i < -5 || i > 5) throw formatWarnErrorMessage(nrule, at + 2, t('number -5 to 5'));
                        numbers.push(i);
                    }
                    else throw formatWarnErrorMessage(nrule, at + 2, t('bad range', {
                        'from': from,
                        'to': to
                    }));
                });
                if (!matchTokens(tokens, endat, ']')) throw formatWarnErrorMessage(nrule, endat + (typeof tokens[endat] === 'object' ? 0 : -1), t('] or more numbers'));
                const add_days = getMoveDays(tokens, endat + 1, 6, 'constrained weekdays');
                week_stable = false;
                // Create selector for each list element.
                for(let nnumber = 0; nnumber < numbers.length; nnumber++)rule.weekday.push(function(weekday, number, add_days) {
                    return function(date) {
                        const date_num = getValueForDate(date, false); // Year not needed to distinguish.
                        const start_of_this_month = new Date(date.getFullYear(), date.getMonth(), 1);
                        const start_of_next_month = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                        const target_day_this_month = getDateForConstrainedWeekday(date.getFullYear(), date.getMonth(), weekday, [
                            number
                        ]);
                        let target_day_with_added_days_this_month = new Date(target_day_this_month.getFullYear(), target_day_this_month.getMonth(), target_day_this_month.getDate() + add_days);
                        // The target day with added days can be before this month
                        if (target_day_with_added_days_this_month.getTime() < start_of_this_month.getTime()) {
                            // but in this case, the target day without the days added needs to be in this month
                            if (target_day_this_month.getTime() >= start_of_this_month.getTime()) {
                                // so we calculate it for the month
                                // following this month and hope that the
                                // target day will actually be this month.
                                target_day_with_added_days_this_month = dateAtNextWeekday(new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) + 1, 1), weekday);
                                target_day_this_month.setDate(target_day_with_added_days_this_month.getDate() + (number + (number > 0 ? -1 : 0)) * 7 + add_days);
                            } else // Calculated target day is not inside this month
                            // therefore the specified weekday (e.g. fifth Sunday)
                            // does not exist this month. Try it next month.
                            return [
                                false,
                                start_of_next_month
                            ];
                        } else if (target_day_with_added_days_this_month.getTime() >= start_of_next_month.getTime()) {
                            // The target day is in the next month. If the target day without the added days is not in this month
                            if (target_day_this_month.getTime() >= start_of_next_month.getTime()) return [
                                false,
                                start_of_next_month
                            ];
                        }
                        let target_day_with_added_moved_days_this_month;
                        if (add_days > 0) {
                            target_day_with_added_moved_days_this_month = dateAtNextWeekday(new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) - 1, 1), weekday);
                            target_day_with_added_moved_days_this_month.setDate(target_day_with_added_moved_days_this_month.getDate() + (number + (number > 0 ? -1 : 0)) * 7 + add_days);
                            if (date_num === getValueForDate(target_day_with_added_moved_days_this_month, false)) return [
                                true,
                                dateAtDayMinutes(date, minutes_in_day)
                            ];
                        } else if (add_days < 0) {
                            target_day_with_added_moved_days_this_month = dateAtNextWeekday(new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) + 1, 1), weekday);
                            target_day_with_added_moved_days_this_month.setDate(target_day_with_added_moved_days_this_month.getDate() + (number + (number > 0 ? -1 : 0)) * 7 + add_days);
                            if (target_day_with_added_moved_days_this_month.getTime() >= start_of_next_month.getTime()) {
                                if (target_day_with_added_days_this_month.getTime() >= start_of_next_month.getTime()) return [
                                    false,
                                    target_day_with_added_moved_days_this_month
                                ];
                            } else {
                                if (target_day_with_added_days_this_month.getTime() < start_of_next_month.getTime() && getValueForDate(target_day_with_added_days_this_month, false) === date_num) return [
                                    true,
                                    dateAtDayMinutes(date, minutes_in_day)
                                ];
                                target_day_with_added_days_this_month = target_day_with_added_moved_days_this_month;
                            }
                        }
                        // we hit the target day
                        const currentDateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                        const targetDateOnly = new Date(target_day_with_added_days_this_month.getFullYear(), target_day_with_added_days_this_month.getMonth(), target_day_with_added_days_this_month.getDate());
                        if (currentDateOnly.getTime() === targetDateOnly.getTime()) return [
                            true,
                            dateAtDayMinutes(date, minutes_in_day)
                        ];
                        // we're before target day
                        if (currentDateOnly.getTime() < targetDateOnly.getTime()) return [
                            false,
                            target_day_with_added_days_this_month
                        ];
                        // we're after target day, set check date to next month
                        return [
                            false,
                            start_of_next_month
                        ];
                    };
                }(tokens[at][0], numbers[nnumber], add_days[0]));
                at = endat + 1 + add_days[1];
            } else if (matchTokens(tokens, at, 'weekday')) {
                // Single weekday (Mo) or weekday range (Mo-Fr)
                const is_range = matchTokens(tokens, at + 1, '-', 'weekday');
                let weekday_from = tokens[at][0];
                let weekday_to = is_range ? tokens[at + 2][0] : weekday_from;
                let inside = true;
                // handle reversed range
                if (weekday_to < weekday_from) {
                    const tmp = weekday_to;
                    weekday_to = weekday_from - 1;
                    weekday_from = tmp + 1;
                    inside = false;
                }
                const weekday_list = Array.apply(0, Array(weekday_to - weekday_from + 1)).map(function(_, index) {
                    return index + weekday_to;
                });
                if (typeof rule_infos[nrule] === 'undefined') rule_infos[nrule] = {};
                if (typeof rule_infos[nrule]['week_days'] === 'object') Array.prototype.push.apply(rule_infos[nrule]['week_days'], weekday_list);
                else rule_infos[nrule]['week_days'] = weekday_list;
                if (weekday_to < weekday_from) rule.weekday.push(function() {
                    return [
                        true
                    ];
                });
                else rule.weekday.push(function(weekday_from, weekday_to, inside) {
                    return function(date) {
                        const ourweekday = date.getDay();
                        if (ourweekday < weekday_from || ourweekday > weekday_to) return [
                            !inside,
                            dateAtNextWeekday(date, weekday_from)
                        ];
                        else return [
                            inside,
                            dateAtNextWeekday(date, weekday_to + 1)
                        ];
                    };
                }(weekday_from, weekday_to, inside));
                at += is_range ? 3 : 1;
            } else if (matchTokens(tokens, at, 'holiday')) {
                week_stable = false;
                return parseHoliday(tokens, at, rule, true, in_holiday_selector);
            } else if (matchTokens(tokens, at - 1, ',')) throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            else throw formatWarnErrorMessage(nrule, at, t('unexpected token weekday range', {
                'token': tokens[at][1]
            }));
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    /* }}} */ /* Get the number of days a date should be moved (if any). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where the date moving tokens could be.
     * :param max_differ: Maximal number of days to move (could also be zero if there are no day move tokens).
     * :returns: Array:
     *            0. Days to add.
     *            1. How many tokens.
     */ function getMoveDays(tokens, at, max_differ, name) {
        const add_days = [
            0,
            0
        ]; // [ 'days to add', 'how many tokens' ]
        add_days[0] = matchTokens(tokens, at, '+') || (matchTokens(tokens, at, '-') ? -1 : 0);
        if (add_days[0] !== 0 && matchTokens(tokens, at + 1, 'number', 'calcday')) {
            // continues with '+ 5 days' or something like that
            if (tokens[at + 1][0] > max_differ) throw formatWarnErrorMessage(nrule, at + 2, t('max differ', {
                'maxdiffer': max_differ,
                'name': name
            }));
            add_days[0] *= tokens[at + 1][0];
            if (add_days[0] === 0 && !done_with_warnings) parsing_warnings.push([
                nrule,
                at + 2,
                t('adding 0')
            ]);
            add_days[1] = 3;
        } else add_days[0] = 0;
        return add_days;
    }
    /* }}} */ /* Holiday parser for public and school holidays (PH,SH) {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param push_to_weekday: Will push the selector into the weekday selector array which has the desired side effect of working in conjunction with the weekday selectors (either the holiday match or the weekday), which is the normal and expected behavior.
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseHoliday(tokens, at, rule, push_to_weekday, in_holiday_selector) {
        if (!in_holiday_selector) {
            if (push_to_weekday) tokens[at][3] = 'weekday';
            else tokens[at][3] = 'holiday'; // Could also be holiday but this is not important here.
        }
        for(; at < tokens.length; at++){
            if (matchTokens(tokens, at, 'holiday')) {
                if (tokens[at][0] === 'PH') {
                    const applying_holidays = getMatchingHoliday(tokens[at][0]);
                    // Only allow moving one day in the past or in the future.
                    // This makes implementation easier because only one holiday is assumed to be moved to the next year.
                    const add_days = getMoveDays(tokens, at + 1, 1, 'public holiday');
                    const selector = function(applying_holidays, add_days) {
                        return function(date) {
                            const holidays = getApplyingHolidaysForYear(applying_holidays, date.getFullYear(), add_days);
                            // Needs to be calculated each time because of movable days.
                            const date_num = getValueForDate(date, true);
                            for(let i = 0; i < holidays.length; i++){
                                const next_holiday_date_num = getValueForDate(holidays[i][0], true);
                                if (date_num < next_holiday_date_num) {
                                    if (add_days[0] > 0) {
                                        // Calculate the last holiday from previous year to tested against it.
                                        const holidays_last_year = getApplyingHolidaysForYear(applying_holidays, date.getFullYear() - 1, add_days);
                                        const last_holiday_last_year = holidays_last_year[holidays_last_year.length - 1];
                                        const last_holiday_last_year_num = getValueForDate(last_holiday_last_year[0], true);
                                        if (date_num < last_holiday_last_year_num) return [
                                            false,
                                            last_holiday_last_year[0]
                                        ];
                                        else if (date_num === last_holiday_last_year_num) return [
                                            true,
                                            dateAtDayMinutes(last_holiday_last_year[0], minutes_in_day),
                                            'Day after ' + last_holiday_last_year[1]
                                        ];
                                    }
                                    return [
                                        false,
                                        holidays[i][0]
                                    ];
                                } else if (date_num === next_holiday_date_num) return [
                                    true,
                                    new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
                                    (add_days[0] > 0 ? 'Day after ' : add_days[0] < 0 ? 'Day before ' : '') + holidays[i][1]
                                ];
                            }
                            if (add_days[0] < 0) {
                                // Calculate the first holiday from next year to tested against it.
                                const holidays_next_year = getApplyingHolidaysForYear(applying_holidays, date.getFullYear() + 1, add_days);
                                const first_holidays_next_year = holidays_next_year[0];
                                const first_holidays_next_year_num = getValueForDate(first_holidays_next_year[0], true);
                                if (date_num === first_holidays_next_year_num) return [
                                    true,
                                    dateAtDayMinutes(first_holidays_next_year[0], minutes_in_day),
                                    'Day before ' + first_holidays_next_year[1]
                                ];
                            }
                            // continue next year
                            return [
                                false,
                                new Date(holidays[0][0].getFullYear() + 1, holidays[0][0].getMonth(), holidays[0][0].getDate())
                            ];
                        };
                    }(applying_holidays, add_days);
                    if (push_to_weekday) rule.weekday.push(selector);
                    else rule.holiday.push(selector);
                    at += 1 + add_days[1];
                } else if (tokens[at][0] === 'SH') {
                    const applying_holidays = getMatchingHoliday(tokens[at][0]);
                    const selector = function(applying_holidays) {
                        return function(date) {
                            const date_num = getValueForDate(date);
                            // Iterate over holiday array containing the different holiday ranges.
                            for(let i = 0; i < applying_holidays.length; i++){
                                const holiday = getSHForYear(applying_holidays[i], date.getFullYear());
                                if (typeof holiday === 'undefined') continue;
                                for(let h = 0; h < holiday.length; h += 4){
                                    let holiday_to_plus = new Date(date.getFullYear(), holiday[2 + h] - 1, holiday[3 + h] + 1);
                                    const holiday_from = (holiday[0 + h] - 1) * 100 + holiday[1 + h];
                                    const holiday_to = (holiday[2 + h] - 1) * 100 + holiday[3 + h];
                                    holiday_to_plus = getValueForDate(holiday_to_plus);
                                    // console.log(`holiday_from: ${holiday_from}, holiday_to: ${holiday_to}, holiday_to_plus: ${holiday_to_plus}`);
                                    const holiday_ends_next_year = holiday_to < holiday_from;
                                    if (date_num < holiday_from) {
                                        // check if we are in the holidays from the last year spanning into this year
                                        const last_year_holiday = getSHForYear(applying_holidays[applying_holidays.length - 1], date.getFullYear() - 1);
                                        if (typeof last_year_holiday === 'object') {
                                            const last_year_holiday_from = (last_year_holiday[last_year_holiday.length - 4] - 1) * 100 + last_year_holiday[last_year_holiday.length - 3]; // e.g. 1125
                                            const last_year_holiday_to = (last_year_holiday[last_year_holiday.length - 2] - 1) * 100 + last_year_holiday[last_year_holiday.length - 1]; // e.g. 0005
                                            // console.log(last_year_holiday_from, last_year_holiday_to);
                                            if (last_year_holiday_from > last_year_holiday_to && date_num <= last_year_holiday_to) return [
                                                true,
                                                new Date(date.getFullYear(), last_year_holiday[last_year_holiday.length - 2] - 1, last_year_holiday[last_year_holiday.length - 1] + 1),
                                                applying_holidays[applying_holidays.length - 1].name
                                            ];
                                            else return [
                                                false,
                                                new Date(date.getFullYear(), holiday[0 + h] - 1, holiday[1 + h])
                                            ];
                                        } else return [
                                            false,
                                            new Date(date.getFullYear(), holiday[0 + h] - 1, holiday[1 + h])
                                        ];
                                    } else if (holiday_from <= date_num && (date_num <= holiday_to || holiday_ends_next_year)) return [
                                        true,
                                        new Date(date.getFullYear() + holiday_ends_next_year, holiday[2 + h] - 1, holiday[3 + h] + 1),
                                        applying_holidays[i].name
                                    ];
                                    else if (holiday_to_plus === date_num) {
                                        if (h + 4 < holiday.length) {
                                            h += 4;
                                            return [
                                                false,
                                                new Date(date.getFullYear(), holiday[0 + h] - 1, holiday[1 + h])
                                            ];
                                        } else /* Because not all school holidays
                                         * have to apply each year this
                                         * part has been simplified which
                                         * makes the implementation a bit
                                         * less efficient but reduces
                                         * complexity.
                                         */ return [
                                            false,
                                            new Date(date.getFullYear(), holiday[2 + h] - 1, holiday[3 + h] + 2)
                                        ];
                                    }
                                }
                            }
                            throw formatLibraryBugMessage(t('no SH definition', {
                                'name': '',
                                'year': date.getFullYear()
                            }), 'library bug PR only');
                        };
                    }(applying_holidays);
                    if (push_to_weekday) rule.weekday.push(selector);
                    else rule.holiday.push(selector);
                    at += 1; // FIXME: test
                }
            } else if (matchTokens(tokens, at, 'weekday')) return parseWeekdayRange(tokens, at, rule, true, nrule);
            else if (matchTokens(tokens, at - 1, ',')) throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            else throw formatWarnErrorMessage(nrule, at, t('unexpected token holiday', {
                'token': tokens[at][1]
            }));
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    // Helpers for holiday parsers {{{
    /* Returns a number for a date which can then be used to compare just the dates (without the time). {{{
     *
     * This is necessary because a selector could be called for the middle of the day and we need to tell if it matches that day.
     * Example: Returns 20150015 for Jan 15 2015.
     *
     * :param date: Date object.
     * :param include_year: Boolean. If true include the year.
     * :returns: Number for the date.
     */ function getValueForDate(date, include_year) {
        // Implicit because undefined evaluates to false.
        // include_year = typeof include_year !== 'undefined' ? include_year : false;
        return (include_year ? date.getFullYear() * 10000 : 0) + date.getMonth() * 100 + date.getDate();
    }
    /* }}} */ /* Return the school holiday definition e.g. [ 5, 25, to 6, 5 ], for the specified year {{{
     *
     * :param SH_hash:
     * :param year: Year as integer.
     * :param fatal: Defines the behavior in case no definition is find. Throw an error if set to true. Return return undefined otherwise.
     * :returns: school holidays for the given year.
     */ function getSHForYear(SH_hash, year, fatal) {
        let holiday = SH_hash[year];
        if (typeof holiday === 'undefined') {
            holiday = SH_hash['default']; // applies for any year without explicit definition
            if (typeof holiday === 'undefined') return undefined;
        }
        return holiday;
    }
    /* }}} */ /* Return closest holiday definition available. {{{
     *
     * First try to get the state, if missing get the country wide holidays
     * (which can on it’s own be limited to some states).
     *
     * :param type_of_holidays: Choices: PH, SH.
     * :returns: Public or school holiday list.
     */ function getMatchingHoliday(type_of_holidays) {
        if (typeof location_cc !== 'string') /* We have no idea which holidays do apply because the country code was not provided. */ throw t('no country code');
        if (!$0e3b0f6e50344df5$var$holiday_definitions[location_cc]) throw formatLibraryBugMessage(t('no holiday definition', {
            'name': type_of_holidays,
            'cc': location_cc
        }), 'library bug PR only');
        let matching_holiday = [];
        if (typeof location_state === 'string' && typeof $0e3b0f6e50344df5$var$holiday_definitions[location_cc][location_state] === 'object' && typeof $0e3b0f6e50344df5$var$holiday_definitions[location_cc][location_state][type_of_holidays] === 'object') {
            /* If holiday_definitions for the state are specified,
             * use it and ignore lesser specific ones (for the
             * country).
             */ const country_holidays = $0e3b0f6e50344df5$var$holiday_definitions[location_cc][type_of_holidays] || [];
            const state_holidays = $0e3b0f6e50344df5$var$holiday_definitions[location_cc][location_state][type_of_holidays];
            if (type_of_holidays === 'PH') matching_holiday = state_holidays;
            else if (!country_holidays.length) matching_holiday = state_holidays;
            else {
                // Merge country and state holidays chronologically
                const country_holiday_names = country_holidays.map(function(country_holiday) {
                    return country_holiday.name;
                });
                matching_holiday.push.apply(matching_holiday, country_holidays);
                matching_holiday.push.apply(matching_holiday, state_holidays.filter(function is_not_a_country_holiday(state_holiday) {
                    return country_holiday_names.indexOf(state_holiday.name) === -1;
                }));
                matching_holiday.sort(function(h1, h2) {
                    const h1_year = Object.keys(h1).find(function(k) {
                        return k !== 'name';
                    });
                    const h2_year = Object.keys(h2).find(function(k) {
                        return k !== 'name';
                    });
                    const h1_date = h1[h1_year];
                    const h2_date = h2[h2_year];
                    // compare both months, or to break a tie both days
                    return h1_date[0] - h2_date[0] || h1_date[1] - h2_date[1];
                });
            }
        } else if ($0e3b0f6e50344df5$var$holiday_definitions[location_cc][type_of_holidays]) {
            /* Holidays are defined country wide. Some
             * countries only have country-wide holiday definitions
             * so that is ok too.
             */ const applying_holidays_for_country = $0e3b0f6e50344df5$var$holiday_definitions[location_cc][type_of_holidays];
            switch(type_of_holidays){
                case 'PH':
                    applying_holidays_for_country.forEach(function(holiday_item) {
                        /* Holidays in the country-wide scope can be limited to certain states. */ if ('only_states' in holiday_item) {
                            if (-1 === holiday_item.only_states.indexOf(location_state)) return;
                        }
                        matching_holiday.push(holiday_item);
                    });
                    break;
                case 'SH':
                    matching_holiday = applying_holidays_for_country;
                    break;
            }
        } else throw formatLibraryBugMessage(t('no holiday definition state', {
            'name': type_of_holidays,
            'cc': location_cc,
            'state': location_state
        }), 'library bug PR only');
        if (matching_holiday.length === 0) throw formatLibraryBugMessage(t('no holiday definition', {
            'name': type_of_holidays,
            'cc': location_cc
        }), 'library bug PR only');
        return matching_holiday;
    }
    /* }}} */ /* Return variable dates used for holiday calculation. {{{
     *
     * :param year: Year as integer.
     * :returns: Hash of variables dates. Key is the name of the variable date. Value is the variable date date object.
     */ function getMovableEventsForYear(year) {
        /* Calculate easter {{{ */ const C = Math.floor(year / 100);
        const N = year - 19 * Math.floor(year / 19);
        const K = Math.floor((C - 17) / 25);
        let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
        I = I - 30 * Math.floor(I / 30);
        I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
        let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
        J = J - 7 * Math.floor(J / 7);
        const L = I - J;
        const M = 3 + Math.floor((L + 40) / 44);
        const D = L + 28 - 31 * Math.floor(M / 4);
        /* }}} */ /* Calculate orthodox easter {{{ */ const oA = year % 4;
        const oB = year % 7;
        const oC = year % 19;
        const oD = (19 * oC + 15) % 30;
        const oE = (2 * oA + 4 * oB - oD + 34) % 7;
        const oF = oD + oE;
        let oDate;
        if (oF < 9) oDate = new Date(year, 3, oF + 4);
        else if (oF + 4 < 31) oDate = new Date(year, 3, oF + 4);
        else oDate = new Date(year, 4, oF - 26);
        /* }}} */ /* Calculate last Sunday in February {{{ */ const lastFebruaryDay = new Date(year, 2, 0);
        const lastFebruarySunday = lastFebruaryDay.getDate() - lastFebruaryDay.getDay();
        /* }}} */ /* Calculate Victoria Day. last Monday before or on May 24 {{{ */ const may_24 = new Date(year, 4, 24);
        const victoriaDay = 24 - (6 + may_24.getDay()) % 7;
        /* }}} */ /* Calculate Canada Day. July 1st unless 1st is on Sunday, then July 2. {{{ */ const july_1 = new Date(year, 6, 1);
        const canadaDay = july_1.getDay() === 0 ? 2 : 1;
        /* }}} */ /* Calculation of the spring and autumnal equinoxes (for Public holidays in Japan). {{{ */ function springEquinoxCalc(year) {
            if (year >= 1900 && year <= 1923) {
                if (year % 4 === 3) return new Date(year, 2, 22);
                else return new Date(year, 2, 21);
            } else if (year >= 1924 && year <= 1959) return new Date(year, 2, 21);
            else if (year >= 1960 && year <= 1991) {
                if (year % 4 === 0) return new Date(year, 2, 20);
                else return new Date(year, 2, 21);
            } else if (year >= 1992 && year <= 2023) {
                if (year % 4 === 0 || year % 4 === 1) return new Date(year, 2, 20);
                else return new Date(year, 2, 21);
            } else if (year >= 2024 && year <= 2055) {
                if (year % 4 === 3) return new Date(year, 2, 21);
                else return new Date(year, 2, 20);
            } else if (year >= 2056 && year <= 2091) return new Date(year, 2, 20);
            else if (year >= 2092 && year <= 2099) {
                if (year % 4 === 0) return new Date(year, 2, 19);
                else return new Date(year, 2, 20);
            }
        }
        function autumnalEquinoxCalc(year) {
            if (year >= 1900 && year <= 1919) {
                if (year % 4 === 0) return new Date(year, 8, 23);
                else return new Date(year, 8, 24);
            } else if (year >= 1920 && year <= 1947) {
                if (year % 4 === 0 || year % 4 === 1) return new Date(year, 8, 23);
                else return new Date(year, 8, 24);
            } else if (year >= 1948 && year <= 1979) {
                if (year % 4 === 3) return new Date(year, 8, 24);
                else return new Date(year, 8, 23);
            } else if (year >= 1980 && year <= 2011) return new Date(year, 8, 23);
            else if (year >= 2012 && year <= 2043) {
                if (year % 4 === 0) return new Date(year, 8, 22);
                else return new Date(year, 8, 23);
            } else if (year >= 2044 && year <= 2075) {
                if (year % 4 === 0 || year % 4 === 1) return new Date(year, 8, 22);
                else return new Date(year, 8, 23);
            } else if (year >= 2076 && year <= 2099) {
                if (year % 4 === 3) return new Date(year, 8, 23);
                else return new Date(year, 8, 22);
            }
        }
        /* Helper functions {{{ */ function firstWeekdayOfMonth(month, weekday) {
            const first = new Date(year, month, 1);
            return 1 + (7 + weekday - first.getDay()) % 7;
        }
        function lastWeekdayOfMonth(month, weekday) {
            const last = new Date(year, month + 1, 0);
            const offset = (7 + last.getDay() - weekday) % 7;
            return last.getDate() - offset;
        }
        function getDateOfWeekdayInDateRange(weekday, start_date) {
            let days_to_dest_date = weekday - start_date.getDay();
            if (days_to_dest_date < 0) days_to_dest_date += 7;
            start_date.setDate(start_date.getDate() + days_to_dest_date);
            return start_date;
        }
        /* Date of next weekday range. {{{
         *
         * :param first_weekday: First weekday in range of wanted weekday (1 is Mo).
         * :param last_weekday: Last weekday in range of wanted weekday (1 is Mo).
         * :param start_date: Earliest possible date to consider.
         * :returns: start_date if in weekday range, otherwise the next day which is in range.
         */ function getDateOfNextWeekdayRange(first_weekday, last_weekday, start_date) {
            if (first_weekday >= last_weekday) throw formatLibraryBugMessage('Not implemented yet.');
            if (first_weekday <= start_date.getDay() && start_date.getDay() <= last_weekday) return start_date;
            else {
                let days_to_dest_date = first_weekday - start_date.getDay();
                if (days_to_dest_date < 0) days_to_dest_date += 7;
                start_date.setDate(start_date.getDate() + days_to_dest_date);
                return start_date;
            }
        }
        /* }}} */ return {
            'easter': new Date(year, M - 1, D),
            'orthodox easter': oDate,
            'victoriaDay': new Date(year, 4, victoriaDay),
            'canadaDay': new Date(year, 6, canadaDay),
            'firstJanuaryMonday': new Date(year, 0, firstWeekdayOfMonth(0, 1)),
            'firstFebruaryMonday': new Date(year, 1, firstWeekdayOfMonth(1, 1)),
            'lastFebruarySunday': new Date(year, 1, lastFebruarySunday),
            'firstMarchMonday': new Date(year, 2, firstWeekdayOfMonth(2, 1)),
            'firstAprilMonday': new Date(year, 3, firstWeekdayOfMonth(3, 1)),
            'firstMayMonday': new Date(year, 4, firstWeekdayOfMonth(4, 1)),
            'firstJuneMonday': new Date(year, 5, firstWeekdayOfMonth(5, 1)),
            'firstJulyMonday': new Date(year, 6, firstWeekdayOfMonth(6, 1)),
            'firstAugustMonday': new Date(year, 7, firstWeekdayOfMonth(7, 1)),
            'firstSeptemberMonday': new Date(year, 8, firstWeekdayOfMonth(8, 1)),
            'firstSeptemberTuesday': new Date(year, 8, firstWeekdayOfMonth(8, 2)),
            'firstSeptemberSunday': new Date(year, 8, firstWeekdayOfMonth(8, 0)),
            'firstOctoberMonday': new Date(year, 9, firstWeekdayOfMonth(9, 1)),
            'firstNovemberMonday': new Date(year, 10, firstWeekdayOfMonth(10, 1)),
            'firstNovemberTuesday': new Date(year, 10, firstWeekdayOfMonth(10, 2)),
            'firstMarchTuesday': new Date(year, 2, firstWeekdayOfMonth(2, 2)),
            'firstAugustTuesday': new Date(year, 7, firstWeekdayOfMonth(7, 2)),
            'firstAugustFriday': new Date(year, 7, firstWeekdayOfMonth(7, 5)),
            'firstNovemberThursday': new Date(year, 10, firstWeekdayOfMonth(10, 4)),
            'lastMayMonday': new Date(year, 4, lastWeekdayOfMonth(4, 1)),
            'lastMarchMonday': new Date(year, 2, lastWeekdayOfMonth(2, 1)),
            'lastAprilMonday': new Date(year, 3, lastWeekdayOfMonth(3, 1)),
            'lastAprilFriday': new Date(year, 3, lastWeekdayOfMonth(3, 5)),
            'lastAugustMonday': new Date(year, 7, lastWeekdayOfMonth(7, 1)),
            'lastSeptemberMonday': new Date(year, 8, lastWeekdayOfMonth(8, 1)),
            'lastSeptemberFriday': new Date(year, 8, lastWeekdayOfMonth(8, 5)),
            'lastOctoberMonday': new Date(year, 9, lastWeekdayOfMonth(9, 1)),
            'lastOctoberFriday': new Date(year, 9, lastWeekdayOfMonth(9, 5)),
            'nextSaturday20Jun': getDateOfWeekdayInDateRange(6, new Date(year, 5, 20)),
            'nextSaturday31Oct': getDateOfWeekdayInDateRange(6, new Date(year, 9, 31)),
            'nextWednesday16Nov': getDateOfWeekdayInDateRange(3, new Date(year, 10, 16)),
            'nextMo-Fr17March': getDateOfNextWeekdayRange(1, 5, new Date(year, 2, 17)),
            'nextMo-Sa01May': getDateOfNextWeekdayRange(1, 6, new Date(year, 4, 1)),
            'nextMo-Fr12July': getDateOfNextWeekdayRange(1, 5, new Date(year, 6, 12)),
            'nextMo-Sa07August': getDateOfNextWeekdayRange(1, 6, new Date(year, 7, 7)),
            'nextMo-Fr30November': getDateOfNextWeekdayRange(1, 5, new Date(year, 10, 30)),
            'nextMo-Sa25December': getDateOfNextWeekdayRange(1, 6, new Date(year, 11, 25)),
            'springEquinox': springEquinoxCalc(year),
            'autumnalEquinox': autumnalEquinoxCalc(year)
        };
    }
    /* }}} */ function getApplyingHolidaysForYear(applying_holidays, year, add_days) {
        const movableDays = getMovableEventsForYear(year);
        let sorted_holidays = [];
        let next_holiday;
        applying_holidays.forEach(function(holiday_item) {
            if ('fixed_date' in holiday_item) next_holiday = new Date(year, holiday_item.fixed_date[0] - 1, holiday_item.fixed_date[1]);
            else if ('variable_date' in holiday_item) {
                const selected_movableDay = movableDays[holiday_item.variable_date];
                if (!selected_movableDay) throw t('movable no formula', {
                    'name': holiday_item.name
                });
                let date_offset = 0;
                if ('offset' in holiday_item) date_offset = holiday_item.offset;
                next_holiday = new Date(selected_movableDay.getFullYear(), selected_movableDay.getMonth(), selected_movableDay.getDate() + date_offset);
                if (year !== next_holiday.getFullYear()) throw t('movable not in year', {
                    'name': holiday_item.variable_date,
                    'days': date_offset
                });
            } else throw formatLibraryBugMessage('Unexpected object: ' + JSON.stringify(holiday_item, null, '    '));
            if (add_days[0]) next_holiday.setDate(next_holiday.getDate() + add_days[0]);
            sorted_holidays.push([
                next_holiday,
                holiday_item.name
            ]);
        });
        sorted_holidays = sorted_holidays.sort(function(a, b) {
            if (a[0].getTime() < b[0].getTime()) return -1;
            if (a[0].getTime() > b[0].getTime()) return 1;
            return 0;
        });
        return sorted_holidays;
    }
    /* }}} */ /* }}} */ /* Year range parser (2013,2016-2018,2020/2). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseYearRange(tokens, at) {
        tokens[at][3] = 'year';
        for(; at < tokens.length; at++){
            if (matchTokens(tokens, at, 'year')) {
                let is_range = false, has_period, period;
                if (matchTokens(tokens, at + 1, '-', 'year', '/', 'number')) {
                    is_range = true;
                    has_period = true;
                    period = parseInt(tokens[at + 4][0]);
                    checkPeriod(at + 4, period, 'year');
                } else {
                    is_range = matchTokens(tokens, at + 1, '-', 'year');
                    has_period = matchTokens(tokens, at + 1, '/', 'number');
                    if (has_period) {
                        period = parseInt(tokens[at + 2][0]);
                        checkPeriod(at + 2, period, 'year', 'no_end_year');
                    } else if (matchTokens(tokens, at + 1, '+')) {
                        period = 1;
                        has_period = 2;
                    }
                }
                const year_from = parseInt(tokens[at][0]);
                // error checking {{{
                if (is_range && tokens[at + 2][0] <= year_from) {
                    // handle reversed range
                    if (tokens[at + 2][0] === year_from) throw formatWarnErrorMessage(nrule, at, t('year range one year', {
                        'year': year_from
                    }));
                    else throw formatWarnErrorMessage(nrule, at, t('year range reverse'));
                }
                if (!is_range && year_from < new Date().getFullYear()) parsing_warnings.push([
                    nrule,
                    at,
                    t('year past')
                ]);
                if (is_range && tokens[at + 2][0] < new Date().getFullYear()) parsing_warnings.push([
                    nrule,
                    at + 2,
                    t('year past')
                ]);
                /* }}} */ rule.year.push(function(tokens, at, year_from, is_range, has_period, period) {
                    return function(date) {
                        const ouryear = date.getFullYear();
                        const year_to = is_range ? parseInt(tokens[at + 2][0]) : year_from;
                        if (ouryear < year_from) return [
                            false,
                            new Date(year_from, 0, 1)
                        ];
                        else if (has_period) {
                            if (year_from <= ouryear) {
                                if (is_range && ouryear > year_to) return [
                                    false
                                ];
                                if (period > 0) {
                                    if ((ouryear - year_from) % period === 0) return [
                                        true,
                                        new Date(ouryear + 1, 0, 1)
                                    ];
                                    else return [
                                        false,
                                        new Date(ouryear + period - 1, 0, 1)
                                    ];
                                }
                            }
                        } else if (is_range) {
                            if (ouryear <= year_to) return [
                                true,
                                new Date(year_to + 1, 0, 1)
                            ];
                        } else if (ouryear === year_from) return [
                            true
                        ];
                        return [
                            false
                        ];
                    };
                }(tokens, at, year_from, is_range, has_period, period));
                at += 1 + (is_range ? 2 : 0) + (has_period ? has_period === 2 ? 1 : 2 : 0);
            } else if (matchTokens(tokens, at - 1, ',')) throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            else throw formatWarnErrorMessage(nrule, at, t('unexpected token year range', {
                'token': tokens[at][1]
            }));
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    /* }}} */ /* Week range parser (week 11-20, week 1-53/2). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseWeekRange(tokens, at) {
        for(; at < tokens.length; at++){
            if (matchTokens(tokens, at, 'week')) at++;
            if (matchTokens(tokens, at, 'number')) {
                const is_range = matchTokens(tokens, at + 1, '-', 'number');
                let period = 0;
                const week_from = tokens[at][0];
                const week_to = is_range ? tokens[at + 2][0] : week_from;
                if (week_from > week_to) throw formatWarnErrorMessage(nrule, at + 2, t('week range reverse'));
                if (week_from < 1) throw formatWarnErrorMessage(nrule, at, t('week negative'));
                if (week_to > 53) throw formatWarnErrorMessage(nrule, is_range ? at + 2 : at, t('week exceed'));
                if (is_range) {
                    period = matchTokens(tokens, at + 3, '/', 'number');
                    if (period) {
                        period = tokens[at + 4][0];
                        tokens[at + 4][4] = 'positive_number';
                        if (period < 2) throw formatWarnErrorMessage(nrule, at + 4, t('week period less than 2', {
                            'weekfrom': week_from,
                            'weekto': week_to,
                            'period': period
                        }));
                        else if (period > 26) throw formatWarnErrorMessage(nrule, at + 4, t('week period greater than 26', {
                            'weekfrom': week_from
                        }));
                    }
                }
                if (week_stable && (!(week_from <= 1 && week_to >= 53) || period)) week_stable = false;
                if (!period && week_from === 1 && week_to === 53) /* Shortcut and work around bug. */ rule.week.push(function() {
                    return [
                        true
                    ];
                });
                else rule.week.push(function(week_from, week_to, period) {
                    return function(date) {
                        const ourweek = getWeekNumber(date);
                        // console.log("week_from: %s, week_to: %s", week_from, week_to);
                        // console.log("ourweek: %s, date: %s", ourweek, date);
                        // before range
                        if (ourweek < week_from) // console.log("Before: " + getNextDateOfISOWeek(week_from, date));
                        return [
                            false,
                            getNextDateOfISOWeek(week_from, date)
                        ];
                        // we're after range, set check date to next year
                        if (ourweek > week_to) // console.log("After");
                        return [
                            false,
                            getNextDateOfISOWeek(week_from, date)
                        ];
                        // we're in range
                        if (period) {
                            const in_period = (ourweek - week_from) % period === 0;
                            if (in_period) return [
                                true,
                                getNextDateOfISOWeek(ourweek + 1, date)
                            ];
                            else {
                                // Calculate how many weeks we need to skip to land on the next period-aligned week
                                const weeks_until_next_match = period - (ourweek - week_from) % period;
                                const next_matching_week = ourweek + weeks_until_next_match;
                                if (next_matching_week <= week_to) return [
                                    false,
                                    getNextDateOfISOWeek(next_matching_week, date)
                                ];
                                else // No further match within the range; wrap to the first matching week in the next year
                                return [
                                    false,
                                    getNextDateOfISOWeek(week_from, date)
                                ];
                            }
                        }
                        // console.log("Match");
                        return [
                            true,
                            getNextDateOfISOWeek(week_to === 53 ? 1 : week_to + 1, date)
                        ];
                    };
                }(week_from, week_to, period));
                at += 1 + (is_range ? 2 : 0) + (period ? 2 : 0);
            } else if (matchTokens(tokens, at - 1, ',')) throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            else throw formatWarnErrorMessage(nrule, at, t('unexpected token week range', {
                'token': tokens[at][1]
            }));
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    // https://stackoverflow.com/a/6117889
    /* For a given date, get the ISO week number.
     *
     * Based on information at:
     *
     *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
     *
     * Algorithm is to find nearest Thursday, it's year
     * is the year of the week number. Then get weeks
     * between that date and the first day of that year.
     *
     * Note that dates in one year can be weeks of previous
     * or next year, overlap is up to 3 days.
     *
     * e.g. 2014/12/29 is Monday in week  1 of 2015
     *      2012/1/1   is Sunday in week 52 of 2011
     */ function getWeekNumber(d) {
        // Copy date so don't modify original
        d = new Date(+d);
        d.setHours(0, 0, 0, 0);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        // Get first day of year
        const yearStart = new Date(d.getFullYear(), 0, 1);
        // Calculate full weeks to nearest Thursday
        return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    }
    // https://stackoverflow.com/a/16591175
    function getDateOfISOWeek(w, year) {
        const simple = new Date(year, 0, 1 + (w - 1) * 7);
        const dow = simple.getDay();
        const ISOweekStart = simple;
        if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        return ISOweekStart;
    }
    function getNextDateOfISOWeek(week, date) {
        let next_date;
        for(let i = -1; i <= 1; i++){
            next_date = getDateOfISOWeek(week, date.getFullYear() + i);
            if (next_date.getTime() > date.getTime()) return next_date;
        }
        throw formatLibraryBugMessage();
    }
    /* }}} */ /* Month range parser (Jan,Feb-Mar). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param push_to_monthday: Will push the selector into the monthday selector array which has the desired side effect of working in conjunction with the monthday selectors (either the month match or the monthday).
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseMonthRange(tokens, at, push_to_monthday, in_selector) {
        if (!in_selector) tokens[at][3] = 'month';
        for(; at < tokens.length; at++){
            // Use parseMonthdayRange if '<month> <daynum>' and not '<month> <hour>:<minute>'
            if (matchTokens(tokens, at, 'month', 'number') && !matchTokens(tokens, at + 2, 'timesep', 'number')) return parseMonthdayRange(tokens, at, nrule, true);
            else if (matchTokens(tokens, at, 'month')) {
                // Single month (Jan) or month range (Feb-Mar)
                const is_range = matchTokens(tokens, at + 1, '-', 'month');
                let month_from = tokens[at][0];
                let month_to = is_range ? tokens[at + 2][0] : month_from;
                if (is_range && week_stable) {
                    if (month_from !== (month_to + 1) % 12) week_stable = false;
                } else week_stable = false;
                let inside = true;
                // handle reversed range
                if (month_to < month_from) {
                    const tmp = month_to;
                    month_to = month_from - 1;
                    month_from = tmp + 1;
                    inside = false;
                }
                const selector = function(month_from, month_to, inside) {
                    return function(date) {
                        const ourmonth = date.getMonth();
                        if (month_to < month_from) /* Handle full range. */ return [
                            !inside
                        ];
                        if (ourmonth < month_from || ourmonth > month_to) return [
                            !inside,
                            dateAtNextMonth(date, month_from)
                        ];
                        else return [
                            inside,
                            dateAtNextMonth(date, month_to + 1)
                        ];
                    };
                }(month_from, month_to, inside);
                if (push_to_monthday === true) rule.monthday.push(selector);
                else rule.month.push(selector);
                at += is_range ? 3 : 1;
            } else throw formatWarnErrorMessage(nrule, at, t('unexpected token month range', {
                'token': tokens[at][1]
            }));
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    function dateAtNextMonth(date, month) {
        return new Date(date.getFullYear(), month < date.getMonth() ? month + 12 : month);
    }
    /* }}} */ /* Month day range parser (Jan 26-31; Jan 26-Feb 26). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param nrule: Rule number starting with 0.
     * :param push_to_month: Will push the selector into the month selector array which has the desired side effect of working in conjunction with the month selectors (either the month match or the monthday).
     * :returns: Position at which the token does not belong to the selector anymore.
     */ function parseMonthdayRange(tokens, at, nrule, push_to_month) {
        if (!push_to_month) tokens[at][3] = 'month';
        for(; at < tokens.length; at++){
            let has_year = [];
            const has_month = [], has_event = [], has_calc = [], has_constrained_weekday = [];
            has_year[0] = matchTokens(tokens, at, 'year');
            has_month[0] = matchTokens(tokens, at + has_year[0], 'month', 'number');
            has_event[0] = matchTokens(tokens, at + has_year[0], 'event');
            if (has_event[0]) has_calc[0] = getMoveDays(tokens, at + has_year[0] + 1, 200, 'event like easter');
            let at_range_sep;
            if (matchTokens(tokens, at + has_year[0], 'month', 'weekday', '[')) {
                has_constrained_weekday[0] = getConstrainedWeekday(tokens, at + has_year[0] + 3);
                has_calc[0] = getMoveDays(tokens, has_constrained_weekday[0][1], 6, 'constrained weekdays');
                at_range_sep = has_constrained_weekday[0][1] + (typeof has_calc[0] === 'object' && has_calc[0][1] ? 3 : 0);
            } else at_range_sep = at + has_year[0] + (has_event[0] ? typeof has_calc[0] === 'object' && has_calc[0][1] ? 4 : 1 : 2);
            let at_sec_event_or_month;
            if ((has_month[0] || has_event[0] || has_constrained_weekday[0]) && matchTokens(tokens, at_range_sep, '-')) {
                has_year[1] = matchTokens(tokens, at_range_sep + 1, 'year');
                at_sec_event_or_month = at_range_sep + 1 + has_year[1];
                has_month[1] = matchTokens(tokens, at_sec_event_or_month, 'month', 'number');
                if (!has_month[1]) {
                    has_event[1] = matchTokens(tokens, at_sec_event_or_month, 'event');
                    if (has_event[1]) has_calc[1] = getMoveDays(tokens, at_sec_event_or_month + 1, 366, 'event like easter');
                    else if (matchTokens(tokens, at_sec_event_or_month, 'month', 'weekday', '[')) {
                        has_constrained_weekday[1] = getConstrainedWeekday(tokens, at_sec_event_or_month + 3);
                        has_calc[1] = getMoveDays(tokens, has_constrained_weekday[1][1], 6, 'constrained weekdays');
                    }
                }
            }
            // monthday range like Jan 26-Feb 26 {{{
            if (has_year[0] === has_year[1] && (has_month[1] || has_event[1] || has_constrained_weekday[1])) {
                if (has_month[0]) checkIfDateIsValid(tokens[at + has_year[0]][0], tokens[at + has_year[0] + 1][0], nrule, at + has_year[0] + 1);
                if (has_month[1]) checkIfDateIsValid(tokens[at_sec_event_or_month][0], tokens[at_sec_event_or_month + 1][0], nrule, at_sec_event_or_month + 1);
                const selector = function(tokens, at, nrule, has_year, has_event, has_calc, at_sec_event_or_month, has_constrained_weekday) {
                    return function(date) {
                        const start_of_next_year = new Date(date.getFullYear() + 1, 0, 1);
                        let movableDays, from_date;
                        if (has_event[0]) {
                            movableDays = getMovableEventsForYear(has_year[0] ? parseInt(tokens[at][0]) : date.getFullYear());
                            from_date = movableDays[tokens[at + has_year[0]][0]];
                            if (typeof has_calc[0] === 'object' && has_calc[0][1]) {
                                const from_year_before_calc = from_date.getFullYear();
                                from_date.setDate(from_date.getDate() + has_calc[0][0]);
                                if (from_year_before_calc !== from_date.getFullYear()) throw formatWarnErrorMessage(nrule, at + has_year[0] + has_calc[0][1] * 3, t('movable not in year', {
                                    'name': tokens[at + has_year[0]][0],
                                    'days': has_calc[0][0]
                                }));
                            }
                        } else if (has_constrained_weekday[0]) from_date = getDateForConstrainedWeekday(has_year[0] ? tokens[at][0] : date.getFullYear(), tokens[at + has_year[0]][0], tokens[at + has_year[0] + 1][0], has_constrained_weekday[0], has_calc[0]);
                        else from_date = new Date(has_year[0] ? tokens[at][0] : date.getFullYear(), tokens[at + has_year[0]][0], tokens[at + has_year[0] + 1][0]);
                        let to_date;
                        if (has_event[1]) {
                            movableDays = getMovableEventsForYear(has_year[1] ? parseInt(tokens[at_sec_event_or_month - 1][0]) : date.getFullYear());
                            to_date = movableDays[tokens[at_sec_event_or_month][0]];
                            if (typeof has_calc[1] === 'object' && has_calc[1][1]) {
                                const to_year_before_calc = to_date.getFullYear();
                                to_date.setDate(to_date.getDate() + has_calc[1][0]);
                                if (to_year_before_calc !== to_date.getFullYear()) throw formatWarnErrorMessage(nrule, at_sec_event_or_month + has_calc[1][1], t('movable not in year', {
                                    'name': tokens[at_sec_event_or_month][0],
                                    'days': has_calc[1][0]
                                }));
                            }
                        } else if (has_constrained_weekday[1]) to_date = getDateForConstrainedWeekday(has_year[1] ? tokens[at_sec_event_or_month - 1][0] : date.getFullYear(), tokens[at_sec_event_or_month][0], tokens[at_sec_event_or_month + 1][0], has_constrained_weekday[1], has_calc[1]);
                        else to_date = new Date(has_year[1] ? tokens[at_sec_event_or_month - 1][0] : date.getFullYear(), tokens[at_sec_event_or_month][0], tokens[at_sec_event_or_month + 1][0] + 1);
                        let inside = true;
                        if (to_date < from_date) {
                            const tmp = to_date;
                            to_date = from_date;
                            from_date = tmp;
                            inside = false;
                        }
                        if (date.getTime() < from_date.getTime()) return [
                            !inside,
                            from_date
                        ];
                        else if (date.getTime() < to_date.getTime()) return [
                            inside,
                            to_date
                        ];
                        else {
                            if (has_year[0]) return [
                                !inside
                            ];
                            else return [
                                !inside,
                                start_of_next_year
                            ];
                        }
                    };
                }(tokens, at, nrule, has_year, has_event, has_calc, at_sec_event_or_month, has_constrained_weekday);
                if (push_to_month === true) rule.month.push(selector);
                else rule.monthday.push(selector);
                at = (has_constrained_weekday[1] ? has_constrained_weekday[1][1] : at_sec_event_or_month + (has_event[1] ? 1 : 2)) + (typeof has_calc[1] === 'object' ? has_calc[1][1] : 0);
            /* }}} */ // Monthday range like Jan 26-31 {{{
            } else if (has_month[0]) {
                has_year = has_year[0];
                const year = tokens[at][0]; // Could be month if has no year. Tested later.
                const month = tokens[at + has_year][0];
                let first_round = true;
                let is_range;
                do {
                    const range_from = tokens[at + 1 + has_year][0];
                    is_range = matchTokens(tokens, at + 2 + has_year, '-', 'number');
                    let period = undefined;
                    const range_to = tokens[at + has_year + (is_range ? 3 : 1)][0] + 1;
                    if (is_range && matchTokens(tokens, at + has_year + 4, '/', 'number')) {
                        period = tokens[at + has_year + 5][0];
                        tokens[at + has_year + 5][4] = 'positive_number';
                        checkPeriod(at + has_year + 5, period, 'day');
                    }
                    if (first_round) {
                        const at_timesep_if_monthRange = at + has_year + 1 // at month number
                         + (is_range ? 2 : 0) + (period ? 2 : 0) + !(is_range || period); // if not range nor has period, add one
                        // Check for '<month> <timespan>'
                        if (matchTokens(tokens, at_timesep_if_monthRange, 'timesep', 'number') && (matchTokens(tokens, at_timesep_if_monthRange + 2, '+') || matchTokens(tokens, at_timesep_if_monthRange + 2, '-') || oh_mode !== 0)) return parseMonthRange(tokens, at, true, true);
                    }
                    // error checking {{{
                    if (range_to < range_from) throw formatWarnErrorMessage(nrule, at + has_year + 3, t('day range reverse'));
                    checkIfDateIsValid(month, range_from, nrule, at + 1 + has_year);
                    checkIfDateIsValid(month, range_to - 1 /* added previously */ , nrule, at + has_year + (is_range ? 3 : 1));
                    /* }}} */ const selector = function(year, has_year, month, range_from, range_to, period) {
                        return function(date) {
                            const start_of_next_year = new Date(date.getFullYear() + 1, 0, 1);
                            const from_date = new Date(has_year ? year : date.getFullYear(), month, range_from);
                            if (month === 1 && range_from !== from_date.getDate()) return [
                                false
                            ]; // If day 29 does not exist,
                            // then the date object adds one day to date
                            // and this selector should not match.
                            const to_date = new Date(from_date.getFullYear(), month, range_to);
                            if (month === 1 && is_range && range_to !== to_date.getDate()) return [
                                false
                            ];
                            if (date.getTime() < from_date.getTime()) return [
                                false,
                                from_date
                            ];
                            else if (date.getTime() >= to_date.getTime()) return [
                                false,
                                start_of_next_year
                            ];
                            else if (!period) return [
                                true,
                                to_date
                            ];
                            const nday = Math.floor((date.getTime() - from_date.getTime()) / msec_in_day);
                            const in_period = nday % period;
                            if (in_period === 0) return [
                                true,
                                new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
                            ];
                            else return [
                                false,
                                new Date(date.getFullYear(), date.getMonth(), date.getDate() + period - in_period)
                            ];
                        };
                    }(year, has_year, month, range_from, range_to, period);
                    if (push_to_month === true) rule.month.push(selector);
                    else rule.monthday.push(selector);
                    at += 2 + has_year + (is_range ? 2 : 0) + (period ? 2 : 0);
                    first_round = false;
                }while (matchTokens(tokens, at, ',', 'number'));
            /* }}} */ // Only event like easter {{{
            } else if (has_event[0]) {
                const selector = function(tokens, at, nrule, has_year, add_days) {
                    return function(date) {
                        // console.log('enter selector with date: ' + date);
                        const movableDays = getMovableEventsForYear(has_year ? tokens[at][0] : date.getFullYear());
                        const event_date = movableDays[tokens[at + has_year][0]];
                        if (!event_date) throw t('movable no formula', {
                            'name': tokens[at + has_year][0]
                        });
                        if (add_days[0]) {
                            event_date.setDate(event_date.getDate() + add_days[0]);
                            if (date.getFullYear() !== event_date.getFullYear()) throw formatWarnErrorMessage(nrule, at + has_year + add_days[1], t('movable not in year', {
                                'name': tokens[at + has_year][0],
                                'days': add_days[0]
                            }));
                        }
                        if (date.getTime() < event_date.getTime()) return [
                            false,
                            event_date
                        ];
                        else if (event_date.getMonth() * 100 + event_date.getDate() === date.getMonth() * 100 + date.getDate()) return [
                            true,
                            new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
                        ];
                        else return [
                            false,
                            new Date(date.getFullYear() + 1, 0, 1)
                        ];
                    };
                }(tokens, at, nrule, has_year[0], has_calc[0]);
                if (push_to_month === true) rule.month.push(selector);
                else rule.monthday.push(selector);
                at += has_year[0] + has_event[0] + (typeof has_calc[0][1] === 'number' && has_calc[0][1] ? 3 : 0);
            /* }}} */ } else if (has_constrained_weekday[0]) at = parseMonthRange(tokens, at);
            else if (matchTokens(tokens, at, 'month')) return parseMonthRange(tokens, at, true, true);
            else // throw 'Unexpected token in monthday range: "' + tokens[at] + '"';
            return at;
            if (!matchTokens(tokens, at, ',')) break;
        }
        return at;
    }
    /* }}} */ /* Main selector traversal function (return state array for date). {{{
     * Checks for given date which rule and those which state and comment applies.
     *
     * :param date: Date object.
     * :returns: Array:
     *            0. resultstate: State: true for 'open', false for 'closed'.
     *            1. changedate: Next change as date object.
     *            2. unknown: true if state open is not sure.
     *            3. comment: Comment which applies for this time range (from date to changedate).
     *            4. match_rule: Rule number starting with 0 (nrule).
     */ this.getStatePair = function(date) {
        let resultstate = false;
        let changedate;
        let unknown = false;
        let comment;
        let match_rule;
        let date_matching_rules = [];
        /* Go though all date selectors and check if they return something
         * else than closed for the given date.
         */ for(let nrule = 0; nrule < rules.length; nrule++){
            let matching_date_rule = true;
            // console.log(nrule, 'length',  rules[nrule].date.length);
            /* Try each date selector type. */ for(let ndateselector = 0; ndateselector < rules[nrule].date.length; ndateselector++){
                const dateselectors = rules[nrule].date[ndateselector];
                // console.log(nrule, ndateselector);
                let has_matching_selector = false;
                for(let datesel = 0; datesel < dateselectors.length; datesel++){
                    const res = dateselectors[datesel](date);
                    if (res[0]) {
                        has_matching_selector = true;
                        if (typeof res[2] === 'string') comment = [
                            res[2],
                            nrule
                        ];
                    }
                    if (typeof changedate === 'undefined' || typeof res[1] === 'object' && res[1].getTime() < changedate.getTime()) changedate = res[1];
                }
                if (!has_matching_selector) {
                    matching_date_rule = false;
                    break;
                }
            }
            if (matching_date_rule) {
                /* The following lines implement date overwriting logic (e.g. for
                 * "Mo-Fr 10:00-20:00; We 10:00-16:00", We rule overrides Mo-Fr rule partly (We).
                 *
                 * This is the only way to be consistent. I thought about ("22:00-02:00; Tu 12:00-14:00") letting Th override 22:00-02:00 partly:
                 * Like: Th 00:00-02:00,12:00-14:00 but this would result in including 22:00-00:00 for Th which is probably not what you want.
                 */ if ((rules[nrule].date.length > 0 || nrule > 0 && rules[nrule].meaning && rules[nrule - 1].date.length === 0) && (rules[nrule].meaning || rules[nrule].unknown) && !rules[nrule].wrapped && !rules[nrule].additional && !rules[nrule].fallback) // let old_date_matching_rules = date_matching_rules;
                date_matching_rules = [];
                date_matching_rules.push(nrule);
            }
        }
        // console.log(date_matching_rules);
        for(let nrule = 0; nrule < date_matching_rules.length; nrule++){
            const rule = date_matching_rules[nrule];
            // console.log('Processing rule ' + rule + ': with date ' + date
            // + ' and ' + rules[rule].time.length + ' time selectors (comment: "' + rules[rule].comment + '").');
            /* There is no time specified, state applies to the whole day. */ if (rules[rule].time.length === 0) // console.log('there is no time', date);
            {
                if (!rules[rule].fallback || rules[rule].fallback && !(resultstate || unknown)) {
                    resultstate = rules[rule].meaning;
                    unknown = rules[rule].unknown;
                    match_rule = rule;
                // if (rules[rule].fallback)
                // break rule; // fallback rule matched, no need for checking the rest
                // WRONG: What if closing rules follow?
                }
            }
            for(let timesel = 0; timesel < rules[rule].time.length; timesel++){
                const res = rules[rule].time[timesel](date);
                // console.log('res:', res);
                if (res[0]) {
                    if (!rules[rule].fallback || rules[rule].fallback && !(resultstate || unknown)) {
                        resultstate = rules[rule].meaning;
                        unknown = rules[rule].unknown;
                        match_rule = rule;
                        /* Reset open end comment */ if (typeof comment === 'object' && comment[0] === t('open end')) comment = undefined;
                        // open end
                        if (res[2] === true && (resultstate || unknown)) {
                            comment = [
                                t('open end'),
                                match_rule
                            ];
                            resultstate = false;
                            unknown = true;
                            /* Hack to make second rule in '07:00+,12:00-16:00; 16:00-24:00 closed "needed because of open end"' obsolete {{{ */ if (typeof rules[rule].time[timesel + 1] === 'function') {
                                const next_res = rules[rule].time[timesel + 1](date);
                                if (!next_res[0] && typeof next_res[1] === 'object' && rules[rule].time[timesel](new Date(date.getTime() - 1))[0]) {
                                    // console.log("07:00+,12:00-16:00 matched.");
                                    resultstate = false;
                                    unknown = false;
                                }
                            }
                        /* Hack to handle '17:00+,13:00-02:00' {{{ */ /* Not enabled. To complicated, just don‘t use them …
                             * It gets even crazier …
                             * Time wrapping over midnight is
                             * stored in the next internal rule:
                             * '17:00-00:00 unknown "Specified as open end. Closing time was guessed.", 13:00-00:00 open' // First internal rule.
                             * + ', ' overwritten part: 00:00-03:00 open + '00:00-02:00 open', // Second internal rule.
                             */ /*
                            if (
                                    typeof rules[rule-1] === 'object'
                                    && rules[rule].build_from_token_rule.toString() === rules[rule-1].build_from_token_rule.toString()
                                    && typeof rules[rule] === 'object'
                                    && rules[rule].build_from_token_rule.toString() === rules[rule].build_from_token_rule.toString()
                                    ) {

                                let last_wrapping_time_selector = rules[rule].time[rules[rule].time.length - 1];
                                let last_w_res = last_wrapping_time_selector(new Date(date.getTime() - 1));
                                // console.log(last_w_res);

                                if (    last_w_res[0]
                                        &&  typeof last_w_res[2] === 'undefined'
                                        && (typeof last_w_res[2] === 'undefined' || last_w_res[2] === false) // Do not match for 'Tu 23:59-40:00+'
                                        &&  typeof last_w_res[1] === 'object'
                                        && date.getTime() === last_w_res[1].getTime()
                                    ) {

                                    // '05:00-06:00,17:00+,13:00-02:00',

                                    // console.log("17:00+,13:00-02:00 matched.");
                                    // console.log(JSON.stringify(rules, null, '    '));

                                    resultstate = false;
                                    unknown     = false;
                                }
                            }
                            /* }}} */ }
                        if (rules[rule].fallback) {
                            if (typeof changedate === 'undefined' || typeof res[1] !== 'undefined' && res[1] < changedate) // FIXME: Changing undefined does not break the test framework.
                            changedate = res[1];
                        }
                    }
                }
                if (typeof changedate === 'undefined' || typeof res[1] === 'object' && res[1] < changedate) changedate = res[1];
            }
        }
        if (typeof rules[match_rule] === 'object' && typeof rules[match_rule].comment === 'string') /* Only use comment if one is explicitly specified. */ comment = rules[match_rule].comment;
        else if (typeof comment === 'object') {
            if (comment[1] === match_rule) comment = comment[0];
            else comment = undefined;
        }
        // console.log('changedate', changedate, resultstate, comment, match_rule);
        return [
            resultstate,
            changedate,
            unknown,
            comment,
            match_rule
        ];
    };
    /* }}} */ /* Generate prettified value for selector based on tokens. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param last_at: Position where to stop.
     * :param conf: Configuration options.
     * :returns: Prettified value.
     */ function prettifySelector(tokens, selector_start, selector_end, selector_type, conf) {
        let prettified_value = '';
        let at = selector_start;
        // console.log(selector_type);
        while(at <= selector_end){
            // console.log('At: ' + at + ', token: ' + tokens[at]);
            if (matchTokens(tokens, at, 'weekday')) {
                if (!conf.leave_weekday_sep_one_day_betw && at - selector_start > 1 && (matchTokens(tokens, at - 1, ',') || matchTokens(tokens, at - 1, '-')) && matchTokens(tokens, at - 2, 'weekday') && tokens[at][0] === (tokens[at - 2][0] + 1) % 7) prettified_value = prettified_value.substring(0, prettified_value.length - 1) + conf.sep_one_day_between;
                prettified_value += weekdays[tokens[at][0]];
            } else if (at - selector_start > 0 // e.g. '09:0' -> '09:00'
             && selector_type === 'time' && matchTokens(tokens, at - 1, 'timesep') && matchTokens(tokens, at, 'number')) prettified_value += (tokens[at][0] < 10 ? '0' : '') + tokens[at][0].toString();
            else if (selector_type === 'time' // e.g. '9:00' -> ' 09:00'
             && conf.zero_pad_hour && at !== tokens.length && matchTokens(tokens, at, 'number') && matchTokens(tokens, at + 1, 'timesep')) prettified_value += (tokens[at][0] < 10 ? tokens[at][0] === 0 && conf.one_zero_if_hour_zero ? '' : '0' : '') + tokens[at][0].toString();
            else if (selector_type === 'time' // e.g. '9-18' -> '09:00-18:00'
             && at + 2 <= selector_end && matchTokens(tokens, at, 'number') && matchTokens(tokens, at + 1, '-') && matchTokens(tokens, at + 2, 'number')) {
                prettified_value += (tokens[at][0] < 10 ? tokens[at][0] === 0 && conf.one_zero_if_hour_zero ? '' : '0' : '') + tokens[at][0].toString();
                prettified_value += ':00-' + (tokens[at + 2][0] < 10 ? '0' : '') + tokens[at + 2][0].toString() + ':00';
                at += 2;
            } else if (matchTokens(tokens, at, 'comment')) prettified_value += '"' + tokens[at][0].toString() + '"';
            else if (matchTokens(tokens, at, 'closed')) prettified_value += conf.leave_off_closed ? tokens[at][0] : conf.keyword_for_off_closed;
            else if (at - selector_start > 0 && matchTokens(tokens, at, 'number') && (selector_type === 'month' || selector_type === 'week')) prettified_value += (matchTokens(tokens, at - 1, 'month') || matchTokens(tokens, at - 1, 'week') ? ' ' : '') + (conf.zero_pad_month_and_week_numbers && tokens[at][4] !== 'positive_number' && tokens[at][0] < 10 ? '0' : '') + tokens[at][0];
            else if (at - selector_start > 0 && matchTokens(tokens, at, 'month') && matchTokens(tokens, at - 1, 'year')) prettified_value += ' ' + months[[
                tokens[at][0]
            ]];
            else if (at - selector_start > 0 && matchTokens(tokens, at, 'event') && matchTokens(tokens, at - 1, 'year')) prettified_value += ' ' + tokens[at][0];
            else if (matchTokens(tokens, at, 'month')) {
                prettified_value += months[[
                    tokens[at][0]
                ]];
                if (at + 1 <= selector_end && matchTokens(tokens, at + 1, 'weekday')) prettified_value += ' ';
            } else if (at + 2 <= selector_end && (matchTokens(tokens, at, '-') || matchTokens(tokens, at, '+')) && matchTokens(tokens, at + 1, 'number', 'calcday')) {
                prettified_value += ' ' + tokens[at][0] + tokens[at + 1][0] + ' day' + (Math.abs(tokens[at + 1][0]) === 1 ? '' : 's');
                at += 2;
            } else if (at === selector_end && selector_type === 'weekday' && tokens[at][0] === ':') ;
            else if (at === selector_end && selector_type === 'time' && tokens[at][0] === ',') ;
            else prettified_value += tokens[at][0].toString();
            at++;
        }
        return prettified_value;
    }
    /* }}} */ //======================================================================
    // Public interface {{{
    // All functions below are considered public.
    //======================================================================
    // Simple API {{{
    this.getState = function(date) {
        const it = this.getIterator(date);
        return it.getState();
    };
    this.getUnknown = function(date) {
        const it = this.getIterator(date);
        return it.getUnknown();
    };
    this.getStateString = function(date, past) {
        const it = this.getIterator(date);
        return it.getStateString(past);
    };
    this.getComment = function(date) {
        const it = this.getIterator(date);
        return it.getComment();
    };
    this.getMatchingRule = function(date) {
        const it = this.getIterator(date);
        return it.getMatchingRule();
    };
    /* Not available for iterator API {{{ */ /* getWarnings: Get warnings, empty list if none {{{ */ this.getWarnings = function() {
        const it = this.getIterator();
        return getWarnings(it);
    };
    /* }}} */ /* prettifyValue: Get a nicely formated value {{{ */ this.prettifyValue = function(argument_hash) {
        this.getWarnings();
        /* getWarnings has to be run before prettifyValue because some
         * decisions if certain aspects makes sense to prettify or not
         * are influenced by warnings.
         * Basically, both functions depend on each other in some way :(
         * See done_with_selector_reordering.
         */ return prettifyValue(argument_hash);
    };
    /* }}} */ /* getNextChange: Get time of next status change {{{ */ this.getNextChange = function(date, maxdate) {
        const it = this.getIterator(date);
        if (!it.advance(maxdate)) return undefined;
        return it.getDate();
    };
    /* }}} */ /* isWeekStable: Checks whether open intervals are same for every week. {{{ */ this.isWeekStable = function() {
        return week_stable;
    };
    /* }}} */ /* isEqualTo: Check if this opening_hours object has the same meaning as the given opening_hours object. {{{ */ this.isEqualTo = function(second_oh_object, start_date) {
        if (typeof start_date === 'undefined') start_date = new Date();
        let datelimit;
        if (this.isWeekStable() && second_oh_object.isWeekStable()) datelimit = new Date(start_date.getTime() + msec_in_day * 10);
        else datelimit = new Date(start_date.getTime() + msec_in_day * 1830);
        const first_it = this.getIterator(start_date);
        const second_it = second_oh_object.getIterator(start_date);
        while(first_it.advance(datelimit)){
            second_it.advance(datelimit);
            const not_equal = [];
            if (first_it.getDate().getTime() !== second_it.getDate().getTime()) not_equal.push('getDate');
            if (first_it.getState() !== second_it.getState()) not_equal.push('getState');
            if (first_it.getUnknown() !== second_it.getUnknown()) not_equal.push('getUnknown');
            if (first_it.getComment() !== second_it.getComment()) not_equal.push('getComment');
            if (not_equal.length) {
                const deviation_for_time = {};
                deviation_for_time[first_it.getDate().getTime()] = not_equal;
                return [
                    false,
                    {
                        'matching_rule': first_it.getMatchingRule(),
                        'matching_rule_other': second_it.getMatchingRule(),
                        'deviation_for_time': deviation_for_time
                    }
                ];
            }
        }
        return [
            true
        ];
    };
    /* }}} */ /* }}} */ /* }}} */ // High-level API {{{
    /* getOpenIntervals: Get array of open intervals between two dates {{{ */ this.getOpenIntervals = function(from, to) {
        const res = [];
        const it = this.getIterator(from);
        if (it.getState() || it.getUnknown()) res.push([
            from,
            undefined,
            it.getUnknown(),
            it.getComment()
        ]);
        while(it.advance(to)){
            if (it.getState() || it.getUnknown()) {
                if (res.length !== 0 && typeof res[res.length - 1][1] === 'undefined') // last state was also open or unknown
                res[res.length - 1][1] = it.getDate();
                res.push([
                    it.getDate(),
                    undefined,
                    it.getUnknown(),
                    it.getComment()
                ]);
            } else if (res.length !== 0 && typeof res[res.length - 1][1] === 'undefined') // only use the first time as closing/change time and ignore closing times which might follow
            res[res.length - 1][1] = it.getDate();
        }
        if (res.length > 0 && typeof res[res.length - 1][1] === 'undefined') res[res.length - 1][1] = to;
        return res;
    };
    /* }}} */ /* getOpenDuration: Get total number of milliseconds a facility is open,unknown within a given date range {{{ */ this.getOpenDuration = function(from, to) {
        let open = 0;
        let unknown = 0;
        const it = this.getIterator(from);
        let prevdate = it.getState() || it.getUnknown() ? from : undefined;
        let prevstate = it.getState();
        let prevunknown = it.getUnknown();
        while(it.advance(to)){
            if (it.getState() || it.getUnknown()) {
                if (typeof prevdate === 'object') {
                    // last state was also open or unknown
                    if (prevunknown) unknown += it.getDate().getTime() - prevdate.getTime();
                    else if (prevstate) open += it.getDate().getTime() - prevdate.getTime();
                }
                prevdate = it.getDate();
                prevstate = it.getState();
                prevunknown = it.getUnknown();
            // console.log('if', prevdate, open / (1000 * 60 * 60), unknown / (1000 * 60 * 60));
            } else // console.log('else', prevdate);
            if (typeof prevdate === 'object') {
                if (prevunknown) unknown += it.getDate().getTime() - prevdate.getTime();
                else open += it.getDate().getTime() - prevdate.getTime();
                prevdate = undefined;
            }
        }
        if (typeof prevdate === 'object') {
            if (prevunknown) unknown += to.getTime() - prevdate.getTime();
            else open += to.getTime() - prevdate.getTime();
        }
        return [
            open,
            unknown
        ];
    };
    /* }}} */ /* }}} */ // Iterator API {{{
    this.getIterator = function(date) {
        return new function(oh) {
            if (typeof date === 'undefined') date = new Date();
            let prevstate = [
                undefined,
                date,
                undefined,
                undefined,
                undefined
            ];
            let state = oh.getStatePair(date);
            /* getDate {{{ */ this.getDate = function() {
                return prevstate[1];
            };
            /* }}} */ /* setDate {{{ */ this.setDate = function(date) {
                if (typeof date !== 'object') throw t('date parameter needed');
                prevstate = [
                    undefined,
                    date,
                    undefined,
                    undefined,
                    undefined
                ];
                state = oh.getStatePair(date);
            };
            /* }}} */ /* getState: Check whether facility is `open' {{{ */ this.getState = function() {
                return state[0];
            };
            /* }}} */ /* getUnknown: Checks whether the opening state is conditional or unknown {{{ */ this.getUnknown = function() {
                return state[2];
            };
            /* }}} */ /* getStateString: Get state string. Either 'open', 'unknown' or 'closed' {{{ */ this.getStateString = function(past) {
                return state[0] ? 'open' : state[2] ? 'unknown' : past ? 'closed' : 'close';
            };
            /* }}} */ /* getComment: Get the comment, undefined in none {{{ */ this.getComment = function() {
                return state[3];
            };
            /* }}} */ /* getMatchingRule: Get the rule which matched thus deterrents the current state {{{ */ this.getMatchingRule = function() {
                if (typeof state[4] === 'undefined') return undefined;
                return rules[state[4]].build_from_token_rule[2];
            };
            /* }}} */ /* advance: Advances to the next position {{{ */ this.advance = function(datelimit) {
                if (typeof datelimit === 'undefined') datelimit = new Date(prevstate[1].getTime() + msec_in_day * 1830);
                else if (datelimit.getTime() <= prevstate[1].getTime()) return false; /* The limit for advance needs to be after the current time. */ 
                do {
                    if (typeof state[1] === 'undefined') return false; /* open range, we won't be able to advance */ 
                    // console.log('\n' + 'previous check time:', prevstate[1]
                    //     + ', current check time:',
                    //     state[1],
                    //     (state[0] ? 'open' : (state[2] ? 'unknown' : 'closed'))
                    //     + ', comment:', state[3]
                    //     + ', match_rule:', state[4]);
                    if (state[1].getTime() <= prevstate[1].getTime()) /* We're going backwards or staying at the same time.
                         * This most likely indicates an error in a selector code.
                         */ throw 'Fatal: infinite loop in nextChange';
                    if (state[1].getTime() >= datelimit.getTime()) /* Don't advance beyond limits. */ return false;
                    // do advance
                    prevstate = state;
                    state = oh.getStatePair(prevstate[1]);
                // console.log(state);
                }while (state[0] === prevstate[0] && state[2] === prevstate[2] && state[3] === prevstate[3]);
                return true;
            };
        /* }}} */ }(this);
    };
/* }}} */ /* }}} */ }



const $b400f3e24794b0f3$var$currentDate = new Date();
const $b400f3e24794b0f3$var$today = new Date();
$b400f3e24794b0f3$var$today.setHours(0, 0, 0, 0);
const $b400f3e24794b0f3$var$weekDay = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $b400f3e24794b0f3$var$monthSelector = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
class $b400f3e24794b0f3$export$2e2bcd8739ae039 {
    constructor(text, locale = 'fr'){
        try {
            this.opening_hours = new (0, $0e3b0f6e50344df5$export$2e2bcd8739ae039)(text, {
                address: {
                    country_code: locale
                }
            });
        } catch (error) {
            console.warn("Invalid input for opening hours");
            this.opening_hours = undefined;
        }
    }
    getState() {
        return this.opening_hours.getState();
    }
    getNextChange() {
        const nextchange = this.opening_hours.getNextChange($b400f3e24794b0f3$var$currentDate);
        if (nextchange) {
            const closingAt = new Date(nextchange);
            const closingAtMins = `0${closingAt.getMinutes()}`.slice(-2);
            return `${closingAt.getHours()}:${closingAtMins}`;
        } else return '';
    }
    getNextChangeDay() {
        const nextchange = this.opening_hours.getNextChange($b400f3e24794b0f3$var$currentDate);
        if (nextchange) {
            const dayNumber = new Date(nextchange).getDay();
            const timeToOpen = new Date(nextchange).getHours() - $b400f3e24794b0f3$var$currentDate.getHours();
            return this.isTomorrow(nextchange) ? (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.tomorrow : timeToOpen < 12 && this.isToday(nextchange) ? '' : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor[$b400f3e24794b0f3$var$weekDay[dayNumber]];
        } else return '';
    }
    getNextSlot(threshold) {
        const from = $b400f3e24794b0f3$var$today;
        const to = new Date(new Date().setDate(new Date().getDate() + threshold));
        const intervals = this.opening_hours.getOpenIntervals(from, to);
        const arrDays = [];
        const regexDays = /0[1-9]|[12]\d|3[01]/;
        for(const count in intervals){
            const start = intervals[count][0];
            const end = intervals[count][1];
            const iterator = this.opening_hours.getIterator(start);
            const matchingRule = this.opening_hours.prettifyValue({
                rule_index: iterator.getMatchingRule()
            });
            const appliedRule = iterator.getMatchingRule() ? matchingRule.split(' ', 2) : null;
            let isSpecial = false;
            for(let index = 0; index < $b400f3e24794b0f3$var$monthSelector.length; index++){
                const element = $b400f3e24794b0f3$var$monthSelector[index];
                if (appliedRule && appliedRule.length > 0) {
                    const dayFound = appliedRule[1].match(regexDays);
                    if (appliedRule[0].includes(element) && dayFound && dayFound.length > 0) {
                        isSpecial = true;
                        break;
                    }
                }
            }
            const day = $b400f3e24794b0f3$var$weekDay[new Date(start).getDay()];
            const startHours = start.getHours();
            const startMins = `0${start.getMinutes()}`.slice(-2);
            const endHours = end.getHours();
            const endMins = `0${end.getMinutes()}`.slice(-2);
            const OSMInterval = {
                day: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor[day],
                opensAt: `${startHours}:${startMins}`,
                closesAt: `${endHours}:${endMins}`,
                isSpecial: isSpecial,
                slots: []
            };
            arrDays.push(OSMInterval);
        }
        const results = this.groupTimeSlotsDaywise(arrDays);
        if (results.length > 0) {
            const firstDay = results[0].day;
            const lastDay = results[results.length - 1].day;
            if (firstDay === lastDay) results.pop();
        }
        return results;
    }
    groupTimeSlotsDaywise(slots) {
        const slotsByDays = [];
        let prevSlotsByDay = {
            day: null,
            slots: []
        };
        slots.forEach((slot)=>{
            if (prevSlotsByDay.day !== slot.day) {
                prevSlotsByDay = {
                    day: slot.day,
                    slots: [],
                    isSpecial: slot.isSpecial
                };
                slotsByDays.push(prevSlotsByDay);
            }
            prevSlotsByDay.slots.push({
                time: `${slot.opensAt} - ${slot.closesAt}`,
                isSpecial: slot.isSpecial
            });
        });
        return slotsByDays;
    }
    isTomorrow(date) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return date.getDate() === tomorrow.getDate() && date.getMonth() === tomorrow.getMonth() && date.getFullYear() === tomorrow.getFullYear();
    }
    isToday(date) {
        const today = new Date();
        return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    }
}


const $3b06b60897362d69$export$ada873a34909da65 = {
    SELECT_POI: 'POI_SELECTED',
    PHONE_CLICK: 'PHONE_CLICKED',
    WEBSITE_CLICK: 'WEBSITE_CLICKED',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
    SEARCH_RESULT_SELECTED: 'SEARCH_RESULT_ITEM_SELECTED',
    SELECT_DIRECTION: 'FIND_ROUTE',
    NAVIGATION_CLICK: 'NAVIGATION_STARTED',
    ITINERARY_MODE_EXITED: 'ITINERARY_MODE_EXITED'
};





class $06e0e2cab4efe59c$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    constructor(props){
        super(), this._inflightRouteSignature = null, this.waypointsMarkers = [], this.startY = 0, this.routeBuilderWarning = "", this.onHideWarningBanner = ()=>{
            this.routeBuilderWarning = "";
            this.setState({
                showRouteBuilderWarning: false
            });
        }, this.onTouchStart = (e)=>{
            e.stopPropagation();
            const content = this.panelRef?.querySelector(".route-panel__content");
            if (content && content.scrollTop > 0) return;
            this.startY = e.touches[0].clientY;
            this.setState({
                isDragging: true
            });
        }, this.onTouchMove = (e)=>{
            e.stopPropagation();
            if (!this.panelRef || !this.state.isDragging) return;
            e.preventDefault();
            const currentY = e.touches[0].clientY;
            const deltaY = Math.max(0, currentY - this.startY);
            this.panelRef.style.transform = `translateY(${deltaY}px)`;
        }, this.onTouchEnd = (e)=>{
            e.stopPropagation();
            if (!this.panelRef) return;
            const endY = e.changedTouches[0].clientY;
            const deltaY = endY - this.startY;
            this.panelRef.style.transform = "";
            this.setState({
                isDragging: false
            });
            if (deltaY > 120) this.setState({
                showRouteBuilderSummary: true
            }); // collapse
            else this.setState({
                showRouteBuilderSummary: false
            }); // expand
        }, this.toggleShop = (shop)=>{
            this.setState((prev)=>{
                const exists = prev.selectedWaypoints.some((f)=>f.id === shop.id);
                if (exists) return {
                    selectedWaypoints: prev.selectedWaypoints.filter((f)=>f.id !== shop.id)
                };
                // Calculate total stops INCLUDING origin and destination
                const currentTotal = prev.selectedWaypoints.length + (prev.selectedOrigin ? 1 : 0) + (prev.selectedDestination ? 1 : 0);
                if (currentTotal >= (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) {
                    this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.max_stop_limit_warning || `Max stop limit exceeded`;
                    this.setState({
                        showRouteBuilderWarning: true
                    });
                    setTimeout(()=>{
                        this.onHideWarningBanner();
                    }, 3000);
                    return null;
                }
                return {
                    selectedWaypoints: [
                        ...prev.selectedWaypoints,
                        shop
                    ]
                };
            });
        }, this.setFavShopAsOrigin = (shop)=>{
            const { selectedOrigin: selectedOrigin, selectedWaypoints: selectedWaypoints, selectedDestination: selectedDestination } = this.state;
            // Check if shop is already part of the route
            const isShopInWaypoints = selectedWaypoints.some((wp)=>wp.id === shop.id);
            const isShopOrigin = selectedOrigin?.id === shop.id;
            const isShopDestination = selectedDestination?.id === shop.id;
            const isShopAlreadyInRoute = isShopInWaypoints || isShopOrigin || isShopDestination;
            // If shop is not already in route, check if adding it would exceed limit
            if (!isShopAlreadyInRoute) {
                const currentTotal = selectedWaypoints.length + (selectedOrigin ? 1 : 0) + (selectedDestination ? 1 : 0);
                if (currentTotal >= (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) {
                    this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.max_stop_limit_warning || `Max stop limit exceeded`;
                    this.setState({
                        showRouteBuilderWarning: true
                    });
                    setTimeout(()=>this.onHideWarningBanner(), 3000);
                    return;
                }
            }
            // If shop is currently the destination, clear it
            const newDestination = isShopDestination ? undefined : selectedDestination;
            // Remove shop from waypoints if present
            let newWaypoints = selectedWaypoints.filter((wp)=>wp.id !== shop.id);
            // Add old origin back to waypoints if it exists and is different
            if (selectedOrigin && selectedOrigin.id !== shop.id) newWaypoints = [
                ...newWaypoints,
                selectedOrigin
            ];
            this.setState({
                selectedOrigin: shop,
                selectedDestination: newDestination,
                selectedWaypoints: newWaypoints
            });
        }, this.setFavShopAsDestination = (shop)=>{
            const { selectedDestination: selectedDestination, selectedWaypoints: selectedWaypoints, selectedOrigin: selectedOrigin, selectedExitGate: selectedExitGate } = this.state;
            // Check if shop is already part of the route
            const isShopInWaypoints = selectedWaypoints.some((wp)=>wp.id === shop.id);
            const isShopOrigin = selectedOrigin?.id === shop.id;
            const isShopDestination = selectedDestination?.id === shop.id;
            const isShopAlreadyInRoute = isShopInWaypoints || isShopOrigin || isShopDestination;
            // If shop is not already in route, check if adding it would exceed limit
            if (!isShopAlreadyInRoute) {
                const currentTotal = selectedWaypoints.length + (selectedOrigin ? 1 : 0) + (selectedDestination ? 1 : 0);
                if (currentTotal >= (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) {
                    this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.max_stop_limit_warning || `Max stop limit exceeded`;
                    this.setState({
                        showRouteBuilderWarning: true
                    });
                    setTimeout(()=>this.onHideWarningBanner(), 3000);
                    return;
                }
            }
            // If shop is currently the origin, clear it
            const newOrigin = isShopOrigin ? undefined : selectedOrigin;
            // Remove shop from waypoints if present
            let newWaypoints = selectedWaypoints.filter((wp)=>wp.id !== shop.id);
            // Add old destination back to waypoints if it exists, is different, and is not an exit gate
            const isOldDestinationExitGate = selectedExitGate && selectedDestination?.id === selectedExitGate.id;
            if (selectedDestination && selectedDestination.id !== shop.id && !isOldDestinationExitGate) newWaypoints = [
                ...newWaypoints,
                selectedDestination
            ];
            this.setState({
                selectedDestination: shop,
                selectedOrigin: newOrigin,
                selectedExitGate: undefined,
                selectedWaypoints: newWaypoints
            }, ()=>this.scrollToLastRouteElement());
        }, this.prepareShopsToVisitForRouteBuilding = (shops)=>{
            const { widgetMapMode: widgetMapMode, mode: mode } = this.state;
            const filterShopsByStatus = shops?.features.filter((feature)=>feature.properties["visit_status"] === "tovisit");
            if (filterShopsByStatus && filterShopsByStatus.length > 0) this.shopsToVisit = {
                type: "FeatureCollection",
                features: filterShopsByStatus
            };
            else this.shopsToVisit = undefined;
            if (widgetMapMode === "favorites" && this.shopsToVisit) {
                const shopsCount = this.shopsToVisit.features.length;
                if (shopsCount < 3) ;
                else if (shopsCount <= (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) // All shops can be added as waypoints & pre-selected also, if they are less than 15
                this.setState({
                    selectedWaypoints: this.shopsToVisit.features,
                    selectAllFavorites: true
                });
                else if (shopsCount > 2) // More than 2 shops: add all as waypoints (will be optimized) but do not pre-select, let user choose.
                this.setState({
                    selectAllFavorites: false
                });
            //ONE MORE CONDITION if shops <= 2
            // TO DO:
            // If exactly 1 or 2 shops: don't auto-add as waypoints
            // User will set them as origin/destination manually
            }
        };
        this.state = {
            value: "",
            isNavigationMode: false,
            searchedFeatures: [],
            searchedDestinations: [],
            searchedOrigins: [],
            allFeatures: [],
            allFeaturesLoaded: false,
            mode: "default",
            activeTab: "level",
            showPanel: false,
            showItineraryResults: false,
            routeErrorMessage: "",
            stepSelected: "",
            directionsResult: undefined,
            isLoading: false,
            levelClicked: {},
            userLocation: undefined,
            selectedFeature: undefined,
            selectedDestination: undefined,
            selectedOrigin: undefined,
            wheelChairEnabled: false,
            openingHoursClicked: false,
            selectedStop: undefined,
            searchedStops: [],
            showRouteBuilderSummary: false,
            selectedWaypoints: [],
            removingWaypointId: null,
            showExitGates: false,
            selectedExitGate: undefined,
            allExitGatesLoaded: false,
            allExitGates: [],
            isBuildingRoute: false,
            routeBuilderView: "default",
            isDragging: false,
            showRouteBuilderWarning: false,
            widgetMapMode: "general",
            selectAllFavorites: false,
            shopsMarkedForVisit: undefined,
            isUserUnauthorized: false,
            staticToastDismissed: false,
            routeBuilderToastDismissed: false,
            itinerarySource: ""
        };
        this.indoorService = new window.woosmap.map.IndoorService();
        this.controller = props.controller;
        this.map = props.controller._renderer.map;
        this.panelHeight = 0;
        this.panelWidth = 0;
        this.renderHeader = this.renderHeader.bind(this);
        this.renderPanelContent = this.renderPanelContent.bind(this);
        this.renderLevel = this.renderLevel.bind(this);
        this.renderMall = this.renderMall.bind(this);
        this.renderItinerary = this.renderItinerary.bind(this);
        this.renderRouteBuilder = this.renderRouteBuilder.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.swapOriginAndDestination = this.swapOriginAndDestination.bind(this);
        this.findRoute = this.findRoute.bind(this);
        this.showRouteBuilder = this.showRouteBuilder.bind(this);
        this.groupInstructionsByLevel = this.groupInstructionsByLevel.bind(this);
        this.highlightStep = this.highlightStep.bind(this);
        this.onDisabilitySwitchChange = this.onDisabilitySwitchChange.bind(this);
        this.launchNavigation = this.launchNavigation.bind(this);
        this.onAutoCompleteClose = this.onAutoCompleteClose.bind(this);
        this.onExitGateOpted = this.onExitGateOpted.bind(this);
        this.onExitGateSelected = this.onExitGateSelected.bind(this);
        this.onBuildRouteWithWaypoints = this.onBuildRouteWithWaypoints.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onHideWarningBanner = this.onHideWarningBanner.bind(this);
        this.cancelRouteBuilding = this.cancelRouteBuilding.bind(this);
        this.editStops = this.editStops.bind(this);
        this.controller._renderer.addListener("indoor_feature_selected", this.selectFeature.bind(this));
        this.controller._renderer.addListener("indoor_user_location", this.setUserLocation.bind(this));
        this.controller.addListener("indoor_stop_navigation", ()=>{
            this.setState({
                isNavigationMode: false
            });
        });
        this.controller.addListener("widget_open_itinerary_panel", (origin, destination, source)=>{
            this.showItineraryPanel(origin, destination, source);
        });
        this.controller.addListener("indoor_widget_map_changed", (mapmode, shops, isUnauthorized)=>{
            const { isNavigationMode: isNavigationMode, mode: mode } = this.state;
            if (!isNavigationMode) this.cancelRouteBuilding();
            const filterShopsByStatus = shops?.features.filter((feature)=>feature.properties["visit_status"] === "tovisit");
            if (filterShopsByStatus && filterShopsByStatus.length > 0) this.shopsToVisit = {
                type: "FeatureCollection",
                features: filterShopsByStatus
            };
            else this.shopsToVisit = undefined;
            if (mode === "waypoints") this.setState({
                shopsMarkedForVisit: shops
            });
            this.setState({
                widgetMapMode: mapmode,
                selectedOrigin: undefined,
                selectedDestination: undefined,
                selectedFeature: undefined,
                isUserUnauthorized: !!isUnauthorized,
                staticToastDismissed: false
            });
        });
    }
    componentDidUpdate(_prevProps, prevState) {
        const { selectedFeature: selectedFeature, selectedOrigin: selectedOrigin } = this.state;
        const { mode: mode, allFeaturesLoaded: allFeaturesLoaded, showPanel: showPanel, wheelChairEnabled: wheelChairEnabled, allExitGatesLoaded: allExitGatesLoaded, widgetMapMode: widgetMapMode, shopsMarkedForVisit: shopsMarkedForVisit, selectedWaypoints: selectedWaypoints } = this.state;
        if (prevState.selectedFeature !== selectedFeature && prevState.selectedFeature !== undefined && mode !== "itinerary") this.setState({
            directionsResult: undefined,
            stepSelected: "",
            routeErrorMessage: "",
            mode: "default"
        });
        const panels = document.getElementsByClassName("woosmap-indoor-panel");
        const panel = panels.length > 0 ? document.getElementsByClassName("woosmap-indoor-panel")[0] : null;
        if (panel && showPanel && panel.classList.contains("hide")) {
            panel.classList.remove("hide");
            panel.classList.add("show");
        } else if (panel && !showPanel && panel.classList.contains("show")) {
            panel.classList.remove("show");
            panel.classList.add("hide");
        }
        if (!allFeaturesLoaded && mode === "level" && prevState.mode !== mode) this.loadAllFeatures();
        if (mode === "itinerary" && prevState.mode !== mode) this.findRoute();
        if (mode === "itinerary" && prevState.wheelChairEnabled !== wheelChairEnabled) {
            if (wheelChairEnabled) this.controller.setDirectionsMode("wheelchair");
            else this.controller.setDirectionsMode("");
            this.findRoute();
        }
        if (mode === "itinerary" && (prevState.selectedFeature !== selectedFeature || prevState.selectedOrigin !== selectedOrigin)) this.findRoute();
        if (!allExitGatesLoaded && mode === "waypoints" && prevState.mode !== mode) this.loadExitGates();
        if (mode === "waypoints" && prevState.mode !== mode && shopsMarkedForVisit === undefined) this.setState({
            shopsMarkedForVisit: this.shopsToVisit
        });
        if (widgetMapMode === "favorites" && mode === "waypoints" && prevState.shopsMarkedForVisit?.features.length !== shopsMarkedForVisit?.features.length) {
            if (this.shopsToVisit) this.prepareShopsToVisitForRouteBuilding(this.shopsToVisit);
        }
        if (mode === "waypoints" && prevState.selectedWaypoints?.length !== selectedWaypoints?.length) this.controller.setSelectedWaypoints(selectedWaypoints);
    }
    componentDidMount() {
        const headerContent = document.getElementsByClassName("woosmap-panel__content__header")[0];
        const bodyContent = document.getElementsByClassName("woosmap-panel__content__body")[0];
        const searchBarContainer = document.getElementsByClassName("woosmap-panel__header")[0];
        if (searchBarContainer && headerContent && bodyContent) {
            // eslint-disable-next-line max-len
            this.panelHeight = headerContent.clientHeight + bodyContent.clientHeight + searchBarContainer.clientHeight;
            this.panelWidth = searchBarContainer.clientWidth;
        }
    }
    selectFeature(selectedFeature) {
        const { isNavigationMode: isNavigationMode, mode: mode } = this.state;
        if (!isNavigationMode && mode !== "itinerary") this.setState({
            selectedFeature: selectedFeature,
            selectedDestination: selectedFeature,
            showPanel: !!selectedFeature
        });
    }
    setUserLocation() {
        const userLocation = this.controller._renderer.getUserLocation();
        const { selectedOrigin: selectedOrigin } = this.state;
        if (!userLocation) return;
        const updatedOrigin = {
            type: "Feature",
            id: -1,
            geometry: {
                type: "Point",
                coordinates: [
                    userLocation.position.lng,
                    userLocation.position.lat
                ]
            },
            properties: {
                level: userLocation.level.toString(),
                name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Your Location"],
                pk: "-1"
            }
        };
        if (selectedOrigin) {
            if (selectedOrigin.id && parseInt(String(selectedOrigin.id)) < 0) this.setState({
                selectedOrigin: updatedOrigin
            });
        } else this.setState({
            selectedOrigin: updatedOrigin
        });
        this.setState({
            userLocation: updatedOrigin
        });
    }
    loadAllFeatures() {
        const venue = this.controller._renderer.getVenue();
        this.setState({
            allFeaturesLoaded: false
        });
        const callback = (featuresCollection)=>{
            this.setState({
                allFeatures: featuresCollection.features,
                allFeaturesLoaded: true
            });
        };
        if (venue) this.indoorService.search(venue.venue_id, "", callback, undefined, undefined, this.controller.getBaseFilter());
    }
    loadExitGates() {
        const venue = this.controller._renderer.getVenue();
        this.setState({
            allExitGatesLoaded: false
        });
        const callback = (featuresCollection)=>{
            this.setState({
                allExitGates: featuresCollection.features,
                allExitGatesLoaded: true
            });
        };
        if (venue) this.indoorService.search(venue.venue_id, "", callback, undefined, undefined, "multi_nav_exit:=yes");
    }
    autocomplete(stateKey, stateTextKey, value) {
        return new Promise((resolve)=>{
            const venue = this.controller._renderer.getVenue();
            let result;
            if (venue && this.state[stateTextKey] !== value) {
                const userLocation = this.controller._renderer.getUserLocation();
                const fromLocation = userLocation && this.controller.getAutocompleteWithDistance() ? `${userLocation.position.lat},${userLocation.position.lng},${userLocation.level}` : null;
                const queryParams = {
                    fromLocation: userLocation ? {
                        position: userLocation.position,
                        level: userLocation.level
                    } : null,
                    filter: this.controller.getBaseFilter()
                };
                const maxResponses = this.controller.getAutocompleteMaxResponses();
                const callback = (results)=>{
                    const newState = {};
                    newState[stateKey] = results.predictions ? results.predictions : [];
                    newState[stateTextKey] = value;
                    this.setState(newState);
                    const { userLocation: userLocation } = this.state;
                    if (userLocation) {
                        const user = {
                            id: -1,
                            name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Your Location"],
                            level: parseInt(userLocation.properties["level"]),
                            building: undefined,
                            ref: undefined,
                            distance: undefined
                        };
                        results.predictions.unshift(user);
                    }
                    result = this.autocompleteItems(results.predictions);
                    resolve(result);
                    if (value.length > 0) /**
             * This event is fired when the user performs any widget specific activities.
             * @event IndoorWidget#indoor_widget_analytics
             * @property {string} event AUTOCOMPLETE.
             * @property {*} args The search query & the list of predictions.
             */ this.controller.trigger(this, "indoor_widget_analytics", [
                        {
                            event: (0, $3b06b60897362d69$export$ada873a34909da65).AUTOCOMPLETE,
                            args: {
                                query: value,
                                queryParams: queryParams,
                                results: result
                            }
                        }
                    ]);
                };
                const filter = stateKey === "searchedOrigins" ? null : this.controller.getBaseFilter();
                this.indoorService.autocomplete(venue.venue_id, value, callback, undefined, undefined, fromLocation, filter, maxResponses);
            }
        });
    }
    onAutoCompleteClose(stateKey) {
        const newState = {};
        newState[stateKey] = undefined;
        this.setState(newState);
    }
    autocompleteItems(results) {
        return results.map((poi)=>{
            const venue = this.controller._renderer.getVenue();
            let building = [];
            if (venue && venue.buildings && venue.buildings.length > 0) building = venue.buildings.filter((current)=>current.ref === poi.building);
            let buildingName = null;
            if (building && building.length > 0) {
                const localizedName = building[0]["localized_name"];
                if (localizedName && localizedName[(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()]) buildingName = localizedName[(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()];
                else buildingName = building[0].name;
            }
            return {
                id: poi.id || 0,
                name: poi[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] ? poi[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] : poi["name"],
                level: poi.level.toString(),
                distance: poi["distance"],
                building: buildingName,
                ref: poi["ref"]
            };
        });
    }
    swapOriginAndDestination() {
        const { selectedOrigin: selectedOrigin, selectedDestination: selectedDestination } = this.state;
        if (selectedOrigin && selectedDestination) this.setState({
            selectedOrigin: selectedDestination,
            selectedDestination: selectedOrigin
        }, this.findRoute);
    }
    findRoute() {
        const { selectedOrigin: selectedOrigin, selectedDestination: selectedDestination, selectedWaypoints: selectedWaypoints } = this.state;
        const venue = this.controller._renderer.getVenue();
        if (venue && selectedOrigin && selectedDestination && selectedOrigin.id !== selectedDestination.id) {
            this.controller._renderer.highlightStep(null);
            this.controller.setSelectedDestination(selectedDestination);
            this.setState({
                stepSelected: "",
                isLoading: true
            });
            let origin;
            let originLevel;
            let originId = selectedOrigin.id;
            if (selectedOrigin.id === -1 || selectedOrigin.id === 0) {
                originId = null;
                const centrePointOrigin = (0, $20c1bb73c4d4ca81$export$2e2bcd8739ae039)(selectedOrigin);
                origin = new woosmap.map.LatLng(centrePointOrigin.geometry.coordinates[1], centrePointOrigin.geometry.coordinates[0]);
                originLevel = parseInt(selectedOrigin.properties["level"]);
            }
            let destination;
            let destinationLevel;
            let destinationId = selectedDestination.id;
            if (destinationId && destinationId === -1 || destinationId === 0) {
                destinationId = null;
                const centrePointDestination = (0, $20c1bb73c4d4ca81$export$2e2bcd8739ae039)(selectedDestination);
                destination = new woosmap.map.LatLng(centrePointDestination.geometry.coordinates[1], centrePointDestination.geometry.coordinates[0]);
                destinationLevel = parseInt(selectedDestination.properties["level"]);
            }
            let requestParams = {
                venueId: venue.venue_id,
                origin: origin,
                originLevel: originLevel,
                originId: originId,
                destination: destination,
                destinationLevel: destinationLevel,
                destinationId: destinationId,
                language: (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase(),
                units: this.controller.getUnits(),
                mode: this.controller.getDirectionsMode(),
                avoid: this.controller.getZonesToAvoid()
            };
            let selectedStopsOnRoute = "";
            if (selectedWaypoints && selectedWaypoints.length > 0) selectedWaypoints.map((stop)=>{
                if (stop.id && stop.id !== -1 && stop.id !== 0) selectedStopsOnRoute = selectedStopsOnRoute.concat(stop.id + "|");
            });
            if (selectedStopsOnRoute.length > 0) requestParams = {
                ...requestParams,
                waypoints: selectedStopsOnRoute.slice(0, -1),
                optimize: true
            };
            // Build a stable signature of this request. If an identical request is
            // already in flight (e.g. componentDidUpdate fires Block 1 and Block 3
            // in the same tick for a list-row itinerary click), skip the duplicate.
            const waypointSig = (selectedWaypoints ?? []).map((w)=>String(w.id)).join("|");
            const signature = JSON.stringify({
                v: requestParams.venueId,
                oId: requestParams.originId,
                o: origin ? [
                    origin.lat(),
                    origin.lng(),
                    originLevel
                ] : null,
                dId: requestParams.destinationId,
                d: destination ? [
                    destination.lat(),
                    destination.lng(),
                    destinationLevel
                ] : null,
                w: waypointSig,
                m: requestParams.mode,
                a: requestParams.avoid
            });
            if (this._inflightRouteSignature === signature) return;
            this._inflightRouteSignature = signature;
            this.indoorService.directions(requestParams, (result)=>{
                if (result) {
                    this._inflightRouteSignature = null;
                    this.setState({
                        directionsResult: result,
                        routeErrorMessage: "",
                        isLoading: false,
                        isBuildingRoute: false
                    });
                    if (selectedWaypoints && selectedWaypoints.length > 0) this.setState({
                        routeBuilderView: "results"
                    });
                    else this.setState({
                        mode: "itinerary"
                    });
                    const padding = this.controller._container ? this.controller._container.clientWidth : 0;
                    this.controller._renderer.setDirections(result, padding);
                    this.addCustomMarkersForWaypoints(result);
                    /**
             * This event is fired when the user performs any widget specific activities.
             * @event IndoorWidget#indoor_widget_analytics
             * @property {string} event FIND_ROUTE.
             * @property {*} args The origin and destination.
             */ this.controller.trigger(this, "indoor_widget_analytics", [
                        {
                            event: (0, $3b06b60897362d69$export$ada873a34909da65).SELECT_DIRECTION,
                            args: {
                                origin: selectedOrigin,
                                destination: selectedDestination,
                                source: this.state.itinerarySource || "main_map"
                            }
                        }
                    ]);
                } else {
                    this._inflightRouteSignature = null;
                    this.setState({
                        routeErrorMessage: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["No route found"]
                        }),
                        directionsResult: undefined,
                        isLoading: false
                    });
                    this.controller._renderer.setDirections(null);
                }
            });
        }
    }
    groupInstructionsByLevel(steps) {
        const instructionsByLevel = [];
        let lastStepsByLevel = {
            level: null
        };
        steps.forEach((step)=>{
            if (lastStepsByLevel.level !== step.properties["level"]) {
                lastStepsByLevel = {
                    level: step.properties["level"],
                    steps: []
                };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    composeLevelTransition(originLevel, destinationLevel) {
        const level = Math.abs(destinationLevel - originLevel);
        let content = level <= 1 ? "level" : "levels";
        content = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor[content];
        const direction = originLevel === destinationLevel ? "" : originLevel > destinationLevel ? (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.down : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.up;
        const floorTransition = {
            level: level,
            content: content,
            direction: direction
        };
        return floorTransition;
    }
    convertDurationToMins(value) {
        const minute = Math.round(value / 60);
        return minute <= 1 ? `${minute} min` : `${minute} mins`;
    }
    highlightStep(step) {
        this.setState({
            stepSelected: step.properties["id"]
        });
        this.controller._renderer.highlightStep(step);
    }
    launchNavigation() {
        const { selectedOrigin: selectedOrigin, selectedDestination: selectedDestination } = this.state;
        /**
     * This event is fired when the user performs any widget specific activities.
     * @event IndoorWidget#indoor_widget_analytics
     * @property {string} event NAVIGATION_CLICK.
     * @property {*} args The origin and destination.
     */ this.controller.trigger(this, "indoor_widget_analytics", [
            {
                event: (0, $3b06b60897362d69$export$ada873a34909da65).NAVIGATION_CLICK,
                args: {
                    origin: selectedOrigin,
                    destination: selectedDestination
                }
            }
        ]);
        this.controller.launchNavigation();
        this.setState({
            isNavigationMode: true
        });
    }
    clearRouteAndItinerary() {
        this.controller._renderer.setDirections(null);
        this.controller._renderer.highlightStep(null);
        this.setState({
            directionsResult: undefined,
            stepSelected: "",
            routeErrorMessage: ""
        });
    }
    toggleSteps(id) {
        const { levelClicked: levelClicked } = this.state;
        levelClicked[id] = levelClicked[id] === false;
        const newLevelClicked = {
            ...levelClicked
        };
        this.setState({
            levelClicked: newLevelClicked
        });
    }
    toggleOpeningHrs() {
        const { openingHoursClicked: openingHoursClicked } = this.state;
        this.setState({
            openingHoursClicked: !openingHoursClicked
        });
    }
    onDisabilitySwitchChange() {
        const { wheelChairEnabled: wheelChairEnabled } = this.state;
        this.setState({
            wheelChairEnabled: !wheelChairEnabled
        });
    }
    onPhoneClicked(phone) {
        window.open(`tel:${phone}`, "_self");
        /**
     * This event is fired when the user performs any widget specific activities.
     * @event IndoorWidget#indoor_widget_analytics
     * @property {string} event PHONE_CLICKED.
     * @property {*} args The phone number of the selected POI.
     */ this.controller.trigger(this, "indoor_widget_analytics", [
            {
                event: (0, $3b06b60897362d69$export$ada873a34909da65).PHONE_CLICK,
                args: phone
            }
        ]);
    }
    onWebsiteClicked(website) {
        /**
     * This event is fired when the user performs any widget specific activities.
     * @event IndoorWidget#indoor_widget_analytics
     * @property {string} event WEBSITE_CLICKED.
     * @property {*} args The website URL of the selected POI.
     */ this.controller.trigger(this, "indoor_widget_analytics", [
            {
                event: (0, $3b06b60897362d69$export$ada873a34909da65).WEBSITE_CLICK,
                args: website
            }
        ]);
    }
    showItineraryPanel(origin, destination, source) {
        let defaultStateParams = {
            mode: "itinerary",
            showPanel: true,
            wheelChairEnabled: this.controller.getDirectionsMode() === "wheelchair"
        };
        let stateParamsToApply = defaultStateParams;
        if (origin) {
            switch(typeof origin){
                case "string":
                    // eslint-disable-next-line no-case-declarations
                    const arrOriginParams = origin.split(",");
                    if (arrOriginParams && arrOriginParams.length > 1) {
                        const originFeature = {
                            type: "Feature",
                            id: 0,
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    parseFloat(arrOriginParams[1]),
                                    parseFloat(arrOriginParams[0])
                                ]
                            },
                            properties: {
                                level: arrOriginParams[2],
                                name: "Custom Location"
                            }
                        };
                        stateParamsToApply = {
                            ...defaultStateParams,
                            selectedOrigin: originFeature
                        };
                    }
                    break;
                case "object":
                    const originObj = origin;
                    if (originObj.type && originObj.type === "Feature" && originObj.geometry) stateParamsToApply = {
                        ...defaultStateParams,
                        selectedOrigin: origin
                    };
                    else {
                        const userLocationAsOrigin = {
                            type: "Feature",
                            id: -1,
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    originObj.position.lng,
                                    originObj.position.lat
                                ]
                            },
                            properties: {
                                level: originObj.level.toString(),
                                name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Your Location"],
                                pk: "-1"
                            }
                        };
                        stateParamsToApply = {
                            ...defaultStateParams,
                            selectedOrigin: userLocationAsOrigin
                        };
                    }
            }
            defaultStateParams = stateParamsToApply;
        } else this.setState({
            selectedOrigin: undefined
        });
        if (destination) switch(typeof destination){
            case "string":
                // eslint-disable-next-line no-case-declarations
                const arrDestinationParams = destination.split(",");
                if (arrDestinationParams && arrDestinationParams.length > 1) {
                    const destFeature = {
                        type: "Feature",
                        id: 0,
                        geometry: {
                            type: "Point",
                            coordinates: [
                                parseFloat(arrDestinationParams[1]),
                                parseFloat(arrDestinationParams[0])
                            ]
                        },
                        properties: {
                            level: arrDestinationParams[2],
                            name: "Custom Location"
                        }
                    };
                    stateParamsToApply = {
                        ...defaultStateParams,
                        selectedDestination: destFeature,
                        selectedFeature: destFeature
                    };
                }
                break;
            case "object":
                const destObj = destination;
                if (destObj.type && destObj.type === "Feature" && destObj.geometry) stateParamsToApply = {
                    ...defaultStateParams,
                    selectedDestination: destination,
                    selectedFeature: destination
                };
                else {
                    const userLocationAsDest = {
                        type: "Feature",
                        id: -1,
                        geometry: {
                            type: "Point",
                            coordinates: [
                                destObj.position.lng,
                                destObj.position.lat
                            ]
                        },
                        properties: {
                            level: destObj.level.toString(),
                            name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Your Location"],
                            pk: "-1"
                        }
                    };
                    stateParamsToApply = {
                        ...defaultStateParams,
                        selectedDestination: userLocationAsDest,
                        selectedFeature: userLocationAsDest
                    };
                }
                break;
        }
        else this.setState({
            selectedDestination: undefined,
            selectedFeature: undefined
        });
        this.setState({
            ...stateParamsToApply,
            itinerarySource: source || "main_map"
        });
    }
    showRouteBuilder() {
        this.setState({
            mode: "waypoints",
            showRouteBuilderSummary: false,
            showPanel: true
        });
    }
    editStops() {
        this.setState({
            mode: "waypoints",
            routeBuilderView: "default",
            showRouteBuilderSummary: false,
            showPanel: true
        });
    }
    handleRemoveWaypoint(stopToRemove) {
        this.setState({
            removingWaypointId: stopToRemove.id
        });
        setTimeout(()=>{
            const { selectedWaypoints: selectedWaypoints } = this.state;
            this.setState({
                selectedWaypoints: selectedWaypoints.filter((stop)=>stop.id !== stopToRemove.id),
                removingWaypointId: null
            });
        }, 250);
    }
    onExitGateOpted() {
        const { showExitGates: showExitGates, selectedWaypoints: selectedWaypoints, selectedDestination: selectedDestination, selectedExitGate: selectedExitGate } = this.state;
        const willShowExitGates = !showExitGates;
        this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.exit_gate_warning;
        if (!willShowExitGates) //Remove exit gate as destination if any
        {
            if (selectedDestination && selectedDestination.properties && selectedDestination.properties["multi_nav_exit"] === "yes") {
                const destinationToSet = selectedWaypoints[selectedWaypoints.length - 1];
                const updatedWaypoints = selectedWaypoints.slice(0, selectedWaypoints.length - 1);
                this.setState({
                    selectedWaypoints: updatedWaypoints,
                    selectedDestination: destinationToSet,
                    selectedFeature: destinationToSet,
                    selectedExitGate: undefined
                });
            }
        }
        this.setState({
            showExitGates: !showExitGates,
            showRouteBuilderWarning: !showExitGates
        });
        setTimeout(()=>{
            this.onHideWarningBanner();
        }, 3000);
    }
    onExitGateSelected(exitGate) {
        const { selectedWaypoints: selectedWaypoints, selectedDestination: selectedDestination, selectedOrigin: selectedOrigin, selectedExitGate: selectedExitGate } = this.state;
        if (selectedExitGate?.id === exitGate.id) {
            this.setState({
                selectedExitGate: undefined,
                selectedDestination: undefined
            });
            return;
        }
        let newWaypoints = selectedWaypoints.filter((stop)=>stop.properties["entrance"] !== "yes");
        const currentTotal = newWaypoints.length + (selectedOrigin ? 1 : 0) + (selectedDestination ? 1 : 0);
        const hasNonExitGateDestination = selectedDestination && selectedDestination.properties["entrance"] !== "yes";
        if (selectedOrigin && selectedOrigin.id === exitGate.id) {
            this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.same_origin_destination_warning || `Origin & Destination cannot be same`;
            this.setState({
                showRouteBuilderWarning: true,
                selectedExitGate: undefined
            });
            setTimeout(()=>this.onHideWarningBanner(), 3000);
            return;
        }
        // If at max limit with a destination set, replace destination with exit gate
        // Old destination gets unselected (not added to waypoints)
        if (currentTotal >= (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED && hasNonExitGateDestination) {
            this.setState({
                selectedExitGate: exitGate,
                selectedWaypoints: newWaypoints,
                selectedDestination: exitGate
            }, ()=>this.scrollToLastRouteElement());
            return;
        }
        // If no destination or destination is already an exit gate, check if we can add
        if (!hasNonExitGateDestination) {
            const totalAfterAdd = newWaypoints.length + (selectedOrigin ? 1 : 0) + 1; // +1 for new destination (exitGate)
            if (totalAfterAdd > (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) {
                this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.max_stop_limit_warning || `Max stop limit exceeded`;
                this.setState({
                    showRouteBuilderWarning: true,
                    selectedExitGate: undefined
                });
                setTimeout(()=>this.onHideWarningBanner(), 3000);
                return;
            }
        } else // Has a non-exit-gate destination and not at max, add it to waypoints
        newWaypoints = [
            ...newWaypoints,
            selectedDestination
        ];
        this.setState({
            selectedExitGate: exitGate,
            selectedWaypoints: newWaypoints,
            selectedDestination: exitGate
        }, ()=>this.scrollToLastRouteElement());
    }
    scrollToLastRouteElement() {
        const container = this.panelRef?.querySelector(".route-panel__content");
        if (container) {
            const lastChild = container.lastElementChild;
            if (lastChild) lastChild.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    }
    stopExistsInRoute(stopToFind) {
        const { selectedWaypoints: selectedWaypoints, selectedOrigin: selectedOrigin, selectedDestination: selectedDestination } = this.state;
        const stopFound = selectedWaypoints.filter((stop)=>stop.id == stopToFind.id);
        if (selectedOrigin && selectedOrigin.id == stopToFind.id) stopFound.push(selectedOrigin);
        if (selectedDestination && selectedDestination.id == stopToFind.id) stopFound.push(selectedDestination);
        return stopFound.length > 0 ? true : false;
    }
    onBuildRouteWithWaypoints() {
        this.setState({
            isBuildingRoute: true
        });
        this.findRoute();
    }
    addCustomMarkersForWaypoints(results) {
        if (this.waypointsMarkers && this.waypointsMarkers.length > 0) this.waypointsMarkers.map((marker)=>{
            marker.setMap(null);
        });
        this.waypointsMarkers = [];
        if (results && results.routes && results.routes.length > 0) {
            const legs = results.routes[0].legs;
            if (legs && legs.length > 0) {
                let strWaypoints = "";
                const { widgetMapMode: widgetMapMode } = this.state;
                let anchor = {
                    x: 14,
                    y: 14
                };
                if (widgetMapMode === "favorites") anchor = {
                    x: 14,
                    y: 7
                };
                legs.slice(0, -1).forEach((leg, index)=>{
                    const wpPosition = leg.end_location;
                    const marker = new woosmap.map.Marker({
                        position: new woosmap.map.LatLng(wpPosition.lat, wpPosition.lng),
                        icon: {
                            url: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.waypoints + `/stop_${index + 1}@3x.png`,
                            scaledSize: {
                                height: 28,
                                width: 28
                            },
                            anchor: anchor
                        }
                    });
                    this.waypointsMarkers.push(marker);
                    marker.setMap(this.map);
                });
            }
        }
    }
    cancelRouteBuilding() {
        this.clearRouteAndItinerary();
        this.clearStopMarkers();
        this.setState({
            selectedStop: undefined,
            searchedStops: [],
            showRouteBuilderSummary: false,
            selectedWaypoints: [],
            removingWaypointId: null,
            showExitGates: false,
            selectedExitGate: undefined,
            allExitGatesLoaded: false,
            allExitGates: [],
            isBuildingRoute: false,
            routeBuilderView: "default",
            isDragging: false,
            showRouteBuilderWarning: false,
            showPanel: false,
            mode: "default",
            selectedOrigin: undefined,
            selectedDestination: undefined,
            shopsMarkedForVisit: undefined,
            routeBuilderToastDismissed: false,
            itinerarySource: ""
        });
        this.controller.setSelectedWaypoints(null);
        if (this.controller.getWidgetMapMode() === "thematic") {
            const thematicDetails = document.querySelector(".thematic-details");
            thematicDetails.style.display = "flex";
        }
    }
    clearStopMarkers() {
        if (this.waypointsMarkers && this.waypointsMarkers.length > 0) {
            this.waypointsMarkers.forEach((marker)=>{
                marker.setMap(null);
            });
            this.waypointsMarkers = [];
        }
    }
    renderHeader() {
        const { mode: mode, showPanel: showPanel } = this.state;
        const modeClassItinerary = `woosmap-panel__header woosmap-panel__header--itinerary desktop ${showPanel ? "left" : ""}`;
        const modeClassLevels = `woosmap-panel__header woosmap-panel__header--levels ${showPanel ? "left" : ""}`;
        const isMobileView = ()=>{
            let res = false;
            if (this.controller._renderer.getView() !== "desktop") {
                if (this.map && this.map._container && this.map._container.clientWidth < 768) res = true;
            }
            return res;
        };
        if (mode === "itinerary") return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: modeClassItinerary,
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                    className: "featured-icon",
                    icon: "itinerary-filled"
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h1", {
                    className: "title",
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Itinerary
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn btn--main btn--close",
                    onClick: ()=>{
                        this.setState({
                            mode: "default",
                            directionsResult: undefined,
                            stepSelected: "",
                            showPanel: false,
                            selectedFeature: undefined
                        });
                        this.controller._renderer.setDirections(null);
                        const { userLocation: userLocation } = this.state;
                        this.setState({
                            selectedOrigin: userLocation,
                            selectedDestination: undefined
                        });
                        this.controller._renderer.unselectFeature();
                        this.cancelRouteBuilding();
                        /**
               * This event is fired when the user performs any widget specific activities.
               * @event IndoorWidget#indoor_widget_analytics
               * @property {string} event ITINERARY_MODE_EXITED.
               * @property {*} args
               */ this.controller.trigger(this, "indoor_widget_analytics", [
                            {
                                event: (0, $3b06b60897362d69$export$ada873a34909da65).ITINERARY_MODE_EXITED
                            }
                        ]);
                    },
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        icon: "close"
                    })
                })
            ]
        }, "iti");
        if (mode === "level") return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: modeClassLevels,
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                    className: "featured-icon",
                    icon: "stairs-thick"
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h1", {
                    className: "title",
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.levels
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn  btn--main btn--close",
                    onClick: ()=>this.setState({
                            mode: "default",
                            showPanel: false
                        }),
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        icon: "close"
                    })
                })
            ]
        }, "levels");
        if (mode === "waypoints") return null;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                this.state.widgetMapMode === "favorites" && isMobileView() && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "woosmap-panel__customcta",
                    disabled: this.state.isUserUnauthorized || (this.shopsToVisit?.features?.length ?? 0) < 3,
                    onClick: this.showRouteBuilder,
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.optimized_route_cta_label
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__header",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fea70e6de74e95e1$export$2e2bcd8739ae039), {
                            src: (value)=>this.autocomplete("searchedFeatures", "searchedFeaturesText", value),
                            keys: [
                                "name"
                            ],
                            placeholder: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Search,
                            onClose: ()=>this.onAutoCompleteClose("searchedFeaturesText"),
                            callbackSelect: (value)=>{
                                let selectedFeature = null;
                                const padding = {
                                    left: 0,
                                    bottom: 0,
                                    top: 0
                                };
                                if (this.map && this.map._container) {
                                    const mapContainerWidth = this.map._container.clientWidth;
                                    switch(this.controller._renderer.getView()){
                                        case "mobile":
                                            padding.bottom = this.panelHeight;
                                            break;
                                        case "desktop":
                                            padding.left = this.panelWidth;
                                            break;
                                        case "auto":
                                            if (mapContainerWidth > 768) padding.left = this.panelWidth;
                                            else padding.bottom = this.panelHeight;
                                            break;
                                    }
                                }
                                const venue = this.controller._renderer.getVenue();
                                if (venue && value) {
                                    if (value.id > 0) new Promise((resolve)=>{
                                        const callback = (featuresCollection)=>{
                                            selectedFeature = featuresCollection && featuresCollection.features[0];
                                            resolve([
                                                this.controller._renderer.selectFeature(selectedFeature, padding),
                                                /**
                         * This event is fired when the user performs any widget specific activities.
                         * @event IndoorWidget#indoor_widget_analytics
                         * @property {string} event SEARCH_RESULT_ITEM_SELECTED.
                         * @property {*} args The GeoJSON feature selected by the user.
                         */ this.controller.trigger(this, "indoor_widget_analytics", [
                                                    {
                                                        event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                        args: selectedFeature
                                                    }
                                                ])
                                            ]);
                                        };
                                        this.indoorService.search(venue.venue_id, "", callback, undefined, value.id.toString());
                                    });
                                    else {
                                        const { userLocation: userLocation } = this.state;
                                        if (userLocation && value.id === -1) {
                                            selectedFeature = userLocation;
                                            this.controller.trigger(this, "indoor_widget_analytics", [
                                                {
                                                    event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                    args: selectedFeature
                                                }
                                            ]);
                                        }
                                    }
                                }
                            },
                            disableAutoFocus: this.controller.getIsAutofocusDisabled(),
                            isMobileView: isMobileView()
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--main btn--primary btn--itinerary",
                            onClick: ()=>this.setState({
                                    mode: "itinerary",
                                    showPanel: true,
                                    wheelChairEnabled: this.controller.getDirectionsMode() === "wheelchair"
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                icon: "itinerary-filled"
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn  btn--main btn--secondary btn--levels",
                            onClick: ()=>this.setState({
                                    mode: "level",
                                    showPanel: true
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                icon: "stairs-thick"
                            })
                        })
                    ]
                }, "auto"),
                this.state.widgetMapMode === "favorites" && isMobileView() && !this.state.staticToastDismissed && (this.state.isUserUnauthorized || (this.shopsToVisit?.features?.length ?? 0) === 0) && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__static-toast",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                            className: "woosmap-panel__static-toast__text",
                            children: this.state.isUserUnauthorized ? (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.unauthorized_map_toast : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.empty_map_toast
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            className: "woosmap-panel__static-toast__close",
                            "aria-label": "Dismiss",
                            onClick: ()=>this.setState({
                                    staticToastDismissed: true
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                icon: "close",
                                size: 15
                            })
                        })
                    ]
                }),
                this.state.widgetMapMode === "favorites" && !isMobileView() && !this.state.showPanel && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__route-card",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            className: "woosmap-panel__route-card__desc",
                            children: this.state.isUserUnauthorized ? (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.unauthorised_favs : (this.shopsToVisit?.features?.length ?? 0) < 3 ? (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.fav_route_builder_min_stop_message : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.optimized_route_cta_desc
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "woosmap-panel__route-card__cta",
                            disabled: this.state.isUserUnauthorized || (this.shopsToVisit?.features?.length ?? 0) < 3,
                            onClick: this.showRouteBuilder,
                            children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.optimized_route_cta_button}`
                        })
                    ]
                })
            ]
        });
    }
    renderItinerary() {
        const { mode: mode, directionsResult: directionsResult, routeErrorMessage: routeErrorMessage, stepSelected: stepSelected, isLoading: isLoading, wheelChairEnabled: wheelChairEnabled, widgetMapMode: widgetMapMode, routeBuilderView: routeBuilderView } = this.state;
        const { selectedFeature: selectedFeature, selectedOrigin: selectedOrigin, selectedDestination: selectedDestination } = this.state;
        let defaultValue, defaultOrigin = "";
        let duration, distance, levels = "";
        let origin = "";
        let destination = "";
        let firstStopInIntinerary;
        const routeSteps = [];
        const isMobileView = ()=>{
            let res = false;
            if (this.controller._renderer.getView() !== "desktop") {
                if (this.map && this.map._container && this.map._container.clientWidth < 768) res = true;
            }
            return res;
        };
        if (mode !== "itinerary") {
            this.controller.setIsItineraryMode(false);
            return null;
        } else {
            this.controller.setIsItineraryMode(true);
            if (selectedFeature && selectedFeature !== selectedOrigin) {
                if (selectedFeature.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) defaultValue = `${selectedFeature.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedFeature.properties["level"]})`;
                else defaultValue = `${selectedFeature.properties["name"]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedFeature.properties["level"]})`;
            }
            if (selectedOrigin) {
                origin = `${selectedOrigin.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] ? selectedOrigin.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] : selectedOrigin.properties["name"]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedOrigin.properties["level"]})`;
                if (selectedOrigin.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) defaultOrigin = `${selectedOrigin.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedOrigin.properties["level"]})`;
                else defaultOrigin = `${selectedOrigin.properties["name"]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedOrigin.properties["level"]})`;
            }
            if (selectedDestination) destination = `${selectedDestination.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] ? selectedDestination.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] : selectedDestination.properties["name"]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${selectedDestination.properties["level"]})`;
            if (defaultValue === undefined) defaultValue = destination;
            if (directionsResult && directionsResult.routes && directionsResult.routes.length > 0) {
                const route = directionsResult.routes[0];
                if (route.legs && route.legs.length > 0) {
                    duration = route.legs[0].duration.value > 60 ? this.convertDurationToMins(Math.round(route.legs[0].duration.value)) : route.legs[0].duration.text;
                    distance = route.legs[0].distance.text;
                    const levelTransitonObject = this.composeLevelTransition(route.legs[0].start_location.level, route.legs[0].end_location.level);
                    if (levelTransitonObject["level"] > 0) levels = `${levelTransitonObject["level"]} ${levelTransitonObject["content"]} ${levelTransitonObject["direction"]}`;
                    route.legs.forEach((leg)=>{
                        if (leg && leg.steps) leg.steps.forEach((step)=>{
                            const feature = {
                                type: "Feature",
                                properties: {
                                    id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                    level: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Level} ${step.start_location.level}`,
                                    floor: step.start_location.level,
                                    instruction: step.instruction ? step.instruction.summary : null,
                                    icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : "caret-down"
                                },
                                geometry: {
                                    type: "LineString",
                                    coordinates: step.polyline
                                }
                            };
                            routeSteps.push(feature);
                        });
                    });
                    if (route.legs && route.legs.length > 1) {
                        //Multi-navigation mode with waypoints
                        const { selectedWaypoints: selectedWaypoints } = this.state;
                        const waypointId = route.legs[0].waypoint;
                        firstStopInIntinerary = selectedWaypoints.find((wp)=>wp.id && wp.id.toString() === waypointId);
                    }
                }
            } else {
                const responsiveStatus = this.controller._renderer.getView();
                const map = this.map;
                if (map && map._container && selectedFeature) {
                    const centrePoint = (0, $20c1bb73c4d4ca81$export$2e2bcd8739ae039)(selectedFeature);
                    const lat = centrePoint.geometry.coordinates[1];
                    const lng = centrePoint.geometry.coordinates[0];
                    const padding = {
                        bottom: 0,
                        left: 0
                    };
                    let flyToOptions = {
                        center: {
                            lat: lat,
                            lng: lng
                        }
                    };
                    switch(responsiveStatus){
                        case "mobile":
                            // eslint-disable-next-line max-len
                            flyToOptions = map.getZoom() < 18 ? {
                                ...flyToOptions,
                                zoom: 18,
                                padding: padding
                            } : {
                                ...flyToOptions,
                                padding: padding
                            };
                            break;
                        case "desktop":
                            if (map._container.clientWidth <= 768) flyToOptions = map.getZoom() < 18 ? {
                                ...flyToOptions,
                                zoom: 18
                            } : flyToOptions;
                            break;
                        default:
                            if (map._container.clientWidth <= 768) // eslint-disable-next-line max-len
                            flyToOptions = map.getZoom() < 18 ? {
                                ...flyToOptions,
                                zoom: 18,
                                padding: padding
                            } : {
                                ...flyToOptions,
                                padding: padding
                            };
                            break;
                    }
                    map.flyTo(flyToOptions);
                }
            }
        }
        const instructionsByLevel = this.groupInstructionsByLevel(routeSteps);
        const noResultClass = routeSteps.length > 0 ? "" : "no-result";
        const { showItineraryResults: showItineraryResults } = this.state;
        const itineraryResultClass = showItineraryResults ? "hide-results" : "";
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__header desktop",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--retract mobile",
                            onClick: ()=>this.setState({
                                    showPanel: false
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 17,
                                icon: "arrow-left"
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "woosmap-panel__content__header__itinenary",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h2", {
                                className: "text",
                                children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Select a location and a destination"]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__body woosmap-panel__content__body--itinerary",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "itinerary-build",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "btn btn--close mobile",
                                    onClick: ()=>{
                                        this.setState({
                                            mode: "default",
                                            directionsResult: null,
                                            stepSelected: "",
                                            showPanel: false,
                                            selectedFeature: undefined,
                                            selectedOrigin: undefined
                                        });
                                        this.controller._renderer.setDirections(null);
                                        this.setState({
                                            selectedOrigin: undefined,
                                            selectedDestination: undefined
                                        });
                                        this.controller._renderer.selectFeature(undefined);
                                        if (this.controller._renderer._activeInfoWindow) this.controller._renderer._activeInfoWindow.close();
                                        this.cancelRouteBuilding();
                                        /**
                 * This event is fired when the user performs any widget specific activities.
                 * @event IndoorWidget#indoor_widget_analytics
                 * @property {string} event ITINERARY_MODE_EXITED.
                 * @property {*} args
                 */ this.controller.trigger(this, "indoor_widget_analytics", [
                                            {
                                                event: (0, $3b06b60897362d69$export$ada873a34909da65).ITINERARY_MODE_EXITED
                                            }
                                        ]);
                                    },
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "arrow-left"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "icons",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            className: "icon__origin",
                                            icon: "position-filled"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            className: "icon__destination",
                                            icon: "marker-filled"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "itinerary-build__fieldset",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "origin",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fea70e6de74e95e1$export$2e2bcd8739ae039), {
                                                defaultValue: defaultOrigin,
                                                src: (value)=>this.autocomplete("searchedOrigins", "searchedOriginsText", value),
                                                keys: [
                                                    "name"
                                                ],
                                                placeholder: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Type a origin"],
                                                value: origin,
                                                onClose: ()=>this.onAutoCompleteClose("searchedOriginsText"),
                                                callbackSelect: (value)=>{
                                                    let selectedOrigin = null;
                                                    const venue = this.controller._renderer.getVenue();
                                                    if (venue && value) {
                                                        if (value.id > 0) new Promise((resolve)=>{
                                                            const callback = (featuresCollection)=>{
                                                                // eslint-disable-next-line max-len
                                                                if (featuresCollection && selectedDestination && featuresCollection.features[0].id === selectedDestination.id) {
                                                                    (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.same_origin_destination_warning || `Origin & Destination cannot be same`, "error");
                                                                    const { selectedOrigin: prevOrigin } = this.state;
                                                                    this.setState({
                                                                        selectedOrigin: undefined
                                                                    }, ()=>{
                                                                        this.setState({
                                                                            selectedOrigin: prevOrigin
                                                                        });
                                                                    });
                                                                    return;
                                                                }
                                                                selectedOrigin = featuresCollection && featuresCollection.features[0];
                                                                resolve(this.setState({
                                                                    selectedOrigin: selectedOrigin
                                                                }, ()=>{
                                                                    if (value) this.findRoute();
                                                                    else this.clearRouteAndItinerary();
                                                                    this.controller.trigger(this, "indoor_widget_analytics", [
                                                                        {
                                                                            event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                                            args: selectedOrigin
                                                                        }
                                                                    ]);
                                                                }));
                                                            };
                                                            this.indoorService.search(venue.venue_id, "", callback, undefined, value.id.toString());
                                                        });
                                                        else {
                                                            const { userLocation: userLocation } = this.state;
                                                            if (userLocation && value.id === -1) {
                                                                selectedOrigin = userLocation;
                                                                this.setState({
                                                                    selectedOrigin: selectedOrigin
                                                                }, ()=>{
                                                                    if (value) this.findRoute();
                                                                    else this.clearRouteAndItinerary();
                                                                    this.controller.trigger(this, "indoor_widget_analytics", [
                                                                        {
                                                                            event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                                            args: selectedOrigin
                                                                        }
                                                                    ]);
                                                                });
                                                            }
                                                        }
                                                    }
                                                },
                                                disableAutoFocus: this.controller.getIsAutofocusDisabled(),
                                                isMobileView: isMobileView()
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "destination",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fea70e6de74e95e1$export$2e2bcd8739ae039), {
                                                defaultValue: defaultValue,
                                                src: (value)=>this.autocomplete("searchedDestinations", "searchedDestinationsText", value),
                                                keys: [
                                                    "name"
                                                ],
                                                placeholder: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Type a destination"],
                                                onClose: ()=>this.onAutoCompleteClose("searchedDestinationsText"),
                                                value: destination,
                                                callbackSelect: (value)=>{
                                                    let selectedDestination = null;
                                                    const venue = this.controller._renderer.getVenue();
                                                    if (venue && value) {
                                                        if (value.id > 0) new Promise((resolve)=>{
                                                            const callback = (featuresCollection)=>{
                                                                // eslint-disable-next-line max-len
                                                                selectedDestination = featuresCollection && featuresCollection.features[0];
                                                                resolve(this.setState({
                                                                    selectedDestination: selectedDestination
                                                                }, ()=>{
                                                                    if (value) this.findRoute();
                                                                    else this.clearRouteAndItinerary();
                                                                }));
                                                                this.controller.trigger(this, "indoor_widget_analytics", [
                                                                    {
                                                                        event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                                        args: selectedDestination
                                                                    }
                                                                ]);
                                                            };
                                                            this.indoorService.search(venue.venue_id, "", callback, undefined, value.id.toString());
                                                        });
                                                        else {
                                                            const { userLocation: userLocation } = this.state;
                                                            if (userLocation && value.id === -1) {
                                                                selectedDestination = userLocation;
                                                                this.setState({
                                                                    selectedDestination: selectedDestination
                                                                }, ()=>{
                                                                    if (value) this.findRoute();
                                                                    else this.clearRouteAndItinerary();
                                                                });
                                                                this.controller.trigger(this, "indoor_widget_analytics", [
                                                                    {
                                                                        event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                                        args: selectedDestination
                                                                    }
                                                                ]);
                                                            }
                                                        }
                                                    }
                                                },
                                                disableAutoFocus: this.controller.getIsAutofocusDisabled(),
                                                isMobileView: isMobileView()
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "btn btn--square btn--mini btn--inverse",
                                    onClick: this.swapOriginAndDestination,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "inverse"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "disability",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    className: "disability__icon",
                                    icon: "disability"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "disability__switcher",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $1d148e12fc214f1e$export$2e2bcd8739ae039), {
                                        isSmall: true,
                                        id: "wheelchair_switch",
                                        checked: wheelChairEnabled,
                                        onChange: this.onDisabilitySwitchChange,
                                        text: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Disability compliant"]
                                    })
                                }),
                                selectedOrigin && selectedDestination && widgetMapMode !== 'favorites' && widgetMapMode !== 'kiosk' && (routeBuilderView === "results" ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "disability__waypoints",
                                    onClick: this.editStops,
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.edit_stops
                                }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "disability__waypoints",
                                    onClick: this.showRouteBuilder,
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.stop_cta
                                }))
                            ]
                        }),
                        isLoading ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "itinerary-loader"
                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: `itinerary-results ${noResultClass} ${itineraryResultClass}`,
                            children: [
                                duration && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "itinerary-results__header",
                                    children: [
                                        duration && distance && (levels !== "" ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "title-container",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h2", {
                                                    className: "title",
                                                    children: `${duration} - ${distance} - ${levels} `
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                                    className: "subtitle",
                                                    children: firstStopInIntinerary && `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.for} ${firstStopInIntinerary.properties.name}`
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "title-container",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h2", {
                                                    className: "title",
                                                    children: `${duration} - ${distance}`
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                                    className: "subtitle",
                                                    children: firstStopInIntinerary && `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.for} ${firstStopInIntinerary.properties.name}`
                                                })
                                            ]
                                        })),
                                        this.controller.getNavigationMode() && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                            className: "btn btn--primary btn--small btn--navigate",
                                            onClick: ()=>this.launchNavigation(),
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    className: "desktop",
                                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Navigate
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                    className: "mobile",
                                                    size: 18,
                                                    icon: "itinerary-start"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                            className: "btn btn--toggle-results mobile",
                                            onClick: ()=>this.setState({
                                                    showItineraryResults: !showItineraryResults
                                                }),
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                size: 17,
                                                icon: showItineraryResults ? "caret-up" : "caret-down"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "itinerary-results__body",
                                    children: routeSteps.length > 0 ? instructionsByLevel.map(({ level: level, steps: steps }, index)=>{
                                        const instructions = steps;
                                        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "itinerary-results__body__section",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                        onClick: ()=>this.toggleSteps(index),
                                                        className: "btn--at-level btn btn--transparent btn--fill",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                size: 13,
                                                                icon: this.state.levelClicked[index] === false ? "arrow-right" : "caret-down"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.At} ${level}`
                                                            })
                                                        ]
                                                    }, `level_${level}`),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                                        className: `${this.state.levelClicked[index] === false ? "itinerary-results__list--collapsed" : ""}`,
                                                        children: instructions.map((step)=>{
                                                            return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                                className: `${stepSelected === step.properties["id"] ? "itinerary-results__highlightedStep" : ""}`,
                                                                onClick: ()=>{
                                                                    this.highlightStep(step);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                        size: 13,
                                                                        icon: step.properties["icon"]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                        children: step.properties["instruction"]
                                                                    })
                                                                ]
                                                            }, step.properties["id"]);
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "itinerary-noResults",
                                        children: routeErrorMessage
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderLevel() {
        const { mode: mode, allFeaturesLoaded: allFeaturesLoaded, allFeatures: allFeatures } = this.state;
        const venue = this.controller._renderer.getVenue();
        if (mode !== "level" || !venue) return null;
        const padding = {
            left: 0,
            bottom: 0,
            top: 0
        };
        if (this.map && this.map._container) {
            const mapContainerWidth = this.map._container.clientWidth;
            switch(this.controller._renderer.getView()){
                case "mobile":
                    padding.bottom = this.panelHeight;
                    break;
                case "desktop":
                    padding.left = this.panelWidth;
                    break;
                case "auto":
                    if (mapContainerWidth > 768) padding.left = this.panelWidth;
                    else padding.bottom = this.panelHeight;
                    break;
            }
        }
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__header",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "tab"
                    })
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__body woosmap-panel__content__body--levels",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "woosmap-panel__content__body__actions",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                className: "btn btn--retract mobile",
                                onClick: ()=>this.setState({
                                        showPanel: false
                                    }),
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    size: 17,
                                    icon: "arrow-left"
                                })
                            })
                        }),
                        !allFeaturesLoaded ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "loading",
                            children: "Loading..."
                        }) : null,
                        allFeaturesLoaded && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: venue.levels.map((level)=>{
                                const levelFeatures = allFeatures.filter((feature)=>{
                                    return feature.properties.level === level.level.toString();
                                });
                                if (levelFeatures.length === 0) return null;
                                return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "card-container",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h2", {
                                            className: "title",
                                            children: level.name || `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Level} ${level.level}`
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                            children: levelFeatures.map((feat)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                    onClick: ()=>{
                                                        this.controller._renderer.selectFeature(feat, padding);
                                                        this.setState({
                                                            selectedDestination: feat,
                                                            mode: "default"
                                                        });
                                                        /**
                             * This event is fired when the user performs any widget specific activities.
                             * @event IndoorWidget#indoor_widget_analytics
                             * @property {string} event POI_SELECTED.
                             * @property {*} args The GeoJSON feature selected by the user from the list of POIs.
                             */ this.controller.trigger(this, "indoor_widget_analytics", [
                                                            {
                                                                event: (0, $3b06b60897362d69$export$ada873a34909da65).SELECT_POI,
                                                                args: feat
                                                            }
                                                        ]);
                                                    },
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "card",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "card__body",
                                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                                                                    className: "shop-name",
                                                                    children: feat.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] ? feat.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`] : feat.properties["name"]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                                className: "btn btn--transparent",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    this.controller._renderer.selectFeature(feat, padding);
                                                                    this.setState({
                                                                        selectedDestination: feat
                                                                    });
                                                                    this.setState({
                                                                        mode: "itinerary",
                                                                        showPanel: true
                                                                    });
                                                                },
                                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                    icon: "itinerary-filled"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }, feat.id))
                                        })
                                    ]
                                }, level.level);
                            })
                        })
                    ]
                })
            ]
        });
    }
    renderMall() {
        const { mode: mode, selectedFeature: selectedFeature } = this.state;
        if (mode !== "default") return null;
        let name, level, desc, phone, website, housenumber, street, postCode, city, coverImage, logo, osmHours, nextSlots = [];
        if (selectedFeature && selectedFeature.id !== -1) {
            const props = selectedFeature.properties;
            if (props[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) name = props[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`];
            else name = props["name"];
            level = props["level"];
            if (props[`description:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`]) desc = props[`description:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`];
            else desc = props["description"];
            if (props[`contact:phone:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) phone = props[`contact:phone:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`];
            else if (props["contact:phone"]) phone = props["contact:phone"];
            if (props[`contact:website:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`]) website = props[`contact:website:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`];
            else if (props["contact:website"]) website = props["contact:website"];
            if (props["addr:housenumber"]) housenumber = props["addr:housenumber"];
            if (props["addr:street"]) street = props["addr:street"];
            if (props["addr:postcode"]) postCode = props["addr:postcode"];
            if (props["addr:city"]) city = props["addr:city"];
            if (props[`woosmap:cover:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) coverImage = props[`woosmap:cover:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`];
            else if (props["woosmap:cover"]) coverImage = props["woosmap:cover"];
            else coverImage = "https://sdk.woosmap.com/map/assets/default-img.png";
            if (props[`woosmap:logo:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`]) logo = props[`woosmap:logo:${(0, $58070e9281bc680d$export$3814be8b8b1016be)()}`];
            else if (props["woosmap:logo"]) logo = props["woosmap:logo"];
            else logo = "https://sdk.woosmap.com/map/assets/default-logo.png";
            if (props["opening_hours"] && typeof props["opening_hours"] === "string") {
                osmHours = new (0, $b400f3e24794b0f3$export$2e2bcd8739ae039)(props["opening_hours"]);
                if (osmHours && osmHours.opening_hours) nextSlots = osmHours.getNextSlot(7);
            }
        }
        const coverImageStyle = coverImage ? `background-image: url(${coverImage})` : `background-image: url(https://sdk.woosmap.com/map/assets/default-img.png)`;
        const logoImageStyle = logo ? `background-image: url(${logo})` : `background-image: url(https://sdk.woosmap.com/map/assets/default-logo.png)`;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__header woosmap-panel__content__header--featured-img",
                    style: coverImageStyle,
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "logo",
                            style: logoImageStyle
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--retract mobile",
                            onClick: ()=>this.setState({
                                    showPanel: false
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 17,
                                icon: "arrow-left"
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            onClick: ()=>this.setState({
                                    mode: "itinerary",
                                    showPanel: true,
                                    wheelChairEnabled: this.controller.getDirectionsMode() === "wheelchair"
                                }),
                            className: "btn btn--round btn--primary btn--itinerary",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                icon: "itinerary-filled"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "woosmap-panel__content__body",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "woosmap-panel__content__body__title-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h2", {
                                    className: "title",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "level-info",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            size: 16,
                                            icon: "stairs-thick"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            children: [
                                                (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Level,
                                                " ",
                                                level
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        desc && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            className: "desc",
                            children: desc
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "date-selector",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "year",
                                    id: "year1"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "month",
                                    id: "month1"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "day",
                                    id: "day1"
                                })
                            ]
                        }),
                        housenumber || street || postCode || city && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            className: "woosmap-panel__content__body__info",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    icon: "marker"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: housenumber
                                }),
                                " ",
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("br", {}),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: street
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: postCode
                                }),
                                " ",
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("br", {}),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: city
                                })
                            ]
                        }),
                        website && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            className: "woosmap-panel__content__body__info",
                            onClick: ()=>this.onWebsiteClicked(website),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                className: "woosmap-panel__content__body__info__link",
                                title: website,
                                href: website,
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "world"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                        className: "woosmap-panel__content__body__info__link__label",
                                        children: website
                                    })
                                ]
                            })
                        }),
                        phone && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            className: "woosmap-panel__content__body__info",
                            onClick: ()=>this.onPhoneClicked(phone),
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    icon: "phone"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: [
                                        " ",
                                        phone
                                    ]
                                })
                            ]
                        }),
                        osmHours && osmHours.opening_hours && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "btn--opening-hours btn btn--transparent",
                                    onClick: ()=>this.toggleOpeningHrs(),
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            icon: "clock",
                                            className: `opening-hours-icon ${osmHours.getState() ? "opened" : "closed"}`
                                        }),
                                        osmHours.getState() ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            className: "opened",
                                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Open
                                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            className: "closed",
                                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Closed
                                        }),
                                        osmHours.getState() ? osmHours.getNextChange() !== "" ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            children: [
                                                (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Closes at"],
                                                " ",
                                                osmHours.getNextChange()
                                            ]
                                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            children: "24 hours"
                                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            children: [
                                                `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Opens} ${osmHours.getNextChangeDay()} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.At}`,
                                                " ",
                                                osmHours.getNextChange()
                                            ]
                                        }),
                                        nextSlots.length > 0 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            size: 13,
                                            icon: this.state.openingHoursClicked === false ? "caret-down" : "caret-up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: `${this.state.openingHoursClicked === false ? "woosmap-panel__content__body--openinghours--collapsed" : "woosmap-panel__content__body--openinghours"}`,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                        children: nextSlots.map((slot, index)=>{
                                            return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                        className: `dayname ${slot.isSpecial ? "special" : index === 0 ? "current" : ""}`,
                                                        children: slot.day
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                                        children: slot.slots.map((timeRange, i)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                                className: `${slot.isSpecial ? "special" : index === 0 ? "current" : ""}`,
                                                                children: timeRange.time
                                                            }, i))
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderPanelContent() {
        const { showPanel: showPanel, selectedFeature: selectedFeature, mode: mode, showRouteBuilderSummary: showRouteBuilderSummary, widgetMapMode: widgetMapMode } = this.state;
        const modeClass = `woosmap-panel__content  ${showRouteBuilderSummary ? `${mode}--summary` : mode} ${showPanel ? "left" : ""}`;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                !showPanel && (selectedFeature || mode !== "default") && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: widgetMapMode === "favorites" ? "btn btn--expand-fav" : "btn btn--expand",
                    onClick: ()=>this.setState({
                            showPanel: true
                        }),
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        size: 17,
                        icon: "arrow-right"
                    })
                }),
                showPanel && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn btn--retract desktop",
                    onClick: ()=>this.setState({
                            showPanel: false
                        }),
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        size: 17,
                        icon: "arrow-left"
                    })
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: modeClass,
                    children: [
                        this.renderMall(),
                        this.renderLevel(),
                        this.renderItinerary(),
                        this.renderRouteBuilder()
                    ]
                })
            ]
        });
    }
    /**
   * Renders the route builder panel with different views based on the current state.
   *
   * @returns {ComponentChildren} The rendered route builder panel component, or null if not in 'waypoints' mode
   *
   * @description
   * This method renders a comprehensive route building interface with the following features:
   * - Collapsed summary view showing origin, destination, and step count
   * - Expanded default view with origin, waypoints, and destination inputs
   * - Results view displaying optimized route with duration, distance, and stops
   * - Favorites view for selecting exhibitors to visit
   * - Search functionality for adding waypoints
   * - Exit gate selection toggle
   * - Mobile view detection and responsive behavior
   *
   * The component displays different content based on:
   * - `mode`: Only renders when mode is 'waypoints'
   * - `showRouteBuilderSummary`: Toggles between collapsed and expanded states
   * - `routeBuilderView`: Controls which view is shown ('default', 'results', or favorites)
   * - `isBuildingRoute`: Shows loading state when route is being calculated
   * - `getWidgetMapMode()`: Determines if showing general or favorites route builder
   *
   * @note
   * The primary action button is disabled when either `selectedOrigin` or `selectedDestination` is undefined.
   * The button will be disabled if BOTH are undefined.
   */ renderRouteBuilder() {
        const { mode: mode, showExitGates: showExitGates, showRouteBuilderSummary: showRouteBuilderSummary } = this.state;
        const { selectedFeature: selectedFeature, selectedOrigin: selectedOrigin, selectedDestination: selectedDestination, selectedWaypoints: selectedWaypoints, directionsResult: directionsResult } = this.state;
        let defaultValue, defaultOrigin = "";
        let duration = 0;
        let distance = 0;
        let origin = "";
        let destination = "";
        let durationMetric = "";
        let totalStops = 0;
        let selectAllFavs = false;
        let pav = "";
        const routeStops = [];
        if (selectedOrigin) {
            origin = `${selectedOrigin.properties[`
woosmap:shortname`] ? selectedOrigin.properties[`
woosmap:shortname`] : selectedOrigin.properties["name"]}`;
            if (selectedOrigin.properties[`
woosmap:shortname`]) defaultOrigin = `${selectedOrigin.properties[`
woosmap:shortname`]})`;
            else defaultOrigin = `${selectedOrigin.properties["name"]})`;
            const originProps = selectedOrigin.properties;
            const originBuilding = originProps["Building"] ? (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(originProps["Building"]) : "";
            const originFloorLabel = originProps["Floorplan_Label"] || "";
            const originLevel = originProps["level"];
            pav = originBuilding ? `Pav ${originBuilding} ${originFloorLabel} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.level} ${originLevel}` : "";
        }
        if (selectedDestination) {
            const destProps = selectedDestination.properties;
            destination = destProps[`woosmap:shortname`] ? destProps[`woosmap:shortname`] : destProps[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] || destProps["name"];
        }
        if (directionsResult && directionsResult.routes && directionsResult.routes.length > 0) {
            const route = directionsResult.routes[0];
            if (route.legs && route.legs.length > 0) {
                let waypointids = "";
                totalStops = route.legs.length + 1;
                route.legs.forEach((leg)=>{
                    duration = duration + leg.duration.value;
                    distance = Math.round(distance + leg.distance.value);
                    //@ts-ignore
                    waypointids = waypointids.concat(leg.waypoint ? leg.waypoint + "," : "");
                });
                const oldDuration = duration;
                duration = duration > 60 ? Math.round(duration / 60) : duration;
                durationMetric = oldDuration > 60 ? `mins` : `secs`;
                route.legs.slice(0).forEach((leg, index)=>{
                    const waypointId = leg.waypoint;
                    const foundWaypoint = selectedWaypoints.find((wp)=>wp.id && wp.id.toString() === waypointId);
                    const waypointName = foundWaypoint ? foundWaypoint.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] || foundWaypoint.properties["name"] : "";
                    const waypointBuilding = foundWaypoint ? (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(foundWaypoint.properties["Building"] || "") : "";
                    const stop = {
                        type: "Feature",
                        properties: {
                            id: waypointId,
                            name: waypointName,
                            building: waypointBuilding,
                            duration: leg.duration.value > 60 ? `${Math.round(leg.duration.value / 60)} mins` : `${leg.duration.value} secs`,
                            distance: leg.distance.text
                        }
                    };
                    routeStops.push(stop);
                });
            }
        }
        const isMobileView = ()=>{
            let res = false;
            if (this.controller._renderer.getView() !== "desktop") {
                if (this.map && this.map._container && this.map._container.clientWidth < 768) res = true;
            }
            return res;
        };
        if (mode !== "waypoints") return null;
        if (mode === "waypoints" && this.controller.getWidgetMapMode() === "thematic" && isMobileView()) {
            const thematicDetails = document.querySelector(".thematic-details");
            if (thematicDetails) thematicDetails.style.display = "none";
        }
        const buildFavoriteShopList = ()=>{
            const { selectedOrigin: selectedOrigin } = this.state;
            return this.shopsToVisit?.features.filter((shop)=>shop.id !== selectedOrigin?.id && shop.id !== selectedDestination?.id);
        };
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            //@ts-ignore
            ref: (el)=>this.panelRef = el ?? undefined,
            className: `route-panel ${showRouteBuilderSummary ? "route-panel--collapsed" : ""}`,
            onClick: (e)=>e.stopPropagation(),
            onMouseDown: (e)=>e.stopPropagation(),
            onPointerDown: (e)=>e.stopPropagation(),
            onPointerMove: (e)=>e.stopPropagation(),
            onPointerUp: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "route-panel__handle"
                }),
                showRouteBuilderSummary ? /* -------- Collapsed summary -------- */ /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "route-panel__summary",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "route-panel__summary-row",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "route-panel__summary-text",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-panel__summary-title",
                                        children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.from} ${origin}`
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-panel__summary-subtitle",
                                        children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.to} ${destination} - ${selectedWaypoints.length + (selectedOrigin && selectedDestination ? 2 : selectedOrigin || selectedDestination ? 1 : 0)} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.steps}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                className: "route-panel__summary-action",
                                onClick: ()=>this.setState({
                                        showRouteBuilderSummary: false
                                    }),
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    icon: "plus"
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "route-panel__header",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "route-panel__header-row",
                        children: isMobileView() ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-panel__title",
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_panel_title
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-panel__close",
                                    onClick: ()=>this.setState({
                                            showRouteBuilderSummary: true
                                        }),
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                        className: "route-panel__close-icon"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    className: "featured-icon",
                                    icon: "itinerary-filled"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-panel__title",
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Itinerary
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-panel__close",
                                    onClick: ()=>{
                                        this.setState({
                                            mode: "default",
                                            directionsResult: undefined,
                                            stepSelected: "",
                                            showPanel: false,
                                            selectedFeature: undefined
                                        });
                                        this.controller._renderer.setDirections(null);
                                        const { userLocation: userLocation } = this.state;
                                        this.setState({
                                            selectedOrigin: userLocation,
                                            selectedDestination: undefined
                                        });
                                        this.controller._renderer.unselectFeature();
                                        this.cancelRouteBuilding();
                                    },
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "close"
                                    })
                                })
                            ]
                        })
                    })
                }),
                this.state.isBuildingRoute && !showRouteBuilderSummary ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "route-panel__loader",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__spinner"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__loader-text",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_loader_header
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_loader_title
                                })
                            ]
                        })
                    ]
                }) : /* Content */ /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                    children: [
                        !showRouteBuilderSummary && this.state.routeBuilderView === "default" && (this.controller.getWidgetMapMode() === "general" || this.controller.getWidgetMapMode() === "thematic") && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__content",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-field",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__label",
                                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_field_origin_label
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__input route-field__input--primary",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-field__left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                            className: "icon__origin",
                                                            icon: "position-filled"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__text",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-field__title",
                                                                    children: origin
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-field__subtitle",
                                                                    children: pav
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                            className: "route-field__edit",
                                                            type: "button",
                                                            "aria-label": "Edit origin",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    mode: "itinerary"
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
                                                                className: "route-field__edit-icon",
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                                                                    d: "M5.40001 18.6H6.67501L16.05 9.225L14.775 7.95L5.40001 17.325V18.6ZM3.60001 20.4V16.575L17.325 2.85L21.15 6.675L7.42501 20.4H3.60001ZM15.4013 8.59875L14.775 7.95L16.05 9.225L15.4013 8.59875Z",
                                                                    fill: "var(--Color-Icon-Secondary, #333333)"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    className: "route-field__action"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                selectedWaypoints.map((waypoint, index)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: `route-stop${this.state.removingWaypointId === waypoint.id ? " route-stop--removing" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-stop__content",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "route-stop__badge",
                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                            children: index + 1
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "route-stop__text",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__title",
                                                                children: waypoint.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] || waypoint.properties["name"]
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__subtitle",
                                                                children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(waypoint.properties["Building"] || "")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                className: "route-stop__remove",
                                                onClick: ()=>this.handleRemoveWaypoint(waypoint),
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                    icon: "close"
                                                })
                                            })
                                        ]
                                    }, `wp-${waypoint.id}`)),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-field",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__label",
                                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_field_des_label
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__input route-field__input--error",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-field__left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                            className: "icon__destination",
                                                            icon: "marker-filled"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__text",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-field__title",
                                                                    children: destination
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-field__subtitle",
                                                                    children: (()=>{
                                                                        const destProps = selectedDestination?.properties;
                                                                        const destBuilding = destProps?.["Building"];
                                                                        return destBuilding ? `Pav ${(0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(destBuilding)} ${destProps["Floorplan_Label"] || ""} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.level} ${destProps["level"]}` : "";
                                                                    })()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                            className: "route-field__edit",
                                                            type: "button",
                                                            "aria-label": "Edit origin",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    mode: "itinerary"
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
                                                                className: "route-field__edit-icon",
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                                                                    d: "M5.40001 18.6H6.67501L16.05 9.225L14.775 7.95L5.40001 17.325V18.6ZM3.60001 20.4V16.575L17.325 2.85L21.15 6.675L7.42501 20.4H3.60001ZM15.4013 8.59875L14.775 7.95L16.05 9.225L15.4013 8.59875Z",
                                                                    fill: "var(--Color-Icon-Secondary, #333333)"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    className: "route-field__action"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !showRouteBuilderSummary && this.state.routeBuilderView === "results" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "route-panel__content route-result",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-result__summary",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-result__summary-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                                                        children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.results_summary_header
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                            className: "route-result__edit",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    routeBuilderView: "default"
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                    icon: "edit",
                                                                    size: 15
                                                                }),
                                                                (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.edit
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-result-stats",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "route-stats",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                icon: "time"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stats__text",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__value",
                                                                        children: duration
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__label",
                                                                        children: durationMetric
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "route-stats",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                icon: "distance"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stats__text",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__value",
                                                                        children: distance
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__label",
                                                                        children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.meters
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "route-stats",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                icon: "stops"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stats__text",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__value",
                                                                        children: totalStops
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "route-stats__label",
                                                                        children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.steps
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-result__list",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-stop route-stop--origin",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                        className: "icon__origin",
                                                        icon: "position-filled"
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        style: {
                                                            minWidth: "0"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__title",
                                                                children: origin
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__subtitle",
                                                                children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)((selectedOrigin?.properties)["Building"] || "")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            routeStops.map((stop, index)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-leg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                    icon: "down-arrow"
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                    children: `${stop.properties["duration"]} - ${stop.properties["distance"]}`
                                                                })
                                                            ]
                                                        }),
                                                        index < routeStops.length - 1 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-stop",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-stop__index",
                                                                    children: index + 1
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-stop__details",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            className: "route-stop__title",
                                                                            children: stop.properties["name"]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            className: "route-stop__subtitle",
                                                                            children: stop.properties["building"]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-stop route-stop--destination",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                        className: "icon__destination",
                                                        icon: "marker-filled"
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        style: {
                                                            minWidth: "0"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__title",
                                                                children: destination
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "route-stop__subtitle",
                                                                children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)((selectedDestination?.properties)["Building"] || "")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !showRouteBuilderSummary && this.state.routeBuilderView === "default" && this.controller.getWidgetMapMode() === "favorites" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "route-panel__content route-favorites",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-favorites__intro",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                                                className: "route-favorites__title",
                                                children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.fav_route_builder_heading
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                                className: "route-favorites__subtitle",
                                                children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.fav_route_builder_sub_heading
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-favorites__count",
                                        children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.fav_route_builder_selected_exhibitors} ${selectedWaypoints.length + (selectedOrigin && selectedDestination ? 2 : selectedOrigin || selectedDestination ? 1 : 0)}/${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED}`
                                    }),
                                    !this.state.routeBuilderToastDismissed && !(selectedOrigin && selectedDestination) && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-favorites__toast",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                className: "route-favorites__toast-text",
                                                children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.route_builder_toast
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                type: "button",
                                                className: "route-favorites__toast-close",
                                                "aria-label": "Dismiss",
                                                onClick: ()=>this.setState({
                                                        routeBuilderToastDismissed: true
                                                    }),
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                    icon: "close",
                                                    size: 15
                                                })
                                            })
                                        ]
                                    }),
                                    this.state.selectedOrigin && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-field__input route-field__input--primary",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__left",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                    className: "icon__origin",
                                                    icon: "position-filled"
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-field__text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__title",
                                                            children: origin
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__subtitle",
                                                            children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)((selectedOrigin?.properties)["Building"] || "")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-favorites__list",
                                        children: buildFavoriteShopList()?.map((shop)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "route-favorites__item route-favorites__item--selected",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-favorites__item-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            className: "route-favorites__radio",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                                    type: "checkbox",
                                                                    checked: selectedWaypoints.findIndex((wp)=>wp.id === shop.id) !== -1,
                                                                    onChange: ()=>this.toggleShop(shop)
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                    className: "route-favorites__radio-icon"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-favorites__item-text",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-favorites__item-title",
                                                                    children: shop.properties["name"]
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                    className: "route-favorites__meta",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            className: "route-favorites__item-subtitle",
                                                                            children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(shop.properties["Building"] || "")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            className: "route-favorites__actions",
                                                                            style: {
                                                                                display: this.shopsToVisit && this.shopsToVisit.features.length >= 2 ? "flex" : "none"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                                                    className: "route-favorites__link",
                                                                                    onClick: ()=>this.setFavShopAsOrigin(shop),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                                            className: "icon__origin",
                                                                                            icon: "position-filled"
                                                                                        }),
                                                                                        (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.set_as_origin || `Set as origin`
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                                                    className: "route-favorites__link",
                                                                                    onClick: ()=>this.setFavShopAsDestination(shop),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                                                            className: "icon__destination",
                                                                                            icon: "marker-filled"
                                                                                        }),
                                                                                        (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.set_as_destination || `Set as destination`
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, shop.id))
                                    }),
                                    this.state.selectedDestination && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "route-field__input route-field__input--error",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__left",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                    className: "icon__destination",
                                                    icon: "marker-filled"
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-field__text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__title",
                                                            children: destination
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "route-field__subtitle",
                                                            children: (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)((selectedDestination?.properties)["Building"] || "")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        !showRouteBuilderSummary && this.state.routeBuilderView === "default" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__footer",
                            children: [
                                this.controller.getWidgetMapMode() !== "favorites" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-field",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-field__label",
                                            children: [
                                                (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.stop_search_label,
                                                " (",
                                                this.state.selectedWaypoints.length,
                                                "/15)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "route-search-input",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-search-input__icon",
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("path", {
                                                            d: "M19.125 20.4L13.15 14.425C12.65 14.7916 12.1017 15.0791 11.5052 15.2875C10.9087 15.4958 10.2739 15.6 9.60073 15.6C7.93356 15.6 6.51664 15.0166 5.34998 13.85C4.18331 12.6833 3.59998 11.2666 3.59998 9.59998C3.59998 7.93331 4.18331 6.51664 5.34998 5.34998C6.51664 4.18331 7.93331 3.59998 9.59998 3.59998C11.2666 3.59998 12.6833 4.18331 13.85 5.34998C15.0166 6.51664 15.6 7.93356 15.6 9.60073C15.6 10.2739 15.4958 10.9087 15.2875 11.5052C15.0791 12.1017 14.7916 12.65 14.425 13.15L20.4 19.125L19.125 20.4ZM9.59998 13.8C10.7666 13.8 11.7583 13.3916 12.575 12.575C13.3916 11.7583 13.8 10.7666 13.8 9.59998C13.8 8.43331 13.3916 7.44164 12.575 6.62498C11.7583 5.80831 10.7666 5.39998 9.59998 5.39998C8.43331 5.39998 7.44164 5.80831 6.62498 6.62498C5.80831 7.44164 5.39998 8.43331 5.39998 9.59998C5.39998 10.7666 5.80831 11.7583 6.62498 12.575C7.44164 13.3916 8.43331 13.8 9.59998 13.8Z",
                                                            fill: "var(--Color-Icon-Secondary, #333333)"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "route-search-input__field",
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fea70e6de74e95e1$export$2e2bcd8739ae039), {
                                                        defaultValue: "",
                                                        src: (value)=>this.autocomplete("searchedStops", "searchedStopsText", value),
                                                        keys: [
                                                            "name"
                                                        ],
                                                        placeholder: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.search_stop,
                                                        value: origin,
                                                        onClose: ()=>this.onAutoCompleteClose("searchedStopsText"),
                                                        clearInputOnSelection: true,
                                                        callbackSelect: (value)=>{
                                                            let selectedStop = null;
                                                            const venue = this.controller._renderer.getVenue();
                                                            if (venue && value) {
                                                                if (value.id > 0) new Promise((resolve)=>{
                                                                    const callback = (featuresCollection)=>{
                                                                        // eslint-disable-next-line max-len
                                                                        selectedStop = featuresCollection && featuresCollection.features[0];
                                                                        resolve(this.setState({
                                                                            selectedStop: selectedStop
                                                                        }, ()=>{
                                                                            if (value) {
                                                                                if (this.state.selectedWaypoints.length < (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.MAX_WAYPOINTS_ALLOWED) {
                                                                                    if (!this.stopExistsInRoute(selectedStop)) {
                                                                                        const updatedWaypoints = [
                                                                                            ...this.state.selectedWaypoints,
                                                                                            selectedStop
                                                                                        ];
                                                                                        this.setState({
                                                                                            selectedWaypoints: updatedWaypoints
                                                                                        }, ()=>{
                                                                                            const container = this.panelRef?.querySelector(".route-panel__content");
                                                                                            if (container) {
                                                                                                const stops = container.querySelectorAll(".route-stop");
                                                                                                const lastStop = stops[stops.length - 1];
                                                                                                if (lastStop) lastStop.scrollIntoView({
                                                                                                    behavior: "smooth",
                                                                                                    block: "nearest"
                                                                                                });
                                                                                            }
                                                                                        });
                                                                                    } else {
                                                                                        this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.duplicate_stop_warning;
                                                                                        this.setState({
                                                                                            showRouteBuilderWarning: true
                                                                                        });
                                                                                        setTimeout(()=>{
                                                                                            this.onHideWarningBanner();
                                                                                        }, 3000);
                                                                                    }
                                                                                    value = "";
                                                                                    this.onAutoCompleteClose("searchedStopsText");
                                                                                } else {
                                                                                    this.routeBuilderWarning = (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.max_stop_limit_warning;
                                                                                    this.setState({
                                                                                        showRouteBuilderWarning: true
                                                                                    });
                                                                                    setTimeout(()=>{
                                                                                        this.onHideWarningBanner();
                                                                                    }, 3000);
                                                                                }
                                                                            }
                                                                            this.controller.trigger(this, "indoor_widget_analytics", [
                                                                                {
                                                                                    event: (0, $3b06b60897362d69$export$ada873a34909da65).SEARCH_RESULT_SELECTED,
                                                                                    args: selectedStop
                                                                                }
                                                                            ]);
                                                                        }));
                                                                    };
                                                                    this.indoorService.search(venue.venue_id, "", callback, undefined, value.id.toString());
                                                                });
                                                            }
                                                        },
                                                        disableAutoFocus: this.controller.getIsAutofocusDisabled(),
                                                        isMobileView: isMobileView()
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-panel__toggle",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.exit_gate_label
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $1d148e12fc214f1e$export$2e2bcd8739ae039), {
                                            isSmall: true,
                                            id: "exitgate_switch",
                                            checked: showExitGates,
                                            onChange: this.onExitGateOpted
                                        })
                                    ]
                                }),
                                this.state.showExitGates && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("section", {
                                    className: "route-panel__section",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "exit-gates",
                                        children: this.state.allExitGates.map((gate)=>{
                                            const props = gate.properties;
                                            const selectedGate = this.state.selectedExitGate;
                                            const isSelected = typeof selectedGate === "object" && selectedGate?.id === gate.id;
                                            return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                className: `exit-gate ${isSelected ? "is-selected" : ""}`,
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.onExitGateSelected(gate);
                                                },
                                                children: props[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] ? props[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] : props["name"]
                                            }, gate.id);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-panel__primary-btn",
                                    disabled: !selectedOrigin || !selectedDestination,
                                    onClick: this.onBuildRouteWithWaypoints,
                                    children: `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.optimized_route_cta_label} ( ${selectedWaypoints.length + (selectedOrigin ? 1 : 0) + (selectedDestination ? 1 : 0)} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.steps})`
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-panel__cancel",
                                    onClick: this.cancelRouteBuilding,
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.cancel
                                })
                            ]
                        }),
                        !showRouteBuilderSummary && this.state.routeBuilderView === "results" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__footer route-result__footer",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-result__cta",
                                    onClick: ()=>{
                                        this.setState({
                                            mode: "itinerary",
                                            showPanel: true
                                        });
                                    },
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.start_navigation
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-result__cancel",
                                    onClick: this.cancelRouteBuilding,
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.cancel
                                })
                            ]
                        }),
                        this.state.showRouteBuilderWarning && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "route-panel__banner",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "route-panel__banner-text",
                                    children: this.routeBuilderWarning
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "route-panel__banner-action",
                                    onClick: this.onHideWarningBanner,
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.cancel
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { mode: mode, isNavigationMode: isNavigationMode } = this.state;
        if (isNavigationMode) return null;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: `woosmap-panel ${mode}`,
            children: [
                this.renderHeader(),
                this.renderPanelContent()
            ]
        });
    }
}




var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");
var $0b06dee5f8010ba6$exports = {};
"use strict";
Object.defineProperty($0b06dee5f8010ba6$exports, "__esModule", {
    value: true
});
$0b06dee5f8010ba6$exports.default = void 0;

var $0b06dee5f8010ba6$var$_propTypes = $0b06dee5f8010ba6$var$_interopRequireDefault((parcelRequire("eCfBx")));

var $0b06dee5f8010ba6$var$_react = $0b06dee5f8010ba6$var$_interopRequireWildcard((parcelRequire("7ikhG")));

var $0b06dee5f8010ba6$var$_swipeJsIso = $0b06dee5f8010ba6$var$_interopRequireDefault((parcelRequire("6STMo")));

var $0b06dee5f8010ba6$var$_lodash = $0b06dee5f8010ba6$var$_interopRequireDefault((parcelRequire("1DYgm")));
function $0b06dee5f8010ba6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $0b06dee5f8010ba6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b06dee5f8010ba6$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0b06dee5f8010ba6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0b06dee5f8010ba6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0b06dee5f8010ba6$var$_typeof(obj);
}
function $0b06dee5f8010ba6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $0b06dee5f8010ba6$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $0b06dee5f8010ba6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0b06dee5f8010ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0b06dee5f8010ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0b06dee5f8010ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0b06dee5f8010ba6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0b06dee5f8010ba6$var$_possibleConstructorReturn(self, call) {
    if (call && ($0b06dee5f8010ba6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $0b06dee5f8010ba6$var$_assertThisInitialized(self);
}
function $0b06dee5f8010ba6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0b06dee5f8010ba6$var$_getPrototypeOf(o) {
    $0b06dee5f8010ba6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b06dee5f8010ba6$var$_getPrototypeOf(o);
}
function $0b06dee5f8010ba6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0b06dee5f8010ba6$var$_setPrototypeOf(subClass, superClass);
}
function $0b06dee5f8010ba6$var$_setPrototypeOf(o, p) {
    $0b06dee5f8010ba6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0b06dee5f8010ba6$var$_setPrototypeOf(o, p);
}
function $0b06dee5f8010ba6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0b06dee5f8010ba6$var$ReactSwipe = /*#__PURE__*/ function(_Component) {
    $0b06dee5f8010ba6$var$_inherits(ReactSwipe, _Component);
    function ReactSwipe() {
        $0b06dee5f8010ba6$var$_classCallCheck(this, ReactSwipe);
        return $0b06dee5f8010ba6$var$_possibleConstructorReturn(this, $0b06dee5f8010ba6$var$_getPrototypeOf(ReactSwipe).apply(this, arguments));
    }
    $0b06dee5f8010ba6$var$_createClass(ReactSwipe, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.swipe = (0, $0b06dee5f8010ba6$var$_swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, childCount = _this$props.childCount, swipeOptions = _this$props.swipeOptions;
                var shouldUpdateSwipeInstance = prevProps.childCount !== childCount || !(0, $0b06dee5f8010ba6$var$_lodash.default)(prevProps.swipeOptions, swipeOptions);
                if (shouldUpdateSwipeInstance) {
                    this.swipe.kill();
                    this.swipe = (0, $0b06dee5f8010ba6$var$_swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.swipe.kill();
                this.swipe = void 0;
            }
        },
        {
            key: "next",
            value: function next() {
                this.swipe.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this.swipe.prev();
            }
        },
        {
            key: "slide",
            value: function slide() {
                var _this$swipe;
                (_this$swipe = this.swipe).slide.apply(_this$swipe, arguments);
            }
        },
        {
            key: "getPos",
            value: function getPos() {
                return this.swipe.getPos();
            }
        },
        {
            key: "getNumSlides",
            value: function getNumSlides() {
                return this.swipe.getNumSlides();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props2 = this.props, id = _this$props2.id, className = _this$props2.className, style = _this$props2.style, children = _this$props2.children;
                return $0b06dee5f8010ba6$var$_react.default.createElement("div", {
                    id: id,
                    ref: function ref(el) {
                        return _this.containerEl = el;
                    },
                    className: "react-swipe-container ".concat(className),
                    style: style.container
                }, $0b06dee5f8010ba6$var$_react.default.createElement("div", {
                    style: style.wrapper
                }, $0b06dee5f8010ba6$var$_react.default.Children.map(children, function(child) {
                    if (!child) return null;
                    var childStyle = child.props.style ? $0b06dee5f8010ba6$var$_objectSpread({}, style.child, child.props.style) : style.child;
                    return $0b06dee5f8010ba6$var$_react.default.cloneElement(child, {
                        style: childStyle
                    });
                })));
            }
        }
    ]);
    return ReactSwipe;
}($0b06dee5f8010ba6$var$_react.Component);
$0b06dee5f8010ba6$var$_defineProperty($0b06dee5f8010ba6$var$ReactSwipe, "propTypes", {
    swipeOptions: $0b06dee5f8010ba6$var$_propTypes.default.shape({
        startSlide: $0b06dee5f8010ba6$var$_propTypes.default.number,
        speed: $0b06dee5f8010ba6$var$_propTypes.default.number,
        auto: $0b06dee5f8010ba6$var$_propTypes.default.number,
        continuous: $0b06dee5f8010ba6$var$_propTypes.default.bool,
        disableScroll: $0b06dee5f8010ba6$var$_propTypes.default.bool,
        stopPropagation: $0b06dee5f8010ba6$var$_propTypes.default.bool,
        swiping: $0b06dee5f8010ba6$var$_propTypes.default.func,
        callback: $0b06dee5f8010ba6$var$_propTypes.default.func,
        transitionEnd: $0b06dee5f8010ba6$var$_propTypes.default.func
    }),
    style: $0b06dee5f8010ba6$var$_propTypes.default.shape({
        container: $0b06dee5f8010ba6$var$_propTypes.default.object,
        wrapper: $0b06dee5f8010ba6$var$_propTypes.default.object,
        child: $0b06dee5f8010ba6$var$_propTypes.default.object
    }),
    id: $0b06dee5f8010ba6$var$_propTypes.default.string,
    className: $0b06dee5f8010ba6$var$_propTypes.default.string,
    childCount: $0b06dee5f8010ba6$var$_propTypes.default.number
});
$0b06dee5f8010ba6$var$_defineProperty($0b06dee5f8010ba6$var$ReactSwipe, "defaultProps", {
    swipeOptions: {},
    style: {
        container: {
            overflow: 'hidden',
            visibility: 'hidden',
            position: 'relative'
        },
        wrapper: {
            overflow: 'hidden',
            position: 'relative'
        },
        child: {
            float: 'left',
            width: '100%',
            position: 'relative',
            transitionProperty: 'transform'
        }
    },
    className: '',
    childCount: 0
});
var $0b06dee5f8010ba6$var$_default = $0b06dee5f8010ba6$var$ReactSwipe;
$0b06dee5f8010ba6$exports.default = $0b06dee5f8010ba6$var$_default;
$0b06dee5f8010ba6$exports = $0b06dee5f8010ba6$exports["default"];







var $874cdec169ff91b0$var$__defProp = Object.defineProperty;
var $874cdec169ff91b0$var$__defProps = Object.defineProperties;
var $874cdec169ff91b0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $874cdec169ff91b0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $874cdec169ff91b0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $874cdec169ff91b0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $874cdec169ff91b0$var$__defNormalProp = (obj, key, value)=>key in obj ? $874cdec169ff91b0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $874cdec169ff91b0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($874cdec169ff91b0$var$__hasOwnProp.call(b, prop)) $874cdec169ff91b0$var$__defNormalProp(a, prop, b[prop]);
    if ($874cdec169ff91b0$var$__getOwnPropSymbols) {
        for (var prop of $874cdec169ff91b0$var$__getOwnPropSymbols(b))if ($874cdec169ff91b0$var$__propIsEnum.call(b, prop)) $874cdec169ff91b0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $874cdec169ff91b0$var$__spreadProps = (a, b)=>$874cdec169ff91b0$var$__defProps(a, $874cdec169ff91b0$var$__getOwnPropDescs(b));
function $874cdec169ff91b0$export$d62bc67813d804ea(lines, pt, options = {}) {
    if (!lines || !pt) throw new Error("lines and pt are required arguments");
    const ptPos = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(pt);
    let closestPt = (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)([
        Infinity,
        Infinity
    ], {
        dist: Infinity,
        index: -1,
        multiFeatureIndex: -1,
        location: -1
    });
    let length = 0;
    (0, $3585f2d1a61dd970$export$12cba8b31beb353b)(lines, function(line, _featureIndex, multiFeatureIndex) {
        const coords = (0, $9b195126e45e4c4e$export$39e042fd83f1b62e)(line);
        for(let i = 0; i < coords.length - 1; i++){
            const start = (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[i]);
            const startPos = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(start);
            const stop = (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[i + 1]);
            const stopPos = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(stop);
            const sectionLength = (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(start, stop, options);
            let intersectPos;
            let wasEnd;
            if (stopPos[0] === ptPos[0] && stopPos[1] === ptPos[1]) [intersectPos, wasEnd] = [
                stopPos,
                true
            ];
            else if (startPos[0] === ptPos[0] && startPos[1] === ptPos[1]) [intersectPos, wasEnd] = [
                startPos,
                false
            ];
            else [intersectPos, wasEnd] = $874cdec169ff91b0$var$nearestPointOnSegment(startPos, stopPos, ptPos);
            const intersectPt = (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(intersectPos, {
                dist: (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(pt, intersectPos, options),
                multiFeatureIndex: multiFeatureIndex,
                location: length + (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(start, intersectPos, options)
            });
            if (intersectPt.properties.dist < closestPt.properties.dist) closestPt = $874cdec169ff91b0$var$__spreadProps($874cdec169ff91b0$var$__spreadValues({}, intersectPt), {
                properties: $874cdec169ff91b0$var$__spreadProps($874cdec169ff91b0$var$__spreadValues({}, intersectPt.properties), {
                    // Legacy behaviour where index progresses to next segment # if we
                    // went with the end point this iteration.
                    index: wasEnd ? i + 1 : i
                })
            });
            length += sectionLength;
        }
    });
    return closestPt;
}
function $874cdec169ff91b0$var$dot(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return v1x * v2x + v1y * v2y + v1z * v2z;
}
function $874cdec169ff91b0$var$cross(v1, v2) {
    const [v1x, v1y, v1z] = v1;
    const [v2x, v2y, v2z] = v2;
    return [
        v1y * v2z - v1z * v2y,
        v1z * v2x - v1x * v2z,
        v1x * v2y - v1y * v2x
    ];
}
function $874cdec169ff91b0$var$magnitude(v) {
    return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2) + Math.pow(v[2], 2));
}
function $874cdec169ff91b0$var$normalize(v) {
    const mag = $874cdec169ff91b0$var$magnitude(v);
    return [
        v[0] / mag,
        v[1] / mag,
        v[2] / mag
    ];
}
function $874cdec169ff91b0$var$lngLatToVector(a) {
    const lat = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(a[1]);
    const lng = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(a[0]);
    return [
        Math.cos(lat) * Math.cos(lng),
        Math.cos(lat) * Math.sin(lng),
        Math.sin(lat)
    ];
}
function $874cdec169ff91b0$var$vectorToLngLat(v) {
    const [x, y, z] = v;
    const zClamp = Math.min(Math.max(z, -1), 1);
    const lat = (0, $99d87cb8abf11eaa$export$c41dd2a8460d3196)(Math.asin(zClamp));
    const lng = (0, $99d87cb8abf11eaa$export$c41dd2a8460d3196)(Math.atan2(y, x));
    return [
        lng,
        lat
    ];
}
function $874cdec169ff91b0$var$nearestPointOnSegment(posA, posB, posC) {
    const A = $874cdec169ff91b0$var$lngLatToVector(posA);
    const B = $874cdec169ff91b0$var$lngLatToVector(posB);
    const C = $874cdec169ff91b0$var$lngLatToVector(posC);
    const segmentAxis = $874cdec169ff91b0$var$cross(A, B);
    if (segmentAxis[0] === 0 && segmentAxis[1] === 0 && segmentAxis[2] === 0) {
        if ($874cdec169ff91b0$var$dot(A, B) > 0) return [
            [
                ...posB
            ],
            true
        ];
        else return [
            [
                ...posC
            ],
            false
        ];
    }
    const targetAxis = $874cdec169ff91b0$var$cross(segmentAxis, C);
    if (targetAxis[0] === 0 && targetAxis[1] === 0 && targetAxis[2] === 0) return [
        [
            ...posB
        ],
        true
    ];
    const intersectionAxis = $874cdec169ff91b0$var$cross(targetAxis, segmentAxis);
    const I1 = $874cdec169ff91b0$var$normalize(intersectionAxis);
    const I2 = [
        -I1[0],
        -I1[1],
        -I1[2]
    ];
    const I = $874cdec169ff91b0$var$dot(C, I1) > $874cdec169ff91b0$var$dot(C, I2) ? I1 : I2;
    const segmentAxisNorm = $874cdec169ff91b0$var$normalize(segmentAxis);
    const cmpAI = $874cdec169ff91b0$var$dot($874cdec169ff91b0$var$cross(A, I), segmentAxisNorm);
    const cmpIB = $874cdec169ff91b0$var$dot($874cdec169ff91b0$var$cross(I, B), segmentAxisNorm);
    if (cmpAI >= 0 && cmpIB >= 0) return [
        $874cdec169ff91b0$var$vectorToLngLat(I),
        false
    ];
    if ($874cdec169ff91b0$var$dot(A, C) > $874cdec169ff91b0$var$dot(B, C)) return [
        [
            ...posA
        ],
        false
    ];
    else return [
        [
            ...posB
        ],
        true
    ];
}
var $874cdec169ff91b0$export$2e2bcd8739ae039 = $874cdec169ff91b0$export$d62bc67813d804ea;



// index.ts


function $318ba6930f9c5ea7$export$f24224f1c91d8156(geojson, options = {}) {
    return (0, $3585f2d1a61dd970$export$eec78cdd4d343a79)(geojson, (previousValue, segment)=>{
        const coords = segment.geometry.coordinates;
        return previousValue + (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(coords[0], coords[1], options);
    }, 0);
}
var $318ba6930f9c5ea7$export$2e2bcd8739ae039 = $318ba6930f9c5ea7$export$f24224f1c91d8156;



class $97813de16aa249a8$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    constructor(props){
        super();
        this.state = {
            currentStep: 0,
            overview: false,
            enableSound: true,
            enableFocus: false,
            userLocation: {},
            prevUserLocationLevel: 0,
            lastDeviationNotification: 0,
            currentLeg: 0
        };
        this.levelWiseSteps = [];
        this.totalSteps = 0;
        this.leashDistance = 10;
        this.bearingToApply = 0;
        this.prevUserLoc = {};
        this.proximityAlertRaised = false;
        this.controller = props.controller;
        this.headerRef = (0, $7Do5B.createRef)();
        this.setMapControls(false);
        this.userIcon = {
            url: `https://sdk.woosmap.com/map/assets/navigation-arrow.svg`,
            scaledSize: {
                height: 60,
                width: 60
            },
            anchor: new woosmap.map.Point(30, 30)
        };
        this.userIcon3d = {
            url: `https://sdk.woosmap.com/map/assets/navigation-arrow-3d.svg`,
            scaledSize: {
                height: 60,
                width: 60
            },
            anchor: new woosmap.map.Point(30, 30)
        };
        this.userDeviationInterval = 15000;
        this.proximityThreshold = 10; //In meters
        this.renderItinerary = this.renderItinerary.bind(this);
        this.renderOverview = this.renderOverview.bind(this);
        this.highlightStep = this.highlightStep.bind(this);
        this.renderInstructionHeader = this.renderInstructionHeader.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.showUserMarker = this.showUserMarker.bind(this);
        this.setMapControls = this.setMapControls.bind(this);
        this.recenterNavigation = this.recenterNavigation.bind(this);
        this.buildRouteFeatureCollection = this.buildRouteFeatureCollection.bind(this);
        this.locateNearestLandmarkForUser = this.locateNearestLandmarkForUser.bind(this);
        this.groupStepsByLevel = this.groupStepsByLevel.bind(this);
        this.computeTotalStepsUptoLevel = this.computeTotalStepsUptoLevel.bind(this);
        this.latchUserLocationOnRoute = this.latchUserLocationOnRoute.bind(this);
        this.controller._indoorRenderer.addListener('indoor_user_location', this.updateUserLocation.bind(this));
    }
    componentDidMount() {
        const userCurrentLocation = this.controller._indoorRenderer.getUserLocation();
        this.highlightStep(0);
        if (userCurrentLocation) {
            const userLocation = {
                type: 'Feature',
                id: -1,
                geometry: {
                    type: 'Point',
                    coordinates: [
                        userCurrentLocation.position.lng,
                        userCurrentLocation.position.lat
                    ]
                },
                properties: {
                    level: userCurrentLocation.level.toString(),
                    name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['Your Location'],
                    pk: '-1'
                }
            };
            //@ts-ignore
            this.latchUserLocationOnRoute(userLocation);
        }
        this.buildRouteFeatureCollection();
    }
    componentWillUnmount() {
        this.levelWiseSteps = [];
        this.setMapControls(true);
        if (this.marker) this.marker.setMap(null);
    }
    componentDidUpdate(_prevProps, prevState) {
        const { currentStep: currentStep, overview: overview, userLocation: userLocation } = this.state;
        const { resetDirections: resetDirections, selectedWaypoints: selectedWaypoints } = this.props;
        if (currentStep !== prevState.currentStep) {
            let prevStep = prevState.currentStep;
            ///* TO DO: IF THEY ASK FOR 3D ARROW WHILE JUMPING BETWEEN WAYPOINTS
            if (selectedWaypoints) prevStep = currentStep - 1;
            this.highlightStep(currentStep, prevStep);
        }
        if (userLocation !== prevState.userLocation) {
            // eslint-disable-next-line max-len
            if (prevState.userLocation.properties && userLocation.properties && parseInt(userLocation.properties.level) !== parseInt(prevState.userLocation.properties.level)) this.setState({
                prevUserLocationLevel: parseInt(prevState.userLocation.properties.level)
            });
            this.latchUserLocationOnRoute(userLocation, prevState.userLocation);
            this._checkProximityToDestination();
        }
        const marker = this.marker;
        if (overview !== prevState.overview) {
            if (overview) {
                resetDirections();
                this.setMapControls(true);
                if (marker) {
                    marker.setIcon(this.userIcon);
                    marker.setPitchAlignment('map');
                }
            } else {
                this.highlightStep(currentStep);
                this.setMapControls(false);
                if (marker) {
                    marker.setIcon(this.userIcon3d);
                    marker.setPitchAlignment('viewport');
                }
            }
        }
    }
    setMapControls(enable) {
        const map = this.controller._indoorRenderer.map;
        const mapboxMap = map ? this.controller._indoorRenderer._getMapboxMap(map) : null;
        if (map && mapboxMap) {
            const controls = map._container ? map._container.getElementsByClassName('mapboxgl-ctrl') : null;
            if (enable) {
                mapboxMap.dragRotate.enable();
                mapboxMap.touchPitch.enable();
                if (controls) for (const control of controls)control.style.display = 'flex';
            } else {
                mapboxMap.dragRotate.disable();
                mapboxMap.touchPitch.disable();
                if (controls) {
                    for (const control of controls)if (!control.classList.contains('mapboxgl-ctrl-attrib')) control.style.display = 'none';
                }
            }
            mapboxMap.on('move', this._mapMovedHandler.bind(this));
        }
    }
    recenterNavigation() {
        const { userLocation: userLocation } = this.state;
        const marker = userLocation.geometry ? this.controller._indoorRenderer._userMarker : this.marker;
        if (marker) {
            const map = this.controller._indoorRenderer.map;
            if (map) {
                const mapboxMap = this.controller._indoorRenderer._getMapboxMap(map);
                mapboxMap.easeTo({
                    bearing: marker.getRotation(),
                    duration: 1000,
                    zoom: 20,
                    center: {
                        lat: marker.getPosition().lat(),
                        lng: marker.getPosition().lng()
                    }
                });
            }
        }
    }
    showUserMarker(prevFeature, feature, reverse = false) {
        const { controller: controller } = this.props;
        const { userLocation: userLocation } = this.state;
        if (feature) {
            const map = controller._indoorRenderer.map;
            const geoJSONData = feature.geometry;
            let coordinates = [];
            if (geoJSONData.type === "LineString") coordinates = geoJSONData.coordinates;
            const lat = coordinates[0][1];
            const lng = coordinates[0][0];
            const bearing = parseInt(feature.properties.bearing) || 0;
            if (map) {
                if (!this.marker) {
                    const marker = new window.woosmap.map.Marker({
                        position: {
                            lat: lat,
                            lng: lng
                        },
                        icon: this.userIcon3d
                    });
                    marker.setMap(map);
                    marker.setRotationAlignment('map');
                    marker.setPitchAlignment('viewport');
                    marker.setRotation(bearing);
                    this.marker = marker;
                    if (userLocation.geometry !== undefined) marker.setOpacity(0);
                } else if (prevFeature) {
                    if (reverse) {
                        this.marker.setRotation(bearing);
                        if (this.marker && this.marker.moveAlong) this.marker.moveAlong([
                            ...coordinates
                        ].reverse(), bearing);
                    } else {
                        const geoJSONData = prevFeature.geometry;
                        let coordinates = [];
                        if (geoJSONData.type === "LineString") coordinates = geoJSONData.coordinates;
                        if (this.marker.moveAlong) this.marker.moveAlong(coordinates, bearing);
                    }
                }
            }
        }
    }
    highlightStep(currentStep, prevStep) {
        const { directions: directions, highlightStep: highlightStep } = this.props;
        const { enableSound: enableSound, userLocation: userLocation } = this.state;
        let feature = null;
        let prevFeature = null;
        let index = 0;
        if (directions && directions.routes && directions.routes.length > 0) {
            const route = directions.routes[0];
            if (route.legs && route.legs.length > 0) {
                route.legs.forEach((leg)=>{
                    if (leg && leg.steps) leg.steps.forEach((step)=>{
                        if (index === currentStep) feature = {
                            type: 'Feature',
                            id: index,
                            isLastStep: index === leg.steps.length - 1,
                            properties: {
                                id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                floor: `${step.start_location.level}`,
                                instruction: step.instruction ? step.instruction.summary : '',
                                bearing: step.bearing_start ? `${step.bearing_start}` : `0`,
                                icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : 'caret-down'
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: step.polyline
                            }
                        };
                        if (index === prevStep) prevFeature = {
                            type: 'Feature',
                            id: index,
                            properties: {
                                id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                floor: `${step.start_location.level}`,
                                instruction: step.instruction ? step.instruction.summary : '',
                                bearing: step.bearing_start ? `${step.bearing_start}` : `0`,
                                icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : 'caret-down'
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: step.polyline
                            }
                        };
                        index = index + 1;
                    });
                });
                if (feature) {
                    const isPrevStep = prevStep !== null && prevStep !== undefined && prevStep > currentStep;
                    highlightStep(feature, true, true, isPrevStep ? false : enableSound);
                    //@ts-ignore
                    this.bearingToApply = parseInt(feature.properties.bearing) || 0;
                    if (userLocation.geometry === undefined) this.showUserMarker(prevFeature, feature, isPrevStep);
                    if ('speechSynthesis' in window && !isPrevStep && enableSound) {
                        const msg = new SpeechSynthesisUtterance();
                        //@ts-ignore
                        msg.text = feature.properties.instruction;
                        msg.lang = (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase();
                        if (this.timeout) clearTimeout(this.timeout);
                        this.timeout = setTimeout(()=>{
                            window.speechSynthesis.speak(msg);
                        }, 700);
                    }
                    if (isPrevStep) this.proximityAlertRaised = false;
                }
            }
        }
    }
    latchUserLocationOnRoute(currentUserLoc, prevUserLoc) {
        const { setUserLocation: setUserLocation } = this.props;
        if (currentUserLoc && currentUserLoc.geometry) {
            const geoJSONData = currentUserLoc.geometry;
            let coordinates;
            if (geoJSONData.type === "Point") coordinates = geoJSONData.coordinates;
            if (coordinates && coordinates.length > 0) {
                const lat = coordinates[1];
                const lng = coordinates[0];
                if (this.marker && this.controller._indoorRenderer.isUserInsideVenue(lat, lng)) this.marker.setOpacity(0);
                const level = parseInt(currentUserLoc.properties.level);
                setUserLocation(lat, lng, level, this.bearingToApply, false, true);
                const userMarker = this.controller._indoorRenderer._userMarker;
                userMarker.setIcon(this.userIcon3d);
                userMarker.setPitchAlignment('viewport');
                const userTrail = [];
                if (prevUserLoc && prevUserLoc.geometry) {
                    const geoJSONData = prevUserLoc.geometry;
                    let coordinates;
                    if (geoJSONData.type === "Point") coordinates = geoJSONData.coordinates;
                    if (coordinates && coordinates.length > 0) {
                        userTrail.push([
                            coordinates[0],
                            coordinates[1]
                        ]);
                        userTrail.push([
                            lng,
                            lat
                        ]);
                        if (userMarker && userMarker.moveAlong) userMarker.moveAlong(userTrail, this.bearingToApply);
                    }
                }
            }
        }
    }
    _mapMovedHandler() {
        const marker = this.marker;
        const map = this.controller._indoorRenderer.map;
        if (marker && map) this.setState({
            enableFocus: !map.getBounds().contains(marker.getPosition())
        });
    }
    updateUserLocation() {
        const userCurrentLocation = this.controller._indoorRenderer.getUserLocation();
        if (!userCurrentLocation) return;
        const lat = userCurrentLocation.position.lat;
        const lng = userCurrentLocation.position.lng;
        if (!this.controller._indoorRenderer.isUserInsideVenue(lat, lng)) return;
        if (!userCurrentLocation.adjusted) this.locateNearestLandmarkForUser();
    }
    buildRouteFeatureCollection() {
        const { directions: directions } = this.props;
        const routeSteps = [];
        if (directions && directions.routes && directions.routes.length > 0) {
            const route = directions.routes[0];
            if (route.legs && route.legs.length > 0) route.legs.forEach((leg)=>{
                if (leg && leg.steps) {
                    this.totalSteps = this.totalSteps + leg.steps.length;
                    leg.steps.forEach((step)=>{
                        routeSteps.push(step);
                    });
                }
            });
        }
        this.levelWiseSteps = this.groupStepsByLevel(routeSteps);
    }
    locateNearestLandmarkForUser() {
        const userCurrentLocation = this.controller._indoorRenderer.getUserLocation();
        if (!userCurrentLocation) return;
        const currentLevel = userCurrentLocation.level;
        const routeCoordinates = [];
        const routePolylineChunks = [];
        const { prevUserLocationLevel: prevUserLocationLevel } = this.state;
        const prevLevelIndex = this.levelWiseSteps.findIndex((element)=>element.level === prevUserLocationLevel);
        const levelRepeated = this.levelWiseSteps.filter((element)=>element.level === currentLevel);
        let stepsForLevel;
        //Handled for multi floor routes that go through the same level more than once in the entire itinerary.
        if (prevLevelIndex > 0 && levelRepeated.length > 1) // eslint-disable-next-line max-len
        stepsForLevel = this.levelWiseSteps.find((element, index)=>element.level === currentLevel && index > prevLevelIndex);
        else stepsForLevel = this.levelWiseSteps.find((element)=>element.level === currentLevel);
        //Handled for multi-floor routes to get nearest point on a route for the level where the user is located
        if (stepsForLevel && stepsForLevel.steps) {
            stepsForLevel.steps.forEach((step, stepIndex)=>{
                if (stepIndex === 0) routeCoordinates.push([
                    step.start_location.lng,
                    step.start_location.lat
                ]);
                routeCoordinates.push([
                    step.end_location.lng,
                    step.end_location.lat
                ]);
                step.polyline.forEach((segment)=>{
                    routePolylineChunks.push([
                        segment[0],
                        segment[1]
                    ]);
                });
            });
            const polylineChunksForRoute = (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)(routePolylineChunks);
            const mergedPolylinesForRoute = (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)(routeCoordinates);
            const userPt = (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)([
                userCurrentLocation.position.lng,
                userCurrentLocation.position.lat
            ]);
            const calibratedUserLocation = (0, $874cdec169ff91b0$export$2e2bcd8739ae039)(polylineChunksForRoute, userPt);
            const userLocationNearLandmark = (0, $874cdec169ff91b0$export$2e2bcd8739ae039)(mergedPolylinesForRoute, userPt);
            const distanceApart = calibratedUserLocation.properties.dist * 1000;
            let userLocation = {
                type: 'Feature',
                id: -1,
                geometry: {
                    type: 'Point',
                    coordinates: [
                        userCurrentLocation.position.lng,
                        userCurrentLocation.position.lat
                    ]
                },
                properties: {
                    level: userCurrentLocation.level.toString(),
                    name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['Your Location'],
                    pk: '-1'
                }
            };
            if (distanceApart <= this.leashDistance) {
                const adjustedLat = calibratedUserLocation.geometry.coordinates[1];
                const adjustedLng = calibratedUserLocation.geometry.coordinates[0];
                userLocation = {
                    ...userLocation,
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            adjustedLng,
                            adjustedLat
                        ]
                    }
                };
                // Handled for computing the proper index to set for currentStep. Index derived from turf helper classes considers the route segments on a particular level.
                const stepsUptoCurrentLevel = this.computeTotalStepsUptoLevel(userCurrentLocation.level);
                if (userLocationNearLandmark.properties.index + stepsUptoCurrentLevel < this.totalSteps) this.setState({
                    currentStep: userLocationNearLandmark.properties.index + stepsUptoCurrentLevel
                });
            } else {
                const { notifyUserDeviated: notifyUserDeviated } = this.props;
                const { lastDeviationNotification: lastDeviationNotification } = this.state;
                if (lastDeviationNotification === 0 || Date.now() - lastDeviationNotification > this.userDeviationInterval) {
                    this.setState({
                        lastDeviationNotification: Date.now()
                    });
                    notifyUserDeviated(userLocation);
                }
            }
            this.setState({
                userLocation: userLocation
            });
        }
    }
    groupStepsByLevel(steps) {
        const instructionsByLevel = [];
        let lastStepsByLevel = {
            level: null,
            steps: []
        };
        steps.forEach((step)=>{
            if (lastStepsByLevel.level !== step.start_location.level) {
                lastStepsByLevel = {
                    level: step.start_location.level,
                    steps: []
                };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    computeTotalStepsUptoLevel(currentLevel) {
        const { prevUserLocationLevel: prevUserLocationLevel } = this.state;
        const prevLevelIndex = this.levelWiseSteps.findIndex((element)=>element.level === prevUserLocationLevel);
        const levelRepeated = this.levelWiseSteps.filter((element)=>element.level === currentLevel);
        let stepIndex;
        if (prevLevelIndex > 0 && levelRepeated.length > 1) // eslint-disable-next-line max-len
        stepIndex = this.levelWiseSteps.findIndex((element, index)=>element.level === currentLevel && index > prevLevelIndex);
        else stepIndex = this.levelWiseSteps.findIndex((element)=>element.level === currentLevel);
        let counter = 0;
        let total = 0;
        if (stepIndex > 0) while(counter < stepIndex){
            total = total + this.levelWiseSteps[counter].steps.length;
            counter = counter + 1;
        }
        return total;
    }
    _checkProximityToDestination() {
        const userCurrentLocation = this.controller._indoorRenderer.getUserLocation();
        const { currentStep: currentStep } = this.state;
        const userLat = userCurrentLocation.position.lat;
        const userLon = userCurrentLocation.position.lng;
        const { directions: directions } = this.props;
        if (directions && directions.routes && directions.routes.length > 0) {
            const route = directions.routes[0];
            if (route.legs && route.legs.length > 0) route.legs.forEach((leg)=>{
                const destination = leg.end_location;
                const distanceFromDest = this._calcDistanceBetweenPoints(userLat, userLon, destination.lat, destination.lng);
                const { notifyProximityToDest: notifyProximityToDest } = this.props;
                if (!this.proximityAlertRaised && distanceFromDest <= this.proximityThreshold && currentStep === this.totalSteps - 1 && userCurrentLocation.level === destination.level) {
                    this.proximityAlertRaised = true;
                    notifyProximityToDest();
                }
            });
        }
    }
    _calcDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
        const line = (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
            [
                lon1,
                lat1
            ],
            [
                lon2,
                lat2
            ]
        ]);
        const lengthInKm = (0, $318ba6930f9c5ea7$export$2e2bcd8739ae039)(line);
        return lengthInKm * 1000;
    }
    _jumpToStep(leg) {
        const { directions: directions } = this.props;
        if (directions && directions.routes && directions.routes.length > 0) {
            const route = directions.routes[0];
            if (route.legs && route.legs.length > 0) {
                const legToJump = route.legs[leg];
                if (legToJump && legToJump.steps && legToJump.steps.length > 0) {
                    //Count steps in selected leg and all previous legs to get the correct step index
                    let stepIndex = 0;
                    for(let i = 0; i < leg; i++){
                        const previousLeg = route.legs[i];
                        stepIndex = stepIndex + previousLeg.steps.length;
                    }
                    // stepIndex = stepIndex + legToJump.steps.length;
                    this.setState({
                        currentStep: stepIndex,
                        currentLeg: leg
                    });
                }
            }
        }
    }
    _getLegGlobalBounds(legIndex) {
        const legs = this.props.directions.routes[0].legs;
        let stepCounter = 0;
        for(let i = 0; i < legs.length; i++){
            const steps = legs[i].steps ?? [];
            const legLength = steps.length;
            if (i === legIndex) return {
                start: stepCounter,
                end: stepCounter + legLength - 1
            };
            stepCounter += legLength;
        }
        return {
            start: 0,
            end: 0
        };
    }
    isAtStartOfCurrentLeg() {
        const { currentStep: currentStep, currentLeg: currentLeg } = this.state;
        const { start: start } = this._getLegGlobalBounds(currentLeg);
        return currentStep === start;
    }
    isAtEndOfCurrentLeg() {
        const { currentStep: currentStep, currentLeg: currentLeg } = this.state;
        const { end: end } = this._getLegGlobalBounds(currentLeg);
        return currentStep === end;
    }
    _jumpToNextLeg() {
        if (this.isAtEndOfCurrentLeg()) this.setState((prev)=>({
                currentLeg: prev.currentLeg + 1
            }));
    }
    _jumpToPrevLeg() {
        if (this.isAtStartOfCurrentLeg()) this.setState((prev)=>({
                currentLeg: prev.currentLeg - 1
            }));
    }
    getWaypointName(waypoint) {
        const { selectedWaypoints: selectedWaypoints } = this.props;
        if (selectedWaypoints && selectedWaypoints.length > 0) {
            const selectedWaypoint = selectedWaypoints.find((wp)=>wp.id && wp.id.toString() === waypoint);
            return selectedWaypoint && selectedWaypoint.properties && selectedWaypoint.properties.name ? selectedWaypoint.properties.name : '';
        }
        return '';
    }
    renderInstructionHeader(previousStep, step, index) {
        const instruction = step && step.instruction;
        const prevInstruction = previousStep.instruction;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "woosmap-navigation-panel__steps-container",
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "woosmap-navigation-panel__step",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "woosmap-navigation-panel__step__current",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 52,
                                icon: "nav-walk_straight_small"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                children: [
                                    prevInstruction?.summary,
                                    ". ",
                                    (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Then,
                                    " ",
                                    instruction?.summary,
                                    " ",
                                    !step && (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['you are arrived']
                                ]
                            })
                        ]
                    }),
                    step && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "woosmap-navigation-panel__step__next",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 48,
                                icon: `nav-${instruction.instruction_type || 'walk_straight_small'}`
                            }),
                            previousStep.distance.value > 0 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                children: [
                                    (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.in,
                                    " ",
                                    previousStep.distance.text
                                ]
                            })
                        ]
                    })
                ]
            })
        }, index);
    }
    renderItinerary() {
        const { directions: directions } = this.props;
        const routeSteps = [];
        let previousStep = null;
        if (directions && directions.routes && directions.routes.length > 0) {
            const route = directions.routes[0];
            if (route.legs && route.legs.length > 0) route.legs.forEach((leg)=>{
                if (leg && leg.steps) leg.steps.forEach((step)=>{
                    if (previousStep) routeSteps.push(this.renderInstructionHeader(previousStep, step, routeSteps.length));
                    previousStep = step;
                });
            });
        }
        if (previousStep) routeSteps.push(this.renderInstructionHeader(previousStep, null, routeSteps.length));
        return routeSteps;
    }
    renderOverview() {
        const { closeCb: closeCb } = this.props;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "woosmap-navigation-panel__overview",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn btn--bordered btn--quit",
                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit,
                    onClick: closeCb,
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn btn--bordered btn--primary btn--resume",
                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Overview,
                    onClick: ()=>{
                        this.setState({
                            overview: false
                        });
                    },
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Resume
                })
            ]
        });
    }
    renderFooter() {
        const { closeCb: closeCb, directions: directions, selectedWaypoints: selectedWaypoints, selectedDestination: selectedDestination } = this.props;
        const { currentStep: currentStep, enableSound: enableSound, currentLeg: currentLeg, enableFocus: enableFocus } = this.state;
        let stepToDisplay = null;
        let index = 0;
        let duration = 0; // remaining duration in current leg
        let totalDistance = 0; // remaining distance in current leg
        let totalSteps = 0;
        let totalLegs = 0;
        let destinationName = '';
        let stopDuration = 0; // full leg duration
        let stopDistance = 0; // full leg distance
        let legStartIndex = 0;
        let legEndIndex = 0;
        if (directions?.routes?.length > 0) {
            const route = directions.routes[0];
            if (route.legs?.length > 0) {
                totalLegs = route.legs.length;
                let counter = 0;
                route.legs.forEach((leg, legIndex)=>{
                    const stepsCount = leg.steps?.length ?? 0;
                    if (legIndex === currentLeg) {
                        legStartIndex = counter;
                        legEndIndex = counter + stepsCount - 1;
                    }
                    counter += stepsCount;
                });
                route.legs.forEach((leg, legIndex)=>{
                    if (!leg?.steps) return;
                    totalSteps += leg.steps.length;
                    leg.steps.forEach((step)=>{
                        // current step to display
                        if (index === currentStep) stepToDisplay = step;
                        // remaining duration & distance ONLY for current leg
                        if (index >= currentStep && index <= legEndIndex && legIndex === currentLeg) {
                            duration += step.duration.value;
                            totalDistance += step.distance.value;
                        }
                        index++;
                    });
                    // full leg (stop-to-stop) values
                    if (legIndex === currentLeg) {
                        stopDuration += leg.duration.value;
                        stopDistance = Math.round(stopDistance + leg.distance.value);
                        const waypointId = leg.waypoint;
                        destinationName = this.getWaypointName(waypointId);
                        if (waypointId === null) {
                            //User has reached final stop so now display the final destination poi name
                            const destProps = selectedDestination?.properties;
                            destinationName = destProps ? destProps[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] || destProps.name || '' : '';
                        }
                    }
                });
            }
        }
        if (!stepToDisplay) return null;
        duration = Math.floor(duration / 60);
        totalDistance = Math.round(totalDistance);
        stopDuration = Math.round(stopDuration / 60);
        const durationLabel = duration > 0 ? `${duration} min` : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['Less than 1min'];
        const distanceLabel = `${totalDistance} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['meters']}`;
        const stopdurationLabel = stopDuration > 0 ? `${stopDuration} min` : (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['Less than 1min'];
        const stopdistanceLabel = `${stopDistance} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['meters']}`;
        const isLastStep = selectedWaypoints && selectedWaypoints.length > 0 && currentLeg >= totalLegs - 1 && currentStep >= totalSteps - 1;
        return isLastStep ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "stops__final-leg",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "stops__final-leg__close-icon",
                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit,
                    onClick: closeCb,
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                        icon: "close"
                    })
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                    className: "btn btn--bordered btn--quit stops__final-leg__close-text",
                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit,
                    onClick: closeCb,
                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "stops__final-leg__content",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__final-leg__heading",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['destination_in_sight']
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    icon: "tour"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__final-leg__subtitle",
                            children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['continue_to_reach'].replace('{distance}', distanceLabel).replace('{name}', destinationName)
                        })
                    ]
                })
            ]
        }) : selectedWaypoints && selectedWaypoints.length > 0 ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "stops",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "stops__top",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__actions",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "stops__icon-btn",
                                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit,
                                    onClick: closeCb,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "close"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "stops__map-controls",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                            className: "btn btn--square btn--bordered btn--sound",
                                            title: "Sound",
                                            onClick: ()=>this.setState({
                                                    enableSound: !enableSound
                                                }),
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                size: 32,
                                                icon: enableSound ? 'sound' : 'sound-mute'
                                            })
                                        }),
                                        enableFocus && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                            className: "btn btn--square btn--bordered btn--recenter",
                                            title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Center,
                                            onClick: ()=>this.recenterNavigation(),
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                size: 32,
                                                icon: "center-marker"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                            className: "btn btn--square btn--bordered btn--overview",
                                            title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Overview,
                                            onClick: ()=>this.setState({
                                                    overview: true
                                                }),
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                size: 32,
                                                icon: "itinerary-overview"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__nav",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    disabled: currentStep <= 0,
                                    className: "stops__icon-btn",
                                    onClick: ()=>{
                                        this.headerRef.current.prev();
                                        this._jumpToPrevLeg();
                                    },
                                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Previous,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        size: 18,
                                        icon: "arrow-left"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    className: "stops__subtext",
                                    children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.leg_step
                                }),
                                currentStep < totalSteps - 1 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    className: "stops__icon-btn stops__icon-btn--primary",
                                    onClick: ()=>{
                                        this.headerRef.current.next();
                                        this._jumpToNextLeg();
                                    },
                                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Next,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        size: 18,
                                        icon: "arrow-right"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "stops__bottom",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__info",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "stops__duration",
                                    children: [
                                        durationLabel,
                                        " - ",
                                        distanceLabel
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "stops__subtitle",
                                    children: destinationName && `${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor['for']} ${destinationName}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "stops__actions",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    disabled: currentLeg <= 0,
                                    className: "stops__icon-btn",
                                    onClick: ()=>this._jumpToStep(currentLeg - 1),
                                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Previous,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "double-arrow-left"
                                    })
                                }),
                                " ",
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    className: "stops__subtext",
                                    children: [
                                        " ",
                                        (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Steps,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    disabled: currentLeg >= totalLegs - 1,
                                    className: "stops__icon-btn stops__icon-btn--primary",
                                    onClick: ()=>this._jumpToStep(currentLeg + 1),
                                    title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Next,
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                        icon: "double-arrow-right"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "stops__mobile-controls",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--square btn--bordered btn--sound",
                            title: "Sound",
                            onClick: ()=>this.setState({
                                    enableSound: !enableSound
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 32,
                                icon: enableSound ? 'sound' : 'sound-mute'
                            })
                        }),
                        enableFocus && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--square btn--bordered btn--recenter",
                            title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Center,
                            onClick: ()=>this.recenterNavigation(),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 32,
                                icon: "center-marker"
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            className: "btn btn--square btn--bordered btn--overview",
                            title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Overview,
                            onClick: ()=>this.setState({
                                    overview: true
                                }),
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                size: 32,
                                icon: "itinerary-overview"
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "woosmap-navigation-panel__footer",
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "woosmap-navigation-panel__footer__content",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "woosmap-navigation-panel__footer__content__left",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "woosmap-navigation-panel__footer__current-level",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                        className: "current-level__label",
                                        children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Level
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                        className: "current-level__number",
                                        children: stepToDisplay.start_location.level
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                className: "btn btn--bordered btn--quit",
                                title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit,
                                onClick: closeCb,
                                children: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Quit
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "woosmap-navigation-panel__footer__content__left__information",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "woosmap-navigation-panel__steps-container",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                                size: 12,
                                                icon: "nav-walk_straight_small"
                                            }),
                                            stepToDisplay.distance.value > 0 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                children: stepToDisplay.distance.text
                                            }),
                                            "\xa0-\xa0",
                                            stepToDisplay.duration.text
                                        ]
                                    }, index),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "woosmap-navigation-panel__footer__content__title",
                                        children: [
                                            (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.ETA,
                                            " ",
                                            durationLabel
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "woosmap-navigation-panel__footer__content__right",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "woosmap-navigation-panel__footer__content__right__options",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                        className: "btn btn--square btn--bordered btn--sound",
                                        title: `Sound`,
                                        onClick: ()=>{
                                            this.setState({
                                                enableSound: !enableSound
                                            });
                                        },
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            size: 32,
                                            icon: enableSound ? 'sound' : 'sound-mute'
                                        })
                                    }),
                                    enableFocus && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                        className: "btn btn--square btn--bordered btn--recenter",
                                        title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Center,
                                        onClick: ()=>{
                                            this.recenterNavigation();
                                        },
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            size: 32,
                                            icon: "center-marker"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                        className: "btn btn--square btn--bordered btn--overview",
                                        title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Overview,
                                        onClick: ()=>{
                                            this.setState({
                                                overview: true
                                            });
                                        },
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                            size: 32,
                                            icon: "itinerary-overview"
                                        })
                                    })
                                ]
                            }),
                            currentStep > 0 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                className: "btn btn--square btn--bordered btn--previous",
                                onClick: ()=>this.headerRef.current.prev(),
                                title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Previous,
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    size: 32,
                                    icon: "arrow-left"
                                })
                            }),
                            currentStep < totalSteps - 1 && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                className: "btn btn--square btn--bordered btn--next",
                                onClick: ()=>this.headerRef.current.next(),
                                title: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor.Next,
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $93f50620ef2b8799$export$2e2bcd8739ae039), {
                                    size: 32,
                                    icon: "arrow-right"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    render() {
        const { currentStep: currentStep, overview: overview } = this.state;
        if (overview) return this.renderOverview();
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0b06dee5f8010ba6$exports))), {
                    swipeOptions: {
                        continuous: false,
                        disableScroll: false,
                        stopPropagation: false,
                        startSlide: currentStep,
                        transitionEnd: (index)=>{
                            this.setState({
                                currentStep: index
                            });
                        }
                    },
                    ref: this.headerRef,
                    children: this.renderItinerary()
                }),
                this.renderFooter()
            ]
        });
    }
}


class $4efe466ba3938f0a$export$2e2bcd8739ae039 {
    /**
     * Creates a new Indoor Navigation Wiget.
     * @param [renderer] IndoorRenderer
     * @param [closeCb] Callback called when the widget is closed by the user.
     * @constructor
     */ constructor(renderer, closeCb, selectedWaypoints, selectedDestination){
        this._indoorRenderer = renderer;
        this._closeCb = closeCb;
        this._selectedWaypoints = selectedWaypoints;
        this._selectedDestination = selectedDestination;
        const container = this._container = document.createElement('div');
        container.classList.add('woosmap-navigation-panel');
        if (this._indoorRenderer.map) this._indoorRenderer.map._container.classList.add('woosmap-navigation');
    }
    /**
     * Sets the map where to render the Indoor navigation widget.
     * @param {?woosmap.map.Map} map
     */ setMap(map) {
        if (map) {
            const control = map._container.getElementsByClassName('mapboxgl-control-container')[0];
            if (control && this._container) control.prepend(this._container);
            this._renderPanel();
        } else this.onRemove();
    }
    onRemove() {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
            (0, $7Do5B.render)(null, this._container);
            if (this._indoorRenderer.map) this._indoorRenderer.map._container.classList.remove('woosmap-navigation');
            this._indoorRenderer._directionsRenderer.resetDirections();
            this._indoorRenderer.highlightStep(null);
            this._indoorRenderer.resetUserMarker();
        }
    }
    _renderPanel() {
        (0, $7Do5B.render)(/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $97813de16aa249a8$export$2e2bcd8739ae039), {
            controller: this,
            directions: this._indoorRenderer.getDirections(),
            highlightStep: this._indoorRenderer.highlightStep.bind(this._indoorRenderer),
            resetDirections: this._indoorRenderer._directionsRenderer.resetDirections.bind(this._indoorRenderer._directionsRenderer),
            closeCb: this._closeCb,
            setUserLocation: this._indoorRenderer.setUserLocation.bind(this._indoorRenderer),
            notifyUserDeviated: this._indoorRenderer.notifyUserDeviated.bind(this._indoorRenderer),
            notifyProximityToDest: this._indoorRenderer.notifyProximityToDest.bind(this._indoorRenderer),
            selectedWaypoints: this._selectedWaypoints,
            selectedDestination: this._selectedDestination
        }), this._container);
    }
}


class $f5763916f75b9ad7$export$2e2bcd8739ae039 {
    /**
   * Creates a new Indoor widget.
   * @param [widgetOptions] IndoorWidgetOptions
   * @param [rendererOptions] IndoorRendererOptions
   * @constructor
   */ constructor(widgetOptions, rendererOptions){
        if (!widgetOptions) widgetOptions = {};
        this._ui = widgetOptions.ui || null;
        this._units = widgetOptions.units || "metric";
        this._directionsMode = widgetOptions.directionsMode || null;
        this._navigationMode = widgetOptions.navigationMode !== undefined ? widgetOptions.navigationMode : true;
        this._avoidZones = widgetOptions.avoidZones || "";
        this._widgetMapMode = widgetOptions.widgetMapMode || "general";
        this._isItineraryMode = false;
        if (widgetOptions.autocomplete && widgetOptions.autocomplete.disableAutoFocus !== undefined) this._disableAutoFocus = widgetOptions.autocomplete.disableAutoFocus;
        else this._disableAutoFocus = false;
        if (widgetOptions.baseFilter) this._baseFilter = widgetOptions.baseFilter;
        else this._baseFilter = widgetOptions.autocomplete && widgetOptions.autocomplete.baseFilter && widgetOptions.autocomplete.baseFilter || null;
        if (widgetOptions.autocompleteWithDistance !== undefined) this._autocompleteWithDistance = widgetOptions.autocompleteWithDistance;
        else this._autocompleteWithDistance = widgetOptions.autocomplete && widgetOptions.autocomplete.autocompleteWithDistance !== undefined ? widgetOptions.autocomplete.autocompleteWithDistance : false;
        this._maxResponses = widgetOptions.autocomplete && widgetOptions.autocomplete.maxResponses !== undefined ? widgetOptions.autocomplete.maxResponses : 5;
        this._renderer = new window.woosmap.map.IndoorRenderer(rendererOptions);
        this._renderer.addListener("indoor_venue_loaded", (data)=>{
            this._renderPanel();
            this.trigger(this, "indoor_venue_loaded", [
                data
            ]);
        });
        this._renderer.addListener("indoor_feature_selected", (data)=>{
            this.trigger(this, "indoor_feature_selected", [
                data
            ]);
        });
        this._renderer.addListener("indoor_level_changed", (data)=>{
            this.trigger(this, "indoor_level_changed", [
                data
            ]);
        });
        this._renderer.addListener("indoor_user_location", (data)=>{
            this.trigger(this, "indoor_user_location", [
                data
            ]);
        });
        this._renderer.addListener("indoor_highlight_step", (data)=>{
            this.trigger(this, "indoor_highlight_step", [
                data
            ]);
        });
        this._renderer.addListener("indoor_user_deviated", (data)=>{
            this.trigger(this, "indoor_user_deviated", [
                data
            ]);
        });
        this._renderer.addListener("indoor_user_near_arrival", ()=>{
            this.trigger(this, "indoor_user_near_arrival", []);
        });
        const root = document.documentElement;
        if (this._ui && root) {
            if (this._ui.primaryColor) root.style.setProperty("--primary-color", this._ui.primaryColor);
            if (this._ui.secondaryColor) root.style.setProperty("--secondary-color", this._ui.secondaryColor);
        }
    }
    /**
   * @private
   */ onAdd() {
        const container = this._container = document.createElement("div");
        container.classList.add("woosmap-indoor-panel");
        container.classList.add("hide");
        container.classList.add("mapboxgl-ctrl");
        return container;
    }
    /**
   * @private
   */ onRemove() {
        if (this._container && this._container.parentNode) this._container.parentNode.removeChild(this._container);
    }
    /**
   * Sets the map where to render the Indoor widget.
   */ setMap(map) {
        if (map) {
            this._renderer.setMap(map);
            this._renderer._getMapboxMap(map).addControl(this, "top-left");
        } else {
            this.onRemove();
            this.setDirections(null);
            if (this._navigationController) this.stopNavigation();
            this._renderer.setMap(map);
        }
    }
    /**
   * Renders map with the selected venue
   */ setVenue(venueId) {
        this._renderer.setVenue(venueId);
    }
    /**
   * Renders a map with a POI highlighted by pk / id
   * silent parameter will prevent the indoor_feature_selected event to trigger
   * padding parameter will apply padding to the map container while highlighting the POI on map
   */ highlightFeature(id, silent = false, padding) {
        this._renderer.highlightFeature(id, silent, padding);
    }
    /**
   * Renders a map with a POI highlighted by its ref
   * padding parameter will apply padding to the map container while highlighting the POI on map
   */ highlightFeatureByRef(ref, padding) {
        this._renderer.highlightFeatureByRef(ref, padding);
    }
    /**
   * Unselect a selected feature: it closes the widget and unhighlight the feature.
   */ unselectFeature() {
        this._renderer.unselectFeature();
    }
    /**
   * Call this function to draw a polyline on map.
   */ setDirections(directions) {
        this._renderer.setDirections(directions);
    }
    /**
   * Sets the distance units.
   */ setUnits(units) {
        this._units = units;
    }
    /**
   * Gets the distance units.
   */ getUnits() {
        return this._units;
    }
    /**
   * Sets the routing profile (or directions mode) ('security' | 'wheelchair') for way finding
   */ setDirectionsMode(profile) {
        this._directionsMode = profile;
    }
    /**
   * Gets the distance units.
   */ getDirectionsMode() {
        return this._directionsMode;
    }
    /**
   * Sets the baseFilter.
   */ setBaseFilter(filter) {
        this._baseFilter = filter;
    }
    /**
   * Gets the baseFilter
   */ getBaseFilter() {
        return this._baseFilter;
    }
    /**
   * Sets the current user location.
   */ setUserLocation(lat, lng, level, bearing, forceFocus) {
        this._renderer.setUserLocation(lat, lng, level, bearing, forceFocus);
    }
    /**
   * Sets the navigation mode
   */ setNavigationMode(allowNavigation) {
        this._navigationMode = allowNavigation;
    }
    /**
   * Gets the navigates mode
   */ getNavigationMode() {
        return this._navigationMode;
    }
    /**
   * Gets the autocompleteWithDistance option
   */ getAutocompleteWithDistance() {
        return this._autocompleteWithDistance;
    }
    /**
   * Gets the autocomplete's maxResponses option value if set to determine the number of search suggestions to retrieve. The default value is 5 and the maximum limit is 10.
   */ getAutocompleteMaxResponses() {
        return this._maxResponses || 5;
    }
    /**
   * Renders map with custom theme
   * @param theme Theme name
   */ setTheme(theme) {
        this._renderer.setTheme(theme);
    }
    /**
   * Sets the zones to avoid during routing. Argument expected in the format level;lat,lng;lat,lng;lat,lng...|level;lat,lng;lat,lng;lat,lng...
   */ setZonesToAvoid(avoidZones) {
        this._avoidZones = avoidZones;
    }
    /**
   * Gets the zones to avoid while routing
   */ getZonesToAvoid() {
        return this._avoidZones;
    }
    /**
   * Sets widget's map mode. This is exclusive for SDM
   */ setWidgetMapMode(mode, favoritesShops, isUnauthorized) {
        this._widgetMapMode = mode;
        this.trigger(this, "indoor_widget_map_changed", [
            mode,
            favoritesShops,
            isUnauthorized
        ]);
    }
    /**
   * Gets the widget map mode. This is exclusive for SDM
   */ getWidgetMapMode() {
        return this._widgetMapMode;
    }
    /**
   * Sets whether to disable the autofocus for the search input.
   */ setIsAutofocusDisabled(disableFocus) {
        this._disableAutoFocus = disableFocus;
    }
    /**
   * Gets whether auto focus on search input is enabled/disabled
   */ getIsAutofocusDisabled() {
        return this._disableAutoFocus;
    }
    launchNavigation() {
        if (!this._navigationController) {
            this._navigationController = new (0, $4efe466ba3938f0a$export$2e2bcd8739ae039)(this._renderer, ()=>{
                this.stopNavigation();
            }, this._selectedWaypoints, this.getSelectedDestination());
            this._navigationController.setMap(this._renderer.map);
        }
    }
    stopNavigation() {
        this._navigationController.setMap(null);
        this._navigationController = null;
        this.trigger(this, "indoor_stop_navigation", []);
    }
    /**
   * Sets the floor for the venue
   */ setFloor(floor) {
        this._renderer.setFloor(floor);
    }
    /**
   * Gets the underlying instance of Indoor Renderer when using the Indoor Widget
   */ getRenderer() {
        return this._renderer;
    }
    setSelectedWaypoints(selectedWaypoints) {
        this._selectedWaypoints = selectedWaypoints;
    }
    getSelectedWaypoints() {
        return this._selectedWaypoints;
    }
    setSelectedDestination(destination) {
        this._selectedDestination = destination;
    }
    getSelectedDestination() {
        return this._selectedDestination;
    }
    setIsItineraryMode(flag) {
        this._isItineraryMode = flag;
    }
    isItineraryMode() {
        return this._isItineraryMode;
    }
    /**
   * @private
   */ _renderPanel() {
        if (this._container) (0, $7Do5B.render)(/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $06e0e2cab4efe59c$export$2e2bcd8739ae039), {
            controller: this
        }), this._container);
    }
    /**
   * Adds a listener for eventName.
   */ addListener(eventName, handler) {
        return woosmap.map.event.addListener(this, eventName, handler);
    }
    /**
   *  Triggers the given event. All arguments after eventName are passed as arguments to the listeners.
   */ trigger(instance, eventName, eventArgs) {
        return woosmap.map.event.trigger(this, eventName, eventArgs);
    }
    /**
   * Opens the widget's panel in itinerary mode.
   * @param origin Origin can be any of the following, A GeoJSON feature or string of coordinates in the format(lat,lng,level) or user's current location
   * @param destination Destination can be any of the following, A GeoJSON feature or string of coordinates in the format(lat,lng,level) or user's current location
   * @param source Optional analytics context indicating how the itinerary was triggered (e.g. 'frame', 'main_map')
   */ showItinerary(origin, destination, source) {
        this.trigger(this, "widget_open_itinerary_panel", [
            origin,
            destination,
            source
        ]);
    }
}


var $0f8c890e7395704d$export$715fed9478e7c158 = /*#__PURE__*/ function(MapComponentEvents) {
    MapComponentEvents["MAP_READY"] = "map_ready";
    MapComponentEvents["MAP_IDLE"] = "idle";
    MapComponentEvents["INDOOR_VENUE_LOADED"] = "indoor_venue_loaded";
    MapComponentEvents["INDOOR_WIDGET_ANALYTICS"] = "indoor_widget_analytics";
    MapComponentEvents["INDOOR_POI_ON_MAP_CLICK"] = "indoor_feature_selected";
    MapComponentEvents["INDOOR_HIGHLIGHT_STEP"] = "indoor_highlight_step";
    MapComponentEvents["INDOOR_STOP_NAVIGATION"] = "indoor_stop_navigation";
    MapComponentEvents["INDOOR_LEVEL_CHANGED"] = "indoor_level_changed";
    MapComponentEvents["FAVORITE_MARKER_CLICKED"] = "fav_marker_clicked";
    return MapComponentEvents;
}({});
class $0f8c890e7395704d$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.id = 'map';
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $109f615c63b90aba$export$2cb99e4be0dc4646)({
            url: (0, $20654a4b7519d360$export$2e2bcd8739ae039).mapJS,
            params: {
                key: this.state.woosmapPublicKey,
                language: (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()
            },
            override: true,
            callback: ()=>{
                this.initMapView();
            }
        }).catch((error)=>{
            console.error((0, $ee9cb80b5c23ac97$export$77ad94ebf1c2b9ed)((0, $58070e9281bc680d$export$180605366c04f0cd)().errors.loadingLibrary, {
                'library': "Woosmap Map JS SDK script"
            }), error);
        });
    }
    initMapView() {
        this.map = new woosmap.map.Map('map', Object.assign({}, this.state.mapOptions));
        this.emit("map_ready");
        this.map.addListener("idle", ()=>{
            this.emit("idle");
        });
        // QA: zoom level label (enabled via ?showZoomLabel URL param)
        const showZoomLabel = new URLSearchParams(window.location.search).has("showZoomLabel");
        if (showZoomLabel) {
            const zoomLabel = document.createElement("div");
            zoomLabel.id = "zoom-label";
            zoomLabel.style.cssText = "position:absolute;top:5%;left:90%;transform:translate(-50%,-50%);z-index:9999;background:rgba(0,0,0,0.6);color:#fff;padding:4px 10px;border-radius:4px;font:bold 14px monospace;pointer-events:none;";
            zoomLabel.textContent = `Zoom: ${this.map.getZoom().toFixed(1)}`;
            this.$element.style.position = "relative";
            this.$element.appendChild(zoomLabel);
            this.map.addListener("zoom_changed", ()=>{
                zoomLabel.textContent = `Zoom: ${this.map.getZoom().toFixed(1)}`;
            });
        }
    }
    initIndoorView() {
        const widgetOptions = this.state.query && this.state.query !== `thematic:=${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorWidgetOptions,
            baseFilter: this.state.query
        } : this.state.indoorWidgetOptions;
        const rendererOptions = this.state.query && this.state.query !== `thematic:=${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorRendererOptions,
            baseFilter: this.state.query
        } : this.state.indoorRendererOptions;
        this.indoorMap = new (0, $f5763916f75b9ad7$export$2e2bcd8739ae039)(widgetOptions, rendererOptions);
        this.indoorMap.setMap(this.map);
        this.indoorMap.addListener("indoor_venue_loaded", (venue)=>{
            this.currentLevel = 0;
            this.emit("indoor_venue_loaded", venue);
        });
        this.indoorMap.addListener("indoor_widget_analytics", (event)=>{
            this.emit("indoor_widget_analytics", event);
        });
        this.indoorMap.addListener("indoor_feature_selected", (event)=>{
            this.emit("indoor_feature_selected", event);
        });
        this.indoorMap.addListener("indoor_highlight_step", (event)=>{
            this.emit("indoor_highlight_step", event);
        });
        this.indoorMap.addListener("indoor_stop_navigation", (event)=>{
            this.emit("indoor_stop_navigation", event);
        });
        this.indoorMap.addListener("indoor_level_changed", (event)=>{
            this.currentLevel = event;
            if (this.userFavorites) this.plotUserFavoritesOnMap(this.userFavorites);
        });
    }
    setFilter(filter) {
        const filterToApply = filter !== undefined ? `thematic:=${filter} OR ${filter}:=true` : ``;
        if (filter !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && filter !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) {
            this.indoorMap.getRenderer().setBaseFilter(filterToApply);
            this.indoorMap.setBaseFilter(filterToApply);
        } else {
            this.indoorMap.getRenderer().setBaseFilter("");
            this.indoorMap.setBaseFilter("");
        }
    }
    setOrigin(data) {
        this.indoorMap.setUserLocation(data.lat, data.lng, data.level || 0, 0, true);
    }
    setTheme(theme) {
        const themeToApply = theme !== undefined ? theme : (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"];
        if (this.indoorMap) this.indoorMap.setTheme(themeToApply);
    }
    setBounds(bounds) {
        let padding = {
            top: 0,
            left: 150,
            right: 150,
            bottom: 0
        };
        if (this.$element.clientWidth > 768) padding = {
            top: 350,
            left: 350,
            right: 350,
            bottom: 350
        };
        this.map.fitBounds(bounds, padding, true);
    }
    unselectPOI() {
        this.indoorMap.unselectFeature();
    }
    turnOffNavigation() {
        this.indoorMap.setNavigationMode(false);
    }
    getDirections() {
        return this.indoorMap.getRenderer()._directionsRenderer.directions;
    }
    showRouteForAllLevels() {
        if (this.indoorMap) {
            const mapStyle = this.map._style;
            if (mapStyle) mapStyle.addLayer({
                id: 'indoor-directions-all-levels',
                type: 'line',
                source: 'indoor-directions',
                filter: [
                    'all',
                    [
                        '==',
                        [
                            'get',
                            'enabled'
                        ],
                        false
                    ]
                ],
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': '#808AC7',
                    'line-opacity': 0.8,
                    'line-width': 6
                }
            }, 'indoor-directions_layers');
        }
    }
    showRouteForSponsor(origin, destination) {
        const originPoint = `${origin.lat},${origin.lng},0`;
        const indoorService = new woosmap.map.IndoorService();
        const cbSearch = (result)=>{
            if (result && result.features && result.features.length > 0) {
                const feature = result.features[0];
                this.indoorMap.showItinerary(originPoint, feature, 'frame');
            }
        };
        indoorService.search((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.venue || `sdm_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.env}`, '', cbSearch, destination);
    }
    plotUserFavoritesOnMap(favorites) {
        this.removeMarkersForFavs();
        this.userFavorites = favorites;
        this.favMarkers = [];
        for (const fav of favorites){
            const status = fav.properties.visit_status;
            if (parseInt(fav.properties.level) === this.currentLevel) {
                const marker = new woosmap.map.Marker({
                    position: (0, $ee9cb80b5c23ac97$export$53fc19a32de59f94)(fav),
                    icon: {
                        url: status === "tovisit" ? (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.favMarkerUrl : (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.vistedShop,
                        scaledSize: {
                            height: 28,
                            width: 28
                        }
                    }
                });
                marker.addListener("click", ()=>{
                    this.indoorMap.highlightFeature(fav.id, false);
                    this.emit("fav_marker_clicked", fav);
                });
                this.favMarkers.push(marker);
                marker.setMap(this.map);
            }
        }
    }
    removeMarkersForFavs() {
        if (this.favMarkers) {
            this.favMarkers.forEach((marker)=>{
                marker.setMap(null);
            });
            this.favMarkers = [];
            this.userFavorites = [];
        }
    }
    destroyMap() {
        if (this.indoorMap) {
            this.indoorMap.getRenderer().setMap(null);
            this.indoorMap = null;
            this.map = new woosmap.map.Map('map', Object.assign({}, this.state.mapOptions));
            this.initIndoorView();
        }
    }
}





/**
 * Previously preloaded links that have been requested by `preloadLink()`.
 */ let $9bbb064cf4ce4d36$var$preloadedLinks = {};
function $9bbb064cf4ce4d36$export$a0db4953bb08f589(options) {
    const { url: url, params: params, as: as, crossOrigin: crossOrigin, override: override } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    const existing = $9bbb064cf4ce4d36$var$preloadedLinks[src];
    if (existing) {
        if (override) {
            const link = $9bbb064cf4ce4d36$var$getLinkElement(src);
            if (link) {
                delete $9bbb064cf4ce4d36$var$preloadedLinks[src];
                link.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($9bbb064cf4ce4d36$var$findLink(src)) resolve();
        const link = $9bbb064cf4ce4d36$export$b756667c7b6cccbc(url, params, as, crossOrigin);
        const onLinkLoad = ()=>{
            resolve();
        };
        const onLinkError = ()=>{
            cleanup();
            delete $9bbb064cf4ce4d36$var$preloadedLinks[src];
            link.remove();
            const defaultError = new Error(`The link "${src}" failed to preload.`);
            reject(defaultError);
        };
        link.addEventListener('load', onLinkLoad);
        link.addEventListener('error', onLinkError);
        document.head.insertBefore(link, document.head.firstElementChild);
        function cleanup() {
            link.removeEventListener('load', onLinkLoad);
            link.removeEventListener('error', onLinkError);
        }
    });
    $9bbb064cf4ce4d36$var$preloadedLinks[src] = promise;
    return promise;
}
/**
 * Find link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {boolean | null} returns `true` if link exist otherwise `null`.
 */ function $9bbb064cf4ce4d36$var$findLink(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return true;
}
/**
 * Get link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {HTMLLinkElement | null} returns existing `HTMLLinkElement` if link exist otherwise `null`.
 */ function $9bbb064cf4ce4d36$var$getLinkElement(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return currentLink;
}
function $9bbb064cf4ce4d36$export$b756667c7b6cccbc(url, params = {}, as, crossOrigin, type) {
    const newLink = document.createElement("link");
    if (Object.keys(params).length) newLink.href = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    else newLink.href = `${url}`;
    if (crossOrigin) newLink.crossOrigin = crossOrigin;
    if (type) newLink.type = type;
    newLink.rel = "preload";
    newLink.as = as;
    return newLink;
}
function $9bbb064cf4ce4d36$export$f427c08ae26d1d06() {
    $9bbb064cf4ce4d36$var$preloadedLinks = {};
}




var $1b81979ac4ba0c49$export$2e2bcd8739ae039 = {
    thematics: [
        {
            id: 1,
            title: "Smart Office",
            ref: "smartoffice",
            description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
        },
        {
            id: 2,
            title: "Eclectic Design",
            ref: "eclectic",
            description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
        },
        {
            id: 3,
            title: "Domestic Outdoor lighting",
            ref: "dol",
            description: "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics."
        },
        {
            id: 4,
            title: "Urban Outdoor lighting",
            ref: "uol",
            description: "Highly innovative interiors: water sustainability according to Salotto NY."
        },
        {
            id: 5,
            title: "Home Entertainment",
            ref: "homent",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        },
        {
            id: 6,
            title: "Umbrellas and Pergolas",
            ref: "umbrella",
            description: "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces."
        },
        {
            id: 7,
            title: "Wallpaper",
            ref: "wallpaper",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        },
        {
            id: 8,
            title: "Rugs",
            ref: "rug",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        }
    ]
};


var $03005ecb18aee849$export$2e2bcd8739ae039 = {
    buildings: [
        {
            ref: "pav1_3",
            title: "P 01-03",
            pavilion: [
                "pav1",
                "pav3"
            ],
            thematics: [
                "umbrella",
                "homent",
                "smartoffice",
                "eclectic",
                "rug",
                "dol"
            ],
            center: {
                lat: 45.517404547972504,
                lng: 9.0829660782425
            },
            kioskZoom: 19.2
        },
        {
            ref: "pav2_4",
            title: "P 02-04",
            pavilion: [
                "pav2",
                "pav4"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {
                lat: 45.51977094554,
                lng: 9.084641596885
            },
            kioskZoom: 19.2
        },
        {
            ref: "pav5_7",
            title: "P 05-07",
            pavilion: [
                "pav5",
                "pav7"
            ],
            thematics: [
                "wallpaper",
                "umbrella",
                "homent",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.518486051029996,
                lng: 9.08057912806
            },
            kioskZoom: 19.5
        },
        {
            ref: "pav6_10",
            title: "P 06-10",
            pavilion: [
                "pav6",
                "pav10"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {
                lat: 45.52043912007,
                lng: 9.081303605317501
            },
            kioskZoom: 19.2
        },
        {
            ref: "pav9_11",
            title: "P 09-11",
            pavilion: [
                "pav9",
                "pav11"
            ],
            thematics: [
                "homent",
                "smartoffice"
            ],
            center: {
                lat: 45.519864817035,
                lng: 9.075825940384998
            },
            kioskZoom: 19.2
        },
        {
            ref: "pav13_15",
            title: "P 13-15",
            pavilion: [
                "pav13",
                "pav15"
            ],
            thematics: [
                "homent",
                "wallpaper",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.5207451646875,
                lng: 9.073293433275
            },
            kioskZoom: 19.2
        },
        {
            ref: "pav14_18",
            title: "P 14-18",
            pavilion: [
                "pav14",
                "pav18"
            ],
            thematics: [
                "wallpaper",
                "homent",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.5216703575,
                lng: 9.0777833391
            },
            kioskZoom: 19.3
        },
        {
            ref: "pav22_24",
            title: "P 22-24",
            pavilion: [
                "pav22",
                "pav24"
            ],
            thematics: [
                "umbrella",
                "wallpaper",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.52294009775724,
                lng: 9.074819554722694
            },
            kioskZoom: 19.3
        }
    ]
};





var $3c0730fc6dc90d7f$export$834029a0b90ac2e7 = /*#__PURE__*/ function(ThematicComponentEvents) {
    ThematicComponentEvents["THEMATIC_SELECTED"] = "thematic_selected";
    ThematicComponentEvents["LANGUAGE_CHANGED"] = "language_changed";
    ThematicComponentEvents["BUILDING_SELECTED"] = "building_selected";
    ThematicComponentEvents["ALL_EXHIBITS_SELECTED"] = "all_exhibits_selected";
    ThematicComponentEvents["FAVORITES_SELECTED"] = "favorites";
    ThematicComponentEvents["THEMATIC_UNSELECTED"] = "thematic_unselected";
    return ThematicComponentEvents;
}({});
class $3c0730fc6dc90d7f$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.renderThematics();
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        if ($btnAllExhibits) {
            $btnAllExhibits.textContent = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits;
            $btnAllExhibits.addEventListener("click", ()=>{
                this.switchMap('all');
            });
        }
        if ($btnFavorites) {
            $btnFavorites.textContent = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites;
            $btnFavorites.addEventListener("click", ()=>{
                $btnFavorites.classList.add("active");
                this.switchMap('favorites');
            });
        }
        this.renderBuildings(this.defaultTheme && this.defaultTheme.ref);
    }
    render() {}
    renderThematics() {
        const jsonData = (0, $1b81979ac4ba0c49$export$2e2bcd8739ae039)["thematics"];
        const container = document.getElementById("thematicDropdown");
        const chooseTitle = document.getElementsByClassName("thematic-selector-title");
        const $btnThematic = document.getElementById("btnThematic");
        if (chooseTitle && chooseTitle[0]) chooseTitle[0].innerHTML = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.choose_thematic;
        if ($btnThematic) $btnThematic.innerHTML = `${(0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
        if (container) {
            container.innerHTML = '';
            jsonData.forEach((item)=>{
                const $dropdownElem = document.createElement("a");
                $dropdownElem.tabIndex = 1;
                $dropdownElem.setAttribute("data-id", item["ref"].toString());
                const ref = item["ref"];
                $dropdownElem.textContent = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, ref);
                if (this.state.query && this.state.query !== "" && this.state.query.includes('thematic')) {
                    const selectedTheme = this.state.query?.split('=')[1] || '';
                    if (selectedTheme.toLowerCase() === ref.toLowerCase()) this.defaultTheme = item;
                }
                $dropdownElem.onclick = ()=>{
                    this.resetClasses();
                    const filter = `thematic:=${item["ref"].replace(' ', '').toLowerCase()}`;
                    this.emit("thematic_selected", filter);
                    this.renderBuildings(item["ref"].replace(' ', '').toLowerCase());
                    if ($btnThematic) {
                        $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, ref)} <span class="caret"></span>`;
                        $btnThematic.classList.add("active");
                    }
                    container.querySelectorAll("a").forEach((option)=>{
                        option.classList.remove("selected-thematic");
                        option.classList.add("unselected-thematic");
                    });
                    $dropdownElem.classList.remove("unselected-thematic");
                    $dropdownElem.classList.add('selected-thematic');
                    this.selectThematic(item);
                };
                container.appendChild($dropdownElem);
            });
        } else console.error("Container not found");
        if (this.defaultTheme) this.setThematicOnLoad(this.defaultTheme);
    }
    renderBuildings(theme) {
        const jsonData = (0, $03005ecb18aee849$export$2e2bcd8739ae039)["buildings"];
        const container = document.getElementById("pavilion-slide");
        if (container) {
            container.innerHTML = '';
            jsonData.forEach((item)=>{
                if (theme) {
                    if (item.thematics?.includes(theme)) this.renderPavHTML(item, container);
                } else this.renderPavHTML(item, container);
            });
        }
    }
    renderPavHTML(item, container) {
        const $sliderElement = document.createElement("div");
        const span = document.createElement("span");
        $sliderElement.tabIndex = 1;
        $sliderElement.setAttribute("data-id", item["ref"].toString());
        $sliderElement.setAttribute("class", "slide");
        span.textContent = item.title;
        $sliderElement.onclick = ()=>{
            if ($sliderElement.classList.contains("slide")) {
                const slides = document.querySelectorAll("#pavilion-slide .slide");
                if ($sliderElement.classList.contains('clicked')) {
                    $sliderElement.classList.remove('clicked');
                    this.selectedBuilding = undefined;
                    this.emit("building_selected", undefined);
                } else {
                    slides.forEach((slide)=>{
                        slide.classList.remove('clicked');
                    });
                    $sliderElement.classList.add('clicked');
                    this.selectedBuilding = item;
                    this.emit("building_selected", item);
                }
            }
        };
        $sliderElement.appendChild(span);
        container.appendChild($sliderElement);
    }
    selectThematic(theme) {
        const $divElements = document.querySelectorAll('.slide');
        const filteredDivs = Array.from($divElements).filter((element)=>{
            const spanElement = element.querySelector('span');
            const textToMatch = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase());
            return spanElement && spanElement.textContent?.toLowerCase() === textToMatch.toLowerCase();
        });
        filteredDivs.forEach((div)=>{
            div.classList.toggle("clicked");
        });
        const $thematicSection = document.getElementsByClassName('thematic-details')[0];
        const $thematicsTitle = document.getElementsByClassName('thematic-name')[0];
        const $thematicsDescription = document.getElementsByClassName('thematic-desc')[0];
        if ($thematicsDescription && this.state.showDescription && $thematicsTitle) {
            $thematicsTitle.innerHTML = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase());
            $thematicsDescription.innerHTML = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematicDescription, theme["ref"].toLowerCase()) || theme["description"] || '';
        }
        if ($thematicSection) $thematicSection.style.display = "flex";
        this.emit("thematic_selected", `thematic:=${theme["ref"].toLowerCase()}`);
    }
    switchMap(mode) {
        this.resetClasses();
        this.defaultTheme = null;
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        switch(mode){
            case 'all':
                $btnAllExhibits.classList.add("active");
                this.renderBuildings();
                this.emit("thematic_unselected", (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"]);
                break;
            case 'favorites':
                $btnFavorites.classList.add("active");
                this.renderBuildings();
                this.emit("thematic_unselected", (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]);
                break;
        }
    }
    resetClasses() {
        const $btnThematic = document.getElementById("btnThematic");
        const $thematicSection = document.getElementsByClassName('thematic-details')[0];
        const container = document.getElementById("thematicDropdown");
        $btnThematic.classList.remove("active");
        $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        if ($btnAllExhibits) $btnAllExhibits.classList.remove("active");
        if ($btnFavorites) $btnFavorites.classList.remove("active");
        if (container) container.querySelectorAll("a").forEach((option)=>{
            option.classList.remove("selected-thematic");
        });
        if ($thematicSection) $thematicSection.style.display = "none";
    }
    setThematicOnLoad(theme) {
        const container = document.getElementById("thematicDropdown");
        const $btnThematic = document.getElementById("btnThematic");
        if (container) {
            container.querySelectorAll("a").forEach((option)=>{
                option.classList.remove("selected-thematic");
            });
            Array.from(container.querySelectorAll('a')).forEach((element)=>{
                const textToMatch = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase());
                if (element && element.textContent?.toLowerCase() === textToMatch.toLowerCase()) element.classList.add('selected-thematic');
            });
        }
        if ($btnThematic) {
            $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase())} <span class="caret-white"></span>`;
            $btnThematic.classList.add("active");
        }
        this.emit("thematic_selected", `thematic:=${theme["ref"].toLowerCase()}`);
    }
    setCTAText(isMobileView) {
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        const $btnThematic = document.getElementById("btnThematic");
        if ($btnAllExhibits) $btnAllExhibits.textContent = isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits;
        if ($btnFavorites) $btnFavorites.textContent = isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites;
        if ($btnThematic) $btnThematic.innerHTML = `${isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
    }
}





var $9e4e7a640172967b$exports = {};
/*!
 * 
 *   simple-keyboard v3.8.93
 *   https://github.com/hodgef/simple-keyboard
 *
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef) and project contributors.
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */ !function(t, e) {
    $9e4e7a640172967b$exports = e();
}($9e4e7a640172967b$exports, function() {
    return function() {
        "use strict";
        var t = {
            34: function(t, e, n) {
                var o = n(4901);
                t.exports = function(t) {
                    return "object" == typeof t ? null !== t : o(t);
                };
            },
            81: function(t, e, n) {
                var o = n(9565), r = n(9306), i = n(8551), a = n(6823), s = n(851), u = TypeError;
                t.exports = function(t, e) {
                    var n = arguments.length < 2 ? s(t) : e;
                    if (r(n)) return i(o(n, t));
                    throw new u(a(t) + " is not iterable");
                };
            },
            235: function(t, e, n) {
                var o = n(9213).forEach, r = n(4598)("forEach");
                t.exports = r ? [].forEach : function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                };
            },
            283: function(t, e, n) {
                var o = n(9504), r = n(9039), i = n(4901), a = n(9297), s = n(3724), u = n(350).CONFIGURABLE, c = n(3706), l = n(1181), f = l.enforce, d = l.get, p = String, h = Object.defineProperty, v = o("".slice), y = o("".replace), g = o([].join), m = s && !r(function() {
                    return 8 !== h(function() {}, "length", {
                        value: 8
                    }).length;
                }), b = String(String).split("String"), w = t.exports = function(t, e, n) {
                    "Symbol(" === v(p(e), 0, 7) && (e = "[" + y(p(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n && n.getter && (e = "get " + e), n && n.setter && (e = "set " + e), (!a(t, "name") || u && t.name !== e) && (s ? h(t, "name", {
                        value: e,
                        configurable: !0
                    }) : t.name = e), m && n && a(n, "arity") && t.length !== n.arity && h(t, "length", {
                        value: n.arity
                    });
                    try {
                        n && a(n, "constructor") && n.constructor ? s && h(t, "prototype", {
                            writable: !1
                        }) : t.prototype && (t.prototype = void 0);
                    } catch (t) {}
                    var o = f(t);
                    return a(o, "source") || (o.source = g(b, "string" == typeof e ? e : "")), t;
                };
                Function.prototype.toString = w(function() {
                    return i(this) && d(this).source || c(this);
                }, "toString");
            },
            298: function(t, e, n) {
                var o = n(2195), r = n(5397), i = n(8480).f, a = n(7680), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(t) {
                    return s && "Window" === o(t) ? function(t) {
                        try {
                            return i(t);
                        } catch (t) {
                            return a(s);
                        }
                    }(t) : i(r(t));
                };
            },
            350: function(t, e, n) {
                var o = n(3724), r = n(9297), i = Function.prototype, a = o && Object.getOwnPropertyDescriptor, s = r(i, "name"), u = s && "something" === (function() {}).name, c = s && (!o || o && a(i, "name").configurable);
                t.exports = {
                    EXISTS: s,
                    PROPER: u,
                    CONFIGURABLE: c
                };
            },
            397: function(t, e, n) {
                var o = n(7751);
                t.exports = o("document", "documentElement");
            },
            421: function(t) {
                t.exports = {};
            },
            511: function(t, e, n) {
                var o = n(9167), r = n(9297), i = n(1951), a = n(4913).f;
                t.exports = function(t) {
                    var e = o.Symbol || (o.Symbol = {});
                    r(e, t) || a(e, t, {
                        value: i.f(t)
                    });
                };
            },
            566: function(t, e, n) {
                var o = n(9504), r = n(9306), i = n(34), a = n(9297), s = n(7680), u = n(616), c = Function, l = o([].concat), f = o([].join), d = {};
                t.exports = u ? c.bind : function(t) {
                    var e = r(this), n = e.prototype, o = s(arguments, 1), u = function() {
                        var n = l(o, s(arguments));
                        return this instanceof u ? function(t, e, n) {
                            if (!a(d, e)) {
                                for(var o = [], r = 0; r < e; r++)o[r] = "a[" + r + "]";
                                d[e] = c("C,a", "return new C(" + f(o, ",") + ")");
                            }
                            return d[e](t, n);
                        }(e, n.length, n) : e.apply(t, n);
                    };
                    return i(n) && (u.prototype = n), u;
                };
            },
            597: function(t, e, n) {
                var o = n(9039), r = n(8227), i = n(9519), a = r("species");
                t.exports = function(t) {
                    return i >= 51 || !o(function() {
                        var e = [];
                        return (e.constructor = {})[a] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== e[t](Boolean).foo;
                    });
                };
            },
            616: function(t, e, n) {
                var o = n(9039);
                t.exports = !o(function() {
                    var t = (function() {}).bind();
                    return "function" != typeof t || t.hasOwnProperty("prototype");
                });
            },
            655: function(t, e, n) {
                var o = n(6955), r = String;
                t.exports = function(t) {
                    if ("Symbol" === o(t)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return r(t);
                };
            },
            687: function(t, e, n) {
                var o = n(4913).f, r = n(9297), i = n(8227)("toStringTag");
                t.exports = function(t, e, n) {
                    t && !n && (t = t.prototype), t && !r(t, i) && o(t, i, {
                        configurable: !0,
                        value: e
                    });
                };
            },
            706: function(t, e, n) {
                var o = n(350).PROPER, r = n(9039), i = n(7452);
                t.exports = function(t) {
                    return r(function() {
                        return !!i[t]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[t]() || o && i[t].name !== t;
                    });
                };
            },
            739: function(t, e, n) {
                var o = n(6518), r = n(9039), i = n(8981), a = n(2777);
                o({
                    target: "Date",
                    proto: !0,
                    arity: 1,
                    forced: r(function() {
                        return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
                            toISOString: function() {
                                return 1;
                            }
                        });
                    })
                }, {
                    toJSON: function(t) {
                        var e = i(this), n = a(e, "number");
                        return "number" != typeof n || isFinite(n) ? e.toISOString() : null;
                    }
                });
            },
            741: function(t) {
                var e = Math.ceil, n = Math.floor;
                t.exports = Math.trunc || function(t) {
                    var o = +t;
                    return (o > 0 ? n : e)(o);
                };
            },
            744: function(t, e, n) {
                var o = n(9565), r = n(9504), i = n(9228), a = n(8551), s = n(34), u = n(7750), c = n(2293), l = n(7829), f = n(8014), d = n(655), p = n(5966), h = n(6682), v = n(8429), y = n(9039), g = v.UNSUPPORTED_Y, m = Math.min, b = r([].push), w = r("".slice), x = !y(function() {
                    var t = /(?:)/, e = t.exec;
                    t.exec = function() {
                        return e.apply(this, arguments);
                    };
                    var n = "ab".split(t);
                    return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
                }), E = "c" === "abbc".split(/(b)*/)[1] || 4 !== "test".split(/(?:)/, -1).length || 2 !== "ab".split(/(?:ab)*/).length || 4 !== ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length;
                i("split", function(t, e, n) {
                    var r = "0".split(void 0, 0).length ? function(t, n) {
                        return void 0 === t && 0 === n ? [] : o(e, this, t, n);
                    } : e;
                    return [
                        function(e, n) {
                            var i = u(this), a = s(e) ? p(e, t) : void 0;
                            return a ? o(a, e, i, n) : o(r, d(i), e, n);
                        },
                        function(t, o) {
                            var i = a(this), s = d(t);
                            if (!E) {
                                var u = n(r, i, s, o, r !== e);
                                if (u.done) return u.value;
                            }
                            var p = c(i, RegExp), v = i.unicode, y = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (g ? "g" : "y"), x = new p(g ? "^(?:" + i.source + ")" : i, y), O = void 0 === o ? 4294967295 : o >>> 0;
                            if (0 === O) return [];
                            if (0 === s.length) return null === h(x, s) ? [
                                s
                            ] : [];
                            for(var S = 0, k = 0, P = []; k < s.length;){
                                x.lastIndex = g ? 0 : k;
                                var I, C = h(x, g ? w(s, k) : s);
                                if (null === C || (I = m(f(x.lastIndex + (g ? k : 0)), s.length)) === S) k = l(s, k, v);
                                else {
                                    if (b(P, w(s, S, k)), P.length === O) return P;
                                    for(var A = 1; A <= C.length - 1; A++)if (b(P, C[A]), P.length === O) return P;
                                    k = S = I;
                                }
                            }
                            return b(P, w(s, S)), P;
                        }
                    ];
                }, E || !x, g);
            },
            757: function(t, e, n) {
                var o = n(7751), r = n(4901), i = n(1625), a = n(7040), s = Object;
                t.exports = a ? function(t) {
                    return "symbol" == typeof t;
                } : function(t) {
                    var e = o("Symbol");
                    return r(e) && i(e.prototype, s(t));
                };
            },
            788: function(t, e, n) {
                var o = n(34), r = n(2195), i = n(8227)("match");
                t.exports = function(t) {
                    var e;
                    return o(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" === r(t));
                };
            },
            825: function(t, e, n) {
                var o = n(6518), r = n(7751), i = n(8745), a = n(566), s = n(5548), u = n(8551), c = n(34), l = n(2360), f = n(9039), d = r("Reflect", "construct"), p = Object.prototype, h = [].push, v = f(function() {
                    function t() {}
                    return !(d(function() {}, [], t) instanceof t);
                }), y = !f(function() {
                    d(function() {});
                }), g = v || y;
                o({
                    target: "Reflect",
                    stat: !0,
                    forced: g,
                    sham: g
                }, {
                    construct: function(t, e) {
                        s(t), u(e);
                        var n = arguments.length < 3 ? t : s(arguments[2]);
                        if (y && !v) return d(t, e, n);
                        if (t === n) {
                            switch(e.length){
                                case 0:
                                    return new t;
                                case 1:
                                    return new t(e[0]);
                                case 2:
                                    return new t(e[0], e[1]);
                                case 3:
                                    return new t(e[0], e[1], e[2]);
                                case 4:
                                    return new t(e[0], e[1], e[2], e[3]);
                            }
                            var o = [
                                null
                            ];
                            return i(h, o, e), new (i(a, t, o));
                        }
                        var r = n.prototype, f = l(c(r) ? r : p), g = i(t, f, e);
                        return c(g) ? g : f;
                    }
                });
            },
            851: function(t, e, n) {
                var o = n(6955), r = n(5966), i = n(4117), a = n(6269), s = n(8227)("iterator");
                t.exports = function(t) {
                    if (!i(t)) return r(t, s) || r(t, "@@iterator") || a[o(t)];
                };
            },
            926: function(t, e, n) {
                var o = n(9306), r = n(8981), i = n(7055), a = n(6198), s = TypeError, u = "Reduce of empty array with no initial value", c = function(t) {
                    return function(e, n, c, l) {
                        var f = r(e), d = i(f), p = a(f);
                        if (o(n), 0 === p && c < 2) throw new s(u);
                        var h = t ? p - 1 : 0, v = t ? -1 : 1;
                        if (c < 2) for(;;){
                            if (h in d) {
                                l = d[h], h += v;
                                break;
                            }
                            if (h += v, t ? h < 0 : p <= h) throw new s(u);
                        }
                        for(; t ? h >= 0 : p > h; h += v)h in d && (l = n(l, d[h], h, f));
                        return l;
                    };
                };
                t.exports = {
                    left: c(!1),
                    right: c(!0)
                };
            },
            1034: function(t, e, n) {
                var o = n(9565), r = n(9297), i = n(1625), a = n(5213), s = n(7979), u = RegExp.prototype;
                t.exports = a.correct ? function(t) {
                    return t.flags;
                } : function(t) {
                    return a.correct || !i(u, t) || r(t, "flags") ? t.flags : o(s, t);
                };
            },
            1056: function(t, e, n) {
                var o = n(4913).f;
                t.exports = function(t, e, n) {
                    n in t || o(t, n, {
                        configurable: !0,
                        get: function() {
                            return e[n];
                        },
                        set: function(t) {
                            e[n] = t;
                        }
                    });
                };
            },
            1072: function(t, e, n) {
                var o = n(1828), r = n(8727);
                t.exports = Object.keys || function(t) {
                    return o(t, r);
                };
            },
            1088: function(t, e, n) {
                var o = n(6518), r = n(9565), i = n(6395), a = n(350), s = n(4901), u = n(3994), c = n(2787), l = n(2967), f = n(687), d = n(6699), p = n(6840), h = n(8227), v = n(6269), y = n(7657), g = a.PROPER, m = a.CONFIGURABLE, b = y.IteratorPrototype, w = y.BUGGY_SAFARI_ITERATORS, x = h("iterator"), E = "keys", O = "values", S = "entries", k = function() {
                    return this;
                };
                t.exports = function(t, e, n, a, h, y, P) {
                    u(n, e, a);
                    var I, C, A, M = function(t) {
                        if (t === h && R) return R;
                        if (!w && t && t in N) return N[t];
                        switch(t){
                            case E:
                            case O:
                            case S:
                                return function() {
                                    return new n(this, t);
                                };
                        }
                        return function() {
                            return new n(this);
                        };
                    }, D = e + " Iterator", T = !1, N = t.prototype, j = N[x] || N["@@iterator"] || h && N[h], R = !w && j || M(h), L = "Array" === e && N.entries || j;
                    if (L && (I = c(L.call(new t))) !== Object.prototype && I.next && (i || c(I) === b || (l ? l(I, b) : s(I[x]) || p(I, x, k)), f(I, D, !0, !0), i && (v[D] = k)), g && h === O && j && j.name !== O && (!i && m ? d(N, "name", O) : (T = !0, R = function() {
                        return r(j, this);
                    })), h) {
                        if (C = {
                            values: M(O),
                            keys: y ? R : M(E),
                            entries: M(S)
                        }, P) for(A in C)(w || T || !(A in N)) && p(N, A, C[A]);
                        else o({
                            target: e,
                            proto: !0,
                            forced: w || T
                        }, C);
                    }
                    return i && !P || N[x] === R || p(N, x, R, {
                        name: h
                    }), v[e] = R, C;
                };
            },
            1181: function(t, e, n) {
                var o, r, i, a = n(8622), s = n(4576), u = n(34), c = n(6699), l = n(9297), f = n(7629), d = n(6119), p = n(421), h = "Object already initialized", v = s.TypeError, y = s.WeakMap;
                if (a || f.state) {
                    var g = f.state || (f.state = new y);
                    g.get = g.get, g.has = g.has, g.set = g.set, o = function(t, e) {
                        if (g.has(t)) throw new v(h);
                        return e.facade = t, g.set(t, e), e;
                    }, r = function(t) {
                        return g.get(t) || {};
                    }, i = function(t) {
                        return g.has(t);
                    };
                } else {
                    var m = d("state");
                    p[m] = !0, o = function(t, e) {
                        if (l(t, m)) throw new v(h);
                        return e.facade = t, c(t, m, e), e;
                    }, r = function(t) {
                        return l(t, m) ? t[m] : {};
                    }, i = function(t) {
                        return l(t, m);
                    };
                }
                t.exports = {
                    set: o,
                    get: r,
                    has: i,
                    enforce: function(t) {
                        return i(t) ? r(t) : o(t, {});
                    },
                    getterFor: function(t) {
                        return function(e) {
                            var n;
                            if (!u(e) || (n = r(e)).type !== t) throw new v("Incompatible receiver, " + t + " required");
                            return n;
                        };
                    }
                };
            },
            1240: function(t, e, n) {
                var o = n(9504);
                t.exports = o(1.1.valueOf);
            },
            1278: function(t, e, n) {
                var o = n(6518), r = n(3724), i = n(5031), a = n(5397), s = n(7347), u = n(4659);
                o({
                    target: "Object",
                    stat: !0,
                    sham: !r
                }, {
                    getOwnPropertyDescriptors: function(t) {
                        for(var e, n, o = a(t), r = s.f, c = i(o), l = {}, f = 0; c.length > f;)void 0 !== (n = r(o, e = c[f++])) && u(l, e, n);
                        return l;
                    }
                });
            },
            1291: function(t, e, n) {
                var o = n(741);
                t.exports = function(t) {
                    var e = +t;
                    return e != e || 0 === e ? 0 : o(e);
                };
            },
            1296: function(t, e, n) {
                var o = n(4495);
                t.exports = o && !!Symbol.for && !!Symbol.keyFor;
            },
            1436: function(t, e, n) {
                var o = n(8227)("match");
                t.exports = function(t) {
                    var e = /./;
                    try {
                        "/./"[t](e);
                    } catch (n) {
                        try {
                            return e[o] = !1, "/./"[t](e);
                        } catch (t) {}
                    }
                    return !1;
                };
            },
            1469: function(t, e, n) {
                var o = n(7433);
                t.exports = function(t, e) {
                    return new (o(t))(0 === e ? 0 : e);
                };
            },
            1480: function(t, e, n) {
                var o = n(6518), r = n(9039), i = n(298).f;
                o({
                    target: "Object",
                    stat: !0,
                    forced: r(function() {
                        return !Object.getOwnPropertyNames(1);
                    })
                }, {
                    getOwnPropertyNames: i
                });
            },
            1510: function(t, e, n) {
                var o = n(6518), r = n(7751), i = n(9297), a = n(655), s = n(5745), u = n(1296), c = s("string-to-symbol-registry"), l = s("symbol-to-string-registry");
                o({
                    target: "Symbol",
                    stat: !0,
                    forced: !u
                }, {
                    for: function(t) {
                        var e = a(t);
                        if (i(c, e)) return c[e];
                        var n = r("Symbol")(e);
                        return c[e] = n, l[n] = e, n;
                    }
                });
            },
            1625: function(t, e, n) {
                var o = n(9504);
                t.exports = o({}.isPrototypeOf);
            },
            1699: function(t, e, n) {
                var o = n(6518), r = n(9504), i = n(5749), a = n(7750), s = n(655), u = n(1436), c = r("".indexOf);
                o({
                    target: "String",
                    proto: !0,
                    forced: !u("includes")
                }, {
                    includes: function(t) {
                        return !!~c(s(a(this)), s(i(t)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            1761: function(t, e, n) {
                var o = n(9565), r = n(9504), i = n(9228), a = n(8551), s = n(34), u = n(8014), c = n(655), l = n(7750), f = n(5966), d = n(7829), p = n(1034), h = n(6682), v = r("".indexOf);
                i("match", function(t, e, n) {
                    return [
                        function(e) {
                            var n = l(this), r = s(e) ? f(e, t) : void 0;
                            return r ? o(r, e, n) : new RegExp(e)[t](c(n));
                        },
                        function(t) {
                            var o = a(this), r = c(t), i = n(e, o, r);
                            if (i.done) return i.value;
                            var s = c(p(o));
                            if (-1 === v(s, "g")) return h(o, r);
                            var l = -1 !== v(s, "u");
                            o.lastIndex = 0;
                            for(var f, y = [], g = 0; null !== (f = h(o, r));){
                                var m = c(f[0]);
                                y[g] = m, "" === m && (o.lastIndex = d(r, u(o.lastIndex), l)), g++;
                            }
                            return 0 === g ? null : y;
                        }
                    ];
                });
            },
            1828: function(t, e, n) {
                var o = n(9504), r = n(9297), i = n(5397), a = n(9617).indexOf, s = n(421), u = o([].push);
                t.exports = function(t, e) {
                    var n, o = i(t), c = 0, l = [];
                    for(n in o)!r(s, n) && r(o, n) && u(l, n);
                    for(; e.length > c;)r(o, n = e[c++]) && (~a(l, n) || u(l, n));
                    return l;
                };
            },
            1951: function(t, e, n) {
                var o = n(8227);
                e.f = o;
            },
            2008: function(t, e, n) {
                var o = n(6518), r = n(9213).filter;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n(597)("filter")
                }, {
                    filter: function(t) {
                        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2010: function(t, e, n) {
                var o = n(3724), r = n(350).EXISTS, i = n(9504), a = n(2106), s = Function.prototype, u = i(s.toString), c = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, l = i(c.exec);
                o && !r && a(s, "name", {
                    configurable: !0,
                    get: function() {
                        try {
                            return l(c, u(this))[1];
                        } catch (t) {
                            return "";
                        }
                    }
                });
            },
            2062: function(t, e, n) {
                var o = n(6518), r = n(9213).map;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n(597)("map")
                }, {
                    map: function(t) {
                        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2087: function(t, e, n) {
                var o = n(34), r = Math.floor;
                t.exports = Number.isInteger || function(t) {
                    return !o(t) && isFinite(t) && r(t) === t;
                };
            },
            2106: function(t, e, n) {
                var o = n(283), r = n(4913);
                t.exports = function(t, e, n) {
                    return n.get && o(n.get, e, {
                        getter: !0
                    }), n.set && o(n.set, e, {
                        setter: !0
                    }), r.f(t, e, n);
                };
            },
            2140: function(t, e, n) {
                var o = {};
                o[n(8227)("toStringTag")] = "z", t.exports = "[object z]" === String(o);
            },
            2195: function(t, e, n) {
                var o = n(9504), r = o({}.toString), i = o("".slice);
                t.exports = function(t) {
                    return i(r(t), 8, -1);
                };
            },
            2211: function(t, e, n) {
                var o = n(9039);
                t.exports = !o(function() {
                    function t() {}
                    return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
                });
            },
            2259: function(t, e, n) {
                n(511)("iterator");
            },
            2293: function(t, e, n) {
                var o = n(8551), r = n(5548), i = n(4117), a = n(8227)("species");
                t.exports = function(t, e) {
                    var n, s = o(t).constructor;
                    return void 0 === s || i(n = o(s)[a]) ? e : r(n);
                };
            },
            2360: function(t, e, n) {
                var o, r = n(8551), i = n(6801), a = n(8727), s = n(421), u = n(397), c = n(4055), l = n(6119), f = "prototype", d = "script", p = l("IE_PROTO"), h = function() {}, v = function(t) {
                    return "<" + d + ">" + t + "</" + d + ">";
                }, y = function(t) {
                    t.write(v("")), t.close();
                    var e = t.parentWindow.Object;
                    return t = null, e;
                }, g = function() {
                    try {
                        o = new ActiveXObject("htmlfile");
                    } catch (t) {}
                    var t, e, n;
                    g = "undefined" != typeof document ? document.domain && o ? y(o) : (e = c("iframe"), n = "java" + d + ":", e.style.display = "none", u.appendChild(e), e.src = String(n), (t = e.contentWindow.document).open(), t.write(v("document.F=Object")), t.close(), t.F) : y(o);
                    for(var r = a.length; r--;)delete g[f][a[r]];
                    return g();
                };
                s[p] = !0, t.exports = Object.create || function(t, e) {
                    var n;
                    return null !== t ? (h[f] = r(t), n = new h, h[f] = null, n[p] = t) : n = g(), void 0 === e ? n : i.f(n, e);
                };
            },
            2478: function(t, e, n) {
                var o = n(9504), r = n(8981), i = Math.floor, a = o("".charAt), s = o("".replace), u = o("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                t.exports = function(t, e, n, o, f, d) {
                    var p = n + t.length, h = o.length, v = l;
                    return void 0 !== f && (f = r(f), v = c), s(d, v, function(r, s) {
                        var c;
                        switch(a(s, 0)){
                            case "$":
                                return "$";
                            case "&":
                                return t;
                            case "`":
                                return u(e, 0, n);
                            case "'":
                                return u(e, p);
                            case "<":
                                c = f[u(s, 1, -1)];
                                break;
                            default:
                                var l = +s;
                                if (0 === l) return r;
                                if (l > h) {
                                    var d = i(l / 10);
                                    return 0 === d ? r : d <= h ? void 0 === o[d - 1] ? a(s, 1) : o[d - 1] + a(s, 1) : r;
                                }
                                c = o[l - 1];
                        }
                        return void 0 === c ? "" : c;
                    });
                };
            },
            2529: function(t) {
                t.exports = function(t, e) {
                    return {
                        value: t,
                        done: e
                    };
                };
            },
            2551: function(t, e, n) {
                var o = n(6395), r = n(4576), i = n(9039), a = n(3607);
                t.exports = o || !i(function() {
                    if (!(a && a < 535)) {
                        var t = Math.random();
                        __defineSetter__.call(null, t, function() {}), delete r[t];
                    }
                });
            },
            2637: function(t, e, n) {
                n(6518)({
                    target: "Number",
                    stat: !0
                }, {
                    isInteger: n(2087)
                });
            },
            2675: function(t, e, n) {
                n(6761), n(1510), n(7812), n(3110), n(9773);
            },
            2712: function(t, e, n) {
                var o = n(6518), r = n(926).left, i = n(4598), a = n(9519);
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n(6193) && a > 79 && a < 83 || !i("reduce")
                }, {
                    reduce: function(t) {
                        var e = arguments.length;
                        return r(this, t, e, e > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2762: function(t, e, n) {
                var o = n(6518), r = n(3802).trim;
                o({
                    target: "String",
                    proto: !0,
                    forced: n(706)("trim")
                }, {
                    trim: function() {
                        return r(this);
                    }
                });
            },
            2777: function(t, e, n) {
                var o = n(9565), r = n(34), i = n(757), a = n(5966), s = n(4270), u = n(8227), c = TypeError, l = u("toPrimitive");
                t.exports = function(t, e) {
                    if (!r(t) || i(t)) return t;
                    var n, u = a(t, l);
                    if (u) {
                        if (void 0 === e && (e = "default"), n = o(u, t, e), !r(n) || i(n)) return n;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === e && (e = "number"), s(t, e);
                };
            },
            2787: function(t, e, n) {
                var o = n(9297), r = n(4901), i = n(8981), a = n(6119), s = n(2211), u = a("IE_PROTO"), c = Object, l = c.prototype;
                t.exports = s ? c.getPrototypeOf : function(t) {
                    var e = i(t);
                    if (o(e, u)) return e[u];
                    var n = e.constructor;
                    return r(n) && e instanceof n ? n.prototype : e instanceof c ? l : null;
                };
            },
            2796: function(t, e, n) {
                var o = n(9039), r = n(4901), i = /#|\.prototype\./, a = function(t, e) {
                    var n = u[s(t)];
                    return n === l || n !== c && (r(e) ? o(e) : !!e);
                }, s = a.normalize = function(t) {
                    return String(t).replace(i, ".").toLowerCase();
                }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                t.exports = a;
            },
            2839: function(t, e, n) {
                var o = n(4576).navigator, r = o && o.userAgent;
                t.exports = r ? String(r) : "";
            },
            2892: function(t, e, n) {
                var o = n(6518), r = n(6395), i = n(3724), a = n(4576), s = n(9167), u = n(9504), c = n(2796), l = n(9297), f = n(3167), d = n(1625), p = n(757), h = n(2777), v = n(9039), y = n(8480).f, g = n(7347).f, m = n(4913).f, b = n(1240), w = n(3802).trim, x = "Number", E = a[x], O = s[x], S = E.prototype, k = a.TypeError, P = u("".slice), I = u("".charCodeAt), C = function(t) {
                    var e, n, o, r, i, a, s, u, c = h(t, "number");
                    if (p(c)) throw new k("Cannot convert a Symbol value to a number");
                    if ("string" == typeof c && c.length > 2) {
                        if (c = w(c), 43 === (e = I(c, 0)) || 45 === e) {
                            if (88 === (n = I(c, 2)) || 120 === n) return NaN;
                        } else if (48 === e) {
                            switch(I(c, 1)){
                                case 66:
                                case 98:
                                    o = 2, r = 49;
                                    break;
                                case 79:
                                case 111:
                                    o = 8, r = 55;
                                    break;
                                default:
                                    return +c;
                            }
                            for(a = (i = P(c, 2)).length, s = 0; s < a; s++)if ((u = I(i, s)) < 48 || u > r) return NaN;
                            return parseInt(i, o);
                        }
                    }
                    return +c;
                }, A = c(x, !E(" 0o1") || !E("0b1") || E("+0x1")), M = function(t) {
                    var e, n = arguments.length < 1 ? 0 : E(function(t) {
                        var e = h(t, "number");
                        return "bigint" == typeof e ? e : C(e);
                    }(t));
                    return d(S, e = this) && v(function() {
                        b(e);
                    }) ? f(Object(n), this, M) : n;
                };
                M.prototype = S, A && !r && (S.constructor = M), o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Number: M
                });
                var D = function(t, e) {
                    for(var n, o = i ? y(e) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), r = 0; o.length > r; r++)l(e, n = o[r]) && !l(t, n) && m(t, n, g(e, n));
                };
                r && O && D(s[x], O), (A || r) && D(s[x], E);
            },
            2953: function(t, e, n) {
                var o = n(4576), r = n(7400), i = n(9296), a = n(3792), s = n(6699), u = n(687), c = n(8227)("iterator"), l = a.values, f = function(t, e) {
                    if (t) {
                        if (t[c] !== l) try {
                            s(t, c, l);
                        } catch (e) {
                            t[c] = l;
                        }
                        if (u(t, e, !0), r[e]) {
                            for(var n in a)if (t[n] !== a[n]) try {
                                s(t, n, a[n]);
                            } catch (e) {
                                t[n] = a[n];
                            }
                        }
                    }
                };
                for(var d in r)f(o[d] && o[d].prototype, d);
                f(i, "DOMTokenList");
            },
            2967: function(t, e, n) {
                var o = n(6706), r = n(34), i = n(7750), a = n(3506);
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var t, e = !1, n = {};
                    try {
                        (t = o(Object.prototype, "__proto__", "set"))(n, []), e = n instanceof Array;
                    } catch (t) {}
                    return function(n, o) {
                        return i(n), a(o), r(n) ? (e ? t(n, o) : n.__proto__ = o, n) : n;
                    };
                }() : void 0);
            },
            3110: function(t, e, n) {
                var o = n(6518), r = n(7751), i = n(8745), a = n(9565), s = n(9504), u = n(9039), c = n(4376), l = n(4901), f = n(5810), d = n(757), p = n(2195), h = n(655), v = n(7680), y = n(8235), g = n(3392), m = n(4495), b = n(7819), w = String, x = r("JSON", "stringify"), E = s(/./.exec), O = s("".charAt), S = s("".charCodeAt), k = s("".replace), P = s("".slice), I = s([].push), C = s(1.1.toString), A = /[\uD800-\uDFFF]/g, M = /^[\uD800-\uDBFF]$/, D = /^[\uDC00-\uDFFF]$/, T = g(), N = T.length, j = !m || u(function() {
                    var t = r("Symbol")("stringify detection");
                    return "[null]" !== x([
                        t
                    ]) || "{}" !== x({
                        a: t
                    }) || "{}" !== x(Object(t));
                }), R = u(function() {
                    return '"\\udf06\\ud834"' !== x("\udf06\ud834") || '"\\udead"' !== x("\udead");
                }), L = j ? function(t, e) {
                    var n = v(arguments), o = K(e);
                    if (l(o) || void 0 !== t && !d(t)) return n[1] = function(t, e) {
                        if (l(o) && (e = a(o, this, w(t), e)), !d(e)) return e;
                    }, i(x, null, n);
                } : x, B = function(t, e, n) {
                    var o = O(n, e - 1), r = O(n, e + 1);
                    return E(M, t) && !E(D, r) || E(D, t) && !E(M, o) ? "\\u" + C(S(t, 0), 16) : t;
                }, K = function(t) {
                    if (l(t)) return t;
                    if (c(t)) {
                        for(var e = t.length, n = [], o = 0; o < e; o++){
                            var r = t[o];
                            "string" == typeof r ? I(n, r) : "number" != typeof r && "Number" !== p(r) && "String" !== p(r) || I(n, h(r));
                        }
                        var i = n.length, a = !0;
                        return function(t, e) {
                            if (a) return a = !1, e;
                            if (c(this)) return e;
                            for(var o = 0; o < i; o++)if (n[o] === t) return e;
                        };
                    }
                };
                x && o({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: j || R || !b
                }, {
                    stringify: function(t, e, n) {
                        var o = K(e), r = [], i = L(t, function(t, e) {
                            var n = l(o) ? a(o, this, w(t), e) : e;
                            return !b && f(n) ? T + (I(r, n.rawJSON) - 1) : n;
                        }, n);
                        if ("string" != typeof i) return i;
                        if (R && (i = k(i, A, B)), b) return i;
                        for(var s = "", u = i.length, c = 0; c < u; c++){
                            var d = O(i, c);
                            if ('"' === d) {
                                var p = y(i, ++c).end - 1, h = P(i, c, p);
                                s += P(h, 0, N) === T ? r[P(h, N)] : '"' + h + '"', c = p;
                            } else s += d;
                        }
                        return s;
                    }
                });
            },
            3167: function(t, e, n) {
                var o = n(4901), r = n(34), i = n(2967);
                t.exports = function(t, e, n) {
                    var a, s;
                    return i && o(a = e.constructor) && a !== n && r(s = a.prototype) && s !== n.prototype && i(t, s), t;
                };
            },
            3179: function(t, e, n) {
                var o = n(2140), r = n(6955);
                t.exports = o ? ({}).toString : function() {
                    return "[object " + r(this) + "]";
                };
            },
            3392: function(t, e, n) {
                var o = n(9504), r = 0, i = Math.random(), a = o(1.1.toString);
                t.exports = function(t) {
                    return "Symbol(" + (void 0 === t ? "" : t) + ")_" + a(++r + i, 36);
                };
            },
            3418: function(t, e, n) {
                var o = n(6518), r = n(7916);
                o({
                    target: "Array",
                    stat: !0,
                    forced: !n(4428)(function(t) {
                        Array.from(t);
                    })
                }, {
                    from: r
                });
            },
            3500: function(t, e, n) {
                var o = n(4576), r = n(7400), i = n(9296), a = n(235), s = n(6699), u = function(t) {
                    if (t && t.forEach !== a) try {
                        s(t, "forEach", a);
                    } catch (e) {
                        t.forEach = a;
                    }
                };
                for(var c in r)r[c] && u(o[c] && o[c].prototype);
                u(i);
            },
            3506: function(t, e, n) {
                var o = n(3925), r = String, i = TypeError;
                t.exports = function(t) {
                    if (o(t)) return t;
                    throw new i("Can't set " + r(t) + " as a prototype");
                };
            },
            3517: function(t, e, n) {
                var o = n(9504), r = n(9039), i = n(4901), a = n(6955), s = n(7751), u = n(3706), c = function() {}, l = s("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = o(f.exec), p = !f.test(c), h = function(t) {
                    if (!i(t)) return !1;
                    try {
                        return l(c, [], t), !0;
                    } catch (t) {
                        return !1;
                    }
                }, v = function(t) {
                    if (!i(t)) return !1;
                    switch(a(t)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, u(t));
                    } catch (t) {
                        return !0;
                    }
                };
                v.sham = !0, t.exports = !l || r(function() {
                    var t;
                    return h(h.call) || !h(Object) || !h(function() {
                        t = !0;
                    }) || t;
                }) ? v : h;
            },
            3607: function(t, e, n) {
                var o = n(2839).match(/AppleWebKit\/(\d+)\./);
                t.exports = !!o && +o[1];
            },
            3635: function(t, e, n) {
                var o = n(9039), r = n(4576).RegExp;
                t.exports = o(function() {
                    var t = r(".", "s");
                    return !(t.dotAll && t.test("\n") && "s" === t.flags);
                });
            },
            3640: function(t, e, n) {
                var o = n(8551), r = n(4270), i = TypeError;
                t.exports = function(t) {
                    if (o(this), "string" === t || "default" === t) t = "string";
                    else if ("number" !== t) throw new i("Incorrect hint");
                    return r(this, t);
                };
            },
            3706: function(t, e, n) {
                var o = n(9504), r = n(4901), i = n(7629), a = o(Function.toString);
                r(i.inspectSource) || (i.inspectSource = function(t) {
                    return a(t);
                }), t.exports = i.inspectSource;
            },
            3709: function(t, e, n) {
                var o = n(2839).match(/firefox\/(\d+)/i);
                t.exports = !!o && +o[1];
            },
            3717: function(t, e) {
                e.f = Object.getOwnPropertySymbols;
            },
            3724: function(t, e, n) {
                var o = n(9039);
                t.exports = !o(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            3763: function(t, e, n) {
                var o = n(2839);
                t.exports = /MSIE|Trident/.test(o);
            },
            3792: function(t, e, n) {
                var o = n(5397), r = n(6469), i = n(6269), a = n(1181), s = n(4913).f, u = n(1088), c = n(2529), l = n(6395), f = n(3724), d = "Array Iterator", p = a.set, h = a.getterFor(d);
                t.exports = u(Array, "Array", function(t, e) {
                    p(this, {
                        type: d,
                        target: o(t),
                        index: 0,
                        kind: e
                    });
                }, function() {
                    var t = h(this), e = t.target, n = t.index++;
                    if (!e || n >= e.length) return t.target = null, c(void 0, !0);
                    switch(t.kind){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(e[n], !1);
                    }
                    return c([
                        n,
                        e[n]
                    ], !1);
                }, "values");
                var v = i.Arguments = i.Array;
                if (r("keys"), r("values"), r("entries"), !l && f && "values" !== v.name) try {
                    s(v, "name", {
                        value: "values"
                    });
                } catch (t) {}
            },
            3802: function(t, e, n) {
                var o = n(9504), r = n(7750), i = n(655), a = n(7452), s = o("".replace), u = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(t) {
                    return function(e) {
                        var n = i(r(e));
                        return 1 & t && (n = s(n, u, "")), 2 & t && (n = s(n, c, "$1")), n;
                    };
                };
                t.exports = {
                    start: l(1),
                    end: l(2),
                    trim: l(3)
                };
            },
            3851: function(t, e, n) {
                var o = n(6518), r = n(9039), i = n(5397), a = n(7347).f, s = n(3724);
                o({
                    target: "Object",
                    stat: !0,
                    forced: !s || r(function() {
                        a(1);
                    }),
                    sham: !s
                }, {
                    getOwnPropertyDescriptor: function(t, e) {
                        return a(i(t), e);
                    }
                });
            },
            3925: function(t, e, n) {
                var o = n(34);
                t.exports = function(t) {
                    return o(t) || null === t;
                };
            },
            3994: function(t, e, n) {
                var o = n(7657).IteratorPrototype, r = n(2360), i = n(6980), a = n(687), s = n(6269), u = function() {
                    return this;
                };
                t.exports = function(t, e, n, c) {
                    var l = e + " Iterator";
                    return t.prototype = r(o, {
                        next: i(+!c, n)
                    }), a(t, l, !1, !0), s[l] = u, t;
                };
            },
            4055: function(t, e, n) {
                var o = n(4576), r = n(34), i = o.document, a = r(i) && r(i.createElement);
                t.exports = function(t) {
                    return a ? i.createElement(t) : {};
                };
            },
            4117: function(t) {
                t.exports = function(t) {
                    return null == t;
                };
            },
            4209: function(t, e, n) {
                var o = n(8227), r = n(6269), i = o("iterator"), a = Array.prototype;
                t.exports = function(t) {
                    return void 0 !== t && (r.Array === t || a[i] === t);
                };
            },
            4213: function(t, e, n) {
                var o = n(3724), r = n(9504), i = n(9565), a = n(9039), s = n(1072), u = n(3717), c = n(8773), l = n(8981), f = n(7055), d = Object.assign, p = Object.defineProperty, h = r([].concat);
                t.exports = !d || a(function() {
                    if (o && 1 !== d({
                        b: 1
                    }, d(p({}, "a", {
                        enumerable: !0,
                        get: function() {
                            p(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var t = {}, e = {}, n = Symbol("assign detection"), r = "abcdefghijklmnopqrst";
                    return t[n] = 7, r.split("").forEach(function(t) {
                        e[t] = t;
                    }), 7 !== d({}, t)[n] || s(d({}, e)).join("") !== r;
                }) ? function(t, e) {
                    for(var n = l(t), r = arguments.length, a = 1, d = u.f, p = c.f; r > a;)for(var v, y = f(arguments[a++]), g = d ? h(s(y), d(y)) : s(y), m = g.length, b = 0; m > b;)v = g[b++], o && !i(p, y, v) || (n[v] = y[v]);
                    return n;
                } : d;
            },
            4215: function(t, e, n) {
                var o = n(4576), r = n(2839), i = n(2195), a = function(t) {
                    return r.slice(0, t.length) === t;
                };
                t.exports = a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : o.Bun && "string" == typeof Bun.version ? "BUN" : o.Deno && "object" == typeof Deno.version ? "DENO" : "process" === i(o.process) ? "NODE" : o.window && o.document ? "BROWSER" : "REST";
            },
            4270: function(t, e, n) {
                var o = n(9565), r = n(4901), i = n(34), a = TypeError;
                t.exports = function(t, e) {
                    var n, s;
                    if ("string" === e && r(n = t.toString) && !i(s = o(n, t))) return s;
                    if (r(n = t.valueOf) && !i(s = o(n, t))) return s;
                    if ("string" !== e && r(n = t.toString) && !i(s = o(n, t))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            4376: function(t, e, n) {
                var o = n(2195);
                t.exports = Array.isArray || function(t) {
                    return "Array" === o(t);
                };
            },
            4423: function(t, e, n) {
                var o = n(6518), r = n(9617).includes, i = n(9039), a = n(6469);
                o({
                    target: "Array",
                    proto: !0,
                    forced: i(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(t) {
                        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), a("includes");
            },
            4428: function(t, e, n) {
                var o = n(8227)("iterator"), r = !1;
                try {
                    var i = 0, a = {
                        next: function() {
                            return {
                                done: !!i++
                            };
                        },
                        return: function() {
                            r = !0;
                        }
                    };
                    a[o] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (t) {}
                t.exports = function(t, e) {
                    try {
                        if (!e && !r) return !1;
                    } catch (t) {
                        return !1;
                    }
                    var n = !1;
                    try {
                        var i = {};
                        i[o] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: n = !0
                                    };
                                }
                            };
                        }, t(i);
                    } catch (t) {}
                    return n;
                };
            },
            4488: function(t, e, n) {
                var o = n(7680), r = Math.floor, i = function(t, e) {
                    var n = t.length;
                    if (n < 8) for(var a, s, u = 1; u < n;){
                        for(s = u, a = t[u]; s && e(t[s - 1], a) > 0;)t[s] = t[--s];
                        s !== u++ && (t[s] = a);
                    }
                    else for(var c = r(n / 2), l = i(o(t, 0, c), e), f = i(o(t, c), e), d = l.length, p = f.length, h = 0, v = 0; h < d || v < p;)t[h + v] = h < d && v < p ? e(l[h], f[v]) <= 0 ? l[h++] : f[v++] : h < d ? l[h++] : f[v++];
                    return t;
                };
                t.exports = i;
            },
            4495: function(t, e, n) {
                var o = n(9519), r = n(9039), i = n(4576).String;
                t.exports = !!Object.getOwnPropertySymbols && !r(function() {
                    var t = Symbol("symbol detection");
                    return !i(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && o && o < 41;
                });
            },
            4527: function(t, e, n) {
                var o = n(3724), r = n(4376), i = TypeError, a = Object.getOwnPropertyDescriptor, s = o && !function() {
                    if (void 0 !== this) return !0;
                    try {
                        Object.defineProperty([], "length", {
                            writable: !1
                        }).length = 1;
                    } catch (t) {
                        return t instanceof TypeError;
                    }
                }();
                t.exports = s ? function(t, e) {
                    if (r(t) && !a(t, "length").writable) throw new i("Cannot set read only .length");
                    return t.length = e;
                } : function(t, e) {
                    return t.length = e;
                };
            },
            4554: function(t, e, n) {
                var o = n(6518), r = n(8981), i = n(5610), a = n(1291), s = n(6198), u = n(4527), c = n(6837), l = n(1469), f = n(4659), d = n(4606), p = n(597)("splice"), h = Math.max, v = Math.min;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !p
                }, {
                    splice: function(t, e) {
                        var n, o, p, y, g, m, b = r(this), w = s(b), x = i(t, w), E = arguments.length;
                        for(0 === E ? n = o = 0 : 1 === E ? (n = 0, o = w - x) : (n = E - 2, o = v(h(a(e), 0), w - x)), c(w + n - o), p = l(b, o), y = 0; y < o; y++)(g = x + y) in b && f(p, y, b[g]);
                        if (p.length = o, n < o) {
                            for(y = x; y < w - o; y++)m = y + n, (g = y + o) in b ? b[m] = b[g] : d(b, m);
                            for(y = w; y > w - o + n; y--)d(b, y - 1);
                        } else if (n > o) for(y = w - o; y > x; y--)m = y + n - 1, (g = y + o - 1) in b ? b[m] = b[g] : d(b, m);
                        for(y = 0; y < n; y++)b[y + x] = arguments[y + 2];
                        return u(b, w - o + n), p;
                    }
                });
            },
            4576: function(t, e, n) {
                var o = function(t) {
                    return t && t.Math === Math && t;
                };
                t.exports = o("object" == typeof globalThis && globalThis) || o("object" == typeof window && window) || o("object" == typeof self && self) || o("object" == typeof n.g && n.g) || o("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            4598: function(t, e, n) {
                var o = n(9039);
                t.exports = function(t, e) {
                    var n = [][t];
                    return !!n && o(function() {
                        n.call(null, e || function() {
                            return 1;
                        }, 1);
                    });
                };
            },
            4606: function(t, e, n) {
                var o = n(6823), r = TypeError;
                t.exports = function(t, e) {
                    if (!delete t[e]) throw new r("Cannot delete property " + o(e) + " of " + o(t));
                };
            },
            4659: function(t, e, n) {
                var o = n(3724), r = n(4913), i = n(6980);
                t.exports = function(t, e, n) {
                    o ? r.f(t, e, i(0, n)) : t[e] = n;
                };
            },
            4782: function(t, e, n) {
                var o = n(6518), r = n(4376), i = n(3517), a = n(34), s = n(5610), u = n(6198), c = n(5397), l = n(4659), f = n(8227), d = n(597), p = n(7680), h = d("slice"), v = f("species"), y = Array, g = Math.max;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !h
                }, {
                    slice: function(t, e) {
                        var n, o, f, d = c(this), h = u(d), m = s(t, h), b = s(void 0 === e ? h : e, h);
                        if (r(d) && (n = d.constructor, (i(n) && (n === y || r(n.prototype)) || a(n) && null === (n = n[v])) && (n = void 0), n === y || void 0 === n)) return p(d, m, b);
                        for(o = new (void 0 === n ? y : n)(g(b - m, 0)), f = 0; m < b; m++, f++)m in d && l(o, f, d[m]);
                        return o.length = f, o;
                    }
                });
            },
            4864: function(t, e, n) {
                var o = n(3724), r = n(4576), i = n(9504), a = n(2796), s = n(3167), u = n(6699), c = n(2360), l = n(8480).f, f = n(1625), d = n(788), p = n(655), h = n(1034), v = n(8429), y = n(1056), g = n(6840), m = n(9039), b = n(9297), w = n(1181).enforce, x = n(7633), E = n(8227), O = n(3635), S = n(8814), k = E("match"), P = r.RegExp, I = P.prototype, C = r.SyntaxError, A = i(I.exec), M = i("".charAt), D = i("".replace), T = i("".indexOf), N = i("".slice), j = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, R = /a/g, L = /a/g, B = new P(R) !== R, K = v.MISSED_STICKY, F = v.UNSUPPORTED_Y, _ = o && (!B || K || O || S || m(function() {
                    return L[k] = !1, P(R) !== R || P(L) === L || "/a/i" !== String(P(R, "i"));
                }));
                if (a("RegExp", _)) {
                    for(var U = function(t, e) {
                        var n, o, r, i, a, l, v = f(I, this), y = d(t), g = void 0 === e, m = [], x = t;
                        if (!v && y && g && t.constructor === U) return t;
                        if ((y || f(I, t)) && (t = t.source, g && (e = h(x))), t = void 0 === t ? "" : p(t), e = void 0 === e ? "" : p(e), x = t, O && "dotAll" in R && (o = !!e && T(e, "s") > -1) && (e = D(e, /s/g, "")), n = e, K && "sticky" in R && (r = !!e && T(e, "y") > -1) && F && (e = D(e, /y/g, "")), S && (i = function(t) {
                            for(var e, n = t.length, o = 0, r = "", i = [], a = c(null), s = !1, u = !1, l = 0, f = ""; o <= n; o++){
                                if ("\\" === (e = M(t, o))) e += M(t, ++o);
                                else if ("]" === e) s = !1;
                                else if (!s) switch(!0){
                                    case "[" === e:
                                        s = !0;
                                        break;
                                    case "(" === e:
                                        if (r += e, "?:" === N(t, o + 1, o + 3)) continue;
                                        A(j, N(t, o + 1)) && (o += 2, u = !0), l++;
                                        continue;
                                    case ">" === e && u:
                                        if ("" === f || b(a, f)) throw new C("Invalid capture group name");
                                        a[f] = !0, i[i.length] = [
                                            f,
                                            l
                                        ], u = !1, f = "";
                                        continue;
                                }
                                u ? f += e : r += e;
                            }
                            return [
                                r,
                                i
                            ];
                        }(t), t = i[0], m = i[1]), a = s(P(t, e), v ? this : I, U), (o || r || m.length) && (l = w(a), o && (l.dotAll = !0, l.raw = U(function(t) {
                            for(var e, n = t.length, o = 0, r = "", i = !1; o <= n; o++)"\\" !== (e = M(t, o)) ? i || "." !== e ? ("[" === e ? i = !0 : "]" === e && (i = !1), r += e) : r += "[\\s\\S]" : r += e + M(t, ++o);
                            return r;
                        }(t), n)), r && (l.sticky = !0), m.length && (l.groups = m)), t !== x) try {
                            u(a, "source", "" === x ? "(?:)" : x);
                        } catch (t) {}
                        return a;
                    }, H = l(P), $ = 0; H.length > $;)y(U, P, H[$++]);
                    I.constructor = U, U.prototype = I, g(r, "RegExp", U, {
                        constructor: !0
                    });
                }
                x("RegExp");
            },
            4901: function(t) {
                var e = "object" == typeof document && document.all;
                t.exports = void 0 === e && void 0 !== e ? function(t) {
                    return "function" == typeof t || t === e;
                } : function(t) {
                    return "function" == typeof t;
                };
            },
            4913: function(t, e, n) {
                var o = n(3724), r = n(5917), i = n(8686), a = n(8551), s = n(6969), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", d = "configurable", p = "writable";
                e.f = o ? i ? function(t, e, n) {
                    if (a(t), e = s(e), a(n), "function" == typeof t && "prototype" === e && "value" in n && p in n && !n[p]) {
                        var o = l(t, e);
                        o && o[p] && (t[e] = n.value, n = {
                            configurable: d in n ? n[d] : o[d],
                            enumerable: f in n ? n[f] : o[f],
                            writable: !1
                        });
                    }
                    return c(t, e, n);
                } : c : function(t, e, n) {
                    if (a(t), e = s(e), a(n), r) try {
                        return c(t, e, n);
                    } catch (t) {}
                    if ("get" in n || "set" in n) throw new u("Accessors not supported");
                    return "value" in n && (t[e] = n.value), t;
                };
            },
            5031: function(t, e, n) {
                var o = n(7751), r = n(9504), i = n(8480), a = n(3717), s = n(8551), u = r([].concat);
                t.exports = o("Reflect", "ownKeys") || function(t) {
                    var e = i.f(s(t)), n = a.f;
                    return n ? u(e, n(t)) : e;
                };
            },
            5213: function(t, e, n) {
                var o = n(4576), r = n(9039), i = o.RegExp, a = !r(function() {
                    var t = !0;
                    try {
                        i(".", "d");
                    } catch (e) {
                        t = !1;
                    }
                    var e = {}, n = "", o = t ? "dgimsy" : "gimsy", r = function(t, o) {
                        Object.defineProperty(e, t, {
                            get: function() {
                                return n += o, !0;
                            }
                        });
                    }, a = {
                        dotAll: "s",
                        global: "g",
                        ignoreCase: "i",
                        multiline: "m",
                        sticky: "y"
                    };
                    for(var s in t && (a.hasIndices = "d"), a)r(s, a[s]);
                    return Object.getOwnPropertyDescriptor(i.prototype, "flags").get.call(e) !== o || n !== o;
                });
                t.exports = {
                    correct: a
                };
            },
            5276: function(t, e, n) {
                var o = n(6518), r = n(7476), i = n(9617).indexOf, a = n(4598), s = r([].indexOf), u = !!s && 1 / s([
                    1
                ], 1, -0) < 0;
                o({
                    target: "Array",
                    proto: !0,
                    forced: u || !a("indexOf")
                }, {
                    indexOf: function(t) {
                        var e = arguments.length > 1 ? arguments[1] : void 0;
                        return u ? s(this, t, e) || 0 : i(this, t, e);
                    }
                });
            },
            5397: function(t, e, n) {
                var o = n(7055), r = n(7750);
                t.exports = function(t) {
                    return o(r(t));
                };
            },
            5440: function(t, e, n) {
                var o = n(8745), r = n(9565), i = n(9504), a = n(9228), s = n(9039), u = n(8551), c = n(4901), l = n(34), f = n(1291), d = n(8014), p = n(655), h = n(7750), v = n(7829), y = n(5966), g = n(2478), m = n(1034), b = n(6682), w = n(8227)("replace"), x = Math.max, E = Math.min, O = i([].concat), S = i([].push), k = i("".indexOf), P = i("".slice), I = "$0" === "a".replace(/./, "$0"), C = !!/./[w] && "" === /./[w]("a", "$0");
                a("replace", function(t, e, n) {
                    var i = C ? "$" : "$0";
                    return [
                        function(t, n) {
                            var o = h(this), i = l(t) ? y(t, w) : void 0;
                            return i ? r(i, t, o, n) : r(e, p(o), t, n);
                        },
                        function(t, r) {
                            var a = u(this), s = p(t);
                            if ("string" == typeof r && -1 === k(r, i) && -1 === k(r, "$<")) {
                                var l = n(e, a, s, r);
                                if (l.done) return l.value;
                            }
                            var h = c(r);
                            h || (r = p(r));
                            var y, w = p(m(a)), I = -1 !== k(w, "g");
                            I && (y = -1 !== k(w, "u"), a.lastIndex = 0);
                            for(var C, A = []; null !== (C = b(a, s)) && (S(A, C), I);)"" === p(C[0]) && (a.lastIndex = v(s, d(a.lastIndex), y));
                            for(var M, D = "", T = 0, N = 0; N < A.length; N++){
                                for(var j, R = p((C = A[N])[0]), L = x(E(f(C.index), s.length), 0), B = [], K = 1; K < C.length; K++)S(B, void 0 === (M = C[K]) ? M : String(M));
                                var F = C.groups;
                                if (h) {
                                    var _ = O([
                                        R
                                    ], B, L, s);
                                    void 0 !== F && S(_, F), j = p(o(r, void 0, _));
                                } else j = g(R, s, L, B, F, r);
                                L >= T && (D += P(s, T, L) + j, T = L + R.length);
                            }
                            return D + P(s, T);
                        }
                    ];
                }, !!s(function() {
                    var t = /./;
                    return t.exec = function() {
                        var t = [];
                        return t.groups = {
                            a: "7"
                        }, t;
                    }, "7" !== "".replace(t, "$<a>");
                }) || !I || C);
            },
            5548: function(t, e, n) {
                var o = n(3517), r = n(6823), i = TypeError;
                t.exports = function(t) {
                    if (o(t)) return t;
                    throw new i(r(t) + " is not a constructor");
                };
            },
            5610: function(t, e, n) {
                var o = n(1291), r = Math.max, i = Math.min;
                t.exports = function(t, e) {
                    var n = o(t);
                    return n < 0 ? r(n + e, 0) : i(n, e);
                };
            },
            5700: function(t, e, n) {
                var o = n(511), r = n(8242);
                o("toPrimitive"), r();
            },
            5745: function(t, e, n) {
                var o = n(7629);
                t.exports = function(t, e) {
                    return o[t] || (o[t] = e || {});
                };
            },
            5749: function(t, e, n) {
                var o = n(788), r = TypeError;
                t.exports = function(t) {
                    if (o(t)) throw new r("The method doesn't accept regular expressions");
                    return t;
                };
            },
            5810: function(t, e, n) {
                var o = n(34), r = n(1181).get;
                t.exports = function(t) {
                    if (!o(t)) return !1;
                    var e = r(t);
                    return !!e && "RawJSON" === e.type;
                };
            },
            5917: function(t, e, n) {
                var o = n(3724), r = n(9039), i = n(4055);
                t.exports = !o && !r(function() {
                    return 7 !== Object.defineProperty(i("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            5966: function(t, e, n) {
                var o = n(9306), r = n(4117);
                t.exports = function(t, e) {
                    var n = t[e];
                    return r(n) ? void 0 : o(n);
                };
            },
            6080: function(t, e, n) {
                var o = n(7476), r = n(9306), i = n(616), a = o(o.bind);
                t.exports = function(t, e) {
                    return r(t), void 0 === e ? t : i ? a(t, e) : function() {
                        return t.apply(e, arguments);
                    };
                };
            },
            6099: function(t, e, n) {
                var o = n(2140), r = n(6840), i = n(3179);
                o || r(Object.prototype, "toString", i, {
                    unsafe: !0
                });
            },
            6119: function(t, e, n) {
                var o = n(5745), r = n(3392), i = o("keys");
                t.exports = function(t) {
                    return i[t] || (i[t] = r(t));
                };
            },
            6193: function(t, e, n) {
                var o = n(4215);
                t.exports = "NODE" === o;
            },
            6198: function(t, e, n) {
                var o = n(8014);
                t.exports = function(t) {
                    return o(t.length);
                };
            },
            6269: function(t) {
                t.exports = {};
            },
            6319: function(t, e, n) {
                var o = n(8551), r = n(9539);
                t.exports = function(t, e, n, i) {
                    try {
                        return i ? e(o(n)[0], n[1]) : e(n);
                    } catch (e) {
                        r(t, "throw", e);
                    }
                };
            },
            6395: function(t) {
                t.exports = !1;
            },
            6469: function(t, e, n) {
                var o = n(8227), r = n(2360), i = n(4913).f, a = o("unscopables"), s = Array.prototype;
                void 0 === s[a] && i(s, a, {
                    configurable: !0,
                    value: r(null)
                }), t.exports = function(t) {
                    s[a][t] = !0;
                };
            },
            6518: function(t, e, n) {
                var o = n(4576), r = n(7347).f, i = n(6699), a = n(6840), s = n(9433), u = n(7740), c = n(2796);
                t.exports = function(t, e) {
                    var n, l, f, d, p, h = t.target, v = t.global, y = t.stat;
                    if (n = v ? o : y ? o[h] || s(h, {}) : o[h] && o[h].prototype) for(l in e){
                        if (d = e[l], f = t.dontCallGetSet ? (p = r(n, l)) && p.value : n[l], !c(v ? l : h + (y ? "." : "#") + l, t.forced) && void 0 !== f) {
                            if (typeof d == typeof f) continue;
                            u(d, f);
                        }
                        (t.sham || f && f.sham) && i(d, "sham", !0), a(n, l, d, t);
                    }
                };
            },
            6682: function(t, e, n) {
                var o = n(9565), r = n(8551), i = n(4901), a = n(2195), s = n(7323), u = TypeError;
                t.exports = function(t, e) {
                    var n = t.exec;
                    if (i(n)) {
                        var c = o(n, t, e);
                        return null !== c && r(c), c;
                    }
                    if ("RegExp" === a(t)) return o(s, t, e);
                    throw new u("RegExp#exec called on incompatible receiver");
                };
            },
            6699: function(t, e, n) {
                var o = n(3724), r = n(4913), i = n(6980);
                t.exports = o ? function(t, e, n) {
                    return r.f(t, e, i(1, n));
                } : function(t, e, n) {
                    return t[e] = n, t;
                };
            },
            6706: function(t, e, n) {
                var o = n(9504), r = n(9306);
                t.exports = function(t, e, n) {
                    try {
                        return o(r(Object.getOwnPropertyDescriptor(t, e)[n]));
                    } catch (t) {}
                };
            },
            6761: function(t, e, n) {
                var o = n(6518), r = n(4576), i = n(9565), a = n(9504), s = n(6395), u = n(3724), c = n(4495), l = n(9039), f = n(9297), d = n(1625), p = n(8551), h = n(5397), v = n(6969), y = n(655), g = n(6980), m = n(2360), b = n(1072), w = n(8480), x = n(298), E = n(3717), O = n(7347), S = n(4913), k = n(6801), P = n(8773), I = n(6840), C = n(2106), A = n(5745), M = n(6119), D = n(421), T = n(3392), N = n(8227), j = n(1951), R = n(511), L = n(8242), B = n(687), K = n(1181), F = n(9213).forEach, _ = M("hidden"), U = "Symbol", H = "prototype", $ = K.set, G = K.getterFor(U), V = Object[H], z = r.Symbol, J = z && z[H], Y = r.RangeError, W = r.TypeError, X = r.QObject, q = O.f, Q = S.f, Z = x.f, tt = P.f, et = a([].push), nt = A("symbols"), ot = A("op-symbols"), rt = A("wks"), it = !X || !X[H] || !X[H].findChild, at = function(t, e, n) {
                    var o = q(V, e);
                    o && delete V[e], Q(t, e, n), o && t !== V && Q(V, e, o);
                }, st = u && l(function() {
                    return 7 !== m(Q({}, "a", {
                        get: function() {
                            return Q(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? at : Q, ut = function(t, e) {
                    var n = nt[t] = m(J);
                    return $(n, {
                        type: U,
                        tag: t,
                        description: e
                    }), u || (n.description = e), n;
                }, ct = function(t, e, n) {
                    t === V && ct(ot, e, n), p(t);
                    var o = v(e);
                    return p(n), f(nt, o) ? (n.enumerable ? (f(t, _) && t[_][o] && (t[_][o] = !1), n = m(n, {
                        enumerable: g(0, !1)
                    })) : (f(t, _) || Q(t, _, g(1, m(null))), t[_][o] = !0), st(t, o, n)) : Q(t, o, n);
                }, lt = function(t, e) {
                    p(t);
                    var n = h(e), o = b(n).concat(ht(n));
                    return F(o, function(e) {
                        u && !i(ft, n, e) || ct(t, e, n[e]);
                    }), t;
                }, ft = function(t) {
                    var e = v(t), n = i(tt, this, e);
                    return !(this === V && f(nt, e) && !f(ot, e)) && (!(n || !f(this, e) || !f(nt, e) || f(this, _) && this[_][e]) || n);
                }, dt = function(t, e) {
                    var n = h(t), o = v(e);
                    if (n !== V || !f(nt, o) || f(ot, o)) {
                        var r = q(n, o);
                        return !r || !f(nt, o) || f(n, _) && n[_][o] || (r.enumerable = !0), r;
                    }
                }, pt = function(t) {
                    var e = Z(h(t)), n = [];
                    return F(e, function(t) {
                        f(nt, t) || f(D, t) || et(n, t);
                    }), n;
                }, ht = function(t) {
                    var e = t === V, n = Z(e ? ot : h(t)), o = [];
                    return F(n, function(t) {
                        !f(nt, t) || e && !f(V, t) || et(o, nt[t]);
                    }), o;
                };
                c || (z = function() {
                    if (d(J, this)) throw new W("Symbol is not a constructor");
                    var t = arguments.length && void 0 !== arguments[0] ? y(arguments[0]) : void 0, e = T(t), n = function(t) {
                        var o = void 0 === this ? r : this;
                        o === V && i(n, ot, t), f(o, _) && f(o[_], e) && (o[_][e] = !1);
                        var a = g(1, t);
                        try {
                            st(o, e, a);
                        } catch (t) {
                            if (!(t instanceof Y)) throw t;
                            at(o, e, a);
                        }
                    };
                    return u && it && st(V, e, {
                        configurable: !0,
                        set: n
                    }), ut(e, t);
                }, I(J = z[H], "toString", function() {
                    return G(this).tag;
                }), I(z, "withoutSetter", function(t) {
                    return ut(T(t), t);
                }), P.f = ft, S.f = ct, k.f = lt, O.f = dt, w.f = x.f = pt, E.f = ht, j.f = function(t) {
                    return ut(N(t), t);
                }, u && (C(J, "description", {
                    configurable: !0,
                    get: function() {
                        return G(this).description;
                    }
                }), s || I(V, "propertyIsEnumerable", ft, {
                    unsafe: !0
                }))), o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: z
                }), F(b(rt), function(t) {
                    R(t);
                }), o({
                    target: U,
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        it = !0;
                    },
                    useSimple: function() {
                        it = !1;
                    }
                }), o({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !u
                }, {
                    create: function(t, e) {
                        return void 0 === e ? m(t) : lt(m(t), e);
                    },
                    defineProperty: ct,
                    defineProperties: lt,
                    getOwnPropertyDescriptor: dt
                }), o({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: pt
                }), L(), B(z, U), D[_] = !0;
            },
            6801: function(t, e, n) {
                var o = n(3724), r = n(8686), i = n(4913), a = n(8551), s = n(5397), u = n(1072);
                e.f = o && !r ? Object.defineProperties : function(t, e) {
                    a(t);
                    for(var n, o = s(e), r = u(e), c = r.length, l = 0; c > l;)i.f(t, n = r[l++], o[n]);
                    return t;
                };
            },
            6823: function(t) {
                var e = String;
                t.exports = function(t) {
                    try {
                        return e(t);
                    } catch (t) {
                        return "Object";
                    }
                };
            },
            6837: function(t) {
                var e = TypeError;
                t.exports = function(t) {
                    if (t > 9007199254740991) throw e("Maximum allowed index exceeded");
                    return t;
                };
            },
            6840: function(t, e, n) {
                var o = n(4901), r = n(4913), i = n(283), a = n(9433);
                t.exports = function(t, e, n, s) {
                    s || (s = {});
                    var u = s.enumerable, c = void 0 !== s.name ? s.name : e;
                    if (o(n) && i(n, c, s), s.global) u ? t[e] = n : a(e, n);
                    else {
                        try {
                            s.unsafe ? t[e] && (u = !0) : delete t[e];
                        } catch (t) {}
                        u ? t[e] = n : r.f(t, e, {
                            value: n,
                            enumerable: !1,
                            configurable: !s.nonConfigurable,
                            writable: !s.nonWritable
                        });
                    }
                    return t;
                };
            },
            6910: function(t, e, n) {
                var o = n(6518), r = n(9504), i = n(9306), a = n(8981), s = n(6198), u = n(4606), c = n(655), l = n(9039), f = n(4488), d = n(4598), p = n(3709), h = n(3763), v = n(9519), y = n(3607), g = [], m = r(g.sort), b = r(g.push), w = l(function() {
                    g.sort(void 0);
                }), x = l(function() {
                    g.sort(null);
                }), E = d("sort"), O = !l(function() {
                    if (v) return v < 70;
                    if (!(p && p > 3)) {
                        if (h) return !0;
                        if (y) return y < 603;
                        var t, e, n, o, r = "";
                        for(t = 65; t < 76; t++){
                            switch(e = String.fromCharCode(t), t){
                                case 66:
                                case 69:
                                case 70:
                                case 72:
                                    n = 3;
                                    break;
                                case 68:
                                case 71:
                                    n = 4;
                                    break;
                                default:
                                    n = 2;
                            }
                            for(o = 0; o < 47; o++)g.push({
                                k: e + o,
                                v: n
                            });
                        }
                        for(g.sort(function(t, e) {
                            return e.v - t.v;
                        }), o = 0; o < g.length; o++)e = g[o].k.charAt(0), r.charAt(r.length - 1) !== e && (r += e);
                        return "DGBEFHACIJK" !== r;
                    }
                });
                o({
                    target: "Array",
                    proto: !0,
                    forced: w || !x || !E || !O
                }, {
                    sort: function(t) {
                        void 0 !== t && i(t);
                        var e = a(this);
                        if (O) return void 0 === t ? m(e) : m(e, t);
                        var n, o, r = [], l = s(e);
                        for(o = 0; o < l; o++)o in e && b(r, e[o]);
                        for(f(r, function(t) {
                            return function(e, n) {
                                return void 0 === n ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, n) || 0 : c(e) > c(n) ? 1 : -1;
                            };
                        }(t)), n = s(r), o = 0; o < n;)e[o] = r[o++];
                        for(; o < l;)u(e, o++);
                        return e;
                    }
                });
            },
            6955: function(t, e, n) {
                var o = n(2140), r = n(4901), i = n(2195), a = n(8227)("toStringTag"), s = Object, u = "Arguments" === i(function() {
                    return arguments;
                }());
                t.exports = o ? i : function(t) {
                    var e, n, o;
                    return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                        try {
                            return t[e];
                        } catch (t) {}
                    }(e = s(t), a)) ? n : u ? i(e) : "Object" === (o = i(e)) && r(e.callee) ? "Arguments" : o;
                };
            },
            6969: function(t, e, n) {
                var o = n(2777), r = n(757);
                t.exports = function(t) {
                    var e = o(t, "string");
                    return r(e) ? e : e + "";
                };
            },
            6980: function(t) {
                t.exports = function(t, e) {
                    return {
                        enumerable: !(1 & t),
                        configurable: !(2 & t),
                        writable: !(4 & t),
                        value: e
                    };
                };
            },
            7040: function(t, e, n) {
                var o = n(4495);
                t.exports = o && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            7055: function(t, e, n) {
                var o = n(9504), r = n(9039), i = n(2195), a = Object, s = o("".split);
                t.exports = r(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(t) {
                    return "String" === i(t) ? s(t, "") : a(t);
                } : a;
            },
            7323: function(t, e, n) {
                var o, r, i = n(9565), a = n(9504), s = n(655), u = n(7979), c = n(8429), l = n(5745), f = n(2360), d = n(1181).get, p = n(3635), h = n(8814), v = l("native-string-replace", String.prototype.replace), y = RegExp.prototype.exec, g = y, m = a("".charAt), b = a("".indexOf), w = a("".replace), x = a("".slice), E = (r = /b*/g, i(y, o = /a/, "a"), i(y, r, "a"), 0 !== o.lastIndex || 0 !== r.lastIndex), O = c.BROKEN_CARET, S = void 0 !== /()??/.exec("")[1];
                (E || S || O || p || h) && (g = function(t) {
                    var e, n, o, r, a, c, l, p = this, h = d(p), k = s(t), P = h.raw;
                    if (P) return P.lastIndex = p.lastIndex, e = i(g, P, k), p.lastIndex = P.lastIndex, e;
                    var I = h.groups, C = O && p.sticky, A = i(u, p), M = p.source, D = 0, T = k;
                    if (C && (A = w(A, "y", ""), -1 === b(A, "g") && (A += "g"), T = x(k, p.lastIndex), p.lastIndex > 0 && (!p.multiline || p.multiline && "\n" !== m(k, p.lastIndex - 1)) && (M = "(?: " + M + ")", T = " " + T, D++), n = new RegExp("^(?:" + M + ")", A)), S && (n = new RegExp("^" + M + "$(?!\\s)", A)), E && (o = p.lastIndex), r = i(y, C ? n : p, T), C ? r ? (r.input = x(r.input, D), r[0] = x(r[0], D), r.index = p.lastIndex, p.lastIndex += r[0].length) : p.lastIndex = 0 : E && r && (p.lastIndex = p.global ? r.index + r[0].length : o), S && r && r.length > 1 && i(v, r[0], n, function() {
                        for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (r[a] = void 0);
                    }), r && I) for(r.groups = c = f(null), a = 0; a < I.length; a++)c[(l = I[a])[0]] = r[l[1]];
                    return r;
                }), t.exports = g;
            },
            7347: function(t, e, n) {
                var o = n(3724), r = n(9565), i = n(8773), a = n(6980), s = n(5397), u = n(6969), c = n(9297), l = n(5917), f = Object.getOwnPropertyDescriptor;
                e.f = o ? f : function(t, e) {
                    if (t = s(t), e = u(e), l) try {
                        return f(t, e);
                    } catch (t) {}
                    if (c(t, e)) return a(!r(i.f, t, e), t[e]);
                };
            },
            7400: function(t) {
                t.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            7427: function(t, e, n) {
                var o = n(6518), r = n(3724), i = n(2551), a = n(9306), s = n(8981), u = n(4913);
                r && o({
                    target: "Object",
                    proto: !0,
                    forced: i
                }, {
                    __defineGetter__: function(t, e) {
                        u.f(s(this), t, {
                            get: a(e),
                            enumerable: !0,
                            configurable: !0
                        });
                    }
                });
            },
            7433: function(t, e, n) {
                var o = n(4376), r = n(3517), i = n(34), a = n(8227)("species"), s = Array;
                t.exports = function(t) {
                    var e;
                    return o(t) && (e = t.constructor, (r(e) && (e === s || o(e.prototype)) || i(e) && null === (e = e[a])) && (e = void 0)), void 0 === e ? s : e;
                };
            },
            7452: function(t) {
                t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            },
            7476: function(t, e, n) {
                var o = n(2195), r = n(9504);
                t.exports = function(t) {
                    if ("Function" === o(t)) return r(t);
                };
            },
            7495: function(t, e, n) {
                var o = n(6518), r = n(7323);
                o({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== r
                }, {
                    exec: r
                });
            },
            7629: function(t, e, n) {
                var o = n(6395), r = n(4576), i = n(9433), a = "__core-js_shared__", s = t.exports = r[a] || i(a, {});
                (s.versions || (s.versions = [])).push({
                    version: "3.47.0",
                    mode: o ? "pure" : "global",
                    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
                    license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            7633: function(t, e, n) {
                var o = n(7751), r = n(2106), i = n(8227), a = n(3724), s = i("species");
                t.exports = function(t) {
                    var e = o(t);
                    a && e && !e[s] && r(e, s, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            7657: function(t, e, n) {
                var o, r, i, a = n(9039), s = n(4901), u = n(34), c = n(2360), l = n(2787), f = n(6840), d = n(8227), p = n(6395), h = d("iterator"), v = !1;
                [].keys && ("next" in (i = [].keys()) ? (r = l(l(i))) !== Object.prototype && (o = r) : v = !0), !u(o) || a(function() {
                    var t = {};
                    return o[h].call(t) !== t;
                }) ? o = {} : p && (o = c(o)), s(o[h]) || f(o, h, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: o,
                    BUGGY_SAFARI_ITERATORS: v
                };
            },
            7680: function(t, e, n) {
                var o = n(9504);
                t.exports = o([].slice);
            },
            7740: function(t, e, n) {
                var o = n(9297), r = n(5031), i = n(7347), a = n(4913);
                t.exports = function(t, e, n) {
                    for(var s = r(e), u = a.f, c = i.f, l = 0; l < s.length; l++){
                        var f = s[l];
                        o(t, f) || n && o(n, f) || u(t, f, c(e, f));
                    }
                };
            },
            7750: function(t, e, n) {
                var o = n(4117), r = TypeError;
                t.exports = function(t) {
                    if (o(t)) throw new r("Can't call method on " + t);
                    return t;
                };
            },
            7751: function(t, e, n) {
                var o = n(4576), r = n(4901);
                t.exports = function(t, e) {
                    var n;
                    return arguments.length < 2 ? (n = o[t], r(n) ? n : void 0) : o[t] && o[t][e];
                };
            },
            7764: function(t, e, n) {
                var o = n(8183).charAt, r = n(655), i = n(1181), a = n(1088), s = n(2529), u = "String Iterator", c = i.set, l = i.getterFor(u);
                a(String, "String", function(t) {
                    c(this, {
                        type: u,
                        string: r(t),
                        index: 0
                    });
                }, function() {
                    var t, e = l(this), n = e.string, r = e.index;
                    return r >= n.length ? s(void 0, !0) : (t = o(n, r), e.index += t.length, s(t, !1));
                });
            },
            7812: function(t, e, n) {
                var o = n(6518), r = n(9297), i = n(757), a = n(6823), s = n(5745), u = n(1296), c = s("symbol-to-string-registry");
                o({
                    target: "Symbol",
                    stat: !0,
                    forced: !u
                }, {
                    keyFor: function(t) {
                        if (!i(t)) throw new TypeError(a(t) + " is not a symbol");
                        if (r(c, t)) return c[t];
                    }
                });
            },
            7819: function(t, e, n) {
                var o = n(9039);
                t.exports = !o(function() {
                    var t = "9007199254740993", e = JSON.rawJSON(t);
                    return !JSON.isRawJSON(e) || JSON.stringify(e) !== t;
                });
            },
            7829: function(t, e, n) {
                var o = n(8183).charAt;
                t.exports = function(t, e, n) {
                    return e + (n ? o(t, e).length : 1);
                };
            },
            7916: function(t, e, n) {
                var o = n(6080), r = n(9565), i = n(8981), a = n(6319), s = n(4209), u = n(3517), c = n(6198), l = n(4659), f = n(81), d = n(851), p = Array;
                t.exports = function(t) {
                    var e = i(t), n = u(this), h = arguments.length, v = h > 1 ? arguments[1] : void 0, y = void 0 !== v;
                    y && (v = o(v, h > 2 ? arguments[2] : void 0));
                    var g, m, b, w, x, E, O = d(e), S = 0;
                    if (!O || this === p && s(O)) for(g = c(e), m = n ? new this(g) : p(g); g > S; S++)E = y ? v(e[S], S) : e[S], l(m, S, E);
                    else for(m = n ? new this : [], x = (w = f(e, O)).next; !(b = r(x, w)).done; S++)E = y ? a(w, v, [
                        b.value,
                        S
                    ], !0) : b.value, l(m, S, E);
                    return m.length = S, m;
                };
            },
            7979: function(t, e, n) {
                var o = n(8551);
                t.exports = function() {
                    var t = o(this), e = "";
                    return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
                };
            },
            8014: function(t, e, n) {
                var o = n(1291), r = Math.min;
                t.exports = function(t) {
                    var e = o(t);
                    return e > 0 ? r(e, 9007199254740991) : 0;
                };
            },
            8183: function(t, e, n) {
                var o = n(9504), r = n(1291), i = n(655), a = n(7750), s = o("".charAt), u = o("".charCodeAt), c = o("".slice), l = function(t) {
                    return function(e, n) {
                        var o, l, f = i(a(e)), d = r(n), p = f.length;
                        return d < 0 || d >= p ? t ? "" : void 0 : (o = u(f, d)) < 55296 || o > 56319 || d + 1 === p || (l = u(f, d + 1)) < 56320 || l > 57343 ? t ? s(f, d) : o : t ? c(f, d, d + 2) : l - 56320 + (o - 55296 << 10) + 65536;
                    };
                };
                t.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            8227: function(t, e, n) {
                var o = n(4576), r = n(5745), i = n(9297), a = n(3392), s = n(4495), u = n(7040), c = o.Symbol, l = r("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                t.exports = function(t) {
                    return i(l, t) || (l[t] = s && i(c, t) ? c[t] : f("Symbol." + t)), l[t];
                };
            },
            8235: function(t, e, n) {
                var o = n(9504), r = n(9297), i = SyntaxError, a = parseInt, s = String.fromCharCode, u = o("".charAt), c = o("".slice), l = o(/./.exec), f = {
                    '\\"': '"',
                    "\\\\": "\\",
                    "\\/": "/",
                    "\\b": "\b",
                    "\\f": "\f",
                    "\\n": "\n",
                    "\\r": "\r",
                    "\\t": "\t"
                }, d = /^[\da-f]{4}$/i, p = /^[\u0000-\u001F]$/;
                t.exports = function(t, e) {
                    for(var n = !0, o = ""; e < t.length;){
                        var h = u(t, e);
                        if ("\\" === h) {
                            var v = c(t, e, e + 2);
                            if (r(f, v)) o += f[v], e += 2;
                            else {
                                if ("\\u" !== v) throw new i('Unknown escape sequence: "' + v + '"');
                                var y = c(t, e += 2, e + 4);
                                if (!l(d, y)) throw new i("Bad Unicode escape at: " + e);
                                o += s(a(y, 16)), e += 4;
                            }
                        } else {
                            if ('"' === h) {
                                n = !1, e++;
                                break;
                            }
                            if (l(p, h)) throw new i("Bad control character in string literal at: " + e);
                            o += h, e++;
                        }
                    }
                    if (n) throw new i("Unterminated string at: " + e);
                    return {
                        value: o,
                        end: e
                    };
                };
            },
            8242: function(t, e, n) {
                var o = n(9565), r = n(7751), i = n(8227), a = n(6840);
                t.exports = function() {
                    var t = r("Symbol"), e = t && t.prototype, n = e && e.valueOf, s = i("toPrimitive");
                    e && !e[s] && a(e, s, function(t) {
                        return o(n, this);
                    }, {
                        arity: 1
                    });
                };
            },
            8344: function(t, e, n) {
                n(8543);
            },
            8429: function(t, e, n) {
                var o = n(9039), r = n(4576).RegExp, i = o(function() {
                    var t = r("a", "y");
                    return t.lastIndex = 2, null !== t.exec("abcd");
                }), a = i || o(function() {
                    return !r("a", "y").sticky;
                }), s = i || o(function() {
                    var t = r("^r", "gy");
                    return t.lastIndex = 2, null !== t.exec("str");
                });
                t.exports = {
                    BROKEN_CARET: s,
                    MISSED_STICKY: a,
                    UNSUPPORTED_Y: i
                };
            },
            8480: function(t, e, n) {
                var o = n(1828), r = n(8727).concat("length", "prototype");
                e.f = Object.getOwnPropertyNames || function(t) {
                    return o(t, r);
                };
            },
            8543: function(t, e, n) {
                var o = n(6518), r = n(9565), i = n(7476), a = n(3994), s = n(2529), u = n(7750), c = n(8014), l = n(655), f = n(8551), d = n(34), p = n(2195), h = n(788), v = n(1034), y = n(5966), g = n(6840), m = n(9039), b = n(8227), w = n(2293), x = n(7829), E = n(6682), O = n(1181), S = n(6395), k = b("matchAll"), P = "RegExp String", I = P + " Iterator", C = O.set, A = O.getterFor(I), M = RegExp.prototype, D = TypeError, T = i("".indexOf), N = i("".matchAll), j = !!N && !m(function() {
                    N("a", /./);
                }), R = a(function(t, e, n, o) {
                    C(this, {
                        type: I,
                        regexp: t,
                        string: e,
                        global: n,
                        unicode: o,
                        done: !1
                    });
                }, P, function() {
                    var t = A(this);
                    if (t.done) return s(void 0, !0);
                    var e = t.regexp, n = t.string, o = E(e, n);
                    return null === o ? (t.done = !0, s(void 0, !0)) : t.global ? ("" === l(o[0]) && (e.lastIndex = x(n, c(e.lastIndex), t.unicode)), s(o, !1)) : (t.done = !0, s(o, !1));
                }), L = function(t) {
                    var e, n, o, r = f(this), i = l(t), a = w(r, RegExp), s = l(v(r));
                    return e = new a(a === RegExp ? r.source : r, s), n = !!~T(s, "g"), o = !!~T(s, "u"), e.lastIndex = c(r.lastIndex), new R(e, i, n, o);
                };
                o({
                    target: "String",
                    proto: !0,
                    forced: j
                }, {
                    matchAll: function(t) {
                        var e, n, o, i, a = u(this);
                        if (d(t)) {
                            if (h(t) && (e = l(u(v(t))), !~T(e, "g"))) throw new D("`.matchAll` does not allow non-global regexes");
                            if (j) return N(a, t);
                            if (void 0 === (o = y(t, k)) && S && "RegExp" === p(t) && (o = L), o) return r(o, t, a);
                        } else if (j) return N(a, t);
                        return n = l(a), i = new RegExp(t, "g"), S ? r(L, i, n) : i[k](n);
                    }
                }), S || k in M || g(M, k, L);
            },
            8551: function(t, e, n) {
                var o = n(34), r = String, i = TypeError;
                t.exports = function(t) {
                    if (o(t)) return t;
                    throw new i(r(t) + " is not an object");
                };
            },
            8598: function(t, e, n) {
                var o = n(6518), r = n(9504), i = n(7055), a = n(5397), s = n(4598), u = r([].join);
                o({
                    target: "Array",
                    proto: !0,
                    forced: i !== Object || !s("join", ",")
                }, {
                    join: function(t) {
                        return u(a(this), void 0 === t ? "," : t);
                    }
                });
            },
            8622: function(t, e, n) {
                var o = n(4576), r = n(4901), i = o.WeakMap;
                t.exports = r(i) && /native code/.test(String(i));
            },
            8686: function(t, e, n) {
                var o = n(3724), r = n(9039);
                t.exports = o && r(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            8706: function(t, e, n) {
                var o = n(6518), r = n(9039), i = n(4376), a = n(34), s = n(8981), u = n(6198), c = n(6837), l = n(4659), f = n(1469), d = n(597), p = n(8227), h = n(9519), v = p("isConcatSpreadable"), y = h >= 51 || !r(function() {
                    var t = [];
                    return t[v] = !1, t.concat()[0] !== t;
                }), g = function(t) {
                    if (!a(t)) return !1;
                    var e = t[v];
                    return void 0 !== e ? !!e : i(t);
                };
                o({
                    target: "Array",
                    proto: !0,
                    arity: 1,
                    forced: !y || !d("concat")
                }, {
                    concat: function(t) {
                        var e, n, o, r, i, a = s(this), d = f(a, 0), p = 0;
                        for(e = -1, o = arguments.length; e < o; e++)if (g(i = -1 === e ? a : arguments[e])) for(r = u(i), c(p + r), n = 0; n < r; n++, p++)n in i && l(d, p, i[n]);
                        else c(p + 1), l(d, p++, i);
                        return d.length = p, d;
                    }
                });
            },
            8727: function(t) {
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            8745: function(t, e, n) {
                var o = n(616), r = Function.prototype, i = r.apply, a = r.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (o ? a.bind(i) : function() {
                    return a.apply(i, arguments);
                });
            },
            8773: function(t, e) {
                var n = {}.propertyIsEnumerable, o = Object.getOwnPropertyDescriptor, r = o && !n.call({
                    1: 2
                }, 1);
                e.f = r ? function(t) {
                    var e = o(this, t);
                    return !!e && e.enumerable;
                } : n;
            },
            8781: function(t, e, n) {
                var o = n(350).PROPER, r = n(6840), i = n(8551), a = n(655), s = n(9039), u = n(1034), c = "toString", l = RegExp.prototype, f = l[c], d = s(function() {
                    return "/a/b" !== f.call({
                        source: "a",
                        flags: "b"
                    });
                }), p = o && f.name !== c;
                (d || p) && r(l, c, function() {
                    var t = i(this);
                    return "/" + a(t.source) + "/" + a(u(t));
                }, {
                    unsafe: !0
                });
            },
            8814: function(t, e, n) {
                var o = n(9039), r = n(4576).RegExp;
                t.exports = o(function() {
                    var t = r("(?<a>b)", "g");
                    return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c");
                });
            },
            8981: function(t, e, n) {
                var o = n(7750), r = Object;
                t.exports = function(t) {
                    return r(o(t));
                };
            },
            9039: function(t) {
                t.exports = function(t) {
                    try {
                        return !!t();
                    } catch (t) {
                        return !0;
                    }
                };
            },
            9085: function(t, e, n) {
                var o = n(6518), r = n(4213);
                o({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== r
                }, {
                    assign: r
                });
            },
            9167: function(t, e, n) {
                var o = n(4576);
                t.exports = o;
            },
            9213: function(t, e, n) {
                var o = n(6080), r = n(9504), i = n(7055), a = n(8981), s = n(6198), u = n(1469), c = r([].push), l = function(t) {
                    var e = 1 === t, n = 2 === t, r = 3 === t, l = 4 === t, f = 6 === t, d = 7 === t, p = 5 === t || f;
                    return function(h, v, y, g) {
                        for(var m, b, w = a(h), x = i(w), E = s(x), O = o(v, y), S = 0, k = g || u, P = e ? k(h, E) : n || d ? k(h, 0) : void 0; E > S; S++)if ((p || S in x) && (b = O(m = x[S], S, w), t)) {
                            if (e) P[S] = b;
                            else if (b) switch(t){
                                case 3:
                                    return !0;
                                case 5:
                                    return m;
                                case 6:
                                    return S;
                                case 2:
                                    c(P, m);
                            }
                            else switch(t){
                                case 4:
                                    return !1;
                                case 7:
                                    c(P, m);
                            }
                        }
                        return f ? -1 : r || l ? l : P;
                    };
                };
                t.exports = {
                    forEach: l(0),
                    map: l(1),
                    filter: l(2),
                    some: l(3),
                    every: l(4),
                    find: l(5),
                    findIndex: l(6),
                    filterReject: l(7)
                };
            },
            9228: function(t, e, n) {
                n(7495);
                var o = n(9565), r = n(6840), i = n(7323), a = n(9039), s = n(8227), u = n(6699), c = s("species"), l = RegExp.prototype;
                t.exports = function(t, e, n, f) {
                    var d = s(t), p = !a(function() {
                        var e = {};
                        return e[d] = function() {
                            return 7;
                        }, 7 !== ""[t](e);
                    }), h = p && !a(function() {
                        var e = !1, n = /a/;
                        if ("split" === t) {
                            var o = {};
                            o[c] = function() {
                                return n;
                            }, (n = {
                                constructor: o,
                                flags: ""
                            })[d] = /./[d];
                        }
                        return n.exec = function() {
                            return e = !0, null;
                        }, n[d](""), !e;
                    });
                    if (!p || !h || n) {
                        var v = /./[d], y = e(d, ""[t], function(t, e, n, r, a) {
                            var s = e.exec;
                            return s === i || s === l.exec ? p && !a ? {
                                done: !0,
                                value: o(v, e, n, r)
                            } : {
                                done: !0,
                                value: o(t, n, e, r)
                            } : {
                                done: !1
                            };
                        });
                        r(String.prototype, t, y[0]), r(l, d, y[1]);
                    }
                    f && u(l[d], "sham", !0);
                };
            },
            9296: function(t, e, n) {
                var o = n(4055)("span").classList, r = o && o.constructor && o.constructor.prototype;
                t.exports = r === Object.prototype ? void 0 : r;
            },
            9297: function(t, e, n) {
                var o = n(9504), r = n(8981), i = o({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(t, e) {
                    return i(r(t), e);
                };
            },
            9306: function(t, e, n) {
                var o = n(4901), r = n(6823), i = TypeError;
                t.exports = function(t) {
                    if (o(t)) return t;
                    throw new i(r(t) + " is not a function");
                };
            },
            9432: function(t, e, n) {
                var o = n(6518), r = n(8981), i = n(1072);
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(9039)(function() {
                        i(1);
                    })
                }, {
                    keys: function(t) {
                        return i(r(t));
                    }
                });
            },
            9433: function(t, e, n) {
                var o = n(4576), r = Object.defineProperty;
                t.exports = function(t, e) {
                    try {
                        r(o, t, {
                            value: e,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (n) {
                        o[t] = e;
                    }
                    return e;
                };
            },
            9463: function(t, e, n) {
                var o = n(6518), r = n(3724), i = n(4576), a = n(9504), s = n(9297), u = n(4901), c = n(1625), l = n(655), f = n(2106), d = n(7740), p = i.Symbol, h = p && p.prototype;
                if (r && u(p) && (!("description" in h) || void 0 !== p().description)) {
                    var v = {}, y = function() {
                        var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : l(arguments[0]), e = c(h, this) ? new p(t) : void 0 === t ? p() : p(t);
                        return "" === t && (v[e] = !0), e;
                    };
                    d(y, p), y.prototype = h, h.constructor = y;
                    var g = "Symbol(description detection)" === String(p("description detection")), m = a(h.valueOf), b = a(h.toString), w = /^Symbol\((.*)\)[^)]+$/, x = a("".replace), E = a("".slice);
                    f(h, "description", {
                        configurable: !0,
                        get: function() {
                            var t = m(this);
                            if (s(v, t)) return "";
                            var e = b(t), n = g ? E(e, 7, -1) : x(e, w, "$1");
                            return "" === n ? void 0 : n;
                        }
                    }), o({
                        global: !0,
                        constructor: !0,
                        forced: !0
                    }, {
                        Symbol: y
                    });
                }
            },
            9504: function(t, e, n) {
                var o = n(616), r = Function.prototype, i = r.call, a = o && r.bind.bind(i, i);
                t.exports = o ? a : function(t) {
                    return function() {
                        return i.apply(t, arguments);
                    };
                };
            },
            9519: function(t, e, n) {
                var o, r, i = n(4576), a = n(2839), s = i.process, u = i.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                l && (r = (o = l.split("."))[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !r && a && (!(o = a.match(/Edge\/(\d+)/)) || o[1] >= 74) && (o = a.match(/Chrome\/(\d+)/)) && (r = +o[1]), t.exports = r;
            },
            9539: function(t, e, n) {
                var o = n(9565), r = n(8551), i = n(5966);
                t.exports = function(t, e, n) {
                    var a, s;
                    r(t);
                    try {
                        if (!(a = i(t, "return"))) {
                            if ("throw" === e) throw n;
                            return n;
                        }
                        a = o(a, t);
                    } catch (t) {
                        s = !0, a = t;
                    }
                    if ("throw" === e) throw n;
                    if (s) throw a;
                    return r(a), n;
                };
            },
            9565: function(t, e, n) {
                var o = n(616), r = Function.prototype.call;
                t.exports = o ? r.bind(r) : function() {
                    return r.apply(r, arguments);
                };
            },
            9572: function(t, e, n) {
                var o = n(9297), r = n(6840), i = n(3640), a = n(8227)("toPrimitive"), s = Date.prototype;
                o(s, a) || r(s, a, i);
            },
            9617: function(t, e, n) {
                var o = n(5397), r = n(5610), i = n(6198), a = function(t) {
                    return function(e, n, a) {
                        var s = o(e), u = i(s);
                        if (0 === u) return !t && -1;
                        var c, l = r(a, u);
                        if (t && n != n) {
                            for(; u > l;)if ((c = s[l++]) != c) return !0;
                        } else for(; u > l; l++)if ((t || l in s) && s[l] === n) return t || l || 0;
                        return !t && -1;
                    };
                };
                t.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            9773: function(t, e, n) {
                var o = n(6518), r = n(4495), i = n(9039), a = n(3717), s = n(8981);
                o({
                    target: "Object",
                    stat: !0,
                    forced: !r || i(function() {
                        a.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(t) {
                        var e = a.f;
                        return e ? e(s(t)) : [];
                    }
                });
            }
        }, e = {};
        function n(o) {
            var r = e[o];
            if (void 0 !== r) return r.exports;
            var i = e[o] = {
                exports: {}
            };
            return t[o].call(i.exports, i, i.exports, n), i.exports;
        }
        n.d = function(t, e) {
            for(var o in e)n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: e[o]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var o = {};
        n.r(o), n.d(o, {
            SimpleKeyboard: function() {
                return T;
            },
            default: function() {
                return N;
            }
        });
        n(5276), n(8598), n(4782), n(4554), n(2010), n(7427), n(6099), n(7495), n(8781), n(5440), n(744), n(2762);
        "undefined" == typeof Element || "remove" in Element.prototype || (Element.prototype.remove = function() {
            this.parentNode && this.parentNode.removeChild(this);
        }), "undefined" != typeof self && "document" in self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(t) {
            if ("Element" in t) {
                var e = "classList", n = "prototype", o = t.Element[n], r = Object, i = String[n].trim || function() {
                    return this.replace(/^\s+|\s+$/g, "");
                }, a = Array[n].indexOf || function(t) {
                    for(var e = 0, n = this.length; e < n; e++)if (e in this && this[e] === t) return e;
                    return -1;
                }, s = function(t, e) {
                    this.name = t, this.code = DOMException[t], this.message = e;
                }, u = function(t, e) {
                    if ("" === e) throw new s("SYNTAX_ERR", "The token must not be empty.");
                    if (/\s/.test(e)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                    return a.call(t, e);
                }, c = function(t) {
                    for(var e = i.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], o = 0, r = n.length; o < r; o++)this.push(n[o]);
                    this._updateClassName = function() {
                        t.setAttribute("class", this.toString());
                    };
                }, l = c[n] = [], f = function() {
                    return new c(this);
                };
                if (s[n] = Error[n], l.item = function(t) {
                    return this[t] || null;
                }, l.contains = function(t) {
                    return ~u(this, t + "");
                }, l.add = function() {
                    var t, e = arguments, n = 0, o = e.length, r = !1;
                    do ~u(this, t = e[n] + "") || (this.push(t), r = !0);
                    while (++n < o);
                    r && this._updateClassName();
                }, l.remove = function() {
                    var t, e, n = arguments, o = 0, r = n.length, i = !1;
                    do for(e = u(this, t = n[o] + ""); ~e;)this.splice(e, 1), i = !0, e = u(this, t);
                    while (++o < r);
                    i && this._updateClassName();
                }, l.toggle = function(t, e) {
                    var n = this.contains(t), o = n ? !0 !== e && "remove" : !1 !== e && "add";
                    return o && this[o](t), !0 === e || !1 === e ? e : !n;
                }, l.replace = function(t, e) {
                    var n = u(t + "");
                    ~n && (this.splice(n, 1, e), this._updateClassName());
                }, l.toString = function() {
                    return this.join(" ");
                }, r.defineProperty) {
                    var d = {
                        get: f,
                        enumerable: !0,
                        configurable: !0
                    };
                    try {
                        r.defineProperty(o, e, d);
                    } catch (t) {
                        void 0 !== t.number && -2146823252 !== t.number || (d.enumerable = !1, r.defineProperty(o, e, d));
                    }
                } else r[n].__defineGetter__ && o.__defineGetter__(e, f);
            }
        }(self), function() {
            var t = document.createElement("_");
            if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
                var e = function(t) {
                    var e = DOMTokenList.prototype[t];
                    DOMTokenList.prototype[t] = function(t) {
                        var n, o = arguments.length;
                        for(n = 0; n < o; n++)t = arguments[n], e.call(this, t);
                    };
                };
                e("add"), e("remove");
            }
            if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
                var n = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(t, e) {
                    return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
                };
            }
            "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function(t, e) {
                var n = this.toString().split(" "), o = n.indexOf(t + "");
                ~o && (n = n.slice(o), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
            }), t = null;
        }());
        n(2675), n(9463), n(2259), n(5700), n(8706), n(2008), n(3418), n(4423), n(3792), n(2062), n(6910), n(739), n(9572), n(2892), n(9085), n(3851), n(1278), n(9432), n(4864), n(1699), n(7764), n(8344), n(3500), n(2953), n(2712), n(2637), n(1480), n(825), n(1761);
        function r(t) {
            return function(t) {
                if (Array.isArray(t)) return a(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || i(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function i(t, e) {
            if (t) {
                if ("string" == typeof t) return a(t, e);
                var n = ({}).toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
            }
        }
        function a(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
            return o;
        }
        function s(t) {
            return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, s(t);
        }
        function u(t, e) {
            for(var n = 0; n < e.length; n++){
                var o = e[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, l(o.key), o);
            }
        }
        function c(t, e, n) {
            return (e = l(e)) in t ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = n, t;
        }
        function l(t) {
            var e = function(t, e) {
                if ("object" != s(t) || !t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var o = n.call(t, e || "default");
                    if ("object" != s(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == s(e) ? e : e + "";
        }
        var f = function() {
            var t, e, n;
            return t = function t(e) {
                var n = e.getOptions, o = e.getCaretPosition, r = e.getCaretPositionEnd, i = e.dispatch;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), c(this, "getOptions", void 0), c(this, "getCaretPosition", void 0), c(this, "getCaretPositionEnd", void 0), c(this, "dispatch", void 0), c(this, "maxLengthReached", void 0), c(this, "isStandardButton", function(t) {
                    return t && !("{" === t[0] && "}" === t[t.length - 1]);
                }), this.getOptions = n, this.getCaretPosition = o, this.getCaretPositionEnd = r, this.dispatch = i, t.bindMethods(t, this);
            }, e = [
                {
                    key: "getButtonType",
                    value: function(t) {
                        return t.includes("{") && t.includes("}") && "{//}" !== t ? "functionBtn" : "standardBtn";
                    }
                },
                {
                    key: "getButtonClass",
                    value: function(t) {
                        var e = this.getButtonType(t), n = t.replace("{", "").replace("}", ""), o = "";
                        return "standardBtn" !== e && (o = " hg-button-".concat(n)), "hg-".concat(e).concat(o);
                    }
                },
                {
                    key: "getDefaultDiplay",
                    value: function() {
                        return {
                            "{bksp}": "backspace",
                            "{backspace}": "backspace",
                            "{enter}": "< enter",
                            "{shift}": "shift",
                            "{shiftleft}": "shift",
                            "{shiftright}": "shift",
                            "{alt}": "alt",
                            "{s}": "shift",
                            "{tab}": "tab",
                            "{lock}": "caps",
                            "{capslock}": "caps",
                            "{accept}": "Submit",
                            "{space}": " ",
                            "{//}": " ",
                            "{esc}": "esc",
                            "{escape}": "esc",
                            "{f1}": "f1",
                            "{f2}": "f2",
                            "{f3}": "f3",
                            "{f4}": "f4",
                            "{f5}": "f5",
                            "{f6}": "f6",
                            "{f7}": "f7",
                            "{f8}": "f8",
                            "{f9}": "f9",
                            "{f10}": "f10",
                            "{f11}": "f11",
                            "{f12}": "f12",
                            "{numpaddivide}": "/",
                            "{numlock}": "lock",
                            "{arrowup}": "\u2191",
                            "{arrowleft}": "\u2190",
                            "{arrowdown}": "\u2193",
                            "{arrowright}": "\u2192",
                            "{prtscr}": "print",
                            "{scrolllock}": "scroll",
                            "{pause}": "pause",
                            "{insert}": "ins",
                            "{home}": "home",
                            "{pageup}": "up",
                            "{delete}": "del",
                            "{forwarddelete}": "del",
                            "{end}": "end",
                            "{pagedown}": "down",
                            "{numpadmultiply}": "*",
                            "{numpadsubtract}": "-",
                            "{numpadadd}": "+",
                            "{numpadenter}": "enter",
                            "{period}": ".",
                            "{numpaddecimal}": ".",
                            "{numpad0}": "0",
                            "{numpad1}": "1",
                            "{numpad2}": "2",
                            "{numpad3}": "3",
                            "{numpad4}": "4",
                            "{numpad5}": "5",
                            "{numpad6}": "6",
                            "{numpad7}": "7",
                            "{numpad8}": "8",
                            "{numpad9}": "9"
                        };
                    }
                },
                {
                    key: "getButtonDisplayName",
                    value: function(t, e) {
                        return (e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? Object.assign({}, this.getDefaultDiplay(), e) : e || this.getDefaultDiplay())[t] || t;
                    }
                },
                {
                    key: "getUpdatedInput",
                    value: function(t, e, n) {
                        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], i = this.getOptions(), a = [
                            n,
                            o,
                            r
                        ], s = e;
                        return ("{bksp}" === t || "{backspace}" === t) && s.length > 0 ? s = this.removeAt.apply(this, [
                            s
                        ].concat(a)) : ("{delete}" === t || "{forwarddelete}" === t) && s.length > 0 ? s = this.removeForwardsAt.apply(this, [
                            s
                        ].concat(a)) : "{space}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            " "
                        ].concat(a)) : "{tab}" !== t || "boolean" == typeof i.tabCharOnTab && !1 === i.tabCharOnTab ? "{enter}" !== t && "{numpadenter}" !== t || !i.newLineOnEnter ? t.includes("numpad") && Number.isInteger(Number(t[t.length - 2])) ? s = this.addStringAt.apply(this, [
                            s,
                            t[t.length - 2]
                        ].concat(a)) : "{numpaddivide}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            "/"
                        ].concat(a)) : "{numpadmultiply}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            "*"
                        ].concat(a)) : "{numpadsubtract}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            "-"
                        ].concat(a)) : "{numpadadd}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            "+"
                        ].concat(a)) : "{numpaddecimal}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            "."
                        ].concat(a)) : "{" === t || "}" === t ? s = this.addStringAt.apply(this, [
                            s,
                            t
                        ].concat(a)) : t.includes("{") || t.includes("}") || (s = this.addStringAt.apply(this, [
                            s,
                            t
                        ].concat(a))) : s = this.addStringAt.apply(this, [
                            s,
                            "\n"
                        ].concat(a)) : s = this.addStringAt.apply(this, [
                            s,
                            "\t"
                        ].concat(a)), i.debug && console.log("Input will be: " + s), s;
                    }
                },
                {
                    key: "updateCaretPos",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.updateCaretPosAction(t, e);
                        this.dispatch(function(t) {
                            t.setCaretPosition(n);
                        });
                    }
                },
                {
                    key: "updateCaretPosAction",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.getOptions(), o = this.getCaretPosition();
                        return null != o && (e ? o > 0 && (o -= t) : o += t), n.debug && console.log("Caret at:", o), o;
                    }
                },
                {
                    key: "addStringAt",
                    value: function(t, e) {
                        var n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length, i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                        return o || 0 === o ? (n = [
                            t.slice(0, o),
                            e,
                            t.slice(r)
                        ].join(""), this.isMaxLengthReached() || i && this.updateCaretPos(e.length)) : n = t + e, n;
                    }
                },
                {
                    key: "removeAt",
                    value: function(t) {
                        var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        if (0 === n && 0 === o) return t;
                        if (n === o) {
                            var i = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                            n && n >= 0 ? t.substring(n - 2, n).match(i) ? (e = t.substr(0, n - 2) + t.substr(n), r && this.updateCaretPos(2, !0)) : (e = t.substr(0, n - 1) + t.substr(n), r && this.updateCaretPos(1, !0)) : t.slice(-2).match(i) ? (e = t.slice(0, -2), r && this.updateCaretPos(2, !0)) : (e = t.slice(0, -1), r && this.updateCaretPos(1, !0));
                        } else e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                            t.setCaretPosition(n);
                        });
                        return e;
                    }
                },
                {
                    key: "removeForwardsAt",
                    value: function(t) {
                        var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        return null != t && t.length && null !== n ? (n === o ? e = t.substring(n, n + 2).match(/([\uD800-\uDBFF][\uDC00-\uDFFF])/g) ? t.substr(0, n) + t.substr(n + 2) : t.substr(0, n) + t.substr(n + 1) : (e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                            t.setCaretPosition(n);
                        })), e) : t;
                    }
                },
                {
                    key: "handleMaxLength",
                    value: function(t, e) {
                        var n = this.getOptions(), o = n.maxLength, r = t[n.inputName || "default"], i = e.length - 1 >= o;
                        if (e.length <= r.length) return !1;
                        if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", i), i ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                        if ("object" === s(o)) {
                            var a = e.length - 1 >= o[n.inputName || "default"];
                            return n.debug && console.log("maxLength (obj) reached:", a), a ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                        }
                    }
                },
                {
                    key: "isMaxLengthReached",
                    value: function() {
                        return Boolean(this.maxLengthReached);
                    }
                },
                {
                    key: "isTouchDevice",
                    value: function() {
                        return "ontouchstart" in window || navigator.maxTouchPoints;
                    }
                },
                {
                    key: "pointerEventsSupported",
                    value: function() {
                        return !!window.PointerEvent;
                    }
                },
                {
                    key: "camelCase",
                    value: function(t) {
                        return t ? t.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function(t, e) {
                            return e.length ? t + e[0].toUpperCase() + e.slice(1) : t;
                        }) : "";
                    }
                },
                {
                    key: "chunkArray",
                    value: function(t, e) {
                        return r(Array(Math.ceil(t.length / e))).map(function(n, o) {
                            return t.slice(e * o, e + e * o);
                        });
                    }
                },
                {
                    key: "escapeRegex",
                    value: function(t) {
                        return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                    }
                },
                {
                    key: "getRtlOffset",
                    value: function(t, e) {
                        var n = t, o = e.indexOf("\u202B");
                        return o < t && -1 != o && n--, e.indexOf("\u202C") < t && -1 != o && n--, n < 0 ? 0 : n;
                    }
                },
                {
                    key: "isConstructor",
                    value: function(t) {
                        try {
                            Reflect.construct(String, [], t);
                        } catch (t) {
                            return !1;
                        }
                        return !0;
                    }
                }
            ], n = [
                {
                    key: "bindMethods",
                    value: function(t, e) {
                        var n, o = function(t, e) {
                            var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                            if (!n) {
                                if (Array.isArray(t) || (n = i(t)) || e && t && "number" == typeof t.length) {
                                    n && (t = n);
                                    var o = 0, r = function() {};
                                    return {
                                        s: r,
                                        n: function() {
                                            return o >= t.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: t[o++]
                                            };
                                        },
                                        e: function(t) {
                                            throw t;
                                        },
                                        f: r
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var a, s = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(t);
                                },
                                n: function() {
                                    var t = n.next();
                                    return s = t.done, t;
                                },
                                e: function(t) {
                                    u = !0, a = t;
                                },
                                f: function() {
                                    try {
                                        s || null == n.return || n.return();
                                    } finally{
                                        if (u) throw a;
                                    }
                                }
                            };
                        }(Object.getOwnPropertyNames(t.prototype));
                        try {
                            for(o.s(); !(n = o.n()).done;){
                                var r = n.value;
                                "constructor" === r || "bindMethods" === r || (e[r] = e[r].bind(e));
                            }
                        } catch (t) {
                            o.e(t);
                        } finally{
                            o.f();
                        }
                    }
                }
            ], e && u(t.prototype, e), n && u(t, n), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        c(f, "noop", function() {});
        var d = f;
        function p(t) {
            return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, p(t);
        }
        function h(t, e) {
            for(var n = 0; n < e.length; n++){
                var o = e[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, y(o.key), o);
            }
        }
        function v(t, e, n) {
            return (e = y(e)) in t ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = n, t;
        }
        function y(t) {
            var e = function(t, e) {
                if ("object" != p(t) || !t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var o = n.call(t, e || "default");
                    if ("object" != p(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == p(e) ? e : e + "";
        }
        var g = function() {
            var t, e, n;
            return t = function t(e) {
                var n = this, o = e.dispatch, r = e.getOptions;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), v(this, "getOptions", void 0), v(this, "dispatch", void 0), v(this, "isModifierKey", function(t) {
                    return t.altKey || t.ctrlKey || t.shiftKey || [
                        "Tab",
                        "CapsLock",
                        "Esc",
                        "ArrowUp",
                        "ArrowDown",
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.code || t.key || n.keyCodeToKey(null == t ? void 0 : t.keyCode));
                }), this.dispatch = o, this.getOptions = r, d.bindMethods(t, this);
            }, e = [
                {
                    key: "handleHighlightKeyDown",
                    value: function(t) {
                        var e = this.getOptions();
                        e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                        var n = this.getSimpleKeyboardLayoutKey(t);
                        this.dispatch(function(o) {
                            var r, i, a = o.getButtonElement(n), s = o.getButtonElement("{".concat(n, "}"));
                            if (a) r = a, i = n;
                            else {
                                if (!s) return;
                                r = s, i = "{".concat(n, "}");
                            }
                            var u, c, l, f, d = function(t) {
                                t.style.background = e.physicalKeyboardHighlightBgColor || "#dadce4", t.style.color = e.physicalKeyboardHighlightTextColor || "black";
                            };
                            if (r) {
                                if (Array.isArray(r)) {
                                    if (r.forEach(function(t) {
                                        return d(t);
                                    }), e.physicalKeyboardHighlightPress) {
                                        if (e.physicalKeyboardHighlightPressUsePointerEvents) null === (u = r[0]) || void 0 === u || null === (c = u.onpointerdown) || void 0 === c || c.call(u, t);
                                        else if (e.physicalKeyboardHighlightPressUseClick) {
                                            var p;
                                            null === (p = r[0]) || void 0 === p || p.click();
                                        } else o.handleButtonClicked(i, t);
                                    }
                                } else d(r), e.physicalKeyboardHighlightPress && (e.physicalKeyboardHighlightPressUsePointerEvents ? null === (l = r) || void 0 === l || null === (f = l.onpointerdown) || void 0 === f || f.call(l, t) : e.physicalKeyboardHighlightPressUseClick ? r.click() : o.handleButtonClicked(i, t));
                            }
                        });
                    }
                },
                {
                    key: "handleHighlightKeyUp",
                    value: function(t) {
                        var e = this.getOptions();
                        e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                        var n = this.getSimpleKeyboardLayoutKey(t);
                        this.dispatch(function(o) {
                            var r, i, a, s = o.getButtonElement(n) || o.getButtonElement("{".concat(n, "}")), u = function(t) {
                                t.removeAttribute && t.removeAttribute("style");
                            };
                            s && (Array.isArray(s) ? (s.forEach(function(t) {
                                return u(t);
                            }), e.physicalKeyboardHighlightPressUsePointerEvents && (null === (r = s[0]) || void 0 === r || null === (i = r.onpointerup) || void 0 === i || i.call(r, t))) : (u(s), e.physicalKeyboardHighlightPressUsePointerEvents && (null == s || null === (a = s.onpointerup) || void 0 === a || a.call(s, t))));
                        });
                    }
                },
                {
                    key: "getSimpleKeyboardLayoutKey",
                    value: function(t) {
                        var e, n = "", o = t.code || t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode);
                        return (n = null != o && o.includes("Numpad") || null != o && o.includes("Shift") || null != o && o.includes("Space") || null != o && o.includes("Backspace") || null != o && o.includes("Control") || null != o && o.includes("Alt") || null != o && o.includes("Meta") ? t.code || "" : t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode) || "").length > 1 ? null === (e = n) || void 0 === e ? void 0 : e.toLowerCase() : n;
                    }
                },
                {
                    key: "keyCodeToKey",
                    value: function(t) {
                        return ({
                            8: "Backspace",
                            9: "Tab",
                            13: "Enter",
                            16: "Shift",
                            17: "Ctrl",
                            18: "Alt",
                            19: "Pause",
                            20: "CapsLock",
                            27: "Esc",
                            32: "Space",
                            33: "PageUp",
                            34: "PageDown",
                            35: "End",
                            36: "Home",
                            37: "ArrowLeft",
                            38: "ArrowUp",
                            39: "ArrowRight",
                            40: "ArrowDown",
                            45: "Insert",
                            46: "Delete",
                            48: "0",
                            49: "1",
                            50: "2",
                            51: "3",
                            52: "4",
                            53: "5",
                            54: "6",
                            55: "7",
                            56: "8",
                            57: "9",
                            65: "A",
                            66: "B",
                            67: "C",
                            68: "D",
                            69: "E",
                            70: "F",
                            71: "G",
                            72: "H",
                            73: "I",
                            74: "J",
                            75: "K",
                            76: "L",
                            77: "M",
                            78: "N",
                            79: "O",
                            80: "P",
                            81: "Q",
                            82: "R",
                            83: "S",
                            84: "T",
                            85: "U",
                            86: "V",
                            87: "W",
                            88: "X",
                            89: "Y",
                            90: "Z",
                            91: "Meta",
                            96: "Numpad0",
                            97: "Numpad1",
                            98: "Numpad2",
                            99: "Numpad3",
                            100: "Numpad4",
                            101: "Numpad5",
                            102: "Numpad6",
                            103: "Numpad7",
                            104: "Numpad8",
                            105: "Numpad9",
                            106: "NumpadMultiply",
                            107: "NumpadAdd",
                            109: "NumpadSubtract",
                            110: "NumpadDecimal",
                            111: "NumpadDivide",
                            112: "F1",
                            113: "F2",
                            114: "F3",
                            115: "F4",
                            116: "F5",
                            117: "F6",
                            118: "F7",
                            119: "F8",
                            120: "F9",
                            121: "F10",
                            122: "F11",
                            123: "F12",
                            144: "NumLock",
                            145: "ScrollLock",
                            186: ";",
                            187: "=",
                            188: ",",
                            189: "-",
                            190: ".",
                            191: "/",
                            192: "`",
                            219: "[",
                            220: "\\",
                            221: "]",
                            222: "'"
                        })[t] || "";
                    }
                }
            ], e && h(t.prototype, e), n && h(t, n), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function m(t) {
            return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, m(t);
        }
        function b(t, e) {
            for(var n = 0; n < e.length; n++){
                var o = e[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, x(o.key), o);
            }
        }
        function w(t, e, n) {
            return (e = x(e)) in t ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = n, t;
        }
        function x(t) {
            var e = function(t, e) {
                if ("object" != m(t) || !t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var o = n.call(t, e || "default");
                    if ("object" != m(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == m(e) ? e : e + "";
        }
        var E = function() {
            var t, e, n;
            return t = function t(e) {
                var n = e.utilities, o = e.options;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), w(this, "utilities", void 0), w(this, "options", void 0), w(this, "candidateBoxElement", void 0), w(this, "pageIndex", 0), w(this, "pageSize", void 0), this.utilities = n, this.options = o, d.bindMethods(t, this), this.pageSize = this.utilities.getOptions().layoutCandidatesPageSize || 5;
            }, e = [
                {
                    key: "destroy",
                    value: function() {
                        this.candidateBoxElement && (this.candidateBoxElement.remove(), this.pageIndex = 0);
                    }
                },
                {
                    key: "show",
                    value: function(t) {
                        var e = this, n = t.candidateValue, o = t.targetElement, r = t.onSelect;
                        if (n && n.length) {
                            var i = this.utilities.chunkArray(n.split(" "), this.pageSize);
                            this.renderPage({
                                candidateListPages: i,
                                targetElement: o,
                                pageIndex: this.pageIndex,
                                nbPages: i.length,
                                onItemSelected: function(t, n) {
                                    r(t, n), e.destroy();
                                }
                            });
                        }
                    }
                },
                {
                    key: "renderPage",
                    value: function(t) {
                        var e, n = this, o = t.candidateListPages, r = t.targetElement, i = t.pageIndex, a = t.nbPages, s = t.onItemSelected;
                        null === (e = this.candidateBoxElement) || void 0 === e || e.remove(), this.candidateBoxElement = document.createElement("div"), this.candidateBoxElement.className = "hg-candidate-box";
                        var u = document.createElement("ul");
                        u.className = "hg-candidate-box-list", o[i].forEach(function(t) {
                            var e, o = document.createElement("li"), r = function() {
                                var t = new (n.options.useTouchEvents ? TouchEvent : MouseEvent)("click");
                                return Object.defineProperty(t, "target", {
                                    value: o
                                }), t;
                            };
                            o.className = "hg-candidate-box-list-item", o.innerHTML = (null === (e = n.options.display) || void 0 === e ? void 0 : e[t]) || t, n.options.useTouchEvents ? o.ontouchstart = function(e) {
                                return s(t, e || r());
                            } : o.onclick = function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r();
                                return s(t, e);
                            }, u.appendChild(o);
                        });
                        var c = i > 0, l = document.createElement("div");
                        l.classList.add("hg-candidate-box-prev"), c && l.classList.add("hg-candidate-box-btn-active");
                        var f = function() {
                            c && n.renderPage({
                                candidateListPages: o,
                                targetElement: r,
                                pageIndex: i - 1,
                                nbPages: a,
                                onItemSelected: s
                            });
                        };
                        this.options.useTouchEvents ? l.ontouchstart = f : l.onclick = f, this.candidateBoxElement.appendChild(l), this.candidateBoxElement.appendChild(u);
                        var d = i < a - 1, p = document.createElement("div");
                        p.classList.add("hg-candidate-box-next"), d && p.classList.add("hg-candidate-box-btn-active");
                        var h = function() {
                            d && n.renderPage({
                                candidateListPages: o,
                                targetElement: r,
                                pageIndex: i + 1,
                                nbPages: a,
                                onItemSelected: s
                            });
                        };
                        this.options.useTouchEvents ? p.ontouchstart = h : p.onclick = h, this.candidateBoxElement.appendChild(p), r.prepend(this.candidateBoxElement);
                    }
                }
            ], e && b(t.prototype, e), n && b(t, n), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), O = E;
        function S(t) {
            return function(t) {
                if (Array.isArray(t)) return k(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return k(t, e);
                    var n = ({}).toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? k(t, e) : void 0;
                }
            }(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function k(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
            return o;
        }
        function P(t) {
            return P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, P(t);
        }
        function I(t, e) {
            var n = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(t);
                e && (o = o.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), n.push.apply(n, o);
            }
            return n;
        }
        function C(t, e) {
            for(var n = 0; n < e.length; n++){
                var o = e[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, M(o.key), o);
            }
        }
        function A(t, e, n) {
            return (e = M(e)) in t ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = n, t;
        }
        function M(t) {
            var e = function(t, e) {
                if ("object" != P(t) || !t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var o = n.call(t, e || "default");
                    if ("object" != P(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == P(e) ? e : e + "";
        }
        var D = function() {
            var t, e, n;
            return t = function t(e, n) {
                var o = this;
                if (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), A(this, "input", void 0), A(this, "options", void 0), A(this, "utilities", void 0), A(this, "caretPosition", void 0), A(this, "caretPositionEnd", void 0), A(this, "keyboardDOM", void 0), A(this, "keyboardPluginClasses", void 0), A(this, "keyboardDOMClass", void 0), A(this, "buttonElements", void 0), A(this, "currentInstanceName", void 0), A(this, "allKeyboardInstances", void 0), A(this, "keyboardInstanceNames", void 0), A(this, "isFirstKeyboardInstance", void 0), A(this, "physicalKeyboard", void 0), A(this, "modules", void 0), A(this, "activeButtonClass", void 0), A(this, "holdInteractionTimeout", void 0), A(this, "holdTimeout", void 0), A(this, "isMouseHold", void 0), A(this, "initialized", void 0), A(this, "candidateBox", void 0), A(this, "keyboardRowsDOM", void 0), A(this, "defaultName", "default"), A(this, "activeInputElement", null), A(this, "handleParams", function(t, e) {
                    var n, o, r;
                    if ("string" == typeof t) n = t.split(".").join(""), o = document.querySelector(".".concat(n)), r = e;
                    else if (t instanceof HTMLDivElement) {
                        if (!t.className) throw console.warn("Any DOM element passed as parameter must have a class."), new Error("KEYBOARD_DOM_CLASS_ERROR");
                        n = t.className.split(" ")[0], o = t, r = e;
                    } else n = "simple-keyboard", o = document.querySelector(".".concat(n)), r = t;
                    return {
                        keyboardDOMClass: n,
                        keyboardDOM: o,
                        options: r
                    };
                }), A(this, "getOptions", function() {
                    return o.options;
                }), A(this, "getCaretPosition", function() {
                    return o.caretPosition;
                }), A(this, "getCaretPositionEnd", function() {
                    return o.caretPositionEnd;
                }), A(this, "registerModule", function(t, e) {
                    o.modules[t] || (o.modules[t] = {}), e(o.modules[t]);
                }), A(this, "getKeyboardClassString", function() {
                    for(var t = arguments.length, e = new Array(t), n = 0; n < t; n++)e[n] = arguments[n];
                    return [
                        o.keyboardDOMClass
                    ].concat(e).filter(function(t) {
                        return !!t;
                    }).join(" ");
                }), "undefined" != typeof window) {
                    var r = this.handleParams(e, n), i = r.keyboardDOMClass, a = r.keyboardDOM, s = r.options, u = void 0 === s ? {} : s;
                    this.utilities = new d({
                        getOptions: this.getOptions,
                        getCaretPosition: this.getCaretPosition,
                        getCaretPositionEnd: this.getCaretPositionEnd,
                        dispatch: this.dispatch
                    }), this.caretPosition = null, this.caretPositionEnd = null, this.keyboardDOM = a, this.options = function(t) {
                        for(var e = 1; e < arguments.length; e++){
                            var n = null != arguments[e] ? arguments[e] : {};
                            e % 2 ? I(Object(n), !0).forEach(function(e) {
                                A(t, e, n[e]);
                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function(e) {
                                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                            });
                        }
                        return t;
                    }({
                        layoutName: "default",
                        theme: "hg-theme-default",
                        inputName: "default",
                        preventMouseDownDefault: !1,
                        enableLayoutCandidates: !0,
                        excludeFromLayout: {}
                    }, u), this.keyboardPluginClasses = "", d.bindMethods(t, this);
                    var c = this.options.inputName, l = void 0 === c ? this.defaultName : c;
                    if (this.input = {}, this.input[l] = "", this.keyboardDOMClass = i, this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), window.SimpleKeyboardInstances[this.currentInstanceName] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new g({
                        dispatch: this.dispatch,
                        getOptions: this.getOptions
                    }), this.candidateBox = this.options.enableLayoutCandidates ? new O({
                        utilities: this.utilities,
                        options: this.options
                    }) : null, !this.keyboardDOM) throw console.warn('".'.concat(i, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
                    this.render(), this.modules = {}, this.loadModules();
                }
            }, e = [
                {
                    key: "setCaretPosition",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                        this.caretPosition = t, this.caretPositionEnd = e;
                    }
                },
                {
                    key: "getInputCandidates",
                    value: function(t) {
                        var e = this, n = this.options, o = n.layoutCandidates, r = n.layoutCandidatesCaseSensitiveMatch;
                        if (!o || "object" !== P(o)) return {};
                        var i = Object.keys(o).filter(function(n) {
                            var o = t.substring(0, e.getCaretPositionEnd() || 0) || t, i = new RegExp("".concat(e.utilities.escapeRegex(n), "$"), r ? "g" : "gi");
                            return !!S(o.matchAll(i)).length;
                        });
                        if (i.length > 1) {
                            var a = i.sort(function(t, e) {
                                return e.length - t.length;
                            })[0];
                            return {
                                candidateKey: a,
                                candidateValue: o[a]
                            };
                        }
                        if (i.length) {
                            var s = i[0];
                            return {
                                candidateKey: s,
                                candidateValue: o[s]
                            };
                        }
                        return {};
                    }
                },
                {
                    key: "showCandidatesBox",
                    value: function(t, e, n) {
                        var o = this;
                        this.candidateBox && this.candidateBox.show({
                            candidateValue: e,
                            targetElement: n,
                            onSelect: function(e, n) {
                                var r = o.options, i = r.layoutCandidatesCaseSensitiveMatch, a = r.disableCandidateNormalization, s = r.enableLayoutCandidatesKeyPress, u = e;
                                a || (u = e.normalize("NFD")), "function" == typeof o.options.beforeInputUpdate && o.options.beforeInputUpdate(o);
                                var c = o.getInput(o.options.inputName, !0), l = o.getCaretPositionEnd() || 0, f = c.substring(0, l || 0) || c, d = new RegExp("".concat(o.utilities.escapeRegex(t), "$"), i ? "g" : "gi"), p = f.replace(d, u), h = c.replace(f, p), v = p.length - f.length, y = (l || c.length) + v;
                                y < 0 && (y = 0), o.setInput(h, o.options.inputName, !0), o.setCaretPosition(y), s && "function" == typeof o.options.onKeyPress && o.options.onKeyPress(e, n), "function" == typeof o.options.onChange && o.options.onChange(o.getInput(o.options.inputName, !0), n), "function" == typeof o.options.onChangeAll && o.options.onChangeAll(o.getAllInputs(), n);
                            }
                        });
                    }
                },
                {
                    key: "handleButtonClicked",
                    value: function(t, e) {
                        var n = this.options, o = n.inputName, r = void 0 === o ? this.defaultName : o, i = n.debug;
                        if ("{//}" !== t) {
                            this.input[r] || (this.input[r] = ""), "function" == typeof this.options.beforeInputUpdate && this.options.beforeInputUpdate(this);
                            var a = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd);
                            if (this.utilities.isStandardButton(t) && this.activeInputElement && this.input[r] && this.input[r] === a && 0 === this.caretPosition && this.caretPositionEnd === a.length) return this.setInput("", this.options.inputName, !0), this.setCaretPosition(0), this.activeInputElement.value = "", this.activeInputElement.setSelectionRange(0, 0), void this.handleButtonClicked(t, e);
                            if ("function" == typeof this.options.onKeyPress && this.options.onKeyPress(t, e), this.input[r] !== a && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(a))) {
                                if (this.options.maxLength && this.utilities.handleMaxLength(this.input, a)) return;
                                var s = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd, !0);
                                if (this.setInput(s, this.options.inputName, !0), i && console.log("Input changed:", this.getAllInputs()), this.options.debug && console.log("Caret at: ", this.getCaretPosition(), this.getCaretPositionEnd(), "(".concat(this.keyboardDOMClass, ")"), null == e ? void 0 : e.type), this.options.syncInstanceInputs && this.syncInstanceInputs(), "function" == typeof this.options.onChange && this.options.onChange(this.getInput(this.options.inputName, !0), e), "function" == typeof this.options.onChangeAll && this.options.onChangeAll(this.getAllInputs(), e), null != e && e.target && this.options.enableLayoutCandidates) {
                                    var u, c = this.getInputCandidates(a), l = c.candidateKey, f = c.candidateValue;
                                    l && f ? this.showCandidatesBox(l, f, this.keyboardDOM) : null === (u = this.candidateBox) || void 0 === u || u.destroy();
                                }
                            }
                            this.caretPositionEnd && this.caretPosition !== this.caretPositionEnd && (this.setCaretPosition(this.caretPositionEnd, this.caretPositionEnd), this.activeInputElement && this.activeInputElement.setSelectionRange(this.caretPositionEnd, this.caretPositionEnd), this.options.debug && console.log("Caret position aligned", this.caretPosition)), i && console.log("Key pressed:", t);
                        }
                    }
                },
                {
                    key: "getMouseHold",
                    value: function() {
                        return this.isMouseHold;
                    }
                },
                {
                    key: "setMouseHold",
                    value: function(t) {
                        this.options.syncInstanceInputs ? this.dispatch(function(e) {
                            e.isMouseHold = t;
                        }) : this.isMouseHold = t;
                    }
                },
                {
                    key: "handleButtonMouseDown",
                    value: function(t, e) {
                        var n = this;
                        e && (this.options.preventMouseDownDefault && e.preventDefault(), this.options.stopMouseDownPropagation && e.stopPropagation(), e.target.classList.add(this.activeButtonClass)), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.setMouseHold(!0), this.options.disableButtonHold || (this.holdTimeout = window.setTimeout(function() {
                            (n.getMouseHold() && (!t.includes("{") && !t.includes("}") || "{delete}" === t || "{backspace}" === t || "{bksp}" === t || "{space}" === t || "{tab}" === t) || "{arrowright}" === t || "{arrowleft}" === t || "{arrowup}" === t || "{arrowdown}" === t) && (n.options.debug && console.log("Button held:", t), n.handleButtonHold(t)), clearTimeout(n.holdTimeout);
                        }, 500));
                    }
                },
                {
                    key: "handleButtonMouseUp",
                    value: function(t, e) {
                        var n = this;
                        e && (this.options.preventMouseUpDefault && e.preventDefault && e.preventDefault(), this.options.stopMouseUpPropagation && e.stopPropagation && e.stopPropagation(), !(e.target === this.keyboardDOM || e.target && this.keyboardDOM.contains(e.target) || this.candidateBox && this.candidateBox.candidateBoxElement && (e.target === this.candidateBox.candidateBoxElement || e.target && this.candidateBox.candidateBoxElement.contains(e.target))) && this.candidateBox && this.candidateBox.destroy()), this.recurseButtons(function(t) {
                            t.classList.remove(n.activeButtonClass);
                        }), this.setMouseHold(!1), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), t && "function" == typeof this.options.onKeyReleased && this.options.onKeyReleased(t, e);
                    }
                },
                {
                    key: "handleKeyboardContainerMouseDown",
                    value: function(t) {
                        this.options.preventMouseDownDefault && t.preventDefault();
                    }
                },
                {
                    key: "handleButtonHold",
                    value: function(t) {
                        var e = this;
                        this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = window.setTimeout(function() {
                            e.getMouseHold() ? (e.handleButtonClicked(t), e.handleButtonHold(t)) : clearTimeout(e.holdInteractionTimeout);
                        }, 100);
                    }
                },
                {
                    key: "syncInstanceInputs",
                    value: function() {
                        var t = this;
                        this.dispatch(function(e) {
                            e.replaceInput(t.input), e.setCaretPosition(t.caretPosition, t.caretPositionEnd);
                        });
                    }
                },
                {
                    key: "clearInput",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName;
                        this.input[t] = "", this.setCaretPosition(0), this.options.syncInstanceInputs && this.syncInstanceInputs();
                    }
                },
                {
                    key: "getInput",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName, e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        return this.options.syncInstanceInputs && !e && this.syncInstanceInputs(), this.options.rtl ? "\u202B" + this.input[t].replace("\u202B", "").replace("\u202C", "") + "\u202C" : this.input[t];
                    }
                },
                {
                    key: "getAllInputs",
                    value: function() {
                        var t = this, e = {};
                        return Object.keys(this.input).forEach(function(n) {
                            e[n] = t.getInput(n, !0);
                        }), e;
                    }
                },
                {
                    key: "setInput",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.inputName || this.defaultName, n = arguments.length > 2 ? arguments[2] : void 0;
                        this.input[e] = t, !n && this.options.syncInstanceInputs && this.syncInstanceInputs();
                    }
                },
                {
                    key: "replaceInput",
                    value: function(t) {
                        this.input = t;
                    }
                },
                {
                    key: "setOptions",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = this.changedOptions(t);
                        this.options = Object.assign(this.options, t), e.length && (this.options.debug && console.log("changedOptions", e), this.onSetOptions(e), this.render());
                    }
                },
                {
                    key: "changedOptions",
                    value: function(t) {
                        var e = this;
                        return Object.keys(t).filter(function(n) {
                            return JSON.stringify(t[n]) !== JSON.stringify(e.options[n]);
                        });
                    }
                },
                {
                    key: "onSetOptions",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                        t.includes("layoutName") && this.candidateBox && this.candidateBox.destroy(), (t.includes("layoutCandidatesPageSize") || t.includes("layoutCandidates")) && this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = new O({
                            utilities: this.utilities,
                            options: this.options
                        }));
                    }
                },
                {
                    key: "resetRows",
                    value: function() {
                        this.keyboardRowsDOM && this.keyboardRowsDOM.remove(), this.keyboardDOM.className = this.keyboardDOMClass, this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.buttonElements = {};
                    }
                },
                {
                    key: "dispatch",
                    value: function(t) {
                        if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                        return Object.keys(window.SimpleKeyboardInstances).forEach(function(e) {
                            t(window.SimpleKeyboardInstances[e], e);
                        });
                    }
                },
                {
                    key: "addButtonTheme",
                    value: function(t, e) {
                        var n = this;
                        e && t && (t.split(" ").forEach(function(o) {
                            e.split(" ").forEach(function(e) {
                                n.options.buttonTheme || (n.options.buttonTheme = []);
                                var r = !1;
                                n.options.buttonTheme.map(function(t) {
                                    if (null != t && t.class.split(" ").includes(e)) {
                                        r = !0;
                                        var n = t.buttons.split(" ");
                                        n.includes(o) || (r = !0, n.push(o), t.buttons = n.join(" "));
                                    }
                                    return t;
                                }), r || n.options.buttonTheme.push({
                                    class: e,
                                    buttons: t
                                });
                            });
                        }), this.render());
                    }
                },
                {
                    key: "removeButtonTheme",
                    value: function(t, e) {
                        var n = this;
                        if (!t && !e) return this.options.buttonTheme = [], void this.render();
                        t && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (t.split(" ").forEach(function(t) {
                            var o;
                            null === (o = n.options) || void 0 === o || null === (o = o.buttonTheme) || void 0 === o || o.map(function(o, r) {
                                if (o && e && e.includes(o.class) || !e) {
                                    var i, a, s = null === (i = o) || void 0 === i ? void 0 : i.buttons.split(" ").filter(function(e) {
                                        return e !== t;
                                    });
                                    o && null != s && s.length ? o.buttons = s.join(" ") : (null === (a = n.options.buttonTheme) || void 0 === a || a.splice(r, 1), o = null);
                                }
                                return o;
                            });
                        }), this.render());
                    }
                },
                {
                    key: "getButtonElement",
                    value: function(t) {
                        var e, n = this.buttonElements[t];
                        return n && (e = n.length > 1 ? n : n[0]), e;
                    }
                },
                {
                    key: "inputPatternIsValid",
                    value: function(t) {
                        var e, n = this.options.inputPattern;
                        if ((e = n instanceof RegExp ? n : n[this.options.inputName || this.defaultName]) && t) {
                            var o = e.test(t);
                            return this.options.debug && console.log('inputPattern ("'.concat(e, '"): ').concat(o ? "passed" : "did not pass!")), o;
                        }
                        return !0;
                    }
                },
                {
                    key: "setEventListeners",
                    value: function() {
                        if (this.isFirstKeyboardInstance || !this.allKeyboardInstances) {
                            this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")"));
                            var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                            document.addEventListener("keyup", this.handleKeyUp, e), document.addEventListener("keydown", this.handleKeyDown, e), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd), this.options.updateCaretOnSelectionChange && document.addEventListener("selectionchange", this.handleSelectionChange), document.addEventListener("select", this.handleSelect);
                        }
                    }
                },
                {
                    key: "handleKeyUp",
                    value: function(t) {
                        this.caretEventHandler(t), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(t);
                    }
                },
                {
                    key: "handleKeyDown",
                    value: function(t) {
                        this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(t);
                    }
                },
                {
                    key: "handleMouseUp",
                    value: function(t) {
                        this.caretEventHandler(t);
                    }
                },
                {
                    key: "handleTouchEnd",
                    value: function(t) {
                        this.caretEventHandler(t);
                    }
                },
                {
                    key: "handleSelect",
                    value: function(t) {
                        this.caretEventHandler(t);
                    }
                },
                {
                    key: "handleSelectionChange",
                    value: function(t) {
                        navigator.userAgent.includes("Firefox") || this.caretEventHandler(t);
                    }
                },
                {
                    key: "caretEventHandler",
                    value: function(t) {
                        var e, n = this;
                        t.target.tagName && (e = t.target.tagName.toLowerCase()), this.dispatch(function(o) {
                            var r = t.target === o.keyboardDOM || t.target && o.keyboardDOM.contains(t.target);
                            if (n.options.syncInstanceInputs && Array.isArray(t.path) && (r = t.path.some(function(t) {
                                var e;
                                return null == t || null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-skInstance");
                            })), ("textarea" === e || "input" === e && [
                                "text",
                                "search",
                                "url",
                                "tel",
                                "password"
                            ].includes(t.target.type)) && !o.options.disableCaretPositioning) {
                                var i = t.target.selectionStart, a = t.target.selectionEnd;
                                o.options.rtl && (i = o.utilities.getRtlOffset(i, o.getInput()), a = o.utilities.getRtlOffset(a, o.getInput())), o.setCaretPosition(i, a), o.activeInputElement = t.target, o.options.debug && console.log("Caret at: ", o.getCaretPosition(), o.getCaretPositionEnd(), t && t.target.tagName.toLowerCase(), "(".concat(o.keyboardDOMClass, ")"), null == t ? void 0 : t.type);
                            } else !o.options.disableCaretPositioning && r || "selectionchange" === (null == t ? void 0 : t.type) || (o.setCaretPosition(null), o.activeInputElement = null, o.options.debug && console.log('Caret position reset due to "'.concat(null == t ? void 0 : t.type, '" event'), t));
                        });
                    }
                },
                {
                    key: "recurseButtons",
                    value: function(t) {
                        var e = this;
                        t && Object.keys(this.buttonElements).forEach(function(n) {
                            return e.buttonElements[n].forEach(t);
                        });
                    }
                },
                {
                    key: "destroy",
                    value: function() {
                        this.options.debug && console.log("Destroying simple-keyboard instance: ".concat(this.currentInstanceName));
                        var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                        document.removeEventListener("keyup", this.handleKeyUp, e), document.removeEventListener("keydown", this.handleKeyDown, e), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), document.removeEventListener("select", this.handleSelect), this.options.updateCaretOnSelectionChange && document.removeEventListener("selectionchange", this.handleSelectionChange), document.onpointerup = null, document.ontouchend = null, document.ontouchcancel = null, document.onmouseup = null, this.recurseButtons(function(t) {
                            t && (t.onpointerdown = null, t.onpointerup = null, t.onpointercancel = null, t.ontouchstart = null, t.ontouchend = null, t.ontouchcancel = null, t.onclick = null, t.onmousedown = null, t.onmouseup = null, t.remove(), t = null);
                        }), this.keyboardDOM.onpointerdown = null, this.keyboardDOM.ontouchstart = null, this.keyboardDOM.onmousedown = null, this.resetRows(), this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = null), this.activeInputElement = null, this.keyboardDOM.removeAttribute("data-skInstance"), this.keyboardDOM.innerHTML = "", window.SimpleKeyboardInstances[this.currentInstanceName] = null, delete window.SimpleKeyboardInstances[this.currentInstanceName], this.initialized = !1;
                    }
                },
                {
                    key: "getButtonThemeClasses",
                    value: function(t) {
                        var e = this.options.buttonTheme, n = [];
                        return Array.isArray(e) && e.forEach(function(e) {
                            if (e && e.class && "string" == typeof e.class && e.buttons && "string" == typeof e.buttons) {
                                var o = e.class.split(" ");
                                e.buttons.split(" ").includes(t) && (n = [].concat(S(n), S(o)));
                            } else console.warn('Incorrect "buttonTheme". Please check the documentation.', e);
                        }), n;
                    }
                },
                {
                    key: "setDOMButtonAttributes",
                    value: function(t, e) {
                        var n = this.options.buttonAttributes;
                        Array.isArray(n) && n.forEach(function(n) {
                            n.attribute && "string" == typeof n.attribute && n.value && "string" == typeof n.value ? n.buttons && "string" == typeof n.buttons ? n.buttons.split(" ").includes(t) && e(n.attribute, n.value) : e(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                        });
                    }
                },
                {
                    key: "onTouchDeviceDetected",
                    value: function() {
                        this.processAutoTouchEvents(), this.disableContextualWindow();
                    }
                },
                {
                    key: "disableContextualWindow",
                    value: function() {
                        window.oncontextmenu = function(t) {
                            var e;
                            if (null !== (e = t.target.classList) && void 0 !== e && e.contains("hg-button")) return t.preventDefault(), t.stopPropagation(), !1;
                        };
                    }
                },
                {
                    key: "processAutoTouchEvents",
                    value: function() {
                        this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
                    }
                },
                {
                    key: "onInit",
                    value: function() {
                        this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" == typeof this.options.onInit && this.options.onInit(this);
                    }
                },
                {
                    key: "beforeFirstRender",
                    value: function() {
                        this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" == typeof this.options.beforeFirstRender && this.options.beforeFirstRender(this), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
                    }
                },
                {
                    key: "beforeRender",
                    value: function() {
                        "function" == typeof this.options.beforeRender && this.options.beforeRender(this);
                    }
                },
                {
                    key: "onRender",
                    value: function() {
                        "function" == typeof this.options.onRender && this.options.onRender(this);
                    }
                },
                {
                    key: "onModulesLoaded",
                    value: function() {
                        "function" == typeof this.options.onModulesLoaded && this.options.onModulesLoaded(this);
                    }
                },
                {
                    key: "loadModules",
                    value: function() {
                        var t = this;
                        Array.isArray(this.options.modules) && (this.options.modules.forEach(function(e) {
                            var n = t.utilities.isConstructor(e) ? new e(t) : e(t);
                            n.init && n.init(t);
                        }), this.keyboardPluginClasses = "modules-loaded", this.render(), this.onModulesLoaded());
                    }
                },
                {
                    key: "getModuleProp",
                    value: function(t, e) {
                        return !!this.modules[t] && this.modules[t][e];
                    }
                },
                {
                    key: "getModulesList",
                    value: function() {
                        return Object.keys(this.modules);
                    }
                },
                {
                    key: "parseRowDOMContainers",
                    value: function(t, e, n, o) {
                        var r = this, i = Array.from(t.children), a = 0;
                        return i.length && n.forEach(function(n, s) {
                            var u = o[s];
                            if (!(u && u > n)) return !1;
                            var c = n - a, l = u - a, f = document.createElement("div");
                            f.className += "hg-button-container";
                            var d = "".concat(r.options.layoutName, "-r").concat(e, "c").concat(s);
                            f.setAttribute("data-skUID", d);
                            var p = i.splice(c, l - c + 1);
                            a += l - c, p.forEach(function(t) {
                                return f.appendChild(t);
                            }), i.splice(c, 0, f), t.innerHTML = "", i.forEach(function(e) {
                                return t.appendChild(e);
                            }), r.options.debug && console.log("rowDOMContainer", p, c, l, a + 1);
                        }), t;
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var t = this;
                        this.resetRows(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                        var e = "hg-layout-".concat(this.options.layoutName), n = this.options.layout || {
                            default: [
                                "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                                "{tab} q w e r t y u i o p [ ] \\",
                                "{lock} a s d f g h j k l ; ' {enter}",
                                "{shift} z x c v b n m , . / {shift}",
                                ".com @ {space}"
                            ],
                            shift: [
                                "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                                "{tab} Q W E R T Y U I O P { } |",
                                '{lock} A S D F G H J K L : " {enter}',
                                "{shift} Z X C V B N M < > ? {shift}",
                                ".com @ {space}"
                            ]
                        }, o = this.options.useTouchEvents || !1, r = o ? "hg-touch-events" : "", i = this.options.useMouseEvents || !1, a = this.options.disableRowButtonContainers;
                        this.keyboardDOM.className = this.getKeyboardClassString(this.options.theme, e, this.keyboardPluginClasses, r), this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.keyboardRowsDOM = document.createElement("div"), this.keyboardRowsDOM.className = "hg-rows", n[this.options.layoutName || this.defaultName].forEach(function(e, n) {
                            var r = e.split(" ");
                            t.options.excludeFromLayout && t.options.excludeFromLayout[t.options.layoutName || t.defaultName] && (r = r.filter(function(e) {
                                return t.options.excludeFromLayout && !t.options.excludeFromLayout[t.options.layoutName || t.defaultName].includes(e);
                            }));
                            var s = document.createElement("div");
                            s.className += "hg-row";
                            var u = [], c = [];
                            r.forEach(function(e, r) {
                                var l, f = !a && "string" == typeof e && e.length > 1 && 0 === e.indexOf("["), d = !a && "string" == typeof e && e.length > 1 && e.indexOf("]") === e.length - 1;
                                f && (u.push(r), e = e.replace(/\[/g, "")), d && (c.push(r), e = e.replace(/\]/g, ""));
                                var p = t.utilities.getButtonClass(e), h = t.utilities.getButtonDisplayName(e, t.options.display, t.options.mergeDisplay), v = t.options.useButtonTag ? "button" : "div", y = document.createElement(v);
                                y.className += "hg-button ".concat(p), (l = y.classList).add.apply(l, S(t.getButtonThemeClasses(e))), t.setDOMButtonAttributes(e, function(t, e) {
                                    y.setAttribute(t, e);
                                }), t.activeButtonClass = "hg-activeButton", !t.utilities.pointerEventsSupported() || o || i ? o ? (y.ontouchstart = function(n) {
                                    t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                }, y.ontouchend = function(n) {
                                    t.handleButtonMouseUp(e, n);
                                }, y.ontouchcancel = function(n) {
                                    t.handleButtonMouseUp(e, n);
                                }) : (y.onclick = function(n) {
                                    t.setMouseHold(!1), "function" == typeof t.options.onKeyReleased || t.options.useMouseEvents && t.options.clickOnMouseDown || t.handleButtonClicked(e, n);
                                }, y.onmousedown = function(n) {
                                    ("function" == typeof t.options.onKeyReleased || t.options.useMouseEvents && t.options.clickOnMouseDown) && !t.isMouseHold && t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                }, y.onmouseup = function(n) {
                                    t.handleButtonMouseUp(e, n);
                                }) : (y.onpointerdown = function(n) {
                                    t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                }, y.onpointerup = function(n) {
                                    t.handleButtonMouseUp(e, n);
                                }, y.onpointercancel = function(n) {
                                    t.handleButtonMouseUp(e, n);
                                }), y.setAttribute("data-skBtn", e);
                                var g = "".concat(t.options.layoutName, "-r").concat(n, "b").concat(r);
                                y.setAttribute("data-skBtnUID", g);
                                var m = document.createElement("span");
                                m.innerHTML = h, y.appendChild(m), t.buttonElements[e] || (t.buttonElements[e] = []), t.buttonElements[e].push(y), s.appendChild(y);
                            }), s = t.parseRowDOMContainers(s, n, u, c), t.keyboardRowsDOM.appendChild(s);
                        }), this.keyboardDOM.appendChild(this.keyboardRowsDOM), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || i ? o ? (document.ontouchend = function(e) {
                            return t.handleButtonMouseUp(void 0, e);
                        }, document.ontouchcancel = function(e) {
                            return t.handleButtonMouseUp(void 0, e);
                        }, this.keyboardDOM.ontouchstart = function(e) {
                            return t.handleKeyboardContainerMouseDown(e);
                        }) : o || (document.onmouseup = function(e) {
                            return t.handleButtonMouseUp(void 0, e);
                        }, this.keyboardDOM.onmousedown = function(e) {
                            return t.handleKeyboardContainerMouseDown(e);
                        }) : (document.onpointerup = function(e) {
                            return t.handleButtonMouseUp(void 0, e);
                        }, this.keyboardDOM.onpointerdown = function(e) {
                            return t.handleKeyboardContainerMouseDown(e);
                        }), this.onInit());
                    }
                }
            ], e && C(t.prototype, e), n && C(t, n), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), T = D, N = T;
        return o;
    }();
});



var $67dc1e3ffb36eb73$export$e163f07d771b24a3 = /*#__PURE__*/ function(KioskComponentEvents) {
    KioskComponentEvents["LOGO_CLICKED"] = "logo_clicked";
    KioskComponentEvents["LOGOS_LOADED"] = "logos_loaded";
    KioskComponentEvents["LANGUAGE_CHANGED"] = "language_changed";
    KioskComponentEvents["MAP_RELOAD"] = "map_reload";
    return KioskComponentEvents;
}({});
class $67dc1e3ffb36eb73$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.sessionDuration = 60;
        this.updateSessionCountdown = this.updateSessionCountdown.bind(this);
        this.getSponsoredLogos().then((response)=>{
            if (response.features && response.features.length > 0) {
                const sponsorsData = response.features;
                this.shuffleSponsorsArray(sponsorsData);
                this.marqueeRows = [
                    [],
                    [],
                    [],
                    []
                ];
                sponsorsData.forEach((img, index)=>{
                    this.marqueeRows[index % 4].push(img);
                });
                this.renderSponsors();
                // Reposition keyboard now that bottom marquees have content
                this.resetKeyboardPosition();
            }
        }).catch((error)=>{
            console.error("Failed to load sponsored logos:", error);
        });
        const $languageSelector = document.getElementById("languageSelector");
        const $logoInstructor = document.getElementById("logo-instruction");
        if ($logoInstructor) $logoInstructor.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.sponsored_logo_selection;
        if ($languageSelector) $languageSelector.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.selectLanguage;
        const $countdownWrapper = document.getElementById('countdownWrapper');
        if ($countdownWrapper) {
            const $linkReset = document.createElement('a');
            $linkReset.id = "lnkReset";
            $linkReset.href = "#";
            $linkReset.innerText = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.resetMap;
            $linkReset.style.visibility = 'hidden';
            $linkReset.style.color = '#e30613';
            $linkReset.addEventListener("click", (event)=>{
                event.preventDefault();
                this.resetMap();
            });
            $countdownWrapper.appendChild($linkReset);
        }
        this.initializeLanguageSelector();
    }
    render() {}
    initCustomKeyboard() {
        this.keyboardInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($9e4e7a640172967b$exports)))({
            onChange: (value)=>{
                if (!this.activeInput) return;
                this.activeInput.value = value;
                // notify third-party widget (autocomplete.js)
                this.activeInput.dispatchEvent(new InputEvent("input", {
                    bubbles: true,
                    inputType: "insertText"
                }));
            },
            onKeyPress: (button)=>{
                if (button === "{search}" && this.activeInput) this.activeInput.dispatchEvent(new KeyboardEvent("keydown", {
                    key: "Enter",
                    bubbles: true
                }));
            },
            layout: {
                default: [
                    "1 2 3 4 5 6 7 8 9 0",
                    "q w e r t y u i o p",
                    "a s d f g h j k l \xe8",
                    "z x c v b n m \xf2 \xe0 {bksp}",
                    "\xec \xf9 \xe9 {space}"
                ]
            },
            layoutName: "default",
            // Kiosk safety
            physicalKeyboardHighlight: false,
            physicalKeyboardHighlightPress: false,
            preventMouseDownDefault: true,
            // No sound, no animation surprises
            enableTouchEvents: true,
            useMouseEvents: false,
            // Do NOT auto-capitalize
            syncInstanceInputs: false,
            // No input masking tricks
            inputPattern: /[a-z0-9àèéìòù ]/i,
            // Do not clear input automatically
            clearInputOnEnter: false,
            // Disable candidate / IME behavior
            disableCaretPositioning: true,
            display: {
                "{bksp}": "\u232B",
                "{space}": (0, $58070e9281bc680d$export$180605366c04f0cd)().keyboard.space
            }
        });
        this.initDragHandle();
        this.initCloseButton();
    }
    initCloseButton() {
        const btn = document.getElementById("keyboard-close");
        if (!btn) return;
        btn.addEventListener("click", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (this.activeInput) this.activeInput.blur();
            this.hideKeyboard();
        });
    }
    initDragHandle() {
        const handle = document.getElementById("keyboard-drag-handle");
        if (!handle) return;
        handle.addEventListener("touchstart", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const overlay = document.getElementById("keyboard-overlay");
            if (!overlay) return;
            this.isDragging = true;
            overlay.classList.add("keyboard-dragging");
            const touch = e.touches[0];
            this.dragStartX = touch.clientX;
            this.dragStartY = touch.clientY;
            const rect = overlay.getBoundingClientRect();
            this.overlayStartX = rect.left;
            this.overlayStartY = rect.top;
            this.boundOnTouchMove = this.onDragMove.bind(this);
            this.boundOnTouchEnd = this.onDragEnd.bind(this);
            document.addEventListener("touchmove", this.boundOnTouchMove, {
                passive: false
            });
            document.addEventListener("touchend", this.boundOnTouchEnd);
        }, {
            passive: false
        });
    }
    onDragMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        // Keyboard is leaving default position
        document.documentElement.style.setProperty('--keyboard-height', '0px');
        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;
        const touch = e.touches[0];
        const deltaX = touch.clientX - this.dragStartX;
        const deltaY = touch.clientY - this.dragStartY;
        const buffer = 100;
        const w = overlay.offsetWidth;
        const handleHeight = 56 + buffer;
        // Keep drag handle visible: top edge clamped at 0 so handle never goes off-screen
        const newX = Math.max(-w + handleHeight, Math.min(this.overlayStartX + deltaX, window.innerWidth - handleHeight));
        const newY = Math.max(0, Math.min(this.overlayStartY + deltaY, window.innerHeight - handleHeight));
        overlay.style.left = `${newX}px`;
        overlay.style.top = `${newY}px`;
        overlay.style.bottom = "auto";
        overlay.style.right = "auto";
    }
    onDragEnd() {
        this.isDragging = false;
        const overlay = document.getElementById("keyboard-overlay");
        overlay?.classList.remove("keyboard-dragging");
        if (this.boundOnTouchMove) document.removeEventListener("touchmove", this.boundOnTouchMove);
        if (this.boundOnTouchEnd) document.removeEventListener("touchend", this.boundOnTouchEnd);
        this.boundOnTouchMove = null;
        this.boundOnTouchEnd = null;
    }
    resetKeyboardPosition() {
        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;
        // Center the keyboard within the #app (map container) area
        const app = document.getElementById("app");
        if (!app) return;
        const appRect = app.getBoundingClientRect();
        const overlayWidth = overlay.offsetWidth;
        const overlayHeight = overlay.offsetHeight;
        const centerLeft = appRect.left + (appRect.width - overlayWidth) / 2;
        const centerTop = appRect.top + (appRect.height - overlayHeight) / 2;
        overlay.style.left = `${centerLeft}px`;
        overlay.style.top = `${centerTop}px`;
        overlay.style.right = "auto";
        overlay.style.bottom = "auto";
        // Keyboard overlaps the map — no need to shrink map height
        document.documentElement.style.setProperty('--keyboard-height', '0px');
    }
    renderSponsors() {
        this.removeExistingMarquees();
        for(let i = 0; i < 4; i++)this.createMarquee(i);
        requestAnimationFrame(()=>{
            this.restartMarqueeAnimation(".marquee");
        });
    }
    createMarquee(rowIndex) {
        const marquee = document.querySelector(`#marquee-container-${rowIndex + 1} .marquee`);
        const marqueeContent = document.createElement('div');
        marqueeContent.classList.add('marquee-content');
        if (marquee) {
            this.marqueeRows[rowIndex].forEach((sponsor)=>{
                const img = document.createElement('img');
                img.src = sponsor.properties.Sponsored_URL;
                img.onerror = ()=>{
                    console.warn(`Skipped broken image: ${sponsor.properties.name}`);
                    img.remove();
                };
                img.dataset.ref = sponsor.properties.ref;
                marqueeContent.appendChild(img);
            });
            marquee.addEventListener('click', (e)=>{
                const target = e.target;
                if (target.tagName === 'IMG' && target.dataset.ref) {
                    this.startSessionCountdown();
                    this.emit("logo_clicked", target.dataset.ref);
                }
            });
            const marqueeClone = marqueeContent.cloneNode(true);
            marquee.appendChild(marqueeContent);
            marquee.appendChild(marqueeClone);
        }
    }
    shuffleSponsorsArray(array) {
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [
                array[j],
                array[i]
            ];
        }
    }
    getSponsoredLogos() {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            const cbSponsoredLogos = (response)=>{
                if (response && response.features && response.features.length > 0) {
                    this.allSponsors = response.features;
                    resolve(response);
                } else // reject(new Error("No sponsors found."));
                resolve([]);
            };
            indoorService.search((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.venue || `sdm_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.env}`, "", cbSponsoredLogos, null, null, `Is_Sponsored:="yes"`);
        });
    }
    initializeLanguageSelector() {
        const languageSelector = document.querySelector(".sl-nav");
        if (languageSelector) {
            const languageOptions = languageSelector.querySelectorAll(".sl-flag");
            languageOptions.forEach((flagElement)=>{
                const parentElement = flagElement.parentElement;
                const elementLang = flagElement.getAttribute("data-lang");
                if (elementLang) {
                    if (elementLang.toLowerCase() === (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()) {
                        const nextSibling = flagElement.nextElementSibling;
                        if (nextSibling) nextSibling.classList.add("active");
                        this.selectLanguage((0, $58070e9281bc680d$export$3814be8b8b1016be)());
                    }
                }
                if (parentElement) // eslint-disable-next-line @typescript-eslint/no-unused-vars
                parentElement.addEventListener("click", (event)=>{
                    const selectedLanguageCode = flagElement.getAttribute("data-lang");
                    window.lang = selectedLanguageCode || (0, $58070e9281bc680d$export$3814be8b8b1016be)();
                    languageOptions.forEach((option)=>{
                        const span = option.parentElement?.querySelector("span");
                        span?.classList.remove("active");
                    });
                    const nextSibling = flagElement.nextElementSibling;
                    if (selectedLanguageCode) this.selectLanguage(selectedLanguageCode);
                    if (nextSibling) nextSibling.classList.add("active");
                });
            });
        }
    }
    selectLanguage(languageCode) {
        const langElement = document.getElementById("selectdLang");
        if (langElement) langElement.innerHTML = `<b>${languageCode.toString().toUpperCase()}</b>`;
        this.emit("language_changed", languageCode);
        const $logoInstructor = document.getElementById("logo-instruction");
        if ($logoInstructor) $logoInstructor.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.sponsored_logo_selection;
    }
    updateSessionCountdown() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        const minutes = Math.floor(this.sessionDuration / 60);
        const seconds = this.sessionDuration % 60;
        if (countdownElement && $lnkReset) {
            countdownElement.innerHTML = `${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.sessionReset} <span style="color: red;font-family: monospace;font-weight:500">${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}</span> ${minutes < 1 ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.seconds : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.minute}`;
            $lnkReset.style.visibility = 'visible';
            this.sessionDuration--;
            if (this.sessionDuration < 0) {
                clearInterval(this.countdownInterval);
                this.sessionDuration = this.TIMEOUT_LIMIT;
                countdownElement.textContent = "";
                this.resetMap();
            }
        }
    }
    startSessionCountdown() {
        this.sessionDuration = this.TIMEOUT_LIMIT;
        this.clearCountdownInterval();
        this.countdownInterval = setInterval(this.updateSessionCountdown, 1000);
    }
    clearCountdownInterval() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = 0;
        }
    }
    resetMap() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        if (countdownElement && $lnkReset) {
            countdownElement.textContent = "";
            $lnkReset.style.visibility = 'hidden';
        }
        this.sendGAEvent();
        this.clearCountdownInterval();
        this.resetKeyboardPosition();
        this.isMapReloaded = !this.isMapReloaded;
        this.emit("map_reload", this.isMapReloaded);
    // location.reload();
    }
    sendGAEvent() {
        const currentTimeMillis = new Date().getTime();
        const currentUnixTimestamp = Math.floor(currentTimeMillis / 1000);
        const queryParam = this.state.query?.split('=');
        const kiosk = queryParam && queryParam?.length > 1 ? queryParam[1] : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "session_rest",
            timestamps: currentUnixTimestamp,
            content_id: kiosk,
            items: undefined,
            search_term: undefined,
            item_name: undefined,
            nav_from: undefined,
            nav_to: undefined,
            content_type: undefined,
            click_location: undefined
        });
    }
    removeExistingMarquees() {
        const marquees = document.querySelectorAll(".marquee-content");
        if (marquees.length > 0) marquees.forEach((el)=>{
            el.remove();
        });
    }
    restartMarqueeAnimation(selector) {
        requestAnimationFrame(()=>{
            const marquees = document.querySelectorAll(selector);
            marquees.forEach((el)=>{
                el.style.animation = "none"; // Stop the animation
                el.offsetWidth; // Force reflow
                el.style.animation = ""; // Restart animation
            });
        });
    }
    disableSystemKeyboard() {
        const observer = new MutationObserver(()=>{
            const inputs = document.querySelectorAll("input, textarea");
            inputs.forEach((input)=>{
                if (!input.dataset.kioskPatched) this.patchInput(input);
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    patchInput(input) {
        input.dataset.kioskPatched = "true";
        // Skip non-text inputs (checkboxes, radios, buttons)
        const textTypes = [
            "text",
            "search",
            "email",
            "url",
            "tel",
            "password",
            ""
        ];
        if (input instanceof HTMLInputElement && !textTypes.includes(input.type)) return;
        input.setAttribute("inputmode", "none");
        // Use touchstart to suppress system keyboard while keeping input focusable.
        // Allow native clear (X) button on search inputs to remain tappable
        // by skipping preventDefault when the touch is on the right edge.
        input.addEventListener("touchstart", (e)=>{
            const te = e;
            if (input.type === "search" && te.touches && te.touches.length > 0) {
                const rect = input.getBoundingClientRect();
                const touchX = te.touches[0].clientX;
                if (touchX > rect.right - 40) return;
            }
            e.preventDefault();
            input.focus();
            this.activateKeyboard(input);
        }, {
            passive: false
        });
        // Fallback for pointer/click events
        input.addEventListener("click", ()=>{
            this.activateKeyboard(input);
        });
        // Handle programmatic focus (e.g. panel opening with input auto-focused)
        input.addEventListener("focus", ()=>{
            this.activateKeyboard(input);
        });
        // If this input already has focus (patched after focus fired), activate now
        if (document.activeElement === input) this.activateKeyboard(input);
        // Hide keyboard when input loses focus
        input.addEventListener("blur", ()=>{
            setTimeout(()=>{
                if (this.activeInput === input && document.activeElement !== input) this.hideKeyboard();
            }, 200);
        });
        // Hide keyboard when native clear (X) button on search inputs is tapped.
        // The native X clears the full value at once, unlike virtual keyboard backspace
        // which removes one character at a time via our onChange handler.
        if (input.type === "search") {
            let prevLength = input.value.length;
            input.addEventListener("input", (e)=>{
                const isVirtualKeyboard = e.inputType === "insertText";
                if (!isVirtualKeyboard && prevLength > 1 && input.value === "") this.hideKeyboard();
                prevLength = input.value.length;
            });
        }
    }
    showKeyboard() {
        const el = document.getElementById("keyboard");
        if (el) el.style.display = "block";
        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;
        requestAnimationFrame(()=>{
            overlay.classList.add("keyboard-visible");
            this.resetKeyboardPosition();
        });
    }
    detachActiveInput() {
        const isItineraryInput = this.activeInput?.closest('.itinerary-build') !== null;
        if (!isItineraryInput) this.keyboardInstance.clearInput();
        this.activeInput = null;
    }
    hideKeyboard() {
        this.detachActiveInput();
        const el = document.getElementById("keyboard");
        if (el) el.style.display = "none";
        const overlay = document.getElementById("keyboard-overlay");
        overlay?.classList.remove("keyboard-visible");
        document.documentElement.style.setProperty('--keyboard-height', '0px');
    }
    activateKeyboard(input) {
        if (this.activeInput === input) return;
        this.activeInput = input;
        this.keyboardInstance.setInput(input.value || "");
        this.showKeyboard();
    }
    applyKeyboardOffset() {
        const keyboard = document.getElementById("keyboard-overlay");
        if (!keyboard) return;
        const keyboardHeight = keyboard.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--keyboard-height', `${keyboardHeight}px`);
    }
    constructor(...args){
        super(...args), this.allSponsors = [], this.marqueeRows = [
            [],
            [],
            [],
            []
        ], this.TIMEOUT_LIMIT = 60, this.isMapReloaded = false, this.activeInput = null, this.isDragging = false, this.dragStartX = 0, this.dragStartY = 0, this.overlayStartX = 0, this.overlayStartY = 0, this.boundOnTouchMove = null, this.boundOnTouchEnd = null;
    }
}



var $4kGcU = parcelRequire("4kGcU");
function $e7190a203d7b16c2$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $e7190a203d7b16c2$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $e7190a203d7b16c2$var$passiveTestOptions = {
        get passive () {
            $e7190a203d7b16c2$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $e7190a203d7b16c2$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $e7190a203d7b16c2$var$passiveTestOptions);
}
var $e7190a203d7b16c2$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $e7190a203d7b16c2$var$locks = [];
var $e7190a203d7b16c2$var$documentListenerAdded = false;
var $e7190a203d7b16c2$var$initialClientY = -1;
var $e7190a203d7b16c2$var$previousBodyOverflowSetting = void 0;
var $e7190a203d7b16c2$var$previousBodyPosition = void 0;
var $e7190a203d7b16c2$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $e7190a203d7b16c2$var$allowTouchMove = function allowTouchMove(el) {
    return $e7190a203d7b16c2$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $e7190a203d7b16c2$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($e7190a203d7b16c2$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $e7190a203d7b16c2$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($e7190a203d7b16c2$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            $e7190a203d7b16c2$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($e7190a203d7b16c2$var$previousBodyOverflowSetting === undefined) {
        $e7190a203d7b16c2$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $e7190a203d7b16c2$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($e7190a203d7b16c2$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $e7190a203d7b16c2$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $e7190a203d7b16c2$var$previousBodyPaddingRight = undefined;
    }
    if ($e7190a203d7b16c2$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $e7190a203d7b16c2$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $e7190a203d7b16c2$var$previousBodyOverflowSetting = undefined;
    }
};
var $e7190a203d7b16c2$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($e7190a203d7b16c2$var$previousBodyPosition === undefined) {
            $e7190a203d7b16c2$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = 'fixed';
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $e7190a203d7b16c2$var$restorePositionSetting = function restorePositionSetting() {
    if ($e7190a203d7b16c2$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $e7190a203d7b16c2$var$previousBodyPosition.position;
        document.body.style.top = $e7190a203d7b16c2$var$previousBodyPosition.top;
        document.body.style.left = $e7190a203d7b16c2$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $e7190a203d7b16c2$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $e7190a203d7b16c2$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $e7190a203d7b16c2$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $e7190a203d7b16c2$var$initialClientY;
    if ($e7190a203d7b16c2$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $e7190a203d7b16c2$var$preventDefault(event);
    if ($e7190a203d7b16c2$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $e7190a203d7b16c2$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $e7190a203d7b16c2$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($e7190a203d7b16c2$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $e7190a203d7b16c2$var$locks = [].concat($e7190a203d7b16c2$var$_toConsumableArray($e7190a203d7b16c2$var$locks), [
        lock
    ]);
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$setPositionFixed();
    else $e7190a203d7b16c2$var$setOverflowHidden(options);
    if ($e7190a203d7b16c2$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $e7190a203d7b16c2$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $e7190a203d7b16c2$var$handleScroll(event, targetElement);
        };
        if (!$e7190a203d7b16c2$var$documentListenerAdded) {
            document.addEventListener('touchmove', $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = true;
        }
    }
};
var $e7190a203d7b16c2$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($e7190a203d7b16c2$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $e7190a203d7b16c2$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($e7190a203d7b16c2$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $e7190a203d7b16c2$var$initialClientY = -1;
    }
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$restorePositionSetting();
    else $e7190a203d7b16c2$var$restoreOverflowSetting();
    $e7190a203d7b16c2$var$locks = [];
};
var $e7190a203d7b16c2$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $e7190a203d7b16c2$var$locks = $e7190a203d7b16c2$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($e7190a203d7b16c2$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($e7190a203d7b16c2$var$documentListenerAdded && $e7190a203d7b16c2$var$locks.length === 0) {
            document.removeEventListener('touchmove', $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = false;
        }
    }
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$restorePositionSetting();
    else $e7190a203d7b16c2$var$restoreOverflowSetting();
};



var $b2f05b2db7d8ade3$export$54f5f69c1651567f = /*#__PURE__*/ function(WidgetEvents) {
    WidgetEvents["AUTOCOMPLETE"] = "AUTOCOMPLETE";
    WidgetEvents["POI_SELECTED"] = "POI_SELECTED";
    WidgetEvents["PHONE_CLICKED"] = "PHONE_CLICKED";
    WidgetEvents["WEBSITE_CLICKED"] = "WEBSITE_CLICKED";
    WidgetEvents["SEARCH_RESULT_ITEM_SELECTED"] = "SEARCH_RESULT_ITEM_SELECTED";
    WidgetEvents["FIND_ROUTE"] = "FIND_ROUTE";
    WidgetEvents["NAVIGATION_STARTED"] = "NAVIGATION_STARTED";
    WidgetEvents["ITINERARY_MODE_EXITED"] = "ITINERARY_MODE_EXITED";
    return WidgetEvents;
}({});
var $b2f05b2db7d8ade3$export$6955bcca4cd3539f = /*#__PURE__*/ function(Page) {
    Page["EXHIBITORS"] = "exhibitors";
    Page["THEMATIC"] = "thematic";
    Page["KIOSK"] = "kiosk";
    Page["GENERAL"] = "general";
    return Page;
}({});
var $b2f05b2db7d8ade3$export$5b5e3de1740177a6 = /*#__PURE__*/ function(DefaultMapOptions) {
    DefaultMapOptions[DefaultMapOptions["tilt"] = 80] = "tilt";
    DefaultMapOptions[DefaultMapOptions["heading"] = -14.39] = "heading";
    DefaultMapOptions[DefaultMapOptions["centerLat"] = 45.51908] = "centerLat";
    DefaultMapOptions[DefaultMapOptions["centerLng"] = 9.08109] = "centerLng";
    DefaultMapOptions[DefaultMapOptions["zoom"] = 17] = "zoom";
    DefaultMapOptions[DefaultMapOptions["minZoomAllowed"] = 14] = "minZoomAllowed";
    DefaultMapOptions[DefaultMapOptions["kioskZoom"] = 20] = "kioskZoom";
    DefaultMapOptions[DefaultMapOptions["kioskTilt"] = 45] = "kioskTilt";
    DefaultMapOptions[DefaultMapOptions["kioskHeading"] = 26.39] = "kioskHeading";
    return DefaultMapOptions;
}({});
var $b2f05b2db7d8ade3$export$1d885e506a42e75 = /*#__PURE__*/ function(ExhibitorStatus) {
    ExhibitorStatus["NONE"] = "none";
    ExhibitorStatus["TO_VISIT"] = "tovisit";
    ExhibitorStatus["VISITED"] = "visited";
    return ExhibitorStatus;
}({});

class $b2f05b2db7d8ade3$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {}
    render() {
        (0, $58070e9281bc680d$export$e6103b0362967aab)(this.state.locale || (0, $58070e9281bc680d$export$9a2147b3808d4c6b));
        (0, $ec948a4cf72a2ce9$export$940a7873bb071df8)(this.state.config);
        this.preloadLinks();
        this.mapComponent = new (0, $0f8c890e7395704d$export$2e2bcd8739ae039)({
            $target: document.getElementById("app"),
            initialState: {
                woosmapPublicKey: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey,
                mapOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions,
                indoorRendererOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions,
                indoorWidgetOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorWidgetOptions,
                query: this.state.config?.map.query
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).MAP_READY, ()=>{
            this.mapComponent.initIndoorView();
            this.loadGoogleTagManager();
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).MAP_IDLE, ()=>{
            if (this.mapComponent.map.getZoom() < 14) {
                if (this.currentPage === "kiosk" && this.currentKiosk) {
                    const kiosk = this.currentKiosk;
                    this.setBoundsForSelectedPav(kiosk.ref, {
                        lat: kiosk.lat,
                        lng: kiosk.lng
                    }, kiosk.isSouth ?? false, kiosk.zoom, kiosk.panOffset, kiosk.xPanOffset);
                } else {
                    this.mapComponent.map.setZoom(17);
                    this.mapComponent.map.panTo({
                        lat: 45.51908,
                        lng: 9.08109
                    });
                }
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_VENUE_LOADED, (venue)=>{
            // TO DO: KEEP UNTIL IT GOES TO PROD
            console.log("Venue loaded ", venue);
            this.venue = JSON.parse(JSON.stringify(venue));
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            // Do any actions here when indoor venue is fully loaded
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.currentPage = "kiosk";
                this.mapComponent.indoorMap.setWidgetMapMode("kiosk");
                this.fetchKiosksData().then((kiosks)=>{
                    const queryParam = this.state.query?.split("=");
                    if (queryParam && queryParam.length > 0 && kiosks) {
                        const filteredKiosk = kiosks?.find((item)=>item.title.toLowerCase() === queryParam[1].toLowerCase());
                        this.isKiosk = true;
                        this.currentKiosk = filteredKiosk;
                        if (filteredKiosk) {
                            this.mapComponent.setOrigin(filteredKiosk);
                            this.selectedOrigin = {
                                type: "Feature",
                                id: -1,
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        filteredKiosk.lng,
                                        filteredKiosk.lat
                                    ]
                                },
                                properties: {
                                    level: "0",
                                    name: (0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["Your Location"],
                                    pk: "-1"
                                }
                            };
                            this.setBoundsForSelectedPav(filteredKiosk.ref, {
                                lat: filteredKiosk.lat,
                                lng: filteredKiosk.lng
                            }, filteredKiosk.isSouth, filteredKiosk.zoom, filteredKiosk.panOffset, filteredKiosk.xPanOffset);
                        }
                    }
                }).catch((error)=>{
                    console.error("Error in reading kiosk data", error);
                });
                this.mapComponent.turnOffNavigation();
                if (this.kioskComponent === undefined) {
                    this.kioskComponent = new (0, $67dc1e3ffb36eb73$export$2e2bcd8739ae039)({
                        $target: document.getElementById("wrapper"),
                        initialState: {
                            query: this.state.query
                        }
                    });
                    this.displayKioskElements();
                    this.restrictKioskUserInteractions();
                    this.kioskComponent.initCustomKeyboard();
                    this.kioskComponent.disableSystemKeyboard();
                    this.mapComponent.indoorMap.setIsAutofocusDisabled(true);
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).LOGO_CLICKED, (ref)=>{
                        if (this.currentKiosk) this.mapComponent.showRouteForSponsor({
                            lat: this.currentKiosk.lat,
                            lng: this.currentKiosk.lng
                        }, ref);
                    });
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).LANGUAGE_CHANGED, (lang)=>{
                        this.setState({
                            locale: lang
                        });
                    });
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).MAP_RELOAD, ()=>{
                        this.mapComponent.destroyMap();
                        this.mapComponent.indoorMap.setIsAutofocusDisabled(true);
                        const btnAllExhibits = document.getElementById("btnAllExhibits");
                        if (btnAllExhibits) btnAllExhibits.classList.add("active");
                        const btnThematic = document.getElementById("btnThematic");
                        if (btnThematic) btnThematic.classList.remove("active");
                    });
                }
            }
            if (this.state.query && this.state.query !== "" && this.state.query.includes("thematic")) {
                const selectedTheme = this.state.query.split("=")[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                if (selectedTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && selectedTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.mapComponent.setFilter(selectedTheme);
                window.dataLayer = window.dataLayer || [];
                if (this.selectedThematic && this.selectedThematic !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && this.selectedThematic !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.getPOIExtendedData(undefined, this.state.query).then((pois)=>{
                    window.dataLayer = window.dataLayer || [];
                    this.itemsForThematicSelected = pois;
                    window.dataLayer.push({
                        event: "woo_filter",
                        click_location: undefined,
                        content_type: "thematic",
                        content_id: this.selectedThematic,
                        parent_content_type: undefined,
                        parent_content_id: undefined,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined
                    });
                }).catch((error)=>{
                    console.error("Error while searching POIs:", error);
                });
            }
            this.initThematicComponent();
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_WIDGET_ANALYTICS, (event)=>{
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.currentPage = "kiosk";
                this.kioskComponent.startSessionCountdown();
            }
            if (event.event === "AUTOCOMPLETE" && event.args.query.length >= 3) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_search",
                    click_location: undefined,
                    search_term: event.args.query,
                    items: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
                const searchResults = event.args.results;
                const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                if (this.selectedThematic && this.selectedThematic !== "" && this.selectedThematic !== "sdm_default") {
                    const pois = this.createPOIListForAnalytics(searchResults, this.selectedThematic);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "woo_poi_search_list",
                        click_location: undefined,
                        content_type: thematic,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        content_id: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined
                    });
                } else /* As far as possible avoid calling /search endpoint */ if (searchResults && searchResults.length > 0) {
                    // const refs: string = searchResults.map((element: SearchResult) => `ref:${element.ref}`).join(',');
                    const ids = searchResults.map((element)=>element.id).join(",");
                    this.getPOIExtendedData(ids).then((pois)=>{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "woo_poi_search_list",
                            click_location: undefined,
                            content_type: thematic,
                            items: pois,
                            _clear: true,
                            search_term: undefined,
                            content_id: undefined,
                            item_name: undefined,
                            nav_from: undefined,
                            nav_to: undefined,
                            parent_content_type: undefined,
                            parent_content_id: undefined
                        });
                    }).catch((error)=>{
                        console.error("Error while searching POIs:", error);
                    });
                }
            }
            if (event.event === "SEARCH_RESULT_ITEM_SELECTED") {
                const poi = event.args;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_poi_search_clic",
                    click_location: undefined,
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "FIND_ROUTE") {
                if (this.infoWindow) this.infoWindow.close();
                // TO DO : REVISIT DIRTY FIX FOR ORIGIN GETTING CLEARED IN RENDERER
                this.resetOriginIfNotFound();
                const poi = event.args;
                // Comment this if something goes wrong in multi level warning changes !!!
                if (this.currentPage === "kiosk") this.checkForMultilevelDirections();
                this.mapComponent.showRouteForAllLevels();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_clic_iti",
                    click_location: poi.source || "main_map",
                    content_type: poi.destination.properties["thematic"] ? poi.destination.properties["thematic"] : "",
                    content_id: poi.destination.properties["POI_ID"],
                    item_name: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "NAVIGATION_STARTED") {
                const poi = event.args;
                let origin = poi.origin.properties["name"];
                if (poi.origin.id === -1) origin = this.isKiosk && this.currentKiosk ? `Kiosk ${this.currentKiosk.title}` : poi.origin.properties["name"];
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_nav",
                    click_location: undefined,
                    nav_from: origin,
                    nav_to: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    item_name: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_POI_ON_MAP_CLICK, (poi)=>{
            // TO DO : REVISIT DIRTY FIX FOR ORIGIN GETTING CLEARED IN RENDERER
            this.resetOriginIfNotFound();
            if (poi) {
                if (!this.mapComponent.indoorMap.isItineraryMode()) this.selectedDestination = poi;
                if ((0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)()) requestAnimationFrame(()=>{
                    const closePanelBtn = document.getElementsByClassName("btn btn--retract desktop")[0];
                    const itineraryPanel = document.getElementsByClassName("woosmap-panel__content itinerary")[0];
                    if (closePanelBtn && !itineraryPanel) closePanelBtn.click();
                });
                window.dataLayer.push({
                    event: "woo_poi_map_clic",
                    click_location: undefined,
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined
                });
                if (this.mapType === "favorites") {
                    if (poi && poi.properties) {
                        if (poi.properties["Exhibitor_Name"] === undefined || poi.properties["Building"] === undefined || poi.properties["Floorplan_Label"] === undefined) return;
                    }
                    Promise.all([
                        this.getUserFavoriteShops(this.loggedInUser, "tovisit"),
                        this.getUserFavoriteShops(this.loggedInUser, "visited")
                    ]).then(([tovisit, visited])=>{
                        const favorites = [
                            ...tovisit.data,
                            ...visited.data
                        ];
                        if (favorites && favorites.length > 0) {
                            const isPoiFav = favorites.find((fav)=>fav.exhibitor_id === poi.properties.Salesforce_ID);
                            poi.properties.visit_status = isPoiFav?.status ?? "to_visit";
                            if (isPoiFav) this.openCustomInfoWindow(poi, true);
                            else this.openCustomInfoWindow(poi, false);
                        } else this.openCustomInfoWindow(poi, false);
                    }).catch((error)=>{
                        console.error("Error in fetching favorites", error);
                    });
                } else this.openCustomInfoWindow(poi, false);
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_WIDGET_ANALYTICS, (event)=>{
            if (event.event === "ITINERARY_MODE_EXITED") {
                this.selectedDestination = undefined;
                if (this.currentPage === "kiosk" && this.currentKiosk) // Re-set origin on the renderer after panel state settles,
                // so the widget's userLocation is current for next panel open
                setTimeout(()=>{
                    this.mapComponent.setOrigin(this.currentKiosk);
                }, 100);
                else this.selectedOrigin = undefined;
            }
        });
    }
    async fetchKiosksData() {
        try {
            const kioskModule = await Promise.resolve((parcelRequire("4kGcU")));
            const kioskData = kioskModule.default;
            return kioskData.kiosks;
        } catch (error) {
            console.error("Error importing Kiosk JSON file:", error);
        }
    }
    preloadLinks() {
        Promise.all([
            // preloadLink({
            //     url: getConfig().urls.mapJS,
            //     params: { key: getConfig().map.woosmapPublicKey, language: getLocaleLang().toLowerCase(), libraries: getConfig().map.libraries },
            //     as: "script",
            // }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/tiles.json",
                params: {
                    key: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/style/streets.json",
                params: {
                    language: (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase(),
                    key: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.png",
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.json",
                as: "fetch",
                crossOrigin: "anonymous"
            })
        ]);
    }
    createResetMapElement() {
        const $mapContainer = document.getElementById("map");
        const $btnToggle = document.getElementById("btnSwitchStandardView");
        if ($mapContainer && !$btnToggle) {
            const toggleStandardView = document.createElement("button");
            toggleStandardView.id = "btnSwitchStandardView";
            toggleStandardView.classList.add("toggle-standard-view");
            toggleStandardView.innerText = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.cta["switch_standard_view"];
            toggleStandardView.addEventListener("click", ()=>{
                // location.reload();
                window.location.href = window.location.origin + window.location.pathname;
            });
            $mapContainer.appendChild(toggleStandardView);
        }
    }
    applyTheme(theme) {
        const { config: config } = this.state;
        if (theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] || theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.setState({
            query: ""
        });
        if (config) {
            const mapConfig = config.map;
            const updatedMapOptions = {
                ...mapConfig,
                indoorRendererOptions: {
                    theme: theme,
                    ...theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"] && {
                        baseFilter: `thematic:=${theme} OR ${theme}:=true`
                    }
                },
                indoorWidgetOptions: {
                    ...theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"] && {
                        baseFilter: `thematic:=${theme} OR ${theme}:=true`
                    }
                }
            };
            const updatedConfig = {
                ...config,
                map: updatedMapOptions
            };
            this.setState({
                config: updatedConfig
            });
        }
        if (this.mapComponent && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.mapComponent.setFilter(theme);
    }
    getPOIExtendedData(ids, filter) {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            const arrPOIs = [];
            const callback = (featuresCollection)=>{
                if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) {
                    featuresCollection.features.forEach((element)=>{
                        const properties = element.properties;
                        const searchedPOI = {
                            item_id: properties["ref"],
                            item_name: properties["name"],
                            item_category: properties["thematic"],
                            quantity: 1
                        };
                        arrPOIs.push(searchedPOI);
                    });
                    resolve(arrPOIs);
                } else reject(new Error("No features found."));
            };
            indoorService.search(this.venue.venue_id, "", callback, null, ids, filter);
        });
    }
    createPOIListForAnalytics(results, thematic) {
        const arrPOIs = [];
        results.forEach((element)=>{
            const searchedPOI = {
                item_id: element.ref,
                item_name: element.name,
                item_category: thematic,
                quantity: 1
            };
            arrPOIs.push(searchedPOI);
        });
        return arrPOIs;
    }
    loadGoogleTagManager() {
        const gaTrackingId = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.GATag;
        if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}"]`)) (function(w, d, s, l, i) {
            w.dataLayer = w.dataLayer || [];
            w.dataLayer.push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l !== "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gaTrackingId);
    }
    computeBoundsOfBuildingSelected(buildingList) {
        if (buildingList["pavilion"]) {
            const mergedBounds = new woosmap.map.LatLngBounds();
            buildingList["pavilion"].forEach((item)=>{
                if (this.venue && this.venue.buildings && this.venue.buildings.length > 0) {
                    const filteredBuilding = this.venue.buildings.filter((building)=>building.ref === item)[0];
                    if (filteredBuilding && filteredBuilding.levels.length > 0) {
                        const bbox = filteredBuilding.levels.filter((level)=>level.level === 0)[0].bbox;
                        mergedBounds.extend({
                            lng: bbox[0],
                            lat: bbox[1]
                        });
                        mergedBounds.extend({
                            lng: bbox[2],
                            lat: bbox[3]
                        });
                    }
                }
            });
            if (!mergedBounds.isEmpty()) {
                const isSouth = buildingList["pavilion"].some((p)=>(0, $4kGcU.SOUTH_PAVILION_REFS).has(p));
                const tilt = this.currentPage === "kiosk" ? 45 : 80;
                const heading = (this.currentPage === "kiosk" ? 26.39 : -14.39) + (isSouth ? 180 : 0);
                this.mapComponent.map.fitBounds(mergedBounds);
                this.mapComponent.map.setTilt(tilt);
                this.mapComponent.map.setHeading(heading);
                if (this.currentPage === "kiosk" && buildingList.kioskZoom) this.mapComponent.map.setZoom(buildingList.kioskZoom);
            }
        }
    }
    setBoundsForSelectedPav(pav, kioskPosition, isSouth = false, zoom, panOffset, xPanOffset) {
        const mergedBounds = new woosmap.map.LatLngBounds();
        // If pav is defined, try to include building bbox in bounds
        if (pav !== undefined && this.venue?.buildings?.length > 0) {
            const filteredBuilding = this.venue.buildings.filter((building)=>building.ref === pav)[0];
            if (filteredBuilding && filteredBuilding.levels.length > 0) {
                const bbox = filteredBuilding.levels.filter((level)=>level.level === 0)[0].bbox;
                mergedBounds.extend({
                    lng: bbox[0],
                    lat: bbox[1]
                });
                mergedBounds.extend({
                    lng: bbox[2],
                    lat: bbox[3]
                });
            }
        }
        // Always include kiosk position and apply map view
        mergedBounds.extend(kioskPosition);
        if (!mergedBounds.isEmpty()) {
            const heading = 26.39 + (isSouth ? 180 : 0);
            this.mapComponent.map.fitBounds(mergedBounds);
            this.mapComponent.map.setTilt(45);
            this.mapComponent.map.setHeading(heading);
            if (zoom) this.mapComponent.map.setZoom(zoom);
            if (panOffset !== undefined || xPanOffset !== undefined) this.mapComponent.map.panBy(xPanOffset ?? 0, panOffset ?? 0);
        }
    }
    resetMap() {
        const defaultOptions = {
            bearing: -14.39,
            animate: true,
            duration: 500
        };
        let mergedOptions;
        let zoom = 17;
        if (this.currentPage === "general") {
            mergedOptions = {
                ...defaultOptions,
                center: this.thematicCenter,
                zoom: 17
            };
            zoom = 17;
        } else if (this.currentPage === "kiosk") {
            if (this.currentKiosk) {
                mergedOptions = {
                    ...defaultOptions,
                    center: {
                        lat: this.currentKiosk.lat,
                        lng: this.currentKiosk.lng
                    },
                    zoom: 20,
                    pitch: 45,
                    bearing: 26.39
                };
                zoom = 17.5;
            }
        }
        if (mergedOptions && zoom) {
            this.mapComponent.map.flyTo(mergedOptions);
            setTimeout(()=>{
                this.mapComponent.map.setZoom(zoom);
            }, 550);
        }
    }
    showMultiLevelWarning() {
        const $mapElement = document.querySelector(".mapboxgl-control-container");
        if ($mapElement) {
            const $infoContainer = document.createElement("div");
            $infoContainer.classList.add("mapboxgl-ctrl-top-center", "fade-in-out");
            setTimeout(()=>{
                $infoContainer.classList.add("show");
            }, 200);
            const $info = document.createElement("div");
            $info.id = "map-info";
            $info.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.multilevelwarning;
            $infoContainer.appendChild($info);
            $mapElement.appendChild($infoContainer);
            setTimeout(()=>{
                $infoContainer.classList.remove("show");
            }, 10000);
        }
    }
    groupInstructionsByLevel(steps) {
        const instructionsByLevel = [];
        let lastStepsByLevel = {
            level: null,
            steps: []
        };
        steps.forEach((step)=>{
            if (lastStepsByLevel.level !== step.properties.level) {
                lastStepsByLevel = {
                    level: step.properties.level,
                    steps: []
                };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    checkForMultilevelDirections() {
        const directionsResult = this.mapComponent.getDirections();
        if (directionsResult && directionsResult.routes && directionsResult.routes.length > 0) {
            const route = directionsResult.routes[0];
            const routeSteps = [];
            if (route.legs && route.legs.length > 0) {
                route.legs.forEach((leg)=>{
                    if (leg && leg.steps) leg.steps.forEach((step)=>{
                        const feature = {
                            type: "Feature",
                            properties: {
                                id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                level: `Level ${step.start_location.level}`,
                                floor: step.start_location.level,
                                instruction: step.instruction ? step.instruction.summary : null,
                                icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : "caret-down"
                            },
                            geometry: {
                                type: "LineString",
                                coordinates: step.polyline
                            }
                        };
                        routeSteps.push(feature);
                    });
                });
                if (routeSteps.length > 0) {
                    const levelsGroup = this.groupInstructionsByLevel(routeSteps);
                    if (levelsGroup.length > 2) this.showMultiLevelWarning();
                }
            }
        }
    }
    resetTheme(theme) {
        if (this.mapComponent) this.mapComponent.setFilter(theme);
    }
    setBoundsOnDirectionsChanged(start, end) {
        const routeBounds = new woosmap.map.LatLngBounds();
        routeBounds.extend({
            lat: start.coordinates[1],
            lng: start.coordinates[0]
        });
        if (end.type === "Polygon") end.coordinates[0].forEach((coord)=>routeBounds.extend({
                lat: coord[1],
                lng: coord[0]
            }));
        else if (end.type === "Point") routeBounds.extend({
            lat: end.coordinates[1],
            lng: end.coordinates[0]
        });
        this.mapComponent.map.fitBounds(routeBounds, {
            top: 20,
            left: 390,
            right: 70,
            bottom: 20
        }, true);
    }
    async getUserFavoriteShops(token, status) {
        try {
            const response = await fetch(`${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.lambdaExternal}?token=${token}&status=${status}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 400) {
                const errorData = await response.json();
                console.warn("Bad Request: 400", errorData.message);
                return {
                    data: [],
                    unauthorized: true
                };
            }
            if (response.status === 401) {
                const errorData = await response.json();
                console.warn("Unauthorized: 401", errorData.message);
                return {
                    data: [],
                    unauthorized: true
                };
            }
            if (!response.ok) {
                const errorData = await response.json();
                (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().messages.api_error, "error");
                throw new Error(`HTTP error: ${response.status}, ${errorData.message}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error occurred:", error);
            return {
                data: []
            };
        }
    }
    getPOIDataForFavorites(favorites) {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            if (favorites && favorites.length > 0) {
                const advanced_filter = favorites.map((favorite)=>`Salesforce_ID:=${favorite}`).join(" OR ");
                const callback = (featuresCollection)=>{
                    if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) resolve(featuresCollection);
                    else reject(new Error("No features found."));
                };
                indoorService.search(this.venue.venue_id, "", callback, null, null, advanced_filter);
            }
        });
    }
    showUserFavoritesOnMap(favorites, shopStatusMapping) {
        if (favorites && favorites.length > 0) this.getPOIDataForFavorites(favorites).then((featuresCollection)=>{
            const enrichedGeoJson = this.enrichFeaturesWithStatus(featuresCollection, shopStatusMapping);
            this.mapComponent.indoorMap.setWidgetMapMode("favorites", enrichedGeoJson);
            this.mapComponent.plotUserFavoritesOnMap(enrichedGeoJson.features);
        });
    }
    openCustomInfoWindow(feature, isFav = false) {
        if (feature) {
            if (this.infoWindow) this.infoWindow.close();
            this.infoWindow = new woosmap.map.InfoWindow({
                content: "",
                disableAutoPan: true
            });
            const logo = feature.properties["woosmap:logo"];
            const logoImageStyle = `background-image: url(${logo})`;
            const poiName = feature.properties["Exhibitor_Name"] ? feature.properties["Exhibitor_Name"] : feature.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] ? feature.properties[`name:${(0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()}`] : feature.properties["name"];
            const poiPav = feature.properties["Building"] ? (0, $ee9cb80b5c23ac97$export$9ba7ead6d3b1a4b8)(feature.properties["Building"]) : undefined;
            const poiFloorLabel = feature.properties["Floorplan_Label"] || "";
            const poiInfo = `${poiPav ? `Pav ${poiPav}` : ""} ${poiFloorLabel} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.level} ${feature.properties["level"]}`;
            const status = feature.properties["visit_status"];
            let customHTML = "";
            const favText = isFav ? `- ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.remove_favorites}` : `+ ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.add_favorites}`;
            if (this.loggedInUser && this.mapType === "favorites") customHTML = `<div class="infowindow-wrapper-favs">
                <div class="infowindow-logo" style="${logoImageStyle}"></div>
                <div class="infowindow-content"><span class="title">${poiName}</span>
                <span class="pav-info">${poiInfo}</span>
                <div class="favs-action">
                    <span class="favs-link">${favText}</span>
                    ${isFav ? `
                    <label class="checkbox">
                        <input type="checkbox" id="chkMarkVisited" ${status === "visited" ? "checked" : ""} />
                        <span class="checkmark"></span>
                        ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.to_visit}
                    </label>` : ``}
                </div>
                <hr class="infowindow-divider"/>
                <div class="infowindow-action-links">
                <div class="icon-destination">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" data-testid="icon-marker-filled" width="24" height="24" class="icon icon__destination"><path d="M14 2.944a7.785 7.785 0 0 0-7.785 7.785c0 5.594 7.054 8.562 7.054 13.689 0 .419.344.638.731.638s.731-.227.731-.638c0-5.127 7.054-8.095 7.054-13.689A7.785 7.785 0 0 0 14 2.944ZM14 14a3.126 3.126 0 1 1 0-6.252A3.126 3.126 0 0 1 14 14Z" fill="#f50057"></path></svg>
                    <span>${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.destination}</span>
                </div>
                <div class="icon-origin">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" data-testid="icon-position-filled" width="24" height="24" class="icon icon__origin"><path d="M14 6.131a7.869 7.869 0 1 0 0 15.738A7.869 7.869 0 0 0 14 6.13Zm0 10.996a3.126 3.126 0 1 1 0-6.252 3.126 3.126 0 0 1 0 6.252Z" fill="#5586ff"></path></svg>
                    <span>${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.origin}</span>
                </div>
            <div>
                </div></div></div></div>`;
            else customHTML = `<div class="infowindow-wrapper-gen">
            <div class="infowindow-logo" style="${logoImageStyle}"></div>
            <div class="infowindow-content"><span class="title">${poiName}</span>
            <span class="pav-info">${poiInfo}</span>
            <div class="infowindow-action-links">
                <div class="icon-destination">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" data-testid="icon-marker-filled" width="24" height="24" class="icon icon__destination"><path d="M14 2.944a7.785 7.785 0 0 0-7.785 7.785c0 5.594 7.054 8.562 7.054 13.689 0 .419.344.638.731.638s.731-.227.731-.638c0-5.127 7.054-8.095 7.054-13.689A7.785 7.785 0 0 0 14 2.944ZM14 14a3.126 3.126 0 1 1 0-6.252A3.126 3.126 0 0 1 14 14Z" fill="#f50057"></path></svg>
                    <span>${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.destination}</span>
                </div>
                <div class="icon-origin">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" data-testid="icon-position-filled" width="24" height="24" class="icon icon__origin"><path d="M14 6.131a7.869 7.869 0 1 0 0 15.738A7.869 7.869 0 0 0 14 6.13Zm0 10.996a3.126 3.126 0 1 1 0-6.252 3.126 3.126 0 0 1 0 6.252Z" fill="#5586ff"></path></svg>
                    <span>${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.origin}</span>
                </div>
            <div>
            </div></div>`;
            this.infoWindow.setContent(customHTML);
            if (isFav) this.infoWindow.setOffset(new woosmap.map.Point(0, -30));
            const pos = (0, $ee9cb80b5c23ac97$export$53fc19a32de59f94)(feature);
            this.infoWindow.open(this.mapComponent.map, pos);
            if (this.mapType === "favorites") document.getElementsByClassName("favs-link")[0].addEventListener("click", ()=>{
                const status = isFav ? "none" : "tovisit";
                this.flagUserFavorites(feature, status).then(()=>{
                    const message = isFav ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.remove_favorites_toast : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.add_favorites_toast;
                    const toastType = "success";
                    this.mapComponent.unselectPOI();
                    (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)(message, toastType);
                    Promise.all([
                        this.getUserFavoriteShops(this.loggedInUser, "tovisit"),
                        this.getUserFavoriteShops(this.loggedInUser, "visited")
                    ]).then(([tovisit, visited])=>{
                        const favorites = [
                            ...tovisit.data,
                            ...visited.data
                        ];
                        if (favorites && favorites.length > 0) {
                            const shopStatusMapping = this.buildStatusMap(favorites);
                            const favoriteShops = favorites.map((favorite)=>favorite.exhibitor_id);
                            this.showUserFavoritesOnMap(favoriteShops, shopStatusMapping);
                        } else {
                            this.mapComponent.removeMarkersForFavs();
                            // Sync widget state so the empty-state static toast can render
                            if (this.mapType === "favorites") this.mapComponent.indoorMap.setWidgetMapMode("favorites", undefined, false);
                        }
                        if (this.infoWindow) this.infoWindow.close();
                    }).catch((error)=>{
                        console.error("Error in fetching favorites", error);
                    });
                });
            });
            document.getElementsByClassName("icon-destination")[0]?.addEventListener("click", ()=>{
                if (this.selectedOrigin && this.selectedOrigin.id === feature.id) this.selectedOrigin = undefined;
                this.selectedDestination = feature;
                this.mapComponent.indoorMap.showItinerary(this.selectedOrigin, feature);
            });
            document.getElementsByClassName("icon-origin")[0]?.addEventListener("click", ()=>{
                if (this.selectedDestination && this.selectedDestination.id === feature.id) this.selectedDestination = undefined;
                this.selectedOrigin = feature;
                this.mapComponent.unselectPOI();
                this.mapComponent.indoorMap.showItinerary(feature, this.selectedDestination);
            });
            const favCheckbox = document.querySelector("#chkMarkVisited");
            if (favCheckbox) favCheckbox.addEventListener("change", (event)=>{
                const isChecked = event.target.checked;
                if (isChecked) this.flagUserFavoritesAsPerStatus(feature, "visited");
                else this.flagUserFavoritesAsPerStatus(feature, "tovisit");
            });
            let flyToOptions = {
                center: pos,
                padding: (0, $ee9cb80b5c23ac97$export$3ba45bd218cae310)(true)
            };
            flyToOptions = this.mapComponent.map.getZoom() < 18 ? {
                ...flyToOptions,
                zoom: 18
            } : flyToOptions;
            this.mapComponent.map.flyTo(flyToOptions);
        }
    }
    async flagUserFavorites(feature, status) {
        try {
            const body = {
                token: this.loggedInUser,
                exhibitorIds: [
                    feature.properties["Salesforce_ID"]
                ],
                status: status
            };
            const response = await fetch((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.lambdaExternal, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().messages.api_error, "error");
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error occurred:", error);
            return Promise.reject(`Fetch failed: ${error}`);
        }
    }
    displayKioskElements() {
        const $mapContainer = document.getElementById("map");
        $mapContainer.style.visibility = "visible";
        const $kioskHeader = document.getElementsByClassName("kiosk-header");
        if ($kioskHeader && $kioskHeader[0]) $kioskHeader[0].style.visibility = "visible";
        const $mapSwitcher = document.getElementsByClassName("button-section");
        if ($mapSwitcher && $mapSwitcher[0]) $mapSwitcher[0].style.visibility = "visible";
        this.mapComponent.indoorMap.setWidgetMapMode("kiosk");
        $mapContainer.addEventListener("click", (e)=>{
            if (e.target?.closest(".mapboxgl-ctrl-compass")) this.kioskComponent?.startSessionCountdown();
        }, true);
    }
    restrictKioskUserInteractions() {
        document.addEventListener("contextmenu", (event)=>{
            event.preventDefault();
        });
        document.addEventListener("touchstart", (event)=>{
            if (event.touches.length > 1) event.preventDefault();
        }, {
            passive: false
        });
    }
    initThematicComponent() {
        let defaultTheme = this.state.config?.map.indoorRendererOptions.theme || "";
        if (defaultTheme && defaultTheme !== "" && defaultTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && defaultTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) defaultTheme = `thematic:=${defaultTheme.substring(0, defaultTheme.indexOf("_"))}`;
        this.thematicComponent = new (0, $3c0730fc6dc90d7f$export$2e2bcd8739ae039)({
            $target: document.querySelector("button-section"),
            initialState: {
                query: this.state.query?.includes("thematic") ? this.state.query : defaultTheme,
                showDescription: true
            }
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).THEMATIC_SELECTED, (thematic)=>{
            if (this.currentPage === "kiosk") this.kioskComponent.startSessionCountdown();
            const selectedTheme = thematic.split("=")[1];
            this.selectedThematic = selectedTheme;
            this.itemsForThematicSelected = [];
            this.mapComponent.setFilter(selectedTheme);
            this.mapComponent.setTheme(`${selectedTheme}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}`);
            this.mapComponent.unselectPOI();
            this.mapType = "thematics";
            this.selectedDestination = undefined;
            this.selectedOrigin = undefined;
            //TO DO ---> IS THIS MODE NEEDED?
            this.mapComponent.indoorMap.setWidgetMapMode("thematic");
            this.mapComponent.removeMarkersForFavs();
            if (this.infoWindow) this.infoWindow.close();
            const initialCenter = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions.center;
            if (this.mapComponent.map.getCenter() !== initialCenter) {
                this.mapComponent.map.panTo(this.thematicCenter);
                setTimeout(()=>{
                    this.mapComponent.map.setZoom(17);
                }, 500);
            }
            if (this.selectedThematic && this.selectedThematic !== `sdm_default_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}`) this.getPOIExtendedData(undefined, thematic).then((pois)=>{
                window.dataLayer = window.dataLayer || [];
                this.itemsForThematicSelected = pois;
                window.dataLayer.push({
                    event: "woo_filter",
                    click_location: undefined,
                    content_type: "thematic",
                    content_id: this.selectedThematic,
                    items: pois,
                    _clear: true,
                    search_term: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }).catch((error)=>{
                console.error("Error while searching POIs:", error);
            });
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).BUILDING_SELECTED, (buildingList)=>{
            if (this.currentPage === "kiosk") {
                this.kioskComponent.startSessionCountdown();
                this.itemsForThematicSelected = [];
            }
            if (buildingList) {
                if (buildingList && buildingList.ref && buildingList.ref === "pav2_4xx") // TO DO: OBSERVE WHY BOUNDS COME WRONG FROM BACKEND. TEMP FIX TO ADJUST IN FRONT END.
                this.mapComponent.map.panTo({
                    lat: buildingList.center.lat,
                    lng: buildingList.center.lng
                });
                else this.computeBoundsOfBuildingSelected(buildingList);
                const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                window.dataLayer.push({
                    event: "woo_filter",
                    click_location: undefined,
                    content_type: "pav",
                    content_id: buildingList.title,
                    parent_content_type: "thematic",
                    parent_content_id: thematic,
                    items: this.itemsForThematicSelected && this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                    search_term: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined
                });
            } else if (this.currentPage === "kiosk" && this.currentKiosk) {
                const kiosk = this.currentKiosk;
                this.setBoundsForSelectedPav(kiosk.ref, {
                    lat: kiosk.lat,
                    lng: kiosk.lng
                }, kiosk.isSouth ?? false, kiosk.zoom, kiosk.panOffset, kiosk.xPanOffset);
            } else this.resetMap();
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).THEMATIC_UNSELECTED, (theme)=>{
            if (this.currentPage === "kiosk") this.kioskComponent.startSessionCountdown();
            this.resetTheme(theme);
            this.mapComponent.setTheme(theme);
            this.mapComponent.unselectPOI();
            this.mapComponent.removeMarkersForFavs();
            this.mapType = "general";
            if (this.infoWindow) this.infoWindow.close();
            const initialCenter = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions.center;
            if (this.mapComponent.map.getCenter() !== initialCenter) {
                this.mapComponent.map.panTo(this.thematicCenter);
                setTimeout(()=>{
                    this.mapComponent.map.setZoom(17);
                }, 500);
            }
            if (theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes.favorites) {
                this.mapType = "favorites";
                const query = this.state.query;
                if (query && query.includes("token")) {
                    const token = query.split(":=")[1];
                    this.loggedInUser = token;
                    const fetchFavorites = (token)=>{
                        Promise.all([
                            this.getUserFavoriteShops(this.loggedInUser, "tovisit"),
                            this.getUserFavoriteShops(this.loggedInUser, "visited")
                        ]).then(([tovisit, visited])=>{
                            const isUnauthorized = tovisit.unauthorized || visited.unauthorized;
                            const favorites = [
                                ...tovisit.data,
                                ...visited.data
                            ];
                            if (favorites && favorites.length > 0) {
                                const shopStatusMapping = this.buildStatusMap(favorites);
                                const favoriteShops = favorites.map((favorite)=>favorite.exhibitor_id);
                                this.showUserFavoritesOnMap(favoriteShops, shopStatusMapping);
                            } else if (isUnauthorized) this.mapComponent.indoorMap.setWidgetMapMode("favorites", undefined, true);
                            else // Logged in but empty favorites list — set mode so the empty-state static toast can render
                            this.mapComponent.indoorMap.setWidgetMapMode("favorites", undefined, false);
                        }).catch((error)=>{
                            console.error("Error in fetching favorites", error);
                        });
                    };
                    if (token) fetchFavorites(token);
                }
            } else this.mapComponent.indoorMap.setWidgetMapMode("general");
        });
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("token") && urlParams.has("path")) {
            const path = urlParams.get("path");
            if (path === "user_exhibitors") this.thematicComponent.switchMap("favorites");
        }
    }
    manageNativeKeyboardIssues() {
        const ulElement = document.getElementById("autoComplete_list_1");
        const searchInput = document.querySelector(".autoComplete_wrapper > input");
        const handleFocusIn = ()=>{
            if (ulElement && searchInput && window.visualViewport) {
                (0, $e7190a203d7b16c2$export$24fdf68abf432c44)(ulElement); // Prevent background scrolling
                const viewportHeight = window.visualViewport.height;
                const inputRect = searchInput.getBoundingClientRect();
                const availableHeight = viewportHeight - inputRect.bottom;
                ulElement.style.maxHeight = `${availableHeight}px !important`;
            }
        };
        const handleFocusOut = ()=>{
            if (ulElement) {
                (0, $e7190a203d7b16c2$export$e5d0524c3725571e)(ulElement); // Restore background scrolling
                ulElement.style.maxHeight = "233px"; // Reset height
            }
        };
        if (searchInput) {
            searchInput.addEventListener("focus", handleFocusIn);
            searchInput.addEventListener("blur", handleFocusOut);
        }
    }
    resetOriginIfNotFound() {
        const panels = document.getElementsByClassName("woosmap-indoor-panel");
        const search = panels.length > 0 ? document.getElementsByTagName("input")[0] : null;
        if (search && search.value === "") {
            if (this.selectedOrigin) {
                const origin = `${this.selectedOrigin.properties["name"]} ${(0, $58070e9281bc680d$export$180605366c04f0cd)().indoor["at Level"]} (${this.selectedOrigin.properties["level"]})`;
                search.value = origin;
            }
        }
    }
    flagUserFavoritesAsPerStatus(feature, status) {
        this.flagUserFavorites(feature, status).then(()=>{
            const message = status === "visited" ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.visited_toast : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.unvisited_toast;
            const toastType = "success";
            this.mapComponent.unselectPOI();
            (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)(message, toastType);
            Promise.all([
                this.getUserFavoriteShops(this.loggedInUser, "tovisit"),
                this.getUserFavoriteShops(this.loggedInUser, "visited")
            ]).then(([tovisit, visited])=>{
                const favorites = [
                    ...tovisit.data,
                    ...visited.data
                ];
                if (favorites && favorites.length > 0) {
                    const shopStatusMapping = this.buildStatusMap(favorites);
                    const favoriteShops = favorites.map((favorite)=>favorite.exhibitor_id);
                    this.showUserFavoritesOnMap(favoriteShops, shopStatusMapping);
                } else this.mapComponent.removeMarkersForFavs();
                if (this.infoWindow) this.infoWindow.close();
            }).catch((error)=>{
                console.error("Error in fetching favorites", error);
            });
        });
    }
    buildStatusMap(data) {
        return new Map(data.map((item)=>[
                item.exhibitor_id,
                item.status
            ]));
    }
    enrichFeaturesWithStatus(featureCollection, statusMap) {
        return {
            ...featureCollection,
            features: featureCollection.features.map((feature)=>{
                const shopId = feature.properties.Salesforce_ID;
                const status = shopId ? statusMap.get(shopId) : undefined;
                return {
                    ...feature,
                    properties: {
                        ...feature.properties,
                        visit_status: status ?? "tovisit"
                    }
                };
            })
        };
    }
    constructor(...args){
        super(...args), this.isKiosk = false, this.currentPage = "general", this.thematicCenter = {
            lat: 45.51908,
            lng: 9.08109
        }, this.loggedInUser = "", this.mapType = "general";
    }
}


window.woosmapIndoorWidget = (0, $b2f05b2db7d8ade3$export$2e2bcd8739ae039);


//# sourceMappingURL=map.fc73e26b.js.map
